import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  GenericScalar: any;
  JSONString: any;
  Time: any;
  UUID: any;
};

export type AcBrand = {
  __typename?: 'ACBrand';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  acSelections: Array<AcSelection>;
};

export type AcSelection = {
  __typename?: 'ACSelection';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  zone: Zone;
  acStyle?: Maybe<AcSelectionAcStyle>;
  acSizeByTon?: Maybe<Scalars['Int']>;
  acNumUnits?: Maybe<Scalars['Int']>;
  brand?: Maybe<AcBrand>;
  brandNameOther?: Maybe<Scalars['String']>;
  acBrand?: Maybe<AcBrand>;
};

export enum AcSelectionAcStyle {
  AirHandler = 'AIR_HANDLER',
  MiniSplit = 'MINI_SPLIT'
}

export type AcSelectionInput = {
  id?: Maybe<Scalars['ID']>;
  brand?: Maybe<CustomInput>;
  brandNameOther?: Maybe<Scalars['String']>;
  acStyle?: Maybe<Scalars['String']>;
  acSizeByTon?: Maybe<Scalars['Int']>;
  acNumUnits?: Maybe<Scalars['Int']>;
};

export type ActiveUserFilterSetInput = {
  email_Icontains?: Maybe<Scalars['String']>;
};

export type AddAroyaApiKeyInput = {
  aroyaApiKey?: Maybe<Scalars['String']>;
  organizationId: Scalars['ID'];
};

export type AddAroyaApiKeyResult = {
  __typename?: 'AddAroyaApiKeyResult';
  organization?: Maybe<Organization>;
  devices?: Maybe<Array<Maybe<AroyaDevice>>>;
  error?: Maybe<Scalars['String']>;
};

export type AddGrowlinkApiKeyInput = {
  growlinkApiKey?: Maybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  growlinkUsername?: Maybe<Scalars['String']>;
  growlinkPassword?: Maybe<Scalars['String']>;
  growlinkOrgId?: Maybe<Scalars['String']>;
};

export type AddGrowlinkApiKeyResult = {
  __typename?: 'AddGrowlinkApiKeyResult';
  organization?: Maybe<Organization>;
  devices?: Maybe<Array<Maybe<GrowlinkDevice>>>;
  error?: Maybe<Scalars['String']>;
};

export type AddMetrcPackageSourceRelationshipInput = {
  sourceSiteId: Scalars['ID'];
  sourceSiteLicenseId: Scalars['ID'];
  targetOrgLicenseId: Scalars['ID'];
};

export type AddOrganizationMetrcPackageSourceLicenseInput = {
  organizationId: Scalars['ID'];
  licenseNumber: Scalars['String'];
  userKey: Scalars['String'];
  metrcState: Scalars['String'];
};

export type AddSiteAroyaCredentialInput = {
  siteId: Scalars['ID'];
  apiKey: Scalars['String'];
  label?: Maybe<Scalars['String']>;
};

export type AddSiteAroyaCredentialResult = {
  __typename?: 'AddSiteAroyaCredentialResult';
  credential?: Maybe<SensorIntegrationCredential>;
  devices?: Maybe<Array<Maybe<AroyaDevice>>>;
  error?: Maybe<Scalars['String']>;
};

export type AddSiteGrowlinkCredentialInput = {
  siteId: Scalars['ID'];
  apiKey: Scalars['String'];
  growlinkOrganizationId?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type AddSiteGrowlinkCredentialResult = {
  __typename?: 'AddSiteGrowlinkCredentialResult';
  credential?: Maybe<SensorIntegrationCredential>;
  organizations?: Maybe<Array<Maybe<GrowlinkOrganization>>>;
  error?: Maybe<Scalars['String']>;
};

export type AddSiteMetrcLicenseInput = {
  siteId: Scalars['ID'];
  licenseNumber: Scalars['String'];
  userKey: Scalars['String'];
  metrcState: Scalars['String'];
};

export type AddSiteTrolmasterCredentialInput = {
  siteId: Scalars['ID'];
  apiKey: Scalars['String'];
  label?: Maybe<Scalars['String']>;
};

export type AddSiteTrolmasterCredentialResult = {
  __typename?: 'AddSiteTrolmasterCredentialResult';
  credential?: Maybe<SensorIntegrationCredential>;
  error?: Maybe<Scalars['String']>;
};

export type AddTrolmasterApiKeyInput = {
  trolmasterApiKey?: Maybe<Scalars['String']>;
  organizationId: Scalars['ID'];
};

export type AffectedStageInfo = {
  __typename?: 'AffectedStageInfo';
  stageName?: Maybe<Scalars['String']>;
  currentStart?: Maybe<Scalars['String']>;
  currentEnd?: Maybe<Scalars['String']>;
  newStart?: Maybe<Scalars['String']>;
  newEnd?: Maybe<Scalars['String']>;
};

export type AirClimateSection = {
  __typename?: 'AirClimateSection';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  entry: ChecklistEntry;
  environmentFeel?: Maybe<AirClimateSectionEnvironmentFeel>;
  environmentalFeelNote?: Maybe<Scalars['String']>;
  airCirculation?: Maybe<AirClimateSectionAirCirculation>;
  airCirculationNote?: Maybe<Scalars['String']>;
};

export enum AirClimateSectionAirCirculation {
  Good = 'GOOD',
  Poor = 'POOR',
  Stagnant = 'STAGNANT'
}

export enum AirClimateSectionEnvironmentFeel {
  Normal = 'NORMAL',
  TooHot = 'TOO_HOT',
  TooCold = 'TOO_COLD',
  TooHumid = 'TOO_HUMID',
  TooDry = 'TOO_DRY'
}

export type AirClimateSectionInput = {
  environmentFeel?: Maybe<Scalars['String']>;
  environmentalFeelNote?: Maybe<Scalars['String']>;
  airCirculation?: Maybe<Scalars['String']>;
  airCirculationNote?: Maybe<Scalars['String']>;
};

export type AlertWarning = {
  __typename?: 'AlertWarning';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  zone: Zone;
  metric: AlertWarningMetric;
  day: EnvironmentalDataDailyType;
  startTime: Scalars['DateTime'];
  endTime: Scalars['DateTime'];
  avgDeviation: Scalars['Float'];
  maxDeviation: Scalars['Float'];
  position: AlertWarningPosition;
  message: Scalars['String'];
  display?: Maybe<Scalars['String']>;
  envType: AlertWarningEnvType;
  timeOfDay: AlertWarningTimeOfDay;
  stage: Stage;
};

export enum AlertWarningEnvType {
  Veg = 'VEG',
  Flower = 'FLOWER',
  NoTargets = 'NO_TARGETS'
}

export enum AlertWarningMetric {
  TempF = 'TEMP_F',
  HumidityPercent = 'HUMIDITY_PERCENT',
  Co2Ppm = 'CO2_PPM',
  Vpd = 'VPD',
  LightLux = 'LIGHT_LUX',
  Vwc = 'VWC',
  PoreEc = 'PORE_EC',
  SubstrateTempF = 'SUBSTRATE_TEMP_F',
  Dfi = 'DFI',
  DrainEc = 'DRAIN_EC',
  DrainTempF = 'DRAIN_TEMP_F'
}

export enum AlertWarningPosition {
  Above = 'ABOVE',
  Below = 'BELOW'
}

export enum AlertWarningTimeOfDay {
  Day = 'DAY',
  Night = 'NIGHT'
}

export type AnalysisWeeklyMetric = {
  __typename?: 'AnalysisWeeklyMetric';
  expected: Scalars['Int'];
  observed: Scalars['Int'];
  comparable: Scalars['Int'];
  inside: Scalars['Int'];
  above: Scalars['Int'];
  below: Scalars['Int'];
  insidePercent?: Maybe<Scalars['Float']>;
  abovePercent?: Maybe<Scalars['Float']>;
  belowPercent?: Maybe<Scalars['Float']>;
  observedCoverage: Scalars['Float'];
  comparableCoverage: Scalars['Float'];
  key: Scalars['String'];
  eligibleDays: Scalars['Int'];
  deviationDays: Scalars['Int'];
  priority?: Maybe<Scalars['String']>;
};

export type AnalyticsChartData = {
  __typename?: 'AnalyticsChartData';
  data: Array<AnalyticsDataPoint>;
  name: Scalars['String'];
  alertWarnings: Array<AlertWarning>;
};

export type AnalyticsDataPoint = {
  __typename?: 'AnalyticsDataPoint';
  x: Scalars['DateTime'];
  y: Scalars['Float'];
};

export type ApiKey = {
  __typename?: 'ApiKey';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  user: UserProfile;
  name: Scalars['String'];
  keyPrefix: Scalars['String'];
  accessLevel: ApiKeyAccessLevel;
  rateLimitTier: ApiKeyRateLimitTier;
  dataScope: ApiKeyDataScope;
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  revokedAt?: Maybe<Scalars['DateTime']>;
  active?: Maybe<Scalars['Boolean']>;
};

export enum ApiKeyAccessLevel {
  ReadOnly = 'READ_ONLY',
  ReadWrite = 'READ_WRITE'
}

export enum ApiKeyDataScope {
  Organization = 'ORGANIZATION',
  Staff = 'STAFF',
  Superuser = 'SUPERUSER'
}

export enum ApiKeyRateLimitTier {
  DataAccess = 'DATA_ACCESS',
  InternalTools = 'INTERNAL_TOOLS',
  ClientApp = 'CLIENT_APP'
}

export type ApproveHarvestCompletionInput = {
  harvestGroupId: Scalars['ID'];
};

export type ApproveLogEntryInput = {
  id: Scalars['ID'];
};

export type AroyaDevice = {
  __typename?: 'AroyaDevice';
  deviceId?: Maybe<Scalars['String']>;
  modelKey?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AroyaDeviceRequest = {
  __typename?: 'AroyaDeviceRequest';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  inventoryPresent?: Maybe<Scalars['Boolean']>;
  credential?: Maybe<SensorIntegrationCredential>;
  deviceId: Scalars['String'];
  modelKey: Scalars['String'];
  serialNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  isAdded: Scalars['Boolean'];
  roomId?: Maybe<Scalars['String']>;
  roomName?: Maybe<Scalars['String']>;
  benchId?: Maybe<Scalars['String']>;
  benchName?: Maybe<Scalars['String']>;
  category?: Maybe<AroyaDeviceRequestCategory>;
};

export enum AroyaDeviceRequestCategory {
  Climate = 'CLIMATE',
  Substrate = 'SUBSTRATE',
  Runoff = 'RUNOFF'
}

export type AssignProcessingJobToUserInput = {
  jobId: Scalars['ID'];
  assigneeId: Scalars['ID'];
  newStatus?: Maybe<Scalars['Boolean']>;
};

export type BestYieldingStrainsResult = {
  __typename?: 'BestYieldingStrainsResult';
  adjustedParentTotalEnabled: Scalars['Boolean'];
  strains: Array<StrainYieldPerformance>;
  productStream: YieldProductStream;
  excludedBatches: Array<HarvestYieldBatch>;
  reconciliationBatches: Array<HarvestYieldBatch>;
  allBudFormFactors: Array<BudFormFactor>;
};

export type BffDebug = {
  __typename?: 'BffDebug';
  formFactors?: Maybe<Array<Maybe<BffDebugFormFactor>>>;
  failedExtractions?: Maybe<Array<Maybe<BffDebugFailedExtraction>>>;
};

export type BffDebugFailedExtraction = {
  __typename?: 'BffDebugFailedExtraction';
  itemName?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  weightG?: Maybe<Scalars['Float']>;
};

export type BffDebugFormFactor = {
  __typename?: 'BffDebugFormFactor';
  name?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  totalWeightG?: Maybe<Scalars['Float']>;
  packageCount?: Maybe<Scalars['Int']>;
  harvestCount?: Maybe<Scalars['Int']>;
  sampleItemNames?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BudFormFactor = {
  __typename?: 'BudFormFactor';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  description: Scalars['String'];
  active: Scalars['Boolean'];
  createdBy: UserProfile;
  orderPosition: Scalars['Int'];
  classification: BudFormFactorClassification;
  metrcId?: Maybe<Scalars['String']>;
  sites: Array<OrganizationSite>;
  yieldCount?: Maybe<Scalars['Int']>;
};

export enum BudFormFactorClassification {
  Flower = 'FLOWER',
  Trim = 'TRIM',
  Unfinished = 'UNFINISHED',
  Waste = 'WASTE'
}

export type BudFormFactorFilterSetInput = {
  active?: Maybe<Scalars['Boolean']>;
  classification?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
};

export type BudFormFactorResult = BudFormFactor | Error;

export type BudFormFactorYield = {
  __typename?: 'BudFormFactorYield';
  id: Scalars['UUID'];
  budFormFactor: BudFormFactor;
  harvestStrainYield: HarvestStrainYield;
  numberOfGrams: Scalars['Float'];
  budFormFactorId: Scalars['String'];
};

export type BulkCreateEquipmentInput = {
  type: Scalars['String'];
  quantity: Scalars['Int'];
  locationId: Scalars['ID'];
  brand?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
};

export type BulkUpdateZoneSchedules = {
  __typename?: 'BulkUpdateZoneSchedules';
  zones?: Maybe<Array<Maybe<Zone>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type BulkUpdateZoneSchedulesInput = {
  zoneUpdates: Array<ZoneScheduleUpdateInput>;
  siteId?: Maybe<Scalars['ID']>;
};

export type CalendarBranch = {
  __typename?: 'CalendarBranch';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  createdBy?: Maybe<UserProfile>;
  lastUpdatedBy?: Maybe<UserProfile>;
  organization: Organization;
  status: CalendarBranchStatus;
  newStages: Array<Stage>;
  newTasks: Array<Task>;
  calendarBranchReviews: Array<CalendarBranchReview>;
  calendarBranchApprovals: Array<CalendarBranchApproval>;
  stageUpdates: Array<StageUpdate>;
  taskUpdates: Array<TaskUpdate>;
  stages: Array<Stage>;
  tasks: Array<Task>;
  updateCount: Scalars['Int'];
  conflictCount: Scalars['Int'];
  updates: Array<UpdateDisplay>;
  conflicts: Array<ConflictDisplay>;
};


export type CalendarBranchStagesArgs = {
  dateRange?: Maybe<DateRangeInput>;
};


export type CalendarBranchTasksArgs = {
  dateRange?: Maybe<DateRangeInput>;
};

export type CalendarBranchApproval = {
  __typename?: 'CalendarBranchApproval';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  calendarBranch: CalendarBranch;
  createdBy?: Maybe<UserProfile>;
};

export type CalendarBranchFilterSetInput = {
  name?: Maybe<Scalars['String']>;
};

export type CalendarBranchMergeLogEntry = {
  __typename?: 'CalendarBranchMergeLogEntry';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  organization?: Maybe<Organization>;
  calendarBranchName: Scalars['String'];
  mergedBy?: Maybe<UserProfile>;
  mergedAt: Scalars['DateTime'];
  changelog?: Maybe<Scalars['GenericScalar']>;
};

export type CalendarBranchMergeLogEntryFilterSetInput = {
  id?: Maybe<Scalars['String']>;
};

export type CalendarBranchResult = CalendarBranch | Error;

export type CalendarBranchReview = {
  __typename?: 'CalendarBranchReview';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  calendarBranch: CalendarBranch;
  comments: Scalars['String'];
  createdBy?: Maybe<UserProfile>;
};

export enum CalendarBranchStatus {
  Created = 'CREATED',
  ChangesMade = 'CHANGES_MADE',
  ReviewRequested = 'REVIEW_REQUESTED',
  ChangesRequested = 'CHANGES_REQUESTED',
  Approved = 'APPROVED',
  MainBranch = 'MAIN_BRANCH'
}

export type ChecklistEntry = {
  __typename?: 'ChecklistEntry';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklistSession: ChecklistSession;
  zone?: Maybe<Zone>;
  inspector?: Maybe<UserProfile>;
  timePeriod?: Maybe<ChecklistEntryTimePeriod>;
  notes?: Maybe<Scalars['String']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  followUpRequired?: Maybe<ChecklistEntryFollowUpRequired>;
  skipReason?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['GenericScalar']>;
  airClimateSection?: Maybe<AirClimateSection>;
  lightingSection?: Maybe<LightingSection>;
  cultivationSection?: Maybe<CultivationSection>;
  ipmSection?: Maybe<IpmSection>;
  maintenanceSection?: Maybe<MaintenanceSection>;
  safetySection?: Maybe<SafetySection>;
  runoffSection?: Maybe<RunoffSection>;
  airClimate?: Maybe<AirClimateSection>;
  lighting?: Maybe<LightingSection>;
  cultivation?: Maybe<CultivationSection>;
  ipm?: Maybe<IpmSection>;
  maintenance?: Maybe<MaintenanceSection>;
  safety?: Maybe<SafetySection>;
  runoff?: Maybe<RunoffSection>;
};

export enum ChecklistEntryFollowUpRequired {
  Yes = 'YES',
  No = 'NO'
}

export type ChecklistEntryResult = ChecklistEntry | Error;

export enum ChecklistEntryTimePeriod {
  Morning = 'MORNING',
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING'
}

export type ChecklistSession = {
  __typename?: 'ChecklistSession';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  site?: Maybe<OrganizationSite>;
  createdBy?: Maybe<UserProfile>;
  checklistType: ChecklistSessionChecklistType;
  date: Scalars['Date'];
  dailySummaryEmailSentAt?: Maybe<Scalars['DateTime']>;
  roomWalkthroughs: Array<ChecklistEntry>;
  waterRoomChecklists: Array<WaterRoomChecklist>;
  waterQualityChecklists: Array<WaterQualityChecklist>;
  preHarvestTaskChecklists: Array<PreHarvestTaskChecklist>;
  postHarvestTaskChecklists: Array<PostHarvestTaskChecklist>;
  dryRoomPreHarvestChecklists: Array<DryRoomPreHarvestChecklist>;
  dryRoomPostHarvestChecklists: Array<DryRoomPostHarvestChecklist>;
  roomLoadTaskChecklists: Array<RoomLoadTaskChecklist>;
  transplantTaskChecklists: Array<TransplantTaskChecklist>;
  cloningTaskChecklists: Array<CloningTaskChecklist>;
  pruningDefolTaskChecklists: Array<PruningDefolTaskChecklist>;
  dailyTasksChecklists: Array<DailyTasksChecklist>;
  dailyWetRoomTaskChecklists: Array<DailyWetRoomTaskChecklist>;
  primaryZoneName?: Maybe<Scalars['String']>;
};

export enum ChecklistSessionChecklistType {
  Walkthrough = 'WALKTHROUGH',
  Simple = 'SIMPLE',
  SimpleWithRunoff = 'SIMPLE_WITH_RUNOFF',
  IpmOnly = 'IPM_ONLY',
  MaintenanceOnly = 'MAINTENANCE_ONLY',
  CultivationOnly = 'CULTIVATION_ONLY',
  RunoffOnly = 'RUNOFF_ONLY',
  WaterRoomCheck = 'WATER_ROOM_CHECK',
  WaterQualityCheck = 'WATER_QUALITY_CHECK',
  PreHarvestTasks = 'PRE_HARVEST_TASKS',
  PostHarvestTasks = 'POST_HARVEST_TASKS',
  DryRoomPreHarvest = 'DRY_ROOM_PRE_HARVEST',
  DryRoomPostHarvest = 'DRY_ROOM_POST_HARVEST',
  RoomLoadTasks = 'ROOM_LOAD_TASKS',
  TransplantTasks = 'TRANSPLANT_TASKS',
  CloningTasks = 'CLONING_TASKS',
  PruningDefolTasks = 'PRUNING_DEFOL_TASKS',
  DailyTasks = 'DAILY_TASKS',
  DailyWetRoomTasks = 'DAILY_WET_ROOM_TASKS'
}

export type ChecklistSessionFilterSetInput = {
  organizationId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  checklistType?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};

export type ChecklistSessionFilterSetOutput = {
  __typename?: 'ChecklistSessionFilterSetOutput';
  organizationId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  checklistType?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};

export type ChecklistSessionQuerysetOptionsInput = {
  paging?: Maybe<PagingInput>;
  filters?: Maybe<ChecklistSessionFilterSetInput>;
};

export type ChecklistSessionQuerysetOptionsOutput = {
  __typename?: 'ChecklistSessionQuerysetOptionsOutput';
  paging: PagingInfo;
  filters: ChecklistSessionFilterSetOutput;
};

export type ChecklistSessionQuerysetResult = {
  __typename?: 'ChecklistSessionQuerysetResult';
  options: ChecklistSessionQuerysetOptionsOutput;
  items: Array<Maybe<ChecklistSession>>;
};

export type ChecklistSessionResult = ChecklistSession | Error;

export type ChecklistTask = {
  __typename?: 'ChecklistTask';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organizationChecklist: OrganizationChecklist;
  name: Scalars['String'];
  status: ChecklistTaskStatus;
  tourStatus: ChecklistTaskTourStatus;
  dataStatus: ChecklistTaskDataStatus;
  order: Scalars['Int'];
};

export enum ChecklistTaskDataStatus {
  NotStarted = 'NOT_STARTED',
  TourCompleted = 'TOUR_COMPLETED',
  CustomDataCreated = 'CUSTOM_DATA_CREATED',
  Complete = 'COMPLETE'
}

export type ChecklistTaskResult = ChecklistTask | Error;

export enum ChecklistTaskStatus {
  NotStarted = 'NOT_STARTED',
  TourCompleted = 'TOUR_COMPLETED',
  CustomDataCreated = 'CUSTOM_DATA_CREATED',
  Complete = 'COMPLETE'
}

export enum ChecklistTaskTourStatus {
  NotStarted = 'NOT_STARTED',
  TourCompleted = 'TOUR_COMPLETED',
  CustomDataCreated = 'CUSTOM_DATA_CREATED',
  Complete = 'COMPLETE'
}

export type CirculatingFanBrand = {
  __typename?: 'CirculatingFanBrand';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  circulatingFanSelections: Array<CirculatingFanSelection>;
};

export type CirculatingFanSelection = {
  __typename?: 'CirculatingFanSelection';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  zone: Zone;
  brand?: Maybe<CirculatingFanBrand>;
  brandNameOther?: Maybe<Scalars['String']>;
  fanCount?: Maybe<Scalars['Int']>;
};

export type CirculatingFanSelectionInput = {
  id?: Maybe<Scalars['ID']>;
  brand?: Maybe<CustomInput>;
  brandNameOther?: Maybe<Scalars['String']>;
  fanCount?: Maybe<Scalars['Int']>;
};

export type ClientAiBootstrap = {
  __typename?: 'ClientAiBootstrap';
  catalogVersion: Scalars['String'];
  minimumSkillVersion: Scalars['String'];
  instructions: Array<Maybe<Scalars['String']>>;
  documents: Array<Maybe<ClientAiDocumentSummary>>;
};

export type ClientAiDocument = {
  __typename?: 'ClientAiDocument';
  slug: Scalars['String'];
  title: Scalars['String'];
  summary: Scalars['String'];
  kind: Scalars['String'];
  version: Scalars['String'];
  content: Scalars['String'];
};

export type ClientAiDocumentSummary = {
  __typename?: 'ClientAiDocumentSummary';
  slug: Scalars['String'];
  title: Scalars['String'];
  summary: Scalars['String'];
  version: Scalars['String'];
};

export type CloningTaskChecklist = {
  __typename?: 'CloningTaskChecklist';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklistSession: ChecklistSession;
  inspector?: Maybe<UserProfile>;
  zone?: Maybe<Zone>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['GenericScalar']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  sanitizeEquipment?: Maybe<Scalars['Boolean']>;
  sanitizeEquipmentNote?: Maybe<Scalars['String']>;
  preSoakPlugsWithCloneFeed?: Maybe<Scalars['Boolean']>;
  preSoakPlugsWithCloneFeedNote?: Maybe<Scalars['String']>;
  squeezePlugs?: Maybe<Scalars['Boolean']>;
  squeezePlugsNote?: Maybe<Scalars['String']>;
  cutClones?: Maybe<Scalars['Boolean']>;
  cutClonesNote?: Maybe<Scalars['String']>;
  cutStems45DegreesRazorBlade?: Maybe<Scalars['Boolean']>;
  cutStems45DegreesRazorBladeNote?: Maybe<Scalars['String']>;
  mixDipNGrow?: Maybe<Scalars['Boolean']>;
  mixDipNGrowNote?: Maybe<Scalars['String']>;
  placeCutsInDipNGrow1520Seconds?: Maybe<Scalars['Boolean']>;
  placeCutsInDipNGrow1520SecondsNote?: Maybe<Scalars['String']>;
  plugClonesWithCallus?: Maybe<Scalars['Boolean']>;
  plugClonesWithCallusNote?: Maybe<Scalars['String']>;
  placeMetrcTags?: Maybe<Scalars['Boolean']>;
  placeMetrcTagsNote?: Maybe<Scalars['String']>;
};

export type CloningTaskChecklistInput = {
  checklistSessionId: Scalars['ID'];
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  sanitizeEquipment?: Maybe<Scalars['Boolean']>;
  sanitizeEquipmentNote?: Maybe<Scalars['String']>;
  preSoakPlugsWithCloneFeed?: Maybe<Scalars['Boolean']>;
  preSoakPlugsWithCloneFeedNote?: Maybe<Scalars['String']>;
  squeezePlugs?: Maybe<Scalars['Boolean']>;
  squeezePlugsNote?: Maybe<Scalars['String']>;
  cutClones?: Maybe<Scalars['Boolean']>;
  cutClonesNote?: Maybe<Scalars['String']>;
  cutStems45DegreesRazorBlade?: Maybe<Scalars['Boolean']>;
  cutStems45DegreesRazorBladeNote?: Maybe<Scalars['String']>;
  mixDipNGrow?: Maybe<Scalars['Boolean']>;
  mixDipNGrowNote?: Maybe<Scalars['String']>;
  placeCutsInDipNGrow1520Seconds?: Maybe<Scalars['Boolean']>;
  placeCutsInDipNGrow1520SecondsNote?: Maybe<Scalars['String']>;
  plugClonesWithCallus?: Maybe<Scalars['Boolean']>;
  plugClonesWithCallusNote?: Maybe<Scalars['String']>;
  placeMetrcTags?: Maybe<Scalars['Boolean']>;
  placeMetrcTagsNote?: Maybe<Scalars['String']>;
};

export type CloningTaskChecklistResult = CloningTaskChecklist | Error;

export type CocoBrand = {
  __typename?: 'CocoBrand';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  zones: Array<Zone>;
};

export type CompleteHarvestInput = {
  harvestGroupId?: Maybe<Scalars['ID']>;
  strainPlantCounts?: Maybe<Array<CompleteHarvestStrainInput>>;
};

export type CompleteHarvestStrainInput = {
  strainId: Scalars['ID'];
  finalPlantCount: Scalars['Int'];
};

export type CompleteMetrcImportReviewInput = {
  siteId: Scalars['ID'];
  batchId: Scalars['ID'];
};

export type CompleteTaskInput = {
  id: Scalars['ID'];
  organizationId?: Maybe<Scalars['ID']>;
};

export type CompletedHarvestGroupFilterSetInput = {
  id?: Maybe<Scalars['String']>;
  importedFromMetrc?: Maybe<Scalars['String']>;
  unarchived?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};

export type CompletedHarvestGroupFilterSetOutput = {
  __typename?: 'CompletedHarvestGroupFilterSetOutput';
  id?: Maybe<Scalars['String']>;
  importedFromMetrc?: Maybe<Scalars['String']>;
  unarchived?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};

export type ConflictDisplay = {
  __typename?: 'ConflictDisplay';
  id: Scalars['String'];
  description: Scalars['String'];
  harvestGroupName: Scalars['String'];
  name: Scalars['String'];
  conflictType: Scalars['String'];
  calendarBranchId: Scalars['String'];
  justification: Scalars['String'];
  colorHexCode: Scalars['String'];
  schedulingRule: Scalars['String'];
};

export type ControlSystem = {
  __typename?: 'ControlSystem';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  zones: Array<Zone>;
};

export type CopySensorCredentialToAllSitesInput = {
  credentialId: Scalars['ID'];
};

export type CopySensorCredentialToAllSitesResult = {
  __typename?: 'CopySensorCredentialToAllSitesResult';
  updatedCount?: Maybe<Scalars['Int']>;
  skippedCount?: Maybe<Scalars['Int']>;
  updatedSiteNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  brandsAddedCount?: Maybe<Scalars['Int']>;
  brandsAddedSiteNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  error?: Maybe<Scalars['String']>;
};

export type CreateApiKeyInput = {
  name: Scalars['String'];
  accessLevel: Scalars['String'];
};

export type CreateApiKeyResult = CreateApiKeySuccess | Error;

export type CreateApiKeySuccess = {
  __typename?: 'CreateApiKeySuccess';
  apiKey?: Maybe<ApiKey>;
  token: Scalars['String'];
};

export type CreateAroyaDeviceInput = {
  name: Scalars['String'];
  zoneId: Scalars['ID'];
  primary?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['String']>;
  aroyaDeviceId: Scalars['String'];
  aroyaModelKey?: Maybe<Scalars['String']>;
  aroyaSerialNumber?: Maybe<Scalars['String']>;
  aroyaApiRoomName?: Maybe<Scalars['String']>;
  aroyaApiBenchName?: Maybe<Scalars['String']>;
  credentialId?: Maybe<Scalars['ID']>;
};

export type CreateBudFormFactorInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  classification: Scalars['String'];
  orderPosition?: Maybe<Scalars['Int']>;
};

export type CreateBudFormFactorYieldInput = {
  budFormFactorId: Scalars['ID'];
  numberOfGrams: Scalars['Decimal'];
};

export type CreateCalendarBranchInput = {
  name: Scalars['String'];
};

export type CreateChecklistEntryInput = {
  checklistSessionId: Scalars['ID'];
  zoneId: Scalars['ID'];
  inspectorId?: Maybe<Scalars['ID']>;
  timePeriod?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  followUpRequired?: Maybe<Scalars['String']>;
  skipReason?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  airClimate?: Maybe<AirClimateSectionInput>;
  lighting?: Maybe<LightingSectionInput>;
  cultivation?: Maybe<CultivationSectionInput>;
  ipm?: Maybe<IpmSectionInput>;
  maintenance?: Maybe<MaintenanceSectionInput>;
  safety?: Maybe<SafetySectionInput>;
  runoff?: Maybe<RunoffSectionInput>;
};

export type CreateChecklistSessionInput = {
  organizationId: Scalars['ID'];
  siteId: Scalars['ID'];
  date: Scalars['Date'];
  checklistType?: Maybe<Scalars['String']>;
};

export type CreateEnvironmentalTargetSetInput = {
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  environmentLightingType?: Maybe<Scalars['String']>;
  environmentalTargetValues: CreateEnvironmentalTargetValuesInput;
};

export type CreateEnvironmentalTargetValuesInput = {
  dayStartTime?: Maybe<Scalars['String']>;
  nightStartTime?: Maybe<Scalars['String']>;
  environmentalTargetType: Scalars['String'];
  zoneId?: Maybe<Scalars['ID']>;
  daysInStageStart?: Maybe<Scalars['Int']>;
  daysInStageEnd?: Maybe<Scalars['Int']>;
  dayTempLow?: Maybe<Scalars['Int']>;
  dayTempHigh?: Maybe<Scalars['Int']>;
  nightTempLow?: Maybe<Scalars['Int']>;
  nightTempHigh?: Maybe<Scalars['Int']>;
  dayVpdLow?: Maybe<Scalars['Float']>;
  dayVpdHigh?: Maybe<Scalars['Float']>;
  nightVpdLow?: Maybe<Scalars['Float']>;
  nightVpdHigh?: Maybe<Scalars['Float']>;
  dayHumidityLow?: Maybe<Scalars['Int']>;
  dayHumidityHigh?: Maybe<Scalars['Int']>;
  nightHumidityLow?: Maybe<Scalars['Int']>;
  nightHumidityHigh?: Maybe<Scalars['Int']>;
  dayCo2Low?: Maybe<Scalars['Int']>;
  dayCo2High?: Maybe<Scalars['Int']>;
  nightCo2Low?: Maybe<Scalars['Int']>;
  nightCo2High?: Maybe<Scalars['Int']>;
};

export type CreateEquipmentInput = {
  label: Scalars['String'];
  type: Scalars['String'];
  lastMaintenanceDate: Scalars['Date'];
  locationId: Scalars['ID'];
  brand?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  installedAtDate?: Maybe<Scalars['Date']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type CreateFacilitySurveyInput = {
  fieldSurveyId: Scalars['ID'];
  reportDate: Scalars['DateTime'];
  phPrefilter: Scalars['Decimal'];
  ecPrefilter: Scalars['Decimal'];
  tdsPrefilter: Scalars['Int'];
  tempPrefilter: Scalars['Decimal'];
  phPostfilter: Scalars['Decimal'];
  ecPostfilter: Scalars['Decimal'];
  tdsPostfilter: Scalars['Int'];
  tempPostfilter: Scalars['Decimal'];
  floorsStatus: Scalars['String'];
  wallsStatus: Scalars['String'];
  ceilingsStatus: Scalars['String'];
  footBaths: Scalars['String'];
  eyeWashStations: Scalars['String'];
  handWashStations: Scalars['String'];
  msdsDocumentationUpToDate: Scalars['String'];
  trainingLogsUpToDate: Scalars['String'];
  hygieneAdherence: Scalars['String'];
  storageConditions: Scalars['String'];
  storageLabels: Scalars['String'];
  storageContainers: Scalars['String'];
  safetyProtocols: Scalars['String'];
  ppeForHandling: Scalars['String'];
  ppeGlovesAvailable: Scalars['String'];
  ppeGogglesAvailable: Scalars['String'];
  ppeMasksAvailable: Scalars['String'];
  roFilters: Scalars['String'];
  roInlineFilters: Scalars['String'];
  roAirChambers: Scalars['String'];
  roCheckValves: Scalars['String'];
  waterTestTap: Scalars['String'];
  waterTestPostFilter: Scalars['String'];
};

export type CreateFieldAgentInput = {
  siteId: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
};

export type CreateFieldAgentResult = CreateFieldAgentSuccess | Error;

export type CreateFieldAgentSuccess = {
  __typename?: 'CreateFieldAgentSuccess';
  fieldAgent?: Maybe<FieldAgent>;
  token: Scalars['String'];
};

export type CreateFieldSurveyInput = {
  siteId: Scalars['ID'];
};

export type CreateGrowlinkDeviceInput = {
  name: Scalars['String'];
  zoneId: Scalars['ID'];
  primary?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['String']>;
  growlinkControllerId: Scalars['String'];
  growlinkModuleName?: Maybe<Scalars['String']>;
  growlinkTemperatureSensorId?: Maybe<Scalars['String']>;
  growlinkHumiditySensorId?: Maybe<Scalars['String']>;
  growlinkCo2SensorId?: Maybe<Scalars['String']>;
  growlinkVpdSensorId?: Maybe<Scalars['String']>;
  growlinkLightSensorId?: Maybe<Scalars['String']>;
  credentialId?: Maybe<Scalars['ID']>;
};

export type CreateHarvestGroupInput = {
  name: Scalars['String'];
  siteId?: Maybe<Scalars['String']>;
  flowerZoneId?: Maybe<Scalars['String']>;
  stages: Array<CreateStageInput>;
  colorHexCode?: Maybe<Scalars['String']>;
  templateId: Scalars['ID'];
  isMultisite?: Maybe<Scalars['Boolean']>;
};

export type CreateHarvestGroupTemplateInput = {
  name: Scalars['String'];
  stageTemplates: Array<Maybe<CreateStageTemplateInput>>;
  organizationId?: Maybe<Scalars['ID']>;
};

export type CreateHarvestReportInput = {
  harvestGroupId: Scalars['ID'];
  strainYields?: Maybe<Array<CreateHarvestStrainYieldInput>>;
};

export type CreateHarvestStrainYieldInput = {
  strainId: Scalars['ID'];
  finalPlantCount: Scalars['Int'];
  totalGrams: Scalars['Decimal'];
  budFormFactorYields?: Maybe<Array<CreateBudFormFactorYieldInput>>;
};

export type CreateMaintenanceRequestInput = {
  description: Scalars['String'];
  firstObservedAt: Scalars['Date'];
  dueDate: Scalars['Date'];
  urgent?: Maybe<Scalars['Boolean']>;
  equipmentInoperable?: Maybe<Scalars['Boolean']>;
  lockOutTagOut?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  tags: Array<Maybe<Scalars['String']>>;
};

export type CreateNutrientInput = {
  name: Scalars['String'];
  unitOfMeasure: Scalars['String'];
  priceInCentsPerUnit?: Maybe<Scalars['Decimal']>;
  boughtPrice?: Maybe<Scalars['Decimal']>;
  boughtAmount?: Maybe<Scalars['Decimal']>;
  boughtUnit?: Maybe<Scalars['String']>;
};

export type CreateOrganizationAndFirstUserInput = {
  name: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  accountType: Scalars['String'];
  trialAccount?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type CreateProcessingGroupInput = {
  name: Scalars['String'];
  fromHarvestGroupId?: Maybe<Scalars['String']>;
  processingGroupTemplateVersionId: Scalars['ID'];
  stages: Array<CreateProcessingGroupStageInput>;
  strains: Array<CreateProcessingGroupStrainInput>;
  colorHexCode?: Maybe<Scalars['String']>;
};

export type CreateProcessingGroupStageInput = {
  processingStageTemplateId: Scalars['ID'];
  startDate: Scalars['Date'];
  schedulingScope: Scalars['String'];
  strainStages: Array<CreateProcessingGroupStrainStageInput>;
  name?: Maybe<Scalars['String']>;
};

export type CreateProcessingGroupStrainInput = {
  strainId: Scalars['String'];
  inventoryGrams: Array<CreateProcessingGroupStrainInventoryGramsInput>;
  valid: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
};

export type CreateProcessingGroupStrainInventoryAdjustmentInput = {
  id: Scalars['ID'];
  formFactorId: Scalars['ID'];
  adjustmentGrams?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
};

export type CreateProcessingGroupStrainInventoryGramsInput = {
  formFactorId: Scalars['ID'];
  grams: Scalars['Decimal'];
};

export type CreateProcessingGroupStrainStageInput = {
  strainId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};

export type CreateProcessingGroupTemplateInput = {
  name: Scalars['String'];
  initialTemplate: CreateProcessingGroupTemplateVersionInput;
};

export type CreateProcessingGroupTemplateVersionInput = {
  stageTemplates?: Maybe<Array<Maybe<CreateProcessingStageTemplateInput>>>;
};

export type CreateProcessingJobInput = {
  strainStageId: Scalars['ID'];
  jobStatus?: Maybe<Scalars['String']>;
  assigneeId?: Maybe<Scalars['ID']>;
  inputGrams: Scalars['Decimal'];
  inputType: Scalars['String'];
  dontTrackUserGpm?: Maybe<Scalars['Boolean']>;
};

export type CreateProcessingJobLogInput = {
  jobId: Scalars['ID'];
  logType: Scalars['String'];
  performerId?: Maybe<Scalars['ID']>;
  startedAt: Scalars['DateTime'];
  endedAt: Scalars['DateTime'];
  breakMinutes: Scalars['Decimal'];
  leftoverInputGrams?: Maybe<Scalars['Decimal']>;
  outputGrams: Array<JobLogOutputGramsInput>;
};

export type CreateProcessingStageTemplateInput = {
  createdStageName: Scalars['String'];
  numberOfDays: Scalars['Int'];
  trackPerformance: Scalars['Boolean'];
  orderInProcess: Scalars['Int'];
  progressScope?: Maybe<Scalars['String']>;
  schedulingScope?: Maybe<Scalars['String']>;
  inputTypes: Array<Scalars['String']>;
  outputTypes: Array<Scalars['String']>;
};

export type CreateRecipeComponentInput = {
  nutrientId: Scalars['String'];
  volume: Scalars['Decimal'];
};

export type CreateRecipeInput = {
  name: Scalars['String'];
  applicationType: Scalars['String'];
  ec?: Maybe<Scalars['Decimal']>;
  ph?: Maybe<Scalars['Decimal']>;
  components: Array<Maybe<CreateRecipeComponentInput>>;
};

export type CreateRoomSurveyInput = {
  fieldSurveyId: Scalars['ID'];
  zoneId: Scalars['ID'];
  reportDate: Scalars['DateTime'];
  startedAt: Scalars['DateTime'];
  skipReason?: Maybe<Scalars['String']>;
  growthPhase?: Maybe<Scalars['String']>;
  lightingPpfd?: Maybe<Scalars['Int']>;
  currentTemperature?: Maybe<Scalars['Decimal']>;
  currentHumidity?: Maybe<Scalars['Decimal']>;
  leafSurfaceTemperature?: Maybe<Scalars['Decimal']>;
  acOutletTemperature?: Maybe<Scalars['Decimal']>;
  vpdLevel?: Maybe<Scalars['Decimal']>;
  co2Level?: Maybe<Scalars['Decimal']>;
  lightingComponentsBulbs?: Maybe<Scalars['String']>;
  lightingComponentsBallasts?: Maybe<Scalars['String']>;
  lightingStatus?: Maybe<Scalars['String']>;
  acUnits?: Maybe<Scalars['String']>;
  dehumidifiers?: Maybe<Scalars['String']>;
  circulatingFans?: Maybe<Scalars['String']>;
  humidifiers?: Maybe<Scalars['String']>;
  dripLines?: Maybe<Scalars['String']>;
  pumps?: Maybe<Scalars['String']>;
  catchCups?: Maybe<Scalars['String']>;
  runoffCollectionPh?: Maybe<Scalars['Decimal']>;
  runoffCollectionEc?: Maybe<Scalars['Decimal']>;
  plantStressIndicator?: Maybe<Scalars['String']>;
  signsOfPests?: Maybe<Scalars['String']>;
  signsOfPathogens?: Maybe<Scalars['String']>;
  stickyTraps?: Maybe<Scalars['String']>;
  growingMediumPh?: Maybe<Scalars['Decimal']>;
  growingMediumEc?: Maybe<Scalars['Decimal']>;
  nutrientSolutionPh?: Maybe<Scalars['Decimal']>;
  nutrientSolutionEc?: Maybe<Scalars['Decimal']>;
  notes?: Maybe<Scalars['String']>;
};

export type CreateRoomWalkthroughChecklistInput = {
  checklistSessionId: Scalars['ID'];
  zoneId: Scalars['ID'];
  inspectorId?: Maybe<Scalars['ID']>;
  timePeriod?: Maybe<Scalars['String']>;
  environmentFeel?: Maybe<Scalars['String']>;
  environmentalFeelNote?: Maybe<Scalars['String']>;
  airCirculation?: Maybe<Scalars['String']>;
  airCirculationNote?: Maybe<Scalars['String']>;
  lightsWorking?: Maybe<Scalars['String']>;
  lightsWorkingNote?: Maybe<Scalars['String']>;
  overallPlantHealth?: Maybe<Scalars['String']>;
  overallPlantHealthNote?: Maybe<Scalars['String']>;
  rootHealth?: Maybe<Scalars['String']>;
  rootHealthNote?: Maybe<Scalars['String']>;
  wiltingPlants?: Maybe<Scalars['String']>;
  wiltingPlantsLocation?: Maybe<Scalars['String']>;
  yellowingDiscoloration?: Maybe<Scalars['String']>;
  yellowingDiscolorationNote?: Maybe<Scalars['String']>;
  growthRate?: Maybe<Scalars['String']>;
  growthRateNote?: Maybe<Scalars['String']>;
  pestsVisible?: Maybe<Scalars['String']>;
  pestsType?: Maybe<Scalars['String']>;
  diseaseSigns?: Maybe<Scalars['String']>;
  diseaseSignsOther?: Maybe<Scalars['String']>;
  stickyTraps?: Maybe<Scalars['String']>;
  stickyTrapsNote?: Maybe<Scalars['String']>;
  hvacRunning?: Maybe<Scalars['String']>;
  hvacRunningNote?: Maybe<Scalars['String']>;
  dehumidifiers?: Maybe<Scalars['String']>;
  dehumidifiersNote?: Maybe<Scalars['String']>;
  irrigationSystem?: Maybe<Scalars['String']>;
  irrigationSystemNote?: Maybe<Scalars['String']>;
  filterCheck?: Maybe<Scalars['String']>;
  filterCheckNote?: Maybe<Scalars['String']>;
  tableDrains?: Maybe<Scalars['String']>;
  tableDrainsNote?: Maybe<Scalars['String']>;
  pumpsOperating?: Maybe<Scalars['String']>;
  pumpsOperatingNote?: Maybe<Scalars['String']>;
  unusualNoises?: Maybe<Scalars['String']>;
  unusualNoisesSource?: Maybe<Scalars['String']>;
  areaClean?: Maybe<Scalars['String']>;
  areaCleanNote?: Maybe<Scalars['String']>;
  spillsPresent?: Maybe<Scalars['String']>;
  spillsLocation?: Maybe<Scalars['String']>;
  toolsPutAway?: Maybe<Scalars['String']>;
  toolsPutAwayNote?: Maybe<Scalars['String']>;
  benchSpacing?: Maybe<Scalars['String']>;
  benchSpacingNote?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  followUpRequired?: Maybe<Scalars['String']>;
  skipReason?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
};

export type CreateSiteInput = {
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type CreateStageInput = {
  name: Scalars['String'];
  startDate: Scalars['Date'];
  zoneId: Scalars['String'];
  tasks: Array<CreateTaskInlineInput>;
  strains: Array<CreateStrainInStageInput>;
  templateId: Scalars['ID'];
};

export type CreateStageTemplateInput = {
  id?: Maybe<Scalars['ID']>;
  createdStageName: Scalars['String'];
  createdStageCalendarDisplayName?: Maybe<Scalars['String']>;
  numberOfDays: Scalars['Int'];
  maxNumberOfDays: Scalars['Int'];
  minNumberOfDays: Scalars['Int'];
  designatedZones: Array<Maybe<Scalars['String']>>;
  nextStageTemplate?: Maybe<Scalars['String']>;
  taskTemplates?: Maybe<Array<Maybe<CreateTaskTemplateInput>>>;
  environmentalTargetType: Scalars['String'];
};

export type CreateStrainInStageInput = {
  strainId: Scalars['ID'];
  numberOfPlants: Scalars['Int'];
};

export type CreateStrainInput = {
  name: Scalars['String'];
  abbreviation: Scalars['String'];
  subspecies: Scalars['String'];
  documentationUrl?: Maybe<Scalars['String']>;
};

export type CreateTaskInlineInput = {
  name: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  templateId: Scalars['ID'];
};

export type CreateTaskInput = {
  name: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  assignedToId?: Maybe<Scalars['ID']>;
  harvestGroupId: Scalars['ID'];
  priority: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  calendarBranchId?: Maybe<Scalars['ID']>;
  stageId?: Maybe<Scalars['ID']>;
  templateId?: Maybe<Scalars['ID']>;
};

export type CreateTaskTemplateInput = {
  id?: Maybe<Scalars['ID']>;
  createdTaskName: Scalars['String'];
  stageDayStart?: Maybe<Scalars['Int']>;
  stageDayEnd?: Maybe<Scalars['Int']>;
  taskType?: Maybe<Scalars['String']>;
  logType?: Maybe<Scalars['String']>;
  logEntryRecipeId?: Maybe<Scalars['ID']>;
};

export type CreateToppingStyleInput = {
  name: Scalars['String'];
};

export type CreateTrolmasterDeviceInput = {
  name: Scalars['String'];
  zoneId: Scalars['ID'];
  primary?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['String']>;
  trolmasterMacAddress: Scalars['String'];
  trolmasterModel: Scalars['String'];
  credentialId?: Maybe<Scalars['ID']>;
};

export type CreateUserInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  roleId: Scalars['String'];
  userPermissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizationId?: Maybe<Scalars['String']>;
};

export type CreateZoneInput = {
  name: Scalars['String'];
  siteId: Scalars['ID'];
  maxConcurrentHarvestGroups?: Maybe<Scalars['Int']>;
  maxConcurrentPlants?: Maybe<Scalars['Int']>;
  cultivationStyleId?: Maybe<Scalars['ID']>;
  cultivationStyleOther?: Maybe<Scalars['String']>;
  growingMediaId?: Maybe<Scalars['ID']>;
  growingMediaOther?: Maybe<Scalars['String']>;
  irrigationStyleId?: Maybe<Scalars['ID']>;
  irrigationStyleOther?: Maybe<Scalars['String']>;
  irrigationFrequencyId?: Maybe<Scalars['ID']>;
  irrigationFrequencyOther?: Maybe<Scalars['String']>;
  lengthFeet?: Maybe<Scalars['Float']>;
  lengthInches?: Maybe<Scalars['Float']>;
  heightFeet?: Maybe<Scalars['Float']>;
  heightInches?: Maybe<Scalars['Float']>;
  widthFeet?: Maybe<Scalars['Float']>;
  widthInches?: Maybe<Scalars['Float']>;
  rows?: Maybe<Scalars['Int']>;
  roomUsage?: Maybe<Scalars['String']>;
  numLightsUnderCanopy?: Maybe<Scalars['Int']>;
  underCanopy?: Maybe<Scalars['Boolean']>;
  underCanopyBrandId?: Maybe<Scalars['ID']>;
  underCanopyBrandOther?: Maybe<Scalars['String']>;
  benchSqFt?: Maybe<Scalars['Int']>;
  numPlants?: Maybe<Scalars['Int']>;
  tiers?: Maybe<Scalars['String']>;
  controlSystemId?: Maybe<Scalars['ID']>;
  controlSystemOther?: Maybe<Scalars['String']>;
  sensorsId?: Maybe<Scalars['ID']>;
  sensorsOther?: Maybe<Scalars['String']>;
  rootZoneSensorId?: Maybe<Scalars['ID']>;
  rootZoneSensorOther?: Maybe<Scalars['String']>;
  rockwoolBrandId?: Maybe<Scalars['ID']>;
  rockwoolBrandOther?: Maybe<Scalars['String']>;
  rockwoolSizeId?: Maybe<Scalars['ID']>;
  rockwoolSizeOther?: Maybe<Scalars['String']>;
  cocoBrandId?: Maybe<Scalars['ID']>;
  cocoBrandOther?: Maybe<Scalars['String']>;
  cocoContainerSize?: Maybe<Scalars['String']>;
  cocoContainerSizeOtherGallons?: Maybe<Scalars['Float']>;
  soilBrandId?: Maybe<Scalars['ID']>;
  soilBrandOther?: Maybe<Scalars['String']>;
  soilContainerSize?: Maybe<Scalars['String']>;
  irrigationTypeId?: Maybe<Scalars['ID']>;
  irrigationTypeOther?: Maybe<Scalars['String']>;
  dripEmitterSize?: Maybe<Scalars['Decimal']>;
  dehumidifierSelections?: Maybe<Array<Maybe<DehumidifierSelectionInput>>>;
  circulatingFanSelections?: Maybe<Array<Maybe<CirculatingFanSelectionInput>>>;
  acSelections?: Maybe<Array<Maybe<AcSelectionInput>>>;
  lightingTypeSelections?: Maybe<Array<Maybe<LightingTypeSelectionInput>>>;
};

export type CultivationActivitySummary = {
  __typename?: 'CultivationActivitySummary';
  id: Scalars['ID'];
  observationsReport: Scalars['String'];
  issuesReport: Scalars['String'];
  irrigationReport: Scalars['String'];
  foliarReport: Scalars['String'];
  pruningReport: Scalars['String'];
  toppingReport: Scalars['String'];
  runoffReport: Scalars['String'];
  status: CultivationActivitySummaryStatus;
  generatedAt: Scalars['DateTime'];
  approvedAt?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<UserProfile>;
  adminNotes: Scalars['String'];
  aiModelUsed: Scalars['String'];
  generationCost?: Maybe<Scalars['Decimal']>;
};

export enum CultivationActivitySummaryStatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Regenerating = 'REGENERATING'
}

export type CultivationSection = {
  __typename?: 'CultivationSection';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  entry: ChecklistEntry;
  overallPlantHealth?: Maybe<CultivationSectionOverallPlantHealth>;
  overallPlantHealthNote?: Maybe<Scalars['String']>;
  rootHealth?: Maybe<CultivationSectionRootHealth>;
  rootHealthNote?: Maybe<Scalars['String']>;
  wiltingPlants?: Maybe<CultivationSectionWiltingPlants>;
  wiltingPlantsLocation?: Maybe<Scalars['String']>;
  yellowingDiscoloration?: Maybe<CultivationSectionYellowingDiscoloration>;
  yellowingDiscolorationNote?: Maybe<Scalars['String']>;
  growthRate?: Maybe<CultivationSectionGrowthRate>;
  growthRateNote?: Maybe<Scalars['String']>;
};

export enum CultivationSectionGrowthRate {
  Fast = 'FAST',
  Normal = 'NORMAL',
  Slow = 'SLOW',
  Uneven = 'UNEVEN'
}

export type CultivationSectionInput = {
  overallPlantHealth?: Maybe<Scalars['String']>;
  overallPlantHealthNote?: Maybe<Scalars['String']>;
  rootHealth?: Maybe<Scalars['String']>;
  rootHealthNote?: Maybe<Scalars['String']>;
  wiltingPlants?: Maybe<Scalars['String']>;
  wiltingPlantsLocation?: Maybe<Scalars['String']>;
  yellowingDiscoloration?: Maybe<Scalars['String']>;
  yellowingDiscolorationNote?: Maybe<Scalars['String']>;
  growthRate?: Maybe<Scalars['String']>;
  growthRateNote?: Maybe<Scalars['String']>;
};

export enum CultivationSectionOverallPlantHealth {
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Fair = 'FAIR',
  Poor = 'POOR'
}

export enum CultivationSectionRootHealth {
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Fair = 'FAIR',
  Poor = 'POOR'
}

export enum CultivationSectionWiltingPlants {
  None = 'NONE',
  Few = 'FEW',
  Many = 'MANY'
}

export enum CultivationSectionYellowingDiscoloration {
  None = 'NONE',
  Minor = 'MINOR',
  Moderate = 'MODERATE',
  Severe = 'SEVERE'
}

export type CultivationStyle = {
  __typename?: 'CultivationStyle';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  zones: Array<Zone>;
};

export type CustomInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  isCustom?: Maybe<Scalars['Boolean']>;
};

export type DailyEnvironmentalMetric = {
  __typename?: 'DailyEnvironmentalMetric';
  expected: Scalars['Int'];
  observed: Scalars['Int'];
  comparable: Scalars['Int'];
  inside: Scalars['Int'];
  above: Scalars['Int'];
  below: Scalars['Int'];
  insidePercent?: Maybe<Scalars['Float']>;
  abovePercent?: Maybe<Scalars['Float']>;
  belowPercent?: Maybe<Scalars['Float']>;
  observedCoverage: Scalars['Float'];
  comparableCoverage: Scalars['Float'];
  dayLow?: Maybe<Scalars['Float']>;
  dayHigh?: Maybe<Scalars['Float']>;
  nightLow?: Maybe<Scalars['Float']>;
  nightHigh?: Maybe<Scalars['Float']>;
  key: Scalars['String'];
  sensors: Array<SensorEnvironmentalComparison>;
};

export type DailyTasksChecklist = {
  __typename?: 'DailyTasksChecklist';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklistSession: ChecklistSession;
  inspector?: Maybe<UserProfile>;
  zone?: Maybe<Zone>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['GenericScalar']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  flowerRoomAmCheck?: Maybe<Scalars['Boolean']>;
  flowerRoomAmCheckNote?: Maybe<Scalars['String']>;
  collectRunOffs?: Maybe<Scalars['Boolean']>;
  collectRunOffsNote?: Maybe<Scalars['String']>;
  cleanNetafimFilters?: Maybe<Scalars['Boolean']>;
  cleanNetafimFiltersNote?: Maybe<Scalars['String']>;
  sweepMopHallways?: Maybe<Scalars['Boolean']>;
  sweepMopHallwaysNote?: Maybe<Scalars['String']>;
  collectAllTrash?: Maybe<Scalars['Boolean']>;
  collectAllTrashNote?: Maybe<Scalars['String']>;
  flowerRoomPmCheck?: Maybe<Scalars['Boolean']>;
  flowerRoomPmCheckNote?: Maybe<Scalars['String']>;
};

export type DailyTasksChecklistInput = {
  checklistSessionId: Scalars['ID'];
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  flowerRoomAmCheck?: Maybe<Scalars['Boolean']>;
  flowerRoomAmCheckNote?: Maybe<Scalars['String']>;
  collectRunOffs?: Maybe<Scalars['Boolean']>;
  collectRunOffsNote?: Maybe<Scalars['String']>;
  cleanNetafimFilters?: Maybe<Scalars['Boolean']>;
  cleanNetafimFiltersNote?: Maybe<Scalars['String']>;
  sweepMopHallways?: Maybe<Scalars['Boolean']>;
  sweepMopHallwaysNote?: Maybe<Scalars['String']>;
  collectAllTrash?: Maybe<Scalars['Boolean']>;
  collectAllTrashNote?: Maybe<Scalars['String']>;
  flowerRoomPmCheck?: Maybe<Scalars['Boolean']>;
  flowerRoomPmCheckNote?: Maybe<Scalars['String']>;
};

export type DailyTasksChecklistResult = DailyTasksChecklist | Error;

export type DailyWetRoomTaskChecklist = {
  __typename?: 'DailyWetRoomTaskChecklist';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklistSession: ChecklistSession;
  inspector?: Maybe<UserProfile>;
  zone?: Maybe<Zone>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['GenericScalar']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  amCheckStockBarrels?: Maybe<Scalars['Boolean']>;
  amCheckStockBarrelsNote?: Maybe<Scalars['String']>;
  amCalibratePhEcEquipment?: Maybe<Scalars['Boolean']>;
  amCalibratePhEcEquipmentNote?: Maybe<Scalars['String']>;
  amMakeNeededStockBarrels?: Maybe<Scalars['Boolean']>;
  amMakeNeededStockBarrelsNote?: Maybe<Scalars['String']>;
  pmCheckStockBarrels?: Maybe<Scalars['Boolean']>;
  pmCheckStockBarrelsNote?: Maybe<Scalars['String']>;
  pmCleanUpPutAwayProducts?: Maybe<Scalars['Boolean']>;
  pmCleanUpPutAwayProductsNote?: Maybe<Scalars['String']>;
  pmCapAndStorePhEcEquipment?: Maybe<Scalars['Boolean']>;
  pmCapAndStorePhEcEquipmentNote?: Maybe<Scalars['String']>;
};

export type DailyWetRoomTaskChecklistInput = {
  checklistSessionId: Scalars['ID'];
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  amCheckStockBarrels?: Maybe<Scalars['Boolean']>;
  amCheckStockBarrelsNote?: Maybe<Scalars['String']>;
  amCalibratePhEcEquipment?: Maybe<Scalars['Boolean']>;
  amCalibratePhEcEquipmentNote?: Maybe<Scalars['String']>;
  amMakeNeededStockBarrels?: Maybe<Scalars['Boolean']>;
  amMakeNeededStockBarrelsNote?: Maybe<Scalars['String']>;
  pmCheckStockBarrels?: Maybe<Scalars['Boolean']>;
  pmCheckStockBarrelsNote?: Maybe<Scalars['String']>;
  pmCleanUpPutAwayProducts?: Maybe<Scalars['Boolean']>;
  pmCleanUpPutAwayProductsNote?: Maybe<Scalars['String']>;
  pmCapAndStorePhEcEquipment?: Maybe<Scalars['Boolean']>;
  pmCapAndStorePhEcEquipmentNote?: Maybe<Scalars['String']>;
};

export type DailyWetRoomTaskChecklistResult = DailyWetRoomTaskChecklist | Error;

export type DataQualityFinding = {
  __typename?: 'DataQualityFinding';
  code: Scalars['String'];
  severity: Scalars['String'];
  message: Scalars['String'];
};


export type DateRangeInput = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};



export type DehumidifierBrand = {
  __typename?: 'DehumidifierBrand';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  dehumidifierSelections: Array<DehumidifierSelection>;
};

export type DehumidifierSelection = {
  __typename?: 'DehumidifierSelection';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  zone: Zone;
  brand?: Maybe<DehumidifierBrand>;
  brandNameOther?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  numUnits?: Maybe<Scalars['Int']>;
};

export type DehumidifierSelectionInput = {
  id?: Maybe<Scalars['ID']>;
  brand?: Maybe<CustomInput>;
  brandNameOther?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  numUnits?: Maybe<Scalars['Int']>;
};

export type DeleteEnvironmentalDeviceInput = {
  id: Scalars['ID'];
};

export type DeleteLogEntryInput = {
  id: Scalars['ID'];
};

export type DeleteLogEntryResult = {
  __typename?: 'DeleteLogEntryResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteRecipeComponentInput = {
  id: Scalars['ID'];
};

export type DeleteStrainInStageInput = {
  strainId: Scalars['ID'];
};

export type DeleteToppingStyleInput = {
  id: Scalars['ID'];
};

export type DeleteToppingStyleResult = {
  __typename?: 'DeleteToppingStyleResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type DetectZoneLightingSchedules = {
  __typename?: 'DetectZoneLightingSchedules';
  schedules?: Maybe<Array<Maybe<DetectedZoneSchedule>>>;
  success?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
};

export type DetectedZoneSchedule = {
  __typename?: 'DetectedZoneSchedule';
  zoneId: Scalars['ID'];
  zoneName: Scalars['String'];
  dayStartTime?: Maybe<Scalars['String']>;
  nightStartTime?: Maybe<Scalars['String']>;
  detected: Scalars['Boolean'];
  brand?: Maybe<Scalars['String']>;
};

export type DryRoomPostHarvestChecklist = {
  __typename?: 'DryRoomPostHarvestChecklist';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklistSession: ChecklistSession;
  inspector?: Maybe<UserProfile>;
  zone?: Maybe<Zone>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['GenericScalar']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  doubleCheckFloorFans?: Maybe<Scalars['Boolean']>;
  doubleCheckFloorFansNote?: Maybe<Scalars['String']>;
  smallDehusOnHighestSetting?: Maybe<Scalars['Boolean']>;
  smallDehusOnHighestSettingNote?: Maybe<Scalars['String']>;
  doubleCheckTrolmasterSetpoints68f55rh?: Maybe<Scalars['Boolean']>;
  doubleCheckTrolmasterSetpoints68f55rhNote?: Maybe<Scalars['String']>;
  sweepAndRemovePlantDebris?: Maybe<Scalars['Boolean']>;
  sweepAndRemovePlantDebrisNote?: Maybe<Scalars['String']>;
};

export type DryRoomPostHarvestChecklistInput = {
  checklistSessionId: Scalars['ID'];
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  doubleCheckFloorFans?: Maybe<Scalars['Boolean']>;
  doubleCheckFloorFansNote?: Maybe<Scalars['String']>;
  smallDehusOnHighestSetting?: Maybe<Scalars['Boolean']>;
  smallDehusOnHighestSettingNote?: Maybe<Scalars['String']>;
  doubleCheckTrolmasterSetpoints68f55rh?: Maybe<Scalars['Boolean']>;
  doubleCheckTrolmasterSetpoints68f55rhNote?: Maybe<Scalars['String']>;
  sweepAndRemovePlantDebris?: Maybe<Scalars['Boolean']>;
  sweepAndRemovePlantDebrisNote?: Maybe<Scalars['String']>;
};

export type DryRoomPostHarvestChecklistResult = DryRoomPostHarvestChecklist | Error;

export type DryRoomPreHarvestChecklist = {
  __typename?: 'DryRoomPreHarvestChecklist';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklistSession: ChecklistSession;
  inspector?: Maybe<UserProfile>;
  zone?: Maybe<Zone>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['GenericScalar']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  setTrolmasterSetpoints68f55rh?: Maybe<Scalars['Boolean']>;
  setTrolmasterSetpoints68f55rhNote?: Maybe<Scalars['String']>;
  setUpFloorFans?: Maybe<Scalars['Boolean']>;
  setUpFloorFansNote?: Maybe<Scalars['String']>;
  setUpSmallDehus?: Maybe<Scalars['Boolean']>;
  setUpSmallDehusNote?: Maybe<Scalars['String']>;
  setRacksUpForHanging?: Maybe<Scalars['Boolean']>;
  setRacksUpForHangingNote?: Maybe<Scalars['String']>;
};

export type DryRoomPreHarvestChecklistInput = {
  checklistSessionId: Scalars['ID'];
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  setTrolmasterSetpoints68f55rh?: Maybe<Scalars['Boolean']>;
  setTrolmasterSetpoints68f55rhNote?: Maybe<Scalars['String']>;
  setUpFloorFans?: Maybe<Scalars['Boolean']>;
  setUpFloorFansNote?: Maybe<Scalars['String']>;
  setUpSmallDehus?: Maybe<Scalars['Boolean']>;
  setUpSmallDehusNote?: Maybe<Scalars['String']>;
  setRacksUpForHanging?: Maybe<Scalars['Boolean']>;
  setRacksUpForHangingNote?: Maybe<Scalars['String']>;
};

export type DryRoomPreHarvestChecklistResult = DryRoomPreHarvestChecklist | Error;

export type DuplicateCalendarBranchInput = {
  name: Scalars['String'];
  originalId: Scalars['ID'];
};

export type EnableMultisiteInput = {
  organizationId: Scalars['ID'];
};

export enum EnvironmentSensorDeviceCategory {
  Climate = 'CLIMATE',
  Substrate = 'SUBSTRATE',
  Runoff = 'RUNOFF'
}

export enum EnvironmentSensorDeviceReportingIntervalMinutes {
  A_15 = 'A_15',
  A_30 = 'A_30',
  A_60 = 'A_60'
}

export enum EnvironmentSensorDeviceTrolmasterModel {
  Hydrox = 'HYDROX',
  HydroxPro = 'HYDROX_PRO',
  HydroxPlus = 'HYDROX_PLUS',
  Aquax = 'AQUAX'
}

export type EnvironmentalAnalysisDay = {
  __typename?: 'EnvironmentalAnalysisDay';
  date: Scalars['Date'];
  stageId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
  targetId?: Maybe<Scalars['ID']>;
  weekInPhase?: Maybe<Scalars['Int']>;
  issues: Array<Scalars['String']>;
  metrics: Array<DailyEnvironmentalMetric>;
};

export type EnvironmentalAnalysisWeek = {
  __typename?: 'EnvironmentalAnalysisWeek';
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  metrics: Array<AnalysisWeeklyMetric>;
};

export type EnvironmentalAnalyticsFilterInput = {
  zoneId?: Maybe<Scalars['String']>;
  harvestGroupId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};

export type EnvironmentalAnalyticsResult = {
  __typename?: 'EnvironmentalAnalyticsResult';
  temperature: AnalyticsChartData;
  humidity: AnalyticsChartData;
  co2: AnalyticsChartData;
  vpd: AnalyticsChartData;
};

export type EnvironmentalDataDailyType = {
  __typename?: 'EnvironmentalDataDailyType';
  id: Scalars['UUID'];
  zone: Zone;
  environmentalFile?: Maybe<EnvironmentalFileType>;
  sensorDevice?: Maybe<EnvironmentalDevice>;
  day: Scalars['Date'];
  dataPoints?: Maybe<Scalars['GenericScalar']>;
};

export type EnvironmentalDevice = {
  __typename?: 'EnvironmentalDevice';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  reportingIntervalMinutes?: Maybe<EnvironmentSensorDeviceReportingIntervalMinutes>;
  name: Scalars['String'];
  isActive: Scalars['Boolean'];
  category?: Maybe<EnvironmentSensorDeviceCategory>;
  isPrimary: Scalars['Boolean'];
  trolmasterMacAddress?: Maybe<Scalars['String']>;
  trolmasterModel?: Maybe<EnvironmentSensorDeviceTrolmasterModel>;
  aroyaDeviceId?: Maybe<Scalars['String']>;
  aroyaModelKey?: Maybe<Scalars['String']>;
  aroyaSerialNumber?: Maybe<Scalars['String']>;
  aroyaApiRoomName?: Maybe<Scalars['String']>;
  aroyaApiBenchName?: Maybe<Scalars['String']>;
  growlinkControllerId?: Maybe<Scalars['String']>;
  growlinkModuleName?: Maybe<Scalars['String']>;
  growlinkTemperatureSensorId?: Maybe<Scalars['String']>;
  growlinkHumiditySensorId?: Maybe<Scalars['String']>;
  growlinkCo2SensorId?: Maybe<Scalars['String']>;
  growlinkVpdSensorId?: Maybe<Scalars['String']>;
  growlinkLightSensorId?: Maybe<Scalars['String']>;
  credential?: Maybe<SensorIntegrationCredential>;
  zone: Zone;
  fieldAgentDevices: Array<FieldAgentDevice>;
  days: Array<EnvironmentalDataDailyType>;
};

export type EnvironmentalDeviceResult = EnvironmentalDevice | Error;

export enum EnvironmentalFileAutodetectStatus {
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  Processed = 'PROCESSED',
  Error = 'ERROR'
}

export enum EnvironmentalFileFileStatus {
  NotStarted = 'NOT_STARTED',
  Uploaded = 'UPLOADED',
  Processed = 'PROCESSED',
  Error = 'ERROR'
}

export enum EnvironmentalFileFileType {
  Thrive = 'THRIVE',
  Trolmaster = 'TROLMASTER'
}

export type EnvironmentalFileFilterSetInput = {
  zoneId?: Maybe<Scalars['String']>;
};

export type EnvironmentalFileInput = {
  fileUrl: Scalars['String'];
  zoneId: Scalars['ID'];
};

export type EnvironmentalFileType = {
  __typename?: 'EnvironmentalFileType';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  organization: Organization;
  dataFile: Scalars['String'];
  fileType?: Maybe<EnvironmentalFileFileType>;
  zone: Zone;
  timeOffsetSeconds: Scalars['Int'];
  sevenDayPreview?: Maybe<Array<AnalyticsDataPoint>>;
  fileStatus: EnvironmentalFileFileStatus;
  autodetectStatus: EnvironmentalFileAutodetectStatus;
  currentHgs?: Maybe<Array<HarvestGroup>>;
  currentStages?: Maybe<Array<Stage>>;
  guessEnvType?: Maybe<Scalars['String']>;
  guessTargetValues?: Maybe<EnvironmentalTargetValues>;
};

export type EnvironmentalFileTypeResult = EnvironmentalFileType | Error;

export type EnvironmentalTargetSet = {
  __typename?: 'EnvironmentalTargetSet';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  environmentLightingType: EnvironmentalTargetSetEnvironmentLightingType;
  environmentalTargetValues?: Maybe<Array<Maybe<EnvironmentalTargetValues>>>;
  displayName?: Maybe<Scalars['String']>;
};

export enum EnvironmentalTargetSetEnvironmentLightingType {
  Default = 'DEFAULT',
  DoubleEndedHps = 'DOUBLE_ENDED_HPS',
  Cmh = 'CMH',
  Led = 'LED',
  Other = 'OTHER'
}

export type EnvironmentalTargetSetResult = EnvironmentalTargetSet | Error;

export type EnvironmentalTargetValues = {
  __typename?: 'EnvironmentalTargetValues';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  environmentalTargetSet: EnvironmentalTargetSet;
  environmentalTargetType: EnvironmentalTargetValuesEnvironmentalTargetType;
  weekInPhase?: Maybe<Scalars['Int']>;
  dayTempLow: Scalars['Int'];
  dayTempHigh: Scalars['Int'];
  nightTempLow: Scalars['Int'];
  nightTempHigh: Scalars['Int'];
  dayVpdLow: Scalars['Float'];
  dayVpdHigh: Scalars['Float'];
  nightVpdLow: Scalars['Float'];
  nightVpdHigh: Scalars['Float'];
  dayHumidityLow: Scalars['Int'];
  dayHumidityHigh: Scalars['Int'];
  nightHumidityLow: Scalars['Int'];
  nightHumidityHigh: Scalars['Int'];
  dayCo2Low: Scalars['Int'];
  dayCo2High: Scalars['Int'];
  nightCo2Low: Scalars['Int'];
  nightCo2High: Scalars['Int'];
  environmentalfileSet: Array<EnvironmentalFileType>;
};

export enum EnvironmentalTargetValuesEnvironmentalTargetType {
  Veg = 'VEG',
  Flower = 'FLOWER',
  NoTargets = 'NO_TARGETS'
}

export type EnvironmentalTargetValuesInput = {
  environmentalTargetType: Scalars['String'];
  weekInPhase: Scalars['Int'];
  dayTempLow?: Maybe<Scalars['Float']>;
  dayTempHigh?: Maybe<Scalars['Float']>;
  nightTempLow?: Maybe<Scalars['Float']>;
  nightTempHigh?: Maybe<Scalars['Float']>;
  dayHumidityLow?: Maybe<Scalars['Float']>;
  dayHumidityHigh?: Maybe<Scalars['Float']>;
  nightHumidityLow?: Maybe<Scalars['Float']>;
  nightHumidityHigh?: Maybe<Scalars['Float']>;
  dayCo2Low?: Maybe<Scalars['Float']>;
  dayCo2High?: Maybe<Scalars['Float']>;
  nightCo2Low?: Maybe<Scalars['Float']>;
  nightCo2High?: Maybe<Scalars['Float']>;
  dayVpdLow?: Maybe<Scalars['Float']>;
  dayVpdHigh?: Maybe<Scalars['Float']>;
  nightVpdLow?: Maybe<Scalars['Float']>;
  nightVpdHigh?: Maybe<Scalars['Float']>;
};

export type Equipment = {
  __typename?: 'Equipment';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  label: Scalars['String'];
  type: EquipmentType;
  lastMaintenanceDate: Scalars['Date'];
  location: Location;
  brand?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  installedAtDate?: Maybe<Scalars['Date']>;
  notes?: Maybe<Scalars['String']>;
  status: EquipmentStatus;
  organization?: Maybe<Organization>;
};

export type EquipmentFilterSetInput = {
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
};

export type EquipmentResult = Equipment | Error;

export enum EquipmentStatus {
  NeedsMaintenance = 'NEEDS_MAINTENANCE',
  Operational = 'OPERATIONAL',
  OutOfService = 'OUT_OF_SERVICE'
}

export enum EquipmentType {
  Dehumidifier = 'DEHUMIDIFIER',
  Ac = 'AC',
  Fan = 'FAN',
  Light = 'LIGHT',
  Sensor = 'SENSOR',
  Pump = 'PUMP',
  Co2 = 'CO2',
  Humidifier = 'HUMIDIFIER',
  FilterBox = 'FILTER_BOX'
}

export type Error = {
  __typename?: 'Error';
  message: Scalars['String'];
};

export type FacilitySurvey = {
  __typename?: 'FacilitySurvey';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  fieldSurvey?: Maybe<FieldSurvey>;
  createdBy?: Maybe<UserProfile>;
  reportDate: Scalars['Date'];
  completedAt?: Maybe<Scalars['DateTime']>;
  phPrefilter: Scalars['Decimal'];
  ecPrefilter: Scalars['Decimal'];
  tdsPrefilter: Scalars['Int'];
  tempPrefilter: Scalars['Decimal'];
  phPostfilter: Scalars['Decimal'];
  ecPostfilter: Scalars['Decimal'];
  tdsPostfilter: Scalars['Int'];
  tempPostfilter: Scalars['Decimal'];
  storageLabels: FacilitySurveyStorageLabels;
  storageContainers: FacilitySurveyStorageContainers;
  storageConditions: FacilitySurveyStorageConditions;
  safetyProtocols: FacilitySurveySafetyProtocols;
  ppeForHandling: FacilitySurveyPpeForHandling;
  ppeGlovesAvailable: FacilitySurveyPpeGlovesAvailable;
  ppeMasksAvailable: FacilitySurveyPpeMasksAvailable;
  ppeGogglesAvailable: FacilitySurveyPpeGogglesAvailable;
  msdsDocumentationUpToDate: FacilitySurveyMsdsDocumentationUpToDate;
  trainingLogsUpToDate: FacilitySurveyTrainingLogsUpToDate;
  hygieneAdherence: FacilitySurveyHygieneAdherence;
  floorsStatus: FacilitySurveyFloorsStatus;
  wallsStatus: FacilitySurveyWallsStatus;
  ceilingsStatus: FacilitySurveyCeilingsStatus;
  handWashStations: FacilitySurveyHandWashStations;
  footBaths: FacilitySurveyFootBaths;
  eyeWashStations: FacilitySurveyEyeWashStations;
  roFilters: FacilitySurveyRoFilters;
  roInlineFilters: FacilitySurveyRoInlineFilters;
  roAirChambers: FacilitySurveyRoAirChambers;
  roPumps: FacilitySurveyRoPumps;
  roCheckValves: FacilitySurveyRoCheckValves;
  waterTestTap: FacilitySurveyWaterTestTap;
  waterTestPostFilter: FacilitySurveyWaterTestPostFilter;
  notes?: Maybe<Scalars['String']>;
  recommendations?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum FacilitySurveyCeilingsStatus {
  Clean = 'CLEAN',
  NeedsCleaning = 'NEEDS_CLEANING'
}

export enum FacilitySurveyEyeWashStations {
  Working = 'WORKING',
  NotWorking = 'NOT_WORKING'
}

export enum FacilitySurveyFloorsStatus {
  Clean = 'CLEAN',
  NeedsCleaning = 'NEEDS_CLEANING'
}

export enum FacilitySurveyFootBaths {
  Filled = 'FILLED',
  Empty = 'EMPTY'
}

export enum FacilitySurveyHandWashStations {
  Working = 'WORKING',
  NotWorking = 'NOT_WORKING'
}

export enum FacilitySurveyHygieneAdherence {
  Yes = 'YES',
  No = 'NO'
}

export enum FacilitySurveyMsdsDocumentationUpToDate {
  Missing = 'MISSING',
  Available = 'AVAILABLE'
}

export enum FacilitySurveyPpeForHandling {
  FullyStocked = 'FULLY_STOCKED',
  NeedsRefill = 'NEEDS_REFILL'
}

export enum FacilitySurveyPpeGlovesAvailable {
  FullyStocked = 'FULLY_STOCKED',
  NeedsRefill = 'NEEDS_REFILL'
}

export enum FacilitySurveyPpeGogglesAvailable {
  FullyStocked = 'FULLY_STOCKED',
  NeedsRefill = 'NEEDS_REFILL'
}

export enum FacilitySurveyPpeMasksAvailable {
  FullyStocked = 'FULLY_STOCKED',
  NeedsRefill = 'NEEDS_REFILL'
}

export type FacilitySurveyResult = FacilitySurvey | Error;

export enum FacilitySurveyRoAirChambers {
  A = 'A_',
  Installed = 'INSTALLED',
  NotInstalled = 'NOT_INSTALLED'
}

export enum FacilitySurveyRoCheckValves {
  A = 'A_',
  Installed = 'INSTALLED',
  NotInstalled = 'NOT_INSTALLED'
}

export enum FacilitySurveyRoFilters {
  Clean = 'CLEAN',
  Dirty = 'DIRTY'
}

export enum FacilitySurveyRoInlineFilters {
  A = 'A_',
  Installed = 'INSTALLED',
  NotInstalled = 'NOT_INSTALLED'
}

export enum FacilitySurveyRoPumps {
  A = 'A_',
  Functioning = 'FUNCTIONING',
  NotFunctioning = 'NOT_FUNCTIONING'
}

export enum FacilitySurveySafetyProtocols {
  Sufficient = 'SUFFICIENT',
  Missing = 'MISSING'
}

export enum FacilitySurveyStorageConditions {
  Leaks = 'LEAKS',
  NoLeaks = 'NO_LEAKS'
}

export enum FacilitySurveyStorageContainers {
  Clear = 'CLEAR',
  Cloudy = 'CLOUDY'
}

export enum FacilitySurveyStorageLabels {
  Clear = 'CLEAR',
  Cloudy = 'CLOUDY'
}

export enum FacilitySurveyTrainingLogsUpToDate {
  Missing = 'MISSING',
  Available = 'AVAILABLE'
}

export enum FacilitySurveyWallsStatus {
  Clean = 'CLEAN',
  NeedsCleaning = 'NEEDS_CLEANING'
}

export enum FacilitySurveyWaterTestPostFilter {
  Sampled = 'SAMPLED',
  NotSampled = 'NOT_SAMPLED'
}

export enum FacilitySurveyWaterTestTap {
  Sampled = 'SAMPLED',
  NotSampled = 'NOT_SAMPLED'
}

export type FieldAgent = {
  __typename?: 'FieldAgent';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization?: Maybe<Organization>;
  site?: Maybe<OrganizationSite>;
  agentId: Scalars['String'];
  label: Scalars['String'];
  vendor: Scalars['String'];
  tokenKey: Scalars['String'];
  tokenKeyPrefix: Scalars['String'];
  tokenSecretHash: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  hostname: Scalars['String'];
  localIp?: Maybe<Scalars['String']>;
  subnet: Scalars['String'];
  softwareVersion: Scalars['String'];
  status: FieldAgentStatus;
  latestStatusPayload: Scalars['JSONString'];
  roomAliases: Scalars['JSONString'];
  devices: Array<FieldAgentDevice>;
  isStale?: Maybe<Scalars['Boolean']>;
};

export type FieldAgentDevice = {
  __typename?: 'FieldAgentDevice';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  agent: FieldAgent;
  vendor: Scalars['String'];
  modbusAddress: Scalars['Int'];
  controllerId: Scalars['String'];
  deviceName: Scalars['String'];
  deviceType: FieldAgentDeviceDeviceType;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  lastMetrics: Scalars['JSONString'];
  sensorDevice?: Maybe<EnvironmentalDevice>;
};

export enum FieldAgentDeviceDeviceType {
  Env = 'ENV',
  Hydro = 'HYDRO',
  Irrigation = 'IRRIGATION',
  Lighting = 'LIGHTING',
  Unknown = 'UNKNOWN'
}

export type FieldAgentDeviceResult = FieldAgentDevice | Error;

export enum FieldAgentStatus {
  Unknown = 'UNKNOWN',
  Online = 'ONLINE',
  Degraded = 'DEGRADED',
  Offline = 'OFFLINE'
}

export type FieldSurvey = {
  __typename?: 'FieldSurvey';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  site?: Maybe<OrganizationSite>;
  createdBy?: Maybe<UserProfile>;
  facilitySurvey?: Maybe<FacilitySurvey>;
  roomSurveys: Array<RoomSurvey>;
  zonesAvailable?: Maybe<Array<Zone>>;
};

export type FieldSurveyResult = FieldSurvey | Error;

export type FileBase64UploadInput = {
  fileData: Scalars['String'];
  fileName: Scalars['String'];
};

export type FinanceDelete = {
  __typename?: 'FinanceDelete';
  ok?: Maybe<Scalars['Boolean']>;
};

export type FinanceMappings = {
  __typename?: 'FinanceMappings';
  ok?: Maybe<Scalars['Boolean']>;
};

export type FinancePublish = {
  __typename?: 'FinancePublish';
  ok?: Maybe<Scalars['Boolean']>;
};

export type FinanceSettings = {
  __typename?: 'FinanceSettings';
  ok?: Maybe<Scalars['Boolean']>;
};

export type FinishProcessingGroupStrainInput = {
  id: Scalars['ID'];
};

export type GenerateFieldAgentClaimCodeInput = {
  fieldAgentId: Scalars['ID'];
};

export type GenerateFieldAgentClaimCodeResult = GenerateFieldAgentClaimCodeSuccess | Error;

export type GenerateFieldAgentClaimCodeSuccess = {
  __typename?: 'GenerateFieldAgentClaimCodeSuccess';
  fieldAgent?: Maybe<FieldAgent>;
  claimCode: Scalars['String'];
  expiresAt: Scalars['DateTime'];
};

export type GenerateHarvestSummaryInput = {
  harvestGroupId: Scalars['ID'];
};

export enum GenerationRequestAnalysisType {
  TargetSetpoints = 'TARGET_SETPOINTS',
  HarvestTemplate = 'HARVEST_TEMPLATE'
}

export enum GenerationRequestAsyncAnalysisStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type GenerationRequestFilterSetInput = {
  analysisType?: Maybe<Scalars['String']>;
  asyncAnalysisStatus?: Maybe<Scalars['String']>;
  createdAt_Gt?: Maybe<Scalars['DateTime']>;
  createdAt_Lt?: Maybe<Scalars['DateTime']>;
  siteId?: Maybe<Scalars['String']>;
};

export type GenerationRequestImageInput = {
  imageUrl: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
};

export type GenerationRequestImageType = {
  __typename?: 'GenerationRequestImageType';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  imageUpload: Scalars['String'];
  order: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
};

export type GenerationRequestType = {
  __typename?: 'GenerationRequestType';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  asyncAnalysisStatus?: Maybe<GenerationRequestAsyncAnalysisStatus>;
  asyncAnalysisStartedAt?: Maybe<Scalars['DateTime']>;
  asyncAnalysisCompletedAt?: Maybe<Scalars['DateTime']>;
  asyncAnalysisError?: Maybe<Scalars['String']>;
  asyncAnalysisProgressPct: Scalars['Int'];
  organization: Organization;
  site?: Maybe<OrganizationSite>;
  requestedBy?: Maybe<UserProfile>;
  analysisType: GenerationRequestAnalysisType;
  textPrompt: Scalars['String'];
  result?: Maybe<Scalars['GenericScalar']>;
  appliedAt?: Maybe<Scalars['DateTime']>;
  appliedBy?: Maybe<UserProfile>;
  images: Array<GenerationRequestImageType>;
};

export type GenerationRequestTypeResult = GenerationRequestType | Error;


export type GetSignedUploadUrlInput = {
  path: Scalars['String'];
  contentType: Scalars['String'];
};

export type GetSignedUploadUrlResult = {
  __typename?: 'GetSignedUploadURLResult';
  signedUploadUrl?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type GroupEnvironmentalAnalysis = {
  __typename?: 'GroupEnvironmentalAnalysis';
  groupId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  timezone: Scalars['String'];
  days: Array<EnvironmentalAnalysisDay>;
  weeks: Array<EnvironmentalAnalysisWeek>;
};

export type GrowingMedia = {
  __typename?: 'GrowingMedia';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  zones: Array<Zone>;
};

export type GrowlinkDevice = {
  __typename?: 'GrowlinkDevice';
  controllerId?: Maybe<Scalars['String']>;
  moduleName?: Maybe<Scalars['String']>;
  temperatureSensorId?: Maybe<Scalars['String']>;
  humiditySensorId?: Maybe<Scalars['String']>;
  co2SensorId?: Maybe<Scalars['String']>;
  vpdSensorId?: Maybe<Scalars['String']>;
  lightSensorId?: Maybe<Scalars['String']>;
  roomName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type GrowlinkDeviceRequest = {
  __typename?: 'GrowlinkDeviceRequest';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  inventoryPresent?: Maybe<Scalars['Boolean']>;
  credential?: Maybe<SensorIntegrationCredential>;
  controllerId: Scalars['String'];
  moduleName?: Maybe<Scalars['String']>;
  temperatureSensorId?: Maybe<Scalars['String']>;
  humiditySensorId?: Maybe<Scalars['String']>;
  co2SensorId?: Maybe<Scalars['String']>;
  vpdSensorId?: Maybe<Scalars['String']>;
  lightSensorId?: Maybe<Scalars['String']>;
  roomName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  isAdded: Scalars['Boolean'];
};

export type GrowlinkOrganization = {
  __typename?: 'GrowlinkOrganization';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type HarvestAnalysisEnvironmentalData = {
  __typename?: 'HarvestAnalysisEnvironmentalData';
  hasData?: Maybe<Scalars['Boolean']>;
  totalWeeks?: Maybe<Scalars['Int']>;
  temperatureCompliance?: Maybe<Scalars['Float']>;
  humidityCompliance?: Maybe<Scalars['Float']>;
  co2Compliance?: Maybe<Scalars['Float']>;
  vpdCompliance?: Maybe<Scalars['Float']>;
};

export type HarvestAnalysisLogData = {
  __typename?: 'HarvestAnalysisLogData';
  totalObservations?: Maybe<Scalars['Int']>;
  totalIssues?: Maybe<Scalars['Int']>;
  irrigationEvents?: Maybe<Scalars['Int']>;
  issuesIdentified?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type HarvestAnalysisYieldData = {
  __typename?: 'HarvestAnalysisYieldData';
  totalGrams?: Maybe<Scalars['Float']>;
  totalPounds?: Maybe<Scalars['Float']>;
  strainCount?: Maybe<Scalars['Int']>;
  topStrain?: Maybe<Scalars['String']>;
  averageGramsPerPlant?: Maybe<Scalars['Float']>;
};

export type HarvestCompletion = {
  __typename?: 'HarvestCompletion';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  harvestGroup: HarvestGroup;
  createdBy: UserProfile;
  cosignedAt?: Maybe<Scalars['DateTime']>;
  cosignedBy?: Maybe<UserProfile>;
};

export type HarvestCompletionResult = HarvestCompletion | Error;

export type HarvestGroup = {
  __typename?: 'HarvestGroup';
  id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  archivedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  shortName?: Maybe<Scalars['String']>;
  createdBy?: Maybe<UserProfile>;
  flowerZone?: Maybe<Zone>;
  colorHexCode?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  harvestDate?: Maybe<Scalars['Date']>;
  templateUsed?: Maybe<HarvestGroupTemplate>;
  site: OrganizationSite;
  importedFromMetrc: Scalars['Boolean'];
  isMultisite: Scalars['Boolean'];
  yields: Array<HarvestStrainYield>;
  harvestCompletion?: Maybe<HarvestCompletion>;
  stages: Array<Stage>;
  logEntries: Array<LogEntry>;
  aiSummary?: Maybe<HarvestSummary>;
  aiActivitySummary?: Maybe<CultivationActivitySummary>;
  becameProcessingGroup?: Maybe<ProcessingGroup>;
  projections?: Maybe<Array<HarvestProjection>>;
  currentStage: Stage;
  strains: Array<Strain>;
  tasks: Array<Task>;
  metrcImportStrainMapping?: Maybe<Scalars['GenericScalar']>;
  /** @deprecated Use groupEnvironmentalAnalysis; legacy scores are retired. */
  yesterdaysHealthStatus?: Maybe<Scalars['String']>;
  /** @deprecated Use groupEnvironmentalAnalysis. */
  weeklyEnvironmentalData?: Maybe<Array<Maybe<WeeklyEnvironmentalData>>>;
  stageWeeks: Array<StageWeek>;
  hasYields?: Maybe<Scalars['Boolean']>;
  draftLogEntryCount?: Maybe<Scalars['Int']>;
  flowerStartDate?: Maybe<Scalars['Date']>;
  isAutoCreated: Scalars['Boolean'];
};


export type HarvestGroupLogEntriesArgs = {
  logEntryOptions?: Maybe<LogsFilterInput>;
};


export type HarvestGroupTasksArgs = {
  dateRange?: Maybe<DateRangeInput>;
  calendarBranchId?: Maybe<Scalars['String']>;
};

export type HarvestGroupAutoCreationConfig = {
  __typename?: 'HarvestGroupAutoCreationConfig';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  site: OrganizationSite;
  template: HarvestGroupTemplate;
  isEnabled: Scalars['Boolean'];
  fillAllRooms: Scalars['Boolean'];
  startDate: Scalars['Date'];
  intervalDays: Scalars['Int'];
  planningHorizonMonths: Scalars['Int'];
  nextRunOn: Scalars['Date'];
  lastRunAt?: Maybe<Scalars['DateTime']>;
  lastSuccessAt?: Maybe<Scalars['DateTime']>;
  lastErrorAt?: Maybe<Scalars['DateTime']>;
  lastErrorMessage?: Maybe<Scalars['String']>;
  createdBy?: Maybe<UserProfile>;
  createdHarvestGroups: Array<HarvestGroup>;
  stageZoneOrders: Array<HarvestGroupAutoCreationStageZoneOrder>;
  stageCursors: Array<HarvestGroupAutoCreationStageCursor>;
  runs: Array<HarvestGroupAutoCreationRun>;
};

export type HarvestGroupAutoCreationConfigResult = HarvestGroupAutoCreationConfig | Error;

export type HarvestGroupAutoCreationRun = {
  __typename?: 'HarvestGroupAutoCreationRun';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  config: HarvestGroupAutoCreationConfig;
  startedAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  status: HarvestGroupAutoCreationRunStatus;
  createdHarvestGroup?: Maybe<HarvestGroup>;
  message?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['JSONString']>;
};

export enum HarvestGroupAutoCreationRunStatus {
  Success = 'SUCCESS',
  Failed = 'FAILED',
  Skipped = 'SKIPPED'
}

export type HarvestGroupAutoCreationStageCursor = {
  __typename?: 'HarvestGroupAutoCreationStageCursor';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  config: HarvestGroupAutoCreationConfig;
  stageTemplate: StageTemplate;
  cursor: Scalars['Int'];
};

export type HarvestGroupAutoCreationStageZoneOrder = {
  __typename?: 'HarvestGroupAutoCreationStageZoneOrder';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  config: HarvestGroupAutoCreationConfig;
  stageTemplate: StageTemplate;
  zone: Zone;
  position: Scalars['Int'];
  rotationStep: Scalars['Int'];
  positionInStep: Scalars['Int'];
};

export type HarvestGroupFilterSetInput = {
  createdAt_Gt?: Maybe<Scalars['DateTime']>;
  createdAt_Lt?: Maybe<Scalars['DateTime']>;
  importedFromMetrc?: Maybe<Scalars['Boolean']>;
  unarchived?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['String']>;
  calendarVisible?: Maybe<Scalars['String']>;
  started?: Maybe<Scalars['String']>;
  usesZoneId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
};

export type HarvestGroupQuerysetOptionsInput = {
  paging?: Maybe<PagingInput>;
  filters?: Maybe<CompletedHarvestGroupFilterSetInput>;
};

export type HarvestGroupQuerysetOptionsOutput = {
  __typename?: 'HarvestGroupQuerysetOptionsOutput';
  paging: PagingInfo;
  filters: CompletedHarvestGroupFilterSetOutput;
};

export type HarvestGroupQuerysetResult = {
  __typename?: 'HarvestGroupQuerysetResult';
  options: HarvestGroupQuerysetOptionsOutput;
  items: Array<Maybe<HarvestGroup>>;
};

export type HarvestGroupResult = HarvestGroup | Error;

export type HarvestGroupTemplate = {
  __typename?: 'HarvestGroupTemplate';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  archivedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  activeTemplateVersion?: Maybe<HarvestGroupTemplateVersion>;
  harvestGroups: Array<HarvestGroup>;
  versions: Array<HarvestGroupTemplateVersion>;
  autoCreationConfigs: Array<HarvestGroupAutoCreationConfig>;
  stageTemplates: Array<StageTemplate>;
  templateVegZones: Array<Zone>;
  templateFlowerZones: Array<Zone>;
};

export type HarvestGroupTemplateFilterSetInput = {
  archivedAt_Isnull?: Maybe<Scalars['Boolean']>;
  unarchived?: Maybe<Scalars['String']>;
};

export type HarvestGroupTemplateResult = HarvestGroupTemplate | Error;

export type HarvestGroupTemplateUpdateResult = {
  __typename?: 'HarvestGroupTemplateUpdateResult';
  template?: Maybe<HarvestGroupTemplate>;
  conflicts?: Maybe<Array<Maybe<ValidationConflict>>>;
  changeNotifications?: Maybe<Array<Maybe<ValidationConflict>>>;
  success?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
};

export type HarvestGroupTemplateVersion = {
  __typename?: 'HarvestGroupTemplateVersion';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  template?: Maybe<HarvestGroupTemplate>;
  version: Scalars['Int'];
  harvestGroups: Array<HarvestGroup>;
  harvestGroupTemplates: Array<HarvestGroupTemplate>;
  stageTemplates: Array<StageTemplate>;
};

export type HarvestProjection = {
  __typename?: 'HarvestProjection';
  id: Scalars['UUID'];
  strain: Strain;
  plantCount: Scalars['Int'];
  harvestGroupId: Scalars['String'];
  strainId: Scalars['String'];
};

export type HarvestProjectionResult = HarvestProjection | Error;

export type HarvestStrainPerformance = {
  __typename?: 'HarvestStrainPerformance';
  id: Scalars['String'];
  name: Scalars['String'];
  harvestDate: Scalars['String'];
  totalGrams: Scalars['Float'];
  effectiveTotalGrams: Scalars['Float'];
  totalFlowerGrams: Scalars['Float'];
  finalPlantCount: Scalars['Int'];
  gramsPerPlant: Scalars['Float'];
  byFormFactor: Array<BudFormFactorYield>;
  adjustedParentTotalGrams?: Maybe<Scalars['Float']>;
};

export type HarvestStrainYield = {
  __typename?: 'HarvestStrainYield';
  id: Scalars['UUID'];
  harvestGroup: HarvestGroup;
  strain: Strain;
  enteredBy: UserProfile;
  totalGrams: Scalars['Float'];
  finalPlantCount: Scalars['Int'];
  historicalAvgGramsPerPlant?: Maybe<Scalars['Float']>;
  harvestGroupId: Scalars['String'];
  strainId: Scalars['String'];
  yieldBatches: Array<HarvestYieldBatch>;
  budFormFactorYields: Array<BudFormFactorYield>;
};

export type HarvestSummary = {
  __typename?: 'HarvestSummary';
  id: Scalars['ID'];
  summaryText: Scalars['String'];
  yieldDriversAnalysis: Scalars['String'];
  status: HarvestSummaryStatus;
  generatedAt: Scalars['DateTime'];
  approvedAt?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<UserProfile>;
  adminNotes: Scalars['String'];
  aiModelUsed: Scalars['String'];
  generationCost?: Maybe<Scalars['Decimal']>;
  yieldAnalysis?: Maybe<HarvestAnalysisYieldData>;
  environmentalAnalysis?: Maybe<HarvestAnalysisEnvironmentalData>;
  logAnalysis?: Maybe<HarvestAnalysisLogData>;
};

export enum HarvestSummaryStatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Regenerating = 'REGENERATING'
}

export type HarvestYieldBatch = {
  __typename?: 'HarvestYieldBatch';
  id: Scalars['String'];
  name: Scalars['String'];
  harvestDate?: Maybe<Scalars['Date']>;
  sourceMetrcHarvestId?: Maybe<Scalars['String']>;
  stream: YieldProductStream;
  flowerGrams: Scalars['Float'];
  trimGrams: Scalars['Float'];
  dryGrams: Scalars['Float'];
  wetPackagedGrams: Scalars['Float'];
  unknownGrams: Scalars['Float'];
  plantCount?: Maybe<Scalars['Int']>;
  gramsPerPlant?: Maybe<Scalars['Float']>;
  byFormFactor: Array<BudFormFactorYield>;
  packagedTotalGrams?: Maybe<Scalars['Float']>;
  reconciliationGapGrams?: Maybe<Scalars['Float']>;
  isOpen: Scalars['Boolean'];
  provenance: Scalars['String'];
  issues: Array<Scalars['String']>;
  adjustedParentTotalGrams?: Maybe<Scalars['Float']>;
};

export type IpmSection = {
  __typename?: 'IPMSection';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  entry: ChecklistEntry;
  pestsVisible?: Maybe<IpmSectionPestsVisible>;
  pestsType?: Maybe<Scalars['String']>;
  diseaseSigns?: Maybe<IpmSectionDiseaseSigns>;
  diseaseSignsOther?: Maybe<Scalars['String']>;
  stickyTraps?: Maybe<IpmSectionStickyTraps>;
  stickyTrapsNote?: Maybe<Scalars['String']>;
};

export enum IpmSectionDiseaseSigns {
  None = 'NONE',
  Mold = 'MOLD',
  Mildew = 'MILDEW',
  Other = 'OTHER'
}

export type IpmSectionInput = {
  pestsVisible?: Maybe<Scalars['String']>;
  pestsType?: Maybe<Scalars['String']>;
  diseaseSigns?: Maybe<Scalars['String']>;
  diseaseSignsOther?: Maybe<Scalars['String']>;
  stickyTraps?: Maybe<Scalars['String']>;
  stickyTrapsNote?: Maybe<Scalars['String']>;
};

export enum IpmSectionPestsVisible {
  None = 'NONE',
  Few = 'FEW',
  Many = 'MANY'
}

export enum IpmSectionStickyTraps {
  None = 'NONE',
  Few = 'FEW',
  Many = 'MANY',
  NoneInstalled = 'NONE_INSTALLED'
}

export type ImportHarvestGroupInput = {
  siteId?: Maybe<Scalars['ID']>;
  templateId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  harvestDate?: Maybe<Scalars['String']>;
  strains?: Maybe<Array<Maybe<ImportHarvestGroupStrainInput>>>;
  cloneZone?: Maybe<Scalars['String']>;
  vegZone?: Maybe<Scalars['String']>;
  flowerZone?: Maybe<Scalars['String']>;
  proposedGroupId?: Maybe<Scalars['ID']>;
};

export type ImportHarvestGroupStrainInput = {
  strainName?: Maybe<Scalars['String']>;
  strainMetrcId?: Maybe<Scalars['String']>;
  metrcHarvestId?: Maybe<Scalars['String']>;
  metrcHarvestName?: Maybe<Scalars['String']>;
  totalPackagedWeight?: Maybe<Scalars['Float']>;
};

export type ImportMetrcBudFormFactorInput = {
  name: Scalars['String'];
  classification: Scalars['String'];
  existingBffId?: Maybe<Scalars['ID']>;
};

export type ImportMetrcBudFormFactorsInput = {
  siteId: Scalars['ID'];
  saveBudFormFactors: Array<Maybe<ImportMetrcBudFormFactorInput>>;
  removeBffIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  migrateYields?: Maybe<Array<Maybe<MigrateYieldsInput>>>;
};

export type ImportMetrcCompletedHarvestGroupsInput = {
  siteId?: Maybe<Scalars['ID']>;
  templateId?: Maybe<Scalars['ID']>;
  saveHarvestGroups?: Maybe<Array<Maybe<ImportHarvestGroupInput>>>;
};

export type ImportMetrcCurrentFloweringGroupInput = {
  locationName: Scalars['String'];
  plantedDate?: Maybe<Scalars['String']>;
  floweringDate?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['ID']>;
  proposedGroupId?: Maybe<Scalars['ID']>;
};

export type ImportMetrcCurrentHarvestGroupsInput = {
  siteId: Scalars['ID'];
  templateId?: Maybe<Scalars['ID']>;
  saveFloweringGroups?: Maybe<Array<Maybe<ImportMetrcCurrentFloweringGroupInput>>>;
};

export type ImportMetrcLocationInput = {
  siteId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  metrcId?: Maybe<Scalars['String']>;
  existingId?: Maybe<Scalars['String']>;
  roomUsage?: Maybe<Scalars['String']>;
};

export type ImportMetrcLocationsInput = {
  siteId: Scalars['ID'];
  saveLocations: Array<Maybe<ImportMetrcLocationInput>>;
};

export type ImportMetrcStrainInput = {
  name?: Maybe<Scalars['String']>;
  subspecies?: Maybe<Scalars['String']>;
  metrcId?: Maybe<Scalars['String']>;
};

export type ImportMetrcStrainsInput = {
  siteId: Scalars['ID'];
  saveStrains: Array<Maybe<ImportMetrcStrainInput>>;
};

export type ImportMetrcTemplateInput = {
  organizationId: Scalars['ID'];
  includeCloneStage?: Maybe<Scalars['Boolean']>;
  includeVegStage?: Maybe<Scalars['Boolean']>;
  designatedCloneZones?: Maybe<Array<Maybe<Scalars['String']>>>;
  designatedVegZones?: Maybe<Array<Maybe<Scalars['String']>>>;
  designatedFlowerZones?: Maybe<Array<Maybe<Scalars['String']>>>;
  cloneDesiredDays?: Maybe<Scalars['Int']>;
  vegDesiredDays?: Maybe<Scalars['Int']>;
  flowerDesiredDays?: Maybe<Scalars['Int']>;
};

export type ImportMetrcZoneRotationInput = {
  siteId: Scalars['ID'];
  templateId?: Maybe<Scalars['ID']>;
  rotationOrder: Array<Maybe<Scalars['String']>>;
  rotationGroups?: Maybe<Array<Array<Scalars['String']>>>;
  intervalDays?: Maybe<Scalars['Int']>;
  fillAllRooms?: Maybe<Scalars['Boolean']>;
  planningHorizonMonths?: Maybe<Scalars['Int']>;
};

export type IntegrityCategoryCount = {
  __typename?: 'IntegrityCategoryCount';
  category: Scalars['String'];
  count: Scalars['Int'];
};

export type IntegrityEvent = {
  __typename?: 'IntegrityEvent';
  id: Scalars['ID'];
  category: Scalars['String'];
  severity: Scalars['String'];
  message: Scalars['String'];
  details?: Maybe<Scalars['GenericScalar']>;
  dedupKey?: Maybe<Scalars['String']>;
  resolutionState: Scalars['String'];
  resolutionAction?: Maybe<Scalars['String']>;
  resolutionPayload?: Maybe<Scalars['GenericScalar']>;
  firstSeenAt?: Maybe<Scalars['DateTime']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  resolvedByName?: Maybe<Scalars['String']>;
  siteId: Scalars['ID'];
  siteName: Scalars['String'];
  organizationId: Scalars['ID'];
  organizationName: Scalars['String'];
  metrcHarvestId?: Maybe<Scalars['String']>;
  metrcHarvestName?: Maybe<Scalars['String']>;
  metrcPackageId?: Maybe<Scalars['String']>;
  metrcPackageLabel?: Maybe<Scalars['String']>;
  metrcPackageDisplayName?: Maybe<Scalars['String']>;
  metrcPackageCategoryName?: Maybe<Scalars['String']>;
  metrcPackageKind?: Maybe<Scalars['String']>;
  harvestGroupId?: Maybe<Scalars['String']>;
  harvestGroupName?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  dashboardGroup: Scalars['String'];
  isActionable: Scalars['Boolean'];
  availableActions: Array<IntegrityEventAction>;
  resolutionOptions: IntegrityResolutionOptions;
};

export type IntegrityEventAction = {
  __typename?: 'IntegrityEventAction';
  action: Scalars['String'];
  label: Scalars['String'];
};

export type IntegrityEventFilterSetInput = {
  siteId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  resolutionState?: Maybe<Scalars['String']>;
  dashboardGroup?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};

export type IntegrityEventFilterSetOutput = {
  __typename?: 'IntegrityEventFilterSetOutput';
  siteId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  resolutionState?: Maybe<Scalars['String']>;
  dashboardGroup?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};

export type IntegrityEventListResult = {
  __typename?: 'IntegrityEventListResult';
  nodes: Array<IntegrityEvent>;
  totalCount: Scalars['Int'];
  pageInfo: IntegrityEventPageInfo;
};

export type IntegrityEventPageInfo = {
  __typename?: 'IntegrityEventPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
};

export type IntegrityEventQuerysetOptionsInput = {
  paging?: Maybe<PagingInput>;
  filters?: Maybe<IntegrityEventFilterSetInput>;
};

export type IntegrityEventQuerysetOptionsOutput = {
  __typename?: 'IntegrityEventQuerysetOptionsOutput';
  paging: PagingInfo;
  filters: IntegrityEventFilterSetOutput;
};

export type IntegrityEventQuerysetResult = {
  __typename?: 'IntegrityEventQuerysetResult';
  options: IntegrityEventQuerysetOptionsOutput;
  items: Array<Maybe<IntegrityEvent>>;
};

export type IntegrityEventSummary = {
  __typename?: 'IntegrityEventSummary';
  openErrors: Scalars['Int'];
  openWarnings: Scalars['Int'];
  openTotal: Scalars['Int'];
  actionableOpen: Scalars['Int'];
  warningOpen: Scalars['Int'];
  dismissedLast7Days: Scalars['Int'];
  resolvedLast7Days: Scalars['Int'];
};

export type IntegrityQueuedTask = {
  __typename?: 'IntegrityQueuedTask';
  type: Scalars['String'];
  label?: Maybe<Scalars['String']>;
};

export type IntegrityResolutionOption = {
  __typename?: 'IntegrityResolutionOption';
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type IntegrityResolutionOptions = {
  __typename?: 'IntegrityResolutionOptions';
  budFormFactors: Array<IntegrityResolutionOption>;
  zones: Array<IntegrityResolutionOption>;
  harvestGroups: Array<IntegrityResolutionOption>;
};

export type IntegritySideEffect = {
  __typename?: 'IntegritySideEffect';
  type: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
};

export type IntegritySiteCount = {
  __typename?: 'IntegritySiteCount';
  siteId: Scalars['ID'];
  siteName: Scalars['String'];
  organizationName: Scalars['String'];
  count: Scalars['Int'];
};

export type IntegrityWarningSummary = {
  __typename?: 'IntegrityWarningSummary';
  siteId: Scalars['ID'];
  siteName: Scalars['String'];
  organizationName: Scalars['String'];
  category: Scalars['String'];
  severity: Scalars['String'];
  count: Scalars['Int'];
  lastSeenAt?: Maybe<Scalars['DateTime']>;
};

export type IrrigationFrequency = {
  __typename?: 'IrrigationFrequency';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  zones: Array<Zone>;
};

export type IrrigationStyle = {
  __typename?: 'IrrigationStyle';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  zones: Array<Zone>;
};

export type IrrigationType = {
  __typename?: 'IrrigationType';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  zones: Array<Zone>;
};


export type JobLogOutputGramsInput = {
  formFactorId: Scalars['ID'];
  grams: Scalars['Decimal'];
};

export type LightingSection = {
  __typename?: 'LightingSection';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  entry: ChecklistEntry;
  lightsWorking?: Maybe<LightingSectionLightsWorking>;
  lightsWorkingNote?: Maybe<Scalars['String']>;
};

export type LightingSectionInput = {
  lightsWorking?: Maybe<Scalars['String']>;
  lightsWorkingNote?: Maybe<Scalars['String']>;
};

export enum LightingSectionLightsWorking {
  AllOn = 'ALL_ON',
  SomeOut = 'SOME_OUT',
  AllOff = 'ALL_OFF'
}

export type LightingTypeBrand = {
  __typename?: 'LightingTypeBrand';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  lightingTypeSelections: Array<LightingTypeSelection>;
};

export type LightingTypeSelection = {
  __typename?: 'LightingTypeSelection';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  zone: Zone;
  lightingType?: Maybe<LightingTypeSelectionLightingType>;
  lightingTypeOther?: Maybe<Scalars['String']>;
  brand?: Maybe<LightingTypeBrand>;
  brandNameOther?: Maybe<Scalars['String']>;
  lightCount?: Maybe<Scalars['Int']>;
  wattsPerLight?: Maybe<Scalars['Int']>;
};

export type LightingTypeSelectionInput = {
  id?: Maybe<Scalars['ID']>;
  brand?: Maybe<CustomInput>;
  brandNameOther?: Maybe<Scalars['String']>;
  lightingType?: Maybe<Scalars['String']>;
  lightingTypeOther?: Maybe<Scalars['String']>;
  lightCount?: Maybe<Scalars['Int']>;
  wattsPerLight?: Maybe<Scalars['Int']>;
};

export enum LightingTypeSelectionLightingType {
  Default = 'DEFAULT',
  DoubleEndedHps = 'DOUBLE_ENDED_HPS',
  Cmh = 'CMH',
  Led = 'LED',
  Other = 'OTHER'
}

export type Location = {
  __typename?: 'Location';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  archivedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  site?: Maybe<OrganizationSite>;
  zone?: Maybe<Zone>;
  equipment: Array<Equipment>;
  maintenancerequestSet: Array<MaintenanceRequest>;
};

export type LocationFilterSetInput = {
  id?: Maybe<Scalars['String']>;
};

export type LogEntry = {
  __typename?: 'LogEntry';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  originalId?: Maybe<Scalars['String']>;
  isCurrentRow: Scalars['Boolean'];
  date: Scalars['DateTime'];
  zone?: Maybe<Zone>;
  performedBy?: Maybe<UserProfile>;
  createdBy: UserProfile;
  logType: LogEntryLogType;
  logEntryData?: Maybe<Scalars['GenericScalar']>;
  isDraft: Scalars['Boolean'];
  readyForApproval: Scalars['Boolean'];
  approvedBy?: Maybe<UserProfile>;
  approvedAt?: Maybe<Scalars['DateTime']>;
  paperlyticsImage?: Maybe<PaperlyticsImage>;
  paperlyticsAccuracyScore?: Maybe<Scalars['Int']>;
  paperlyticsIssuesList?: Maybe<Scalars['JSONString']>;
  paperlyticsBoundaries?: Maybe<Scalars['JSONString']>;
  stage?: Maybe<Stage>;
};

export type LogEntryInput = {
  id?: Maybe<Scalars['ID']>;
  date: Scalars['Date'];
  harvestGroupId: Scalars['ID'];
  dataFields?: Maybe<Scalars['GenericScalar']>;
  isDraft?: Maybe<Scalars['Boolean']>;
  performedBy?: Maybe<Scalars['ID']>;
  needsAttention?: Maybe<Scalars['Boolean']>;
};

export enum LogEntryLogType {
  Observation = 'OBSERVATION',
  Issue = 'ISSUE',
  Irrigation = 'IRRIGATION',
  Foliar = 'FOLIAR',
  Pruning = 'PRUNING',
  Defoliate = 'DEFOLIATE',
  Topping = 'TOPPING',
  Greenwaste = 'GREENWASTE',
  Runoff = 'RUNOFF'
}

export type LogEntryResult = LogEntry | Error;

export type LogoutResult = LogoutSuccess | Error;

export type LogoutSuccess = {
  __typename?: 'LogoutSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type LogsFilterInput = {
  logEntryDate?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  includeDraftLogs?: Maybe<Scalars['Boolean']>;
};

export type MaintenanceRequest = {
  __typename?: 'MaintenanceRequest';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  firstObservedAt: Scalars['DateTime'];
  dueDate: Scalars['DateTime'];
  urgent: Scalars['Boolean'];
  equipmentInoperable: Scalars['Boolean'];
  lockOutTagOut: Scalars['Boolean'];
  requestedBy: UserProfile;
  description: Scalars['String'];
  location: Location;
  imageUrl?: Maybe<Scalars['String']>;
  resolution?: Maybe<MaintenanceRequestResolution>;
  tags?: Maybe<Array<Maybe<MaintenanceRequestTag>>>;
};

export type MaintenanceRequestFilterSetInput = {
  id?: Maybe<Scalars['String']>;
};

export type MaintenanceRequestResolution = {
  __typename?: 'MaintenanceRequestResolution';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  maintenanceRequest: MaintenanceRequest;
  resolvedAt: Scalars['DateTime'];
  notes?: Maybe<Scalars['String']>;
  resolvedBy: UserProfile;
};

export type MaintenanceRequestResult = MaintenanceRequest | Error;

export type MaintenanceRequestTag = {
  __typename?: 'MaintenanceRequestTag';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  maintenanceRequest: MaintenanceRequest;
  tag: Tag;
  name?: Maybe<Scalars['String']>;
};

export type MaintenanceSection = {
  __typename?: 'MaintenanceSection';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  entry: ChecklistEntry;
  hvacRunning?: Maybe<MaintenanceSectionHvacRunning>;
  hvacRunningNote?: Maybe<Scalars['String']>;
  irrigationSystem?: Maybe<MaintenanceSectionIrrigationSystem>;
  irrigationSystemNote?: Maybe<Scalars['String']>;
  filterCheck?: Maybe<MaintenanceSectionFilterCheck>;
  filterCheckNote?: Maybe<Scalars['String']>;
  tableDrains?: Maybe<MaintenanceSectionTableDrains>;
  tableDrainsNote?: Maybe<Scalars['String']>;
  pumpsOperating?: Maybe<MaintenanceSectionPumpsOperating>;
  pumpsOperatingNote?: Maybe<Scalars['String']>;
  dehumidifiers?: Maybe<MaintenanceSectionDehumidifiers>;
  dehumidifiersNote?: Maybe<Scalars['String']>;
  unusualNoises?: Maybe<MaintenanceSectionUnusualNoises>;
  unusualNoisesSource?: Maybe<Scalars['String']>;
};

export enum MaintenanceSectionDehumidifiers {
  Working = 'WORKING',
  Issues = 'ISSUES'
}

export enum MaintenanceSectionFilterCheck {
  Clean = 'CLEAN',
  Dirty = 'DIRTY'
}

export enum MaintenanceSectionHvacRunning {
  Yes = 'YES',
  No = 'NO'
}

export type MaintenanceSectionInput = {
  hvacRunning?: Maybe<Scalars['String']>;
  hvacRunningNote?: Maybe<Scalars['String']>;
  irrigationSystem?: Maybe<Scalars['String']>;
  irrigationSystemNote?: Maybe<Scalars['String']>;
  filterCheck?: Maybe<Scalars['String']>;
  filterCheckNote?: Maybe<Scalars['String']>;
  tableDrains?: Maybe<Scalars['String']>;
  tableDrainsNote?: Maybe<Scalars['String']>;
  pumpsOperating?: Maybe<Scalars['String']>;
  pumpsOperatingNote?: Maybe<Scalars['String']>;
  dehumidifiers?: Maybe<Scalars['String']>;
  dehumidifiersNote?: Maybe<Scalars['String']>;
  unusualNoises?: Maybe<Scalars['String']>;
  unusualNoisesSource?: Maybe<Scalars['String']>;
};

export enum MaintenanceSectionIrrigationSystem {
  Working = 'WORKING',
  Issues = 'ISSUES'
}

export enum MaintenanceSectionPumpsOperating {
  Yes = 'YES',
  No = 'NO'
}

export enum MaintenanceSectionTableDrains {
  Clean = 'CLEAN',
  Clogged = 'CLOGGED'
}

export enum MaintenanceSectionUnusualNoises {
  Yes = 'YES',
  No = 'NO'
}

export type MapFieldAgentDeviceInput = {
  fieldAgentDeviceId: Scalars['ID'];
  sensorDeviceId: Scalars['ID'];
};

export type MarkTourCompletedInput = {
  taskName: Scalars['String'];
};

export type MetrcAnalyticsTotals = {
  __typename?: 'MetrcAnalyticsTotals';
  groups?: Maybe<Scalars['Int']>;
  totalGrams?: Maybe<Scalars['Float']>;
  flowerGrams?: Maybe<Scalars['Float']>;
  trimGrams?: Maybe<Scalars['Float']>;
  totalPlants?: Maybe<Scalars['Int']>;
  gramsPerPlant?: Maybe<Scalars['Float']>;
};

export type MetrcApiKeyFacility = {
  __typename?: 'MetrcApiKeyFacility';
  licenseNumber: Scalars['String'];
  siteName?: Maybe<Scalars['String']>;
  isConfigured: Scalars['Boolean'];
  willCatchUp: Scalars['Boolean'];
};

export type MetrcBffYield = {
  __typename?: 'MetrcBffYield';
  name?: Maybe<Scalars['String']>;
  weightG?: Maybe<Scalars['Float']>;
  packageCount?: Maybe<Scalars['Int']>;
  classification?: Maybe<Scalars['String']>;
};

export type MetrcBudFormFactor = {
  __typename?: 'MetrcBudFormFactor';
  name?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  packageCount?: Maybe<Scalars['Int']>;
  existingBff?: Maybe<Scalars['ID']>;
  existingBffOrder?: Maybe<Scalars['Int']>;
  sampleItemNames?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MetrcCurrentFloweringGroupStrain = {
  __typename?: 'MetrcCurrentFloweringGroupStrain';
  strainName?: Maybe<Scalars['String']>;
  plantCount?: Maybe<Scalars['Int']>;
  strainMetrcId?: Maybe<Scalars['String']>;
  existingStrainId?: Maybe<Scalars['ID']>;
  plantedDates?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MetrcDataOverviewOutput = {
  __typename?: 'MetrcDataOverviewOutput';
  ready?: Maybe<Scalars['Boolean']>;
  totalHarvests?: Maybe<Scalars['Int']>;
  totalPackages?: Maybe<Scalars['Int']>;
  totalStrains?: Maybe<Scalars['Int']>;
  totalLocations?: Maybe<Scalars['Int']>;
  totalFloweringPlants?: Maybe<Scalars['Int']>;
  dateRangeStart?: Maybe<Scalars['String']>;
  dateRangeEnd?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<Maybe<MetrcOverviewLocation>>>;
  strainNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  strains?: Maybe<Array<Maybe<MetrcOverviewStrain>>>;
  newStrainCount?: Maybe<Scalars['Int']>;
  existingStrainCount?: Maybe<Scalars['Int']>;
  harvestGroups?: Maybe<Array<Maybe<MetrcOverviewHarvestGroup>>>;
  hgsWithRoomCount?: Maybe<Scalars['Int']>;
  hgsWithoutRoomCount?: Maybe<Scalars['Int']>;
  formFactors?: Maybe<Array<Maybe<MetrcOverviewFormFactor>>>;
  ffFailedCount?: Maybe<Scalars['Int']>;
  ffFailedSamples?: Maybe<Array<Maybe<Scalars['String']>>>;
  adjustments?: Maybe<Array<Maybe<MetrcOverviewAdjustment>>>;
  totalAdjustmentCount?: Maybe<Scalars['Int']>;
  rotation?: Maybe<MetrcOverviewRotation>;
  floweringGroups?: Maybe<Array<Maybe<MetrcOverviewFloweringGroup>>>;
  alerts?: Maybe<Array<Maybe<MetrcOverviewAlert>>>;
};

export type MetrcFlowerRoom = {
  __typename?: 'MetrcFlowerRoom';
  dateSource?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  floweringDate?: Maybe<Scalars['String']>;
};

export type MetrcGroupStat = {
  __typename?: 'MetrcGroupStat';
  harvestGroupId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  harvestDate?: Maybe<Scalars['Date']>;
  totalGrams?: Maybe<Scalars['Float']>;
  flowerGrams?: Maybe<Scalars['Float']>;
  trimGrams?: Maybe<Scalars['Float']>;
  totalPlants?: Maybe<Scalars['Int']>;
  gramsPerPlant?: Maybe<Scalars['Float']>;
};

export type MetrcHarvestGroupStrain = {
  __typename?: 'MetrcHarvestGroupStrain';
  strainName?: Maybe<Scalars['String']>;
  strainMetrcId?: Maybe<Scalars['String']>;
  metrcHarvestId?: Maybe<Scalars['String']>;
  metrcHarvestName?: Maybe<Scalars['String']>;
  totalWetWeight?: Maybe<Scalars['Float']>;
  finishedDate?: Maybe<Scalars['String']>;
  totalPackagedWeight?: Maybe<Scalars['Float']>;
  plantCount?: Maybe<Scalars['Int']>;
  createdHgId?: Maybe<Scalars['String']>;
  createdStrainId?: Maybe<Scalars['String']>;
  bffYields?: Maybe<Array<Maybe<MetrcBffYield>>>;
};

export type MetrcImportAnalyticsResult = {
  __typename?: 'MetrcImportAnalyticsResult';
  totals?: Maybe<MetrcAnalyticsTotals>;
  topStrains?: Maybe<Array<Maybe<MetrcStrainStat>>>;
  bottomStrains?: Maybe<Array<Maybe<MetrcStrainStat>>>;
  topStrainsPerPlant?: Maybe<Array<Maybe<MetrcStrainStat>>>;
  bottomStrainsPerPlant?: Maybe<Array<Maybe<MetrcStrainStat>>>;
  topHarvestGroups?: Maybe<Array<Maybe<MetrcGroupStat>>>;
  topHarvestGroupsPerPlant?: Maybe<Array<Maybe<MetrcGroupStat>>>;
  bottomHarvestGroups?: Maybe<Array<Maybe<MetrcGroupStat>>>;
  bottomHarvestGroupsPerPlant?: Maybe<Array<Maybe<MetrcGroupStat>>>;
};

export type MetrcImportOverviewV2 = {
  __typename?: 'MetrcImportOverviewV2';
  siteId: Scalars['ID'];
  ready: Scalars['Boolean'];
  lastAnalyzedAt?: Maybe<Scalars['DateTime']>;
  harvestsAnalyzedCount: Scalars['Int'];
  totalHarvests?: Maybe<Scalars['Int']>;
  totalPackages?: Maybe<Scalars['Int']>;
  totalStrains?: Maybe<Scalars['Int']>;
  totalLocations?: Maybe<Scalars['Int']>;
  totalFloweringPlants?: Maybe<Scalars['Int']>;
  dateRangeStart?: Maybe<Scalars['String']>;
  dateRangeEnd?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<Maybe<MetrcOverviewLocation>>>;
  strainNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  strains?: Maybe<Array<Maybe<MetrcOverviewStrain>>>;
  newStrainCount?: Maybe<Scalars['Int']>;
  existingStrainCount?: Maybe<Scalars['Int']>;
  harvestGroups?: Maybe<Array<Maybe<MetrcOverviewHarvestGroup>>>;
  hgsWithRoomCount?: Maybe<Scalars['Int']>;
  hgsWithoutRoomCount?: Maybe<Scalars['Int']>;
  formFactors?: Maybe<Array<Maybe<MetrcOverviewFormFactor>>>;
  ffFailedCount?: Maybe<Scalars['Int']>;
  ffFailedSamples?: Maybe<Array<Maybe<Scalars['String']>>>;
  adjustments?: Maybe<Array<Maybe<MetrcOverviewAdjustment>>>;
  totalAdjustmentCount?: Maybe<Scalars['Int']>;
  rotation?: Maybe<MetrcOverviewRotation>;
  floweringGroups?: Maybe<Array<Maybe<MetrcOverviewFloweringGroup>>>;
  alerts?: Maybe<Array<Maybe<MetrcOverviewAlert>>>;
  integritySignals: Array<MetrcIntegritySignal>;
  parsingRulesetStatus: MetrcOverviewParsingRulesetStatus;
};

export type MetrcImportTask = {
  __typename?: 'MetrcImportTask';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  asyncMetrcStatus?: Maybe<MetrcImportTaskAsyncMetrcStatus>;
  asyncMetrcStartedAt?: Maybe<Scalars['DateTime']>;
  asyncMetrcCompletedAt?: Maybe<Scalars['DateTime']>;
  asyncMetrcTaskId?: Maybe<Scalars['String']>;
  asyncMetrcError?: Maybe<Scalars['String']>;
  asyncMetrcTraceback?: Maybe<Scalars['String']>;
  asyncMetrcProgressPct: Scalars['Int'];
  asyncDailyMetrcStatus?: Maybe<MetrcImportTaskAsyncDailyMetrcStatus>;
  asyncDailyMetrcStartedAt?: Maybe<Scalars['DateTime']>;
  asyncDailyMetrcCompletedAt?: Maybe<Scalars['DateTime']>;
  asyncDailyMetrcTaskId?: Maybe<Scalars['String']>;
  asyncDailyMetrcError?: Maybe<Scalars['String']>;
  asyncDailyMetrcTraceback?: Maybe<Scalars['String']>;
  asyncDailyMetrcProgressPct: Scalars['Int'];
  site: OrganizationSite;
  isRefresh: Scalars['Boolean'];
  resultSummary: Scalars['JSONString'];
  completedSteps: Scalars['JSONString'];
  siteBatches: Array<MetrcSiteImportBatch>;
  metrcProgressPct?: Maybe<Scalars['Int']>;
  metrcEtaSecondsRemaining?: Maybe<Scalars['Int']>;
  metrcEtaDatetime?: Maybe<Scalars['DateTime']>;
};

export enum MetrcImportTaskAsyncDailyMetrcStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export enum MetrcImportTaskAsyncMetrcStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type MetrcIntegritySignal = {
  __typename?: 'MetrcIntegritySignal';
  id: Scalars['ID'];
  category: Scalars['String'];
  severity: Scalars['String'];
  message: Scalars['String'];
  details?: Maybe<Scalars['GenericScalar']>;
  dedupKey?: Maybe<Scalars['String']>;
  resolutionState: Scalars['String'];
  firstSeenAt?: Maybe<Scalars['DateTime']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  metrcHarvestId?: Maybe<Scalars['String']>;
  metrcPackageId?: Maybe<Scalars['String']>;
};

export type MetrcLicenseImportTask = {
  __typename?: 'MetrcLicenseImportTask';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  batch: MetrcSiteImportBatch;
  orgMetrcLicense: OrganizationMetrcLicense;
  siteMetrcLicense?: Maybe<OrganizationSiteMetrcLicense>;
  status: MetrcLicenseImportTaskStatus;
  progressPct: Scalars['Int'];
  resultSummary: Scalars['JSONString'];
  error: Scalars['String'];
  startedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  licenseNumber?: Maybe<Scalars['String']>;
};

export enum MetrcLicenseImportTaskStatus {
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type MetrcLocation = {
  __typename?: 'MetrcLocation';
  name?: Maybe<Scalars['String']>;
  metrcId?: Maybe<Scalars['String']>;
  existingLocation?: Maybe<Zone>;
  hasFloweringPlants?: Maybe<Scalars['Boolean']>;
  isImported?: Maybe<Scalars['Boolean']>;
};

export type MetrcOverviewAdjustment = {
  __typename?: 'MetrcOverviewAdjustment';
  reason?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  totalQuantity?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  totalWeightG?: Maybe<Scalars['Float']>;
  earliestDate?: Maybe<Scalars['String']>;
  latestDate?: Maybe<Scalars['String']>;
};

export type MetrcOverviewAlert = {
  __typename?: 'MetrcOverviewAlert';
  severity?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  samples?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MetrcOverviewFloweringGroup = {
  __typename?: 'MetrcOverviewFloweringGroup';
  proposedGroupId?: Maybe<Scalars['String']>;
  createdHgId?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  plantCount?: Maybe<Scalars['Int']>;
  totalPlants?: Maybe<Scalars['Int']>;
  strainNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  floweringDate?: Maybe<Scalars['String']>;
  plantedDate?: Maybe<Scalars['String']>;
  projectedHarvestDate?: Maybe<Scalars['String']>;
  cloneStageDays?: Maybe<Scalars['Int']>;
  vegStageDays?: Maybe<Scalars['Int']>;
  flowerStageDays?: Maybe<Scalars['Int']>;
  cloneVegDays?: Maybe<Scalars['Int']>;
  allPlantedDates?: Maybe<Array<Maybe<MetrcOverviewPlantedDate>>>;
  strains?: Maybe<Array<Maybe<MetrcCurrentFloweringGroupStrain>>>;
};

export type MetrcOverviewFormFactor = {
  __typename?: 'MetrcOverviewFormFactor';
  name?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  totalWeightG?: Maybe<Scalars['Float']>;
  packageCount?: Maybe<Scalars['Int']>;
  sampleItemNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  earliestDate?: Maybe<Scalars['String']>;
  latestDate?: Maybe<Scalars['String']>;
};

export type MetrcOverviewHarvestGroup = {
  __typename?: 'MetrcOverviewHarvestGroup';
  productStreams?: Maybe<Array<MetrcOverviewProductStream>>;
  proposedGroupId?: Maybe<Scalars['String']>;
  createdHgId?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  harvestDate?: Maybe<Scalars['String']>;
  assignedFlowerRoom?: Maybe<Scalars['String']>;
  strainNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  totalWetWeightG?: Maybe<Scalars['Float']>;
  totalPackagedWeightG?: Maybe<Scalars['Float']>;
  pkgWetPct?: Maybe<Scalars['Float']>;
  yieldCoveragePct?: Maybe<Scalars['Float']>;
  isInferredComplete?: Maybe<Scalars['Boolean']>;
  harvestNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  harvestNameRoomMap?: Maybe<Array<Maybe<Scalars['String']>>>;
  yieldBreakdown?: Maybe<MetrcOverviewYieldBreakdown>;
  strainCount?: Maybe<Scalars['Int']>;
  strainWithYieldCount?: Maybe<Scalars['Int']>;
  strains?: Maybe<Array<Maybe<MetrcHarvestGroupStrain>>>;
};

export type MetrcOverviewHarvestSequenceEntry = {
  __typename?: 'MetrcOverviewHarvestSequenceEntry';
  date?: Maybe<Scalars['String']>;
  room?: Maybe<Scalars['String']>;
  intervalDays?: Maybe<Scalars['Int']>;
  cycle?: Maybe<Scalars['Int']>;
};

export type MetrcOverviewLastAuthoringSession = {
  __typename?: 'MetrcOverviewLastAuthoringSession';
  status: Scalars['String'];
  endedAt?: Maybe<Scalars['String']>;
  iterations: Scalars['Int'];
  aiCostUsd: Scalars['Float'];
};

export type MetrcOverviewLocation = {
  __typename?: 'MetrcOverviewLocation';
  name?: Maybe<Scalars['String']>;
  metrcId?: Maybe<Scalars['String']>;
  zoneId?: Maybe<Scalars['String']>;
  metrcSourceCount?: Maybe<Scalars['Int']>;
  hasFloweringPlants?: Maybe<Scalars['Boolean']>;
  guessedUsage?: Maybe<Scalars['String']>;
};

export type MetrcOverviewParsingRule = {
  __typename?: 'MetrcOverviewParsingRule';
  template: Scalars['String'];
  kind: Scalars['String'];
  priority: Scalars['Int'];
  slotSummary: Scalars['String'];
};

export type MetrcOverviewParsingRulesetDomainStatus = {
  __typename?: 'MetrcOverviewParsingRulesetDomainStatus';
  status: Scalars['String'];
  rulesCount: Scalars['Int'];
  inputFieldChain: Array<Scalars['String']>;
  rules: Array<MetrcOverviewParsingRule>;
  lastAuthoringSession?: Maybe<MetrcOverviewLastAuthoringSession>;
};

export type MetrcOverviewParsingRulesetStatus = {
  __typename?: 'MetrcOverviewParsingRulesetStatus';
  harvestNames: MetrcOverviewParsingRulesetDomainStatus;
  packageItems: MetrcOverviewParsingRulesetDomainStatus;
};

export type MetrcOverviewPlantedDate = {
  __typename?: 'MetrcOverviewPlantedDate';
  date?: Maybe<Scalars['String']>;
  plantCount?: Maybe<Scalars['Int']>;
  isDominant?: Maybe<Scalars['Boolean']>;
  isOutlier?: Maybe<Scalars['Boolean']>;
};

export type MetrcOverviewProductStream = {
  __typename?: 'MetrcOverviewProductStream';
  dryToWetBasis?: Maybe<Scalars['String']>;
  coverageNote?: Maybe<Scalars['String']>;
  harvestPackagedWeightG?: Maybe<Scalars['Float']>;
  dryWeightG: Scalars['Float'];
  wetPackagedWeightG: Scalars['Float'];
  harvestWetWeightG: Scalars['Float'];
  dryToWetPct?: Maybe<Scalars['Float']>;
  stream: Scalars['String'];
  batchCount: Scalars['Int'];
  finishedBatchCount: Scalars['Int'];
  plantCount: Scalars['Int'];
  outputWeightG?: Maybe<Scalars['Float']>;
  reportedPackagedWeightG?: Maybe<Scalars['Float']>;
  packageCoveragePct?: Maybe<Scalars['Float']>;
};

export type MetrcOverviewRotation = {
  __typename?: 'MetrcOverviewRotation';
  rotationOrder?: Maybe<Array<Maybe<Scalars['String']>>>;
  intervalDays?: Maybe<Scalars['Int']>;
  flowerRooms?: Maybe<Array<Maybe<MetrcFlowerRoom>>>;
  source?: Maybe<Scalars['String']>;
  harvestSequence?: Maybe<Array<Maybe<MetrcOverviewHarvestSequenceEntry>>>;
};

export type MetrcOverviewStrain = {
  __typename?: 'MetrcOverviewStrain';
  name?: Maybe<Scalars['String']>;
  pdsStrainId?: Maybe<Scalars['String']>;
  metrcSourceCount?: Maybe<Scalars['Int']>;
  imported?: Maybe<Scalars['Boolean']>;
};

export type MetrcOverviewYieldBreakdown = {
  __typename?: 'MetrcOverviewYieldBreakdown';
  foundByFf: Array<MetrcOverviewYieldFoundFf>;
  missingByReason: Array<MetrcOverviewYieldMissingReason>;
  unaccountedG?: Maybe<Scalars['Float']>;
  totalPackagedG?: Maybe<Scalars['Float']>;
  totalFoundG?: Maybe<Scalars['Float']>;
  wetParentPackagesSuppressed: Scalars['Boolean'];
  wetParentSuppressedPackageNames: Array<Scalars['String']>;
  wetParentSuppressedWeightG?: Maybe<Scalars['Float']>;
};

export type MetrcOverviewYieldFoundFf = {
  __typename?: 'MetrcOverviewYieldFoundFf';
  ffName: Scalars['String'];
  classification?: Maybe<Scalars['String']>;
  weightG: Scalars['Float'];
  packageCount: Scalars['Int'];
  strainBreakdown: Array<MetrcOverviewYieldFoundFfStrain>;
};

export type MetrcOverviewYieldFoundFfStrain = {
  __typename?: 'MetrcOverviewYieldFoundFfStrain';
  strainName: Scalars['String'];
  pdsStrainId?: Maybe<Scalars['String']>;
  weightG: Scalars['Float'];
  packageCount: Scalars['Int'];
};

export type MetrcOverviewYieldMissingReason = {
  __typename?: 'MetrcOverviewYieldMissingReason';
  category: Scalars['String'];
  label: Scalars['String'];
  description: Scalars['String'];
  weightG?: Maybe<Scalars['Float']>;
  packageCount: Scalars['Int'];
  samplePackageNames: Array<Scalars['String']>;
};

export type MetrcOverviewYieldPackageBreakdown = {
  __typename?: 'MetrcOverviewYieldPackageBreakdown';
  packages: Array<MetrcOverviewYieldPackageEntry>;
};

export type MetrcOverviewYieldPackageEntry = {
  __typename?: 'MetrcOverviewYieldPackageEntry';
  packageLabel: Scalars['String'];
  metrcPackageId?: Maybe<Scalars['String']>;
  weightG?: Maybe<Scalars['Float']>;
  ffName?: Maybe<Scalars['String']>;
  sourceHarvestNames: Array<Scalars['String']>;
  packageSiteName?: Maybe<Scalars['String']>;
  packageLicenseNumber?: Maybe<Scalars['String']>;
  packageLicenseRole?: Maybe<Scalars['String']>;
  packageRole?: Maybe<Scalars['String']>;
  packageReason?: Maybe<Scalars['String']>;
  weightBasis?: Maybe<Scalars['String']>;
  createdWeightG?: Maybe<Scalars['Float']>;
  shippedWeightG?: Maybe<Scalars['Float']>;
  adjustmentWeightG?: Maybe<Scalars['Float']>;
  adjustmentNote?: Maybe<Scalars['String']>;
  sourcePackageLabels: Array<Scalars['String']>;
};

export type MetrcRotationAnalysis = {
  __typename?: 'MetrcRotationAnalysis';
  source?: Maybe<Scalars['String']>;
  rotationOrder?: Maybe<Array<Maybe<Scalars['String']>>>;
  intervalDays?: Maybe<Scalars['Int']>;
  flowerRooms?: Maybe<Array<Maybe<MetrcFlowerRoom>>>;
};

export type MetrcSiteImportBatch = {
  __typename?: 'MetrcSiteImportBatch';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  site: OrganizationSite;
  importTask: MetrcImportTask;
  status: MetrcSiteImportBatchStatus;
  startedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  licenseTasks?: Maybe<Array<Maybe<MetrcLicenseImportTask>>>;
};

export enum MetrcSiteImportBatchStatus {
  Pending = 'PENDING',
  Running = 'RUNNING',
  Completed = 'COMPLETED',
  PartialFailure = 'PARTIAL_FAILURE',
  Failed = 'FAILED'
}

export type MetrcStrain = {
  __typename?: 'MetrcStrain';
  name?: Maybe<Scalars['String']>;
  sativaPercentage?: Maybe<Scalars['Float']>;
  indicaPercentage?: Maybe<Scalars['Float']>;
  metrcId?: Maybe<Scalars['String']>;
  existingStrain?: Maybe<Strain>;
};

export type MetrcStrainStat = {
  __typename?: 'MetrcStrainStat';
  strainId?: Maybe<Scalars['String']>;
  strainName?: Maybe<Scalars['String']>;
  totalGrams?: Maybe<Scalars['Float']>;
  flowerGrams?: Maybe<Scalars['Float']>;
  trimGrams?: Maybe<Scalars['Float']>;
  totalPlants?: Maybe<Scalars['Int']>;
  gramsPerPlant?: Maybe<Scalars['Float']>;
};

export type MigrateYieldsInput = {
  fromBffId: Scalars['ID'];
  toMetrcName: Scalars['String'];
};

export type MoveUpProcessingGroupStrainInput = {
  id: Scalars['ID'];
};

export type Mutation = {
  __typename?: 'Mutation';
  financeSettings?: Maybe<FinanceSettings>;
  financeConfirmMappings?: Maybe<FinanceMappings>;
  financePublishCsv?: Maybe<FinancePublish>;
  financeDeleteData?: Maybe<FinanceDelete>;
  approveCalendarBranch?: Maybe<CalendarBranchResult>;
  createCalendarBranch?: Maybe<CalendarBranchResult>;
  deleteCalendarBranch?: Maybe<SuccessOkResult>;
  duplicateCalendarBranch?: Maybe<CalendarBranchResult>;
  undoBranchCalendarStageUpdate?: Maybe<CalendarBranchResult>;
  undoBranchCalendarTaskUpdate?: Maybe<CalendarBranchResult>;
  updateCalendarBranchStage?: Maybe<CalendarBranchResult>;
  updateCalendarBranchTask?: Maybe<CalendarBranchResult>;
  updateCalendarBranchStageAndFollowingEventsInHarvestGroup?: Maybe<CalendarBranchResult>;
  updateStageConflict?: Maybe<CalendarBranchResult>;
  updateTaskConflict?: Maybe<CalendarBranchResult>;
  createProcessingGroup?: Maybe<ProcessingGroupResult>;
  updateProcessingGroupArchived?: Maybe<ProcessingGroupResult>;
  finishProcessingGroupStrain?: Maybe<ProcessingGroupStrainResult>;
  moveUpProcessingGroupStrain?: Maybe<ProcessingGroupStrainResult>;
  createProcessingGroupStrainInventoryAdjustment?: Maybe<ProcessingGroupStrainResult>;
  createProcessingJob?: Maybe<ProcessingJobResult>;
  assignProcessingJobToUser?: Maybe<ProcessingJobResult>;
  updateProcessingJob?: Maybe<ProcessingJobResult>;
  createProcessingJobLog?: Maybe<ProcessingJobLogResult>;
  updateProcessingJobLog?: Maybe<ProcessingJobLogResult>;
  createProcessingGroupTemplate?: Maybe<ProcessingGroupTemplateResult>;
  updateActiveProcessingGroupTemplateVersion?: Maybe<ProcessingGroupTemplateResult>;
  updateProcessingGroupTemplateArchived?: Maybe<ProcessingGroupTemplateResult>;
  createMaintenanceRequest?: Maybe<MaintenanceRequestResult>;
  resolveMaintenanceRequest?: Maybe<MaintenanceRequestResult>;
  createEquipment?: Maybe<EquipmentResult>;
  updateEquipment?: Maybe<EquipmentResult>;
  bulkCreateEquipment?: Maybe<Array<Maybe<Equipment>>>;
  createNutrient?: Maybe<NutrientResult>;
  updateNutrient?: Maybe<NutrientResult>;
  createRecipe?: Maybe<RecipeResult>;
  updateRecipe?: Maybe<RecipeResult>;
  createZone?: Maybe<ZoneResult>;
  updateZone?: Maybe<ZoneResult>;
  bulkUpdateZoneSchedules?: Maybe<BulkUpdateZoneSchedules>;
  detectZoneLightingSchedules?: Maybe<DetectZoneLightingSchedules>;
  createBudFormFactor?: Maybe<BudFormFactorResult>;
  updateBudFormFactor?: Maybe<BudFormFactorResult>;
  reorderBudFormFactors?: Maybe<BudFormFactorResult>;
  createTask?: Maybe<TaskResult>;
  updateTask?: Maybe<TaskResult>;
  completeTask?: Maybe<TaskResult>;
  uncompleteTask?: Maybe<TaskResult>;
  createStrain?: Maybe<StrainResult>;
  updateStrain?: Maybe<StrainResult>;
  createHarvestGroup?: Maybe<HarvestGroupResult>;
  updateHarvestGroup?: Maybe<HarvestGroupResult>;
  updateHarvestGroupFlowerZone?: Maybe<HarvestGroupResult>;
  completeHarvest?: Maybe<HarvestCompletionResult>;
  approveHarvestCompletion?: Maybe<HarvestCompletionResult>;
  updateHarvestGroupArchived?: Maybe<HarvestGroupResult>;
  createHarvestReport?: Maybe<HarvestGroupResult>;
  updateHarvestReport?: Maybe<HarvestGroupResult>;
  updateHarvestYields?: Maybe<HarvestGroupResult>;
  generateHarvestSummary?: Maybe<HarvestGroupResult>;
  updateHarvestProjection?: Maybe<HarvestProjectionResult>;
  addObservationLogEntry?: Maybe<LogEntryResult>;
  addIrrigationLogEntry?: Maybe<LogEntryResult>;
  addFoliarLogEntry?: Maybe<LogEntryResult>;
  addGreenWasteLogEntry?: Maybe<LogEntryResult>;
  addRunOffLogEntry?: Maybe<LogEntryResult>;
  addPruningLogEntry?: Maybe<LogEntryResult>;
  addDefoliateLogEntry?: Maybe<LogEntryResult>;
  addToppingLogEntry?: Maybe<LogEntryResult>;
  addIssueLogEntry?: Maybe<LogEntryResult>;
  approveLogEntry?: Maybe<LogEntryResult>;
  deleteLogEntry?: Maybe<DeleteLogEntryResult>;
  createHarvestGroupTemplate?: Maybe<HarvestGroupTemplateResult>;
  updateHarvestGroupTemplate?: Maybe<HarvestGroupTemplateUpdateResult>;
  updateHarvestGroupTemplateArchived?: Maybe<HarvestGroupTemplateResult>;
  upsertHarvestGroupAutoCreationConfig?: Maybe<HarvestGroupAutoCreationConfigResult>;
  toggleHarvestGroupAutoCreationConfig?: Maybe<HarvestGroupAutoCreationConfigResult>;
  deleteHarvestGroupAutoCreationConfig?: Maybe<SuccessOkResult>;
  uploadPaperlyticsImage?: Maybe<PaperlyticsImageResult>;
  retryPaperlyticsImage?: Maybe<PaperlyticsImageResult>;
  createGenerationRequest?: Maybe<GenerationRequestTypeResult>;
  retryGenerationRequest?: Maybe<GenerationRequestTypeResult>;
  applyGenerationRequest?: Maybe<GenerationRequestTypeResult>;
  uploadEnvironmentalFile?: Maybe<EnvironmentalFileTypeResult>;
  updateTimeOffset?: Maybe<EnvironmentalFileTypeResult>;
  processEnvironmentalFile?: Maybe<EnvironmentalFileTypeResult>;
  verifySensorReplacement?: Maybe<VerifySensorReplacement>;
  setSensorActive?: Maybe<SetSensorActive>;
  setSensorCollection?: Maybe<SetSensorCollection>;
  tokenAuth?: Maybe<TokenAuthResult>;
  sendPasswordResetEmail?: Maybe<SendPasswordResetEmailResult>;
  sendAccountInvitation?: Maybe<SendAccountInvitation>;
  passwordReset?: Maybe<PasswordResetResult>;
  logout?: Maybe<LogoutResult>;
  createApiKey?: Maybe<CreateApiKeyResult>;
  revokeApiKey?: Maybe<RevokeApiKeyResult>;
  updateUserProfile?: Maybe<UpdateUserProfileResult>;
  createUser?: Maybe<UserProfileResult>;
  updateUser?: Maybe<UserProfileResult>;
  updateUserActive?: Maybe<UserProfileResult>;
  getSignedUploadUrl?: Maybe<GetSignedUploadUrlResult>;
  createToppingStyle?: Maybe<ToppingStyleResult>;
  deleteToppingStyle?: Maybe<DeleteToppingStyleResult>;
  setOrganizationActive?: Maybe<OrganizationResult>;
  updateOrganizationSettings?: Maybe<OrganizationResult>;
  updateOrganizationBranding?: Maybe<OrganizationResult>;
  createEnvironmentalTargetSet?: Maybe<EnvironmentalTargetSetResult>;
  updateEnvironmentalTargetSet?: Maybe<EnvironmentalTargetSetResult>;
  updateEnvironmentalTargetSetBulk?: Maybe<EnvironmentalTargetSetResult>;
  updateRole?: Maybe<RoleResult>;
  createOrganizationAndFirstUser?: Maybe<OrganizationResult>;
  markTourCompleted?: Maybe<ChecklistTaskResult>;
  resolveIntegrityEvent?: Maybe<ResolveIntegrityEventPayload>;
  importMetrcCompletedHarvestGroups?: Maybe<OrganizationResult>;
  importMetrcLocations?: Maybe<OrganizationResult>;
  importMetrcStrains?: Maybe<OrganizationResult>;
  importMetrcTemplate?: Maybe<OrganizationResult>;
  importMetrcBudFormFactors?: Maybe<OrganizationResult>;
  importMetrcZoneRotation?: Maybe<OrganizationResult>;
  importMetrcCurrentHarvestGroups?: Maybe<OrganizationResult>;
  updateSiteCredentials?: Maybe<OrganizationSiteResult>;
  addSiteMetrcLicense?: Maybe<OrganizationSiteResult>;
  validateOrganizationMetrcApiKey?: Maybe<ValidateOrganizationMetrcApiKeyResult>;
  rotateOrganizationMetrcApiKeyAndCatchUp?: Maybe<RotateOrganizationMetrcApiKeyResult>;
  addOrganizationMetrcPackageSourceLicense?: Maybe<OrganizationMetrcLicenseResult>;
  addMetrcPackageSourceRelationship?: Maybe<OrganizationMetrcLicenseRelationshipResult>;
  skipMetrcProcessingConnections?: Maybe<OrganizationSiteResult>;
  completeMetrcImportReview?: Maybe<OrganizationSiteResult>;
  refreshMetrcData?: Maybe<OrganizationSiteResult>;
  updateSiteSensorBrands?: Maybe<OrganizationSiteResult>;
  createSite?: Maybe<OrganizationSiteResult>;
  updateSite?: Maybe<OrganizationSiteResult>;
  enableMultisite?: Maybe<OrganizationResult>;
  createFacilitySurvey?: Maybe<FacilitySurveyResult>;
  createFieldSurvey?: Maybe<FieldSurveyResult>;
  createRoomSurvey?: Maybe<RoomSurveyResult>;
  updateRoomSurvey?: Maybe<RoomSurveyResult>;
  updateFacilitySurvey?: Maybe<FacilitySurveyResult>;
  createChecklistSession?: Maybe<ChecklistSessionResult>;
  createRoomWalkthroughChecklist?: Maybe<RoomWalkthroughChecklistResult>;
  updateRoomWalkthroughChecklist?: Maybe<RoomWalkthroughChecklistResult>;
  createChecklistEntry?: Maybe<ChecklistEntryResult>;
  updateChecklistEntry?: Maybe<ChecklistEntryResult>;
  createWaterRoomChecklist?: Maybe<WaterRoomChecklistResult>;
  updateWaterRoomChecklist?: Maybe<WaterRoomChecklistResult>;
  createWaterQualityChecklist?: Maybe<WaterQualityChecklistResult>;
  updateWaterQualityChecklist?: Maybe<WaterQualityChecklistResult>;
  createPreHarvestTaskChecklist?: Maybe<PreHarvestTaskChecklistResult>;
  updatePreHarvestTaskChecklist?: Maybe<PreHarvestTaskChecklistResult>;
  createPostHarvestTaskChecklist?: Maybe<PostHarvestTaskChecklistResult>;
  updatePostHarvestTaskChecklist?: Maybe<PostHarvestTaskChecklistResult>;
  createDryRoomPreHarvestChecklist?: Maybe<DryRoomPreHarvestChecklistResult>;
  updateDryRoomPreHarvestChecklist?: Maybe<DryRoomPreHarvestChecklistResult>;
  createDryRoomPostHarvestChecklist?: Maybe<DryRoomPostHarvestChecklistResult>;
  updateDryRoomPostHarvestChecklist?: Maybe<DryRoomPostHarvestChecklistResult>;
  createRoomLoadTaskChecklist?: Maybe<RoomLoadTaskChecklistResult>;
  updateRoomLoadTaskChecklist?: Maybe<RoomLoadTaskChecklistResult>;
  createTransplantTaskChecklist?: Maybe<TransplantTaskChecklistResult>;
  updateTransplantTaskChecklist?: Maybe<TransplantTaskChecklistResult>;
  createCloningTaskChecklist?: Maybe<CloningTaskChecklistResult>;
  updateCloningTaskChecklist?: Maybe<CloningTaskChecklistResult>;
  createPruningDefolTaskChecklist?: Maybe<PruningDefolTaskChecklistResult>;
  updatePruningDefolTaskChecklist?: Maybe<PruningDefolTaskChecklistResult>;
  createDailyTasksChecklist?: Maybe<DailyTasksChecklistResult>;
  updateDailyTasksChecklist?: Maybe<DailyTasksChecklistResult>;
  createDailyWetRoomTaskChecklist?: Maybe<DailyWetRoomTaskChecklistResult>;
  updateDailyWetRoomTaskChecklist?: Maybe<DailyWetRoomTaskChecklistResult>;
  createTrolmasterDevice?: Maybe<EnvironmentalDeviceResult>;
  createAroyaDevice?: Maybe<EnvironmentalDeviceResult>;
  createGrowlinkDevice?: Maybe<EnvironmentalDeviceResult>;
  updateTrolmasterDevice?: Maybe<EnvironmentalDeviceResult>;
  updateAroyaDevice?: Maybe<EnvironmentalDeviceResult>;
  updateGrowlinkDevice?: Maybe<EnvironmentalDeviceResult>;
  deleteEnvironmentalDevice?: Maybe<EnvironmentalDeviceResult>;
  setPrimaryDevice?: Maybe<EnvironmentalDeviceResult>;
  validateDeviceQrCode?: Maybe<ValidateDeviceQrCodeResult>;
  reassignDeviceZone?: Maybe<EnvironmentalDeviceResult>;
  createFieldAgent?: Maybe<CreateFieldAgentResult>;
  rotateFieldAgentToken?: Maybe<RotateFieldAgentTokenResult>;
  generateFieldAgentClaimCode?: Maybe<GenerateFieldAgentClaimCodeResult>;
  mapFieldAgentDevice?: Maybe<FieldAgentDeviceResult>;
  importAroyaData?: Maybe<SensorImportSiteResult>;
  importAroyaSubstrateData?: Maybe<SensorImportSiteResult>;
  importTrolmasterData?: Maybe<SensorImportSiteResult>;
  importGrowlinkData?: Maybe<SensorImportSiteResult>;
  addTrolmasterApiKey?: Maybe<OrganizationResult>;
  addAroyaApiKey?: Maybe<AddAroyaApiKeyResult>;
  addGrowlinkApiKey?: Maybe<AddGrowlinkApiKeyResult>;
  addSiteAroyaCredential?: Maybe<AddSiteAroyaCredentialResult>;
  addSiteGrowlinkCredential?: Maybe<AddSiteGrowlinkCredentialResult>;
  addSiteTrolmasterCredential?: Maybe<AddSiteTrolmasterCredentialResult>;
  refreshSiteAroyaDeviceRequests?: Maybe<RefreshSiteAroyaDeviceRequestsResult>;
  refreshSiteGrowlinkDeviceRequests?: Maybe<RefreshSiteGrowlinkDeviceRequestsResult>;
  confirmTargetValues?: Maybe<OrganizationResult>;
  regenerateAlerts?: Maybe<OrganizationResult>;
  copySensorCredentialToAllSites?: Maybe<CopySensorCredentialToAllSitesResult>;
  updateNotificationPreference?: Maybe<OrganizationNotificationPreferenceResult>;
  updateUserNotificationPreference?: Maybe<UserNotificationPreferenceResult>;
};


export type MutationFinanceSettingsArgs = {
  basis?: Maybe<Scalars['String']>;
  confirm?: Maybe<Scalars['Boolean']>;
  mappings?: Maybe<Scalars['GenericScalar']>;
  source: Scalars['String'];
};


export type MutationFinanceConfirmMappingsArgs = {
  mappings: Scalars['GenericScalar'];
};


export type MutationFinancePublishCsvArgs = {
  mappings?: Maybe<Scalars['GenericScalar']>;
  months: Array<Scalars['String']>;
  replace?: Maybe<Scalars['Boolean']>;
  runId: Scalars['UUID'];
};


export type MutationFinanceDeleteDataArgs = {
  confirm: Scalars['Boolean'];
};


export type MutationApproveCalendarBranchArgs = {
  id: Scalars['ID'];
};


export type MutationCreateCalendarBranchArgs = {
  input?: Maybe<CreateCalendarBranchInput>;
};


export type MutationDeleteCalendarBranchArgs = {
  id: Scalars['ID'];
};


export type MutationDuplicateCalendarBranchArgs = {
  input?: Maybe<DuplicateCalendarBranchInput>;
};


export type MutationUndoBranchCalendarStageUpdateArgs = {
  input?: Maybe<UndoBranchCalendarStageUpdateInput>;
};


export type MutationUndoBranchCalendarTaskUpdateArgs = {
  input?: Maybe<UndoBranchCalendarTaskUpdateInput>;
};


export type MutationUpdateCalendarBranchStageArgs = {
  input?: Maybe<UpdateCalendarBranchStageInput>;
};


export type MutationUpdateCalendarBranchTaskArgs = {
  input?: Maybe<UpdateCalendarBranchTaskInput>;
};


export type MutationUpdateCalendarBranchStageAndFollowingEventsInHarvestGroupArgs = {
  input?: Maybe<UpdateCalendarBranchStageInput>;
};


export type MutationUpdateStageConflictArgs = {
  input?: Maybe<UpdateStageConflictInput>;
};


export type MutationUpdateTaskConflictArgs = {
  input?: Maybe<UpdateTaskConflictInput>;
};


export type MutationCreateProcessingGroupArgs = {
  input?: Maybe<CreateProcessingGroupInput>;
};


export type MutationUpdateProcessingGroupArchivedArgs = {
  input?: Maybe<UpdateProcessingGroupArchivedInput>;
};


export type MutationFinishProcessingGroupStrainArgs = {
  input?: Maybe<FinishProcessingGroupStrainInput>;
};


export type MutationMoveUpProcessingGroupStrainArgs = {
  input?: Maybe<MoveUpProcessingGroupStrainInput>;
};


export type MutationCreateProcessingGroupStrainInventoryAdjustmentArgs = {
  input?: Maybe<CreateProcessingGroupStrainInventoryAdjustmentInput>;
};


export type MutationCreateProcessingJobArgs = {
  input?: Maybe<CreateProcessingJobInput>;
};


export type MutationAssignProcessingJobToUserArgs = {
  input?: Maybe<AssignProcessingJobToUserInput>;
};


export type MutationUpdateProcessingJobArgs = {
  input?: Maybe<UpdateProcessingJobInput>;
};


export type MutationCreateProcessingJobLogArgs = {
  input?: Maybe<CreateProcessingJobLogInput>;
};


export type MutationUpdateProcessingJobLogArgs = {
  input?: Maybe<UpdateProcessingJobLogInput>;
};


export type MutationCreateProcessingGroupTemplateArgs = {
  input?: Maybe<CreateProcessingGroupTemplateInput>;
};


export type MutationUpdateActiveProcessingGroupTemplateVersionArgs = {
  input?: Maybe<UpdateActiveProcessingGroupTemplateVersionInput>;
};


export type MutationUpdateProcessingGroupTemplateArchivedArgs = {
  input?: Maybe<UpdateProcessingGroupTemplateArchivedInput>;
};


export type MutationCreateMaintenanceRequestArgs = {
  input?: Maybe<CreateMaintenanceRequestInput>;
};


export type MutationResolveMaintenanceRequestArgs = {
  input?: Maybe<ResolveMaintenanceRequestInput>;
};


export type MutationCreateEquipmentArgs = {
  input?: Maybe<CreateEquipmentInput>;
};


export type MutationUpdateEquipmentArgs = {
  input?: Maybe<UpdateEquipmentInput>;
};


export type MutationBulkCreateEquipmentArgs = {
  input?: Maybe<BulkCreateEquipmentInput>;
};


export type MutationCreateNutrientArgs = {
  input?: Maybe<CreateNutrientInput>;
};


export type MutationUpdateNutrientArgs = {
  input?: Maybe<UpdateNutrientInput>;
};


export type MutationCreateRecipeArgs = {
  input?: Maybe<CreateRecipeInput>;
};


export type MutationUpdateRecipeArgs = {
  input?: Maybe<UpdateRecipeInput>;
};


export type MutationCreateZoneArgs = {
  input?: Maybe<CreateZoneInput>;
};


export type MutationUpdateZoneArgs = {
  input?: Maybe<UpdateZoneInput>;
};


export type MutationBulkUpdateZoneSchedulesArgs = {
  input: BulkUpdateZoneSchedulesInput;
};


export type MutationDetectZoneLightingSchedulesArgs = {
  siteId: Scalars['ID'];
};


export type MutationCreateBudFormFactorArgs = {
  input?: Maybe<CreateBudFormFactorInput>;
};


export type MutationUpdateBudFormFactorArgs = {
  input?: Maybe<UpdateBudFormFactorInput>;
};


export type MutationReorderBudFormFactorsArgs = {
  input?: Maybe<ReorderBudFormFactorsInput>;
};


export type MutationCreateTaskArgs = {
  input?: Maybe<CreateTaskInput>;
};


export type MutationUpdateTaskArgs = {
  input?: Maybe<UpdateTaskInput>;
};


export type MutationCompleteTaskArgs = {
  input?: Maybe<CompleteTaskInput>;
};


export type MutationUncompleteTaskArgs = {
  input?: Maybe<UncompleteTaskInput>;
};


export type MutationCreateStrainArgs = {
  input?: Maybe<CreateStrainInput>;
};


export type MutationUpdateStrainArgs = {
  input?: Maybe<UpdateStrainInput>;
};


export type MutationCreateHarvestGroupArgs = {
  input?: Maybe<CreateHarvestGroupInput>;
};


export type MutationUpdateHarvestGroupArgs = {
  input?: Maybe<UpdateHarvestGroupInput>;
};


export type MutationUpdateHarvestGroupFlowerZoneArgs = {
  input?: Maybe<UpdateHarvestGroupFlowerZoneInput>;
};


export type MutationCompleteHarvestArgs = {
  input?: Maybe<CompleteHarvestInput>;
};


export type MutationApproveHarvestCompletionArgs = {
  input?: Maybe<ApproveHarvestCompletionInput>;
};


export type MutationUpdateHarvestGroupArchivedArgs = {
  input?: Maybe<UpdateHarvestGroupArchivedInput>;
};


export type MutationCreateHarvestReportArgs = {
  input?: Maybe<CreateHarvestReportInput>;
};


export type MutationUpdateHarvestReportArgs = {
  input?: Maybe<UpdateHarvestReportInput>;
};


export type MutationUpdateHarvestYieldsArgs = {
  input?: Maybe<UpdateHarvestYieldsInput>;
};


export type MutationGenerateHarvestSummaryArgs = {
  input?: Maybe<GenerateHarvestSummaryInput>;
};


export type MutationUpdateHarvestProjectionArgs = {
  input?: Maybe<UpdateHarvestProjectionInput>;
};


export type MutationAddObservationLogEntryArgs = {
  input?: Maybe<LogEntryInput>;
};


export type MutationAddIrrigationLogEntryArgs = {
  input?: Maybe<LogEntryInput>;
};


export type MutationAddFoliarLogEntryArgs = {
  input?: Maybe<LogEntryInput>;
};


export type MutationAddGreenWasteLogEntryArgs = {
  input?: Maybe<LogEntryInput>;
};


export type MutationAddRunOffLogEntryArgs = {
  input?: Maybe<LogEntryInput>;
};


export type MutationAddPruningLogEntryArgs = {
  input?: Maybe<LogEntryInput>;
};


export type MutationAddDefoliateLogEntryArgs = {
  input?: Maybe<LogEntryInput>;
};


export type MutationAddToppingLogEntryArgs = {
  input?: Maybe<LogEntryInput>;
};


export type MutationAddIssueLogEntryArgs = {
  input?: Maybe<LogEntryInput>;
};


export type MutationApproveLogEntryArgs = {
  input?: Maybe<ApproveLogEntryInput>;
};


export type MutationDeleteLogEntryArgs = {
  input?: Maybe<DeleteLogEntryInput>;
};


export type MutationCreateHarvestGroupTemplateArgs = {
  input?: Maybe<CreateHarvestGroupTemplateInput>;
};


export type MutationUpdateHarvestGroupTemplateArgs = {
  input?: Maybe<UpdateHarvestGroupTemplateInput>;
};


export type MutationUpdateHarvestGroupTemplateArchivedArgs = {
  input?: Maybe<UpdateHarvestGroupTemplateArchivedInput>;
};


export type MutationUpsertHarvestGroupAutoCreationConfigArgs = {
  input: UpsertHarvestGroupAutoCreationConfigInput;
};


export type MutationToggleHarvestGroupAutoCreationConfigArgs = {
  isEnabled: Scalars['Boolean'];
  siteId: Scalars['ID'];
};


export type MutationDeleteHarvestGroupAutoCreationConfigArgs = {
  siteId: Scalars['ID'];
};


export type MutationUploadPaperlyticsImageArgs = {
  harvestGroupId: Scalars['String'];
  imageUrl: Scalars['String'];
};


export type MutationRetryPaperlyticsImageArgs = {
  imageId: Scalars['String'];
};


export type MutationCreateGenerationRequestArgs = {
  analysisType: Scalars['String'];
  images: Array<GenerationRequestImageInput>;
  organizationId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  textPrompt?: Maybe<Scalars['String']>;
};


export type MutationRetryGenerationRequestArgs = {
  id: Scalars['String'];
};


export type MutationApplyGenerationRequestArgs = {
  id: Scalars['String'];
  lightingType?: Maybe<Scalars['String']>;
};


export type MutationUploadEnvironmentalFileArgs = {
  input?: Maybe<EnvironmentalFileInput>;
};


export type MutationUpdateTimeOffsetArgs = {
  input?: Maybe<UpdateTimeOffsetInput>;
};


export type MutationProcessEnvironmentalFileArgs = {
  input?: Maybe<ProcessEnvironmentalFileInput>;
};


export type MutationVerifySensorReplacementArgs = {
  candidateId: Scalars['ID'];
  deviceId: Scalars['ID'];
};


export type MutationSetSensorActiveArgs = {
  active: Scalars['Boolean'];
  deviceId: Scalars['ID'];
};


export type MutationSetSensorCollectionArgs = {
  enabled: Scalars['Boolean'];
  siteId: Scalars['ID'];
};


export type MutationTokenAuthArgs = {
  password: Scalars['String'];
  username_Iexact: Scalars['String'];
};


export type MutationSendPasswordResetEmailArgs = {
  email: Scalars['String'];
};


export type MutationSendAccountInvitationArgs = {
  id: Scalars['ID'];
};


export type MutationPasswordResetArgs = {
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
  token: Scalars['String'];
};


export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


export type MutationRevokeApiKeyArgs = {
  input: RevokeApiKeyInput;
};


export type MutationUpdateUserProfileArgs = {
  input?: Maybe<UpdateUserProfileInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationUpdateUserActiveArgs = {
  input?: Maybe<UpdateUserActiveInput>;
};


export type MutationGetSignedUploadUrlArgs = {
  input: GetSignedUploadUrlInput;
};


export type MutationCreateToppingStyleArgs = {
  input?: Maybe<CreateToppingStyleInput>;
};


export type MutationDeleteToppingStyleArgs = {
  input?: Maybe<DeleteToppingStyleInput>;
};


export type MutationSetOrganizationActiveArgs = {
  active: Scalars['Boolean'];
  organizationId: Scalars['ID'];
};


export type MutationUpdateOrganizationSettingsArgs = {
  input?: Maybe<UpdateOrganizationSettingsInput>;
};


export type MutationUpdateOrganizationBrandingArgs = {
  input: UpdateOrganizationBrandingInput;
};


export type MutationCreateEnvironmentalTargetSetArgs = {
  input: CreateEnvironmentalTargetSetInput;
};


export type MutationUpdateEnvironmentalTargetSetArgs = {
  input: UpdateEnvironmentalTargetSetInput;
};


export type MutationUpdateEnvironmentalTargetSetBulkArgs = {
  input: UpdateEnvironmentalTargetSetBulkInput;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationCreateOrganizationAndFirstUserArgs = {
  input?: Maybe<CreateOrganizationAndFirstUserInput>;
};


export type MutationMarkTourCompletedArgs = {
  input: MarkTourCompletedInput;
};


export type MutationResolveIntegrityEventArgs = {
  input: ResolveIntegrityEventInput;
};


export type MutationImportMetrcCompletedHarvestGroupsArgs = {
  input: ImportMetrcCompletedHarvestGroupsInput;
};


export type MutationImportMetrcLocationsArgs = {
  input: ImportMetrcLocationsInput;
};


export type MutationImportMetrcStrainsArgs = {
  input: ImportMetrcStrainsInput;
};


export type MutationImportMetrcTemplateArgs = {
  input: ImportMetrcTemplateInput;
};


export type MutationImportMetrcBudFormFactorsArgs = {
  input: ImportMetrcBudFormFactorsInput;
};


export type MutationImportMetrcZoneRotationArgs = {
  input: ImportMetrcZoneRotationInput;
};


export type MutationImportMetrcCurrentHarvestGroupsArgs = {
  input: ImportMetrcCurrentHarvestGroupsInput;
};


export type MutationUpdateSiteCredentialsArgs = {
  input: UpdateSiteCredentialsInput;
};


export type MutationAddSiteMetrcLicenseArgs = {
  input: AddSiteMetrcLicenseInput;
};


export type MutationValidateOrganizationMetrcApiKeyArgs = {
  input: OrganizationMetrcApiKeyInput;
};


export type MutationRotateOrganizationMetrcApiKeyAndCatchUpArgs = {
  input: OrganizationMetrcApiKeyInput;
};


export type MutationAddOrganizationMetrcPackageSourceLicenseArgs = {
  input: AddOrganizationMetrcPackageSourceLicenseInput;
};


export type MutationAddMetrcPackageSourceRelationshipArgs = {
  input: AddMetrcPackageSourceRelationshipInput;
};


export type MutationSkipMetrcProcessingConnectionsArgs = {
  input: SkipMetrcProcessingConnectionsInput;
};


export type MutationCompleteMetrcImportReviewArgs = {
  input: CompleteMetrcImportReviewInput;
};


export type MutationRefreshMetrcDataArgs = {
  input: RefreshMetrcDataInput;
};


export type MutationUpdateSiteSensorBrandsArgs = {
  input: UpdateSiteSensorBrandsInput;
};


export type MutationCreateSiteArgs = {
  input: CreateSiteInput;
};


export type MutationUpdateSiteArgs = {
  input: UpdateSiteInput;
};


export type MutationEnableMultisiteArgs = {
  input: EnableMultisiteInput;
};


export type MutationCreateFacilitySurveyArgs = {
  input: CreateFacilitySurveyInput;
};


export type MutationCreateFieldSurveyArgs = {
  input: CreateFieldSurveyInput;
};


export type MutationCreateRoomSurveyArgs = {
  input: CreateRoomSurveyInput;
};


export type MutationUpdateRoomSurveyArgs = {
  input: UpdateRoomSurveyInput;
};


export type MutationUpdateFacilitySurveyArgs = {
  input: UpdateFacilitySurveyInput;
};


export type MutationCreateChecklistSessionArgs = {
  input: CreateChecklistSessionInput;
};


export type MutationCreateRoomWalkthroughChecklistArgs = {
  input: CreateRoomWalkthroughChecklistInput;
};


export type MutationUpdateRoomWalkthroughChecklistArgs = {
  input: UpdateRoomWalkthroughChecklistInput;
};


export type MutationCreateChecklistEntryArgs = {
  input: CreateChecklistEntryInput;
};


export type MutationUpdateChecklistEntryArgs = {
  input: UpdateChecklistEntryInput;
};


export type MutationCreateWaterRoomChecklistArgs = {
  input: WaterRoomChecklistInput;
};


export type MutationUpdateWaterRoomChecklistArgs = {
  input: UpdateWaterRoomChecklistInput;
};


export type MutationCreateWaterQualityChecklistArgs = {
  input: WaterQualityChecklistInput;
};


export type MutationUpdateWaterQualityChecklistArgs = {
  input: UpdateWaterQualityChecklistInput;
};


export type MutationCreatePreHarvestTaskChecklistArgs = {
  input: PreHarvestTaskChecklistInput;
};


export type MutationUpdatePreHarvestTaskChecklistArgs = {
  input: UpdatePreHarvestTaskChecklistInput;
};


export type MutationCreatePostHarvestTaskChecklistArgs = {
  input: PostHarvestTaskChecklistInput;
};


export type MutationUpdatePostHarvestTaskChecklistArgs = {
  input: UpdatePostHarvestTaskChecklistInput;
};


export type MutationCreateDryRoomPreHarvestChecklistArgs = {
  input: DryRoomPreHarvestChecklistInput;
};


export type MutationUpdateDryRoomPreHarvestChecklistArgs = {
  input: UpdateDryRoomPreHarvestChecklistInput;
};


export type MutationCreateDryRoomPostHarvestChecklistArgs = {
  input: DryRoomPostHarvestChecklistInput;
};


export type MutationUpdateDryRoomPostHarvestChecklistArgs = {
  input: UpdateDryRoomPostHarvestChecklistInput;
};


export type MutationCreateRoomLoadTaskChecklistArgs = {
  input: RoomLoadTaskChecklistInput;
};


export type MutationUpdateRoomLoadTaskChecklistArgs = {
  input: UpdateRoomLoadTaskChecklistInput;
};


export type MutationCreateTransplantTaskChecklistArgs = {
  input: TransplantTaskChecklistInput;
};


export type MutationUpdateTransplantTaskChecklistArgs = {
  input: UpdateTransplantTaskChecklistInput;
};


export type MutationCreateCloningTaskChecklistArgs = {
  input: CloningTaskChecklistInput;
};


export type MutationUpdateCloningTaskChecklistArgs = {
  input: UpdateCloningTaskChecklistInput;
};


export type MutationCreatePruningDefolTaskChecklistArgs = {
  input: PruningDefolTaskChecklistInput;
};


export type MutationUpdatePruningDefolTaskChecklistArgs = {
  input: UpdatePruningDefolTaskChecklistInput;
};


export type MutationCreateDailyTasksChecklistArgs = {
  input: DailyTasksChecklistInput;
};


export type MutationUpdateDailyTasksChecklistArgs = {
  input: UpdateDailyTasksChecklistInput;
};


export type MutationCreateDailyWetRoomTaskChecklistArgs = {
  input: DailyWetRoomTaskChecklistInput;
};


export type MutationUpdateDailyWetRoomTaskChecklistArgs = {
  input: UpdateDailyWetRoomTaskChecklistInput;
};


export type MutationCreateTrolmasterDeviceArgs = {
  input: CreateTrolmasterDeviceInput;
};


export type MutationCreateAroyaDeviceArgs = {
  input: CreateAroyaDeviceInput;
};


export type MutationCreateGrowlinkDeviceArgs = {
  input: CreateGrowlinkDeviceInput;
};


export type MutationUpdateTrolmasterDeviceArgs = {
  input: UpdateTrolmasterDeviceInput;
};


export type MutationUpdateAroyaDeviceArgs = {
  input: UpdateAroyaDeviceInput;
};


export type MutationUpdateGrowlinkDeviceArgs = {
  input: UpdateGrowlinkDeviceInput;
};


export type MutationDeleteEnvironmentalDeviceArgs = {
  input: DeleteEnvironmentalDeviceInput;
};


export type MutationSetPrimaryDeviceArgs = {
  input: SetPrimaryDeviceInput;
};


export type MutationValidateDeviceQrCodeArgs = {
  input: ValidateDeviceQrCodeInput;
};


export type MutationReassignDeviceZoneArgs = {
  input: ReassignDeviceZoneInput;
};


export type MutationCreateFieldAgentArgs = {
  input: CreateFieldAgentInput;
};


export type MutationRotateFieldAgentTokenArgs = {
  input: RotateFieldAgentTokenInput;
};


export type MutationGenerateFieldAgentClaimCodeArgs = {
  input: GenerateFieldAgentClaimCodeInput;
};


export type MutationMapFieldAgentDeviceArgs = {
  input: MapFieldAgentDeviceInput;
};


export type MutationImportAroyaDataArgs = {
  siteId: Scalars['ID'];
};


export type MutationImportAroyaSubstrateDataArgs = {
  siteId: Scalars['ID'];
};


export type MutationImportTrolmasterDataArgs = {
  siteId: Scalars['ID'];
};


export type MutationImportGrowlinkDataArgs = {
  siteId: Scalars['ID'];
};


export type MutationAddTrolmasterApiKeyArgs = {
  input: AddTrolmasterApiKeyInput;
};


export type MutationAddAroyaApiKeyArgs = {
  input: AddAroyaApiKeyInput;
};


export type MutationAddGrowlinkApiKeyArgs = {
  input: AddGrowlinkApiKeyInput;
};


export type MutationAddSiteAroyaCredentialArgs = {
  input: AddSiteAroyaCredentialInput;
};


export type MutationAddSiteGrowlinkCredentialArgs = {
  input: AddSiteGrowlinkCredentialInput;
};


export type MutationAddSiteTrolmasterCredentialArgs = {
  input: AddSiteTrolmasterCredentialInput;
};


export type MutationRefreshSiteAroyaDeviceRequestsArgs = {
  input: RefreshSiteAroyaDeviceRequestsInput;
};


export type MutationRefreshSiteGrowlinkDeviceRequestsArgs = {
  input: RefreshSiteGrowlinkDeviceRequestsInput;
};


export type MutationConfirmTargetValuesArgs = {
  organizationId: Scalars['ID'];
};


export type MutationRegenerateAlertsArgs = {
  organizationId: Scalars['ID'];
};


export type MutationCopySensorCredentialToAllSitesArgs = {
  input: CopySensorCredentialToAllSitesInput;
};


export type MutationUpdateNotificationPreferenceArgs = {
  input?: Maybe<UpdateNotificationPreferenceInput>;
};


export type MutationUpdateUserNotificationPreferenceArgs = {
  input?: Maybe<UpdateUserNotificationPreferenceInput>;
};

export type Nutrient = {
  __typename?: 'Nutrient';
  id: Scalars['UUID'];
  name: Scalars['String'];
  active: Scalars['Boolean'];
  unitOfMeasure: NutrientUnitOfMeasure;
  priceInCentsPerUnit: Scalars['Decimal'];
  boughtPrice?: Maybe<Scalars['Decimal']>;
  boughtAmount?: Maybe<Scalars['Decimal']>;
  boughtUnit?: Maybe<Scalars['String']>;
};

export type NutrientFilterSetInput = {
  active?: Maybe<Scalars['Boolean']>;
};

export type NutrientResult = Nutrient | Error;

export enum NutrientUnitOfMeasure {
  MillilitersPerGallon = 'MILLILITERS_PER_GALLON',
  GramsPerGallon = 'GRAMS_PER_GALLON'
}

export type Organization = {
  __typename?: 'Organization';
  id: Scalars['String'];
  asyncRegenerateAlertsStatus?: Maybe<OrganizationAsyncRegenerateAlertsStatus>;
  asyncRegenerateAlertsStartedAt?: Maybe<Scalars['DateTime']>;
  asyncRegenerateAlertsCompletedAt?: Maybe<Scalars['DateTime']>;
  asyncRegenerateAlertsError?: Maybe<Scalars['String']>;
  asyncRegenerateAlertsProgressPct: Scalars['Int'];
  name: Scalars['String'];
  hubspotOrganizationId?: Maybe<Scalars['String']>;
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  moduleEnabledCultivation: Scalars['Boolean'];
  moduleEnabledProcessing: Scalars['Boolean'];
  moduleEnabledFinance: Scalars['Boolean'];
  moduleEnabledMaintenance: Scalars['Boolean'];
  redesignEnabled: Scalars['Boolean'];
  apiEnabled: Scalars['Boolean'];
  optionConvertGramsAbove: Scalars['Int'];
  timezone: Scalars['String'];
  normalizeWindowMinutes: Scalars['Int'];
  alertConsecutiveThreshold: Scalars['Int'];
  trialAccount?: Maybe<OrganizationTrialAccount>;
  accountType?: Maybe<OrganizationAccountType>;
  allowMultisite: Scalars['Boolean'];
  dayStartTime: Scalars['Time'];
  nightStartTime: Scalars['Time'];
  confirmedTargetValues: Scalars['Boolean'];
  alertsRegenerated: Scalars['Boolean'];
  users?: Maybe<Array<Maybe<UserProfile>>>;
  sensorBrands: Array<OrganizationSensorBrand>;
  checklist?: Maybe<OrganizationChecklist>;
  environmentalTargetSets: Array<EnvironmentalTargetSet>;
  sites?: Maybe<Array<Maybe<OrganizationSite>>>;
  branding: OrganizationBranding;
  staffUser?: Maybe<UserProfile>;
  zones?: Maybe<Array<Maybe<Zone>>>;
  harvestGroupTemplates?: Maybe<Array<Maybe<HarvestGroupTemplate>>>;
  budFormFactors?: Maybe<Array<Maybe<BudFormFactor>>>;
  metrcLicenses?: Maybe<Array<Maybe<OrganizationMetrcLicense>>>;
  metrcImportCompleted?: Maybe<Scalars['Boolean']>;
  hasEnvironmentalDevices?: Maybe<Scalars['Boolean']>;
  notificationPreferences?: Maybe<Array<Maybe<OrganizationNotificationPreference>>>;
  regenerateAlertsEtaSecondsRemaining?: Maybe<Scalars['Int']>;
  regenerateAlertsEtaDatetime?: Maybe<Scalars['DateTime']>;
};

export enum OrganizationAccountType {
  Freemium = 'FREEMIUM',
  Paid = 'PAID',
  Demo = 'DEMO'
}

export enum OrganizationAsyncRegenerateAlertsStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type OrganizationBranding = {
  __typename?: 'OrganizationBranding';
  colorPreset: Scalars['String'];
  typographyPreset: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  logoDarkUrl?: Maybe<Scalars['String']>;
  customized: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationChecklist = {
  __typename?: 'OrganizationChecklist';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  checklistTasks?: Maybe<Array<Maybe<ChecklistTask>>>;
};

export type OrganizationFilterSetInput = {
  id_Icontains?: Maybe<Scalars['String']>;
  deactivatedAt_Isnull?: Maybe<Scalars['Boolean']>;
};

export type OrganizationMetrcApiKeyInput = {
  organizationId: Scalars['ID'];
  licenseNumber: Scalars['String'];
  userKey: Scalars['String'];
  metrcState: Scalars['String'];
};

export type OrganizationMetrcLicense = {
  __typename?: 'OrganizationMetrcLicense';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  asyncPackageImportStatus?: Maybe<OrganizationMetrcLicenseAsyncPackageImportStatus>;
  asyncPackageImportStartedAt?: Maybe<Scalars['DateTime']>;
  asyncPackageImportCompletedAt?: Maybe<Scalars['DateTime']>;
  asyncPackageImportTaskId?: Maybe<Scalars['String']>;
  asyncPackageImportError?: Maybe<Scalars['String']>;
  asyncPackageImportTraceback?: Maybe<Scalars['String']>;
  asyncPackageImportProgressPct: Scalars['Int'];
  organization: Organization;
  licenseNumber: Scalars['String'];
  userKey: Scalars['String'];
  metrcState: OrganizationMetrcLicenseMetrcState;
  licenseType?: Maybe<Scalars['String']>;
  canGrowPlants?: Maybe<Scalars['Boolean']>;
  facilityType: Scalars['JSONString'];
  role: OrganizationMetrcLicenseRole;
  isActive: Scalars['Boolean'];
  validationStatus: OrganizationMetrcLicenseValidationStatus;
  validationError: Scalars['String'];
  importTasks: Array<MetrcLicenseImportTask>;
  siteAssignments: Array<OrganizationSiteMetrcLicense>;
  sourceMetrcLicenseRelationships: Array<OrganizationMetrcLicenseRelationship>;
  targetMetrcLicenseRelationships: Array<OrganizationMetrcLicenseRelationship>;
};

export enum OrganizationMetrcLicenseAsyncPackageImportStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export enum OrganizationMetrcLicenseMetrcState {
  Al = 'AL',
  Ak = 'AK',
  Dc = 'DC',
  Ca = 'CA',
  Co = 'CO',
  Il = 'IL',
  Ky = 'KY',
  La = 'LA',
  Me = 'ME',
  Md = 'MD',
  Ma = 'MA',
  Mi = 'MI',
  Mn = 'MN',
  Ms = 'MS',
  Mt = 'MT',
  Nj = 'NJ',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR'
}

export type OrganizationMetrcLicenseRelationship = {
  __typename?: 'OrganizationMetrcLicenseRelationship';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  sourceSite: OrganizationSite;
  sourceSiteLicense?: Maybe<OrganizationSiteMetrcLicense>;
  sourceOrgLicense?: Maybe<OrganizationMetrcLicense>;
  targetOrgLicense: OrganizationMetrcLicense;
  relationshipType: OrganizationMetrcLicenseRelationshipRelationshipType;
  isActive: Scalars['Boolean'];
  isRequiredForInitialImport: Scalars['Boolean'];
  notes: Scalars['String'];
};

export enum OrganizationMetrcLicenseRelationshipRelationshipType {
  HarvestYieldPackage = 'HARVEST_YIELD_PACKAGE',
  PlantMaterialSource = 'PLANT_MATERIAL_SOURCE',
  DownstreamTraceability = 'DOWNSTREAM_TRACEABILITY'
}

export type OrganizationMetrcLicenseRelationshipResult = OrganizationMetrcLicenseRelationship | Error;

export type OrganizationMetrcLicenseResult = OrganizationMetrcLicense | Error;

export enum OrganizationMetrcLicenseRole {
  Unknown = 'UNKNOWN',
  Cultivation = 'CULTIVATION',
  Processor = 'PROCESSOR',
  HubProcessor = 'HUB_PROCESSOR',
  Nursery = 'NURSERY',
  Distributor = 'DISTRIBUTOR'
}

export enum OrganizationMetrcLicenseValidationStatus {
  Pending = 'PENDING',
  Valid = 'VALID',
  Invalid = 'INVALID'
}

export type OrganizationNotificationPreference = {
  __typename?: 'OrganizationNotificationPreference';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  reportType: OrganizationNotificationPreferenceReportType;
  enabled: Scalars['Boolean'];
  frequency: OrganizationNotificationPreferenceFrequency;
  sendToAdmins: Scalars['Boolean'];
  sendToCultivationManagers: Scalars['Boolean'];
  sendToCultivation: Scalars['Boolean'];
  isScheduledReport?: Maybe<Scalars['Boolean']>;
  isEventTriggeredReport?: Maybe<Scalars['Boolean']>;
  requiresFrequencySelection?: Maybe<Scalars['Boolean']>;
  effectiveFrequency?: Maybe<Scalars['String']>;
};

export enum OrganizationNotificationPreferenceFrequency {
  Immediate = 'IMMEDIATE',
  Daily = 'DAILY',
  Weekly = 'WEEKLY'
}

export enum OrganizationNotificationPreferenceReportType {
  CultivationActivity = 'CULTIVATION_ACTIVITY',
  Environmental = 'ENVIRONMENTAL',
  DailyGrower = 'DAILY_GROWER',
  WeeklyReview = 'WEEKLY_REVIEW',
  IssueAlert = 'ISSUE_ALERT',
  ChecklistCompletion = 'CHECKLIST_COMPLETION',
  HarvestReport = 'HARVEST_REPORT',
  CalendarBranchApproval = 'CALENDAR_BRANCH_APPROVAL'
}

export type OrganizationNotificationPreferenceResult = OrganizationNotificationPreference | Error;

export type OrganizationResult = Organization | Error;

export type OrganizationSensorBrand = {
  __typename?: 'OrganizationSensorBrand';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  organization: Organization;
  brandName: OrganizationSensorBrandBrandName;
  isActive: Scalars['Boolean'];
};

export enum OrganizationSensorBrandBrandName {
  Aroya = 'AROYA',
  Trolmaster = 'TROLMASTER',
  Growlink = 'GROWLINK',
  Agrowtek = 'AGROWTEK'
}

export type OrganizationSite = {
  __typename?: 'OrganizationSite';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  collectAllSensors: Scalars['Boolean'];
  name: Scalars['String'];
  organization: Organization;
  isActive: Scalars['Boolean'];
  asyncTaskId?: Maybe<Scalars['String']>;
  asyncImportStatus?: Maybe<OrganizationSiteAsyncImportStatus>;
  asyncImportStartedAt?: Maybe<Scalars['DateTime']>;
  asyncImportCompletedAt?: Maybe<Scalars['DateTime']>;
  metrcLicenseNumber?: Maybe<Scalars['String']>;
  metrcUserKey?: Maybe<Scalars['String']>;
  metrcState?: Maybe<OrganizationSiteMetrcState>;
  metrcLicenseType?: Maybe<Scalars['String']>;
  metrcCanGrowPlants?: Maybe<Scalars['Boolean']>;
  confirmedLightingSchedules: Scalars['Boolean'];
  preferredYieldSource: OrganizationSitePreferredYieldSource;
  enableMetrcTotalWholePackageStrategy: Scalars['Boolean'];
  metrcPackageYieldStrategy: OrganizationSiteMetrcPackageYieldStrategy;
  metrcPackageCandidateIndexReady: Scalars['Boolean'];
  metrcRoomNormalizationStrategy: OrganizationSiteMetrcRoomNormalizationStrategy;
  metrcSyncFloweringDates: Scalars['Boolean'];
  metrcSyncHarvestDates: Scalars['Boolean'];
  metrcProcessingConnectionsSkipped: Scalars['Boolean'];
  fieldAgents: Array<FieldAgent>;
  metrcImportTask?: Maybe<MetrcImportTask>;
  metrcImportBatches: Array<MetrcSiteImportBatch>;
  harvestGroups: Array<HarvestGroup>;
  harvestGroupAutoCreationConfig?: Maybe<HarvestGroupAutoCreationConfig>;
  budFormFactors: Array<BudFormFactor>;
  zones: Array<Zone>;
  locations: Array<Location>;
  generationrequestSet: Array<GenerationRequestType>;
  authorizedUsers: Array<UserProfile>;
  sensorBrands?: Maybe<Array<Maybe<SiteSensorBrand>>>;
  sensorCredentials?: Maybe<Array<Maybe<SensorIntegrationCredential>>>;
  fieldSurveys?: Maybe<Array<Maybe<FieldSurvey>>>;
  checklistSessions: Array<ChecklistSession>;
  enabledChecklistTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  sensorImportTask?: Maybe<SensorImportTask>;
  metrcLicenses?: Maybe<Array<Maybe<OrganizationSiteMetrcLicense>>>;
  metrcLicenseRelationships?: Maybe<Array<Maybe<OrganizationMetrcLicenseRelationship>>>;
  latestMetrcImportBatch?: Maybe<MetrcSiteImportBatch>;
  hasConfiguredSensors?: Maybe<Scalars['Boolean']>;
  hasEnvironmentalData?: Maybe<Scalars['Boolean']>;
  importedHarvestGroupCount?: Maybe<Scalars['Int']>;
};

export enum OrganizationSiteAsyncImportStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type OrganizationSiteMetrcLicense = {
  __typename?: 'OrganizationSiteMetrcLicense';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  site: OrganizationSite;
  orgMetrcLicense?: Maybe<OrganizationMetrcLicense>;
  licenseNumber: Scalars['String'];
  userKey: Scalars['String'];
  metrcState: OrganizationSiteMetrcLicenseMetrcState;
  licenseType?: Maybe<Scalars['String']>;
  canGrowPlants?: Maybe<Scalars['Boolean']>;
  facilityType: Scalars['JSONString'];
  isActive: Scalars['Boolean'];
  validationStatus: OrganizationSiteMetrcLicenseValidationStatus;
  validationError: Scalars['String'];
  importTasks: Array<MetrcLicenseImportTask>;
  sourceMetrcLicenseRelationships: Array<OrganizationMetrcLicenseRelationship>;
  latestImportStatus?: Maybe<Scalars['String']>;
  latestImportStartedAt?: Maybe<Scalars['DateTime']>;
  latestImportCompletedAt?: Maybe<Scalars['DateTime']>;
};

export enum OrganizationSiteMetrcLicenseMetrcState {
  Al = 'AL',
  Ak = 'AK',
  Dc = 'DC',
  Ca = 'CA',
  Co = 'CO',
  Il = 'IL',
  Ky = 'KY',
  La = 'LA',
  Me = 'ME',
  Md = 'MD',
  Ma = 'MA',
  Mi = 'MI',
  Mn = 'MN',
  Ms = 'MS',
  Mt = 'MT',
  Nj = 'NJ',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR'
}

export enum OrganizationSiteMetrcLicenseValidationStatus {
  Pending = 'PENDING',
  Valid = 'VALID',
  Invalid = 'INVALID'
}

export enum OrganizationSiteMetrcPackageYieldStrategy {
  Legacy = 'LEGACY',
  ProductDescendants = 'PRODUCT_DESCENDANTS'
}

export enum OrganizationSiteMetrcRoomNormalizationStrategy {
  None = 'NONE',
  BayTable = 'BAY_TABLE'
}

export enum OrganizationSiteMetrcState {
  Al = 'AL',
  Ak = 'AK',
  Dc = 'DC',
  Ca = 'CA',
  Co = 'CO',
  Il = 'IL',
  Ky = 'KY',
  La = 'LA',
  Me = 'ME',
  Md = 'MD',
  Ma = 'MA',
  Mi = 'MI',
  Mn = 'MN',
  Ms = 'MS',
  Mt = 'MT',
  Nj = 'NJ',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR'
}

export enum OrganizationSitePreferredYieldSource {
  Auto = 'AUTO',
  Normal = 'NORMAL',
  Xfer = 'XFER'
}

export type OrganizationSiteResult = OrganizationSite | Error;

export enum OrganizationTrialAccount {
  Faven = 'FAVEN',
  Hgv = 'HGV',
  Other = 'OTHER'
}

export type PagingInfo = {
  __typename?: 'PagingInfo';
  totalCount: Scalars['Int'];
  unfilteredCount: Scalars['Int'];
  pageCount: Scalars['Int'];
  ordering: Scalars['String'];
  start: Scalars['Int'];
  size: Scalars['Int'];
  page: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
};

export type PagingInput = {
  start?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  ordering?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};

export type PaperlyticsFilterSetInput = {
  harvestGroupId?: Maybe<Scalars['String']>;
};

export type PaperlyticsImage = {
  __typename?: 'PaperlyticsImage';
  id: Scalars['UUID'];
  imageUpload?: Maybe<Scalars['String']>;
  organization: Organization;
  startedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  uploadedBy?: Maybe<UserProfile>;
  success: Scalars['Boolean'];
  targetType?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['JSONString']>;
  accuracyScore?: Maybe<Scalars['Int']>;
  issuesList?: Maybe<Scalars['JSONString']>;
  harvestGroup?: Maybe<HarvestGroup>;
  harvestGroupId: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
};

export type PaperlyticsImageResult = PaperlyticsImage | Error;

export type PasswordResetResult = PasswordResetSuccess | Error;

export type PasswordResetSuccess = {
  __typename?: 'PasswordResetSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type Permission = {
  __typename?: 'Permission';
  name: Scalars['String'];
};

export type PostHarvestTaskChecklist = {
  __typename?: 'PostHarvestTaskChecklist';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklistSession: ChecklistSession;
  inspector?: Maybe<UserProfile>;
  zone?: Maybe<Zone>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['GenericScalar']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  zerotolSprayHallways?: Maybe<Scalars['Boolean']>;
  zerotolSprayHallwaysNote?: Maybe<Scalars['String']>;
  cleanTablesGutters?: Maybe<Scalars['Boolean']>;
  cleanTablesGuttersNote?: Maybe<Scalars['String']>;
  cleanMainFloorDrain?: Maybe<Scalars['Boolean']>;
  cleanMainFloorDrainNote?: Maybe<Scalars['String']>;
  cleanRackAndFloorFans?: Maybe<Scalars['Boolean']>;
  cleanRackAndFloorFansNote?: Maybe<Scalars['String']>;
  greencleanAcidFlushLines?: Maybe<Scalars['Boolean']>;
  greencleanAcidFlushLinesNote?: Maybe<Scalars['String']>;
  flushAcidWithZerotolThenRo?: Maybe<Scalars['Boolean']>;
  flushAcidWithZerotolThenRoNote?: Maybe<Scalars['String']>;
  replaceAcAndDehuFilters?: Maybe<Scalars['Boolean']>;
  replaceAcAndDehuFiltersNote?: Maybe<Scalars['String']>;
  blowOutDehuDrainLines?: Maybe<Scalars['Boolean']>;
  blowOutDehuDrainLinesNote?: Maybe<Scalars['String']>;
  replaceFeedingLinesDrippersIfNeeded?: Maybe<Scalars['Boolean']>;
  replaceFeedingLinesDrippersIfNeededNote?: Maybe<Scalars['String']>;
};

export type PostHarvestTaskChecklistInput = {
  checklistSessionId: Scalars['ID'];
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  zerotolSprayHallways?: Maybe<Scalars['Boolean']>;
  zerotolSprayHallwaysNote?: Maybe<Scalars['String']>;
  cleanTablesGutters?: Maybe<Scalars['Boolean']>;
  cleanTablesGuttersNote?: Maybe<Scalars['String']>;
  cleanMainFloorDrain?: Maybe<Scalars['Boolean']>;
  cleanMainFloorDrainNote?: Maybe<Scalars['String']>;
  cleanRackAndFloorFans?: Maybe<Scalars['Boolean']>;
  cleanRackAndFloorFansNote?: Maybe<Scalars['String']>;
  greencleanAcidFlushLines?: Maybe<Scalars['Boolean']>;
  greencleanAcidFlushLinesNote?: Maybe<Scalars['String']>;
  flushAcidWithZerotolThenRo?: Maybe<Scalars['Boolean']>;
  flushAcidWithZerotolThenRoNote?: Maybe<Scalars['String']>;
  replaceAcAndDehuFilters?: Maybe<Scalars['Boolean']>;
  replaceAcAndDehuFiltersNote?: Maybe<Scalars['String']>;
  blowOutDehuDrainLines?: Maybe<Scalars['Boolean']>;
  blowOutDehuDrainLinesNote?: Maybe<Scalars['String']>;
  replaceFeedingLinesDrippersIfNeeded?: Maybe<Scalars['Boolean']>;
  replaceFeedingLinesDrippersIfNeededNote?: Maybe<Scalars['String']>;
};

export type PostHarvestTaskChecklistResult = PostHarvestTaskChecklist | Error;

export type PreHarvestTaskChecklist = {
  __typename?: 'PreHarvestTaskChecklist';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklistSession: ChecklistSession;
  inspector?: Maybe<UserProfile>;
  zone?: Maybe<Zone>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['GenericScalar']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  pullAroyaSensors?: Maybe<Scalars['Boolean']>;
  pullAroyaSensorsNote?: Maybe<Scalars['String']>;
  cutLowestLayerOfTrellis?: Maybe<Scalars['Boolean']>;
  cutLowestLayerOfTrellisNote?: Maybe<Scalars['String']>;
  flowerBinsClean?: Maybe<Scalars['Boolean']>;
  flowerBinsCleanNote?: Maybe<Scalars['String']>;
  writeFlowerBinLabels?: Maybe<Scalars['Boolean']>;
  writeFlowerBinLabelsNote?: Maybe<Scalars['String']>;
  dryRoomClean?: Maybe<Scalars['Boolean']>;
  dryRoomCleanNote?: Maybe<Scalars['String']>;
};

export type PreHarvestTaskChecklistInput = {
  checklistSessionId: Scalars['ID'];
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  pullAroyaSensors?: Maybe<Scalars['Boolean']>;
  pullAroyaSensorsNote?: Maybe<Scalars['String']>;
  cutLowestLayerOfTrellis?: Maybe<Scalars['Boolean']>;
  cutLowestLayerOfTrellisNote?: Maybe<Scalars['String']>;
  flowerBinsClean?: Maybe<Scalars['Boolean']>;
  flowerBinsCleanNote?: Maybe<Scalars['String']>;
  writeFlowerBinLabels?: Maybe<Scalars['Boolean']>;
  writeFlowerBinLabelsNote?: Maybe<Scalars['String']>;
  dryRoomClean?: Maybe<Scalars['Boolean']>;
  dryRoomCleanNote?: Maybe<Scalars['String']>;
};

export type PreHarvestTaskChecklistResult = PreHarvestTaskChecklist | Error;

export type ProcessEnvironmentalFileInput = {
  fileId: Scalars['String'];
};

export type ProcessingGroup = {
  __typename?: 'ProcessingGroup';
  id: Scalars['String'];
  archivedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  shortName?: Maybe<Scalars['String']>;
  status: ProcessingGroupStatus;
  startDate?: Maybe<Scalars['Date']>;
  createdBy: UserProfile;
  colorHexCode?: Maybe<Scalars['String']>;
  processingGroupTemplateVersion?: Maybe<ProcessingGroupTemplateVersion>;
  fromHarvestGroup?: Maybe<HarvestGroup>;
  processingGroupStrains: Array<ProcessingGroupStrain>;
  processingGroupStages: Array<ProcessingGroupStage>;
  stages?: Maybe<Array<ProcessingGroupStage>>;
  strains?: Maybe<Array<ProcessingGroupStrain>>;
  latestStage?: Maybe<ProcessingGroupStage>;
  processingGroupStrainStages: Array<ProcessingGroupStrainStage>;
  inUnfinishedJobs?: Maybe<Scalars['GenericScalar']>;
};


export type ProcessingGroupProcessingGroupStrainsArgs = {
  strainId?: Maybe<Scalars['String']>;
};


export type ProcessingGroupProcessingGroupStrainStagesArgs = {
  strainId?: Maybe<Scalars['String']>;
};


export type ProcessingGroupInUnfinishedJobsArgs = {
  strainId?: Maybe<Scalars['String']>;
};

export type ProcessingGroupFilterSetInput = {
  createdAt_Gt?: Maybe<Scalars['DateTime']>;
  createdAt_Lt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  unarchived?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
};

export type ProcessingGroupResult = ProcessingGroup | Error;

export type ProcessingGroupStage = {
  __typename?: 'ProcessingGroupStage';
  id: Scalars['UUID'];
  name: Scalars['String'];
  status: ProcessingGroupStageStatus;
  processingGroup: ProcessingGroup;
  processingStageTemplate: ProcessingStageTemplate;
  startDate: Scalars['Date'];
  endDate?: Maybe<Scalars['Date']>;
  progressScope: ProcessingGroupStageProgressScope;
  schedulingScope: ProcessingGroupStageSchedulingScope;
  totalInputGrams?: Maybe<Scalars['GenericScalar']>;
  totalOutputGrams?: Maybe<Scalars['GenericScalar']>;
  totalPendingGrams?: Maybe<Scalars['GenericScalar']>;
  totalPartialGrams?: Maybe<Scalars['GenericScalar']>;
  summary: ProcessingGroupStrainStageSummary;
  jobs?: Maybe<Array<ProcessingJob>>;
  processingGroupId: Scalars['ID'];
};

export enum ProcessingGroupStageProgressScope {
  Simple = 'SIMPLE',
  ByWeight = 'BY_WEIGHT',
  ByDays = 'BY_DAYS'
}

export enum ProcessingGroupStageSchedulingScope {
  StrainsTogether = 'STRAINS_TOGETHER',
  StrainsIndependent = 'STRAINS_INDEPENDENT'
}

export enum ProcessingGroupStageStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE'
}

export enum ProcessingGroupStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE'
}

export type ProcessingGroupStrain = {
  __typename?: 'ProcessingGroupStrain';
  id: Scalars['UUID'];
  status: ProcessingGroupStrainStatus;
  processingGroup: ProcessingGroup;
  strain: Strain;
  orderInProcess?: Maybe<Scalars['Int']>;
  inventoryGrams?: Maybe<Scalars['GenericScalar']>;
  totalInputGrams?: Maybe<Scalars['GenericScalar']>;
  totalOutputGrams?: Maybe<Scalars['GenericScalar']>;
  totalPendingGrams?: Maybe<Scalars['GenericScalar']>;
  totalPartialGrams?: Maybe<Scalars['GenericScalar']>;
  totalAdjustmentGrams?: Maybe<Scalars['GenericScalar']>;
  inventoryAdjustments: Array<ProcessingGroupStrainInventoryAdjustment>;
};

export type ProcessingGroupStrainInventoryAdjustment = {
  __typename?: 'ProcessingGroupStrainInventoryAdjustment';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  processingGroupStrain: ProcessingGroupStrain;
  adjustmentGrams?: Maybe<Scalars['GenericScalar']>;
  description: Scalars['String'];
  createdBy: UserProfile;
};

export type ProcessingGroupStrainResult = ProcessingGroupStrain | Error;

export type ProcessingGroupStrainStage = {
  __typename?: 'ProcessingGroupStrainStage';
  id: Scalars['UUID'];
  name: Scalars['String'];
  status: ProcessingGroupStrainStageStatus;
  stage: ProcessingGroupStage;
  processingGroupStrain: ProcessingGroupStrain;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  totalInputGrams?: Maybe<Scalars['GenericScalar']>;
  totalOutputGrams?: Maybe<Scalars['GenericScalar']>;
  totalPendingGrams?: Maybe<Scalars['GenericScalar']>;
  totalPartialGrams?: Maybe<Scalars['GenericScalar']>;
  processingJobs: Array<ProcessingJob>;
  summary: ProcessingGroupStrainStageSummary;
};

export enum ProcessingGroupStrainStageStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE'
}

export type ProcessingGroupStrainStageSummary = {
  __typename?: 'ProcessingGroupStrainStageSummary';
  progressPercent: Scalars['Float'];
  daysElapsed: Scalars['Int'];
  numDays?: Maybe<Scalars['Int']>;
  weightCompletedGrams: Scalars['Float'];
  weightTotalGrams: Scalars['Float'];
  remainingInventoryGrams: Scalars['Float'];
};

export enum ProcessingGroupStrainStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE'
}

export type ProcessingGroupTemplate = {
  __typename?: 'ProcessingGroupTemplate';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  archivedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  activeTemplateVersion?: Maybe<ProcessingGroupTemplateVersion>;
  processingGroupTemplateVersions: Array<ProcessingGroupTemplateVersion>;
};

export type ProcessingGroupTemplateFilterSetInput = {
  id?: Maybe<Scalars['String']>;
  unarchived?: Maybe<Scalars['String']>;
};

export type ProcessingGroupTemplateResult = ProcessingGroupTemplate | Error;

export type ProcessingGroupTemplateVersion = {
  __typename?: 'ProcessingGroupTemplateVersion';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  version: Scalars['Int'];
  processingGroupTemplate?: Maybe<ProcessingGroupTemplate>;
  processinggroupSet: Array<ProcessingGroup>;
  processingStageTemplates: Array<ProcessingStageTemplate>;
  activeForTemplates: Array<ProcessingGroupTemplate>;
};

export type ProcessingJob = {
  __typename?: 'ProcessingJob';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  strainStage: ProcessingGroupStrainStage;
  jobStatus: ProcessingJobJobStatus;
  createdBy: UserProfile;
  assignee?: Maybe<UserProfile>;
  totalWorkedMinutes: Scalars['Decimal'];
  inputType: BudFormFactor;
  inputGrams: Scalars['Decimal'];
  dontTrackUserGpm?: Maybe<Scalars['Boolean']>;
  totalOutputGrams?: Maybe<Scalars['GenericScalar']>;
  processingJobLogs: Array<ProcessingJobLog>;
  startedAt?: Maybe<Scalars['DateTime']>;
};

export type ProcessingJobFilterSetInput = {
  strainStage_Stage_ProcessingGroup_ArchivedAt_Isnull?: Maybe<Scalars['Boolean']>;
  strainStage_Stage_ProcessingGroupId?: Maybe<Scalars['String']>;
  strainStage_Stage_ProcessingStageTemplateId?: Maybe<Scalars['String']>;
  strainStage_StageId?: Maybe<Scalars['String']>;
  strainStage_Stage_ProcessingStageTemplate_TrackPerformance?: Maybe<Scalars['Boolean']>;
  strainStage_ProcessingGroupStrainId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};

export enum ProcessingJobJobStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Complete = 'COMPLETE'
}

export type ProcessingJobLog = {
  __typename?: 'ProcessingJobLog';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  job: ProcessingJob;
  logType: ProcessingJobLogLogType;
  startedAt: Scalars['DateTime'];
  endedAt: Scalars['DateTime'];
  breakMinutes: Scalars['Int'];
  workedMinutes: Scalars['Decimal'];
  leftoverInputGrams?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<UserProfile>;
  performer?: Maybe<UserProfile>;
  outputGrams?: Maybe<Scalars['GenericScalar']>;
};

export enum ProcessingJobLogLogType {
  Created = 'CREATED',
  PartialLog = 'PARTIAL_LOG',
  Completed = 'COMPLETED',
  Skipped = 'SKIPPED'
}

export type ProcessingJobLogResult = ProcessingJobLog | Error;

export type ProcessingJobResult = ProcessingJob | Error;

export type ProcessingStageTemplate = {
  __typename?: 'ProcessingStageTemplate';
  id: Scalars['UUID'];
  name: Scalars['String'];
  numberOfDays: Scalars['Int'];
  createdStageName?: Maybe<Scalars['String']>;
  trackPerformance: Scalars['Boolean'];
  processingGroupTemplateVersion: ProcessingGroupTemplateVersion;
  orderInProcess: Scalars['Int'];
  progressScope: ProcessingStageTemplateProgressScope;
  schedulingScope: ProcessingStageTemplateSchedulingScope;
  inputTypes: Array<BudFormFactor>;
  outputTypes: Array<BudFormFactor>;
};

export enum ProcessingStageTemplateProgressScope {
  Simple = 'SIMPLE',
  ByWeight = 'BY_WEIGHT',
  ByDays = 'BY_DAYS'
}

export enum ProcessingStageTemplateSchedulingScope {
  StrainsTogether = 'STRAINS_TOGETHER',
  StrainsIndependent = 'STRAINS_INDEPENDENT'
}

export type PruningDefolTaskChecklist = {
  __typename?: 'PruningDefolTaskChecklist';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklistSession: ChecklistSession;
  inspector?: Maybe<UserProfile>;
  zone?: Maybe<Zone>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['GenericScalar']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  prepPrunersTrashBagsBuckets?: Maybe<Scalars['Boolean']>;
  prepPrunersTrashBagsBucketsNote?: Maybe<Scalars['String']>;
  sanitizeUsedEquipmentBuckets?: Maybe<Scalars['Boolean']>;
  sanitizeUsedEquipmentBucketsNote?: Maybe<Scalars['String']>;
  putTablesBackInPlace?: Maybe<Scalars['Boolean']>;
  putTablesBackInPlaceNote?: Maybe<Scalars['String']>;
  logWasteWeights?: Maybe<Scalars['Boolean']>;
  logWasteWeightsNote?: Maybe<Scalars['String']>;
};

export type PruningDefolTaskChecklistInput = {
  checklistSessionId: Scalars['ID'];
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  prepPrunersTrashBagsBuckets?: Maybe<Scalars['Boolean']>;
  prepPrunersTrashBagsBucketsNote?: Maybe<Scalars['String']>;
  sanitizeUsedEquipmentBuckets?: Maybe<Scalars['Boolean']>;
  sanitizeUsedEquipmentBucketsNote?: Maybe<Scalars['String']>;
  putTablesBackInPlace?: Maybe<Scalars['Boolean']>;
  putTablesBackInPlaceNote?: Maybe<Scalars['String']>;
  logWasteWeights?: Maybe<Scalars['Boolean']>;
  logWasteWeightsNote?: Maybe<Scalars['String']>;
};

export type PruningDefolTaskChecklistResult = PruningDefolTaskChecklist | Error;

export type Query = {
  __typename?: 'Query';
  clientAiBootstrap: ClientAiBootstrap;
  clientAiDocument?: Maybe<ClientAiDocument>;
  harvestEnvironmentalReportCard: ReportResult;
  harvestDateWindowReport: ReportResult;
  sensorCoverageReport: ReportResult;
  siteYieldRollupReport: ReportResult;
  financialDashboardInputs: ReportResult;
  strainComparisonReport: ReportResult;
  metrcReadinessReport: ReportResult;
  morningGrowerReport: ReportResult;
  weeklyCultivationReviewReport: ReportResult;
  harvestForecastReport: ReportResult;
  harvestAnalysisReport: ReportResult;
  strainPerformanceReport: ReportResult;
  harvestBenchmarkReport: ReportResult;
  comprehensiveCultivationReport: ReportResult;
  harvestAnalysisDetailReport: ReportResult;
  harvestAnalysisInsightsReport: ReportResult;
  financeWorkspace: Scalars['GenericScalar'];
  financeMappings: Scalars['GenericScalar'];
  financeImports: Scalars['GenericScalar'];
  financeMonthlyPnl: Scalars['GenericScalar'];
  calendarBranches?: Maybe<Array<CalendarBranch>>;
  calendarBranch: CalendarBranch;
  calendarBranchMergeLogEntries?: Maybe<Array<CalendarBranchMergeLogEntry>>;
  processingGroups?: Maybe<Array<ProcessingGroup>>;
  processingGroup?: Maybe<ProcessingGroup>;
  processingGroupTemplates?: Maybe<Array<ProcessingGroupTemplate>>;
  processingGroupTemplate?: Maybe<ProcessingGroupTemplate>;
  processingGroupTemplateVersion?: Maybe<ProcessingGroupTemplateVersion>;
  processingJobs?: Maybe<Array<ProcessingJob>>;
  processingJob?: Maybe<ProcessingJob>;
  processingGroupStrainStage?: Maybe<ProcessingGroupStrainStage>;
  groupEnvironmentalAnalysis: GroupEnvironmentalAnalysis;
  telemetryRooms?: Maybe<Array<Zone>>;
  roomTelemetry: RoomTelemetry;
  harvestForecastYieldHistory?: Maybe<Array<HarvestStrainYield>>;
  harvestGroups?: Maybe<Array<HarvestGroup>>;
  completedHarvestGroupsPaginated?: Maybe<HarvestGroupQuerysetResult>;
  harvestGroup: HarvestGroup;
  harvestGroupTemplates?: Maybe<Array<HarvestGroupTemplate>>;
  harvestGroupAutoCreationConfigs?: Maybe<Array<HarvestGroupAutoCreationConfig>>;
  harvestGroupAutoCreationConfig?: Maybe<HarvestGroupAutoCreationConfig>;
  staffHarvestGroupTemplates?: Maybe<Array<HarvestGroupTemplate>>;
  harvestGroupTemplate: HarvestGroupTemplate;
  harvestGroupsWithTemplate?: Maybe<Array<HarvestGroup>>;
  budFormFactors?: Maybe<Array<BudFormFactor>>;
  zones?: Maybe<Array<Zone>>;
  salesManagerZones?: Maybe<Array<Zone>>;
  acBrands?: Maybe<Array<AcBrand>>;
  lightingTypeBrands?: Maybe<Array<LightingTypeBrand>>;
  circulatingFanBrands?: Maybe<Array<CirculatingFanBrand>>;
  dehumidifierBrands?: Maybe<Array<DehumidifierBrand>>;
  sensors?: Maybe<Array<Sensors>>;
  underCanopyBrands?: Maybe<Array<UnderCanopyBrand>>;
  growingMedias?: Maybe<Array<GrowingMedia>>;
  rockwoolBrands?: Maybe<Array<RockwoolBrand>>;
  rockwoolSizes?: Maybe<Array<RockwoolSize>>;
  cocoBrands?: Maybe<Array<CocoBrand>>;
  soilBrands?: Maybe<Array<SoilBrand>>;
  irrigationStyles?: Maybe<Array<IrrigationStyle>>;
  irrigationFrequencies?: Maybe<Array<IrrigationFrequency>>;
  irrigationTypes?: Maybe<Array<IrrigationType>>;
  harvestSummary?: Maybe<HarvestSummary>;
  controlSystems?: Maybe<Array<ControlSystem>>;
  cultivationStyles?: Maybe<Array<CultivationStyle>>;
  strains?: Maybe<Array<Strain>>;
  recipes?: Maybe<Array<Recipe>>;
  recipe: Recipe;
  recipeComponents?: Maybe<Array<RecipeComponent>>;
  nutrients?: Maybe<Array<Nutrient>>;
  locations?: Maybe<Array<Location>>;
  equipments?: Maybe<Array<Equipment>>;
  equipment: Equipment;
  tags?: Maybe<Array<Tag>>;
  maintenanceRequests?: Maybe<Array<MaintenanceRequest>>;
  strainPerformance: StrainPerformanceResult;
  environmentalFiles?: Maybe<Array<EnvironmentalFileType>>;
  environmentalFile: EnvironmentalFileType;
  environmentalAnalytics: EnvironmentalAnalyticsResult;
  environmentalWeeklyData?: Maybe<Array<WeeklyEnvironmentalData>>;
  paperlyticsImages?: Maybe<Array<PaperlyticsImage>>;
  generationRequests?: Maybe<Array<GenerationRequestType>>;
  generationRequest?: Maybe<GenerationRequestType>;
  bestYieldingStrains: BestYieldingStrainsResult;
  latestSensorCollection?: Maybe<SensorRunResult>;
  sensorCoverage?: Maybe<SensorCoverage>;
  myProfile?: Maybe<UserProfile>;
  apiKeys: Array<Maybe<ApiKey>>;
  staffOrganizations?: Maybe<Array<Maybe<Organization>>>;
  staffOrganization?: Maybe<Organization>;
  users?: Maybe<Array<Maybe<UserProfile>>>;
  checklistSessions?: Maybe<Array<Maybe<ChecklistSession>>>;
  checklistSessionsPaginated?: Maybe<ChecklistSessionQuerysetResult>;
  checklistSession?: Maybe<ChecklistSession>;
  roomWalkthroughChecklists?: Maybe<Array<Maybe<RoomWalkthroughChecklist>>>;
  organizationSites?: Maybe<Array<Maybe<OrganizationSite>>>;
  organizationSite?: Maybe<OrganizationSite>;
  fieldSurvey?: Maybe<FieldSurvey>;
  facilitySurvey?: Maybe<FacilitySurvey>;
  roomSurvey?: Maybe<RoomSurvey>;
  activeUsers?: Maybe<Array<Maybe<UserProfile>>>;
  roles?: Maybe<Array<Maybe<Role>>>;
  organizationRoles?: Maybe<Array<Maybe<Role>>>;
  toppingStyles?: Maybe<Array<Maybe<ToppingStyle>>>;
  environmentalTargetSets?: Maybe<Array<Maybe<EnvironmentalTargetSet>>>;
  verifyMetrcImport?: Maybe<VerifyMetrcImportOutput>;
  metrcImportOverviewV2?: Maybe<MetrcImportOverviewV2>;
  integrityEvents?: Maybe<IntegrityEventListResult>;
  integrityEventsPaginated?: Maybe<IntegrityEventQuerysetResult>;
  integrityEvent?: Maybe<IntegrityEvent>;
  integrityEventSummary?: Maybe<IntegrityEventSummary>;
  integrityEventCategoryCounts?: Maybe<Array<IntegrityCategoryCount>>;
  integrityEventWarningSummaries?: Maybe<Array<IntegrityWarningSummary>>;
  integrityEventSiteCounts?: Maybe<Array<IntegritySiteCount>>;
  metrcImportYieldBreakdown?: Maybe<MetrcOverviewYieldBreakdown>;
  metrcImportYieldPackageBreakdown?: Maybe<MetrcOverviewYieldPackageBreakdown>;
  metrcImportAnalytics?: Maybe<MetrcImportAnalyticsResult>;
  aroyaDeviceRequests?: Maybe<Array<Maybe<AroyaDeviceRequest>>>;
  growlinkDeviceRequests?: Maybe<Array<Maybe<GrowlinkDeviceRequest>>>;
  environmentalDevices?: Maybe<Array<Maybe<EnvironmentalDevice>>>;
  fieldAgents?: Maybe<Array<Maybe<FieldAgent>>>;
  fieldAgentDevices?: Maybe<Array<Maybe<FieldAgentDevice>>>;
  metrcImportDataOverview?: Maybe<MetrcDataOverviewOutput>;
};


export type QueryClientAiDocumentArgs = {
  slug: Scalars['String'];
};


export type QueryHarvestEnvironmentalReportCardArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  cursor?: Maybe<Scalars['String']>;
};


export type QueryHarvestDateWindowReportArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  cursor?: Maybe<Scalars['String']>;
};


export type QuerySensorCoverageReportArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  cursor?: Maybe<Scalars['String']>;
};


export type QuerySiteYieldRollupReportArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  cursor?: Maybe<Scalars['String']>;
};


export type QueryFinancialDashboardInputsArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  cursor?: Maybe<Scalars['String']>;
};


export type QueryStrainComparisonReportArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  cursor?: Maybe<Scalars['String']>;
};


export type QueryMetrcReadinessReportArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  cursor?: Maybe<Scalars['String']>;
};


export type QueryMorningGrowerReportArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  cursor?: Maybe<Scalars['String']>;
};


export type QueryWeeklyCultivationReviewReportArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  cursor?: Maybe<Scalars['String']>;
};


export type QueryHarvestForecastReportArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  cursor?: Maybe<Scalars['String']>;
};


export type QueryHarvestAnalysisReportArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  cursor?: Maybe<Scalars['String']>;
};


export type QueryStrainPerformanceReportArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  cursor?: Maybe<Scalars['String']>;
};


export type QueryHarvestBenchmarkReportArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  cursor?: Maybe<Scalars['String']>;
};


export type QueryComprehensiveCultivationReportArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  cursor?: Maybe<Scalars['String']>;
};


export type QueryHarvestAnalysisDetailReportArgs = {
  harvestGroupId: Scalars['ID'];
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};


export type QueryHarvestAnalysisInsightsReportArgs = {
  harvestGroupIds: Array<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};


export type QueryFinanceMonthlyPnlArgs = {
  month: Scalars['Date'];
};


export type QueryCalendarBranchesArgs = {
  filters?: Maybe<CalendarBranchFilterSetInput>;
};


export type QueryCalendarBranchArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QueryCalendarBranchMergeLogEntriesArgs = {
  filters?: Maybe<CalendarBranchMergeLogEntryFilterSetInput>;
};


export type QueryProcessingGroupsArgs = {
  filters?: Maybe<ProcessingGroupFilterSetInput>;
};


export type QueryProcessingGroupArgs = {
  id: Scalars['String'];
};


export type QueryProcessingGroupTemplatesArgs = {
  filters?: Maybe<ProcessingGroupTemplateFilterSetInput>;
};


export type QueryProcessingGroupTemplateArgs = {
  id: Scalars['String'];
};


export type QueryProcessingGroupTemplateVersionArgs = {
  id: Scalars['String'];
};


export type QueryProcessingJobsArgs = {
  filters?: Maybe<ProcessingJobFilterSetInput>;
};


export type QueryProcessingJobArgs = {
  id: Scalars['ID'];
};


export type QueryProcessingGroupStrainStageArgs = {
  id: Scalars['String'];
};


export type QueryGroupEnvironmentalAnalysisArgs = {
  groupId: Scalars['ID'];
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};


export type QueryTelemetryRoomsArgs = {
  siteId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
};


export type QueryRoomTelemetryArgs = {
  zoneId: Scalars['ID'];
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
};


export type QueryHarvestForecastYieldHistoryArgs = {
  siteId?: Maybe<Scalars['String']>;
};


export type QueryHarvestGroupsArgs = {
  filters?: Maybe<HarvestGroupFilterSetInput>;
  logEntryOptions?: Maybe<LogsFilterInput>;
};


export type QueryCompletedHarvestGroupsPaginatedArgs = {
  options?: Maybe<HarvestGroupQuerysetOptionsInput>;
};


export type QueryHarvestGroupArgs = {
  id: Scalars['String'];
};


export type QueryHarvestGroupTemplatesArgs = {
  filters?: Maybe<HarvestGroupTemplateFilterSetInput>;
};


export type QueryHarvestGroupAutoCreationConfigsArgs = {
  siteId?: Maybe<Scalars['String']>;
};


export type QueryHarvestGroupAutoCreationConfigArgs = {
  siteId: Scalars['String'];
};


export type QueryStaffHarvestGroupTemplatesArgs = {
  organizationId: Scalars['String'];
};


export type QueryHarvestGroupTemplateArgs = {
  id: Scalars['String'];
};


export type QueryHarvestGroupsWithTemplateArgs = {
  id: Scalars['String'];
};


export type QueryBudFormFactorsArgs = {
  filters?: Maybe<BudFormFactorFilterSetInput>;
};


export type QueryZonesArgs = {
  filters?: Maybe<ZoneFilterSetInput>;
};


export type QuerySalesManagerZonesArgs = {
  filters?: Maybe<SalesManagerZoneFilterSetInput>;
};


export type QueryHarvestSummaryArgs = {
  harvestGroupId: Scalars['String'];
};


export type QueryStrainsArgs = {
  filters?: Maybe<StrainFilterSetInput>;
};


export type QueryRecipesArgs = {
  filters?: Maybe<RecipeFilterSetInput>;
};


export type QueryRecipeArgs = {
  id: Scalars['String'];
};


export type QueryRecipeComponentsArgs = {
  filters?: Maybe<RecipeComponentFilterSetInput>;
};


export type QueryNutrientsArgs = {
  filters?: Maybe<NutrientFilterSetInput>;
};


export type QueryLocationsArgs = {
  filters?: Maybe<LocationFilterSetInput>;
};


export type QueryEquipmentsArgs = {
  filters?: Maybe<EquipmentFilterSetInput>;
};


export type QueryEquipmentArgs = {
  id: Scalars['String'];
};


export type QueryTagsArgs = {
  filters?: Maybe<TagFilterSetInput>;
};


export type QueryMaintenanceRequestsArgs = {
  filters?: Maybe<MaintenanceRequestFilterSetInput>;
};


export type QueryStrainPerformanceArgs = {
  strainId1: Scalars['String'];
  strainId2: Scalars['String'];
  strainId3: Scalars['String'];
  strainId4: Scalars['String'];
};


export type QueryEnvironmentalFilesArgs = {
  filters?: Maybe<EnvironmentalFileFilterSetInput>;
};


export type QueryEnvironmentalFileArgs = {
  id: Scalars['String'];
};


export type QueryEnvironmentalAnalyticsArgs = {
  filters?: Maybe<EnvironmentalAnalyticsFilterInput>;
};


export type QueryEnvironmentalWeeklyDataArgs = {
  harvestGroupId: Scalars['ID'];
};


export type QueryPaperlyticsImagesArgs = {
  filters?: Maybe<PaperlyticsFilterSetInput>;
};


export type QueryGenerationRequestsArgs = {
  filters?: Maybe<GenerationRequestFilterSetInput>;
};


export type QueryGenerationRequestArgs = {
  id: Scalars['String'];
};


export type QueryBestYieldingStrainsArgs = {
  limit?: Maybe<Scalars['Int']>;
  minHarvests?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  siteId?: Maybe<Scalars['String']>;
  productStream?: Maybe<YieldProductStream>;
  includeOpenHarvests?: Maybe<Scalars['Boolean']>;
};


export type QueryLatestSensorCollectionArgs = {
  siteId: Scalars['ID'];
  brand: Scalars['String'];
};


export type QuerySensorCoverageArgs = {
  siteId: Scalars['ID'];
  start: Scalars['Date'];
  end: Scalars['Date'];
  brand?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['ID']>;
  outcomes?: Maybe<Array<Maybe<Scalars['String']>>>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};


export type QueryStaffOrganizationsArgs = {
  filters?: Maybe<OrganizationFilterSetInput>;
};


export type QueryStaffOrganizationArgs = {
  id: Scalars['String'];
};


export type QueryUsersArgs = {
  filters?: Maybe<UserFilterSetInput>;
};


export type QueryChecklistSessionsArgs = {
  organizationId: Scalars['ID'];
  siteId?: Maybe<Scalars['ID']>;
};


export type QueryChecklistSessionsPaginatedArgs = {
  options?: Maybe<ChecklistSessionQuerysetOptionsInput>;
};


export type QueryChecklistSessionArgs = {
  id: Scalars['ID'];
};


export type QueryRoomWalkthroughChecklistsArgs = {
  checklistSessionId: Scalars['ID'];
};


export type QueryOrganizationSiteArgs = {
  id: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
};


export type QueryFieldSurveyArgs = {
  id: Scalars['String'];
};


export type QueryFacilitySurveyArgs = {
  id: Scalars['String'];
};


export type QueryRoomSurveyArgs = {
  id: Scalars['String'];
  zoneId: Scalars['String'];
};


export type QueryActiveUsersArgs = {
  filters?: Maybe<ActiveUserFilterSetInput>;
};


export type QueryRolesArgs = {
  filters?: Maybe<RoleFilterSetInput>;
};


export type QueryOrganizationRolesArgs = {
  organizationId: Scalars['String'];
};


export type QueryToppingStylesArgs = {
  filters?: Maybe<ToppingStyleFilterSetInput>;
};


export type QueryEnvironmentalTargetSetsArgs = {
  organizationId: Scalars['ID'];
};


export type QueryVerifyMetrcImportArgs = {
  siteId: Scalars['ID'];
};


export type QueryMetrcImportOverviewV2Args = {
  siteId: Scalars['ID'];
};


export type QueryIntegrityEventsArgs = {
  siteId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Scalars['String']>>;
  severities?: Maybe<Array<Scalars['String']>>;
  since?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type QueryIntegrityEventsPaginatedArgs = {
  options?: Maybe<IntegrityEventQuerysetOptionsInput>;
};


export type QueryIntegrityEventArgs = {
  id: Scalars['ID'];
};


export type QueryIntegrityEventSummaryArgs = {
  siteId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
};


export type QueryIntegrityEventCategoryCountsArgs = {
  siteId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
};


export type QueryIntegrityEventWarningSummariesArgs = {
  siteId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
  days?: Maybe<Scalars['Int']>;
};


export type QueryIntegrityEventSiteCountsArgs = {
  organizationId?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
};


export type QueryMetrcImportYieldBreakdownArgs = {
  proposedGroupId: Scalars['ID'];
};


export type QueryMetrcImportYieldPackageBreakdownArgs = {
  proposedGroupId: Scalars['ID'];
  bucketKind: Scalars['String'];
  bucketKey: Scalars['String'];
};


export type QueryMetrcImportAnalyticsArgs = {
  siteId: Scalars['ID'];
};


export type QueryAroyaDeviceRequestsArgs = {
  organizationId: Scalars['ID'];
  credentialId?: Maybe<Scalars['ID']>;
};


export type QueryGrowlinkDeviceRequestsArgs = {
  organizationId: Scalars['ID'];
  credentialId?: Maybe<Scalars['ID']>;
};


export type QueryEnvironmentalDevicesArgs = {
  zoneId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
};


export type QueryFieldAgentsArgs = {
  siteId?: Maybe<Scalars['ID']>;
};


export type QueryFieldAgentDevicesArgs = {
  fieldAgentId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  unmappedOnly?: Maybe<Scalars['Boolean']>;
};


export type QueryMetrcImportDataOverviewArgs = {
  siteId: Scalars['ID'];
};

export type ReassignDeviceZoneInput = {
  deviceId: Scalars['ID'];
  zoneId: Scalars['ID'];
};

export type Recipe = {
  __typename?: 'Recipe';
  id: Scalars['UUID'];
  name: Scalars['String'];
  applicationType: RecipeApplicationType;
  ec?: Maybe<Scalars['Decimal']>;
  ph?: Maybe<Scalars['Decimal']>;
  createdBy: UserProfile;
  active: Scalars['Boolean'];
  components: Array<RecipeComponent>;
};

export enum RecipeApplicationType {
  Foliar = 'FOLIAR',
  Irrigation = 'IRRIGATION'
}

export type RecipeComponent = {
  __typename?: 'RecipeComponent';
  id: Scalars['UUID'];
  nutrient: Nutrient;
  volume: Scalars['Decimal'];
  unitOfMeasure: RecipeComponentUnitOfMeasure;
  assignedRecipe: Recipe;
};

export type RecipeComponentFilterSetInput = {
  id?: Maybe<Scalars['String']>;
};

export enum RecipeComponentUnitOfMeasure {
  MillilitersPerGallon = 'MILLILITERS_PER_GALLON',
  GramsPerGallon = 'GRAMS_PER_GALLON'
}

export type RecipeFilterSetInput = {
  active?: Maybe<Scalars['Boolean']>;
  applicationType?: Maybe<Scalars['String']>;
};

export type RecipeResult = Recipe | Error;

export type RefreshMetrcDataInput = {
  siteId: Scalars['ID'];
};

export type RefreshSiteAroyaDeviceRequestsInput = {
  siteId: Scalars['ID'];
};

export type RefreshSiteAroyaDeviceRequestsResult = {
  __typename?: 'RefreshSiteAroyaDeviceRequestsResult';
  devices?: Maybe<Array<Maybe<AroyaDevice>>>;
  error?: Maybe<Scalars['String']>;
};

export type RefreshSiteGrowlinkDeviceRequestsInput = {
  siteId: Scalars['ID'];
};

export type RefreshSiteGrowlinkDeviceRequestsResult = {
  __typename?: 'RefreshSiteGrowlinkDeviceRequestsResult';
  devices?: Maybe<Array<Maybe<GrowlinkDevice>>>;
  error?: Maybe<Scalars['String']>;
};

export type ReorderBudFormFactorsInput = {
  id: Scalars['ID'];
  direction?: Maybe<Scalars['String']>;
};

export type ReportBatchExclusion = {
  __typename?: 'ReportBatchExclusion';
  groupName?: Maybe<Scalars['String']>;
  metrcHarvestName?: Maybe<Scalars['String']>;
  linkedHarvests?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  harvestGroupId?: Maybe<Scalars['ID']>;
  groupDate?: Maybe<Scalars['Date']>;
  harvestDate?: Maybe<Scalars['Date']>;
  siteName?: Maybe<Scalars['String']>;
  strainId?: Maybe<Scalars['ID']>;
  strainName?: Maybe<Scalars['String']>;
  issues: Array<Scalars['String']>;
};

export type ReportMetadata = {
  __typename?: 'ReportMetadata';
  report: Scalars['String'];
  organizationId: Scalars['ID'];
  organizationName: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  generatedAt: Scalars['DateTime'];
  reportVersion: Scalars['String'];
  instructionsVersion: Scalars['String'];
  targetSource: Scalars['String'];
};

export type ReportMetric = {
  __typename?: 'ReportMetric';
  name: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
  unit: Scalars['String'];
  formatted?: Maybe<Scalars['String']>;
};

export type ReportResult = {
  __typename?: 'ReportResult';
  excludedBatches?: Maybe<Array<ReportBatchExclusion>>;
  metadata: ReportMetadata;
  metrics: Array<Maybe<ReportMetric>>;
  rows: Array<Maybe<ReportRow>>;
  relatedRows: Array<Maybe<ReportRow>>;
  dataQuality: Array<Maybe<DataQualityFinding>>;
  caveats: Array<Maybe<Scalars['String']>>;
  truncated: Scalars['Boolean'];
  continuationCursor?: Maybe<Scalars['String']>;
};

export type ReportRow = {
  __typename?: 'ReportRow';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['ID']>;
  siteName?: Maybe<Scalars['String']>;
  zoneId?: Maybe<Scalars['ID']>;
  zoneName?: Maybe<Scalars['String']>;
  strainId?: Maybe<Scalars['ID']>;
  strainName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
  flowerStartDate?: Maybe<Scalars['Date']>;
  status?: Maybe<Scalars['String']>;
  metrics: Array<Maybe<ReportMetric>>;
};

export type ResolveIntegrityEventInput = {
  eventId: Scalars['ID'];
  action: Scalars['String'];
  payload?: Maybe<Scalars['GenericScalar']>;
  rerunMode?: Maybe<Scalars['String']>;
};

export type ResolveIntegrityEventPayload = {
  __typename?: 'ResolveIntegrityEventPayload';
  event?: Maybe<IntegrityEvent>;
  createdSideEffects: Array<IntegritySideEffect>;
  queuedTask?: Maybe<IntegrityQueuedTask>;
  errors: Array<Scalars['String']>;
};

export type ResolveMaintenanceRequestInput = {
  maintenanceRequestId: Scalars['ID'];
  resolvedAt: Scalars['Date'];
  notes?: Maybe<Scalars['String']>;
};

export type RevokeApiKeyInput = {
  id: Scalars['ID'];
};

export type RevokeApiKeyResult = RevokeApiKeySuccess | Error;

export type RevokeApiKeySuccess = {
  __typename?: 'RevokeApiKeySuccess';
  apiKey?: Maybe<ApiKey>;
};

export type RockwoolBrand = {
  __typename?: 'RockwoolBrand';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  zones: Array<Zone>;
};

export type RockwoolSize = {
  __typename?: 'RockwoolSize';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  zones: Array<Zone>;
};

export type Role = {
  __typename?: 'Role';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  userSet: Array<UserProfile>;
  rolePermissions: Array<RolePermissions>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RoleFilterSetInput = {
  id?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
};

export type RolePermissions = {
  __typename?: 'RolePermissions';
  role: Role;
  permission: Permission;
};

export type RoleResult = Role | Error;

export type RoomLoadTaskChecklist = {
  __typename?: 'RoomLoadTaskChecklist';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklistSession: ChecklistSession;
  inspector?: Maybe<UserProfile>;
  zone?: Maybe<Zone>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['GenericScalar']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  parMeterCheckPlants?: Maybe<Scalars['Boolean']>;
  parMeterCheckPlantsNote?: Maybe<Scalars['String']>;
  measurePlantHeight?: Maybe<Scalars['Boolean']>;
  measurePlantHeightNote?: Maybe<Scalars['String']>;
  setUpHumidifiers?: Maybe<Scalars['Boolean']>;
  setUpHumidifiersNote?: Maybe<Scalars['String']>;
  roomAt82f72rh?: Maybe<Scalars['Boolean']>;
  roomAt82f72rhNote?: Maybe<Scalars['String']>;
  trolmasterWeek1Settings?: Maybe<Scalars['Boolean']>;
  trolmasterWeek1SettingsNote?: Maybe<Scalars['String']>;
  reinstallAroyaSensors?: Maybe<Scalars['Boolean']>;
  reinstallAroyaSensorsNote?: Maybe<Scalars['String']>;
  placeTrolmasterClimateSensors?: Maybe<Scalars['Boolean']>;
  placeTrolmasterClimateSensorsNote?: Maybe<Scalars['String']>;
  deployCatchCupsRunoffTrays?: Maybe<Scalars['Boolean']>;
  deployCatchCupsRunoffTraysNote?: Maybe<Scalars['String']>;
  doubleCheckNetbowsPluggedIn?: Maybe<Scalars['Boolean']>;
  doubleCheckNetbowsPluggedInNote?: Maybe<Scalars['String']>;
  placeMetrcTags?: Maybe<Scalars['Boolean']>;
  placeMetrcTagsNote?: Maybe<Scalars['String']>;
  add3LayersOfTrellis?: Maybe<Scalars['Boolean']>;
  add3LayersOfTrellisNote?: Maybe<Scalars['String']>;
};

export type RoomLoadTaskChecklistInput = {
  checklistSessionId: Scalars['ID'];
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  parMeterCheckPlants?: Maybe<Scalars['Boolean']>;
  parMeterCheckPlantsNote?: Maybe<Scalars['String']>;
  measurePlantHeight?: Maybe<Scalars['Boolean']>;
  measurePlantHeightNote?: Maybe<Scalars['String']>;
  setUpHumidifiers?: Maybe<Scalars['Boolean']>;
  setUpHumidifiersNote?: Maybe<Scalars['String']>;
  roomAt82f72rh?: Maybe<Scalars['Boolean']>;
  roomAt82f72rhNote?: Maybe<Scalars['String']>;
  trolmasterWeek1Settings?: Maybe<Scalars['Boolean']>;
  trolmasterWeek1SettingsNote?: Maybe<Scalars['String']>;
  reinstallAroyaSensors?: Maybe<Scalars['Boolean']>;
  reinstallAroyaSensorsNote?: Maybe<Scalars['String']>;
  placeTrolmasterClimateSensors?: Maybe<Scalars['Boolean']>;
  placeTrolmasterClimateSensorsNote?: Maybe<Scalars['String']>;
  deployCatchCupsRunoffTrays?: Maybe<Scalars['Boolean']>;
  deployCatchCupsRunoffTraysNote?: Maybe<Scalars['String']>;
  doubleCheckNetbowsPluggedIn?: Maybe<Scalars['Boolean']>;
  doubleCheckNetbowsPluggedInNote?: Maybe<Scalars['String']>;
  placeMetrcTags?: Maybe<Scalars['Boolean']>;
  placeMetrcTagsNote?: Maybe<Scalars['String']>;
  add3LayersOfTrellis?: Maybe<Scalars['Boolean']>;
  add3LayersOfTrellisNote?: Maybe<Scalars['String']>;
};

export type RoomLoadTaskChecklistResult = RoomLoadTaskChecklist | Error;

export type RoomSurvey = {
  __typename?: 'RoomSurvey';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  fieldSurvey: FieldSurvey;
  zone?: Maybe<Zone>;
  skipReason?: Maybe<Scalars['String']>;
  createdBy?: Maybe<UserProfile>;
  reportDate: Scalars['DateTime'];
  startedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  growthPhase?: Maybe<RoomSurveyGrowthPhase>;
  lightingPpfd?: Maybe<Scalars['Int']>;
  currentTemperature?: Maybe<Scalars['Decimal']>;
  currentHumidity?: Maybe<Scalars['Decimal']>;
  leafSurfaceTemperature?: Maybe<Scalars['Decimal']>;
  acOutletTemperature?: Maybe<Scalars['Decimal']>;
  vpdLevel?: Maybe<Scalars['Decimal']>;
  co2Level?: Maybe<Scalars['Decimal']>;
  lightingComponentsBulbs?: Maybe<RoomSurveyLightingComponentsBulbs>;
  lightingComponentsBallasts?: Maybe<RoomSurveyLightingComponentsBallasts>;
  lightingStatus?: Maybe<RoomSurveyLightingStatus>;
  acUnits?: Maybe<RoomSurveyAcUnits>;
  dehumidifiers?: Maybe<RoomSurveyDehumidifiers>;
  circulatingFans?: Maybe<RoomSurveyCirculatingFans>;
  humidifiers?: Maybe<RoomSurveyHumidifiers>;
  dripLines?: Maybe<RoomSurveyDripLines>;
  pumps?: Maybe<RoomSurveyPumps>;
  catchCups?: Maybe<RoomSurveyCatchCups>;
  runoffCollectionPh?: Maybe<Scalars['Decimal']>;
  runoffCollectionEc?: Maybe<Scalars['Decimal']>;
  plantStressIndicator?: Maybe<RoomSurveyPlantStressIndicator>;
  signsOfPests?: Maybe<RoomSurveySignsOfPests>;
  signsOfPathogens?: Maybe<RoomSurveySignsOfPathogens>;
  stickyTraps?: Maybe<RoomSurveyStickyTraps>;
  growingMediumPh?: Maybe<Scalars['Decimal']>;
  growingMediumEc?: Maybe<Scalars['Decimal']>;
  nutrientSolutionPh?: Maybe<Scalars['Decimal']>;
  nutrientSolutionEc?: Maybe<Scalars['Decimal']>;
  notes?: Maybe<Scalars['String']>;
  recommendations?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum RoomSurveyAcUnits {
  A = 'A_',
  Functioning = 'FUNCTIONING',
  NotFunctioning = 'NOT_FUNCTIONING'
}

export enum RoomSurveyCatchCups {
  A = 'A_',
  Installed = 'INSTALLED',
  NotInstalled = 'NOT_INSTALLED'
}

export enum RoomSurveyCirculatingFans {
  A = 'A_',
  Functioning = 'FUNCTIONING',
  NotFunctioning = 'NOT_FUNCTIONING'
}

export enum RoomSurveyDehumidifiers {
  A = 'A_',
  Functioning = 'FUNCTIONING',
  NotFunctioning = 'NOT_FUNCTIONING'
}

export enum RoomSurveyDripLines {
  A = 'A_',
  Clear = 'CLEAR',
  Clogged = 'CLOGGED'
}

export enum RoomSurveyGrowthPhase {
  A = 'A_',
  Vegetative = 'VEGETATIVE',
  Flower = 'FLOWER'
}

export enum RoomSurveyHumidifiers {
  A = 'A_',
  Functioning = 'FUNCTIONING',
  NotFunctioning = 'NOT_FUNCTIONING'
}

export enum RoomSurveyLightingComponentsBallasts {
  A = 'A_',
  Functioning = 'FUNCTIONING',
  NotFunctioning = 'NOT_FUNCTIONING'
}

export enum RoomSurveyLightingComponentsBulbs {
  A = 'A_',
  Functioning = 'FUNCTIONING',
  NotFunctioning = 'NOT_FUNCTIONING'
}

export enum RoomSurveyLightingStatus {
  A = 'A_',
  On = 'ON',
  Off = 'OFF'
}

export enum RoomSurveyPlantStressIndicator {
  A = 'A_',
  NotDetected = 'NOT_DETECTED',
  Detected = 'DETECTED'
}

export enum RoomSurveyPumps {
  A = 'A_',
  Functioning = 'FUNCTIONING',
  NotFunctioning = 'NOT_FUNCTIONING'
}

export type RoomSurveyResult = RoomSurvey | Error;

export enum RoomSurveySignsOfPathogens {
  A = 'A_',
  NotDetected = 'NOT_DETECTED',
  Detected = 'DETECTED'
}

export enum RoomSurveySignsOfPests {
  A = 'A_',
  NotDetected = 'NOT_DETECTED',
  Detected = 'DETECTED'
}

export enum RoomSurveyStickyTraps {
  A = 'A_',
  Installed = 'INSTALLED',
  NotInstalled = 'NOT_INSTALLED'
}

export type RoomTelemetry = {
  __typename?: 'RoomTelemetry';
  nightPeriods: Array<TelemetryNightPeriod>;
  zoneId: Scalars['ID'];
  roomName: Scalars['String'];
  timezone: Scalars['String'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  expectedBins: Scalars['Int'];
  sources: Array<TelemetrySource>;
};

export type RoomWalkthroughChecklist = {
  __typename?: 'RoomWalkthroughChecklist';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklistSession: ChecklistSession;
  zone?: Maybe<Zone>;
  inspector?: Maybe<UserProfile>;
  timePeriod?: Maybe<ChecklistEntryTimePeriod>;
  notes?: Maybe<Scalars['String']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  followUpRequired?: Maybe<ChecklistEntryFollowUpRequired>;
  skipReason?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['GenericScalar']>;
  airClimateSection?: Maybe<AirClimateSection>;
  lightingSection?: Maybe<LightingSection>;
  cultivationSection?: Maybe<CultivationSection>;
  ipmSection?: Maybe<IpmSection>;
  maintenanceSection?: Maybe<MaintenanceSection>;
  safetySection?: Maybe<SafetySection>;
  runoffSection?: Maybe<RunoffSection>;
  airClimate?: Maybe<AirClimateSection>;
  lighting?: Maybe<LightingSection>;
  cultivation?: Maybe<CultivationSection>;
  ipm?: Maybe<IpmSection>;
  maintenance?: Maybe<MaintenanceSection>;
  safety?: Maybe<SafetySection>;
  runoff?: Maybe<RunoffSection>;
};

export type RoomWalkthroughChecklistResult = RoomWalkthroughChecklist | Error;

export type RotateFieldAgentTokenInput = {
  fieldAgentId: Scalars['ID'];
};

export type RotateFieldAgentTokenResult = RotateFieldAgentTokenSuccess | Error;

export type RotateFieldAgentTokenSuccess = {
  __typename?: 'RotateFieldAgentTokenSuccess';
  fieldAgent?: Maybe<FieldAgent>;
  token: Scalars['String'];
};

export type RotateOrganizationMetrcApiKeyResult = RotateOrganizationMetrcApiKeySuccess | Error;

export type RotateOrganizationMetrcApiKeySuccess = {
  __typename?: 'RotateOrganizationMetrcApiKeySuccess';
  catchUpQueued: Scalars['Boolean'];
};

export type RunoffSection = {
  __typename?: 'RunoffSection';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  entry: ChecklistEntry;
  entries?: Maybe<Array<Maybe<RunoffSectionEntry>>>;
};

export type RunoffSectionEntry = {
  __typename?: 'RunoffSectionEntry';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  section: RunoffSection;
  strain?: Maybe<Strain>;
  ec?: Maybe<Scalars['Decimal']>;
  ph?: Maybe<Scalars['Decimal']>;
  amount?: Maybe<Scalars['Decimal']>;
  type: RunoffSectionEntryType;
  notes?: Maybe<Scalars['String']>;
};

export type RunoffSectionEntryInput = {
  strainId?: Maybe<Scalars['ID']>;
  ec?: Maybe<Scalars['Float']>;
  ph?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
};

export enum RunoffSectionEntryType {
  Constant = 'CONSTANT',
  Random = 'RANDOM'
}

export type RunoffSectionInput = {
  entries?: Maybe<Array<Maybe<RunoffSectionEntryInput>>>;
};

export type SafetySection = {
  __typename?: 'SafetySection';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  entry: ChecklistEntry;
  areaClean?: Maybe<SafetySectionAreaClean>;
  areaCleanNote?: Maybe<Scalars['String']>;
  spillsPresent?: Maybe<SafetySectionSpillsPresent>;
  spillsLocation?: Maybe<Scalars['String']>;
  toolsPutAway?: Maybe<SafetySectionToolsPutAway>;
  toolsPutAwayNote?: Maybe<Scalars['String']>;
  benchSpacing?: Maybe<SafetySectionBenchSpacing>;
  benchSpacingNote?: Maybe<Scalars['String']>;
};

export enum SafetySectionAreaClean {
  Yes = 'YES',
  No = 'NO'
}

export enum SafetySectionBenchSpacing {
  Good = 'GOOD',
  NeedsAdjusting = 'NEEDS_ADJUSTING'
}

export type SafetySectionInput = {
  areaClean?: Maybe<Scalars['String']>;
  areaCleanNote?: Maybe<Scalars['String']>;
  spillsPresent?: Maybe<Scalars['String']>;
  spillsLocation?: Maybe<Scalars['String']>;
  toolsPutAway?: Maybe<Scalars['String']>;
  toolsPutAwayNote?: Maybe<Scalars['String']>;
  benchSpacing?: Maybe<Scalars['String']>;
  benchSpacingNote?: Maybe<Scalars['String']>;
};

export enum SafetySectionSpillsPresent {
  Yes = 'YES',
  No = 'NO'
}

export enum SafetySectionToolsPutAway {
  Yes = 'YES',
  No = 'NO'
}

export type SalesManagerZoneFilterSetInput = {
  active?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
};

export type SendAccountInvitation = {
  __typename?: 'SendAccountInvitation';
  user?: Maybe<UserProfile>;
};

export type SendPasswordResetEmailResult = SendPasswordResetEmailSuccess | Error;

export type SendPasswordResetEmailSuccess = {
  __typename?: 'SendPasswordResetEmailSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type SensorCoverage = {
  __typename?: 'SensorCoverage';
  rows: Array<SensorDayOutcome>;
  counts: Scalars['GenericScalar'];
  exclusions: Scalars['GenericScalar'];
  inventory: Scalars['GenericScalar'];
  policy: Scalars['String'];
  timezone: Scalars['String'];
  collectAllSensors: Scalars['Boolean'];
  eligibleDevices: Scalars['Int'];
  total: Scalars['Int'];
  nextCursor?: Maybe<Scalars['String']>;
  runs?: Maybe<Array<Maybe<SensorRunResult>>>;
};

export type SensorDayOutcome = {
  __typename?: 'SensorDayOutcome';
  deviceId: Scalars['ID'];
  deviceName: Scalars['String'];
  zoneId: Scalars['ID'];
  roomName: Scalars['String'];
  provider: Scalars['String'];
  category: Scalars['String'];
  day: Scalars['Date'];
  outcome: Scalars['String'];
  readingsPresent: Scalars['Boolean'];
  lastAttempt?: Maybe<Scalars['DateTime']>;
  lastSuccessfulFetch?: Maybe<Scalars['DateTime']>;
  failureReason?: Maybe<Scalars['String']>;
  runId?: Maybe<Scalars['ID']>;
};

export type SensorEnvironmentalComparison = {
  __typename?: 'SensorEnvironmentalComparison';
  expected: Scalars['Int'];
  observed: Scalars['Int'];
  comparable: Scalars['Int'];
  inside: Scalars['Int'];
  above: Scalars['Int'];
  below: Scalars['Int'];
  insidePercent?: Maybe<Scalars['Float']>;
  abovePercent?: Maybe<Scalars['Float']>;
  belowPercent?: Maybe<Scalars['Float']>;
  observedCoverage: Scalars['Float'];
  comparableCoverage: Scalars['Float'];
  sensorId: Scalars['ID'];
  name: Scalars['String'];
};

export type SensorImportSiteResult = OrganizationSite | Error;

export type SensorImportTask = {
  __typename?: 'SensorImportTask';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  asyncAroyaStatus?: Maybe<SensorImportTaskAsyncAroyaStatus>;
  asyncAroyaStartedAt?: Maybe<Scalars['DateTime']>;
  asyncAroyaCompletedAt?: Maybe<Scalars['DateTime']>;
  asyncAroyaTaskId?: Maybe<Scalars['String']>;
  asyncAroyaError?: Maybe<Scalars['String']>;
  asyncAroyaTraceback?: Maybe<Scalars['String']>;
  asyncAroyaProgressPct: Scalars['Int'];
  asyncAroyaSubstrateStatus?: Maybe<SensorImportTaskAsyncAroyaSubstrateStatus>;
  asyncAroyaSubstrateStartedAt?: Maybe<Scalars['DateTime']>;
  asyncAroyaSubstrateCompletedAt?: Maybe<Scalars['DateTime']>;
  asyncAroyaSubstrateTaskId?: Maybe<Scalars['String']>;
  asyncAroyaSubstrateError?: Maybe<Scalars['String']>;
  asyncAroyaSubstrateTraceback?: Maybe<Scalars['String']>;
  asyncAroyaSubstrateProgressPct: Scalars['Int'];
  asyncTrolmasterStatus?: Maybe<SensorImportTaskAsyncTrolmasterStatus>;
  asyncTrolmasterStartedAt?: Maybe<Scalars['DateTime']>;
  asyncTrolmasterCompletedAt?: Maybe<Scalars['DateTime']>;
  asyncTrolmasterTaskId?: Maybe<Scalars['String']>;
  asyncTrolmasterError?: Maybe<Scalars['String']>;
  asyncTrolmasterTraceback?: Maybe<Scalars['String']>;
  asyncTrolmasterProgressPct: Scalars['Int'];
  asyncGrowlinkStatus?: Maybe<SensorImportTaskAsyncGrowlinkStatus>;
  asyncGrowlinkStartedAt?: Maybe<Scalars['DateTime']>;
  asyncGrowlinkCompletedAt?: Maybe<Scalars['DateTime']>;
  asyncGrowlinkTaskId?: Maybe<Scalars['String']>;
  asyncGrowlinkError?: Maybe<Scalars['String']>;
  asyncGrowlinkTraceback?: Maybe<Scalars['String']>;
  asyncGrowlinkProgressPct: Scalars['Int'];
  asyncDailyAroyaStatus?: Maybe<SensorImportTaskAsyncDailyAroyaStatus>;
  asyncDailyAroyaStartedAt?: Maybe<Scalars['DateTime']>;
  asyncDailyAroyaCompletedAt?: Maybe<Scalars['DateTime']>;
  asyncDailyAroyaTaskId?: Maybe<Scalars['String']>;
  asyncDailyAroyaError?: Maybe<Scalars['String']>;
  asyncDailyAroyaTraceback?: Maybe<Scalars['String']>;
  asyncDailyAroyaProgressPct: Scalars['Int'];
  asyncDailyTrolmasterStatus?: Maybe<SensorImportTaskAsyncDailyTrolmasterStatus>;
  asyncDailyTrolmasterStartedAt?: Maybe<Scalars['DateTime']>;
  asyncDailyTrolmasterCompletedAt?: Maybe<Scalars['DateTime']>;
  asyncDailyTrolmasterTaskId?: Maybe<Scalars['String']>;
  asyncDailyTrolmasterError?: Maybe<Scalars['String']>;
  asyncDailyTrolmasterTraceback?: Maybe<Scalars['String']>;
  asyncDailyTrolmasterProgressPct: Scalars['Int'];
  asyncDailyGrowlinkStatus?: Maybe<SensorImportTaskAsyncDailyGrowlinkStatus>;
  asyncDailyGrowlinkStartedAt?: Maybe<Scalars['DateTime']>;
  asyncDailyGrowlinkCompletedAt?: Maybe<Scalars['DateTime']>;
  asyncDailyGrowlinkTaskId?: Maybe<Scalars['String']>;
  asyncDailyGrowlinkError?: Maybe<Scalars['String']>;
  asyncDailyGrowlinkTraceback?: Maybe<Scalars['String']>;
  asyncDailyGrowlinkProgressPct: Scalars['Int'];
  asyncAroyaRefreshStatus?: Maybe<SensorImportTaskAsyncAroyaRefreshStatus>;
  asyncAroyaRefreshStartedAt?: Maybe<Scalars['DateTime']>;
  asyncAroyaRefreshCompletedAt?: Maybe<Scalars['DateTime']>;
  asyncAroyaRefreshTaskId?: Maybe<Scalars['String']>;
  asyncAroyaRefreshError?: Maybe<Scalars['String']>;
  asyncAroyaRefreshTraceback?: Maybe<Scalars['String']>;
  asyncAroyaRefreshProgressPct: Scalars['Int'];
  site: OrganizationSite;
  analysisResult: Scalars['JSONString'];
  aroyaEtaSecondsRemaining?: Maybe<Scalars['Int']>;
  aroyaSubstrateEtaSecondsRemaining?: Maybe<Scalars['Int']>;
  aroyaRefreshEtaSecondsRemaining?: Maybe<Scalars['Int']>;
  trolmasterEtaSecondsRemaining?: Maybe<Scalars['Int']>;
  growlinkEtaSecondsRemaining?: Maybe<Scalars['Int']>;
  aroyaEtaDatetime?: Maybe<Scalars['DateTime']>;
  aroyaSubstrateEtaDatetime?: Maybe<Scalars['DateTime']>;
  aroyaRefreshEtaDatetime?: Maybe<Scalars['DateTime']>;
  trolmasterEtaDatetime?: Maybe<Scalars['DateTime']>;
  growlinkEtaDatetime?: Maybe<Scalars['DateTime']>;
  eddGapDays?: Maybe<Scalars['Int']>;
};

export enum SensorImportTaskAsyncAroyaRefreshStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export enum SensorImportTaskAsyncAroyaStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export enum SensorImportTaskAsyncAroyaSubstrateStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export enum SensorImportTaskAsyncDailyAroyaStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export enum SensorImportTaskAsyncDailyGrowlinkStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export enum SensorImportTaskAsyncDailyTrolmasterStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export enum SensorImportTaskAsyncGrowlinkStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export enum SensorImportTaskAsyncTrolmasterStatus {
  Pending = 'PENDING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type SensorIntegrationCredential = {
  __typename?: 'SensorIntegrationCredential';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  site: OrganizationSite;
  brand: SensorIntegrationCredentialBrand;
  label: Scalars['String'];
  apiKey: Scalars['String'];
  username?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  growlinkApiVersion?: Maybe<SensorIntegrationCredentialGrowlinkApiVersion>;
  growlinkOrganizationId?: Maybe<Scalars['String']>;
  inventoryAttemptedAt?: Maybe<Scalars['DateTime']>;
  inventorySucceededAt?: Maybe<Scalars['DateTime']>;
  inventoryError: Scalars['String'];
  isActive: Scalars['Boolean'];
  aroyaDeviceRequests: Array<AroyaDeviceRequest>;
  growlinkDeviceRequests: Array<GrowlinkDeviceRequest>;
  environmentSensorDevices: Array<EnvironmentalDevice>;
};

export enum SensorIntegrationCredentialBrand {
  Aroya = 'AROYA',
  Trolmaster = 'TROLMASTER',
  Growlink = 'GROWLINK',
  Agrowtek = 'AGROWTEK'
}

export enum SensorIntegrationCredentialGrowlinkApiVersion {
  V1 = 'V1',
  V2 = 'V2'
}

export type SensorMetricQuality = {
  __typename?: 'SensorMetricQuality';
  codes: Array<Scalars['String']>;
  messages: Array<Scalars['String']>;
  expectedSamples: Scalars['Int'];
  observedSamples: Scalars['Int'];
  coveragePercent: Scalars['Float'];
  intervalMinutes: Scalars['Int'];
  cadenceConfigured: Scalars['Boolean'];
  latestObservation?: Maybe<Scalars['DateTime']>;
  suspectedStuckDays: Array<Scalars['String']>;
};

export type SensorObservationMetric = {
  __typename?: 'SensorObservationMetric';
  quality?: Maybe<SensorMetricQuality>;
  deviceId: Scalars['ID'];
  name: Scalars['String'];
  mean: Scalars['Float'];
  dayMean?: Maybe<Scalars['Float']>;
  nightMean?: Maybe<Scalars['Float']>;
  observedBins: Scalars['Int'];
  expectedBins: Scalars['Int'];
};

export type SensorRunResult = {
  __typename?: 'SensorRunResult';
  id: Scalars['ID'];
  state: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  trigger?: Maybe<Scalars['String']>;
  startDay?: Maybe<Scalars['Date']>;
  endDay?: Maybe<Scalars['Date']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  summary?: Maybe<Scalars['GenericScalar']>;
  error?: Maybe<Scalars['String']>;
  policy?: Maybe<Scalars['String']>;
  requestSettings?: Maybe<Scalars['GenericScalar']>;
  latestDayCounts?: Maybe<Scalars['GenericScalar']>;
  connectionStatus?: Maybe<Scalars['String']>;
};

export type Sensors = {
  __typename?: 'Sensors';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  zones: Array<Zone>;
  zonesRootZoneSensors: Array<Zone>;
};

export type SetPrimaryDeviceInput = {
  deviceId: Scalars['ID'];
};

export type SetSensorActive = {
  __typename?: 'SetSensorActive';
  active: Scalars['Boolean'];
};

export type SetSensorCollection = {
  __typename?: 'SetSensorCollection';
  enabled: Scalars['Boolean'];
};

export type SiteSensorBrand = {
  __typename?: 'SiteSensorBrand';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  site: OrganizationSite;
  brandName: SiteSensorBrandBrandName;
  isActive: Scalars['Boolean'];
};

export enum SiteSensorBrandBrandName {
  Aroya = 'AROYA',
  Trolmaster = 'TROLMASTER',
  Growlink = 'GROWLINK',
  Agrowtek = 'AGROWTEK'
}

export type SkipMetrcProcessingConnectionsInput = {
  siteId: Scalars['ID'];
  skipped: Scalars['Boolean'];
};

export type SoilBrand = {
  __typename?: 'SoilBrand';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  zones: Array<Zone>;
};

export type Stage = {
  __typename?: 'Stage';
  id: Scalars['UUID'];
  name: Scalars['String'];
  harvestGroup: HarvestGroup;
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  zone: Zone;
  templateUsed?: Maybe<StageTemplate>;
  desiredNumberOfDays?: Maybe<Scalars['Int']>;
  maxNumberOfDays?: Maybe<Scalars['Int']>;
  minNumberOfDays?: Maybe<Scalars['Int']>;
  orderInProcess: Scalars['Int'];
  environmentalTargetType: StageEnvironmentalTargetType;
  calendarBranch?: Maybe<CalendarBranch>;
  strainsInStage: Array<StrainInStage>;
  tasks: Array<Task>;
  calendarBranchId: Scalars['String'];
  currentDayOfStage: Scalars['Int'];
  daysInStage: Scalars['Int'];
};

export type StageConflict = {
  __typename?: 'StageConflict';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  schedulingRule: StageConflictSchedulingRule;
  message: Scalars['String'];
  justification?: Maybe<Scalars['String']>;
  stageUpdate: StageUpdate;
  stageconflictoverrideSet: Array<StageConflictOverride>;
};

export type StageConflictOverride = {
  __typename?: 'StageConflictOverride';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  stageConflict: StageConflict;
  schedulingRule: StageConflictOverrideSchedulingRule;
  reason: Scalars['String'];
  createdBy?: Maybe<UserProfile>;
};

export enum StageConflictOverrideSchedulingRule {
  StageLength = 'STAGE_LENGTH',
  ZoneOverlap = 'ZONE_OVERLAP',
  LaborShortage = 'LABOR_SHORTAGE',
  EquipmentShortage = 'EQUIPMENT_SHORTAGE',
  TaskOutsideStage = 'TASK_OUTSIDE_STAGE',
  TaskOutOfOrder = 'TASK_OUT_OF_ORDER'
}

export enum StageConflictSchedulingRule {
  StageLength = 'STAGE_LENGTH',
  ZoneOverlap = 'ZONE_OVERLAP',
  LaborShortage = 'LABOR_SHORTAGE',
  EquipmentShortage = 'EQUIPMENT_SHORTAGE',
  TaskOutsideStage = 'TASK_OUTSIDE_STAGE',
  TaskOutOfOrder = 'TASK_OUT_OF_ORDER'
}

export enum StageEnvironmentalTargetType {
  Veg = 'VEG',
  Flower = 'FLOWER',
  NoTargets = 'NO_TARGETS'
}

export type StageTemplate = {
  __typename?: 'StageTemplate';
  id: Scalars['UUID'];
  name: Scalars['String'];
  createdStageName: Scalars['String'];
  numberOfDays: Scalars['Int'];
  maxNumberOfDays: Scalars['Int'];
  minNumberOfDays: Scalars['Int'];
  orderInProcess: Scalars['Int'];
  environmentalTargetType: StageTemplateEnvironmentalTargetType;
  designatedZones: Array<Zone>;
  taskTemplates: Array<TaskTemplate>;
};

export enum StageTemplateEnvironmentalTargetType {
  Veg = 'VEG',
  Flower = 'FLOWER',
  NoTargets = 'NO_TARGETS'
}

export type StageUpdate = {
  __typename?: 'StageUpdate';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  newStartDate?: Maybe<Scalars['Date']>;
  newEndDate?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<UserProfile>;
  calendarBranch: CalendarBranch;
  stage: Stage;
  conflicts: Array<StageConflict>;
};

export type StageWeek = {
  __typename?: 'StageWeek';
  stage: Stage;
  weekNumber: Scalars['Int'];
  weekStartDate: Scalars['Date'];
  weekEndDate: Scalars['Date'];
  hasEnvironmentalData: Scalars['Boolean'];
};

export type StageZoneOrderInput = {
  stageTemplateId: Scalars['ID'];
  zoneIds?: Maybe<Array<Scalars['ID']>>;
  zoneGroups?: Maybe<Array<Array<Scalars['ID']>>>;
};

export type Strain = {
  __typename?: 'Strain';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  createdBy: UserProfile;
  name: Scalars['String'];
  abbreviation: Scalars['String'];
  subspecies: StrainSubspecies;
  active: Scalars['Boolean'];
  documentationUrl?: Maybe<Scalars['String']>;
  metrcId?: Maybe<Scalars['String']>;
  yieldEditIdentity: Strain;
};

export type StrainFilterSetInput = {
  active?: Maybe<Scalars['Boolean']>;
};

export type StrainInStage = {
  __typename?: 'StrainInStage';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  strain: Strain;
  stage: Stage;
  numberOfPlants: Scalars['Int'];
};

export type StrainPerformance = {
  __typename?: 'StrainPerformance';
  id: Scalars['String'];
  name: Scalars['String'];
  harvests: Array<HarvestStrainPerformance>;
  avgGramsPerPlant: Scalars['Float'];
};

export type StrainPerformanceResult = {
  __typename?: 'StrainPerformanceResult';
  strainPerformance1: StrainPerformance;
  strainPerformance2: StrainPerformance;
  strainPerformance3: StrainPerformance;
  strainPerformance4: StrainPerformance;
  strain1: Strain;
  strain2: Strain;
  strain3: Strain;
  strain4: Strain;
  allStrains: Array<Strain>;
  allBudFormFactors: Array<BudFormFactor>;
};

export type StrainResult = Strain | Error;

export enum StrainSubspecies {
  Indica = 'INDICA',
  Sativa = 'SATIVA',
  Hybrid = 'HYBRID',
  Ruderalis = 'RUDERALIS',
  Cbd = 'CBD',
  Hemp = 'HEMP'
}

export type StrainYieldPerformance = {
  __typename?: 'StrainYieldPerformance';
  strain: Strain;
  harvests: Array<HarvestStrainPerformance>;
  totalHarvests: Scalars['Int'];
  totalPlants: Scalars['Int'];
  totalGrams: Scalars['Float'];
  totalFlowerGrams: Scalars['Float'];
  avgGramsPerPlant: Scalars['Float'];
  avgFlowerGramsPerPlant: Scalars['Float'];
  adjustedParentTotalGrams?: Maybe<Scalars['Float']>;
};

export type SuccessOk = {
  __typename?: 'SuccessOK';
  ok: Scalars['Boolean'];
};

export type SuccessOkResult = SuccessOk | Error;

export type Tag = {
  __typename?: 'Tag';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  colorHexCode?: Maybe<Scalars['String']>;
  maintenanceRequestTags: Array<MaintenanceRequestTag>;
};

export type TagFilterSetInput = {
  id?: Maybe<Scalars['String']>;
};

export enum TargetTypeEnum {
  Task = 'TASK',
  Stage = 'STAGE'
}

export type Task = {
  __typename?: 'Task';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  originalId: Scalars['String'];
  isCurrentRow: Scalars['Boolean'];
  isComplete: Scalars['Boolean'];
  createdBy: UserProfile;
  assignedTo?: Maybe<UserProfile>;
  harvestGroup: HarvestGroup;
  name: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  priority: TaskPriority;
  notes?: Maybe<Scalars['String']>;
  templateUsed?: Maybe<TaskTemplate>;
  orderInProcess: Scalars['Int'];
  desiredStageDayStart?: Maybe<Scalars['Int']>;
  desiredStageDayEnd?: Maybe<Scalars['Int']>;
  logType?: Maybe<TaskLogType>;
  logEntryRecipe?: Maybe<Recipe>;
  currentZone?: Maybe<Zone>;
  stageOnTaskDate?: Maybe<TaskStageInfo>;
};

export type TaskConflict = {
  __typename?: 'TaskConflict';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  schedulingRule: TaskConflictSchedulingRule;
  message: Scalars['String'];
  justification?: Maybe<Scalars['String']>;
  taskUpdate: TaskUpdate;
  taskconflictoverrideSet: Array<TaskConflictOverride>;
};

export type TaskConflictOverride = {
  __typename?: 'TaskConflictOverride';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  taskConflict: TaskConflict;
  schedulingRule: TaskConflictOverrideSchedulingRule;
  reason: Scalars['String'];
  createdBy?: Maybe<UserProfile>;
};

export enum TaskConflictOverrideSchedulingRule {
  StageLength = 'STAGE_LENGTH',
  ZoneOverlap = 'ZONE_OVERLAP',
  LaborShortage = 'LABOR_SHORTAGE',
  EquipmentShortage = 'EQUIPMENT_SHORTAGE',
  TaskOutsideStage = 'TASK_OUTSIDE_STAGE',
  TaskOutOfOrder = 'TASK_OUT_OF_ORDER'
}

export enum TaskConflictSchedulingRule {
  StageLength = 'STAGE_LENGTH',
  ZoneOverlap = 'ZONE_OVERLAP',
  LaborShortage = 'LABOR_SHORTAGE',
  EquipmentShortage = 'EQUIPMENT_SHORTAGE',
  TaskOutsideStage = 'TASK_OUTSIDE_STAGE',
  TaskOutOfOrder = 'TASK_OUT_OF_ORDER'
}

export enum TaskLogType {
  Observation = 'OBSERVATION',
  Issue = 'ISSUE',
  Irrigation = 'IRRIGATION',
  Foliar = 'FOLIAR',
  Pruning = 'PRUNING',
  Defoliate = 'DEFOLIATE',
  Topping = 'TOPPING',
  Greenwaste = 'GREENWASTE',
  Runoff = 'RUNOFF'
}

export enum TaskPriority {
  Low = 'LOW',
  Normal = 'NORMAL',
  High = 'HIGH',
  Urgent = 'URGENT'
}

export type TaskResult = Task | Error;

export type TaskStageInfo = {
  __typename?: 'TaskStageInfo';
  name: Scalars['String'];
  currentDayOfStage: Scalars['Int'];
  daysInStage: Scalars['Int'];
};

export type TaskTemplate = {
  __typename?: 'TaskTemplate';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  createdTaskName: Scalars['String'];
  stageTemplate: StageTemplate;
  orderInProcess: Scalars['Int'];
  stageDayStart: Scalars['Int'];
  stageDayEnd: Scalars['Int'];
  taskType: TaskTemplateTaskType;
  logType?: Maybe<TaskTemplateLogType>;
  logEntryRecipe?: Maybe<Recipe>;
  tasks: Array<Task>;
  tasksUsingTemplate: Array<Task>;
};

export enum TaskTemplateLogType {
  Observation = 'OBSERVATION',
  Issue = 'ISSUE',
  Irrigation = 'IRRIGATION',
  Foliar = 'FOLIAR',
  Pruning = 'PRUNING',
  Defoliate = 'DEFOLIATE',
  Topping = 'TOPPING',
  Greenwaste = 'GREENWASTE',
  Runoff = 'RUNOFF'
}

export enum TaskTemplateTaskType {
  Custom = 'CUSTOM',
  LogEntry = 'LOG_ENTRY'
}

export type TaskUpdate = {
  __typename?: 'TaskUpdate';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  newStartDate?: Maybe<Scalars['Date']>;
  newEndDate?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<UserProfile>;
  calendarBranch: CalendarBranch;
  task: Task;
  conflicts: Array<TaskConflict>;
};

export type TelemetryMetric = {
  __typename?: 'TelemetryMetric';
  quality?: Maybe<SensorMetricQuality>;
  key: Scalars['String'];
  label: Scalars['String'];
  unit: Scalars['String'];
  category: Scalars['String'];
  observedBins: Scalars['Int'];
  expectedBins: Scalars['Int'];
  minimum: Scalars['Float'];
  maximum: Scalars['Float'];
  mean: Scalars['Float'];
  dayMean?: Maybe<Scalars['Float']>;
  nightMean?: Maybe<Scalars['Float']>;
  constant: Scalars['Boolean'];
  points: Array<TelemetryPoint>;
};

export type TelemetryNightPeriod = {
  __typename?: 'TelemetryNightPeriod';
  start: Scalars['Float'];
  end: Scalars['Float'];
};

export type TelemetryPoint = {
  __typename?: 'TelemetryPoint';
  time: Scalars['Float'];
  value?: Maybe<Scalars['Float']>;
};

export type TelemetrySource = {
  __typename?: 'TelemetrySource';
  id: Scalars['ID'];
  name: Scalars['String'];
  primary: Scalars['Boolean'];
  active: Scalars['Boolean'];
  category: Scalars['String'];
  latestObservation?: Maybe<Scalars['DateTime']>;
  metrics: Array<TelemetryMetric>;
};


export type TokenAuthResult = TokenAuthSuccess | Error;

export type TokenAuthSuccess = {
  __typename?: 'TokenAuthSuccess';
  token?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  user?: Maybe<UserProfile>;
};

export type ToppingStyle = {
  __typename?: 'ToppingStyle';
  id: Scalars['UUID'];
  name: Scalars['String'];
  organization: Organization;
};

export type ToppingStyleFilterSetInput = {
  id?: Maybe<Scalars['String']>;
};

export type ToppingStyleResult = ToppingStyle | Error;

export type TransplantTaskChecklist = {
  __typename?: 'TransplantTaskChecklist';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklistSession: ChecklistSession;
  inspector?: Maybe<UserProfile>;
  zone?: Maybe<Zone>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['GenericScalar']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  handChargeCocosWithCalciumNitrate?: Maybe<Scalars['Boolean']>;
  handChargeCocosWithCalciumNitrateNote?: Maybe<Scalars['String']>;
  plugInAroyaSensors?: Maybe<Scalars['Boolean']>;
  plugInAroyaSensorsNote?: Maybe<Scalars['String']>;
  addGypsumAndCalciumCarbonateRinse?: Maybe<Scalars['Boolean']>;
  addGypsumAndCalciumCarbonateRinseNote?: Maybe<Scalars['String']>;
  transplantClonesIntoPots?: Maybe<Scalars['Boolean']>;
  transplantClonesIntoPotsNote?: Maybe<Scalars['String']>;
  topOffEachPlantWithVegFeed?: Maybe<Scalars['Boolean']>;
  topOffEachPlantWithVegFeedNote?: Maybe<Scalars['String']>;
  plugInNetbows?: Maybe<Scalars['Boolean']>;
  plugInNetbowsNote?: Maybe<Scalars['String']>;
  placeMetrcTags?: Maybe<Scalars['Boolean']>;
  placeMetrcTagsNote?: Maybe<Scalars['String']>;
  cleanAndSanitizeCloneTablesTrays?: Maybe<Scalars['Boolean']>;
  cleanAndSanitizeCloneTablesTraysNote?: Maybe<Scalars['String']>;
};

export type TransplantTaskChecklistInput = {
  checklistSessionId: Scalars['ID'];
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  handChargeCocosWithCalciumNitrate?: Maybe<Scalars['Boolean']>;
  handChargeCocosWithCalciumNitrateNote?: Maybe<Scalars['String']>;
  plugInAroyaSensors?: Maybe<Scalars['Boolean']>;
  plugInAroyaSensorsNote?: Maybe<Scalars['String']>;
  addGypsumAndCalciumCarbonateRinse?: Maybe<Scalars['Boolean']>;
  addGypsumAndCalciumCarbonateRinseNote?: Maybe<Scalars['String']>;
  transplantClonesIntoPots?: Maybe<Scalars['Boolean']>;
  transplantClonesIntoPotsNote?: Maybe<Scalars['String']>;
  topOffEachPlantWithVegFeed?: Maybe<Scalars['Boolean']>;
  topOffEachPlantWithVegFeedNote?: Maybe<Scalars['String']>;
  plugInNetbows?: Maybe<Scalars['Boolean']>;
  plugInNetbowsNote?: Maybe<Scalars['String']>;
  placeMetrcTags?: Maybe<Scalars['Boolean']>;
  placeMetrcTagsNote?: Maybe<Scalars['String']>;
  cleanAndSanitizeCloneTablesTrays?: Maybe<Scalars['Boolean']>;
  cleanAndSanitizeCloneTablesTraysNote?: Maybe<Scalars['String']>;
};

export type TransplantTaskChecklistResult = TransplantTaskChecklist | Error;


export type UncompleteTaskInput = {
  id: Scalars['ID'];
  organizationId?: Maybe<Scalars['ID']>;
};

export type UnderCanopyBrand = {
  __typename?: 'UnderCanopyBrand';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  isCustom: Scalars['Boolean'];
  zones: Array<Zone>;
};

export type UndoBranchCalendarStageUpdateInput = {
  calendarBranchId: Scalars['ID'];
  stageId: Scalars['ID'];
};

export type UndoBranchCalendarTaskUpdateInput = {
  calendarBranchId: Scalars['ID'];
  taskId: Scalars['ID'];
};

export type UpdateActiveProcessingGroupTemplateVersionInput = {
  id: Scalars['ID'];
  versionId: Scalars['ID'];
};

export type UpdateAroyaDeviceInput = {
  id: Scalars['ID'];
  aroyaDeviceId?: Maybe<Scalars['String']>;
  aroyaModelKey?: Maybe<Scalars['String']>;
  aroyaSerialNumber?: Maybe<Scalars['String']>;
};

export type UpdateBranchCalendarStagePatchInput = {
  newStartDate?: Maybe<Scalars['Date']>;
  newEndDate?: Maybe<Scalars['Date']>;
};

export type UpdateBranchCalendarTaskPatchInput = {
  newStartDate?: Maybe<Scalars['Date']>;
  newEndDate?: Maybe<Scalars['Date']>;
};

export type UpdateBudFormFactorInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
};

export type UpdateCalendarBranchStageInput = {
  calendarBranchId: Scalars['ID'];
  stageId: Scalars['ID'];
  patch?: Maybe<UpdateBranchCalendarStagePatchInput>;
};

export type UpdateCalendarBranchTaskInput = {
  calendarBranchId: Scalars['ID'];
  taskId: Scalars['ID'];
  patch?: Maybe<UpdateBranchCalendarTaskPatchInput>;
};

export type UpdateChecklistEntryInput = {
  id: Scalars['ID'];
  timePeriod?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  followUpRequired?: Maybe<Scalars['String']>;
  skipReason?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  airClimate?: Maybe<AirClimateSectionInput>;
  lighting?: Maybe<LightingSectionInput>;
  cultivation?: Maybe<CultivationSectionInput>;
  ipm?: Maybe<IpmSectionInput>;
  maintenance?: Maybe<MaintenanceSectionInput>;
  safety?: Maybe<SafetySectionInput>;
  runoff?: Maybe<RunoffSectionInput>;
};

export type UpdateCloningTaskChecklistInput = {
  checklistSessionId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  sanitizeEquipment?: Maybe<Scalars['Boolean']>;
  sanitizeEquipmentNote?: Maybe<Scalars['String']>;
  preSoakPlugsWithCloneFeed?: Maybe<Scalars['Boolean']>;
  preSoakPlugsWithCloneFeedNote?: Maybe<Scalars['String']>;
  squeezePlugs?: Maybe<Scalars['Boolean']>;
  squeezePlugsNote?: Maybe<Scalars['String']>;
  cutClones?: Maybe<Scalars['Boolean']>;
  cutClonesNote?: Maybe<Scalars['String']>;
  cutStems45DegreesRazorBlade?: Maybe<Scalars['Boolean']>;
  cutStems45DegreesRazorBladeNote?: Maybe<Scalars['String']>;
  mixDipNGrow?: Maybe<Scalars['Boolean']>;
  mixDipNGrowNote?: Maybe<Scalars['String']>;
  placeCutsInDipNGrow1520Seconds?: Maybe<Scalars['Boolean']>;
  placeCutsInDipNGrow1520SecondsNote?: Maybe<Scalars['String']>;
  plugClonesWithCallus?: Maybe<Scalars['Boolean']>;
  plugClonesWithCallusNote?: Maybe<Scalars['String']>;
  placeMetrcTags?: Maybe<Scalars['Boolean']>;
  placeMetrcTagsNote?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateDailyTasksChecklistInput = {
  checklistSessionId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  flowerRoomAmCheck?: Maybe<Scalars['Boolean']>;
  flowerRoomAmCheckNote?: Maybe<Scalars['String']>;
  collectRunOffs?: Maybe<Scalars['Boolean']>;
  collectRunOffsNote?: Maybe<Scalars['String']>;
  cleanNetafimFilters?: Maybe<Scalars['Boolean']>;
  cleanNetafimFiltersNote?: Maybe<Scalars['String']>;
  sweepMopHallways?: Maybe<Scalars['Boolean']>;
  sweepMopHallwaysNote?: Maybe<Scalars['String']>;
  collectAllTrash?: Maybe<Scalars['Boolean']>;
  collectAllTrashNote?: Maybe<Scalars['String']>;
  flowerRoomPmCheck?: Maybe<Scalars['Boolean']>;
  flowerRoomPmCheckNote?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateDailyWetRoomTaskChecklistInput = {
  checklistSessionId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  amCheckStockBarrels?: Maybe<Scalars['Boolean']>;
  amCheckStockBarrelsNote?: Maybe<Scalars['String']>;
  amCalibratePhEcEquipment?: Maybe<Scalars['Boolean']>;
  amCalibratePhEcEquipmentNote?: Maybe<Scalars['String']>;
  amMakeNeededStockBarrels?: Maybe<Scalars['Boolean']>;
  amMakeNeededStockBarrelsNote?: Maybe<Scalars['String']>;
  pmCheckStockBarrels?: Maybe<Scalars['Boolean']>;
  pmCheckStockBarrelsNote?: Maybe<Scalars['String']>;
  pmCleanUpPutAwayProducts?: Maybe<Scalars['Boolean']>;
  pmCleanUpPutAwayProductsNote?: Maybe<Scalars['String']>;
  pmCapAndStorePhEcEquipment?: Maybe<Scalars['Boolean']>;
  pmCapAndStorePhEcEquipmentNote?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateDisplay = {
  __typename?: 'UpdateDisplay';
  id: Scalars['String'];
  changeDescription: Scalars['String'];
  harvestGroupName: Scalars['String'];
  name: Scalars['String'];
  updateType: UpdateTypeEnum;
  targetType: TargetTypeEnum;
  colorHexCode: Scalars['String'];
  undoable: Scalars['Boolean'];
};

export type UpdateDryRoomPostHarvestChecklistInput = {
  checklistSessionId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  doubleCheckFloorFans?: Maybe<Scalars['Boolean']>;
  doubleCheckFloorFansNote?: Maybe<Scalars['String']>;
  smallDehusOnHighestSetting?: Maybe<Scalars['Boolean']>;
  smallDehusOnHighestSettingNote?: Maybe<Scalars['String']>;
  doubleCheckTrolmasterSetpoints68f55rh?: Maybe<Scalars['Boolean']>;
  doubleCheckTrolmasterSetpoints68f55rhNote?: Maybe<Scalars['String']>;
  sweepAndRemovePlantDebris?: Maybe<Scalars['Boolean']>;
  sweepAndRemovePlantDebrisNote?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateDryRoomPreHarvestChecklistInput = {
  checklistSessionId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  setTrolmasterSetpoints68f55rh?: Maybe<Scalars['Boolean']>;
  setTrolmasterSetpoints68f55rhNote?: Maybe<Scalars['String']>;
  setUpFloorFans?: Maybe<Scalars['Boolean']>;
  setUpFloorFansNote?: Maybe<Scalars['String']>;
  setUpSmallDehus?: Maybe<Scalars['Boolean']>;
  setUpSmallDehusNote?: Maybe<Scalars['String']>;
  setRacksUpForHanging?: Maybe<Scalars['Boolean']>;
  setRacksUpForHangingNote?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateEnvironmentalTargetSetBulkInput = {
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  environmentalTargetValuesList: Array<Maybe<EnvironmentalTargetValuesInput>>;
};

export type UpdateEnvironmentalTargetSetInput = {
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
  environmentalTargetValues: EnvironmentalTargetValuesInput;
  environmentalTargetType: Scalars['String'];
};

export type UpdateEquipmentInput = {
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  lastMaintenanceDate?: Maybe<Scalars['Date']>;
  locationId?: Maybe<Scalars['ID']>;
  brand?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  installedAtDate?: Maybe<Scalars['Date']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type UpdateFacilitySurveyInput = {
  id: Scalars['ID'];
  phPrefilter: Scalars['Decimal'];
  ecPrefilter: Scalars['Decimal'];
  tdsPrefilter: Scalars['Int'];
  tempPrefilter: Scalars['Decimal'];
  phPostfilter: Scalars['Decimal'];
  ecPostfilter: Scalars['Decimal'];
  tdsPostfilter: Scalars['Int'];
  tempPostfilter: Scalars['Decimal'];
  floorsStatus: Scalars['String'];
  wallsStatus: Scalars['String'];
  ceilingsStatus: Scalars['String'];
  footBaths: Scalars['String'];
  eyeWashStations: Scalars['String'];
  handWashStations: Scalars['String'];
  msdsDocumentationUpToDate: Scalars['String'];
  trainingLogsUpToDate: Scalars['String'];
  hygieneAdherence: Scalars['String'];
  storageConditions: Scalars['String'];
  storageLabels: Scalars['String'];
  storageContainers: Scalars['String'];
  safetyProtocols: Scalars['String'];
  ppeForHandling: Scalars['String'];
  ppeGlovesAvailable: Scalars['String'];
  ppeGogglesAvailable: Scalars['String'];
  ppeMasksAvailable: Scalars['String'];
  roFilters: Scalars['String'];
  roInlineFilters: Scalars['String'];
  roAirChambers: Scalars['String'];
  roCheckValves: Scalars['String'];
  waterTestTap: Scalars['String'];
  waterTestPostFilter: Scalars['String'];
};

export type UpdateGrowlinkDeviceInput = {
  id: Scalars['ID'];
  growlinkControllerId?: Maybe<Scalars['String']>;
  growlinkModuleName?: Maybe<Scalars['String']>;
  growlinkTemperatureSensorId?: Maybe<Scalars['String']>;
  growlinkHumiditySensorId?: Maybe<Scalars['String']>;
  growlinkCo2SensorId?: Maybe<Scalars['String']>;
  growlinkVpdSensorId?: Maybe<Scalars['String']>;
  growlinkLightSensorId?: Maybe<Scalars['String']>;
};

export type UpdateHarvestGroupArchivedInput = {
  id?: Maybe<Scalars['ID']>;
  archivedAt?: Maybe<Scalars['String']>;
};

export type UpdateHarvestGroupFlowerZoneInput = {
  id: Scalars['ID'];
  flowerZoneId?: Maybe<Scalars['String']>;
};

export type UpdateHarvestGroupInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  flowerZoneId?: Maybe<Scalars['String']>;
  stages?: Maybe<Array<UpdateStageInput>>;
  colorHexCode?: Maybe<Scalars['String']>;
  tasks?: Maybe<Array<UpdateTaskInput>>;
  isMultisite?: Maybe<Scalars['Boolean']>;
};

export type UpdateHarvestGroupTemplateArchivedInput = {
  id: Scalars['ID'];
  archivedAt?: Maybe<Scalars['String']>;
};

export type UpdateHarvestGroupTemplateInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  stageTemplates?: Maybe<Array<Maybe<CreateStageTemplateInput>>>;
  harvestGroupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  validateOnly?: Maybe<Scalars['Boolean']>;
};

export type UpdateHarvestProjectionInput = {
  harvestGroupId: Scalars['ID'];
  strainId: Scalars['ID'];
  plantCount: Scalars['Int'];
};

export type UpdateHarvestReportInput = {
  harvestGroupId: Scalars['ID'];
  strainYields?: Maybe<Array<CreateHarvestStrainYieldInput>>;
};

export type UpdateHarvestYieldsInput = {
  harvestGroupId: Scalars['ID'];
  strainYields?: Maybe<Array<CreateHarvestStrainYieldInput>>;
};

export type UpdateNotificationPreferenceInput = {
  organizationId?: Maybe<Scalars['ID']>;
  reportType: Scalars['String'];
  enabled?: Maybe<Scalars['Boolean']>;
  frequency?: Maybe<Scalars['String']>;
  sendToAdmins?: Maybe<Scalars['Boolean']>;
  sendToCultivationManagers?: Maybe<Scalars['Boolean']>;
  sendToCultivation?: Maybe<Scalars['Boolean']>;
};

export type UpdateNutrientInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  unitOfMeasure?: Maybe<Scalars['String']>;
  priceInCentsPerUnit?: Maybe<Scalars['Float']>;
  boughtPrice?: Maybe<Scalars['Float']>;
  boughtAmount?: Maybe<Scalars['Float']>;
  boughtUnit?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
};

export type UpdateOrganizationBrandingInput = {
  organizationId: Scalars['ID'];
  colorPreset?: Maybe<Scalars['String']>;
  typographyPreset?: Maybe<Scalars['String']>;
  logo?: Maybe<FileBase64UploadInput>;
  logoDark?: Maybe<FileBase64UploadInput>;
  clearLogo?: Maybe<Scalars['Boolean']>;
  clearLogoDark?: Maybe<Scalars['Boolean']>;
};

export type UpdateOrganizationSettingsInput = {
  timezone?: Maybe<Scalars['String']>;
  optionConvertGramsAbove?: Maybe<Scalars['Int']>;
  normalizeWindowMinutes?: Maybe<Scalars['Int']>;
  alertConsecutiveThreshold?: Maybe<Scalars['Int']>;
  apiEnabled?: Maybe<Scalars['Boolean']>;
  redesignEnabled?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['ID']>;
};

export type UpdatePostHarvestTaskChecklistInput = {
  checklistSessionId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  zerotolSprayHallways?: Maybe<Scalars['Boolean']>;
  zerotolSprayHallwaysNote?: Maybe<Scalars['String']>;
  cleanTablesGutters?: Maybe<Scalars['Boolean']>;
  cleanTablesGuttersNote?: Maybe<Scalars['String']>;
  cleanMainFloorDrain?: Maybe<Scalars['Boolean']>;
  cleanMainFloorDrainNote?: Maybe<Scalars['String']>;
  cleanRackAndFloorFans?: Maybe<Scalars['Boolean']>;
  cleanRackAndFloorFansNote?: Maybe<Scalars['String']>;
  greencleanAcidFlushLines?: Maybe<Scalars['Boolean']>;
  greencleanAcidFlushLinesNote?: Maybe<Scalars['String']>;
  flushAcidWithZerotolThenRo?: Maybe<Scalars['Boolean']>;
  flushAcidWithZerotolThenRoNote?: Maybe<Scalars['String']>;
  replaceAcAndDehuFilters?: Maybe<Scalars['Boolean']>;
  replaceAcAndDehuFiltersNote?: Maybe<Scalars['String']>;
  blowOutDehuDrainLines?: Maybe<Scalars['Boolean']>;
  blowOutDehuDrainLinesNote?: Maybe<Scalars['String']>;
  replaceFeedingLinesDrippersIfNeeded?: Maybe<Scalars['Boolean']>;
  replaceFeedingLinesDrippersIfNeededNote?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdatePreHarvestTaskChecklistInput = {
  checklistSessionId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  pullAroyaSensors?: Maybe<Scalars['Boolean']>;
  pullAroyaSensorsNote?: Maybe<Scalars['String']>;
  cutLowestLayerOfTrellis?: Maybe<Scalars['Boolean']>;
  cutLowestLayerOfTrellisNote?: Maybe<Scalars['String']>;
  flowerBinsClean?: Maybe<Scalars['Boolean']>;
  flowerBinsCleanNote?: Maybe<Scalars['String']>;
  writeFlowerBinLabels?: Maybe<Scalars['Boolean']>;
  writeFlowerBinLabelsNote?: Maybe<Scalars['String']>;
  dryRoomClean?: Maybe<Scalars['Boolean']>;
  dryRoomCleanNote?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateProcessingGroupArchivedInput = {
  id: Scalars['ID'];
  archivedAt?: Maybe<Scalars['String']>;
};

export type UpdateProcessingGroupTemplateArchivedInput = {
  id: Scalars['ID'];
  archivedAt?: Maybe<Scalars['String']>;
};

export type UpdateProcessingJobInput = {
  id: Scalars['ID'];
  assigneeId?: Maybe<Scalars['ID']>;
  newInputGrams: Scalars['Decimal'];
};

export type UpdateProcessingJobLogInput = {
  id: Scalars['ID'];
  jobId: Scalars['ID'];
  performerId?: Maybe<Scalars['ID']>;
  startedAt: Scalars['DateTime'];
  endedAt: Scalars['DateTime'];
  breakMinutes: Scalars['Decimal'];
  leftoverInputGrams?: Maybe<Scalars['Decimal']>;
  outputGrams: Array<JobLogOutputGramsInput>;
};

export type UpdatePruningDefolTaskChecklistInput = {
  checklistSessionId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  prepPrunersTrashBagsBuckets?: Maybe<Scalars['Boolean']>;
  prepPrunersTrashBagsBucketsNote?: Maybe<Scalars['String']>;
  sanitizeUsedEquipmentBuckets?: Maybe<Scalars['Boolean']>;
  sanitizeUsedEquipmentBucketsNote?: Maybe<Scalars['String']>;
  putTablesBackInPlace?: Maybe<Scalars['Boolean']>;
  putTablesBackInPlaceNote?: Maybe<Scalars['String']>;
  logWasteWeights?: Maybe<Scalars['Boolean']>;
  logWasteWeightsNote?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateRecipeComponentInput = {
  id: Scalars['ID'];
  nutrientId?: Maybe<Scalars['String']>;
  volume?: Maybe<Scalars['Decimal']>;
};

export type UpdateRecipeInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  applicationType?: Maybe<Scalars['String']>;
  ec?: Maybe<Scalars['Decimal']>;
  ph?: Maybe<Scalars['Decimal']>;
  active?: Maybe<Scalars['Boolean']>;
  componentsToCreate?: Maybe<Array<Maybe<CreateRecipeComponentInput>>>;
  componentsToUpdate?: Maybe<Array<Maybe<UpdateRecipeComponentInput>>>;
  componentsToDelete?: Maybe<Array<Maybe<DeleteRecipeComponentInput>>>;
};

export type UpdateRoleInput = {
  id: Scalars['ID'];
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpdateRoomLoadTaskChecklistInput = {
  checklistSessionId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  parMeterCheckPlants?: Maybe<Scalars['Boolean']>;
  parMeterCheckPlantsNote?: Maybe<Scalars['String']>;
  measurePlantHeight?: Maybe<Scalars['Boolean']>;
  measurePlantHeightNote?: Maybe<Scalars['String']>;
  setUpHumidifiers?: Maybe<Scalars['Boolean']>;
  setUpHumidifiersNote?: Maybe<Scalars['String']>;
  roomAt82f72rh?: Maybe<Scalars['Boolean']>;
  roomAt82f72rhNote?: Maybe<Scalars['String']>;
  trolmasterWeek1Settings?: Maybe<Scalars['Boolean']>;
  trolmasterWeek1SettingsNote?: Maybe<Scalars['String']>;
  reinstallAroyaSensors?: Maybe<Scalars['Boolean']>;
  reinstallAroyaSensorsNote?: Maybe<Scalars['String']>;
  placeTrolmasterClimateSensors?: Maybe<Scalars['Boolean']>;
  placeTrolmasterClimateSensorsNote?: Maybe<Scalars['String']>;
  deployCatchCupsRunoffTrays?: Maybe<Scalars['Boolean']>;
  deployCatchCupsRunoffTraysNote?: Maybe<Scalars['String']>;
  doubleCheckNetbowsPluggedIn?: Maybe<Scalars['Boolean']>;
  doubleCheckNetbowsPluggedInNote?: Maybe<Scalars['String']>;
  placeMetrcTags?: Maybe<Scalars['Boolean']>;
  placeMetrcTagsNote?: Maybe<Scalars['String']>;
  add3LayersOfTrellis?: Maybe<Scalars['Boolean']>;
  add3LayersOfTrellisNote?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateRoomSurveyInput = {
  id: Scalars['ID'];
  zoneId: Scalars['ID'];
  growthPhase?: Maybe<Scalars['String']>;
  lightingPpfd?: Maybe<Scalars['Int']>;
  currentTemperature?: Maybe<Scalars['Decimal']>;
  currentHumidity?: Maybe<Scalars['Decimal']>;
  leafSurfaceTemperature?: Maybe<Scalars['Decimal']>;
  acOutletTemperature?: Maybe<Scalars['Decimal']>;
  vpdLevel?: Maybe<Scalars['Decimal']>;
  co2Level?: Maybe<Scalars['Decimal']>;
  lightingComponentsBulbs?: Maybe<Scalars['String']>;
  lightingComponentsBallasts?: Maybe<Scalars['String']>;
  lightingStatus?: Maybe<Scalars['String']>;
  acUnits?: Maybe<Scalars['String']>;
  dehumidifiers?: Maybe<Scalars['String']>;
  circulatingFans?: Maybe<Scalars['String']>;
  humidifiers?: Maybe<Scalars['String']>;
  dripLines?: Maybe<Scalars['String']>;
  pumps?: Maybe<Scalars['String']>;
  catchCups?: Maybe<Scalars['String']>;
  runoffCollectionPh?: Maybe<Scalars['Decimal']>;
  runoffCollectionEc?: Maybe<Scalars['Decimal']>;
  plantStressIndicator?: Maybe<Scalars['String']>;
  signsOfPests?: Maybe<Scalars['String']>;
  signsOfPathogens?: Maybe<Scalars['String']>;
  stickyTraps?: Maybe<Scalars['String']>;
  growingMediumPh?: Maybe<Scalars['Decimal']>;
  growingMediumEc?: Maybe<Scalars['Decimal']>;
  nutrientSolutionPh?: Maybe<Scalars['Decimal']>;
  nutrientSolutionEc?: Maybe<Scalars['Decimal']>;
  notes?: Maybe<Scalars['String']>;
};

export type UpdateRoomWalkthroughChecklistInput = {
  id: Scalars['ID'];
  timePeriod?: Maybe<Scalars['String']>;
  environmentFeel?: Maybe<Scalars['String']>;
  environmentalFeelNote?: Maybe<Scalars['String']>;
  airCirculation?: Maybe<Scalars['String']>;
  airCirculationNote?: Maybe<Scalars['String']>;
  lightsWorking?: Maybe<Scalars['String']>;
  lightsWorkingNote?: Maybe<Scalars['String']>;
  overallPlantHealth?: Maybe<Scalars['String']>;
  overallPlantHealthNote?: Maybe<Scalars['String']>;
  rootHealth?: Maybe<Scalars['String']>;
  rootHealthNote?: Maybe<Scalars['String']>;
  wiltingPlants?: Maybe<Scalars['String']>;
  wiltingPlantsLocation?: Maybe<Scalars['String']>;
  yellowingDiscoloration?: Maybe<Scalars['String']>;
  yellowingDiscolorationNote?: Maybe<Scalars['String']>;
  growthRate?: Maybe<Scalars['String']>;
  growthRateNote?: Maybe<Scalars['String']>;
  pestsVisible?: Maybe<Scalars['String']>;
  pestsType?: Maybe<Scalars['String']>;
  diseaseSigns?: Maybe<Scalars['String']>;
  diseaseSignsOther?: Maybe<Scalars['String']>;
  stickyTraps?: Maybe<Scalars['String']>;
  stickyTrapsNote?: Maybe<Scalars['String']>;
  hvacRunning?: Maybe<Scalars['String']>;
  hvacRunningNote?: Maybe<Scalars['String']>;
  dehumidifiers?: Maybe<Scalars['String']>;
  dehumidifiersNote?: Maybe<Scalars['String']>;
  irrigationSystem?: Maybe<Scalars['String']>;
  irrigationSystemNote?: Maybe<Scalars['String']>;
  filterCheck?: Maybe<Scalars['String']>;
  filterCheckNote?: Maybe<Scalars['String']>;
  tableDrains?: Maybe<Scalars['String']>;
  tableDrainsNote?: Maybe<Scalars['String']>;
  pumpsOperating?: Maybe<Scalars['String']>;
  pumpsOperatingNote?: Maybe<Scalars['String']>;
  unusualNoises?: Maybe<Scalars['String']>;
  unusualNoisesSource?: Maybe<Scalars['String']>;
  areaClean?: Maybe<Scalars['String']>;
  areaCleanNote?: Maybe<Scalars['String']>;
  spillsPresent?: Maybe<Scalars['String']>;
  spillsLocation?: Maybe<Scalars['String']>;
  toolsPutAway?: Maybe<Scalars['String']>;
  toolsPutAwayNote?: Maybe<Scalars['String']>;
  benchSpacing?: Maybe<Scalars['String']>;
  benchSpacingNote?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  followUpRequired?: Maybe<Scalars['String']>;
  skipReason?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
};

export type UpdateSiteCredentialsInput = {
  siteId: Scalars['ID'];
  licenseNumber: Scalars['String'];
  userKey: Scalars['String'];
  metrcState: Scalars['String'];
};

export type UpdateSiteInput = {
  siteId: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateSiteSensorBrandsInput = {
  siteId: Scalars['ID'];
  activeBrands: Array<Maybe<Scalars['String']>>;
};

export type UpdateStageConflictInput = {
  schedulingRule?: Maybe<Scalars['String']>;
  calendarBranchId: Scalars['ID'];
  stageId: Scalars['ID'];
  patch?: Maybe<UpdateStageConflictPatchInput>;
};

export type UpdateStageConflictPatchInput = {
  justification: Scalars['String'];
};

export type UpdateStageInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  zoneId?: Maybe<Scalars['String']>;
  upsertStrainsInStage: Array<UpdateStrainInStageInput>;
  removeStrainsInStage?: Maybe<Array<DeleteStrainInStageInput>>;
};

export type UpdateStrainInStageInput = {
  strainId: Scalars['ID'];
  numberOfPlants: Scalars['Int'];
};

export type UpdateStrainInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  abbreviation?: Maybe<Scalars['String']>;
  subspecies?: Maybe<Scalars['String']>;
  documentationUrl?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
};

export type UpdateTaskConflictInput = {
  schedulingRule?: Maybe<Scalars['String']>;
  calendarBranchId: Scalars['ID'];
  taskId: Scalars['ID'];
  patch?: Maybe<UpdateTaskConflictPatchInput>;
};

export type UpdateTaskConflictPatchInput = {
  justification: Scalars['String'];
};

export type UpdateTaskInput = {
  id: Scalars['ID'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  assignedToId?: Maybe<Scalars['ID']>;
};

export type UpdateTimeOffsetInput = {
  fileId: Scalars['ID'];
  offsetSeconds: Scalars['Int'];
};

export type UpdateTransplantTaskChecklistInput = {
  checklistSessionId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  handChargeCocosWithCalciumNitrate?: Maybe<Scalars['Boolean']>;
  handChargeCocosWithCalciumNitrateNote?: Maybe<Scalars['String']>;
  plugInAroyaSensors?: Maybe<Scalars['Boolean']>;
  plugInAroyaSensorsNote?: Maybe<Scalars['String']>;
  addGypsumAndCalciumCarbonateRinse?: Maybe<Scalars['Boolean']>;
  addGypsumAndCalciumCarbonateRinseNote?: Maybe<Scalars['String']>;
  transplantClonesIntoPots?: Maybe<Scalars['Boolean']>;
  transplantClonesIntoPotsNote?: Maybe<Scalars['String']>;
  topOffEachPlantWithVegFeed?: Maybe<Scalars['Boolean']>;
  topOffEachPlantWithVegFeedNote?: Maybe<Scalars['String']>;
  plugInNetbows?: Maybe<Scalars['Boolean']>;
  plugInNetbowsNote?: Maybe<Scalars['String']>;
  placeMetrcTags?: Maybe<Scalars['Boolean']>;
  placeMetrcTagsNote?: Maybe<Scalars['String']>;
  cleanAndSanitizeCloneTablesTrays?: Maybe<Scalars['Boolean']>;
  cleanAndSanitizeCloneTablesTraysNote?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateTrolmasterDeviceInput = {
  id: Scalars['ID'];
  trolmasterMacAddress?: Maybe<Scalars['String']>;
  trolmasterModel?: Maybe<Scalars['String']>;
};

export enum UpdateTypeEnum {
  NewEvent = 'NEW_EVENT',
  DateChange = 'DATE_CHANGE'
}

export type UpdateUserActiveInput = {
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
};

export type UpdateUserInput = {
  id: Scalars['ID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
  isNoLogin?: Maybe<Scalars['Boolean']>;
  userPermissions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpdateUserNotificationPreferenceInput = {
  notificationType: Scalars['String'];
  optedOut: Scalars['Boolean'];
  userId?: Maybe<Scalars['ID']>;
};

export type UpdateUserProfileInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type UpdateUserProfileResult = UpdateUserProfileSuccess | Error;

export type UpdateUserProfileSuccess = {
  __typename?: 'UpdateUserProfileSuccess';
  user?: Maybe<UserProfile>;
};

export type UpdateWaterQualityChecklistInput = {
  checklistSessionId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  issuesFoundSummary?: Maybe<Scalars['String']>;
  correctiveActionSummary?: Maybe<Scalars['String']>;
  readings?: Maybe<Array<Maybe<WaterQualityStationReadingInput>>>;
  id: Scalars['ID'];
};

export type UpdateWaterRoomChecklistInput = {
  checklistSessionId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  photos?: Maybe<Scalars['JSONString']>;
  roomTemp?: Maybe<Scalars['Decimal']>;
  f1Level?: Maybe<Scalars['Decimal']>;
  f1Ph?: Maybe<Scalars['Decimal']>;
  f1Ec?: Maybe<Scalars['Decimal']>;
  f1TankTemp?: Maybe<Scalars['Decimal']>;
  f2Level?: Maybe<Scalars['Decimal']>;
  f2Ph?: Maybe<Scalars['Decimal']>;
  f2Ec?: Maybe<Scalars['Decimal']>;
  f2TankTemp?: Maybe<Scalars['Decimal']>;
  f3Level?: Maybe<Scalars['Decimal']>;
  f3Ph?: Maybe<Scalars['Decimal']>;
  f3Ec?: Maybe<Scalars['Decimal']>;
  f3TankTemp?: Maybe<Scalars['Decimal']>;
  f4Level?: Maybe<Scalars['Decimal']>;
  f4Ph?: Maybe<Scalars['Decimal']>;
  f4Ec?: Maybe<Scalars['Decimal']>;
  f4TankTemp?: Maybe<Scalars['Decimal']>;
  f5Level?: Maybe<Scalars['Decimal']>;
  f5Ph?: Maybe<Scalars['Decimal']>;
  f5Ec?: Maybe<Scalars['Decimal']>;
  f5TankTemp?: Maybe<Scalars['Decimal']>;
  f6Level?: Maybe<Scalars['Decimal']>;
  f6Ph?: Maybe<Scalars['Decimal']>;
  f6Ec?: Maybe<Scalars['Decimal']>;
  f6TankTemp?: Maybe<Scalars['Decimal']>;
  combinedVegTankLevel?: Maybe<Scalars['Decimal']>;
  vegTankPh?: Maybe<Scalars['Decimal']>;
  vegTankEc?: Maybe<Scalars['Decimal']>;
  vegTankTemp?: Maybe<Scalars['Decimal']>;
  roHoseValveClosed?: Maybe<Scalars['Boolean']>;
  dechlorHoseValveClosed?: Maybe<Scalars['Boolean']>;
  dishPitHoseValveClosed?: Maybe<Scalars['Boolean']>;
  flowerBaseStockLevel?: Maybe<Scalars['Decimal']>;
  flowerCalciumStockLevel?: Maybe<Scalars['Decimal']>;
  flowerPhStockLevel?: Maybe<Scalars['Decimal']>;
  vegBaseStockLevel?: Maybe<Scalars['Decimal']>;
  vegCalciumStockLevel?: Maybe<Scalars['Decimal']>;
  vegPhStockLevel?: Maybe<Scalars['Decimal']>;
  amHeaterValveCloseAndTempCheck?: Maybe<Scalars['Decimal']>;
  pmHeaterValveOpen?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateZoneInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  maxConcurrentHarvestGroups?: Maybe<Scalars['Int']>;
  maxConcurrentPlants?: Maybe<Scalars['Int']>;
  cultivationStyleId?: Maybe<Scalars['String']>;
  cultivationStyleOther?: Maybe<Scalars['String']>;
  irrigationStyleId?: Maybe<Scalars['String']>;
  irrigationStyleOther?: Maybe<Scalars['String']>;
  irrigationFrequencyId?: Maybe<Scalars['String']>;
  irrigationFrequencyOther?: Maybe<Scalars['String']>;
  irrigationTypeId?: Maybe<Scalars['String']>;
  irrigationTypeOther?: Maybe<Scalars['String']>;
  growingMediaId?: Maybe<Scalars['String']>;
  rockwoolBrandId?: Maybe<Scalars['String']>;
  rockwoolBrandOther?: Maybe<Scalars['String']>;
  rockwoolSizeId?: Maybe<Scalars['String']>;
  rockwoolSizeOther?: Maybe<Scalars['String']>;
  cocoBrandId?: Maybe<Scalars['String']>;
  cocoBrandOther?: Maybe<Scalars['String']>;
  cocoContainerSize?: Maybe<Scalars['String']>;
  cocoContainerSizeOtherGallons?: Maybe<Scalars['Float']>;
  soilBrandId?: Maybe<Scalars['String']>;
  soilBrandOther?: Maybe<Scalars['String']>;
  soilContainerSize?: Maybe<Scalars['String']>;
  lengthFeet?: Maybe<Scalars['Float']>;
  lengthInches?: Maybe<Scalars['Float']>;
  heightFeet?: Maybe<Scalars['Float']>;
  heightInches?: Maybe<Scalars['Float']>;
  widthFeet?: Maybe<Scalars['Float']>;
  widthInches?: Maybe<Scalars['Float']>;
  rows?: Maybe<Scalars['Int']>;
  roomUsage?: Maybe<Scalars['String']>;
  numLightsUnderCanopy?: Maybe<Scalars['Int']>;
  underCanopy?: Maybe<Scalars['Boolean']>;
  underCanopyBrandId?: Maybe<Scalars['String']>;
  underCanopyBrandOther?: Maybe<Scalars['String']>;
  benchSqFt?: Maybe<Scalars['Int']>;
  tiers?: Maybe<Scalars['String']>;
  controlSystemId?: Maybe<Scalars['String']>;
  controlSystemOther?: Maybe<Scalars['String']>;
  sensorsId?: Maybe<Scalars['String']>;
  sensorsOther?: Maybe<Scalars['String']>;
  rootZoneSensorId?: Maybe<Scalars['String']>;
  rootZoneSensorOther?: Maybe<Scalars['String']>;
  dripEmitterSize?: Maybe<Scalars['Decimal']>;
  dehumidifierSelections?: Maybe<Array<Maybe<DehumidifierSelectionInput>>>;
  circulatingFanSelections?: Maybe<Array<Maybe<CirculatingFanSelectionInput>>>;
  acSelections?: Maybe<Array<Maybe<AcSelectionInput>>>;
  lightingTypeSelections?: Maybe<Array<Maybe<LightingTypeSelectionInput>>>;
};

export type UpsertHarvestGroupAutoCreationConfigInput = {
  siteId: Scalars['ID'];
  templateId: Scalars['ID'];
  stageZoneOrders: Array<StageZoneOrderInput>;
  intervalDays: Scalars['Int'];
  startDate: Scalars['Date'];
  isEnabled: Scalars['Boolean'];
  fillAllRooms?: Maybe<Scalars['Boolean']>;
  planningHorizonMonths?: Maybe<Scalars['Int']>;
  metrcSyncFloweringDates?: Maybe<Scalars['Boolean']>;
  metrcSyncHarvestDates?: Maybe<Scalars['Boolean']>;
};

export type UserFilterSetInput = {
  email_Icontains?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
};

export type UserNotificationPreference = {
  __typename?: 'UserNotificationPreference';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  user: UserProfile;
  notificationType: UserNotificationPreferenceNotificationType;
  optedOut: Scalars['Boolean'];
};

export enum UserNotificationPreferenceNotificationType {
  CultivationActivity = 'CULTIVATION_ACTIVITY',
  Environmental = 'ENVIRONMENTAL',
  DailyGrower = 'DAILY_GROWER',
  WeeklyReview = 'WEEKLY_REVIEW',
  IssueAlert = 'ISSUE_ALERT',
  ChecklistCompletion = 'CHECKLIST_COMPLETION',
  HarvestReport = 'HARVEST_REPORT',
  CalendarBranchApproval = 'CALENDAR_BRANCH_APPROVAL'
}

export type UserNotificationPreferenceResult = UserNotificationPreference | Error;

export type UserProfile = {
  __typename?: 'UserProfile';
  lastLogin?: Maybe<Scalars['DateTime']>;
  isSuperuser: Scalars['Boolean'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  isStaff: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  id: Scalars['String'];
  organization?: Maybe<Organization>;
  isNoLogin: Scalars['Boolean'];
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  salesManagerGroup?: Maybe<UserSalesManagerGroup>;
  notificationPreferences: Array<UserNotificationPreference>;
  userPermissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  organizationId?: Maybe<Scalars['String']>;
};

export type UserProfileResult = UserProfile | Error;

export enum UserSalesManagerGroup {
  Elevated = 'ELEVATED',
  Plantminded = 'PLANTMINDED',
  Sidehustle = 'SIDEHUSTLE',
  PdsStaff = 'PDS_STAFF',
  IcSolutions = 'IC_SOLUTIONS',
  Tcra = 'TCRA',
  KeeganCrew = 'KEEGAN_CREW',
  Holistic = 'HOLISTIC'
}

export type ValidateDeviceQrCodeInput = {
  qrCodeData: Scalars['String'];
};

export type ValidateDeviceQrCodeResult = {
  __typename?: 'ValidateDeviceQrCodeResult';
  macAddress?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
};

export type ValidateOrganizationMetrcApiKeyResult = ValidateOrganizationMetrcApiKeySuccess | Error;

export type ValidateOrganizationMetrcApiKeySuccess = {
  __typename?: 'ValidateOrganizationMetrcApiKeySuccess';
  facilities: Array<MetrcApiKeyFacility>;
};

export type ValidationConflict = {
  __typename?: 'ValidationConflict';
  type?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  stageName?: Maybe<Scalars['String']>;
  taskName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  suggestedFix?: Maybe<Scalars['String']>;
  harvestGroupId?: Maybe<Scalars['ID']>;
  harvestGroupName?: Maybe<Scalars['String']>;
  customStages?: Maybe<Array<Maybe<Scalars['String']>>>;
  durationChange?: Maybe<Scalars['Int']>;
  oldDuration?: Maybe<Scalars['Int']>;
  newDuration?: Maybe<Scalars['Int']>;
  affectedStages?: Maybe<Array<Maybe<AffectedStageInfo>>>;
  currentStartDate?: Maybe<Scalars['String']>;
  currentEndDate?: Maybe<Scalars['String']>;
  newStartDate?: Maybe<Scalars['String']>;
  newEndDate?: Maybe<Scalars['String']>;
  taskStartDay?: Maybe<Scalars['Int']>;
  taskEndDay?: Maybe<Scalars['Int']>;
};

export type VerifyMetrcImportOutput = {
  __typename?: 'VerifyMetrcImportOutput';
  newLocations?: Maybe<Array<Maybe<MetrcLocation>>>;
  newStrains?: Maybe<Array<Maybe<MetrcStrain>>>;
  newBudFormFactors?: Maybe<Array<Maybe<MetrcBudFormFactor>>>;
  existingBudFormFactors?: Maybe<Array<Maybe<BudFormFactor>>>;
  rotationAnalysis?: Maybe<MetrcRotationAnalysis>;
  bffDebug?: Maybe<BffDebug>;
};

export type VerifySensorReplacement = {
  __typename?: 'VerifySensorReplacement';
  result?: Maybe<Scalars['GenericScalar']>;
};

export type WaterQualityChecklist = {
  __typename?: 'WaterQualityChecklist';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklistSession: ChecklistSession;
  inspector?: Maybe<UserProfile>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['GenericScalar']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  issuesFoundSummary?: Maybe<Scalars['String']>;
  correctiveActionSummary?: Maybe<Scalars['String']>;
  readings?: Maybe<Array<Maybe<WaterQualityStationReading>>>;
};

export type WaterQualityChecklistInput = {
  checklistSessionId: Scalars['ID'];
  inspectorId?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['JSONString']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  issuesFoundSummary?: Maybe<Scalars['String']>;
  correctiveActionSummary?: Maybe<Scalars['String']>;
  readings?: Maybe<Array<Maybe<WaterQualityStationReadingInput>>>;
};

export type WaterQualityChecklistResult = WaterQualityChecklist | Error;

export type WaterQualityStationReading = {
  __typename?: 'WaterQualityStationReading';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklist: WaterQualityChecklist;
  station: WaterQualityStationReadingStation;
  item: WaterQualityStationReadingItem;
  target: Scalars['String'];
  reading?: Maybe<Scalars['Decimal']>;
  passFail: WaterQualityStationReadingPassFail;
  notes?: Maybe<Scalars['String']>;
  correctiveAction?: Maybe<Scalars['String']>;
};

export type WaterQualityStationReadingInput = {
  id?: Maybe<Scalars['ID']>;
  station: Scalars['String'];
  item: Scalars['String'];
  target?: Maybe<Scalars['String']>;
  reading?: Maybe<Scalars['Decimal']>;
  passFail?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  correctiveAction?: Maybe<Scalars['String']>;
};

export enum WaterQualityStationReadingItem {
  ChlorineDioxide = 'CHLORINE_DIOXIDE',
  Orp = 'ORP',
  Ph = 'PH',
  EcPpm = 'EC_PPM',
  Temperature = 'TEMPERATURE',
  Do = 'DO'
}

export enum WaterQualityStationReadingPassFail {
  Pass = 'PASS',
  Fail = 'FAIL',
  NotRecorded = 'NOT_RECORDED'
}

export enum WaterQualityStationReadingStation {
  FrontTank = 'FRONT_TANK',
  BackTank = 'BACK_TANK',
  InsideRo = 'INSIDE_RO',
  PostCarbon = 'POST_CARBON'
}

export type WaterRoomChecklist = {
  __typename?: 'WaterRoomChecklist';
  v1Id?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  checklistSession: ChecklistSession;
  inspector?: Maybe<UserProfile>;
  zone?: Maybe<Zone>;
  roomTemp?: Maybe<Scalars['Decimal']>;
  f1Level?: Maybe<Scalars['Decimal']>;
  f1Ph?: Maybe<Scalars['Decimal']>;
  f1Ec?: Maybe<Scalars['Decimal']>;
  f1TankTemp?: Maybe<Scalars['Decimal']>;
  f2Level?: Maybe<Scalars['Decimal']>;
  f2Ph?: Maybe<Scalars['Decimal']>;
  f2Ec?: Maybe<Scalars['Decimal']>;
  f2TankTemp?: Maybe<Scalars['Decimal']>;
  f3Level?: Maybe<Scalars['Decimal']>;
  f3Ph?: Maybe<Scalars['Decimal']>;
  f3Ec?: Maybe<Scalars['Decimal']>;
  f3TankTemp?: Maybe<Scalars['Decimal']>;
  f4Level?: Maybe<Scalars['Decimal']>;
  f4Ph?: Maybe<Scalars['Decimal']>;
  f4Ec?: Maybe<Scalars['Decimal']>;
  f4TankTemp?: Maybe<Scalars['Decimal']>;
  f5Level?: Maybe<Scalars['Decimal']>;
  f5Ph?: Maybe<Scalars['Decimal']>;
  f5Ec?: Maybe<Scalars['Decimal']>;
  f5TankTemp?: Maybe<Scalars['Decimal']>;
  f6Level?: Maybe<Scalars['Decimal']>;
  f6Ph?: Maybe<Scalars['Decimal']>;
  f6Ec?: Maybe<Scalars['Decimal']>;
  f6TankTemp?: Maybe<Scalars['Decimal']>;
  combinedVegTankLevel?: Maybe<Scalars['Decimal']>;
  vegTankPh?: Maybe<Scalars['Decimal']>;
  vegTankEc?: Maybe<Scalars['Decimal']>;
  vegTankTemp?: Maybe<Scalars['Decimal']>;
  roHoseValveClosed?: Maybe<Scalars['Boolean']>;
  dechlorHoseValveClosed?: Maybe<Scalars['Boolean']>;
  dishPitHoseValveClosed?: Maybe<Scalars['Boolean']>;
  flowerBaseStockLevel?: Maybe<Scalars['Decimal']>;
  flowerCalciumStockLevel?: Maybe<Scalars['Decimal']>;
  flowerPhStockLevel?: Maybe<Scalars['Decimal']>;
  vegBaseStockLevel?: Maybe<Scalars['Decimal']>;
  vegCalciumStockLevel?: Maybe<Scalars['Decimal']>;
  vegPhStockLevel?: Maybe<Scalars['Decimal']>;
  amHeaterValveCloseAndTempCheck?: Maybe<Scalars['Decimal']>;
  pmHeaterValveOpen?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Scalars['GenericScalar']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
};

export type WaterRoomChecklistInput = {
  checklistSessionId: Scalars['ID'];
  zoneId?: Maybe<Scalars['ID']>;
  inspectorId?: Maybe<Scalars['ID']>;
  timeCompleted?: Maybe<Scalars['DateTime']>;
  photos?: Maybe<Scalars['JSONString']>;
  roomTemp?: Maybe<Scalars['Decimal']>;
  f1Level?: Maybe<Scalars['Decimal']>;
  f1Ph?: Maybe<Scalars['Decimal']>;
  f1Ec?: Maybe<Scalars['Decimal']>;
  f1TankTemp?: Maybe<Scalars['Decimal']>;
  f2Level?: Maybe<Scalars['Decimal']>;
  f2Ph?: Maybe<Scalars['Decimal']>;
  f2Ec?: Maybe<Scalars['Decimal']>;
  f2TankTemp?: Maybe<Scalars['Decimal']>;
  f3Level?: Maybe<Scalars['Decimal']>;
  f3Ph?: Maybe<Scalars['Decimal']>;
  f3Ec?: Maybe<Scalars['Decimal']>;
  f3TankTemp?: Maybe<Scalars['Decimal']>;
  f4Level?: Maybe<Scalars['Decimal']>;
  f4Ph?: Maybe<Scalars['Decimal']>;
  f4Ec?: Maybe<Scalars['Decimal']>;
  f4TankTemp?: Maybe<Scalars['Decimal']>;
  f5Level?: Maybe<Scalars['Decimal']>;
  f5Ph?: Maybe<Scalars['Decimal']>;
  f5Ec?: Maybe<Scalars['Decimal']>;
  f5TankTemp?: Maybe<Scalars['Decimal']>;
  f6Level?: Maybe<Scalars['Decimal']>;
  f6Ph?: Maybe<Scalars['Decimal']>;
  f6Ec?: Maybe<Scalars['Decimal']>;
  f6TankTemp?: Maybe<Scalars['Decimal']>;
  combinedVegTankLevel?: Maybe<Scalars['Decimal']>;
  vegTankPh?: Maybe<Scalars['Decimal']>;
  vegTankEc?: Maybe<Scalars['Decimal']>;
  vegTankTemp?: Maybe<Scalars['Decimal']>;
  roHoseValveClosed?: Maybe<Scalars['Boolean']>;
  dechlorHoseValveClosed?: Maybe<Scalars['Boolean']>;
  dishPitHoseValveClosed?: Maybe<Scalars['Boolean']>;
  flowerBaseStockLevel?: Maybe<Scalars['Decimal']>;
  flowerCalciumStockLevel?: Maybe<Scalars['Decimal']>;
  flowerPhStockLevel?: Maybe<Scalars['Decimal']>;
  vegBaseStockLevel?: Maybe<Scalars['Decimal']>;
  vegCalciumStockLevel?: Maybe<Scalars['Decimal']>;
  vegPhStockLevel?: Maybe<Scalars['Decimal']>;
  amHeaterValveCloseAndTempCheck?: Maybe<Scalars['Decimal']>;
  pmHeaterValveOpen?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
};

export type WaterRoomChecklistResult = WaterRoomChecklist | Error;

export type WeeklyEnvironmentalData = {
  __typename?: 'WeeklyEnvironmentalData';
  week: Scalars['Int'];
  stageName: Scalars['String'];
  environmentalType: Scalars['String'];
  temperature: WeeklyEnvironmentalMetric;
  humidity: WeeklyEnvironmentalMetric;
  co2: WeeklyEnvironmentalMetric;
  vpd: WeeklyEnvironmentalMetric;
};

export type WeeklyEnvironmentalMetric = {
  __typename?: 'WeeklyEnvironmentalMetric';
  compliant?: Maybe<Scalars['Boolean']>;
  deviation?: Maybe<Scalars['Float']>;
  percentInRange?: Maybe<Scalars['Float']>;
};

export enum YieldProductStream {
  Dry = 'DRY',
  WetPackaged = 'WET_PACKAGED',
  Mixed = 'MIXED',
  Unknown = 'UNKNOWN'
}

export type Zone = {
  __typename?: 'Zone';
  id: Scalars['String'];
  name: Scalars['String'];
  active: Scalars['Boolean'];
  maxConcurrentHarvestGroups?: Maybe<Scalars['Int']>;
  maxConcurrentPlants?: Maybe<Scalars['Int']>;
  site: OrganizationSite;
  metrcId?: Maybe<Scalars['String']>;
  lightingClassification?: Maybe<ZoneLightingClassification>;
  dayStartTime?: Maybe<Scalars['Time']>;
  nightStartTime?: Maybe<Scalars['Time']>;
  lengthFeet?: Maybe<Scalars['Int']>;
  lengthInches?: Maybe<Scalars['Int']>;
  heightFeet?: Maybe<Scalars['Int']>;
  heightInches?: Maybe<Scalars['Int']>;
  widthFeet?: Maybe<Scalars['Int']>;
  widthInches?: Maybe<Scalars['Int']>;
  benchSqFt?: Maybe<Scalars['Int']>;
  rows?: Maybe<Scalars['Int']>;
  numLightsUnderCanopy?: Maybe<Scalars['Int']>;
  cultivationStyle?: Maybe<CultivationStyle>;
  roomUsage?: Maybe<ZoneRoomUsage>;
  tiers?: Maybe<ZoneTiers>;
  controlSystem?: Maybe<ControlSystem>;
  sensors?: Maybe<Sensors>;
  rootZoneSensor?: Maybe<Sensors>;
  underCanopy?: Maybe<Scalars['Boolean']>;
  underCanopyBrand?: Maybe<UnderCanopyBrand>;
  growingMedia?: Maybe<GrowingMedia>;
  rockwoolBrand?: Maybe<RockwoolBrand>;
  rockwoolSize?: Maybe<RockwoolSize>;
  cocoBrand?: Maybe<CocoBrand>;
  cocoContainerSize?: Maybe<ZoneCocoContainerSize>;
  cocoContainerSizeOtherGallons?: Maybe<Scalars['Float']>;
  soilBrand?: Maybe<SoilBrand>;
  soilContainerSize?: Maybe<ZoneSoilContainerSize>;
  irrigationStyle?: Maybe<IrrigationStyle>;
  irrigationFrequency?: Maybe<IrrigationFrequency>;
  irrigationType?: Maybe<IrrigationType>;
  dripEmitterSize?: Maybe<Scalars['Decimal']>;
  dehumidifierSelections: Array<DehumidifierSelection>;
  circulatingFanSelections: Array<CirculatingFanSelection>;
  lightingTypeSelections: Array<LightingTypeSelection>;
  acSelections: Array<AcSelection>;
  observationSummary?: Maybe<ZoneObservationSummary>;
  currentHarvestGroups: Array<HarvestGroup>;
  primaryDevice?: Maybe<EnvironmentalDevice>;
};

export enum ZoneCocoContainerSize {
  HalfGallon = 'HALF_GALLON',
  OneGallon = 'ONE_GALLON',
  TwoGallon = 'TWO_GALLON',
  ThreeGallon = 'THREE_GALLON',
  FiveGallon = 'FIVE_GALLON',
  SevenGallon = 'SEVEN_GALLON',
  TenGallon = 'TEN_GALLON',
  TwentyGallon = 'TWENTY_GALLON',
  Other = 'OTHER'
}

export type ZoneFilterSetInput = {
  active?: Maybe<Scalars['Boolean']>;
  siteId?: Maybe<Scalars['String']>;
};

export enum ZoneLightingClassification {
  Default = 'DEFAULT',
  DoubleEndedHps = 'DOUBLE_ENDED_HPS',
  Cmh = 'CMH',
  Led = 'LED',
  Other = 'OTHER'
}

export type ZoneObservationMetric = {
  __typename?: 'ZoneObservationMetric';
  mean: Scalars['Float'];
  key: Scalars['String'];
  label: Scalars['String'];
  unit: Scalars['String'];
  category: Scalars['String'];
  sensors: Array<SensorObservationMetric>;
};

export type ZoneObservationSummary = {
  __typename?: 'ZoneObservationSummary';
  metrics: Array<ZoneObservationMetric>;
  day: Scalars['Date'];
  sourceCount: Scalars['Int'];
  reportingSourceCount: Scalars['Int'];
  latestObservation?: Maybe<Scalars['DateTime']>;
};

export type ZoneResult = Zone | Error;

export enum ZoneRoomUsage {
  Vegetative = 'VEGETATIVE',
  Propagation = 'PROPAGATION',
  Mother = 'MOTHER',
  Flower = 'FLOWER',
  Other = 'OTHER'
}

export type ZoneScheduleUpdateInput = {
  id: Scalars['ID'];
  lightingClassification?: Maybe<Scalars['String']>;
  dayStartTime?: Maybe<Scalars['String']>;
  nightStartTime?: Maybe<Scalars['String']>;
};

export enum ZoneSoilContainerSize {
  HalfGallon = 'HALF_GALLON',
  OneGallon = 'ONE_GALLON',
  TwoGallon = 'TWO_GALLON',
  ThreeGallon = 'THREE_GALLON',
  FiveGallon = 'FIVE_GALLON',
  SevenGallon = 'SEVEN_GALLON',
  TenGallon = 'TEN_GALLON',
  TwentyGallon = 'TWENTY_GALLON',
  Other = 'OTHER'
}

export enum ZoneTiers {
  Single = 'SINGLE',
  Double = 'DOUBLE',
  Triple = 'TRIPLE'
}

export type CalendarBranchQueryVariables = Exact<{
  id?: Maybe<Scalars['String']>;
  dateRange?: Maybe<DateRangeInput>;
}>;


export type CalendarBranchQuery = { __typename?: 'Query', calendarBranch: (
    { __typename?: 'CalendarBranch' }
    & CalendarBranchFieldsFragment
  ) };

export type CalendarBranchesQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendarBranchesQuery = { __typename?: 'Query', calendarBranches?: Maybe<Array<(
    { __typename?: 'CalendarBranch' }
    & CalendarBranchesGeneralInfoFieldsFragment
  )>> };

export type CalendarBranchMergeLogEntriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendarBranchMergeLogEntriesQuery = { __typename?: 'Query', calendarBranchMergeLogEntries?: Maybe<Array<{ __typename?: 'CalendarBranchMergeLogEntry', id: any, calendarBranchName: string, mergedAt: any, changelog?: Maybe<any>, mergedBy?: Maybe<{ __typename?: 'UserProfile', id: string, firstName: string, lastName: string }> }>> };

export type CalendarBranchFieldsFragment = (
  { __typename?: 'CalendarBranch', id: any, name: string, status: CalendarBranchStatus, updatedAt: any, createdBy?: Maybe<{ __typename?: 'UserProfile', id: string }>, stages: Array<(
    { __typename?: 'Stage' }
    & StageCalendarFieldsFragment
  )>, tasks: Array<(
    { __typename?: 'Task' }
    & TaskCalendarFieldsFragment
  )> }
  & UpdateAndConflictDisplaysFragment
);

export type ShortCalendarBranchFieldsFragment = { __typename?: 'CalendarBranch', id: any, name: string, status: CalendarBranchStatus, updatedAt: any, createdBy?: Maybe<{ __typename?: 'UserProfile', id: string }> };

export type CalendarBranchesGeneralInfoFieldsFragment = { __typename?: 'CalendarBranch', id: any, name: string, createdAt: any, updatedAt: any, status: CalendarBranchStatus, updateCount: number, conflictCount: number, createdBy?: Maybe<{ __typename?: 'UserProfile', id: string, firstName: string, lastName: string }>, lastUpdatedBy?: Maybe<{ __typename?: 'UserProfile', id: string, firstName: string, lastName: string }> };

export type UpdateAndConflictDisplaysFragment = { __typename?: 'CalendarBranch', updates: Array<{ __typename?: 'UpdateDisplay', changeDescription: string, harvestGroupName: string, name: string, id: string, updateType: UpdateTypeEnum, colorHexCode: string, undoable: boolean, targetType: TargetTypeEnum }>, conflicts: Array<{ __typename?: 'ConflictDisplay', id: string, conflictType: string, description: string, harvestGroupName: string, name: string, colorHexCode: string, calendarBranchId: string, justification: string, schedulingRule: string }> };

export type CreateCalendarBranchMutationVariables = Exact<{
  input: CreateCalendarBranchInput;
}>;


export type CreateCalendarBranchMutation = { __typename?: 'Mutation', createCalendarBranch?: Maybe<(
    { __typename?: 'CalendarBranch' }
    & ShortCalendarBranchFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type DuplicateCalendarBranchMutationVariables = Exact<{
  input: DuplicateCalendarBranchInput;
}>;


export type DuplicateCalendarBranchMutation = { __typename?: 'Mutation', duplicateCalendarBranch?: Maybe<(
    { __typename?: 'CalendarBranch' }
    & ShortCalendarBranchFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateCalendarBranchTaskMutationVariables = Exact<{
  input: UpdateCalendarBranchTaskInput;
  dateRange?: Maybe<DateRangeInput>;
}>;


export type UpdateCalendarBranchTaskMutation = { __typename?: 'Mutation', updateCalendarBranchTask?: Maybe<(
    { __typename?: 'CalendarBranch' }
    & CalendarBranchFieldsFragment
  ) | { __typename?: 'Error' }> };

export type UpdateCalendarBranchStageMutationVariables = Exact<{
  input: UpdateCalendarBranchStageInput;
  dateRange?: Maybe<DateRangeInput>;
}>;


export type UpdateCalendarBranchStageMutation = { __typename?: 'Mutation', updateCalendarBranchStage?: Maybe<(
    { __typename?: 'CalendarBranch' }
    & CalendarBranchFieldsFragment
  ) | { __typename?: 'Error' }> };

export type UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutationVariables = Exact<{
  input: UpdateCalendarBranchStageInput;
}>;


export type UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutation = { __typename?: 'Mutation', updateCalendarBranchStageAndFollowingEventsInHarvestGroup?: Maybe<(
    { __typename?: 'CalendarBranch' }
    & ShortCalendarBranchFieldsFragment
  ) | { __typename?: 'Error' }> };

export type UndoBranchCalendarTaskUpdateMutationVariables = Exact<{
  input: UndoBranchCalendarTaskUpdateInput;
  dateRange?: Maybe<DateRangeInput>;
}>;


export type UndoBranchCalendarTaskUpdateMutation = { __typename?: 'Mutation', undoBranchCalendarTaskUpdate?: Maybe<(
    { __typename?: 'CalendarBranch' }
    & CalendarBranchFieldsFragment
  ) | { __typename?: 'Error' }> };

export type UndoBranchCalendarStageUpdateMutationVariables = Exact<{
  input: UndoBranchCalendarStageUpdateInput;
  dateRange?: Maybe<DateRangeInput>;
}>;


export type UndoBranchCalendarStageUpdateMutation = { __typename?: 'Mutation', undoBranchCalendarStageUpdate?: Maybe<(
    { __typename?: 'CalendarBranch' }
    & CalendarBranchFieldsFragment
  ) | { __typename?: 'Error' }> };

export type UpdateStageConflictMutationVariables = Exact<{
  input: UpdateStageConflictInput;
}>;


export type UpdateStageConflictMutation = { __typename?: 'Mutation', updateStageConflict?: Maybe<{ __typename?: 'CalendarBranch', id: any, name: string, status: CalendarBranchStatus, updatedAt: any, createdBy?: Maybe<{ __typename?: 'UserProfile', id: string }> } | { __typename?: 'Error', message: string }> };

export type UpdateTaskConflictMutationVariables = Exact<{
  input: UpdateTaskConflictInput;
}>;


export type UpdateTaskConflictMutation = { __typename?: 'Mutation', updateTaskConflict?: Maybe<{ __typename?: 'CalendarBranch', id: any, name: string, status: CalendarBranchStatus, updatedAt: any, createdBy?: Maybe<{ __typename?: 'UserProfile', id: string }> } | { __typename?: 'Error', message: string }> };

export type ApproveCalendarBranchMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApproveCalendarBranchMutation = { __typename?: 'Mutation', approveCalendarBranch?: Maybe<(
    { __typename?: 'CalendarBranch' }
    & CalendarBranchesGeneralInfoFieldsFragment
  ) | { __typename?: 'Error' }> };

export type DeleteCalendarBranchMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCalendarBranchMutation = { __typename?: 'Mutation', deleteCalendarBranch?: Maybe<{ __typename?: 'SuccessOK', ok: boolean } | { __typename?: 'Error', message: string }> };

export type StrainPerformanceQueryVariables = Exact<{
  strainId1: Scalars['String'];
  strainId2: Scalars['String'];
  strainId3: Scalars['String'];
  strainId4: Scalars['String'];
}>;


export type StrainPerformanceQuery = { __typename?: 'Query', strainPerformance: { __typename?: 'StrainPerformanceResult', strain1: { __typename?: 'Strain', id: any, name: string }, strainPerformance1: { __typename?: 'StrainPerformance', id: string, name: string, avgGramsPerPlant: number, harvests: Array<{ __typename?: 'HarvestStrainPerformance', finalPlantCount: number, gramsPerPlant: number, harvestDate: string, id: string, name: string, totalGrams: number, effectiveTotalGrams: number, totalFlowerGrams: number, byFormFactor: Array<{ __typename?: 'BudFormFactorYield', budFormFactorId: string, numberOfGrams: number }> }> }, strain2: { __typename?: 'Strain', id: any, name: string }, strainPerformance2: { __typename?: 'StrainPerformance', id: string, name: string, avgGramsPerPlant: number, harvests: Array<{ __typename?: 'HarvestStrainPerformance', finalPlantCount: number, gramsPerPlant: number, harvestDate: string, id: string, name: string, totalGrams: number, effectiveTotalGrams: number, totalFlowerGrams: number, byFormFactor: Array<{ __typename?: 'BudFormFactorYield', budFormFactorId: string, numberOfGrams: number }> }> }, strain3: { __typename?: 'Strain', id: any, name: string }, strainPerformance3: { __typename?: 'StrainPerformance', id: string, name: string, avgGramsPerPlant: number, harvests: Array<{ __typename?: 'HarvestStrainPerformance', finalPlantCount: number, gramsPerPlant: number, harvestDate: string, id: string, name: string, totalGrams: number, effectiveTotalGrams: number, totalFlowerGrams: number, byFormFactor: Array<{ __typename?: 'BudFormFactorYield', budFormFactorId: string, numberOfGrams: number }> }> }, strain4: { __typename?: 'Strain', id: any, name: string }, strainPerformance4: { __typename?: 'StrainPerformance', id: string, name: string, avgGramsPerPlant: number, harvests: Array<{ __typename?: 'HarvestStrainPerformance', finalPlantCount: number, gramsPerPlant: number, harvestDate: string, id: string, name: string, totalGrams: number, effectiveTotalGrams: number, totalFlowerGrams: number, byFormFactor: Array<{ __typename?: 'BudFormFactorYield', budFormFactorId: string, numberOfGrams: number }> }> }, allStrains: Array<{ __typename?: 'Strain', id: any, name: string }>, allBudFormFactors: Array<(
      { __typename?: 'BudFormFactor' }
      & BudFormFactorFieldsFragment
    )> } };

export type BestYieldingStrainsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  minHarvests?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  siteId?: Maybe<Scalars['String']>;
  productStream?: Maybe<YieldProductStream>;
}>;


export type BestYieldingStrainsQuery = { __typename?: 'Query', bestYieldingStrains: { __typename?: 'BestYieldingStrainsResult', productStream: YieldProductStream, excludedBatches: Array<{ __typename?: 'HarvestYieldBatch', id: string, name: string, issues: Array<string> }>, reconciliationBatches: Array<{ __typename?: 'HarvestYieldBatch', id: string, name: string, reconciliationGapGrams?: Maybe<number> }>, strains: Array<{ __typename?: 'StrainYieldPerformance', totalHarvests: number, totalPlants: number, totalGrams: number, totalFlowerGrams: number, avgGramsPerPlant: number, avgFlowerGramsPerPlant: number, strain: { __typename?: 'Strain', id: any, name: string }, harvests: Array<{ __typename?: 'HarvestStrainPerformance', id: string, name: string, harvestDate: string, totalGrams: number, totalFlowerGrams: number, finalPlantCount: number, gramsPerPlant: number, byFormFactor: Array<{ __typename?: 'BudFormFactorYield', budFormFactorId: string, numberOfGrams: number }> }> }>, allBudFormFactors: Array<(
      { __typename?: 'BudFormFactor' }
      & BudFormFactorFieldsFragment
    )> } };

export type HarvestAnalyticsQueryVariables = Exact<{
  unarchived?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
}>;


export type HarvestAnalyticsQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<{ __typename?: 'HarvestGroup', id: string, name: string, startDate?: Maybe<any>, harvestDate?: Maybe<any>, archivedAt?: Maybe<any>, flowerZone?: Maybe<{ __typename?: 'Zone', id: string, name: string }>, yields: Array<{ __typename?: 'HarvestStrainYield', id: any, totalGrams: number, finalPlantCount: number, yieldBatches: Array<(
        { __typename?: 'HarvestYieldBatch' }
        & YieldAnalysisBatchFragment
      )>, strain: { __typename?: 'Strain', id: any, name: string }, budFormFactorYields: Array<{ __typename?: 'BudFormFactorYield', numberOfGrams: number, budFormFactor: { __typename?: 'BudFormFactor', id: any, name: string } }> }> }>> };

export type TelemetryRoomsQueryVariables = Exact<{
  siteId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
}>;


export type TelemetryRoomsQuery = { __typename?: 'Query', telemetryRooms?: Maybe<Array<{ __typename?: 'Zone', id: string, name: string, site: { __typename?: 'OrganizationSite', id: any, name: string } }>> };

export type RoomTelemetryQueryVariables = Exact<{
  zoneId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
}>;


export type RoomTelemetryQuery = { __typename?: 'Query', roomTelemetry: { __typename?: 'RoomTelemetry', zoneId: string, roomName: string, timezone: string, startDate: any, endDate: any, expectedBins: number, nightPeriods: Array<{ __typename?: 'TelemetryNightPeriod', start: number, end: number }>, sources: Array<{ __typename?: 'TelemetrySource', id: string, name: string, primary: boolean, active: boolean, category: string, latestObservation?: Maybe<any>, metrics: Array<{ __typename?: 'TelemetryMetric', key: string, label: string, unit: string, category: string, observedBins: number, expectedBins: number, minimum: number, maximum: number, mean: number, dayMean?: Maybe<number>, nightMean?: Maybe<number>, constant: boolean, quality?: Maybe<(
          { __typename?: 'SensorMetricQuality' }
          & SensorMetricQualityFieldsFragment
        )>, points: Array<{ __typename?: 'TelemetryPoint', time: number, value?: Maybe<number> }> }> }> } };

export type SensorMetricQualityFieldsFragment = { __typename?: 'SensorMetricQuality', codes: Array<string>, messages: Array<string>, expectedSamples: number, observedSamples: number, coveragePercent: number, intervalMinutes: number, cadenceConfigured: boolean, latestObservation?: Maybe<any>, suspectedStuckDays: Array<string> };

export type HarvestGroupAutoCreationStageZoneOrderFieldsFragment = { __typename?: 'HarvestGroupAutoCreationStageZoneOrder', id: any, position: number, rotationStep: number, positionInStep: number, stageTemplate: { __typename?: 'StageTemplate', id: any, createdStageName: string, orderInProcess: number, environmentalTargetType: StageTemplateEnvironmentalTargetType, designatedZones: Array<{ __typename?: 'Zone', id: string, name: string, site: { __typename?: 'OrganizationSite', id: any, name: string } }> }, zone: { __typename?: 'Zone', id: string, name: string, site: { __typename?: 'OrganizationSite', id: any, name: string } } };

export type HarvestGroupAutoCreationStageCursorFieldsFragment = { __typename?: 'HarvestGroupAutoCreationStageCursor', id: any, cursor: number, stageTemplate: { __typename?: 'StageTemplate', id: any } };

export type HarvestGroupAutoCreationConfigFieldsFragment = { __typename?: 'HarvestGroupAutoCreationConfig', id: any, isEnabled: boolean, fillAllRooms: boolean, startDate: any, intervalDays: number, planningHorizonMonths: number, nextRunOn: any, lastRunAt?: Maybe<any>, lastSuccessAt?: Maybe<any>, lastErrorAt?: Maybe<any>, lastErrorMessage?: Maybe<string>, template: { __typename?: 'HarvestGroupTemplate', id: any, name: string }, site: { __typename?: 'OrganizationSite', id: any, name: string, metrcSyncFloweringDates: boolean, metrcSyncHarvestDates: boolean }, stageZoneOrders: Array<(
    { __typename?: 'HarvestGroupAutoCreationStageZoneOrder' }
    & HarvestGroupAutoCreationStageZoneOrderFieldsFragment
  )>, stageCursors: Array<(
    { __typename?: 'HarvestGroupAutoCreationStageCursor' }
    & HarvestGroupAutoCreationStageCursorFieldsFragment
  )> };

export type HarvestGroupAutoCreationConfigsQueryVariables = Exact<{
  siteId?: Maybe<Scalars['String']>;
}>;


export type HarvestGroupAutoCreationConfigsQuery = { __typename?: 'Query', harvestGroupAutoCreationConfigs?: Maybe<Array<(
    { __typename?: 'HarvestGroupAutoCreationConfig' }
    & HarvestGroupAutoCreationConfigFieldsFragment
  )>> };

export type HarvestGroupAutoCreationConfigQueryVariables = Exact<{
  siteId: Scalars['String'];
}>;


export type HarvestGroupAutoCreationConfigQuery = { __typename?: 'Query', harvestGroupAutoCreationConfig?: Maybe<(
    { __typename?: 'HarvestGroupAutoCreationConfig' }
    & HarvestGroupAutoCreationConfigFieldsFragment
  )> };

export type UpsertHarvestGroupAutoCreationConfigMutationVariables = Exact<{
  input: UpsertHarvestGroupAutoCreationConfigInput;
}>;


export type UpsertHarvestGroupAutoCreationConfigMutation = { __typename?: 'Mutation', upsertHarvestGroupAutoCreationConfig?: Maybe<(
    { __typename?: 'HarvestGroupAutoCreationConfig' }
    & HarvestGroupAutoCreationConfigFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ToggleHarvestGroupAutoCreationConfigMutationVariables = Exact<{
  siteId: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
}>;


export type ToggleHarvestGroupAutoCreationConfigMutation = { __typename?: 'Mutation', toggleHarvestGroupAutoCreationConfig?: Maybe<(
    { __typename?: 'HarvestGroupAutoCreationConfig' }
    & HarvestGroupAutoCreationConfigFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type BudFormFactorsQueryVariables = Exact<{
  filters?: Maybe<BudFormFactorFilterSetInput>;
}>;


export type BudFormFactorsQuery = { __typename?: 'Query', budFormFactors?: Maybe<Array<(
    { __typename?: 'BudFormFactor' }
    & BudFormFactorFieldsFragment
  )>> };

export type CreateBudFormFactorMutationVariables = Exact<{
  input: CreateBudFormFactorInput;
}>;


export type CreateBudFormFactorMutation = { __typename?: 'Mutation', createBudFormFactor?: Maybe<(
    { __typename?: 'BudFormFactor' }
    & BudFormFactorFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateBudFormFactorMutationVariables = Exact<{
  input: UpdateBudFormFactorInput;
}>;


export type UpdateBudFormFactorMutation = { __typename?: 'Mutation', updateBudFormFactor?: Maybe<(
    { __typename?: 'BudFormFactor' }
    & BudFormFactorFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ReorderBudFormFactorsMutationVariables = Exact<{
  input: ReorderBudFormFactorsInput;
}>;


export type ReorderBudFormFactorsMutation = { __typename?: 'Mutation', reorderBudFormFactors?: Maybe<(
    { __typename?: 'BudFormFactor' }
    & BudFormFactorFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ActivateBudFormFactorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActivateBudFormFactorMutation = { __typename?: 'Mutation', updateBudFormFactor?: Maybe<(
    { __typename?: 'BudFormFactor' }
    & BudFormFactorFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type DeactivateBudFormFactorMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeactivateBudFormFactorMutation = { __typename?: 'Mutation', updateBudFormFactor?: Maybe<(
    { __typename?: 'BudFormFactor' }
    & BudFormFactorFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type BudFormFactorFieldsFragment = { __typename?: 'BudFormFactor', id: any, name: string, active: boolean, createdAt: any, description: string, orderPosition: number, classification: BudFormFactorClassification, metrcId?: Maybe<string>, createdBy: { __typename?: 'UserProfile', id: string, email: string, firstName: string, lastName: string } };

export type UploadEnvironmentalFileMutationVariables = Exact<{
  input: EnvironmentalFileInput;
}>;


export type UploadEnvironmentalFileMutation = { __typename?: 'Mutation', uploadEnvironmentalFile?: Maybe<(
    { __typename?: 'EnvironmentalFileType' }
    & EnvironmentalFileFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateTimeOffsetMutationVariables = Exact<{
  input: UpdateTimeOffsetInput;
}>;


export type UpdateTimeOffsetMutation = { __typename?: 'Mutation', updateTimeOffset?: Maybe<(
    { __typename?: 'EnvironmentalFileType' }
    & EnvironmentalFileFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ProcessEnvironmentalFileMutationVariables = Exact<{
  input: ProcessEnvironmentalFileInput;
}>;


export type ProcessEnvironmentalFileMutation = { __typename?: 'Mutation', processEnvironmentalFile?: Maybe<(
    { __typename?: 'EnvironmentalFileType' }
    & EnvironmentalFileFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type EnvironmentalFilesQueryVariables = Exact<{
  filters?: Maybe<EnvironmentalFileFilterSetInput>;
}>;


export type EnvironmentalFilesQuery = { __typename?: 'Query', environmentalFiles?: Maybe<Array<(
    { __typename?: 'EnvironmentalFileType' }
    & EnvironmentalFileFieldsFragment
  )>> };

export type EnvironmentalFileQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type EnvironmentalFileQuery = { __typename?: 'Query', environmentalFile: (
    { __typename?: 'EnvironmentalFileType' }
    & PreviewFileFieldsFragment
  ) };

export type EnvironmentalFileFieldsFragment = { __typename?: 'EnvironmentalFileType', id: any, createdAt: any, dataFile: string, fileType?: Maybe<EnvironmentalFileFileType>, fileStatus: EnvironmentalFileFileStatus, autodetectStatus: EnvironmentalFileAutodetectStatus, timeOffsetSeconds: number, zone: { __typename?: 'Zone', id: string, name: string } };

export type PreviewFileFieldsFragment = { __typename?: 'EnvironmentalFileType', id: any, fileType?: Maybe<EnvironmentalFileFileType>, autodetectStatus: EnvironmentalFileAutodetectStatus, guessEnvType?: Maybe<string>, timeOffsetSeconds: number, sevenDayPreview?: Maybe<Array<{ __typename?: 'AnalyticsDataPoint', x: any, y: number }>>, guessTargetValues?: Maybe<{ __typename?: 'EnvironmentalTargetValues', id: any }>, zone: { __typename?: 'Zone', id: string, name: string, site: { __typename?: 'OrganizationSite', id: any, organization: { __typename?: 'Organization', id: string, timezone: string, dayStartTime: any, nightStartTime: any } } }, currentHgs?: Maybe<Array<{ __typename?: 'HarvestGroup', id: string, name: string }>>, currentStages?: Maybe<Array<{ __typename?: 'Stage', id: any, name: string }>> };

export type AlertWarningFragment = { __typename?: 'AlertWarning', id: any, metric: AlertWarningMetric, updatedAt: any, createdAt: any, startTime: any, endTime: any, avgDeviation: number, maxDeviation: number, display?: Maybe<string>, position: AlertWarningPosition, message: string, zone: { __typename?: 'Zone', id: string, name: string }, stage: { __typename?: 'Stage', id: any, name: string, harvestGroup: { __typename?: 'HarvestGroup', id: string, name: string, colorHexCode?: Maybe<string> } } };

export type AnalyticsChartDataFragment = { __typename?: 'AnalyticsChartData', name: string, data: Array<{ __typename?: 'AnalyticsDataPoint', x: any, y: number }>, alertWarnings: Array<(
    { __typename?: 'AlertWarning' }
    & AlertWarningFragment
  )> };

export type EnvironmentalAnalyticsQueryVariables = Exact<{
  filters?: Maybe<EnvironmentalAnalyticsFilterInput>;
}>;


export type EnvironmentalAnalyticsQuery = { __typename?: 'Query', environmentalAnalytics: { __typename?: 'EnvironmentalAnalyticsResult', temperature: (
      { __typename?: 'AnalyticsChartData' }
      & AnalyticsChartDataFragment
    ), humidity: (
      { __typename?: 'AnalyticsChartData' }
      & AnalyticsChartDataFragment
    ), co2: (
      { __typename?: 'AnalyticsChartData' }
      & AnalyticsChartDataFragment
    ), vpd: (
      { __typename?: 'AnalyticsChartData' }
      & AnalyticsChartDataFragment
    ) } };

export type WeeklyEnvironmentalMetricFragment = { __typename?: 'WeeklyEnvironmentalMetric', compliant?: Maybe<boolean>, deviation?: Maybe<number>, percentInRange?: Maybe<number> };

export type EnvironmentalWeeklyDataQueryVariables = Exact<{
  harvestGroupId: Scalars['ID'];
}>;


export type EnvironmentalWeeklyDataQuery = { __typename?: 'Query', environmentalWeeklyData?: Maybe<Array<{ __typename?: 'WeeklyEnvironmentalData', week: number, stageName: string, environmentalType: string, temperature: (
      { __typename?: 'WeeklyEnvironmentalMetric' }
      & WeeklyEnvironmentalMetricFragment
    ), humidity: (
      { __typename?: 'WeeklyEnvironmentalMetric' }
      & WeeklyEnvironmentalMetricFragment
    ), co2: (
      { __typename?: 'WeeklyEnvironmentalMetric' }
      & WeeklyEnvironmentalMetricFragment
    ), vpd: (
      { __typename?: 'WeeklyEnvironmentalMetric' }
      & WeeklyEnvironmentalMetricFragment
    ) }>> };

export type GenerationRequestFieldsFragment = { __typename?: 'GenerationRequestType', id: any, createdAt: any, updatedAt: any, asyncAnalysisStatus?: Maybe<GenerationRequestAsyncAnalysisStatus>, asyncAnalysisStartedAt?: Maybe<any>, asyncAnalysisCompletedAt?: Maybe<any>, asyncAnalysisError?: Maybe<string>, asyncAnalysisProgressPct: number, analysisType: GenerationRequestAnalysisType, textPrompt: string, result?: Maybe<any>, images: Array<{ __typename?: 'GenerationRequestImageType', id: any, imageUrl?: Maybe<string>, order: number }> };

export type CreateGenerationRequestMutationVariables = Exact<{
  analysisType: Scalars['String'];
  images: Array<GenerationRequestImageInput>;
  textPrompt?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
}>;


export type CreateGenerationRequestMutation = { __typename?: 'Mutation', createGenerationRequest?: Maybe<(
    { __typename?: 'GenerationRequestType' }
    & GenerationRequestFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type GenerationRequestQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GenerationRequestQuery = { __typename?: 'Query', generationRequest?: Maybe<(
    { __typename?: 'GenerationRequestType' }
    & GenerationRequestFieldsFragment
  )> };

export type CurrentAndUpcomingHarvestGroupsQueryVariables = Exact<{
  unarchived?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
}>;


export type CurrentAndUpcomingHarvestGroupsQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<(
    { __typename?: 'HarvestGroup' }
    & HarvestGroupFieldsFragment
    & HarvestGroupOverviewFieldsFragment
    & HarvestGroupCurrentStageFieldsFragment
  )>> };

export type CurrentAndUpcomingHarvestGroupsShortQueryVariables = Exact<{
  unarchived?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
}>;


export type CurrentAndUpcomingHarvestGroupsShortQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<(
    { __typename?: 'HarvestGroup' }
    & CurrentGroupsShortFieldsFragment
  )>> };

export type HarvestGroupsStartedInThePastQueryVariables = Exact<{
  zoneId?: Maybe<Scalars['String']>;
}>;


export type HarvestGroupsStartedInThePastQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<(
    { __typename?: 'HarvestGroup', site: { __typename?: 'OrganizationSite', organization: { __typename?: 'Organization', id: string, environmentalTargetSets: Array<(
          { __typename?: 'EnvironmentalTargetSet' }
          & EnvironmentalTargetSetFieldsFragment
        )> } }, stages: Array<{ __typename?: 'Stage', id: any, name: string, startDate: any, endDate: any, environmentalTargetType: StageEnvironmentalTargetType, zone: { __typename?: 'Zone', id: string, name: string, lightingClassification?: Maybe<ZoneLightingClassification> } }> }
    & HarvestGroupShortOverviewFieldsFragment
    & HarvestGroupCurrentStageFieldsFragment
  )>> };

export type CurrentAndUpcomingHarvestGroupsForTaskFormQueryVariables = Exact<{
  unarchived?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
}>;


export type CurrentAndUpcomingHarvestGroupsForTaskFormQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<{ __typename?: 'HarvestGroup', id: string, name: string, flowerZone?: Maybe<{ __typename?: 'Zone', id: string, name: string }>, stages: Array<{ __typename?: 'Stage', id: any, name: string, startDate: any, endDate: any }> }>> };

export type CurrentAndUpcomingHarvestGroupsForSelectQueryVariables = Exact<{
  filters?: Maybe<HarvestGroupFilterSetInput>;
}>;


export type CurrentAndUpcomingHarvestGroupsForSelectQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<{ __typename?: 'HarvestGroup', name: string, id: string, colorHexCode?: Maybe<string>, startDate?: Maybe<any>, stages: Array<{ __typename?: 'Stage', zone: { __typename?: 'Zone', id: string } }> }>> };

export type CompletedHarvestGroupsPaginatedQueryVariables = Exact<{
  options?: Maybe<HarvestGroupQuerysetOptionsInput>;
}>;


export type CompletedHarvestGroupsPaginatedQuery = { __typename?: 'Query', completedHarvestGroupsPaginated?: Maybe<(
    { __typename?: 'HarvestGroupQuerysetResult' }
    & CompletedHarvestGroupsPaginatedResultFragment
  )> };

export type PagingInfoFragment = { __typename?: 'PagingInfo', totalCount: number, pageCount: number, size: number, start: number, page: number, hasNextPage: boolean, hasPreviousPage: boolean };

export type CompletedHarvestGroupsPaginatedResultFragment = { __typename?: 'HarvestGroupQuerysetResult', options: { __typename?: 'HarvestGroupQuerysetOptionsOutput', paging: (
      { __typename?: 'PagingInfo' }
      & PagingInfoFragment
    ) }, items: Array<Maybe<{ __typename?: 'HarvestGroup', id: string, name: string, startDate?: Maybe<any>, harvestDate?: Maybe<any>, archivedAt?: Maybe<any>, importedFromMetrc: boolean, hasYields?: Maybe<boolean>, site: { __typename?: 'OrganizationSite', id: any, name: string, hasEnvironmentalData?: Maybe<boolean> }, strains: Array<(
      { __typename?: 'Strain' }
      & StrainReportFieldsFragment
    )>, flowerZone?: Maybe<(
      { __typename?: 'Zone' }
      & ZoneIdAndNameFragment
    )>, aiSummary?: Maybe<{ __typename?: 'HarvestSummary', status: HarvestSummaryStatus, generatedAt: any }> }>> };

export type CompletedHarvestGroupsQueryVariables = Exact<{
  unarchived?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  importedFromMetrc?: Maybe<Scalars['Boolean']>;
}>;


export type CompletedHarvestGroupsQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<(
    { __typename?: 'HarvestGroup' }
    & CompletedHarvestGroupFieldsFragment
  )>> };

export type CompletedHarvestGroupsYieldsQueryVariables = Exact<{
  unarchived?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
}>;


export type CompletedHarvestGroupsYieldsQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<(
    { __typename?: 'HarvestGroup' }
    & CompletedHarvestGroupYieldsFieldsFragment
  )>> };

export type HarvestForecastYieldHistoryQueryVariables = Exact<{
  siteId?: Maybe<Scalars['String']>;
}>;


export type HarvestForecastYieldHistoryQuery = { __typename?: 'Query', harvestForecastYieldHistory?: Maybe<Array<(
    { __typename?: 'HarvestStrainYield' }
    & HarvestForecastYieldHistoryFieldsFragment
  )>> };

export type CompletedHarvestGroupsNamesQueryVariables = Exact<{
  unarchived?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
}>;


export type CompletedHarvestGroupsNamesQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<{ __typename?: 'HarvestGroup', id: string, name: string, harvestDate?: Maybe<any> }>> };

export type CompletedHarvestGroupsTableViewQueryVariables = Exact<{
  unarchived?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
}>;


export type CompletedHarvestGroupsTableViewQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<{ __typename?: 'HarvestGroup', id: string, name: string, startDate?: Maybe<any>, harvestDate?: Maybe<any>, archivedAt?: Maybe<any>, hasYields?: Maybe<boolean>, strains: Array<(
      { __typename?: 'Strain' }
      & StrainReportFieldsFragment
    )>, flowerZone?: Maybe<(
      { __typename?: 'Zone' }
      & ZoneIdAndNameFragment
    )> }>> };

export type CompletedHarvestGroupsListQueryVariables = Exact<{
  unarchived?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
}>;


export type CompletedHarvestGroupsListQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<{ __typename?: 'HarvestGroup', id: string, name: string, startDate?: Maybe<any>, harvestDate?: Maybe<any>, archivedAt?: Maybe<any>, strains: Array<(
      { __typename?: 'Strain' }
      & StrainReportFieldsFragment
    )>, flowerZone?: Maybe<(
      { __typename?: 'Zone' }
      & ZoneIdAndNameFragment
    )>, yields: Array<{ __typename?: 'HarvestStrainYield', id: any, totalGrams: number, budFormFactorYields: Array<{ __typename?: 'BudFormFactorYield', numberOfGrams: number, budFormFactor: { __typename?: 'BudFormFactor', id: any, name: string } }> }> }>> };

export type CompletedHarvestGroupQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CompletedHarvestGroupQuery = { __typename?: 'Query', harvestGroup: (
    { __typename?: 'HarvestGroup' }
    & CompletedHarvestGroupFieldsFragment
  ) };

export type AnalyticsHarvestGroupsQueryVariables = Exact<{
  unarchived?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
}>;


export type AnalyticsHarvestGroupsQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<(
    { __typename?: 'HarvestGroup' }
    & AnalyticsHarvestGroupFieldsFragment
  )>> };

export type AnalyticsHarvestGroupsOverviewFragment = { __typename?: 'HarvestGroup', name: string, startDate?: Maybe<any>, harvestDate?: Maybe<any>, archivedAt?: Maybe<any>, yields: Array<{ __typename?: 'HarvestStrainYield', id: any, strain: (
      { __typename?: 'Strain' }
      & StrainReportFieldsFragment
    ) }> };

export type AnalyticsHarvestGroupsOverviewQueryVariables = Exact<{
  unarchived?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
}>;


export type AnalyticsHarvestGroupsOverviewQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<(
    { __typename?: 'HarvestGroup' }
    & AnalyticsHarvestGroupsOverviewFragment
  )>> };

export type CompletedHarvestGroupWithLogsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CompletedHarvestGroupWithLogsQuery = { __typename?: 'Query', harvestGroup: (
    { __typename?: 'HarvestGroup' }
    & CompletedHarvestGroupWithLogsFieldsFragment
  ) };

export type HarvestReportComparisonQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type HarvestReportComparisonQuery = { __typename?: 'Query', harvestGroup: (
    { __typename?: 'HarvestGroup' }
    & HarvestGroupReportComparisonFieldsFragment
  ) };

export type HarvestGroupQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type HarvestGroupQuery = { __typename?: 'Query', harvestGroup: (
    { __typename?: 'HarvestGroup' }
    & HarvestGroupFieldsFragment
  ) };

export type DashboardHarvestGroupTooltipQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type DashboardHarvestGroupTooltipQuery = { __typename?: 'Query', harvestGroup: (
    { __typename?: 'HarvestGroup' }
    & HarvestGroupOverviewTooltipFieldsFragment
  ) };

export type HarvestGroupWithJustLogEntriesAndCompletionQueryVariables = Exact<{
  id: Scalars['String'];
  logEntryOptions?: Maybe<LogsFilterInput>;
}>;


export type HarvestGroupWithJustLogEntriesAndCompletionQuery = { __typename?: 'Query', harvestGroup: { __typename?: 'HarvestGroup', id: string, name: string, colorHexCode?: Maybe<string>, logEntries: Array<(
      { __typename?: 'LogEntry' }
      & LogEntryFieldsFragment
    )>, harvestCompletion?: Maybe<{ __typename?: 'HarvestCompletion', cosignedAt?: Maybe<any> }> } };

export type AllHarvestGroupsWithLogEntriesQueryVariables = Exact<{
  logEntryOptions?: Maybe<LogsFilterInput>;
}>;


export type AllHarvestGroupsWithLogEntriesQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<{ __typename?: 'HarvestGroup', id: string, name: string, flowerZone?: Maybe<{ __typename?: 'Zone', id: string }>, logEntries: Array<(
      { __typename?: 'LogEntry' }
      & LogEntryFieldsFragment
    )> }>> };

export type AllHarvestGroupsShortOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type AllHarvestGroupsShortOverviewQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<(
    { __typename?: 'HarvestGroup' }
    & HarvestGroupShortOverviewFieldsFragment
  )>> };

export type HarvestGroupWithJustStrainsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type HarvestGroupWithJustStrainsQuery = { __typename?: 'Query', harvestGroup: { __typename?: 'HarvestGroup', strains: Array<(
      { __typename?: 'Strain' }
      & StrainReportFieldsFragment
    )> } };

export type CreateHarvestGroupMutationVariables = Exact<{
  input: CreateHarvestGroupInput;
}>;


export type CreateHarvestGroupMutation = { __typename?: 'Mutation', createHarvestGroup?: Maybe<(
    { __typename?: 'HarvestGroup' }
    & HarvestGroupFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateHarvestGroupMutationVariables = Exact<{
  input: UpdateHarvestGroupInput;
}>;


export type UpdateHarvestGroupMutation = { __typename?: 'Mutation', updateHarvestGroup?: Maybe<{ __typename?: 'HarvestGroup', id: string, name: string, colorHexCode?: Maybe<string>, startDate?: Maybe<any>, harvestDate?: Maybe<any>, isMultisite: boolean, flowerZone?: Maybe<{ __typename?: 'Zone', id: string, name: string }>, site: { __typename?: 'OrganizationSite', id: any, name: string } } | { __typename?: 'Error', message: string }> };

export type UpdateHarvestGroupArchivedMutationVariables = Exact<{
  input: UpdateHarvestGroupArchivedInput;
}>;


export type UpdateHarvestGroupArchivedMutation = { __typename?: 'Mutation', updateHarvestGroupArchived?: Maybe<(
    { __typename?: 'HarvestGroup' }
    & HarvestGroupFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type GenerateHarvestSummaryMutationVariables = Exact<{
  input: GenerateHarvestSummaryInput;
}>;


export type GenerateHarvestSummaryMutation = { __typename?: 'Mutation', generateHarvestSummary?: Maybe<{ __typename?: 'HarvestGroup', id: string, name: string, aiSummary?: Maybe<{ __typename?: 'HarvestSummary', id: string, summaryText: string, yieldDriversAnalysis: string, status: HarvestSummaryStatus, generatedAt: any }> } | { __typename?: 'Error', message: string }> };

export type CreateHarvestReportMutationVariables = Exact<{
  input: CreateHarvestReportInput;
}>;


export type CreateHarvestReportMutation = { __typename?: 'Mutation', createHarvestReport?: Maybe<{ __typename?: 'HarvestGroup', id: string, yields: Array<(
      { __typename?: 'HarvestStrainYield' }
      & YieldFieldsFragment
    )> } | { __typename?: 'Error', message: string }> };

export type UpdateHarvestReportMutationVariables = Exact<{
  input: UpdateHarvestReportInput;
}>;


export type UpdateHarvestReportMutation = { __typename?: 'Mutation', updateHarvestReport?: Maybe<{ __typename?: 'HarvestGroup', id: string, yields: Array<(
      { __typename?: 'HarvestStrainYield' }
      & YieldFieldsFragment
    )> } | { __typename?: 'Error', message: string }> };

export type UpdateHarvestProjectionMutationVariables = Exact<{
  input: UpdateHarvestProjectionInput;
}>;


export type UpdateHarvestProjectionMutation = { __typename?: 'Mutation', updateHarvestProjection?: Maybe<{ __typename?: 'HarvestProjection', id: any, strainId: string, plantCount: number, harvestGroupId: string, strain: { __typename?: 'Strain', id: any, name: string } } | { __typename?: 'Error' }> };

export type HarvestReportQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type HarvestReportQuery = { __typename?: 'Query', harvestGroup: { __typename?: 'HarvestGroup', id: string, yields: Array<(
      { __typename?: 'HarvestStrainYield' }
      & YieldFieldsFragment
    )> } };

export type UpdateHarvestYieldsMutationVariables = Exact<{
  input: UpdateHarvestYieldsInput;
}>;


export type UpdateHarvestYieldsMutation = { __typename?: 'Mutation', updateHarvestYields?: Maybe<{ __typename?: 'HarvestGroup', id: string, yields: Array<{ __typename?: 'HarvestStrainYield', strainId: string, totalGrams: number, finalPlantCount: number, strain: { __typename?: 'Strain', id: any, name: string }, budFormFactorYields: Array<{ __typename?: 'BudFormFactorYield', budFormFactorId: string, numberOfGrams: number }> }> } | { __typename?: 'Error', message: string }> };

export type HarvestYieldFormDataQueryVariables = Exact<{
  id: Scalars['String'];
  formFactorFilters?: Maybe<BudFormFactorFilterSetInput>;
}>;


export type HarvestYieldFormDataQuery = { __typename?: 'Query', harvestGroup: { __typename?: 'HarvestGroup', id: string, importedFromMetrc: boolean, site: { __typename?: 'OrganizationSite', id: any }, yields: Array<{ __typename?: 'HarvestStrainYield', strainId: string, totalGrams: number, finalPlantCount: number, strain: { __typename?: 'Strain', id: any, name: string, yieldEditIdentity: { __typename?: 'Strain', id: any, name: string } }, budFormFactorYields: Array<{ __typename?: 'BudFormFactorYield', budFormFactorId: string, numberOfGrams: number, budFormFactor: { __typename?: 'BudFormFactor', id: any, name: string, classification: BudFormFactorClassification, metrcId?: Maybe<string>, sites: Array<{ __typename?: 'OrganizationSite', id: any }> } }> }>, stages: Array<{ __typename?: 'Stage', id: any, strainsInStage: Array<{ __typename?: 'StrainInStage', numberOfPlants: number, strain: { __typename?: 'Strain', id: any, name: string, yieldEditIdentity: { __typename?: 'Strain', id: any, name: string } } }> }>, becameProcessingGroup?: Maybe<{ __typename?: 'ProcessingGroup', id: string, processingGroupStrains: Array<(
        { __typename?: 'ProcessingGroupStrain' }
        & ProcessingStrainYieldFieldsFragment
      )> }> }, budFormFactors?: Maybe<Array<{ __typename?: 'BudFormFactor', id: any, name: string, classification: BudFormFactorClassification, metrcId?: Maybe<string>, sites: Array<{ __typename?: 'OrganizationSite', id: any }> }>> };

export type CurrentGroupsHarvestForecastQueryVariables = Exact<{
  siteId?: Maybe<Scalars['String']>;
}>;


export type CurrentGroupsHarvestForecastQuery = { __typename?: 'Query', harvestGroups?: Maybe<Array<(
    { __typename?: 'HarvestGroup' }
    & CurrentGroupsHarvestForecastFieldsFragment
  )>> };

export type CompleteHarvestMutationVariables = Exact<{
  input: CompleteHarvestInput;
}>;


export type CompleteHarvestMutation = { __typename?: 'Mutation', completeHarvest?: Maybe<(
    { __typename?: 'HarvestCompletion' }
    & HarvestCompletionFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ApproveHarvestCompletionMutationVariables = Exact<{
  input: ApproveHarvestCompletionInput;
}>;


export type ApproveHarvestCompletionMutation = { __typename?: 'Mutation', approveHarvestCompletion?: Maybe<(
    { __typename?: 'HarvestCompletion' }
    & HarvestCompletionFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ArchiveHarvestGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveHarvestGroupMutation = { __typename?: 'Mutation', updateHarvestGroupArchived?: Maybe<(
    { __typename?: 'HarvestGroup' }
    & HarvestGroupFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UnarchiveHarvestGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnarchiveHarvestGroupMutation = { __typename?: 'Mutation', updateHarvestGroupArchived?: Maybe<(
    { __typename?: 'HarvestGroup' }
    & HarvestGroupFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type HarvestGroupWithLogEntriesFragment = (
  { __typename?: 'HarvestGroup', logEntries: Array<(
    { __typename?: 'LogEntry' }
    & LogEntryFieldsFragment
  )> }
  & HarvestGroupOverviewFieldsFragment
  & HarvestGroupCurrentStageFieldsFragment
);

export type HarvestGroupCalendarFieldsFragment = { __typename?: 'HarvestGroup', id: string, name: string, colorHexCode?: Maybe<string>, tasks: Array<(
    { __typename?: 'Task' }
    & TaskCalendarFieldsFragment
  )>, stages: Array<(
    { __typename?: 'Stage' }
    & StageCalendarFieldsFragment
  )> };

export type HarvestGroupFieldsFragment = (
  { __typename?: 'HarvestGroup', id: string, startDate?: Maybe<any>, harvestDate?: Maybe<any>, isMultisite: boolean, draftLogEntryCount?: Maybe<number>, archivedAt?: Maybe<any>, flowerZone?: Maybe<{ __typename?: 'Zone', id: string, name: string }>, site: { __typename?: 'OrganizationSite', id: any, name: string }, stages: Array<(
    { __typename?: 'Stage', zone: { __typename?: 'Zone', id: string, name: string }, strainsInStage: Array<{ __typename?: 'StrainInStage', numberOfPlants: number, strain: { __typename?: 'Strain', id: any, name: string } }>, tasks: Array<(
      { __typename?: 'Task' }
      & TaskFieldsFragment
    )> }
    & StageFieldsFragment
  )>, strains: Array<(
    { __typename?: 'Strain' }
    & StrainFieldsFragment
  )>, harvestCompletion?: Maybe<{ __typename?: 'HarvestCompletion', createdAt: any, cosignedAt?: Maybe<any>, createdBy: (
      { __typename?: 'UserProfile', id: string }
      & NameFragment
    ), cosignedBy?: Maybe<(
      { __typename?: 'UserProfile', id: string }
      & NameFragment
    )> }>, templateUsed?: Maybe<(
    { __typename?: 'HarvestGroupTemplate' }
    & HarvestGroupTemplateFieldsFragment
  )> }
  & HarvestGroupCalendarFieldsFragment
);

export type HarvestProjectionFragment = { __typename?: 'HarvestProjection', id: any, harvestGroupId: string, strainId: string, plantCount: number };

export type HarvestGroupCurrentStageFieldsFragment = { __typename?: 'HarvestGroup', currentStage: { __typename?: 'Stage', id: any, name: string, currentDayOfStage: number, daysInStage: number, calendarBranchId: string, zone: { __typename?: 'Zone', id: string, name: string }, strainsInStage: Array<{ __typename?: 'StrainInStage', numberOfPlants: number, strain: { __typename?: 'Strain', name: string, id: any } }> }, projections?: Maybe<Array<(
    { __typename?: 'HarvestProjection' }
    & HarvestProjectionFragment
  )>> };

export type HarvestCompletionFieldsFragment = { __typename?: 'HarvestCompletion', id: any, cosignedBy?: Maybe<{ __typename?: 'UserProfile', id: string, firstName: string, lastName: string }>, harvestGroup: (
    { __typename?: 'HarvestGroup' }
    & HarvestGroupFieldsFragment
  ), createdBy: { __typename?: 'UserProfile', id: string, firstName: string, lastName: string } };

export type CompletedHarvestGroupFieldsFragment = (
  { __typename?: 'HarvestGroup', id: string, name: string, startDate?: Maybe<any>, harvestDate?: Maybe<any>, archivedAt?: Maybe<any>, aiSummary?: Maybe<(
    { __typename?: 'HarvestSummary' }
    & HarvestSummaryFieldsFragment
  )>, aiActivitySummary?: Maybe<(
    { __typename?: 'CultivationActivitySummary' }
    & ActivitySummaryFieldsFragment
  )>, stages: Array<(
    { __typename?: 'Stage' }
    & StageReportFieldsFragment
  )>, strains: Array<(
    { __typename?: 'Strain' }
    & StrainReportFieldsFragment
  )>, yields: Array<(
    { __typename?: 'HarvestStrainYield' }
    & YieldReportFieldsFragment
  )>, flowerZone?: Maybe<(
    { __typename?: 'Zone' }
    & ZoneIdAndNameFragment
  )>, becameProcessingGroup?: Maybe<{ __typename?: 'ProcessingGroup', id: string, name: string }> }
  & HarvestGroupReportFieldsFragment
);

export type HarvestSummaryFieldsFragment = { __typename?: 'HarvestSummary', id: string, approvedAt?: Maybe<any>, adminNotes: string, aiModelUsed: string, generationCost?: Maybe<any>, status: HarvestSummaryStatus, generatedAt: any, summaryText: string, yieldDriversAnalysis: string, approvedBy?: Maybe<(
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  )> };

export type ActivitySummaryFieldsFragment = { __typename?: 'CultivationActivitySummary', id: string, status: CultivationActivitySummaryStatus, generatedAt: any, approvedAt?: Maybe<any>, observationsReport: string, issuesReport: string, irrigationReport: string, foliarReport: string, pruningReport: string, toppingReport: string, runoffReport: string, approvedBy?: Maybe<(
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  )> };

export type CompletedHarvestGroupYieldsFieldsFragment = { __typename?: 'HarvestGroup', id: string, name: string, yields: Array<(
    { __typename?: 'HarvestStrainYield' }
    & YieldReportFieldsFragment
  )> };

export type HarvestForecastYieldHistoryFieldsFragment = { __typename?: 'HarvestStrainYield', finalPlantCount: number, harvestGroup: { __typename?: 'HarvestGroup', id: string, name: string }, strain: (
    { __typename?: 'Strain' }
    & StrainReportFieldsFragment
  ), budFormFactorYields: Array<{ __typename?: 'BudFormFactorYield', budFormFactorId: string, numberOfGrams: number, budFormFactor: { __typename?: 'BudFormFactor', id: any, name: string, active: boolean, orderPosition: number, classification: BudFormFactorClassification } }> };

export type CurrentGroupsHarvestForecastFieldsFragment = (
  { __typename?: 'HarvestGroup', id: string, name: string, startDate?: Maybe<any>, harvestDate?: Maybe<any>, colorHexCode?: Maybe<string>, projections?: Maybe<Array<(
    { __typename?: 'HarvestProjection' }
    & HarvestProjectionFragment
  )>>, strains: Array<(
    { __typename?: 'Strain' }
    & StrainReportFieldsFragment
  )>, yields: Array<(
    { __typename?: 'HarvestStrainYield' }
    & YieldReportFieldsFragment
  )>, flowerZone?: Maybe<(
    { __typename?: 'Zone' }
    & ZoneIdAndNameFragment
  )>, harvestCompletion?: Maybe<{ __typename?: 'HarvestCompletion', id: any }> }
  & HarvestGroupCurrentStageFieldsFragment
);

export type AnalyticsHarvestGroupFieldsFragment = (
  { __typename?: 'HarvestGroup', name: string, startDate?: Maybe<any>, harvestDate?: Maybe<any>, archivedAt?: Maybe<any>, stages: Array<(
    { __typename?: 'Stage' }
    & StageReportFieldsFragment
  )>, strains: Array<(
    { __typename?: 'Strain' }
    & StrainReportFieldsFragment
  )>, yields: Array<(
    { __typename?: 'HarvestStrainYield' }
    & YieldReportFieldsFragment
  )>, flowerZone?: Maybe<(
    { __typename?: 'Zone' }
    & ZoneIdAndNameFragment
  )>, becameProcessingGroup?: Maybe<{ __typename?: 'ProcessingGroup', id: string, name: string }> }
  & HarvestGroupReportFieldsFragment
  & HarvestGroupFieldsFragment
);

export type CompletedHarvestGroupWithLogsFieldsFragment = (
  { __typename?: 'HarvestGroup', logEntries: Array<(
    { __typename?: 'LogEntry' }
    & LogEntryFieldsFragment
  )>, weeklyEnvironmentalData?: Maybe<Array<Maybe<{ __typename?: 'WeeklyEnvironmentalData', week: number, stageName: string, environmentalType: string, temperature: { __typename?: 'WeeklyEnvironmentalMetric', compliant?: Maybe<boolean>, percentInRange?: Maybe<number> }, humidity: { __typename?: 'WeeklyEnvironmentalMetric', compliant?: Maybe<boolean>, percentInRange?: Maybe<number> }, co2: { __typename?: 'WeeklyEnvironmentalMetric', compliant?: Maybe<boolean>, percentInRange?: Maybe<number> }, vpd: { __typename?: 'WeeklyEnvironmentalMetric', compliant?: Maybe<boolean>, percentInRange?: Maybe<number> } }>>> }
  & CompletedHarvestGroupFieldsFragment
);

export type HarvestGroupReportComparisonFieldsFragment = (
  { __typename?: 'HarvestGroup', logEntries: Array<{ __typename?: 'LogEntry', id: any, logType: LogEntryLogType }> }
  & CompletedHarvestGroupFieldsFragment
);

export type HarvestGroupReportFieldsFragment = { __typename?: 'HarvestGroup', id: string, name: string, startDate?: Maybe<any>, harvestDate?: Maybe<any>, colorHexCode?: Maybe<string> };

export type HarvestGroupWithLogEntriesQueryVariables = Exact<{
  id: Scalars['String'];
  logEntryOptions?: Maybe<LogsFilterInput>;
}>;


export type HarvestGroupWithLogEntriesQuery = { __typename?: 'Query', harvestGroup: (
    { __typename?: 'HarvestGroup' }
    & HarvestGroupWithLogEntriesFragment
  ) };

export type HarvestGroupsWithTemplateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type HarvestGroupsWithTemplateQuery = { __typename?: 'Query', harvestGroupsWithTemplate?: Maybe<Array<{ __typename?: 'HarvestGroup', id: string, name: string, startDate?: Maybe<any>, harvestDate?: Maybe<any>, stages: Array<{ __typename?: 'Stage', id: any, name: string, startDate: any, endDate: any, desiredNumberOfDays?: Maybe<number>, templateUsed?: Maybe<{ __typename?: 'StageTemplate', id: any, createdStageName: string, numberOfDays: number }> }> }>> };

export type HarvestGroupWithProcessingAndFormFactorsQueryVariables = Exact<{
  id: Scalars['String'];
  filters?: Maybe<BudFormFactorFilterSetInput>;
}>;


export type HarvestGroupWithProcessingAndFormFactorsQuery = { __typename?: 'Query', harvestGroup: (
    { __typename?: 'HarvestGroup' }
    & HarvestGroupDetailFieldsFragment
    & HarvestBecameProcessingFieldsFragment
  ), budFormFactors?: Maybe<Array<(
    { __typename?: 'BudFormFactor' }
    & BudFormFactorFieldsFragment
  )>> };

export type HarvestBecameProcessingFieldsFragment = { __typename?: 'HarvestGroup', id: string, becameProcessingGroup?: Maybe<{ __typename?: 'ProcessingGroup', id: string, name: string, processingGroupStrains: Array<(
      { __typename?: 'ProcessingGroupStrain' }
      & ProcessingStrainYieldFieldsFragment
    )> }> };

export type HarvestGroupDetailFieldsFragment = (
  { __typename?: 'HarvestGroup', id: string, startDate?: Maybe<any>, harvestDate?: Maybe<any>, archivedAt?: Maybe<any>, stages: Array<(
    { __typename?: 'Stage', zone: { __typename?: 'Zone', id: string, name: string }, strainsInStage: Array<{ __typename?: 'StrainInStage', id: any, numberOfPlants: number, strain: { __typename?: 'Strain', id: any, name: string } }> }
    & StageCalendarFieldsFragment
  )>, strains: Array<(
    { __typename?: 'Strain' }
    & StrainFieldsFragment
  )> }
  & HarvestGroupCalendarFieldsFragment
);

export type HarvestGroupShortOverviewFieldsFragment = { __typename?: 'HarvestGroup', id: string, name: string, startDate?: Maybe<any>, harvestDate?: Maybe<any>, archivedAt?: Maybe<any>, colorHexCode?: Maybe<string>, flowerZone?: Maybe<{ __typename?: 'Zone', id: string, name: string }>, currentStage: { __typename?: 'Stage', id: any, name: string } };

export type HarvestGroupOverviewFieldsFragment = (
  { __typename?: 'HarvestGroup', strains: Array<{ __typename?: 'Strain', id: any, name: string }>, flowerZone?: Maybe<{ __typename?: 'Zone', id: string, name: string }>, harvestCompletion?: Maybe<{ __typename?: 'HarvestCompletion', createdAt: any, cosignedAt?: Maybe<any>, createdBy: (
      { __typename?: 'UserProfile', id: string }
      & NameFragment
    ), cosignedBy?: Maybe<(
      { __typename?: 'UserProfile', id: string }
      & NameFragment
    )> }>, yields: Array<(
    { __typename?: 'HarvestStrainYield' }
    & YieldFieldsFragment
  )> }
  & HarvestGroupShortOverviewFieldsFragment
);

export type CurrentGroupsShortFieldsFragment = { __typename?: 'HarvestGroup', id: string, name: string, startDate?: Maybe<any>, flowerStartDate?: Maybe<any>, harvestDate?: Maybe<any>, colorHexCode?: Maybe<string>, importedFromMetrc: boolean, isAutoCreated: boolean, site: { __typename?: 'OrganizationSite', id: any, name: string }, flowerZone?: Maybe<{ __typename?: 'Zone', id: string, name: string }>, currentStage: { __typename?: 'Stage', id: any, name: string, strainsInStage: Array<{ __typename?: 'StrainInStage', id: any, numberOfPlants: number, strain: { __typename?: 'Strain', id: any, name: string } }> }, strains: Array<{ __typename?: 'Strain', id: any, name: string }>, harvestCompletion?: Maybe<{ __typename?: 'HarvestCompletion', id: any, createdBy: (
      { __typename?: 'UserProfile', id: string }
      & NameFragment
    ), cosignedBy?: Maybe<(
      { __typename?: 'UserProfile', id: string }
      & NameFragment
    )> }> };

export type HarvestGroupOverviewTooltipFieldsFragment = { __typename?: 'HarvestGroup', id: string, name: string, startDate?: Maybe<any>, flowerStartDate?: Maybe<any>, harvestDate?: Maybe<any>, colorHexCode?: Maybe<string>, importedFromMetrc: boolean, isAutoCreated: boolean, site: { __typename?: 'OrganizationSite', id: any, name: string }, flowerZone?: Maybe<{ __typename?: 'Zone', id: string, name: string }>, currentStage: { __typename?: 'Stage', id: any, name: string, strainsInStage: Array<{ __typename?: 'StrainInStage', id: any, numberOfPlants: number, strain: { __typename?: 'Strain', id: any, name: string } }> }, strains: Array<{ __typename?: 'Strain', id: any, name: string }>, harvestCompletion?: Maybe<{ __typename?: 'HarvestCompletion', id: any, createdBy: (
      { __typename?: 'UserProfile', id: string }
      & NameFragment
    ), cosignedBy?: Maybe<(
      { __typename?: 'UserProfile', id: string }
      & NameFragment
    )> }> };

export type UpdateHarvestGroupFlowerZoneMutationVariables = Exact<{
  input: UpdateHarvestGroupFlowerZoneInput;
}>;


export type UpdateHarvestGroupFlowerZoneMutation = { __typename?: 'Mutation', updateHarvestGroupFlowerZone?: Maybe<{ __typename?: 'HarvestGroup', id: string, flowerZone?: Maybe<{ __typename?: 'Zone', id: string, name: string }> } | { __typename?: 'Error', message: string }> };

export type AddObservationMutationVariables = Exact<{
  input: LogEntryInput;
}>;


export type AddObservationMutation = { __typename?: 'Mutation', addObservationLogEntry?: Maybe<(
    { __typename?: 'LogEntry' }
    & LogEntryFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type AddIssueMutationVariables = Exact<{
  input: LogEntryInput;
}>;


export type AddIssueMutation = { __typename?: 'Mutation', addIssueLogEntry?: Maybe<(
    { __typename?: 'LogEntry' }
    & LogEntryFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type AddIrrigationActivityMutationVariables = Exact<{
  input: LogEntryInput;
}>;


export type AddIrrigationActivityMutation = { __typename?: 'Mutation', addIrrigationLogEntry?: Maybe<(
    { __typename?: 'LogEntry' }
    & LogEntryFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type AddFoliarActivityMutationVariables = Exact<{
  input: LogEntryInput;
}>;


export type AddFoliarActivityMutation = { __typename?: 'Mutation', addFoliarLogEntry?: Maybe<(
    { __typename?: 'LogEntry' }
    & LogEntryFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type AddPruningActivityMutationVariables = Exact<{
  input: LogEntryInput;
}>;


export type AddPruningActivityMutation = { __typename?: 'Mutation', addPruningLogEntry?: Maybe<(
    { __typename?: 'LogEntry' }
    & LogEntryFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type AddDefoliateActivityMutationVariables = Exact<{
  input: LogEntryInput;
}>;


export type AddDefoliateActivityMutation = { __typename?: 'Mutation', addDefoliateLogEntry?: Maybe<(
    { __typename?: 'LogEntry' }
    & LogEntryFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type AddToppingActivityMutationVariables = Exact<{
  input: LogEntryInput;
}>;


export type AddToppingActivityMutation = { __typename?: 'Mutation', addToppingLogEntry?: Maybe<(
    { __typename?: 'LogEntry' }
    & LogEntryFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type AddGreenWasteActivityMutationVariables = Exact<{
  input: LogEntryInput;
}>;


export type AddGreenWasteActivityMutation = { __typename?: 'Mutation', addGreenWasteLogEntry?: Maybe<(
    { __typename?: 'LogEntry' }
    & LogEntryFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type AddRunOffActivityMutationVariables = Exact<{
  input: LogEntryInput;
}>;


export type AddRunOffActivityMutation = { __typename?: 'Mutation', addRunOffLogEntry?: Maybe<(
    { __typename?: 'LogEntry' }
    & LogEntryFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type DeleteLogEntryMutationVariables = Exact<{
  input: DeleteLogEntryInput;
}>;


export type DeleteLogEntryMutation = { __typename?: 'Mutation', deleteLogEntry?: Maybe<{ __typename?: 'DeleteLogEntryResult', success?: Maybe<boolean> }> };

export type ApproveLogEntryMutationVariables = Exact<{
  input: ApproveLogEntryInput;
}>;


export type ApproveLogEntryMutation = { __typename?: 'Mutation', approveLogEntry?: Maybe<(
    { __typename?: 'LogEntry' }
    & LogEntryFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type LogEntryFieldsFragment = { __typename?: 'LogEntry', id: any, logType: LogEntryLogType, date: any, logEntryData?: Maybe<any>, isDraft: boolean, readyForApproval: boolean, approvedAt?: Maybe<any>, paperlyticsIssuesList?: Maybe<any>, paperlyticsBoundaries?: Maybe<any>, paperlyticsAccuracyScore?: Maybe<number>, performedBy?: Maybe<(
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  )>, stage?: Maybe<{ __typename?: 'Stage', id: any, name: string, startDate: any, calendarBranchId: string, harvestGroup: { __typename?: 'HarvestGroup', id: string, name: string }, zone: { __typename?: 'Zone', id: string, name: string } }>, approvedBy?: Maybe<(
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  )>, paperlyticsImage?: Maybe<{ __typename?: 'PaperlyticsImage', imageUrl?: Maybe<string> }> };

export type LogEntriesFragment = { __typename?: 'HarvestGroup', id: string, logEntries: Array<(
    { __typename?: 'LogEntry' }
    & LogEntryFieldsFragment
  )> };

export type MaintenanceRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type MaintenanceRequestsQuery = { __typename?: 'Query', maintenanceRequests?: Maybe<Array<(
    { __typename?: 'MaintenanceRequest' }
    & MaintenanceRequestFieldsFragment
  )>> };

export type CreateMaintenanceRequestMutationVariables = Exact<{
  input: CreateMaintenanceRequestInput;
}>;


export type CreateMaintenanceRequestMutation = { __typename?: 'Mutation', createMaintenanceRequest?: Maybe<(
    { __typename?: 'MaintenanceRequest' }
    & MaintenanceRequestFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ResolveMaintenanceRequestMutationVariables = Exact<{
  input: ResolveMaintenanceRequestInput;
}>;


export type ResolveMaintenanceRequestMutation = { __typename?: 'Mutation', resolveMaintenanceRequest?: Maybe<(
    { __typename?: 'MaintenanceRequest', id: any }
    & MaintenanceRequestResolutionFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type CreateEquipmentMutationVariables = Exact<{
  input: CreateEquipmentInput;
}>;


export type CreateEquipmentMutation = { __typename?: 'Mutation', createEquipment?: Maybe<(
    { __typename?: 'Equipment' }
    & EquipmentFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateEquipmentMutationVariables = Exact<{
  input: UpdateEquipmentInput;
}>;


export type UpdateEquipmentMutation = { __typename?: 'Mutation', updateEquipment?: Maybe<(
    { __typename?: 'Equipment' }
    & EquipmentFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type BulkCreateEquipmentMutationVariables = Exact<{
  input: BulkCreateEquipmentInput;
}>;


export type BulkCreateEquipmentMutation = { __typename?: 'Mutation', bulkCreateEquipment?: Maybe<Array<Maybe<(
    { __typename?: 'Equipment' }
    & EquipmentFieldsFragment
  )>>> };

export type MaintenanceRequestFieldsFragment = (
  { __typename?: 'MaintenanceRequest', id: any, createdAt: any, firstObservedAt: any, dueDate: any, urgent: boolean, equipmentInoperable: boolean, lockOutTagOut: boolean, description: string, imageUrl?: Maybe<string>, requestedBy: (
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  ), location: { __typename?: 'Location', id: any, name: string }, tags?: Maybe<Array<Maybe<{ __typename?: 'MaintenanceRequestTag', name?: Maybe<string> }>>> }
  & MaintenanceRequestResolutionFieldsFragment
);

export type MaintenanceRequestResolutionFieldsFragment = { __typename?: 'MaintenanceRequest', resolution?: Maybe<{ __typename?: 'MaintenanceRequestResolution', createdAt: any, resolvedAt: any, notes?: Maybe<string>, resolvedBy: (
      { __typename?: 'UserProfile', id: string }
      & NameFragment
    ) }> };

export type EquipmentFieldsFragment = { __typename?: 'Equipment', id: any, label: string, type: EquipmentType, lastMaintenanceDate: any, brand?: Maybe<string>, serialNumber?: Maybe<string>, model?: Maybe<string>, installedAtDate?: Maybe<any>, notes?: Maybe<string>, status: EquipmentStatus, location: { __typename?: 'Location', id: any, name: string } };

export type NutrientsQueryVariables = Exact<{
  filters?: Maybe<NutrientFilterSetInput>;
}>;


export type NutrientsQuery = { __typename?: 'Query', nutrients?: Maybe<Array<(
    { __typename?: 'Nutrient' }
    & NutrientFieldsFragment
  )>> };

export type CreateNutrientMutationVariables = Exact<{
  input: CreateNutrientInput;
}>;


export type CreateNutrientMutation = { __typename?: 'Mutation', createNutrient?: Maybe<(
    { __typename?: 'Nutrient' }
    & NutrientFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateNutrientMutationVariables = Exact<{
  input: UpdateNutrientInput;
}>;


export type UpdateNutrientMutation = { __typename?: 'Mutation', updateNutrient?: Maybe<(
    { __typename?: 'Nutrient' }
    & NutrientFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ActivateNutrientMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActivateNutrientMutation = { __typename?: 'Mutation', updateNutrient?: Maybe<(
    { __typename?: 'Nutrient' }
    & NutrientFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type DeactivateNutrientMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeactivateNutrientMutation = { __typename?: 'Mutation', updateNutrient?: Maybe<(
    { __typename?: 'Nutrient' }
    & NutrientFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type NutrientFieldsFragment = { __typename?: 'Nutrient', id: any, name: string, active: boolean, unitOfMeasure: NutrientUnitOfMeasure, priceInCentsPerUnit: any, boughtPrice?: Maybe<any>, boughtAmount?: Maybe<any>, boughtUnit?: Maybe<string> };

export type UploadPaperlyticsImageMutationVariables = Exact<{
  imageUrl: Scalars['String'];
  harvestGroupId: Scalars['String'];
}>;


export type UploadPaperlyticsImageMutation = { __typename?: 'Mutation', uploadPaperlyticsImage?: Maybe<(
    { __typename?: 'PaperlyticsImage' }
    & PaperlyticsImageFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type RetryPaperlyticsImageMutationVariables = Exact<{
  imageId: Scalars['String'];
}>;


export type RetryPaperlyticsImageMutation = { __typename?: 'Mutation', retryPaperlyticsImage?: Maybe<(
    { __typename?: 'PaperlyticsImage' }
    & PaperlyticsImageFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type PaperlyticsImagesQueryVariables = Exact<{
  filters?: Maybe<PaperlyticsFilterSetInput>;
}>;


export type PaperlyticsImagesQuery = { __typename?: 'Query', paperlyticsImages?: Maybe<Array<(
    { __typename?: 'PaperlyticsImage' }
    & PaperlyticsImageFieldsFragment
  )>> };

export type PaperlyticsImageFieldsFragment = { __typename?: 'PaperlyticsImage', id: any, imageUrl?: Maybe<string>, imageUpload?: Maybe<string>, startedAt?: Maybe<any>, completedAt?: Maybe<any>, success: boolean, targetType?: Maybe<string>, result?: Maybe<any>, accuracyScore?: Maybe<number>, issuesList?: Maybe<any>, harvestGroup?: Maybe<{ __typename?: 'HarvestGroup', id: string, name: string }>, uploadedBy?: Maybe<{ __typename?: 'UserProfile', id: string, firstName: string, lastName: string, email: string }> };

export type RecipesQueryVariables = Exact<{
  filters?: Maybe<RecipeFilterSetInput>;
}>;


export type RecipesQuery = { __typename?: 'Query', recipes?: Maybe<Array<(
    { __typename?: 'Recipe' }
    & RecipeFieldsFragment
  )>> };

export type RecipeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type RecipeQuery = { __typename?: 'Query', recipe: (
    { __typename?: 'Recipe' }
    & RecipeFieldsFragment
  ) };

export type RecipesAndNutrientsQueryVariables = Exact<{
  filters?: Maybe<RecipeFilterSetInput>;
}>;


export type RecipesAndNutrientsQuery = { __typename?: 'Query', recipes?: Maybe<Array<(
    { __typename?: 'Recipe' }
    & RecipeFieldsFragment
  )>>, nutrients?: Maybe<Array<(
    { __typename?: 'Nutrient' }
    & NutrientFieldsFragment
  )>> };

export type CreateRecipeMutationVariables = Exact<{
  input: CreateRecipeInput;
}>;


export type CreateRecipeMutation = { __typename?: 'Mutation', createRecipe?: Maybe<(
    { __typename?: 'Recipe' }
    & RecipeFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateRecipeMutationVariables = Exact<{
  input: UpdateRecipeInput;
}>;


export type UpdateRecipeMutation = { __typename?: 'Mutation', updateRecipe?: Maybe<(
    { __typename?: 'Recipe' }
    & RecipeFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ActivateRecipeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActivateRecipeMutation = { __typename?: 'Mutation', updateRecipe?: Maybe<(
    { __typename?: 'Recipe' }
    & RecipeFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type DeactivateRecipeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeactivateRecipeMutation = { __typename?: 'Mutation', updateRecipe?: Maybe<(
    { __typename?: 'Recipe' }
    & RecipeFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type RecipeFieldsFragment = { __typename?: 'Recipe', id: any, name: string, active: boolean, applicationType: RecipeApplicationType, ec?: Maybe<any>, ph?: Maybe<any>, components: Array<{ __typename?: 'RecipeComponent', id: any, volume: any, nutrient: (
      { __typename?: 'Nutrient' }
      & NutrientFieldsFragment
    ) }> };

export type StageReportFieldsFragment = { __typename?: 'Stage', id: any, name: string, daysInStage: number, startDate: any, endDate: any, calendarBranchId: string, desiredNumberOfDays?: Maybe<number> };

export type StageCalendarFieldsFragment = { __typename?: 'Stage', id: any, name: string, startDate: any, calendarBranchId: string, zone: { __typename?: 'Zone', id: string, name: string }, harvestGroup: { __typename?: 'HarvestGroup', id: string, name: string, colorHexCode?: Maybe<string>, flowerZone?: Maybe<{ __typename?: 'Zone', id: string, name: string }>, site: { __typename?: 'OrganizationSite', id: any, name: string } }, templateUsed?: Maybe<{ __typename?: 'StageTemplate', id: any, createdStageName: string }> };

export type StageFieldsFragment = { __typename?: 'Stage', id: any, name: string, startDate: any, endDate: any, calendarBranchId: string, desiredNumberOfDays?: Maybe<number>, environmentalTargetType: StageEnvironmentalTargetType, maxNumberOfDays?: Maybe<number>, minNumberOfDays?: Maybe<number>, orderInProcess: number, templateUsed?: Maybe<{ __typename?: 'StageTemplate', id: any, name: string }> };

export type StrainsQueryVariables = Exact<{
  filters?: Maybe<StrainFilterSetInput>;
}>;


export type StrainsQuery = { __typename?: 'Query', strains?: Maybe<Array<(
    { __typename?: 'Strain' }
    & StrainFieldsFragment
  )>> };

export type CreateStrainMutationVariables = Exact<{
  input: CreateStrainInput;
}>;


export type CreateStrainMutation = { __typename?: 'Mutation', createStrain?: Maybe<(
    { __typename?: 'Strain' }
    & StrainFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateStrainMutationVariables = Exact<{
  input: UpdateStrainInput;
}>;


export type UpdateStrainMutation = { __typename?: 'Mutation', updateStrain?: Maybe<(
    { __typename?: 'Strain' }
    & StrainFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ActivateStrainMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActivateStrainMutation = { __typename?: 'Mutation', updateStrain?: Maybe<(
    { __typename?: 'Strain' }
    & StrainFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type DeactivateStrainMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeactivateStrainMutation = { __typename?: 'Mutation', updateStrain?: Maybe<(
    { __typename?: 'Strain' }
    & StrainFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type StrainsAndRecipesAndNutrientsQueryVariables = Exact<{
  harvestGroupId: Scalars['String'];
  filters?: Maybe<RecipeFilterSetInput>;
}>;


export type StrainsAndRecipesAndNutrientsQuery = { __typename?: 'Query', harvestGroup: { __typename?: 'HarvestGroup', strains: Array<(
      { __typename?: 'Strain' }
      & StrainReportFieldsFragment
    )> }, recipes?: Maybe<Array<(
    { __typename?: 'Recipe' }
    & RecipeFieldsFragment
  )>>, nutrients?: Maybe<Array<(
    { __typename?: 'Nutrient' }
    & NutrientFieldsFragment
  )>> };

export type StrainFieldsFragment = { __typename?: 'Strain', id: any, name: string, active: boolean, metrcId?: Maybe<string>, subspecies: StrainSubspecies, abbreviation: string, documentationUrl?: Maybe<string>, createdBy: { __typename?: 'UserProfile', id: string, firstName: string, lastName: string } };

export type StrainReportFieldsFragment = { __typename?: 'Strain', id: any, name: string };

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask?: Maybe<(
    { __typename?: 'Task' }
    & TaskFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask?: Maybe<(
    { __typename?: 'Task' }
    & TaskFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type CompleteTaskMutationVariables = Exact<{
  input: CompleteTaskInput;
}>;


export type CompleteTaskMutation = { __typename?: 'Mutation', completeTask?: Maybe<(
    { __typename?: 'Task' }
    & TaskFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UncompleteTaskMutationVariables = Exact<{
  input: UncompleteTaskInput;
}>;


export type UncompleteTaskMutation = { __typename?: 'Mutation', uncompleteTask?: Maybe<(
    { __typename?: 'Task' }
    & TaskFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type TaskFieldsFragment = { __typename?: 'Task', id: any, name: string, startDate?: Maybe<any>, endDate?: Maybe<any>, completedAt?: Maybe<any>, priority: TaskPriority, notes?: Maybe<string>, assignedTo?: Maybe<{ __typename?: 'UserProfile', id: string, firstName: string, lastName: string }>, createdBy: { __typename?: 'UserProfile', id: string, firstName: string, lastName: string }, templateUsed?: Maybe<{ __typename?: 'TaskTemplate', id: any }> };

export type TaskCalendarFieldsFragment = { __typename?: 'Task', id: any, name: string, startDate?: Maybe<any>, endDate?: Maybe<any>, priority: TaskPriority, isComplete: boolean, notes?: Maybe<string>, assignedTo?: Maybe<(
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  )>, templateUsed?: Maybe<{ __typename?: 'TaskTemplate', id: any }>, currentZone?: Maybe<{ __typename?: 'Zone', id: string, name: string }>, stageOnTaskDate?: Maybe<{ __typename?: 'TaskStageInfo', name: string, currentDayOfStage: number, daysInStage: number }>, harvestGroup: { __typename?: 'HarvestGroup', id: string, name: string, colorHexCode?: Maybe<string>, flowerZone?: Maybe<{ __typename?: 'Zone', id: string, name: string }>, site: { __typename?: 'OrganizationSite', id: any, name: string } } };

export type AddHarvestGroupTemplateMutationVariables = Exact<{
  input: CreateHarvestGroupTemplateInput;
}>;


export type AddHarvestGroupTemplateMutation = { __typename?: 'Mutation', createHarvestGroupTemplate?: Maybe<(
    { __typename?: 'HarvestGroupTemplate' }
    & HarvestGroupTemplateFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateHarvestGroupTemplateMutationVariables = Exact<{
  input: UpdateHarvestGroupTemplateInput;
}>;


export type UpdateHarvestGroupTemplateMutation = { __typename?: 'Mutation', updateHarvestGroupTemplate?: Maybe<{ __typename?: 'HarvestGroupTemplateUpdateResult', success?: Maybe<boolean>, message?: Maybe<string>, template?: Maybe<(
      { __typename?: 'HarvestGroupTemplate' }
      & HarvestGroupTemplateFieldsFragment
    )>, conflicts?: Maybe<Array<Maybe<{ __typename?: 'ValidationConflict', type?: Maybe<string>, stageName?: Maybe<string>, taskName?: Maybe<string>, message?: Maybe<string>, suggestedFix?: Maybe<string>, harvestGroupId?: Maybe<string>, severity?: Maybe<string>, harvestGroupName?: Maybe<string>, customStages?: Maybe<Array<Maybe<string>>>, durationChange?: Maybe<number>, oldDuration?: Maybe<number>, newDuration?: Maybe<number>, taskStartDay?: Maybe<number>, taskEndDay?: Maybe<number>, currentStartDate?: Maybe<string>, currentEndDate?: Maybe<string>, newStartDate?: Maybe<string>, newEndDate?: Maybe<string>, affectedStages?: Maybe<Array<Maybe<{ __typename?: 'AffectedStageInfo', stageName?: Maybe<string>, currentStart?: Maybe<string>, currentEnd?: Maybe<string>, newStart?: Maybe<string>, newEnd?: Maybe<string> }>>> }>>>, changeNotifications?: Maybe<Array<Maybe<{ __typename?: 'ValidationConflict', type?: Maybe<string>, stageName?: Maybe<string>, taskName?: Maybe<string>, message?: Maybe<string>, suggestedFix?: Maybe<string>, harvestGroupId?: Maybe<string>, severity?: Maybe<string>, harvestGroupName?: Maybe<string>, customStages?: Maybe<Array<Maybe<string>>>, durationChange?: Maybe<number>, oldDuration?: Maybe<number>, newDuration?: Maybe<number>, taskStartDay?: Maybe<number>, taskEndDay?: Maybe<number>, currentStartDate?: Maybe<string>, currentEndDate?: Maybe<string>, newStartDate?: Maybe<string>, newEndDate?: Maybe<string>, affectedStages?: Maybe<Array<Maybe<{ __typename?: 'AffectedStageInfo', stageName?: Maybe<string>, currentStart?: Maybe<string>, currentEnd?: Maybe<string>, newStart?: Maybe<string>, newEnd?: Maybe<string> }>>> }>>> }> };

export type HarvestGroupTemplateFieldsFragment = { __typename?: 'HarvestGroupTemplate', id: any, name: string, archivedAt?: Maybe<any>, stageTemplates: Array<(
    { __typename?: 'StageTemplate' }
    & HarvestGroupStageTemplateFieldsFragment
  )> };

export type HarvestGroupTemplateVersionFieldsFragment = { __typename?: 'HarvestGroupTemplateVersion', id: any, name: string, version: number, stageTemplates: Array<(
    { __typename?: 'StageTemplate' }
    & HarvestGroupStageTemplateFieldsFragment
  )> };

export type HarvestGroupStageTemplateFieldsFragment = { __typename?: 'StageTemplate', id: any, name: string, createdStageName: string, numberOfDays: number, maxNumberOfDays: number, minNumberOfDays: number, orderInProcess: number, environmentalTargetType: StageTemplateEnvironmentalTargetType, designatedZones: Array<(
    { __typename?: 'Zone' }
    & ZoneFieldsFragment
  )>, taskTemplates: Array<(
    { __typename?: 'TaskTemplate' }
    & HarvestGroupTaskTemplateFieldsFragment
  )> };

export type HarvestGroupTaskTemplateFieldsFragment = { __typename?: 'TaskTemplate', id: any, createdTaskName: string, stageDayStart: number, stageDayEnd: number, taskType: TaskTemplateTaskType, logType?: Maybe<TaskTemplateLogType>, logEntryRecipe?: Maybe<{ __typename?: 'Recipe', id: any, name: string, applicationType: RecipeApplicationType }> };

export type HarvestGroupTemplatesQueryVariables = Exact<{
  filters?: Maybe<HarvestGroupTemplateFilterSetInput>;
}>;


export type HarvestGroupTemplatesQuery = { __typename?: 'Query', harvestGroupTemplates?: Maybe<Array<(
    { __typename?: 'HarvestGroupTemplate' }
    & HarvestGroupTemplateFieldsFragment
  )>> };

export type ArchiveHarvestGroupTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveHarvestGroupTemplateMutation = { __typename?: 'Mutation', updateHarvestGroupTemplateArchived?: Maybe<(
    { __typename?: 'HarvestGroupTemplate' }
    & HarvestGroupTemplateFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UnarchiveHarvestGroupTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnarchiveHarvestGroupTemplateMutation = { __typename?: 'Mutation', updateHarvestGroupTemplateArchived?: Maybe<(
    { __typename?: 'HarvestGroupTemplate' }
    & HarvestGroupTemplateFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type StaffHarvestGroupTemplatesQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type StaffHarvestGroupTemplatesQuery = { __typename?: 'Query', staffHarvestGroupTemplates?: Maybe<Array<(
    { __typename?: 'HarvestGroupTemplate' }
    & HarvestGroupTemplateFieldsFragment
  )>> };

export type YieldFieldsFragment = { __typename?: 'HarvestStrainYield', harvestGroupId: string, totalGrams: number, finalPlantCount: number, strainId: string, strain: (
    { __typename?: 'Strain' }
    & StrainFieldsFragment
  ), budFormFactorYields: Array<(
    { __typename?: 'BudFormFactorYield' }
    & BudFormFactorYieldFragment
  )> };

export type YieldReportFieldsFragment = (
  { __typename?: 'HarvestStrainYield', historicalAvgGramsPerPlant?: Maybe<number>, yieldBatches: Array<(
    { __typename?: 'HarvestYieldBatch' }
    & YieldAnalysisBatchFragment
  )>, strain: (
    { __typename?: 'Strain' }
    & StrainReportFieldsFragment
  ) }
  & YieldFieldsFragment
);

export type BudFormFactorYieldFragment = { __typename?: 'BudFormFactorYield', budFormFactorId: string, numberOfGrams: number, budFormFactor: (
    { __typename?: 'BudFormFactor' }
    & BudFormFactorFieldsFragment
  ) };

export type YieldAnalysisBatchFragment = { __typename?: 'HarvestYieldBatch', id: string, name: string, stream: YieldProductStream, plantCount?: Maybe<number>, gramsPerPlant?: Maybe<number>, dryGrams: number, wetPackagedGrams: number, isOpen: boolean, issues: Array<string>, byFormFactor: Array<(
    { __typename?: 'BudFormFactorYield' }
    & BudFormFactorYieldFragment
  )> };

export type ZonesWithHarvestGroupsQueryVariables = Exact<{
  zoneOptions?: Maybe<LogsFilterInput>;
  filters?: Maybe<ZoneFilterSetInput>;
}>;


export type ZonesWithHarvestGroupsQuery = { __typename?: 'Query', zones?: Maybe<Array<(
    { __typename?: 'Zone' }
    & ZoneWithHarvestGroupFieldsFragment
  )>> };

export type ZonesQueryVariables = Exact<{ [key: string]: never; }>;


export type ZonesQuery = { __typename?: 'Query', zones?: Maybe<Array<(
    { __typename?: 'Zone' }
    & ZoneFieldsFragment
  )>> };

export type AppIndexPageQueryVariables = Exact<{
  filters?: Maybe<ZoneFilterSetInput>;
  taskDateRange?: Maybe<DateRangeInput>;
  calendarBranchId?: Maybe<Scalars['String']>;
}>;


export type AppIndexPageQuery = { __typename?: 'Query', zones?: Maybe<Array<(
    { __typename?: 'Zone' }
    & DashboardZoneCardFieldsFragment
  )>> };

export type CalendarZoneCardsQueryVariables = Exact<{
  filters?: Maybe<ZoneFilterSetInput>;
  taskDateRange?: Maybe<DateRangeInput>;
  calendarBranchId?: Maybe<Scalars['String']>;
}>;


export type CalendarZoneCardsQuery = { __typename?: 'Query', zones?: Maybe<Array<(
    { __typename?: 'Zone' }
    & CalendarZoneCardFieldsFragment
  )>> };

export type CreateZoneMutationVariables = Exact<{
  input: CreateZoneInput;
}>;


export type CreateZoneMutation = { __typename?: 'Mutation', createZone?: Maybe<(
    { __typename?: 'Zone' }
    & ZoneFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateZoneMutationVariables = Exact<{
  input: UpdateZoneInput;
}>;


export type UpdateZoneMutation = { __typename?: 'Mutation', updateZone?: Maybe<(
    { __typename?: 'Zone' }
    & ZoneFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ActivateZoneMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActivateZoneMutation = { __typename?: 'Mutation', updateZone?: Maybe<(
    { __typename?: 'Zone' }
    & ZoneFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type DeactivateZoneMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeactivateZoneMutation = { __typename?: 'Mutation', updateZone?: Maybe<(
    { __typename?: 'Zone' }
    & ZoneFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ZoneNamesQueryVariables = Exact<{
  filters?: Maybe<ZoneFilterSetInput>;
}>;


export type ZoneNamesQuery = { __typename?: 'Query', zones?: Maybe<Array<(
    { __typename?: 'Zone' }
    & ZoneIdAndNameFragment
  )>> };

export type SalesManagerZoneNamesQueryVariables = Exact<{
  filters?: Maybe<SalesManagerZoneFilterSetInput>;
}>;


export type SalesManagerZoneNamesQuery = { __typename?: 'Query', salesManagerZones?: Maybe<Array<(
    { __typename?: 'Zone' }
    & ZoneIdAndNameFragment
  )>> };

export type ZonesWithActiveHarvestGroupsQueryVariables = Exact<{
  filters?: Maybe<ZoneFilterSetInput>;
}>;


export type ZonesWithActiveHarvestGroupsQuery = { __typename?: 'Query', zones?: Maybe<Array<{ __typename?: 'Zone', id: string, name: string, site: { __typename?: 'OrganizationSite', id: any, name: string }, primaryDevice?: Maybe<{ __typename?: 'EnvironmentalDevice', id: any, trolmasterMacAddress?: Maybe<string>, aroyaDeviceId?: Maybe<string>, growlinkControllerId?: Maybe<string> }>, currentHarvestGroups: Array<{ __typename?: 'HarvestGroup', id: string, name: string, site: { __typename?: 'OrganizationSite', organization: { __typename?: 'Organization', id: string, timezone: string } }, stageWeeks: Array<{ __typename?: 'StageWeek', weekNumber: number, weekStartDate: any, weekEndDate: any, hasEnvironmentalData: boolean, stage: { __typename?: 'Stage', id: any, name: string, environmentalTargetType: StageEnvironmentalTargetType, zone: { __typename?: 'Zone', id: string, name: string, lightingClassification?: Maybe<ZoneLightingClassification> } } }> }> }>> };

export type HarvestGroupZoneCardFieldsFragment = (
  { __typename?: 'HarvestGroup', id: string, logEntries: Array<(
    { __typename?: 'LogEntry' }
    & LogEntryFieldsFragment
  )> }
  & HarvestGroupCurrentStageFieldsFragment
);

export type ZoneWithHarvestGroupFieldsFragment = (
  { __typename?: 'Zone', currentHarvestGroups: Array<(
    { __typename?: 'HarvestGroup', logEntries: Array<(
      { __typename?: 'LogEntry' }
      & LogEntryFieldsFragment
    )> }
    & CurrentGroupsShortFieldsFragment
    & HarvestGroupCurrentStageFieldsFragment
  )> }
  & ZoneFieldsFragment
);

export type ZoneIdAndNameFragment = { __typename?: 'Zone', id: string, name: string, site: { __typename?: 'OrganizationSite', id: any, name: string } };

export type ZoneFieldsFragment = { __typename?: 'Zone', id: string, name: string, metrcId?: Maybe<string>, active: boolean, maxConcurrentHarvestGroups?: Maybe<number>, maxConcurrentPlants?: Maybe<number>, lightingClassification?: Maybe<ZoneLightingClassification>, dayStartTime?: Maybe<any>, nightStartTime?: Maybe<any>, dripEmitterSize?: Maybe<any>, cocoContainerSize?: Maybe<ZoneCocoContainerSize>, cocoContainerSizeOtherGallons?: Maybe<number>, soilContainerSize?: Maybe<ZoneSoilContainerSize>, lengthFeet?: Maybe<number>, lengthInches?: Maybe<number>, heightFeet?: Maybe<number>, heightInches?: Maybe<number>, widthFeet?: Maybe<number>, widthInches?: Maybe<number>, rows?: Maybe<number>, roomUsage?: Maybe<ZoneRoomUsage>, numLightsUnderCanopy?: Maybe<number>, underCanopy?: Maybe<boolean>, benchSqFt?: Maybe<number>, tiers?: Maybe<ZoneTiers>, site: { __typename?: 'OrganizationSite', id: any, name: string }, primaryDevice?: Maybe<{ __typename?: 'EnvironmentalDevice', id: any }>, cultivationStyle?: Maybe<{ __typename?: 'CultivationStyle', id: string, name: string }>, irrigationStyle?: Maybe<{ __typename?: 'IrrigationStyle', id: string, name: string }>, irrigationFrequency?: Maybe<{ __typename?: 'IrrigationFrequency', id: string, name: string }>, irrigationType?: Maybe<{ __typename?: 'IrrigationType', id: string, name: string }>, growingMedia?: Maybe<{ __typename?: 'GrowingMedia', id: string, name: string }>, rockwoolBrand?: Maybe<{ __typename?: 'RockwoolBrand', id: string, name: string }>, rockwoolSize?: Maybe<{ __typename?: 'RockwoolSize', id: string, name: string }>, cocoBrand?: Maybe<{ __typename?: 'CocoBrand', id: string, name: string }>, soilBrand?: Maybe<{ __typename?: 'SoilBrand', id: string, name: string }>, underCanopyBrand?: Maybe<{ __typename?: 'UnderCanopyBrand', id: string, name: string }>, controlSystem?: Maybe<{ __typename?: 'ControlSystem', id: string, name: string }>, sensors?: Maybe<{ __typename?: 'Sensors', id: string, name: string }>, rootZoneSensor?: Maybe<{ __typename?: 'Sensors', id: string, name: string }>, dehumidifierSelections: Array<{ __typename?: 'DehumidifierSelection', id: string, brandNameOther?: Maybe<string>, size?: Maybe<number>, numUnits?: Maybe<number>, brand?: Maybe<{ __typename?: 'DehumidifierBrand', id: string, name: string, isCustom: boolean }> }>, circulatingFanSelections: Array<{ __typename?: 'CirculatingFanSelection', id: string, brandNameOther?: Maybe<string>, fanCount?: Maybe<number>, brand?: Maybe<{ __typename?: 'CirculatingFanBrand', id: string, name: string, isCustom: boolean }> }>, acSelections: Array<{ __typename?: 'ACSelection', id: string, brandNameOther?: Maybe<string>, acStyle?: Maybe<AcSelectionAcStyle>, acSizeByTon?: Maybe<number>, acNumUnits?: Maybe<number>, brand?: Maybe<{ __typename?: 'ACBrand', id: string, name: string, isCustom: boolean }> }>, lightingTypeSelections: Array<{ __typename?: 'LightingTypeSelection', id: string, lightingType?: Maybe<LightingTypeSelectionLightingType>, lightingTypeOther?: Maybe<string>, brandNameOther?: Maybe<string>, lightCount?: Maybe<number>, wattsPerLight?: Maybe<number>, brand?: Maybe<{ __typename?: 'LightingTypeBrand', id: string, name: string, isCustom: boolean }> }> };

export type ZoneObservationSummaryFieldsFragment = { __typename?: 'ZoneObservationSummary', day: any, sourceCount: number, reportingSourceCount: number, latestObservation?: Maybe<any>, metrics: Array<{ __typename?: 'ZoneObservationMetric', mean: number, key: string, label: string, unit: string, category: string, sensors: Array<{ __typename?: 'SensorObservationMetric', deviceId: string, name: string, mean: number, dayMean?: Maybe<number>, nightMean?: Maybe<number>, observedBins: number, expectedBins: number, quality?: Maybe<(
        { __typename?: 'SensorMetricQuality' }
        & SensorMetricQualityFieldsFragment
      )> }> }> };

export type ZoneCardFieldsFragment = (
  { __typename?: 'Zone', observationSummary?: Maybe<(
    { __typename?: 'ZoneObservationSummary' }
    & ZoneObservationSummaryFieldsFragment
  )>, currentHarvestGroups: Array<(
    { __typename?: 'HarvestGroup', tasks: Array<(
      { __typename?: 'Task' }
      & TaskCalendarFieldsFragment
    )> }
    & CurrentGroupsShortFieldsFragment
    & HarvestGroupCurrentStageFieldsFragment
  )> }
  & ZoneFieldsFragment
);

export type DashboardTaskFieldsFragment = { __typename?: 'Task', id: any, name: string, startDate?: Maybe<any>, endDate?: Maybe<any> };

export type DashboardHarvestGroupFieldsFragment = { __typename?: 'HarvestGroup', id: string, name: string, harvestDate?: Maybe<any>, colorHexCode?: Maybe<string>, site: { __typename?: 'OrganizationSite', id: any, name: string }, flowerZone?: Maybe<{ __typename?: 'Zone', id: string, name: string }>, currentStage: { __typename?: 'Stage', id: any, name: string, currentDayOfStage: number, daysInStage: number }, tasks: Array<(
    { __typename?: 'Task' }
    & DashboardTaskFieldsFragment
  )> };

export type DashboardZoneCardFieldsFragment = { __typename?: 'Zone', id: string, name: string, roomUsage?: Maybe<ZoneRoomUsage>, dayStartTime?: Maybe<any>, nightStartTime?: Maybe<any>, observationSummary?: Maybe<(
    { __typename?: 'ZoneObservationSummary' }
    & ZoneObservationSummaryFieldsFragment
  )>, site: { __typename?: 'OrganizationSite', id: any, name: string }, primaryDevice?: Maybe<{ __typename?: 'EnvironmentalDevice', id: any }>, currentHarvestGroups: Array<(
    { __typename?: 'HarvestGroup' }
    & DashboardHarvestGroupFieldsFragment
  )> };

export type CalendarZoneCardHarvestGroupFieldsFragment = { __typename?: 'HarvestGroup', id: string, name: string, colorHexCode?: Maybe<string>, currentStage: { __typename?: 'Stage', id: any, name: string, currentDayOfStage: number, daysInStage: number }, tasks: Array<(
    { __typename?: 'Task' }
    & DashboardTaskFieldsFragment
  )> };

export type CalendarZoneCardFieldsFragment = { __typename?: 'Zone', id: string, name: string, roomUsage?: Maybe<ZoneRoomUsage>, observationSummary?: Maybe<(
    { __typename?: 'ZoneObservationSummary' }
    & ZoneObservationSummaryFieldsFragment
  )>, site: { __typename?: 'OrganizationSite', id: any, name: string }, primaryDevice?: Maybe<{ __typename?: 'EnvironmentalDevice', id: any }>, currentHarvestGroups: Array<(
    { __typename?: 'HarvestGroup' }
    & CalendarZoneCardHarvestGroupFieldsFragment
  )> };

export type ZonesOverviewQueryVariables = Exact<{
  filters?: Maybe<ZoneFilterSetInput>;
}>;


export type ZonesOverviewQuery = { __typename?: 'Query', zones?: Maybe<Array<(
    { __typename?: 'Zone' }
    & ZoneFieldsFragment
  )>> };

export type DehumidifierBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type DehumidifierBrandsQuery = { __typename?: 'Query', dehumidifierBrands?: Maybe<Array<{ __typename?: 'DehumidifierBrand', id: string, name: string, isCustom: boolean }>> };

export type CirculatingFanBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type CirculatingFanBrandsQuery = { __typename?: 'Query', circulatingFanBrands?: Maybe<Array<{ __typename?: 'CirculatingFanBrand', id: string, name: string, isCustom: boolean }>> };

export type AcBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type AcBrandsQuery = { __typename?: 'Query', acBrands?: Maybe<Array<{ __typename?: 'ACBrand', id: string, name: string, isCustom: boolean }>> };

export type LightingTypeBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type LightingTypeBrandsQuery = { __typename?: 'Query', lightingTypeBrands?: Maybe<Array<{ __typename?: 'LightingTypeBrand', id: string, name: string, isCustom: boolean }>> };

export type SensorsQueryVariables = Exact<{ [key: string]: never; }>;


export type SensorsQuery = { __typename?: 'Query', sensors?: Maybe<Array<{ __typename?: 'Sensors', id: string, name: string, isCustom: boolean }>> };

export type UnderCanopyBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnderCanopyBrandsQuery = { __typename?: 'Query', underCanopyBrands?: Maybe<Array<{ __typename?: 'UnderCanopyBrand', id: string, name: string, isCustom: boolean }>> };

export type GrowingMediasQueryVariables = Exact<{ [key: string]: never; }>;


export type GrowingMediasQuery = { __typename?: 'Query', growingMedias?: Maybe<Array<{ __typename?: 'GrowingMedia', id: string, name: string, isCustom: boolean }>> };

export type SoilBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type SoilBrandsQuery = { __typename?: 'Query', soilBrands?: Maybe<Array<{ __typename?: 'SoilBrand', id: string, name: string, isCustom: boolean }>> };

export type IrrigationStylesQueryVariables = Exact<{ [key: string]: never; }>;


export type IrrigationStylesQuery = { __typename?: 'Query', irrigationStyles?: Maybe<Array<{ __typename?: 'IrrigationStyle', id: string, name: string }>> };

export type IrrigationFrequenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type IrrigationFrequenciesQuery = { __typename?: 'Query', irrigationFrequencies?: Maybe<Array<{ __typename?: 'IrrigationFrequency', id: string, name: string }>> };

export type IrrigationTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type IrrigationTypesQuery = { __typename?: 'Query', irrigationTypes?: Maybe<Array<{ __typename?: 'IrrigationType', id: string, name: string }>> };

export type ControlSystemsQueryVariables = Exact<{ [key: string]: never; }>;


export type ControlSystemsQuery = { __typename?: 'Query', controlSystems?: Maybe<Array<{ __typename?: 'ControlSystem', id: string, name: string }>> };

export type CultivationStylesQueryVariables = Exact<{ [key: string]: never; }>;


export type CultivationStylesQuery = { __typename?: 'Query', cultivationStyles?: Maybe<Array<{ __typename?: 'CultivationStyle', id: string, name: string }>> };

export type RockwoolBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type RockwoolBrandsQuery = { __typename?: 'Query', rockwoolBrands?: Maybe<Array<{ __typename?: 'RockwoolBrand', id: string, name: string }>> };

export type RockwoolSizesQueryVariables = Exact<{ [key: string]: never; }>;


export type RockwoolSizesQuery = { __typename?: 'Query', rockwoolSizes?: Maybe<Array<{ __typename?: 'RockwoolSize', id: string, name: string, isCustom: boolean }>> };

export type CocoBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type CocoBrandsQuery = { __typename?: 'Query', cocoBrands?: Maybe<Array<{ __typename?: 'CocoBrand', id: string, name: string }>> };

export type BulkUpdateZoneSchedulesMutationVariables = Exact<{
  input: BulkUpdateZoneSchedulesInput;
}>;


export type BulkUpdateZoneSchedulesMutation = { __typename?: 'Mutation', bulkUpdateZoneSchedules?: Maybe<{ __typename?: 'BulkUpdateZoneSchedules', success?: Maybe<boolean>, zones?: Maybe<Array<Maybe<{ __typename?: 'Zone', id: string, name: string, lightingClassification?: Maybe<ZoneLightingClassification>, dayStartTime?: Maybe<any>, nightStartTime?: Maybe<any> }>>> }> };

export type DetectZoneLightingSchedulesMutationVariables = Exact<{
  siteId: Scalars['ID'];
}>;


export type DetectZoneLightingSchedulesMutation = { __typename?: 'Mutation', detectZoneLightingSchedules?: Maybe<{ __typename?: 'DetectZoneLightingSchedules', success?: Maybe<boolean>, error?: Maybe<string>, schedules?: Maybe<Array<Maybe<{ __typename?: 'DetectedZoneSchedule', zoneId: string, zoneName: string, dayStartTime?: Maybe<string>, nightStartTime?: Maybe<string>, detected: boolean, brand?: Maybe<string> }>>> }> };

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = { __typename?: 'Query', tags?: Maybe<Array<{ __typename?: 'Tag', id: any, name: string, colorHexCode?: Maybe<string> }>> };

export type FinanceWorkspaceQueryVariables = Exact<{ [key: string]: never; }>;


export type FinanceWorkspaceQuery = { __typename?: 'Query', financeWorkspace: any, financeMappings: any };

export type FinanceSettingsMutationVariables = Exact<{
  source: Scalars['String'];
  confirm?: Maybe<Scalars['Boolean']>;
  basis?: Maybe<Scalars['String']>;
  mappings?: Maybe<Scalars['GenericScalar']>;
}>;


export type FinanceSettingsMutation = { __typename?: 'Mutation', financeSettings?: Maybe<{ __typename?: 'FinanceSettings', ok?: Maybe<boolean> }> };

export type FinanceConfirmMappingsMutationVariables = Exact<{
  mappings: Scalars['GenericScalar'];
}>;


export type FinanceConfirmMappingsMutation = { __typename?: 'Mutation', financeConfirmMappings?: Maybe<{ __typename?: 'FinanceMappings', ok?: Maybe<boolean> }> };

export type FinancePublishCsvMutationVariables = Exact<{
  runId: Scalars['UUID'];
  months: Array<Scalars['String']>;
  replace?: Maybe<Scalars['Boolean']>;
  mappings?: Maybe<Scalars['GenericScalar']>;
}>;


export type FinancePublishCsvMutation = { __typename?: 'Mutation', financePublishCsv?: Maybe<{ __typename?: 'FinancePublish', ok?: Maybe<boolean> }> };

export type FinanceDeleteDataMutationVariables = Exact<{
  confirm: Scalars['Boolean'];
}>;


export type FinanceDeleteDataMutation = { __typename?: 'Mutation', financeDeleteData?: Maybe<{ __typename?: 'FinanceDelete', ok?: Maybe<boolean> }> };

export type ProcessingJobsQueryVariables = Exact<{
  filters?: Maybe<ProcessingJobFilterSetInput>;
}>;


export type ProcessingJobsQuery = { __typename?: 'Query', processingJobs?: Maybe<Array<(
    { __typename?: 'ProcessingJob' }
    & ProcessingJobOverviewWithGroupFieldsFragment
  )>> };

export type ProcessingGroupJobQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProcessingGroupJobQuery = { __typename?: 'Query', processingJob?: Maybe<(
    { __typename?: 'ProcessingJob' }
    & ProcessingJobOverviewWithLogsFieldsFragment
  )> };

export type CreateProcessingJobMutationVariables = Exact<{
  input: CreateProcessingJobInput;
}>;


export type CreateProcessingJobMutation = { __typename?: 'Mutation', createProcessingJob?: Maybe<(
    { __typename?: 'ProcessingJob' }
    & ProcessingJobOverviewFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type AssignProcessingJobToUserMutationVariables = Exact<{
  input: AssignProcessingJobToUserInput;
}>;


export type AssignProcessingJobToUserMutation = { __typename?: 'Mutation', assignProcessingJobToUser?: Maybe<(
    { __typename?: 'ProcessingJob' }
    & ProcessingJobOverviewFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateProcessingJobMutationVariables = Exact<{
  input: UpdateProcessingJobInput;
}>;


export type UpdateProcessingJobMutation = { __typename?: 'Mutation', updateProcessingJob?: Maybe<(
    { __typename?: 'ProcessingJob' }
    & ProcessingJobOverviewFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type CreateProcessingJobLogMutationVariables = Exact<{
  input: CreateProcessingJobLogInput;
}>;


export type CreateProcessingJobLogMutation = { __typename?: 'Mutation', createProcessingJobLog?: Maybe<(
    { __typename?: 'ProcessingJobLog', job: (
      { __typename?: 'ProcessingJob' }
      & ProcessingJobOverviewFieldsFragment
    ) }
    & ProcessingJobLogFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateProcessingJobLogMutationVariables = Exact<{
  input: UpdateProcessingJobLogInput;
}>;


export type UpdateProcessingJobLogMutation = { __typename?: 'Mutation', updateProcessingJobLog?: Maybe<(
    { __typename?: 'ProcessingJobLog', job: (
      { __typename?: 'ProcessingJob' }
      & ProcessingJobOverviewFieldsFragment
    ) }
    & ProcessingJobLogFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ProcessingJobOverviewWithLogsFieldsFragment = (
  { __typename?: 'ProcessingJob', processingJobLogs: Array<(
    { __typename?: 'ProcessingJobLog' }
    & ProcessingJobLogFieldsFragment
  )> }
  & ProcessingJobOverviewFieldsFragment
);

export type ProcessingJobOverviewFieldsFragment = { __typename?: 'ProcessingJob', id: any, jobStatus: ProcessingJobJobStatus, inputGrams: any, totalOutputGrams?: Maybe<any>, createdAt: any, startedAt?: Maybe<any>, totalWorkedMinutes: any, assignee?: Maybe<(
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  )>, createdBy: (
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  ), inputType: (
    { __typename?: 'BudFormFactor' }
    & BudFormFactorFieldsFragment
  ), strainStage: { __typename?: 'ProcessingGroupStrainStage', status: ProcessingGroupStrainStageStatus, id: any, stage: (
      { __typename?: 'ProcessingGroupStage' }
      & ProcessingGroupStageWithTemplateFieldsFragment
    ), processingGroupStrain: { __typename?: 'ProcessingGroupStrain', id: any, strain: { __typename?: 'Strain', id: any, name: string } } } };

export type ProcessingJobOverviewWithGroupFieldsFragment = (
  { __typename?: 'ProcessingJob' }
  & ProcessingJobOverviewFieldsFragment
);

export type ProcessingJobLogFieldsFragment = { __typename?: 'ProcessingJobLog', id: any, logType: ProcessingJobLogLogType, startedAt: any, endedAt: any, createdAt: any, breakMinutes: number, workedMinutes: any, outputGrams?: Maybe<any>, leftoverInputGrams?: Maybe<number>, createdBy?: Maybe<(
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  )>, performer?: Maybe<(
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  )> };

export type ProcessingGroupsQueryVariables = Exact<{
  filters?: Maybe<ProcessingGroupFilterSetInput>;
}>;


export type ProcessingGroupsQuery = { __typename?: 'Query', processingGroups?: Maybe<Array<(
    { __typename?: 'ProcessingGroup' }
    & ProcessingGroupFieldsFragment
  )>> };

export type CurrentAndUpcomingProcessingGroupsQueryVariables = Exact<{
  unarchived?: Maybe<Scalars['String']>;
}>;


export type CurrentAndUpcomingProcessingGroupsQuery = { __typename?: 'Query', processingGroups?: Maybe<Array<(
    { __typename?: 'ProcessingGroup' }
    & ProcessingGroupFieldsFragment
  )>> };

export type CompletedProcessingGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompletedProcessingGroupsQuery = { __typename?: 'Query', processingGroups?: Maybe<Array<(
    { __typename?: 'ProcessingGroup' }
    & ProcessingGroupOverviewFieldsFragment
  )>> };

export type ProcessingGroupQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ProcessingGroupQuery = { __typename?: 'Query', processingGroup?: Maybe<(
    { __typename?: 'ProcessingGroup' }
    & ProcessingGroupOverviewFieldsFragment
  )> };

export type ProcessingGroupWithJobsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ProcessingGroupWithJobsQuery = { __typename?: 'Query', processingGroup?: Maybe<(
    { __typename?: 'ProcessingGroup' }
    & ProcessingGroupOverviewFieldsFragment
    & ProcessingGroupFieldsWithStageJobsFragment
  )> };

export type ProcessingGroupWithStrainsAndStagesQueryVariables = Exact<{
  id: Scalars['String'];
  strainId?: Maybe<Scalars['String']>;
}>;


export type ProcessingGroupWithStrainsAndStagesQuery = { __typename?: 'Query', processingGroup?: Maybe<(
    { __typename?: 'ProcessingGroup' }
    & ProcessingGroupWithStrainsAndStagesFieldsFragment
  )> };

export type ProcessingGroupWithStrainsAndStagesAndJobsQueryVariables = Exact<{
  id: Scalars['String'];
  strainId?: Maybe<Scalars['String']>;
}>;


export type ProcessingGroupWithStrainsAndStagesAndJobsQuery = { __typename?: 'Query', processingGroup?: Maybe<(
    { __typename?: 'ProcessingGroup' }
    & ProcessingGroupWithStrainsAndStagesFieldsAndJobsFragment
  )> };

export type ProcessingGroupStatusQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ProcessingGroupStatusQuery = { __typename?: 'Query', processingGroup?: Maybe<{ __typename?: 'ProcessingGroup', id: string, name: string, status: ProcessingGroupStatus, processingGroupStrains: Array<{ __typename?: 'ProcessingGroupStrain', id: any, status: ProcessingGroupStrainStatus }> }> };

export type AllProcessingGroupsWithStrainsAndStagesQueryVariables = Exact<{
  strainId?: Maybe<Scalars['String']>;
}>;


export type AllProcessingGroupsWithStrainsAndStagesQuery = { __typename?: 'Query', processingGroups?: Maybe<Array<(
    { __typename?: 'ProcessingGroup' }
    & ProcessingGroupShortOverviewFragment
    & ProcessingGroupWithStrainsAndStagesFieldsFragment
  )>> };

export type AllProcessingGroupsShortOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProcessingGroupsShortOverviewQuery = { __typename?: 'Query', processingGroups?: Maybe<Array<(
    { __typename?: 'ProcessingGroup' }
    & ProcessingGroupShortOverviewFragment
  )>> };

export type CreateProcessingGroupMutationVariables = Exact<{
  input: CreateProcessingGroupInput;
}>;


export type CreateProcessingGroupMutation = { __typename?: 'Mutation', createProcessingGroup?: Maybe<(
    { __typename?: 'ProcessingGroup' }
    & ProcessingGroupFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type CreateProcessingGroupStrainInventoryAdjustmentMutationVariables = Exact<{
  input: CreateProcessingGroupStrainInventoryAdjustmentInput;
}>;


export type CreateProcessingGroupStrainInventoryAdjustmentMutation = { __typename?: 'Mutation', createProcessingGroupStrainInventoryAdjustment?: Maybe<(
    { __typename?: 'ProcessingGroupStrain' }
    & ProcessingGroupStrainFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ArchiveProcessingGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveProcessingGroupMutation = { __typename?: 'Mutation', updateProcessingGroupArchived?: Maybe<(
    { __typename?: 'ProcessingGroup' }
    & ProcessingGroupFieldsFragment
  ) | { __typename?: 'Error' }> };

export type UnarchiveProcessingGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnarchiveProcessingGroupMutation = { __typename?: 'Mutation', updateProcessingGroupArchived?: Maybe<(
    { __typename?: 'ProcessingGroup' }
    & ProcessingGroupFieldsFragment
  ) | { __typename?: 'Error' }> };

export type MoveUpProcessingGroupStrainMutationVariables = Exact<{
  input: MoveUpProcessingGroupStrainInput;
}>;


export type MoveUpProcessingGroupStrainMutation = { __typename?: 'Mutation', moveUpProcessingGroupStrain?: Maybe<(
    { __typename?: 'ProcessingGroupStrain' }
    & ProcessingGroupStrainFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type FinishProcessingGroupStrainMutationVariables = Exact<{
  input: FinishProcessingGroupStrainInput;
}>;


export type FinishProcessingGroupStrainMutation = { __typename?: 'Mutation', finishProcessingGroupStrain?: Maybe<(
    { __typename?: 'ProcessingGroupStrain' }
    & ProcessingGroupStrainFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ProcessingGroupFieldsFragment = { __typename?: 'ProcessingGroup', id: string, name: string, status: ProcessingGroupStatus, archivedAt?: Maybe<any>, colorHexCode?: Maybe<string>, startDate?: Maybe<any>, createdBy: (
    { __typename?: 'UserProfile' }
    & NameFragment
  ), latestStage?: Maybe<(
    { __typename?: 'ProcessingGroupStage' }
    & ProcessingGroupStageFieldsFragment
  )>, processingGroupStrains: Array<{ __typename?: 'ProcessingGroupStrain', id: any }> };

export type ProcessingGroupOverviewFieldsFragment = (
  { __typename?: 'ProcessingGroup', status: ProcessingGroupStatus, processingGroupStages: Array<(
    { __typename?: 'ProcessingGroupStage' }
    & ProcessingGroupStageWithSummaryFieldsFragment
  )>, processingGroupStrains: Array<(
    { __typename?: 'ProcessingGroupStrain' }
    & ProcessingGroupStrainFieldsFragment
  )> }
  & ProcessingGroupFieldsFragment
);

export type ProcessingGroupNameFragment = { __typename?: 'ProcessingGroup', id: string, name: string };

export type ProcessingGroupStageFieldsFragment = { __typename?: 'ProcessingGroupStage', id: any, name: string, status: ProcessingGroupStageStatus, startDate: any, endDate?: Maybe<any>, schedulingScope: ProcessingGroupStageSchedulingScope, totalInputGrams?: Maybe<any>, totalOutputGrams?: Maybe<any>, totalPendingGrams?: Maybe<any>, totalPartialGrams?: Maybe<any>, processingGroup: (
    { __typename?: 'ProcessingGroup' }
    & ProcessingGroupNameFragment
  ), summary: { __typename?: 'ProcessingGroupStrainStageSummary', progressPercent: number, weightCompletedGrams: number, weightTotalGrams: number, numDays?: Maybe<number>, daysElapsed: number, remainingInventoryGrams: number }, processingStageTemplate: { __typename?: 'ProcessingStageTemplate', id: any, name: string, inputTypes: Array<{ __typename?: 'BudFormFactor', id: any, name: string }> } };

export type ProcessingGroupStageWithTemplateFieldsFragment = (
  { __typename?: 'ProcessingGroupStage', processingStageTemplate: (
    { __typename?: 'ProcessingStageTemplate' }
    & ProcessingStageTemplateFieldsFragment
  ) }
  & ProcessingGroupStageFieldsFragment
);

export type ProcessingGroupStrainFieldsFragment = { __typename?: 'ProcessingGroupStrain', id: any, status: ProcessingGroupStrainStatus, orderInProcess?: Maybe<number>, inventoryGrams?: Maybe<any>, totalInputGrams?: Maybe<any>, totalPendingGrams?: Maybe<any>, totalPartialGrams?: Maybe<any>, totalOutputGrams?: Maybe<any>, totalAdjustmentGrams?: Maybe<any>, strain: (
    { __typename?: 'Strain' }
    & StrainFieldsFragment
  ), inventoryAdjustments: Array<(
    { __typename?: 'ProcessingGroupStrainInventoryAdjustment' }
    & AdjustmentFieldsFragment
  )> };

export type AdjustmentFieldsFragment = { __typename?: 'ProcessingGroupStrainInventoryAdjustment', id: any, createdAt: any, adjustmentGrams?: Maybe<any>, description: string, createdBy: (
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  ) };

export type ProcessingGroupWithStrainsAndStagesFieldsFragment = (
  { __typename?: 'ProcessingGroup', inUnfinishedJobs?: Maybe<any>, processingGroupStages: Array<(
    { __typename?: 'ProcessingGroupStage' }
    & ProcessingGroupStageWithSummaryFieldsFragment
  )>, processingGroupStrains: Array<(
    { __typename?: 'ProcessingGroupStrain' }
    & ProcessingGroupStrainFieldsFragment
  )>, processingGroupStrainStages: Array<(
    { __typename?: 'ProcessingGroupStrainStage', id: any, stage: (
      { __typename?: 'ProcessingGroupStage' }
      & ProcessingGroupStageWithSummaryFieldsFragment
    ), processingGroupStrain: { __typename?: 'ProcessingGroupStrain', id: any, strain: (
        { __typename?: 'Strain' }
        & StrainFieldsFragment
      ) } }
    & ProcessingGroupStrainStageOverviewFieldsFragment
  )> }
  & ProcessingGroupShortOverviewFragment
);

export type ProcessingGroupWithStrainsAndStagesFieldsAndJobsFragment = (
  { __typename?: 'ProcessingGroup', processingGroupStages: Array<{ __typename?: 'ProcessingGroupStage', jobs?: Maybe<Array<(
      { __typename?: 'ProcessingJob' }
      & ProcessingJobOverviewFieldsFragment
    )>> }> }
  & ProcessingGroupWithStrainsAndStagesFieldsFragment
);

export type ProcessingGroupStageWithSummaryFieldsFragment = (
  { __typename?: 'ProcessingGroupStage', summary: { __typename?: 'ProcessingGroupStrainStageSummary', progressPercent: number, daysElapsed: number, numDays?: Maybe<number>, weightCompletedGrams: number, weightTotalGrams: number, remainingInventoryGrams: number } }
  & ProcessingGroupStageWithTemplateFieldsFragment
);

export type ProcessingGroupStrainStageSummaryFieldsFragment = { __typename?: 'ProcessingGroupStrainStage', id: any, summary: { __typename?: 'ProcessingGroupStrainStageSummary', progressPercent: number, daysElapsed: number, numDays?: Maybe<number>, weightCompletedGrams: number, weightTotalGrams: number, remainingInventoryGrams: number } };

export type ProcessingGroupStrainStageOverviewFieldsFragment = (
  { __typename?: 'ProcessingGroupStrainStage', id: any, status: ProcessingGroupStrainStageStatus, startDate?: Maybe<any>, endDate?: Maybe<any>, totalInputGrams?: Maybe<any>, totalPendingGrams?: Maybe<any>, totalPartialGrams?: Maybe<any>, totalOutputGrams?: Maybe<any>, processingGroupStrain: { __typename?: 'ProcessingGroupStrain', inventoryAdjustments: Array<(
      { __typename?: 'ProcessingGroupStrainInventoryAdjustment' }
      & AdjustmentFieldsFragment
    )>, strain: (
      { __typename?: 'Strain' }
      & StrainFieldsFragment
    ) }, stage: (
    { __typename?: 'ProcessingGroupStage', processingGroup: { __typename?: 'ProcessingGroup', id: string } }
    & ProcessingGroupStageWithSummaryFieldsFragment
  ) }
  & ProcessingGroupStrainStageSummaryFieldsFragment
);

export type ProcessingGroupShortOverviewFragment = { __typename?: 'ProcessingGroup', id: string, name: string, status: ProcessingGroupStatus, colorHexCode?: Maybe<string> };

export type ProcessingStrainYieldFieldsFragment = { __typename?: 'ProcessingGroupStrain', id: any, status: ProcessingGroupStrainStatus, totalOutputGrams?: Maybe<any>, totalInputGrams?: Maybe<any>, inventoryGrams?: Maybe<any>, strain: { __typename?: 'Strain', id: any } };

export type ProcessingGroupFieldsWithStageJobsFragment = (
  { __typename?: 'ProcessingGroup', id: string, stages?: Maybe<Array<{ __typename?: 'ProcessingGroupStage', processingStageTemplate: { __typename?: 'ProcessingStageTemplate', trackPerformance: boolean, outputTypes: Array<{ __typename?: 'BudFormFactor', id: any, name: string }> }, jobs?: Maybe<Array<{ __typename?: 'ProcessingJob', jobStatus: ProcessingJobJobStatus, totalOutputGrams?: Maybe<any>, totalWorkedMinutes: any, inputType: (
        { __typename?: 'BudFormFactor' }
        & BudFormFactorFieldsFragment
      ), assignee?: Maybe<(
        { __typename?: 'UserProfile', id: string }
        & NameFragment
      )>, strainStage: { __typename?: 'ProcessingGroupStrainStage', processingGroupStrain: { __typename?: 'ProcessingGroupStrain', id: any, strain: { __typename?: 'Strain', id: any, name: string } } } }>> }>> }
  & ProcessingGroupOverviewFieldsFragment
);

export type ProcessingGroupTemplatesQueryVariables = Exact<{
  filters?: Maybe<ProcessingGroupTemplateFilterSetInput>;
}>;


export type ProcessingGroupTemplatesQuery = { __typename?: 'Query', processingGroupTemplates?: Maybe<Array<(
    { __typename?: 'ProcessingGroupTemplate' }
    & ProcessingGroupTemplateFieldsFragment
  )>> };

export type ProcessingGroupTemplateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ProcessingGroupTemplateQuery = { __typename?: 'Query', processingGroupTemplate?: Maybe<(
    { __typename?: 'ProcessingGroupTemplate' }
    & ProcessingGroupTemplateFieldsFragment
  )> };

export type ProcessingGroupTemplateFieldsFragment = { __typename?: 'ProcessingGroupTemplate', id: any, name: string, archivedAt?: Maybe<any>, activeTemplateVersion?: Maybe<(
    { __typename?: 'ProcessingGroupTemplateVersion' }
    & ProcessingGroupTemplateVersionFieldsFragment
  )>, processingGroupTemplateVersions: Array<(
    { __typename?: 'ProcessingGroupTemplateVersion' }
    & ProcessingGroupTemplateVersionFieldsFragment
  )> };

export type ProcessingGroupTemplateVersionFieldsFragment = { __typename?: 'ProcessingGroupTemplateVersion', id: any, name: string, version: number, processingStageTemplates: Array<(
    { __typename?: 'ProcessingStageTemplate' }
    & ProcessingStageTemplateFieldsFragment
  )> };

export type ProcessingStageTemplateFieldsFragment = { __typename?: 'ProcessingStageTemplate', id: any, name: string, numberOfDays: number, trackPerformance: boolean, orderInProcess: number, progressScope: ProcessingStageTemplateProgressScope, schedulingScope: ProcessingStageTemplateSchedulingScope, inputTypes: Array<(
    { __typename?: 'BudFormFactor' }
    & BudFormFactorFieldsFragment
  )>, outputTypes: Array<(
    { __typename?: 'BudFormFactor' }
    & BudFormFactorFieldsFragment
  )> };

export type AddProcessingGroupTemplateMutationVariables = Exact<{
  input: CreateProcessingGroupTemplateInput;
}>;


export type AddProcessingGroupTemplateMutation = { __typename?: 'Mutation', createProcessingGroupTemplate?: Maybe<(
    { __typename?: 'ProcessingGroupTemplate' }
    & ProcessingGroupTemplateFieldsFragment
  ) | { __typename?: 'Error' }> };

export type UpdateActiveProcessingGroupTemplateVersionMutationVariables = Exact<{
  input: UpdateActiveProcessingGroupTemplateVersionInput;
}>;


export type UpdateActiveProcessingGroupTemplateVersionMutation = { __typename?: 'Mutation', updateActiveProcessingGroupTemplateVersion?: Maybe<(
    { __typename?: 'ProcessingGroupTemplate' }
    & ProcessingGroupTemplateFieldsFragment
  ) | { __typename?: 'Error' }> };

export type ArchiveProcessingGroupTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveProcessingGroupTemplateMutation = { __typename?: 'Mutation', updateProcessingGroupTemplateArchived?: Maybe<(
    { __typename?: 'ProcessingGroupTemplate' }
    & ProcessingGroupTemplateFieldsFragment
  ) | { __typename?: 'Error' }> };

export type UnarchiveProcessingGroupTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnarchiveProcessingGroupTemplateMutation = { __typename?: 'Mutation', updateProcessingGroupTemplateArchived?: Maybe<(
    { __typename?: 'ProcessingGroupTemplate' }
    & ProcessingGroupTemplateFieldsFragment
  ) | { __typename?: 'Error' }> };

export type HarvestAnalysisReportQueryVariables = Exact<{
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  start?: Maybe<Scalars['Date']>;
  end?: Maybe<Scalars['Date']>;
}>;


export type HarvestAnalysisReportQuery = { __typename?: 'Query', harvestAnalysisReport: { __typename?: 'ReportResult', truncated: boolean, caveats: Array<Maybe<string>>, excludedBatches?: Maybe<Array<{ __typename?: 'ReportBatchExclusion', groupName?: Maybe<string>, metrcHarvestName?: Maybe<string>, linkedHarvests?: Maybe<Array<string>>, id: string, name: string, harvestGroupId?: Maybe<string>, groupDate?: Maybe<any>, harvestDate?: Maybe<any>, siteName?: Maybe<string>, strainId?: Maybe<string>, strainName?: Maybe<string>, issues: Array<string> }>>, metadata: { __typename?: 'ReportMetadata', generatedAt: any, report: string, organizationId: string }, metrics: Array<Maybe<{ __typename?: 'ReportMetric', name: string, value?: Maybe<number>, unit: string }>>, rows: Array<Maybe<{ __typename?: 'ReportRow', id?: Maybe<string>, name?: Maybe<string>, siteName?: Maybe<string>, zoneId?: Maybe<string>, zoneName?: Maybe<string>, date?: Maybe<any>, startDate?: Maybe<any>, flowerStartDate?: Maybe<any>, metrics: Array<Maybe<{ __typename?: 'ReportMetric', name: string, value?: Maybe<number>, unit: string }>> }>>, dataQuality: Array<Maybe<{ __typename?: 'DataQualityFinding', code: string, severity: string, message: string }>> } };

export type HarvestAnalysisDetailReportQueryVariables = Exact<{
  harvestGroupId: Scalars['ID'];
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  start?: Maybe<Scalars['Date']>;
  end?: Maybe<Scalars['Date']>;
}>;


export type HarvestAnalysisDetailReportQuery = { __typename?: 'Query', harvestAnalysisDetailReport: { __typename?: 'ReportResult', truncated: boolean, caveats: Array<Maybe<string>>, excludedBatches?: Maybe<Array<{ __typename?: 'ReportBatchExclusion', groupName?: Maybe<string>, metrcHarvestName?: Maybe<string>, linkedHarvests?: Maybe<Array<string>>, id: string, name: string, harvestGroupId?: Maybe<string>, groupDate?: Maybe<any>, harvestDate?: Maybe<any>, siteName?: Maybe<string>, strainId?: Maybe<string>, strainName?: Maybe<string>, issues: Array<string> }>>, metadata: { __typename?: 'ReportMetadata', generatedAt: any, report: string, organizationId: string }, metrics: Array<Maybe<{ __typename?: 'ReportMetric', name: string, value?: Maybe<number>, unit: string }>>, rows: Array<Maybe<{ __typename?: 'ReportRow', id?: Maybe<string>, strainId?: Maybe<string>, strainName?: Maybe<string>, metrics: Array<Maybe<{ __typename?: 'ReportMetric', name: string, value?: Maybe<number>, unit: string }>> }>>, dataQuality: Array<Maybe<{ __typename?: 'DataQualityFinding', code: string, severity: string, message: string }>> } };

export type HarvestAnalysisInsightsReportQueryVariables = Exact<{
  harvestGroupIds: Array<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  start?: Maybe<Scalars['Date']>;
  end?: Maybe<Scalars['Date']>;
}>;


export type HarvestAnalysisInsightsReportQuery = { __typename?: 'Query', harvestAnalysisInsightsReport: { __typename?: 'ReportResult', caveats: Array<Maybe<string>>, metadata: { __typename?: 'ReportMetadata', generatedAt: any, report: string, organizationId: string }, rows: Array<Maybe<{ __typename?: 'ReportRow', id?: Maybe<string>, strainId?: Maybe<string>, strainName?: Maybe<string>, status?: Maybe<string>, metrics: Array<Maybe<{ __typename?: 'ReportMetric', name: string, value?: Maybe<number>, unit: string }>> }>>, dataQuality: Array<Maybe<{ __typename?: 'DataQualityFinding', code: string, severity: string, message: string }>> } };

export type StrainPerformanceReportQueryVariables = Exact<{
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  start?: Maybe<Scalars['Date']>;
  end?: Maybe<Scalars['Date']>;
}>;


export type StrainPerformanceReportQuery = { __typename?: 'Query', strainPerformanceReport: { __typename?: 'ReportResult', truncated: boolean, caveats: Array<Maybe<string>>, excludedBatches?: Maybe<Array<{ __typename?: 'ReportBatchExclusion', groupName?: Maybe<string>, metrcHarvestName?: Maybe<string>, linkedHarvests?: Maybe<Array<string>>, id: string, name: string, harvestGroupId?: Maybe<string>, groupDate?: Maybe<any>, harvestDate?: Maybe<any>, siteName?: Maybe<string>, strainId?: Maybe<string>, strainName?: Maybe<string>, issues: Array<string> }>>, metadata: { __typename?: 'ReportMetadata', generatedAt: any, report: string, organizationId: string }, metrics: Array<Maybe<{ __typename?: 'ReportMetric', name: string, value?: Maybe<number>, unit: string }>>, rows: Array<Maybe<{ __typename?: 'ReportRow', id?: Maybe<string>, strainId?: Maybe<string>, strainName?: Maybe<string>, zoneId?: Maybe<string>, zoneName?: Maybe<string>, status?: Maybe<string>, metrics: Array<Maybe<{ __typename?: 'ReportMetric', name: string, value?: Maybe<number>, unit: string }>> }>>, relatedRows: Array<Maybe<{ __typename?: 'ReportRow', id?: Maybe<string>, name?: Maybe<string>, strainId?: Maybe<string>, strainName?: Maybe<string>, zoneId?: Maybe<string>, zoneName?: Maybe<string>, date?: Maybe<any>, status?: Maybe<string>, metrics: Array<Maybe<{ __typename?: 'ReportMetric', name: string, value?: Maybe<number>, unit: string }>> }>>, dataQuality: Array<Maybe<{ __typename?: 'DataQualityFinding', code: string, severity: string, message: string }>> } };

export type HarvestBenchmarkReportQueryVariables = Exact<{
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  start?: Maybe<Scalars['Date']>;
  end?: Maybe<Scalars['Date']>;
}>;


export type HarvestBenchmarkReportQuery = { __typename?: 'Query', harvestBenchmarkReport: { __typename?: 'ReportResult', caveats: Array<Maybe<string>>, metadata: { __typename?: 'ReportMetadata', generatedAt: any, report: string, organizationId: string }, metrics: Array<Maybe<{ __typename?: 'ReportMetric', name: string, value?: Maybe<number>, unit: string }>>, rows: Array<Maybe<{ __typename?: 'ReportRow', id?: Maybe<string>, name?: Maybe<string>, siteName?: Maybe<string>, zoneName?: Maybe<string>, strainId?: Maybe<string>, strainName?: Maybe<string>, date?: Maybe<any>, status?: Maybe<string>, metrics: Array<Maybe<{ __typename?: 'ReportMetric', name: string, value?: Maybe<number>, unit: string }>> }>>, dataQuality: Array<Maybe<{ __typename?: 'DataQualityFinding', code: string, severity: string, message: string }>> } };

export type HarvestForecastReportQueryVariables = Exact<{
  organizationId?: Maybe<Scalars['ID']>;
  siteId?: Maybe<Scalars['ID']>;
  start?: Maybe<Scalars['Date']>;
  end?: Maybe<Scalars['Date']>;
}>;


export type HarvestForecastReportQuery = { __typename?: 'Query', harvestForecastReport: { __typename?: 'ReportResult', truncated: boolean, caveats: Array<Maybe<string>>, excludedBatches?: Maybe<Array<{ __typename?: 'ReportBatchExclusion', groupName?: Maybe<string>, metrcHarvestName?: Maybe<string>, linkedHarvests?: Maybe<Array<string>>, id: string, name: string, harvestGroupId?: Maybe<string>, groupDate?: Maybe<any>, harvestDate?: Maybe<any>, siteName?: Maybe<string>, strainId?: Maybe<string>, strainName?: Maybe<string>, issues: Array<string> }>>, metadata: { __typename?: 'ReportMetadata', generatedAt: any, report: string, organizationId: string }, metrics: Array<Maybe<{ __typename?: 'ReportMetric', name: string, value?: Maybe<number>, unit: string }>>, rows: Array<Maybe<{ __typename?: 'ReportRow', id?: Maybe<string>, name?: Maybe<string>, siteId?: Maybe<string>, siteName?: Maybe<string>, strainId?: Maybe<string>, strainName?: Maybe<string>, date?: Maybe<any>, status?: Maybe<string>, metrics: Array<Maybe<{ __typename?: 'ReportMetric', name: string, value?: Maybe<number>, unit: string }>> }>>, dataQuality: Array<Maybe<{ __typename?: 'DataQualityFinding', code: string, severity: string, message: string }>> } };

export type ApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeysQuery = { __typename?: 'Query', apiKeys: Array<Maybe<{ __typename?: 'ApiKey', id: any, name: string, keyPrefix: string, accessLevel: ApiKeyAccessLevel, rateLimitTier: ApiKeyRateLimitTier, active?: Maybe<boolean>, createdAt: any, lastUsedAt?: Maybe<any>, revokedAt?: Maybe<any>, user: { __typename?: 'UserProfile', id: string, firstName: string, lastName: string, email: string } }>> };

export type CreateApiKeyMutationVariables = Exact<{
  input: CreateApiKeyInput;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey?: Maybe<{ __typename?: 'CreateApiKeySuccess', token: string, apiKey?: Maybe<{ __typename?: 'ApiKey', id: any, name: string, keyPrefix: string, accessLevel: ApiKeyAccessLevel, rateLimitTier: ApiKeyRateLimitTier, active?: Maybe<boolean>, createdAt: any, lastUsedAt?: Maybe<any>, revokedAt?: Maybe<any>, user: { __typename?: 'UserProfile', id: string, firstName: string, lastName: string, email: string } }> } | { __typename?: 'Error', message: string }> };

export type RevokeApiKeyMutationVariables = Exact<{
  input: RevokeApiKeyInput;
}>;


export type RevokeApiKeyMutation = { __typename?: 'Mutation', revokeApiKey?: Maybe<{ __typename?: 'RevokeApiKeySuccess', apiKey?: Maybe<{ __typename?: 'ApiKey', id: any, name: string, keyPrefix: string, accessLevel: ApiKeyAccessLevel, rateLimitTier: ApiKeyRateLimitTier, active?: Maybe<boolean>, createdAt: any, lastUsedAt?: Maybe<any>, revokedAt?: Maybe<any>, user: { __typename?: 'UserProfile', id: string, firstName: string, lastName: string, email: string } }> } | { __typename?: 'Error', message: string }> };

export type UserProfileFragment = (
  { __typename?: 'UserProfile', organization?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  )>, notificationPreferences: Array<(
    { __typename?: 'UserNotificationPreference' }
    & UserNotificationPreferenceFieldsFragment
  )> }
  & UserAttributesFragment
);

export type NameFragment = { __typename?: 'UserProfile', firstName: string, lastName: string };

export type UserAttributesFragment = { __typename?: 'UserProfile', id: string, firstName: string, lastName: string, email: string, lastLogin?: Maybe<any>, organizationId?: Maybe<string>, userPermissions?: Maybe<Array<Maybe<string>>>, isNoLogin: boolean, isStaff: boolean, isSuperuser: boolean, isActive: boolean, salesManagerGroup?: Maybe<UserSalesManagerGroup>, role?: Maybe<(
    { __typename?: 'Role' }
    & RoleFieldsFragment
  )> };

export type OrganizationFieldsFragment = { __typename?: 'Organization', id: string, name: string, timezone: string, moduleEnabledCultivation: boolean, moduleEnabledProcessing: boolean, moduleEnabledFinance: boolean, moduleEnabledMaintenance: boolean, redesignEnabled: boolean, apiEnabled: boolean, optionConvertGramsAbove: number, normalizeWindowMinutes: number, alertConsecutiveThreshold: number, trialAccount?: Maybe<OrganizationTrialAccount>, accountType?: Maybe<OrganizationAccountType>, deactivatedAt?: Maybe<any>, allowMultisite: boolean, dayStartTime: any, nightStartTime: any, confirmedTargetValues: boolean, zones?: Maybe<Array<Maybe<{ __typename?: 'Zone', id: string }>>>, branding: { __typename?: 'OrganizationBranding', colorPreset: string, typographyPreset: string, logoUrl?: Maybe<string>, logoDarkUrl?: Maybe<string>, customized: boolean, updatedAt?: Maybe<any> }, environmentalTargetSets: Array<(
    { __typename?: 'EnvironmentalTargetSet' }
    & EnvironmentalTargetSetFieldsFragment
  )>, checklist?: Maybe<{ __typename?: 'OrganizationChecklist', checklistTasks?: Maybe<Array<Maybe<(
      { __typename?: 'ChecklistTask' }
      & ChecklistTaskFieldsFragment
    )>>> }>, sites?: Maybe<Array<Maybe<(
    { __typename?: 'OrganizationSite' }
    & OrganizationSiteFieldsFragment
  )>>>, metrcLicenses?: Maybe<Array<Maybe<(
    { __typename?: 'OrganizationMetrcLicense' }
    & OrganizationMetrcLicenseFieldsFragment
  )>>> };

export type MyOrganizationPageFieldsFragment = { __typename?: 'Organization', id: string, name: string, timezone: string, allowMultisite: boolean, accountType?: Maybe<OrganizationAccountType>, moduleEnabledCultivation: boolean, moduleEnabledProcessing: boolean, moduleEnabledFinance: boolean, moduleEnabledMaintenance: boolean, apiEnabled: boolean, optionConvertGramsAbove: number, normalizeWindowMinutes: number, alertConsecutiveThreshold: number, notificationPreferences?: Maybe<Array<Maybe<(
    { __typename?: 'OrganizationNotificationPreference' }
    & OrganizationNotificationPreferenceFieldsFragment
  )>>> };

export type OrganizationNotificationPreferenceFieldsFragment = { __typename?: 'OrganizationNotificationPreference', id: any, reportType: OrganizationNotificationPreferenceReportType, enabled: boolean, frequency: OrganizationNotificationPreferenceFrequency, sendToAdmins: boolean, sendToCultivationManagers: boolean, sendToCultivation: boolean, isScheduledReport?: Maybe<boolean>, requiresFrequencySelection?: Maybe<boolean> };

export type UserNotificationPreferenceFieldsFragment = { __typename?: 'UserNotificationPreference', id: any, notificationType: UserNotificationPreferenceNotificationType, optedOut: boolean };

export type StaffOrganizationFieldsFragment = { __typename?: 'Organization', id: string, name: string, apiEnabled: boolean, allowMultisite: boolean, dayStartTime: any, nightStartTime: any, confirmedTargetValues: boolean, sensorBrands: Array<{ __typename?: 'OrganizationSensorBrand', id: any, brandName: OrganizationSensorBrandBrandName, isActive: boolean }>, environmentalTargetSets: Array<(
    { __typename?: 'EnvironmentalTargetSet' }
    & EnvironmentalTargetSetFieldsFragment
  )>, users?: Maybe<Array<Maybe<(
    { __typename?: 'UserProfile' }
    & UserProfileFragment
  )>>>, sites?: Maybe<Array<Maybe<(
    { __typename?: 'OrganizationSite' }
    & OrganizationSiteFieldsFragment
  )>>>, metrcLicenses?: Maybe<Array<Maybe<(
    { __typename?: 'OrganizationMetrcLicense' }
    & OrganizationMetrcLicenseFieldsFragment
  )>>> };

export type AroyaDeviceRequestFieldsFragment = { __typename?: 'AroyaDeviceRequest', id: any, isAdded: boolean, deviceId: string, modelKey: string, serialNumber?: Maybe<string>, name?: Maybe<string>, roomId?: Maybe<string>, roomName?: Maybe<string>, benchId?: Maybe<string>, benchName?: Maybe<string>, category?: Maybe<AroyaDeviceRequestCategory> };

export type GrowlinkDeviceRequestFieldsFragment = { __typename?: 'GrowlinkDeviceRequest', id: any, name?: Maybe<string>, isAdded: boolean, controllerId: string, moduleName?: Maybe<string>, temperatureSensorId?: Maybe<string>, humiditySensorId?: Maybe<string>, co2SensorId?: Maybe<string>, vpdSensorId?: Maybe<string>, lightSensorId?: Maybe<string>, roomName?: Maybe<string> };

export type SensorCredentialFieldsFragment = { __typename?: 'SensorIntegrationCredential', id: any, brand: SensorIntegrationCredentialBrand, label: string, apiKey: string, username?: Maybe<string>, password?: Maybe<string>, growlinkApiVersion?: Maybe<SensorIntegrationCredentialGrowlinkApiVersion>, growlinkOrganizationId?: Maybe<string>, isActive: boolean };

export type OrganizationSiteFieldsFragment = { __typename?: 'OrganizationSite', metrcSyncFloweringDates: boolean, metrcSyncHarvestDates: boolean, id: any, name: string, isActive: boolean, metrcLicenseNumber?: Maybe<string>, metrcUserKey?: Maybe<string>, metrcState?: Maybe<OrganizationSiteMetrcState>, asyncImportStatus?: Maybe<OrganizationSiteAsyncImportStatus>, asyncImportStartedAt?: Maybe<any>, asyncImportCompletedAt?: Maybe<any>, metrcProcessingConnectionsSkipped: boolean, organization: { __typename?: 'Organization', id: string, name: string, timezone: string, allowMultisite: boolean, confirmedTargetValues: boolean, environmentalTargetSets: Array<(
      { __typename?: 'EnvironmentalTargetSet' }
      & EnvironmentalTargetSetFieldsFragment
    )>, metrcLicenses?: Maybe<Array<Maybe<(
      { __typename?: 'OrganizationMetrcLicense' }
      & OrganizationMetrcLicenseFieldsFragment
    )>>>, harvestGroupTemplates?: Maybe<Array<Maybe<{ __typename?: 'HarvestGroupTemplate', id: any, stageTemplates: Array<{ __typename?: 'StageTemplate', id: any, designatedZones: Array<{ __typename?: 'Zone', id: string }> }> }>>> }, zones: Array<{ __typename?: 'Zone', id: string, name: string, active: boolean, metrcId?: Maybe<string>, lightingClassification?: Maybe<ZoneLightingClassification>, roomUsage?: Maybe<ZoneRoomUsage>, dayStartTime?: Maybe<any>, nightStartTime?: Maybe<any> }>, metrcLicenses?: Maybe<Array<Maybe<(
    { __typename?: 'OrganizationSiteMetrcLicense' }
    & OrganizationSiteMetrcLicenseFieldsFragment
  )>>>, metrcLicenseRelationships?: Maybe<Array<Maybe<(
    { __typename?: 'OrganizationMetrcLicenseRelationship' }
    & OrganizationMetrcLicenseRelationshipFieldsFragment
  )>>>, latestMetrcImportBatch?: Maybe<(
    { __typename?: 'MetrcSiteImportBatch' }
    & MetrcSiteImportBatchFieldsFragment
  )> };

export type OrganizationMetrcLicenseFieldsFragment = { __typename?: 'OrganizationMetrcLicense', id: any, licenseNumber: string, userKey: string, metrcState: OrganizationMetrcLicenseMetrcState, licenseType?: Maybe<string>, canGrowPlants?: Maybe<boolean>, role: OrganizationMetrcLicenseRole, isActive: boolean, validationStatus: OrganizationMetrcLicenseValidationStatus, validationError: string, asyncPackageImportStatus?: Maybe<OrganizationMetrcLicenseAsyncPackageImportStatus>, asyncPackageImportStartedAt?: Maybe<any>, asyncPackageImportCompletedAt?: Maybe<any>, asyncPackageImportError?: Maybe<string>, asyncPackageImportProgressPct: number, createdAt: any, updatedAt: any };

export type OrganizationMetrcLicenseRelationshipFieldsFragment = { __typename?: 'OrganizationMetrcLicenseRelationship', id: any, relationshipType: OrganizationMetrcLicenseRelationshipRelationshipType, isActive: boolean, isRequiredForInitialImport: boolean, sourceSiteLicense?: Maybe<{ __typename?: 'OrganizationSiteMetrcLicense', id: any, licenseNumber: string }>, targetOrgLicense: (
    { __typename?: 'OrganizationMetrcLicense' }
    & OrganizationMetrcLicenseFieldsFragment
  ) };

export type OrganizationSiteMetrcLicenseFieldsFragment = { __typename?: 'OrganizationSiteMetrcLicense', id: any, licenseNumber: string, userKey: string, metrcState: OrganizationSiteMetrcLicenseMetrcState, licenseType?: Maybe<string>, canGrowPlants?: Maybe<boolean>, isActive: boolean, validationStatus: OrganizationSiteMetrcLicenseValidationStatus, validationError: string, latestImportStatus?: Maybe<string>, latestImportStartedAt?: Maybe<any>, latestImportCompletedAt?: Maybe<any>, createdAt: any, updatedAt: any };

export type MetrcLicenseImportTaskFieldsFragment = { __typename?: 'MetrcLicenseImportTask', id: any, licenseNumber?: Maybe<string>, status: MetrcLicenseImportTaskStatus, progressPct: number, resultSummary: any, error: string, startedAt?: Maybe<any>, completedAt?: Maybe<any>, orgMetrcLicense: { __typename?: 'OrganizationMetrcLicense', id: any, licenseNumber: string, metrcState: OrganizationMetrcLicenseMetrcState, role: OrganizationMetrcLicenseRole }, siteMetrcLicense?: Maybe<{ __typename?: 'OrganizationSiteMetrcLicense', id: any, licenseNumber: string, metrcState: OrganizationSiteMetrcLicenseMetrcState }> };

export type MetrcSiteImportBatchFieldsFragment = { __typename?: 'MetrcSiteImportBatch', id: any, status: MetrcSiteImportBatchStatus, startedAt?: Maybe<any>, completedAt?: Maybe<any>, licenseTasks?: Maybe<Array<Maybe<(
    { __typename?: 'MetrcLicenseImportTask' }
    & MetrcLicenseImportTaskFieldsFragment
  )>>> };

export type FacilitySurveyFieldsFragment = { __typename?: 'FacilitySurvey', id: any, reportDate: any, completedAt?: Maybe<any>, phPrefilter: any, ecPrefilter: any, tdsPrefilter: number, tempPrefilter: any, phPostfilter: any, ecPostfilter: any, tdsPostfilter: number, tempPostfilter: any, floorsStatus: FacilitySurveyFloorsStatus, wallsStatus: FacilitySurveyWallsStatus, ceilingsStatus: FacilitySurveyCeilingsStatus, footBaths: FacilitySurveyFootBaths, eyeWashStations: FacilitySurveyEyeWashStations, handWashStations: FacilitySurveyHandWashStations, msdsDocumentationUpToDate: FacilitySurveyMsdsDocumentationUpToDate, trainingLogsUpToDate: FacilitySurveyTrainingLogsUpToDate, hygieneAdherence: FacilitySurveyHygieneAdherence, storageConditions: FacilitySurveyStorageConditions, storageLabels: FacilitySurveyStorageLabels, storageContainers: FacilitySurveyStorageContainers, safetyProtocols: FacilitySurveySafetyProtocols, ppeForHandling: FacilitySurveyPpeForHandling, ppeGlovesAvailable: FacilitySurveyPpeGlovesAvailable, ppeGogglesAvailable: FacilitySurveyPpeGogglesAvailable, ppeMasksAvailable: FacilitySurveyPpeMasksAvailable, roFilters: FacilitySurveyRoFilters, roInlineFilters: FacilitySurveyRoInlineFilters, roAirChambers: FacilitySurveyRoAirChambers, roCheckValves: FacilitySurveyRoCheckValves, waterTestTap: FacilitySurveyWaterTestTap, waterTestPostFilter: FacilitySurveyWaterTestPostFilter, notes?: Maybe<string>, recommendations?: Maybe<Array<Maybe<string>>>, createdBy?: Maybe<(
    { __typename?: 'UserProfile' }
    & UserAttributesFragment
  )>, fieldSurvey?: Maybe<{ __typename?: 'FieldSurvey', id: any }> };

export type FieldSurveyFieldsFragment = { __typename?: 'FieldSurvey', id: any, createdAt: any, site?: Maybe<(
    { __typename?: 'OrganizationSite' }
    & OrganizationSiteFieldsFragment
  )>, createdBy?: Maybe<(
    { __typename?: 'UserProfile' }
    & UserAttributesFragment
  )>, facilitySurvey?: Maybe<(
    { __typename?: 'FacilitySurvey' }
    & FacilitySurveyFieldsFragment
  )>, roomSurveys: Array<(
    { __typename?: 'RoomSurvey' }
    & RoomSurveyFieldsFragment
  )> };

export type RoomSurveyFieldsFragment = { __typename?: 'RoomSurvey', id: any, skipReason?: Maybe<string>, reportDate: any, startedAt?: Maybe<any>, completedAt?: Maybe<any>, growthPhase?: Maybe<RoomSurveyGrowthPhase>, lightingComponentsBulbs?: Maybe<RoomSurveyLightingComponentsBulbs>, lightingComponentsBallasts?: Maybe<RoomSurveyLightingComponentsBallasts>, lightingStatus?: Maybe<RoomSurveyLightingStatus>, lightingPpfd?: Maybe<number>, currentTemperature?: Maybe<any>, currentHumidity?: Maybe<any>, leafSurfaceTemperature?: Maybe<any>, acOutletTemperature?: Maybe<any>, vpdLevel?: Maybe<any>, co2Level?: Maybe<any>, runoffCollectionPh?: Maybe<any>, runoffCollectionEc?: Maybe<any>, acUnits?: Maybe<RoomSurveyAcUnits>, dehumidifiers?: Maybe<RoomSurveyDehumidifiers>, circulatingFans?: Maybe<RoomSurveyCirculatingFans>, humidifiers?: Maybe<RoomSurveyHumidifiers>, dripLines?: Maybe<RoomSurveyDripLines>, pumps?: Maybe<RoomSurveyPumps>, catchCups?: Maybe<RoomSurveyCatchCups>, plantStressIndicator?: Maybe<RoomSurveyPlantStressIndicator>, signsOfPests?: Maybe<RoomSurveySignsOfPests>, signsOfPathogens?: Maybe<RoomSurveySignsOfPathogens>, stickyTraps?: Maybe<RoomSurveyStickyTraps>, growingMediumPh?: Maybe<any>, growingMediumEc?: Maybe<any>, nutrientSolutionPh?: Maybe<any>, nutrientSolutionEc?: Maybe<any>, notes?: Maybe<string>, recommendations?: Maybe<Array<Maybe<string>>>, createdBy?: Maybe<(
    { __typename?: 'UserProfile' }
    & UserAttributesFragment
  )>, fieldSurvey: { __typename?: 'FieldSurvey', id: any, createdAt: any }, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string }> };

export type EnvironmentalTargetSetFieldsFragment = { __typename?: 'EnvironmentalTargetSet', id: any, displayName?: Maybe<string>, environmentLightingType: EnvironmentalTargetSetEnvironmentLightingType, organization: { __typename?: 'Organization', id: string }, environmentalTargetValues?: Maybe<Array<Maybe<(
    { __typename?: 'EnvironmentalTargetValues' }
    & EnvironmentalTargetValuesFieldsFragment
  )>>> };

export type EnvironmentalTargetValuesFieldsFragment = { __typename?: 'EnvironmentalTargetValues', id: any, environmentalTargetType: EnvironmentalTargetValuesEnvironmentalTargetType, weekInPhase?: Maybe<number>, dayTempLow: number, dayTempHigh: number, nightTempLow: number, nightTempHigh: number, dayVpdLow: number, dayVpdHigh: number, nightVpdLow: number, nightVpdHigh: number, dayHumidityLow: number, dayHumidityHigh: number, nightHumidityLow: number, nightHumidityHigh: number, dayCo2Low: number, dayCo2High: number, nightCo2Low: number, nightCo2High: number };

export type RoleFieldsFragment = { __typename?: 'Role', id: any, name: string, permissions?: Maybe<Array<Maybe<string>>> };

export type EnvironmentalDeviceFieldsFragment = { __typename?: 'EnvironmentalDevice', id: any, name: string, category?: Maybe<EnvironmentSensorDeviceCategory>, isPrimary: boolean, trolmasterMacAddress?: Maybe<string>, trolmasterModel?: Maybe<EnvironmentSensorDeviceTrolmasterModel>, aroyaModelKey?: Maybe<string>, aroyaDeviceId?: Maybe<string>, aroyaSerialNumber?: Maybe<string>, aroyaApiRoomName?: Maybe<string>, aroyaApiBenchName?: Maybe<string>, growlinkControllerId?: Maybe<string>, growlinkModuleName?: Maybe<string>, growlinkTemperatureSensorId?: Maybe<string>, growlinkHumiditySensorId?: Maybe<string>, growlinkCo2SensorId?: Maybe<string>, growlinkVpdSensorId?: Maybe<string>, growlinkLightSensorId?: Maybe<string>, zone: { __typename?: 'Zone', id: string, name: string, active: boolean, metrcId?: Maybe<string>, primaryDevice?: Maybe<{ __typename?: 'EnvironmentalDevice', id: any }>, site: { __typename?: 'OrganizationSite', id: any, name: string } } };

export type SensorImportTaskFieldsFragment = (
  { __typename?: 'SensorImportTask', id: any, analysisResult: any, eddGapDays?: Maybe<number> }
  & AroyaImportTaskFieldsFragment
  & TrolmasterImportTaskFieldsFragment
  & GrowlinkImportTaskFieldsFragment
);

export type AroyaImportTaskFieldsFragment = { __typename?: 'SensorImportTask', id: any, asyncAroyaStatus?: Maybe<SensorImportTaskAsyncAroyaStatus>, asyncAroyaProgressPct: number, asyncAroyaStartedAt?: Maybe<any>, asyncAroyaCompletedAt?: Maybe<any>, asyncAroyaError?: Maybe<string>, aroyaEtaSecondsRemaining?: Maybe<number>, asyncAroyaSubstrateStatus?: Maybe<SensorImportTaskAsyncAroyaSubstrateStatus>, asyncAroyaSubstrateProgressPct: number, asyncAroyaSubstrateStartedAt?: Maybe<any>, asyncAroyaSubstrateCompletedAt?: Maybe<any>, asyncAroyaSubstrateError?: Maybe<string>, aroyaSubstrateEtaSecondsRemaining?: Maybe<number>, asyncAroyaRefreshStatus?: Maybe<SensorImportTaskAsyncAroyaRefreshStatus>, asyncAroyaRefreshProgressPct: number, asyncAroyaRefreshStartedAt?: Maybe<any>, asyncAroyaRefreshCompletedAt?: Maybe<any>, asyncAroyaRefreshError?: Maybe<string>, aroyaRefreshEtaSecondsRemaining?: Maybe<number>, asyncDailyAroyaStatus?: Maybe<SensorImportTaskAsyncDailyAroyaStatus>, asyncDailyAroyaStartedAt?: Maybe<any>, asyncDailyAroyaCompletedAt?: Maybe<any>, asyncDailyAroyaError?: Maybe<string> };

export type TrolmasterImportTaskFieldsFragment = { __typename?: 'SensorImportTask', id: any, asyncTrolmasterStatus?: Maybe<SensorImportTaskAsyncTrolmasterStatus>, asyncTrolmasterProgressPct: number, asyncTrolmasterStartedAt?: Maybe<any>, asyncTrolmasterCompletedAt?: Maybe<any>, asyncTrolmasterError?: Maybe<string>, trolmasterEtaSecondsRemaining?: Maybe<number>, asyncDailyTrolmasterStatus?: Maybe<SensorImportTaskAsyncDailyTrolmasterStatus>, asyncDailyTrolmasterStartedAt?: Maybe<any>, asyncDailyTrolmasterCompletedAt?: Maybe<any>, asyncDailyTrolmasterError?: Maybe<string> };

export type GrowlinkImportTaskFieldsFragment = { __typename?: 'SensorImportTask', id: any, asyncGrowlinkStatus?: Maybe<SensorImportTaskAsyncGrowlinkStatus>, asyncGrowlinkProgressPct: number, asyncGrowlinkStartedAt?: Maybe<any>, asyncGrowlinkCompletedAt?: Maybe<any>, asyncGrowlinkError?: Maybe<string>, growlinkEtaSecondsRemaining?: Maybe<number>, asyncDailyGrowlinkStatus?: Maybe<SensorImportTaskAsyncDailyGrowlinkStatus>, asyncDailyGrowlinkStartedAt?: Maybe<any>, asyncDailyGrowlinkCompletedAt?: Maybe<any>, asyncDailyGrowlinkError?: Maybe<string> };

export type MetrcImportTaskFieldsFragment = { __typename?: 'MetrcImportTask', id: any, asyncMetrcStatus?: Maybe<MetrcImportTaskAsyncMetrcStatus>, asyncMetrcProgressPct: number, asyncMetrcStartedAt?: Maybe<any>, asyncMetrcCompletedAt?: Maybe<any>, asyncMetrcError?: Maybe<string>, metrcProgressPct?: Maybe<number>, metrcEtaSecondsRemaining?: Maybe<number>, resultSummary: any };

export type TokenAuthMutationVariables = Exact<{
  username_Iexact: Scalars['String'];
  password: Scalars['String'];
}>;


export type TokenAuthMutation = { __typename?: 'Mutation', tokenAuth?: Maybe<{ __typename: 'TokenAuthSuccess', token?: Maybe<string>, refreshToken?: Maybe<string> } | { __typename: 'Error', message: string }> };

export type SendPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendPasswordResetEmailMutation = { __typename?: 'Mutation', sendPasswordResetEmail?: Maybe<{ __typename: 'SendPasswordResetEmailSuccess', success?: Maybe<boolean> } | { __typename: 'Error', message: string }> };

export type SendAccountInvitationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SendAccountInvitationMutation = { __typename?: 'Mutation', sendAccountInvitation?: Maybe<{ __typename?: 'SendAccountInvitation', user?: Maybe<(
      { __typename?: 'UserProfile' }
      & UserProfileFragment
    )> }> };

export type PasswordResetMutationVariables = Exact<{
  token: Scalars['String'];
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
}>;


export type PasswordResetMutation = { __typename?: 'Mutation', passwordReset?: Maybe<{ __typename: 'PasswordResetSuccess', success?: Maybe<boolean> } | { __typename: 'Error', message: string }> };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: Maybe<{ __typename: 'LogoutSuccess', success?: Maybe<boolean> } | { __typename: 'Error', message: string }> };

export type UpdateUserProfileMutationVariables = Exact<{
  input?: Maybe<UpdateUserProfileInput>;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile?: Maybe<{ __typename: 'UpdateUserProfileSuccess', user?: Maybe<(
      { __typename?: 'UserProfile' }
      & UserProfileFragment
    )> } | { __typename: 'Error', message: string }> };

export type MarkTourCompletedMutationVariables = Exact<{
  input: MarkTourCompletedInput;
}>;


export type MarkTourCompletedMutation = { __typename?: 'Mutation', markTourCompleted?: Maybe<(
    { __typename?: 'ChecklistTask' }
    & ChecklistTaskFieldsFragment
  ) | { __typename?: 'Error' }> };

export type ChecklistTaskFieldsFragment = { __typename?: 'ChecklistTask', id: any, name: string, tourStatus: ChecklistTaskTourStatus, dataStatus: ChecklistTaskDataStatus, order: number };

export type WaterRoomChecklistFullFieldsFragment = { __typename?: 'WaterRoomChecklist', id: any, notes?: Maybe<string>, timeCompleted?: Maybe<any>, roomTemp?: Maybe<any>, f1Level?: Maybe<any>, f1Ph?: Maybe<any>, f1Ec?: Maybe<any>, f1TankTemp?: Maybe<any>, f2Level?: Maybe<any>, f2Ph?: Maybe<any>, f2Ec?: Maybe<any>, f2TankTemp?: Maybe<any>, f3Level?: Maybe<any>, f3Ph?: Maybe<any>, f3Ec?: Maybe<any>, f3TankTemp?: Maybe<any>, f4Level?: Maybe<any>, f4Ph?: Maybe<any>, f4Ec?: Maybe<any>, f4TankTemp?: Maybe<any>, f5Level?: Maybe<any>, f5Ph?: Maybe<any>, f5Ec?: Maybe<any>, f5TankTemp?: Maybe<any>, f6Level?: Maybe<any>, f6Ph?: Maybe<any>, f6Ec?: Maybe<any>, f6TankTemp?: Maybe<any>, combinedVegTankLevel?: Maybe<any>, vegTankPh?: Maybe<any>, vegTankEc?: Maybe<any>, vegTankTemp?: Maybe<any>, roHoseValveClosed?: Maybe<boolean>, dechlorHoseValveClosed?: Maybe<boolean>, dishPitHoseValveClosed?: Maybe<boolean>, flowerBaseStockLevel?: Maybe<any>, flowerCalciumStockLevel?: Maybe<any>, flowerPhStockLevel?: Maybe<any>, vegBaseStockLevel?: Maybe<any>, vegCalciumStockLevel?: Maybe<any>, vegPhStockLevel?: Maybe<any>, amHeaterValveCloseAndTempCheck?: Maybe<any>, pmHeaterValveOpen?: Maybe<boolean>, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string }> };

export type WaterQualityStationReadingFullFieldsFragment = { __typename?: 'WaterQualityStationReading', id: any, station: WaterQualityStationReadingStation, item: WaterQualityStationReadingItem, target: string, reading?: Maybe<any>, passFail: WaterQualityStationReadingPassFail, notes?: Maybe<string>, correctiveAction?: Maybe<string> };

export type WaterQualityChecklistFullFieldsFragment = { __typename?: 'WaterQualityChecklist', id: any, notes?: Maybe<string>, timeCompleted?: Maybe<any>, issuesFoundSummary?: Maybe<string>, correctiveActionSummary?: Maybe<string>, readings?: Maybe<Array<Maybe<(
    { __typename?: 'WaterQualityStationReading' }
    & WaterQualityStationReadingFullFieldsFragment
  )>>> };

export type PreHarvestTaskChecklistFullFieldsFragment = { __typename?: 'PreHarvestTaskChecklist', id: any, notes?: Maybe<string>, timeCompleted?: Maybe<any>, pullAroyaSensors?: Maybe<boolean>, pullAroyaSensorsNote?: Maybe<string>, cutLowestLayerOfTrellis?: Maybe<boolean>, cutLowestLayerOfTrellisNote?: Maybe<string>, flowerBinsClean?: Maybe<boolean>, flowerBinsCleanNote?: Maybe<string>, writeFlowerBinLabels?: Maybe<boolean>, writeFlowerBinLabelsNote?: Maybe<string>, dryRoomClean?: Maybe<boolean>, dryRoomCleanNote?: Maybe<string>, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string }> };

export type PostHarvestTaskChecklistFullFieldsFragment = { __typename?: 'PostHarvestTaskChecklist', id: any, notes?: Maybe<string>, timeCompleted?: Maybe<any>, zerotolSprayHallways?: Maybe<boolean>, zerotolSprayHallwaysNote?: Maybe<string>, cleanTablesGutters?: Maybe<boolean>, cleanTablesGuttersNote?: Maybe<string>, cleanMainFloorDrain?: Maybe<boolean>, cleanMainFloorDrainNote?: Maybe<string>, cleanRackAndFloorFans?: Maybe<boolean>, cleanRackAndFloorFansNote?: Maybe<string>, greencleanAcidFlushLines?: Maybe<boolean>, greencleanAcidFlushLinesNote?: Maybe<string>, flushAcidWithZerotolThenRo?: Maybe<boolean>, flushAcidWithZerotolThenRoNote?: Maybe<string>, replaceAcAndDehuFilters?: Maybe<boolean>, replaceAcAndDehuFiltersNote?: Maybe<string>, blowOutDehuDrainLines?: Maybe<boolean>, blowOutDehuDrainLinesNote?: Maybe<string>, replaceFeedingLinesDrippersIfNeeded?: Maybe<boolean>, replaceFeedingLinesDrippersIfNeededNote?: Maybe<string>, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string }> };

export type DryRoomPreHarvestChecklistFullFieldsFragment = { __typename?: 'DryRoomPreHarvestChecklist', id: any, notes?: Maybe<string>, timeCompleted?: Maybe<any>, setTrolmasterSetpoints68f55rh?: Maybe<boolean>, setTrolmasterSetpoints68f55rhNote?: Maybe<string>, setUpFloorFans?: Maybe<boolean>, setUpFloorFansNote?: Maybe<string>, setUpSmallDehus?: Maybe<boolean>, setUpSmallDehusNote?: Maybe<string>, setRacksUpForHanging?: Maybe<boolean>, setRacksUpForHangingNote?: Maybe<string>, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string }> };

export type DryRoomPostHarvestChecklistFullFieldsFragment = { __typename?: 'DryRoomPostHarvestChecklist', id: any, notes?: Maybe<string>, timeCompleted?: Maybe<any>, doubleCheckFloorFans?: Maybe<boolean>, doubleCheckFloorFansNote?: Maybe<string>, smallDehusOnHighestSetting?: Maybe<boolean>, smallDehusOnHighestSettingNote?: Maybe<string>, doubleCheckTrolmasterSetpoints68f55rh?: Maybe<boolean>, doubleCheckTrolmasterSetpoints68f55rhNote?: Maybe<string>, sweepAndRemovePlantDebris?: Maybe<boolean>, sweepAndRemovePlantDebrisNote?: Maybe<string>, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string }> };

export type RoomLoadTaskChecklistFullFieldsFragment = { __typename?: 'RoomLoadTaskChecklist', id: any, notes?: Maybe<string>, timeCompleted?: Maybe<any>, parMeterCheckPlants?: Maybe<boolean>, parMeterCheckPlantsNote?: Maybe<string>, measurePlantHeight?: Maybe<boolean>, measurePlantHeightNote?: Maybe<string>, setUpHumidifiers?: Maybe<boolean>, setUpHumidifiersNote?: Maybe<string>, roomAt82f72rh?: Maybe<boolean>, roomAt82f72rhNote?: Maybe<string>, trolmasterWeek1Settings?: Maybe<boolean>, trolmasterWeek1SettingsNote?: Maybe<string>, reinstallAroyaSensors?: Maybe<boolean>, reinstallAroyaSensorsNote?: Maybe<string>, placeTrolmasterClimateSensors?: Maybe<boolean>, placeTrolmasterClimateSensorsNote?: Maybe<string>, deployCatchCupsRunoffTrays?: Maybe<boolean>, deployCatchCupsRunoffTraysNote?: Maybe<string>, doubleCheckNetbowsPluggedIn?: Maybe<boolean>, doubleCheckNetbowsPluggedInNote?: Maybe<string>, placeMetrcTags?: Maybe<boolean>, placeMetrcTagsNote?: Maybe<string>, add3LayersOfTrellis?: Maybe<boolean>, add3LayersOfTrellisNote?: Maybe<string>, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string }> };

export type TransplantTaskChecklistFullFieldsFragment = { __typename?: 'TransplantTaskChecklist', id: any, notes?: Maybe<string>, timeCompleted?: Maybe<any>, handChargeCocosWithCalciumNitrate?: Maybe<boolean>, handChargeCocosWithCalciumNitrateNote?: Maybe<string>, plugInAroyaSensors?: Maybe<boolean>, plugInAroyaSensorsNote?: Maybe<string>, addGypsumAndCalciumCarbonateRinse?: Maybe<boolean>, addGypsumAndCalciumCarbonateRinseNote?: Maybe<string>, transplantClonesIntoPots?: Maybe<boolean>, transplantClonesIntoPotsNote?: Maybe<string>, topOffEachPlantWithVegFeed?: Maybe<boolean>, topOffEachPlantWithVegFeedNote?: Maybe<string>, plugInNetbows?: Maybe<boolean>, plugInNetbowsNote?: Maybe<string>, placeMetrcTags?: Maybe<boolean>, placeMetrcTagsNote?: Maybe<string>, cleanAndSanitizeCloneTablesTrays?: Maybe<boolean>, cleanAndSanitizeCloneTablesTraysNote?: Maybe<string>, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string }> };

export type CloningTaskChecklistFullFieldsFragment = { __typename?: 'CloningTaskChecklist', id: any, notes?: Maybe<string>, timeCompleted?: Maybe<any>, sanitizeEquipment?: Maybe<boolean>, sanitizeEquipmentNote?: Maybe<string>, preSoakPlugsWithCloneFeed?: Maybe<boolean>, preSoakPlugsWithCloneFeedNote?: Maybe<string>, squeezePlugs?: Maybe<boolean>, squeezePlugsNote?: Maybe<string>, cutClones?: Maybe<boolean>, cutClonesNote?: Maybe<string>, cutStems45DegreesRazorBlade?: Maybe<boolean>, cutStems45DegreesRazorBladeNote?: Maybe<string>, mixDipNGrow?: Maybe<boolean>, mixDipNGrowNote?: Maybe<string>, placeCutsInDipNGrow1520Seconds?: Maybe<boolean>, placeCutsInDipNGrow1520SecondsNote?: Maybe<string>, plugClonesWithCallus?: Maybe<boolean>, plugClonesWithCallusNote?: Maybe<string>, placeMetrcTags?: Maybe<boolean>, placeMetrcTagsNote?: Maybe<string>, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string }> };

export type PruningDefolTaskChecklistFullFieldsFragment = { __typename?: 'PruningDefolTaskChecklist', id: any, notes?: Maybe<string>, timeCompleted?: Maybe<any>, prepPrunersTrashBagsBuckets?: Maybe<boolean>, prepPrunersTrashBagsBucketsNote?: Maybe<string>, sanitizeUsedEquipmentBuckets?: Maybe<boolean>, sanitizeUsedEquipmentBucketsNote?: Maybe<string>, putTablesBackInPlace?: Maybe<boolean>, putTablesBackInPlaceNote?: Maybe<string>, logWasteWeights?: Maybe<boolean>, logWasteWeightsNote?: Maybe<string>, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string }> };

export type DailyTasksChecklistFullFieldsFragment = { __typename?: 'DailyTasksChecklist', id: any, notes?: Maybe<string>, timeCompleted?: Maybe<any>, flowerRoomAmCheck?: Maybe<boolean>, flowerRoomAmCheckNote?: Maybe<string>, collectRunOffs?: Maybe<boolean>, collectRunOffsNote?: Maybe<string>, cleanNetafimFilters?: Maybe<boolean>, cleanNetafimFiltersNote?: Maybe<string>, sweepMopHallways?: Maybe<boolean>, sweepMopHallwaysNote?: Maybe<string>, collectAllTrash?: Maybe<boolean>, collectAllTrashNote?: Maybe<string>, flowerRoomPmCheck?: Maybe<boolean>, flowerRoomPmCheckNote?: Maybe<string>, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string }> };

export type DailyWetRoomTaskChecklistFullFieldsFragment = { __typename?: 'DailyWetRoomTaskChecklist', id: any, notes?: Maybe<string>, timeCompleted?: Maybe<any>, amCheckStockBarrels?: Maybe<boolean>, amCheckStockBarrelsNote?: Maybe<string>, amCalibratePhEcEquipment?: Maybe<boolean>, amCalibratePhEcEquipmentNote?: Maybe<string>, amMakeNeededStockBarrels?: Maybe<boolean>, amMakeNeededStockBarrelsNote?: Maybe<string>, pmCheckStockBarrels?: Maybe<boolean>, pmCheckStockBarrelsNote?: Maybe<string>, pmCleanUpPutAwayProducts?: Maybe<boolean>, pmCleanUpPutAwayProductsNote?: Maybe<string>, pmCapAndStorePhEcEquipment?: Maybe<boolean>, pmCapAndStorePhEcEquipmentNote?: Maybe<string>, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string }> };

export type ExistingWaterRoomChecklistQueryVariables = Exact<{
  checklistSessionId: Scalars['ID'];
}>;


export type ExistingWaterRoomChecklistQuery = { __typename?: 'Query', checklistSession?: Maybe<{ __typename?: 'ChecklistSession', id: any, waterRoomChecklists: Array<(
      { __typename?: 'WaterRoomChecklist' }
      & WaterRoomChecklistFullFieldsFragment
    )> }> };

export type ExistingWaterQualityChecklistQueryVariables = Exact<{
  checklistSessionId: Scalars['ID'];
}>;


export type ExistingWaterQualityChecklistQuery = { __typename?: 'Query', checklistSession?: Maybe<{ __typename?: 'ChecklistSession', id: any, waterQualityChecklists: Array<(
      { __typename?: 'WaterQualityChecklist' }
      & WaterQualityChecklistFullFieldsFragment
    )> }> };

export type ExistingTaskChecklistForSessionQueryVariables = Exact<{
  checklistSessionId: Scalars['ID'];
}>;


export type ExistingTaskChecklistForSessionQuery = { __typename?: 'Query', checklistSession?: Maybe<{ __typename?: 'ChecklistSession', id: any, preHarvestTaskChecklists: Array<(
      { __typename?: 'PreHarvestTaskChecklist' }
      & PreHarvestTaskChecklistFullFieldsFragment
    )>, postHarvestTaskChecklists: Array<(
      { __typename?: 'PostHarvestTaskChecklist' }
      & PostHarvestTaskChecklistFullFieldsFragment
    )>, dryRoomPreHarvestChecklists: Array<(
      { __typename?: 'DryRoomPreHarvestChecklist' }
      & DryRoomPreHarvestChecklistFullFieldsFragment
    )>, dryRoomPostHarvestChecklists: Array<(
      { __typename?: 'DryRoomPostHarvestChecklist' }
      & DryRoomPostHarvestChecklistFullFieldsFragment
    )>, roomLoadTaskChecklists: Array<(
      { __typename?: 'RoomLoadTaskChecklist' }
      & RoomLoadTaskChecklistFullFieldsFragment
    )>, transplantTaskChecklists: Array<(
      { __typename?: 'TransplantTaskChecklist' }
      & TransplantTaskChecklistFullFieldsFragment
    )>, cloningTaskChecklists: Array<(
      { __typename?: 'CloningTaskChecklist' }
      & CloningTaskChecklistFullFieldsFragment
    )>, pruningDefolTaskChecklists: Array<(
      { __typename?: 'PruningDefolTaskChecklist' }
      & PruningDefolTaskChecklistFullFieldsFragment
    )>, dailyTasksChecklists: Array<(
      { __typename?: 'DailyTasksChecklist' }
      & DailyTasksChecklistFullFieldsFragment
    )>, dailyWetRoomTaskChecklists: Array<(
      { __typename?: 'DailyWetRoomTaskChecklist' }
      & DailyWetRoomTaskChecklistFullFieldsFragment
    )> }> };

export type CreatePreHarvestTaskChecklistMutationVariables = Exact<{
  input: PreHarvestTaskChecklistInput;
}>;


export type CreatePreHarvestTaskChecklistMutation = { __typename?: 'Mutation', createPreHarvestTaskChecklist?: Maybe<{ __typename?: 'PreHarvestTaskChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type UpdatePreHarvestTaskChecklistMutationVariables = Exact<{
  input: UpdatePreHarvestTaskChecklistInput;
}>;


export type UpdatePreHarvestTaskChecklistMutation = { __typename?: 'Mutation', updatePreHarvestTaskChecklist?: Maybe<{ __typename?: 'PreHarvestTaskChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type CreatePostHarvestTaskChecklistMutationVariables = Exact<{
  input: PostHarvestTaskChecklistInput;
}>;


export type CreatePostHarvestTaskChecklistMutation = { __typename?: 'Mutation', createPostHarvestTaskChecklist?: Maybe<{ __typename?: 'PostHarvestTaskChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type UpdatePostHarvestTaskChecklistMutationVariables = Exact<{
  input: UpdatePostHarvestTaskChecklistInput;
}>;


export type UpdatePostHarvestTaskChecklistMutation = { __typename?: 'Mutation', updatePostHarvestTaskChecklist?: Maybe<{ __typename?: 'PostHarvestTaskChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type CreateDryRoomPreHarvestChecklistMutationVariables = Exact<{
  input: DryRoomPreHarvestChecklistInput;
}>;


export type CreateDryRoomPreHarvestChecklistMutation = { __typename?: 'Mutation', createDryRoomPreHarvestChecklist?: Maybe<{ __typename?: 'DryRoomPreHarvestChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type UpdateDryRoomPreHarvestChecklistMutationVariables = Exact<{
  input: UpdateDryRoomPreHarvestChecklistInput;
}>;


export type UpdateDryRoomPreHarvestChecklistMutation = { __typename?: 'Mutation', updateDryRoomPreHarvestChecklist?: Maybe<{ __typename?: 'DryRoomPreHarvestChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type CreateDryRoomPostHarvestChecklistMutationVariables = Exact<{
  input: DryRoomPostHarvestChecklistInput;
}>;


export type CreateDryRoomPostHarvestChecklistMutation = { __typename?: 'Mutation', createDryRoomPostHarvestChecklist?: Maybe<{ __typename?: 'DryRoomPostHarvestChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type UpdateDryRoomPostHarvestChecklistMutationVariables = Exact<{
  input: UpdateDryRoomPostHarvestChecklistInput;
}>;


export type UpdateDryRoomPostHarvestChecklistMutation = { __typename?: 'Mutation', updateDryRoomPostHarvestChecklist?: Maybe<{ __typename?: 'DryRoomPostHarvestChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type CreateRoomLoadTaskChecklistMutationVariables = Exact<{
  input: RoomLoadTaskChecklistInput;
}>;


export type CreateRoomLoadTaskChecklistMutation = { __typename?: 'Mutation', createRoomLoadTaskChecklist?: Maybe<{ __typename?: 'RoomLoadTaskChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type UpdateRoomLoadTaskChecklistMutationVariables = Exact<{
  input: UpdateRoomLoadTaskChecklistInput;
}>;


export type UpdateRoomLoadTaskChecklistMutation = { __typename?: 'Mutation', updateRoomLoadTaskChecklist?: Maybe<{ __typename?: 'RoomLoadTaskChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type CreateTransplantTaskChecklistMutationVariables = Exact<{
  input: TransplantTaskChecklistInput;
}>;


export type CreateTransplantTaskChecklistMutation = { __typename?: 'Mutation', createTransplantTaskChecklist?: Maybe<{ __typename?: 'TransplantTaskChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type UpdateTransplantTaskChecklistMutationVariables = Exact<{
  input: UpdateTransplantTaskChecklistInput;
}>;


export type UpdateTransplantTaskChecklistMutation = { __typename?: 'Mutation', updateTransplantTaskChecklist?: Maybe<{ __typename?: 'TransplantTaskChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type CreateCloningTaskChecklistMutationVariables = Exact<{
  input: CloningTaskChecklistInput;
}>;


export type CreateCloningTaskChecklistMutation = { __typename?: 'Mutation', createCloningTaskChecklist?: Maybe<{ __typename?: 'CloningTaskChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type UpdateCloningTaskChecklistMutationVariables = Exact<{
  input: UpdateCloningTaskChecklistInput;
}>;


export type UpdateCloningTaskChecklistMutation = { __typename?: 'Mutation', updateCloningTaskChecklist?: Maybe<{ __typename?: 'CloningTaskChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type CreatePruningDefolTaskChecklistMutationVariables = Exact<{
  input: PruningDefolTaskChecklistInput;
}>;


export type CreatePruningDefolTaskChecklistMutation = { __typename?: 'Mutation', createPruningDefolTaskChecklist?: Maybe<{ __typename?: 'PruningDefolTaskChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type UpdatePruningDefolTaskChecklistMutationVariables = Exact<{
  input: UpdatePruningDefolTaskChecklistInput;
}>;


export type UpdatePruningDefolTaskChecklistMutation = { __typename?: 'Mutation', updatePruningDefolTaskChecklist?: Maybe<{ __typename?: 'PruningDefolTaskChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type CreateDailyTasksChecklistMutationVariables = Exact<{
  input: DailyTasksChecklistInput;
}>;


export type CreateDailyTasksChecklistMutation = { __typename?: 'Mutation', createDailyTasksChecklist?: Maybe<{ __typename?: 'DailyTasksChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type UpdateDailyTasksChecklistMutationVariables = Exact<{
  input: UpdateDailyTasksChecklistInput;
}>;


export type UpdateDailyTasksChecklistMutation = { __typename?: 'Mutation', updateDailyTasksChecklist?: Maybe<{ __typename?: 'DailyTasksChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type CreateDailyWetRoomTaskChecklistMutationVariables = Exact<{
  input: DailyWetRoomTaskChecklistInput;
}>;


export type CreateDailyWetRoomTaskChecklistMutation = { __typename?: 'Mutation', createDailyWetRoomTaskChecklist?: Maybe<{ __typename?: 'DailyWetRoomTaskChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type UpdateDailyWetRoomTaskChecklistMutationVariables = Exact<{
  input: UpdateDailyWetRoomTaskChecklistInput;
}>;


export type UpdateDailyWetRoomTaskChecklistMutation = { __typename?: 'Mutation', updateDailyWetRoomTaskChecklist?: Maybe<{ __typename?: 'DailyWetRoomTaskChecklist', id: any, timeCompleted?: Maybe<any>, notes?: Maybe<string> } | { __typename?: 'Error', message: string }> };

export type CreateChecklistEntryMutationVariables = Exact<{
  input: CreateChecklistEntryInput;
}>;


export type CreateChecklistEntryMutation = { __typename?: 'Mutation', createChecklistEntry?: Maybe<(
    { __typename?: 'ChecklistEntry' }
    & ChecklistEntryFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateChecklistEntryMutationVariables = Exact<{
  input: UpdateChecklistEntryInput;
}>;


export type UpdateChecklistEntryMutation = { __typename?: 'Mutation', updateChecklistEntry?: Maybe<(
    { __typename?: 'ChecklistEntry' }
    & ChecklistEntryFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type AirClimateSectionFieldsFragment = { __typename?: 'AirClimateSection', id: any, environmentFeel?: Maybe<AirClimateSectionEnvironmentFeel>, environmentalFeelNote?: Maybe<string>, airCirculation?: Maybe<AirClimateSectionAirCirculation>, airCirculationNote?: Maybe<string> };

export type LightingSectionFieldsFragment = { __typename?: 'LightingSection', id: any, lightsWorking?: Maybe<LightingSectionLightsWorking>, lightsWorkingNote?: Maybe<string> };

export type CultivationSectionFieldsFragment = { __typename?: 'CultivationSection', id: any, overallPlantHealth?: Maybe<CultivationSectionOverallPlantHealth>, overallPlantHealthNote?: Maybe<string>, rootHealth?: Maybe<CultivationSectionRootHealth>, rootHealthNote?: Maybe<string>, wiltingPlants?: Maybe<CultivationSectionWiltingPlants>, wiltingPlantsLocation?: Maybe<string>, yellowingDiscoloration?: Maybe<CultivationSectionYellowingDiscoloration>, yellowingDiscolorationNote?: Maybe<string>, growthRate?: Maybe<CultivationSectionGrowthRate>, growthRateNote?: Maybe<string> };

export type IpmSectionFieldsFragment = { __typename?: 'IPMSection', id: any, pestsVisible?: Maybe<IpmSectionPestsVisible>, pestsType?: Maybe<string>, diseaseSigns?: Maybe<IpmSectionDiseaseSigns>, diseaseSignsOther?: Maybe<string>, stickyTraps?: Maybe<IpmSectionStickyTraps>, stickyTrapsNote?: Maybe<string> };

export type MaintenanceSectionFieldsFragment = { __typename?: 'MaintenanceSection', id: any, hvacRunning?: Maybe<MaintenanceSectionHvacRunning>, hvacRunningNote?: Maybe<string>, irrigationSystem?: Maybe<MaintenanceSectionIrrigationSystem>, irrigationSystemNote?: Maybe<string>, filterCheck?: Maybe<MaintenanceSectionFilterCheck>, filterCheckNote?: Maybe<string>, tableDrains?: Maybe<MaintenanceSectionTableDrains>, tableDrainsNote?: Maybe<string>, pumpsOperating?: Maybe<MaintenanceSectionPumpsOperating>, pumpsOperatingNote?: Maybe<string>, dehumidifiers?: Maybe<MaintenanceSectionDehumidifiers>, dehumidifiersNote?: Maybe<string>, unusualNoises?: Maybe<MaintenanceSectionUnusualNoises>, unusualNoisesSource?: Maybe<string> };

export type SafetySectionFieldsFragment = { __typename?: 'SafetySection', id: any, areaClean?: Maybe<SafetySectionAreaClean>, areaCleanNote?: Maybe<string>, spillsPresent?: Maybe<SafetySectionSpillsPresent>, spillsLocation?: Maybe<string>, toolsPutAway?: Maybe<SafetySectionToolsPutAway>, toolsPutAwayNote?: Maybe<string>, benchSpacing?: Maybe<SafetySectionBenchSpacing>, benchSpacingNote?: Maybe<string> };

export type RunoffSectionFieldsFragment = { __typename?: 'RunoffSection', id: any, entries?: Maybe<Array<Maybe<{ __typename?: 'RunoffSectionEntry', id: any, ec?: Maybe<any>, ph?: Maybe<any>, amount?: Maybe<any>, type: RunoffSectionEntryType, notes?: Maybe<string>, strain?: Maybe<{ __typename?: 'Strain', id: any, name: string }> }>>> };

export type ChecklistEntryFieldsFragment = { __typename?: 'ChecklistEntry', id: any, timePeriod?: Maybe<ChecklistEntryTimePeriod>, notes?: Maybe<string>, timeCompleted?: Maybe<any>, followUpRequired?: Maybe<ChecklistEntryFollowUpRequired>, skipReason?: Maybe<string>, photos?: Maybe<any>, createdAt: any, updatedAt: any, inspector?: Maybe<(
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  )>, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string }>, airClimateSection?: Maybe<(
    { __typename?: 'AirClimateSection' }
    & AirClimateSectionFieldsFragment
  )>, lightingSection?: Maybe<(
    { __typename?: 'LightingSection' }
    & LightingSectionFieldsFragment
  )>, cultivationSection?: Maybe<(
    { __typename?: 'CultivationSection' }
    & CultivationSectionFieldsFragment
  )>, ipmSection?: Maybe<(
    { __typename?: 'IPMSection' }
    & IpmSectionFieldsFragment
  )>, maintenanceSection?: Maybe<(
    { __typename?: 'MaintenanceSection' }
    & MaintenanceSectionFieldsFragment
  )>, safetySection?: Maybe<(
    { __typename?: 'SafetySection' }
    & SafetySectionFieldsFragment
  )>, runoffSection?: Maybe<(
    { __typename?: 'RunoffSection' }
    & RunoffSectionFieldsFragment
  )> };

export type CreateWaterRoomChecklistMutationVariables = Exact<{
  input: WaterRoomChecklistInput;
}>;


export type CreateWaterRoomChecklistMutation = { __typename?: 'Mutation', createWaterRoomChecklist?: Maybe<(
    { __typename?: 'WaterRoomChecklist' }
    & WaterRoomChecklistFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateWaterRoomChecklistMutationVariables = Exact<{
  input: UpdateWaterRoomChecklistInput;
}>;


export type UpdateWaterRoomChecklistMutation = { __typename?: 'Mutation', updateWaterRoomChecklist?: Maybe<(
    { __typename?: 'WaterRoomChecklist' }
    & WaterRoomChecklistFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type WaterRoomChecklistFieldsFragment = { __typename?: 'WaterRoomChecklist', id: any, roomTemp?: Maybe<any>, f1Level?: Maybe<any>, f1Ph?: Maybe<any>, f1Ec?: Maybe<any>, f1TankTemp?: Maybe<any>, f2Level?: Maybe<any>, f2Ph?: Maybe<any>, f2Ec?: Maybe<any>, f2TankTemp?: Maybe<any>, f3Level?: Maybe<any>, f3Ph?: Maybe<any>, f3Ec?: Maybe<any>, f3TankTemp?: Maybe<any>, f4Level?: Maybe<any>, f4Ph?: Maybe<any>, f4Ec?: Maybe<any>, f4TankTemp?: Maybe<any>, f5Level?: Maybe<any>, f5Ph?: Maybe<any>, f5Ec?: Maybe<any>, f5TankTemp?: Maybe<any>, f6Level?: Maybe<any>, f6Ph?: Maybe<any>, f6Ec?: Maybe<any>, f6TankTemp?: Maybe<any>, combinedVegTankLevel?: Maybe<any>, vegTankPh?: Maybe<any>, vegTankEc?: Maybe<any>, vegTankTemp?: Maybe<any>, roHoseValveClosed?: Maybe<boolean>, dechlorHoseValveClosed?: Maybe<boolean>, dishPitHoseValveClosed?: Maybe<boolean>, flowerBaseStockLevel?: Maybe<any>, flowerCalciumStockLevel?: Maybe<any>, flowerPhStockLevel?: Maybe<any>, vegBaseStockLevel?: Maybe<any>, vegCalciumStockLevel?: Maybe<any>, vegPhStockLevel?: Maybe<any>, amHeaterValveCloseAndTempCheck?: Maybe<any>, pmHeaterValveOpen?: Maybe<boolean>, notes?: Maybe<string>, photos?: Maybe<any>, timeCompleted?: Maybe<any>, inspector?: Maybe<(
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  )> };

export type CreateWaterQualityChecklistMutationVariables = Exact<{
  input: WaterQualityChecklistInput;
}>;


export type CreateWaterQualityChecklistMutation = { __typename?: 'Mutation', createWaterQualityChecklist?: Maybe<(
    { __typename?: 'WaterQualityChecklist' }
    & WaterQualityChecklistFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateWaterQualityChecklistMutationVariables = Exact<{
  input: UpdateWaterQualityChecklistInput;
}>;


export type UpdateWaterQualityChecklistMutation = { __typename?: 'Mutation', updateWaterQualityChecklist?: Maybe<(
    { __typename?: 'WaterQualityChecklist' }
    & WaterQualityChecklistFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type WaterQualityChecklistFieldsFragment = { __typename?: 'WaterQualityChecklist', id: any, notes?: Maybe<string>, photos?: Maybe<any>, timeCompleted?: Maybe<any>, issuesFoundSummary?: Maybe<string>, correctiveActionSummary?: Maybe<string>, inspector?: Maybe<(
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  )>, readings?: Maybe<Array<Maybe<{ __typename?: 'WaterQualityStationReading', id: any, station: WaterQualityStationReadingStation, item: WaterQualityStationReadingItem, target: string, reading?: Maybe<any>, passFail: WaterQualityStationReadingPassFail, notes?: Maybe<string>, correctiveAction?: Maybe<string> }>>> };

export type CreateRoomWalkthroughChecklistMutationVariables = Exact<{
  input: CreateRoomWalkthroughChecklistInput;
}>;


export type CreateRoomWalkthroughChecklistMutation = { __typename?: 'Mutation', createRoomWalkthroughChecklist?: Maybe<(
    { __typename?: 'RoomWalkthroughChecklist' }
    & RoomWalkthroughChecklistFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateRoomWalkthroughChecklistMutationVariables = Exact<{
  input: UpdateRoomWalkthroughChecklistInput;
}>;


export type UpdateRoomWalkthroughChecklistMutation = { __typename?: 'Mutation', updateRoomWalkthroughChecklist?: Maybe<(
    { __typename?: 'RoomWalkthroughChecklist' }
    & RoomWalkthroughChecklistFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type CreateChecklistSessionMutationVariables = Exact<{
  input: CreateChecklistSessionInput;
}>;


export type CreateChecklistSessionMutation = { __typename?: 'Mutation', createChecklistSession?: Maybe<(
    { __typename?: 'ChecklistSession' }
    & ChecklistSessionFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type RoomWalkthroughChecklistFieldsFragment = { __typename?: 'RoomWalkthroughChecklist', id: any, timePeriod?: Maybe<ChecklistEntryTimePeriod>, notes?: Maybe<string>, timeCompleted?: Maybe<any>, followUpRequired?: Maybe<ChecklistEntryFollowUpRequired>, skipReason?: Maybe<string>, createdAt: any, updatedAt: any, photos?: Maybe<any>, inspector?: Maybe<(
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  )>, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string }>, airClimateSection?: Maybe<{ __typename?: 'AirClimateSection', id: any, environmentFeel?: Maybe<AirClimateSectionEnvironmentFeel>, environmentalFeelNote?: Maybe<string>, airCirculation?: Maybe<AirClimateSectionAirCirculation>, airCirculationNote?: Maybe<string> }>, lightingSection?: Maybe<{ __typename?: 'LightingSection', id: any, lightsWorking?: Maybe<LightingSectionLightsWorking>, lightsWorkingNote?: Maybe<string> }>, cultivationSection?: Maybe<{ __typename?: 'CultivationSection', id: any, overallPlantHealth?: Maybe<CultivationSectionOverallPlantHealth>, overallPlantHealthNote?: Maybe<string>, rootHealth?: Maybe<CultivationSectionRootHealth>, rootHealthNote?: Maybe<string>, wiltingPlants?: Maybe<CultivationSectionWiltingPlants>, wiltingPlantsLocation?: Maybe<string>, yellowingDiscoloration?: Maybe<CultivationSectionYellowingDiscoloration>, yellowingDiscolorationNote?: Maybe<string>, growthRate?: Maybe<CultivationSectionGrowthRate>, growthRateNote?: Maybe<string> }>, ipmSection?: Maybe<{ __typename?: 'IPMSection', id: any, pestsVisible?: Maybe<IpmSectionPestsVisible>, pestsType?: Maybe<string>, diseaseSigns?: Maybe<IpmSectionDiseaseSigns>, diseaseSignsOther?: Maybe<string>, stickyTraps?: Maybe<IpmSectionStickyTraps>, stickyTrapsNote?: Maybe<string> }>, maintenanceSection?: Maybe<{ __typename?: 'MaintenanceSection', id: any, hvacRunning?: Maybe<MaintenanceSectionHvacRunning>, hvacRunningNote?: Maybe<string>, irrigationSystem?: Maybe<MaintenanceSectionIrrigationSystem>, irrigationSystemNote?: Maybe<string>, filterCheck?: Maybe<MaintenanceSectionFilterCheck>, filterCheckNote?: Maybe<string>, tableDrains?: Maybe<MaintenanceSectionTableDrains>, tableDrainsNote?: Maybe<string>, pumpsOperating?: Maybe<MaintenanceSectionPumpsOperating>, pumpsOperatingNote?: Maybe<string>, dehumidifiers?: Maybe<MaintenanceSectionDehumidifiers>, dehumidifiersNote?: Maybe<string>, unusualNoises?: Maybe<MaintenanceSectionUnusualNoises>, unusualNoisesSource?: Maybe<string> }>, safetySection?: Maybe<{ __typename?: 'SafetySection', id: any, areaClean?: Maybe<SafetySectionAreaClean>, areaCleanNote?: Maybe<string>, spillsPresent?: Maybe<SafetySectionSpillsPresent>, spillsLocation?: Maybe<string>, toolsPutAway?: Maybe<SafetySectionToolsPutAway>, toolsPutAwayNote?: Maybe<string>, benchSpacing?: Maybe<SafetySectionBenchSpacing>, benchSpacingNote?: Maybe<string> }>, runoffSection?: Maybe<(
    { __typename?: 'RunoffSection' }
    & RunoffSectionFieldsFragment
  )> };

export type ChecklistSessionFieldsFragment = { __typename?: 'ChecklistSession', id: any, date: any, checklistType: ChecklistSessionChecklistType, primaryZoneName?: Maybe<string>, createdAt: any, updatedAt: any, site?: Maybe<{ __typename?: 'OrganizationSite', id: any, name: string, zones: Array<{ __typename?: 'Zone', id: string, name: string, active: boolean }> }>, createdBy?: Maybe<(
    { __typename?: 'UserProfile', id: string }
    & NameFragment
  )>, roomWalkthroughs: Array<{ __typename?: 'ChecklistEntry', id: any, timeCompleted?: Maybe<any>, zone?: Maybe<{ __typename?: 'Zone', id: string }> }> };

export type CreateTrolmasterDeviceMutationVariables = Exact<{
  input: CreateTrolmasterDeviceInput;
}>;


export type CreateTrolmasterDeviceMutation = { __typename?: 'Mutation', createTrolmasterDevice?: Maybe<(
    { __typename?: 'EnvironmentalDevice' }
    & EnvironmentalDeviceFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type CreateAroyaDeviceMutationVariables = Exact<{
  input: CreateAroyaDeviceInput;
}>;


export type CreateAroyaDeviceMutation = { __typename?: 'Mutation', createAroyaDevice?: Maybe<(
    { __typename?: 'EnvironmentalDevice' }
    & EnvironmentalDeviceFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type CreateGrowlinkDeviceMutationVariables = Exact<{
  input: CreateGrowlinkDeviceInput;
}>;


export type CreateGrowlinkDeviceMutation = { __typename?: 'Mutation', createGrowlinkDevice?: Maybe<(
    { __typename?: 'EnvironmentalDevice' }
    & EnvironmentalDeviceFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateGrowlinkDeviceMutationVariables = Exact<{
  input: UpdateGrowlinkDeviceInput;
}>;


export type UpdateGrowlinkDeviceMutation = { __typename?: 'Mutation', updateGrowlinkDevice?: Maybe<(
    { __typename?: 'EnvironmentalDevice' }
    & EnvironmentalDeviceFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateTrolmasterDeviceMutationVariables = Exact<{
  input: UpdateTrolmasterDeviceInput;
}>;


export type UpdateTrolmasterDeviceMutation = { __typename?: 'Mutation', updateTrolmasterDevice?: Maybe<(
    { __typename?: 'EnvironmentalDevice' }
    & EnvironmentalDeviceFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateAroyaDeviceMutationVariables = Exact<{
  input: UpdateAroyaDeviceInput;
}>;


export type UpdateAroyaDeviceMutation = { __typename?: 'Mutation', updateAroyaDevice?: Maybe<(
    { __typename?: 'EnvironmentalDevice' }
    & EnvironmentalDeviceFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type DeleteEnvironmentalDeviceMutationVariables = Exact<{
  input: DeleteEnvironmentalDeviceInput;
}>;


export type DeleteEnvironmentalDeviceMutation = { __typename?: 'Mutation', deleteEnvironmentalDevice?: Maybe<{ __typename?: 'EnvironmentalDevice', id: any } | { __typename?: 'Error', message: string }> };

export type SetPrimaryDeviceMutationVariables = Exact<{
  input: SetPrimaryDeviceInput;
}>;


export type SetPrimaryDeviceMutation = { __typename?: 'Mutation', setPrimaryDevice?: Maybe<(
    { __typename?: 'EnvironmentalDevice' }
    & EnvironmentalDeviceFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ImportAroyaDataMutationVariables = Exact<{
  siteId: Scalars['ID'];
}>;


export type ImportAroyaDataMutation = { __typename?: 'Mutation', importAroyaData?: Maybe<{ __typename?: 'OrganizationSite', id: any, sensorImportTask?: Maybe<(
      { __typename?: 'SensorImportTask' }
      & AroyaImportTaskFieldsFragment
    )> } | { __typename?: 'Error', message: string }> };

export type ImportAroyaSubstrateDataMutationVariables = Exact<{
  siteId: Scalars['ID'];
}>;


export type ImportAroyaSubstrateDataMutation = { __typename?: 'Mutation', importAroyaSubstrateData?: Maybe<{ __typename?: 'OrganizationSite', id: any, sensorImportTask?: Maybe<(
      { __typename?: 'SensorImportTask' }
      & AroyaImportTaskFieldsFragment
    )> } | { __typename?: 'Error', message: string }> };

export type ImportTrolmasterDataMutationVariables = Exact<{
  siteId: Scalars['ID'];
}>;


export type ImportTrolmasterDataMutation = { __typename?: 'Mutation', importTrolmasterData?: Maybe<{ __typename?: 'OrganizationSite', id: any, sensorImportTask?: Maybe<(
      { __typename?: 'SensorImportTask' }
      & TrolmasterImportTaskFieldsFragment
    )> } | { __typename?: 'Error', message: string }> };

export type ImportGrowlinkDataMutationVariables = Exact<{
  siteId: Scalars['ID'];
}>;


export type ImportGrowlinkDataMutation = { __typename?: 'Mutation', importGrowlinkData?: Maybe<{ __typename?: 'OrganizationSite', id: any, sensorImportTask?: Maybe<(
      { __typename?: 'SensorImportTask' }
      & GrowlinkImportTaskFieldsFragment
    )> } | { __typename?: 'Error', message: string }> };

export type ReassignDeviceZoneMutationVariables = Exact<{
  input: ReassignDeviceZoneInput;
}>;


export type ReassignDeviceZoneMutation = { __typename?: 'Mutation', reassignDeviceZone?: Maybe<(
    { __typename?: 'EnvironmentalDevice' }
    & EnvironmentalDeviceFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ValidateDeviceQrCodeMutationVariables = Exact<{
  input: ValidateDeviceQrCodeInput;
}>;


export type ValidateDeviceQrCodeMutation = { __typename?: 'Mutation', validateDeviceQrCode?: Maybe<{ __typename?: 'ValidateDeviceQrCodeResult', macAddress?: Maybe<string>, error?: Maybe<string> }> };

export type UpdateEnvironmentalTargetSetMutationVariables = Exact<{
  input: UpdateEnvironmentalTargetSetInput;
}>;


export type UpdateEnvironmentalTargetSetMutation = { __typename?: 'Mutation', updateEnvironmentalTargetSet?: Maybe<(
    { __typename?: 'EnvironmentalTargetSet' }
    & EnvironmentalTargetSetFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateEnvironmentalTargetSetBulkMutationVariables = Exact<{
  input: UpdateEnvironmentalTargetSetBulkInput;
}>;


export type UpdateEnvironmentalTargetSetBulkMutation = { __typename?: 'Mutation', updateEnvironmentalTargetSetBulk?: Maybe<(
    { __typename?: 'EnvironmentalTargetSet' }
    & EnvironmentalTargetSetFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type CreateEnvironmentalTargetSetMutationVariables = Exact<{
  input: CreateEnvironmentalTargetSetInput;
}>;


export type CreateEnvironmentalTargetSetMutation = { __typename?: 'Mutation', createEnvironmentalTargetSet?: Maybe<(
    { __typename?: 'EnvironmentalTargetSet' }
    & EnvironmentalTargetSetFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type CreateFieldAgentMutationVariables = Exact<{
  input: CreateFieldAgentInput;
}>;


export type CreateFieldAgentMutation = { __typename?: 'Mutation', createFieldAgent?: Maybe<{ __typename?: 'CreateFieldAgentSuccess', token: string, fieldAgent?: Maybe<{ __typename?: 'FieldAgent', id: any, agentId: string, label: string, vendor: string, hostname: string, localIp?: Maybe<string>, subnet: string, softwareVersion: string, status: FieldAgentStatus, isStale?: Maybe<boolean>, isActive: boolean, lastSeenAt?: Maybe<any>, devices: Array<{ __typename?: 'FieldAgentDevice', id: any }> }> } | { __typename?: 'Error', message: string }> };

export type RotateFieldAgentTokenMutationVariables = Exact<{
  input: RotateFieldAgentTokenInput;
}>;


export type RotateFieldAgentTokenMutation = { __typename?: 'Mutation', rotateFieldAgentToken?: Maybe<{ __typename?: 'RotateFieldAgentTokenSuccess', token: string, fieldAgent?: Maybe<{ __typename?: 'FieldAgent', id: any, agentId: string, tokenKeyPrefix: string }> } | { __typename?: 'Error', message: string }> };

export type GenerateFieldAgentClaimCodeMutationVariables = Exact<{
  input: GenerateFieldAgentClaimCodeInput;
}>;


export type GenerateFieldAgentClaimCodeMutation = { __typename?: 'Mutation', generateFieldAgentClaimCode?: Maybe<{ __typename?: 'GenerateFieldAgentClaimCodeSuccess', claimCode: string, expiresAt: any, fieldAgent?: Maybe<{ __typename?: 'FieldAgent', id: any, agentId: string }> } | { __typename?: 'Error', message: string }> };

export type MapFieldAgentDeviceMutationVariables = Exact<{
  input: MapFieldAgentDeviceInput;
}>;


export type MapFieldAgentDeviceMutation = { __typename?: 'Mutation', mapFieldAgentDevice?: Maybe<{ __typename?: 'FieldAgentDevice', id: any, sensorDevice?: Maybe<{ __typename?: 'EnvironmentalDevice', id: any, name: string, zone: { __typename?: 'Zone', id: string, name: string } }> } | { __typename?: 'Error', message: string }> };

export type ResolveIntegrityEventMutationVariables = Exact<{
  input: ResolveIntegrityEventInput;
}>;


export type ResolveIntegrityEventMutation = { __typename?: 'Mutation', resolveIntegrityEvent?: Maybe<{ __typename?: 'ResolveIntegrityEventPayload', errors: Array<string>, event?: Maybe<{ __typename?: 'IntegrityEvent', id: string, category: string, severity: string, message: string, resolutionState: string, resolutionAction?: Maybe<string>, siteId: string, siteName: string, availableActions: Array<{ __typename?: 'IntegrityEventAction', action: string, label: string }>, resolutionOptions: { __typename?: 'IntegrityResolutionOptions', budFormFactors: Array<{ __typename?: 'IntegrityResolutionOption', id: string, label: string }>, zones: Array<{ __typename?: 'IntegrityResolutionOption', id: string, label: string }>, harvestGroups: Array<{ __typename?: 'IntegrityResolutionOption', id: string, label: string }> } }>, createdSideEffects: Array<{ __typename?: 'IntegritySideEffect', type: string, id?: Maybe<string>, label: string }>, queuedTask?: Maybe<{ __typename?: 'IntegrityQueuedTask', type: string, label?: Maybe<string> }> }> };

export type ImportMetrcCompletedHarvestGroupsMutationVariables = Exact<{
  input: ImportMetrcCompletedHarvestGroupsInput;
}>;


export type ImportMetrcCompletedHarvestGroupsMutation = { __typename?: 'Mutation', importMetrcCompletedHarvestGroups?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  ) | { __typename?: 'Error' }> };

export type ImportMetrcLocationsMutationVariables = Exact<{
  input: ImportMetrcLocationsInput;
}>;


export type ImportMetrcLocationsMutation = { __typename?: 'Mutation', importMetrcLocations?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ImportMetrcStrainsMutationVariables = Exact<{
  input: ImportMetrcStrainsInput;
}>;


export type ImportMetrcStrainsMutation = { __typename?: 'Mutation', importMetrcStrains?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  ) | { __typename?: 'Error' }> };

export type ImportMetrcTemplateMutationVariables = Exact<{
  input: ImportMetrcTemplateInput;
}>;


export type ImportMetrcTemplateMutation = { __typename?: 'Mutation', importMetrcTemplate?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ImportMetrcBudFormFactorsMutationVariables = Exact<{
  input: ImportMetrcBudFormFactorsInput;
}>;


export type ImportMetrcBudFormFactorsMutation = { __typename?: 'Mutation', importMetrcBudFormFactors?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  ) | { __typename?: 'Error' }> };

export type ImportMetrcZoneRotationMutationVariables = Exact<{
  input: ImportMetrcZoneRotationInput;
}>;


export type ImportMetrcZoneRotationMutation = { __typename?: 'Mutation', importMetrcZoneRotation?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  ) | { __typename?: 'Error' }> };

export type ImportMetrcCurrentHarvestGroupsMutationVariables = Exact<{
  input: ImportMetrcCurrentHarvestGroupsInput;
}>;


export type ImportMetrcCurrentHarvestGroupsMutation = { __typename?: 'Mutation', importMetrcCurrentHarvestGroups?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  ) | { __typename?: 'Error' }> };

export type CreateOrganizationAndFirstUserMutationVariables = Exact<{
  input: CreateOrganizationAndFirstUserInput;
}>;


export type CreateOrganizationAndFirstUserMutation = { __typename?: 'Mutation', createOrganizationAndFirstUser?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateOrganizationSettingsMutationVariables = Exact<{
  input?: Maybe<UpdateOrganizationSettingsInput>;
}>;


export type UpdateOrganizationSettingsMutation = { __typename?: 'Mutation', updateOrganizationSettings?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateOrganizationBrandingMutationVariables = Exact<{
  input: UpdateOrganizationBrandingInput;
}>;


export type UpdateOrganizationBrandingMutation = { __typename?: 'Mutation', updateOrganizationBranding?: Maybe<{ __typename?: 'Organization', id: string, branding: { __typename?: 'OrganizationBranding', colorPreset: string, logoUrl?: Maybe<string>, logoDarkUrl?: Maybe<string>, customized: boolean, updatedAt?: Maybe<any> } } | { __typename?: 'Error', message: string }> };

export type EnableMultisiteMutationVariables = Exact<{
  input: EnableMultisiteInput;
}>;


export type EnableMultisiteMutation = { __typename?: 'Mutation', enableMultisite?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  ) | { __typename?: 'Error' }> };

export type UpdateRoleMutationVariables = Exact<{
  input: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole?: Maybe<(
    { __typename?: 'Role' }
    & RoleFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type AddTrolmasterApiKeyMutationVariables = Exact<{
  input: AddTrolmasterApiKeyInput;
}>;


export type AddTrolmasterApiKeyMutation = { __typename?: 'Mutation', addTrolmasterApiKey?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  ) | { __typename?: 'Error' }> };

export type AddAroyaApiKeyMutationVariables = Exact<{
  input: AddAroyaApiKeyInput;
}>;


export type AddAroyaApiKeyMutation = { __typename?: 'Mutation', addAroyaApiKey?: Maybe<{ __typename?: 'AddAroyaApiKeyResult', error?: Maybe<string>, devices?: Maybe<Array<Maybe<{ __typename?: 'AroyaDevice', deviceId?: Maybe<string>, modelKey?: Maybe<string>, serialNumber?: Maybe<string>, name?: Maybe<string> }>>>, organization?: Maybe<{ __typename?: 'Organization', id: string }> }> };

export type AddGrowlinkApiKeyMutationVariables = Exact<{
  input: AddGrowlinkApiKeyInput;
}>;


export type AddGrowlinkApiKeyMutation = { __typename?: 'Mutation', addGrowlinkApiKey?: Maybe<{ __typename?: 'AddGrowlinkApiKeyResult', error?: Maybe<string>, devices?: Maybe<Array<Maybe<{ __typename?: 'GrowlinkDevice', controllerId?: Maybe<string>, moduleName?: Maybe<string>, temperatureSensorId?: Maybe<string>, humiditySensorId?: Maybe<string>, co2SensorId?: Maybe<string>, vpdSensorId?: Maybe<string> }>>>, organization?: Maybe<{ __typename?: 'Organization', id: string }> }> };

export type AddSiteAroyaCredentialMutationVariables = Exact<{
  input: AddSiteAroyaCredentialInput;
}>;


export type AddSiteAroyaCredentialMutation = { __typename?: 'Mutation', addSiteAroyaCredential?: Maybe<{ __typename?: 'AddSiteAroyaCredentialResult', error?: Maybe<string>, credential?: Maybe<{ __typename?: 'SensorIntegrationCredential', id: any, brand: SensorIntegrationCredentialBrand, label: string }> }> };

export type AddSiteGrowlinkCredentialMutationVariables = Exact<{
  input: AddSiteGrowlinkCredentialInput;
}>;


export type AddSiteGrowlinkCredentialMutation = { __typename?: 'Mutation', addSiteGrowlinkCredential?: Maybe<{ __typename?: 'AddSiteGrowlinkCredentialResult', error?: Maybe<string>, organizations?: Maybe<Array<Maybe<{ __typename?: 'GrowlinkOrganization', id: string, name: string }>>>, credential?: Maybe<{ __typename?: 'SensorIntegrationCredential', id: any, brand: SensorIntegrationCredentialBrand, label: string, growlinkApiVersion?: Maybe<SensorIntegrationCredentialGrowlinkApiVersion>, growlinkOrganizationId?: Maybe<string> }> }> };

export type AddSiteTrolmasterCredentialMutationVariables = Exact<{
  input: AddSiteTrolmasterCredentialInput;
}>;


export type AddSiteTrolmasterCredentialMutation = { __typename?: 'Mutation', addSiteTrolmasterCredential?: Maybe<{ __typename?: 'AddSiteTrolmasterCredentialResult', error?: Maybe<string>, credential?: Maybe<{ __typename?: 'SensorIntegrationCredential', id: any, brand: SensorIntegrationCredentialBrand, label: string }> }> };

export type RefreshSiteAroyaDeviceRequestsMutationVariables = Exact<{
  input: RefreshSiteAroyaDeviceRequestsInput;
}>;


export type RefreshSiteAroyaDeviceRequestsMutation = { __typename?: 'Mutation', refreshSiteAroyaDeviceRequests?: Maybe<{ __typename?: 'RefreshSiteAroyaDeviceRequestsResult', error?: Maybe<string>, devices?: Maybe<Array<Maybe<{ __typename?: 'AroyaDevice', deviceId?: Maybe<string>, modelKey?: Maybe<string>, serialNumber?: Maybe<string>, name?: Maybe<string> }>>> }> };

export type RefreshSiteGrowlinkDeviceRequestsMutationVariables = Exact<{
  input: RefreshSiteGrowlinkDeviceRequestsInput;
}>;


export type RefreshSiteGrowlinkDeviceRequestsMutation = { __typename?: 'Mutation', refreshSiteGrowlinkDeviceRequests?: Maybe<{ __typename?: 'RefreshSiteGrowlinkDeviceRequestsResult', error?: Maybe<string>, devices?: Maybe<Array<Maybe<{ __typename?: 'GrowlinkDevice', controllerId?: Maybe<string>, moduleName?: Maybe<string>, temperatureSensorId?: Maybe<string>, humiditySensorId?: Maybe<string>, co2SensorId?: Maybe<string>, vpdSensorId?: Maybe<string>, name: string }>>> }> };

export type ConfirmTargetValuesMutationVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type ConfirmTargetValuesMutation = { __typename?: 'Mutation', confirmTargetValues?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  ) | { __typename?: 'Error' }> };

export type RegenerateAlertsMutationVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type RegenerateAlertsMutation = { __typename?: 'Mutation', regenerateAlerts?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  ) | { __typename?: 'Error' }> };

export type CopySensorCredentialToAllSitesMutationVariables = Exact<{
  input: CopySensorCredentialToAllSitesInput;
}>;


export type CopySensorCredentialToAllSitesMutation = { __typename?: 'Mutation', copySensorCredentialToAllSites?: Maybe<{ __typename?: 'CopySensorCredentialToAllSitesResult', updatedCount?: Maybe<number>, skippedCount?: Maybe<number>, updatedSiteNames?: Maybe<Array<Maybe<string>>>, brandsAddedCount?: Maybe<number>, brandsAddedSiteNames?: Maybe<Array<Maybe<string>>>, error?: Maybe<string> }> };

export type UpdateNotificationPreferenceMutationVariables = Exact<{
  input?: Maybe<UpdateNotificationPreferenceInput>;
}>;


export type UpdateNotificationPreferenceMutation = { __typename?: 'Mutation', updateNotificationPreference?: Maybe<{ __typename?: 'OrganizationNotificationPreference', id: any, reportType: OrganizationNotificationPreferenceReportType, enabled: boolean, frequency: OrganizationNotificationPreferenceFrequency, sendToAdmins: boolean, sendToCultivationManagers: boolean } | { __typename?: 'Error', message: string }> };

export type UpdateUserNotificationPreferenceMutationVariables = Exact<{
  input: UpdateUserNotificationPreferenceInput;
}>;


export type UpdateUserNotificationPreferenceMutation = { __typename?: 'Mutation', updateUserNotificationPreference?: Maybe<(
    { __typename?: 'UserNotificationPreference' }
    & UserNotificationPreferenceFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type SetOrganizationActiveMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  active: Scalars['Boolean'];
}>;


export type SetOrganizationActiveMutation = { __typename?: 'Mutation', setOrganizationActive?: Maybe<{ __typename?: 'Organization', id: string, deactivatedAt?: Maybe<any> } | { __typename?: 'Error', message: string }> };

export type CreateSiteMutationVariables = Exact<{
  input: CreateSiteInput;
}>;


export type CreateSiteMutation = { __typename?: 'Mutation', createSite?: Maybe<(
    { __typename?: 'OrganizationSite' }
    & OrganizationSiteFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateSiteMutationVariables = Exact<{
  input: UpdateSiteInput;
}>;


export type UpdateSiteMutation = { __typename?: 'Mutation', updateSite?: Maybe<(
    { __typename?: 'OrganizationSite' }
    & OrganizationSiteFieldsFragment
  ) | { __typename?: 'Error' }> };

export type UpdateSiteCredentialsMutationVariables = Exact<{
  input: UpdateSiteCredentialsInput;
}>;


export type UpdateSiteCredentialsMutation = { __typename?: 'Mutation', updateSiteCredentials?: Maybe<(
    { __typename?: 'OrganizationSite' }
    & OrganizationSiteFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type AddSiteMetrcLicenseMutationVariables = Exact<{
  input: AddSiteMetrcLicenseInput;
}>;


export type AddSiteMetrcLicenseMutation = { __typename?: 'Mutation', addSiteMetrcLicense?: Maybe<(
    { __typename?: 'OrganizationSite' }
    & OrganizationSiteFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type ValidateOrganizationMetrcApiKeyMutationVariables = Exact<{
  input: OrganizationMetrcApiKeyInput;
}>;


export type ValidateOrganizationMetrcApiKeyMutation = { __typename?: 'Mutation', validateOrganizationMetrcApiKey?: Maybe<{ __typename?: 'ValidateOrganizationMetrcApiKeySuccess', facilities: Array<{ __typename?: 'MetrcApiKeyFacility', licenseNumber: string, siteName?: Maybe<string>, isConfigured: boolean, willCatchUp: boolean }> } | { __typename?: 'Error', message: string }> };

export type RotateOrganizationMetrcApiKeyAndCatchUpMutationVariables = Exact<{
  input: OrganizationMetrcApiKeyInput;
}>;


export type RotateOrganizationMetrcApiKeyAndCatchUpMutation = { __typename?: 'Mutation', rotateOrganizationMetrcApiKeyAndCatchUp?: Maybe<{ __typename?: 'RotateOrganizationMetrcApiKeySuccess', catchUpQueued: boolean } | { __typename?: 'Error', message: string }> };

export type AddOrganizationMetrcPackageSourceLicenseMutationVariables = Exact<{
  input: AddOrganizationMetrcPackageSourceLicenseInput;
}>;


export type AddOrganizationMetrcPackageSourceLicenseMutation = { __typename?: 'Mutation', addOrganizationMetrcPackageSourceLicense?: Maybe<(
    { __typename?: 'OrganizationMetrcLicense' }
    & OrganizationMetrcLicenseFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type AddMetrcPackageSourceRelationshipMutationVariables = Exact<{
  input: AddMetrcPackageSourceRelationshipInput;
}>;


export type AddMetrcPackageSourceRelationshipMutation = { __typename?: 'Mutation', addMetrcPackageSourceRelationship?: Maybe<(
    { __typename?: 'OrganizationMetrcLicenseRelationship' }
    & OrganizationMetrcLicenseRelationshipFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type SkipMetrcProcessingConnectionsMutationVariables = Exact<{
  input: SkipMetrcProcessingConnectionsInput;
}>;


export type SkipMetrcProcessingConnectionsMutation = { __typename?: 'Mutation', skipMetrcProcessingConnections?: Maybe<(
    { __typename?: 'OrganizationSite' }
    & OrganizationSiteFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type RefreshMetrcDataMutationVariables = Exact<{
  input: RefreshMetrcDataInput;
}>;


export type RefreshMetrcDataMutation = { __typename?: 'Mutation', refreshMetrcData?: Maybe<(
    { __typename?: 'OrganizationSite' }
    & OrganizationSiteFieldsFragment
  ) | { __typename?: 'Error' }> };

export type UpdateSiteSensorBrandsMutationVariables = Exact<{
  input: UpdateSiteSensorBrandsInput;
}>;


export type UpdateSiteSensorBrandsMutation = { __typename?: 'Mutation', updateSiteSensorBrands?: Maybe<{ __typename?: 'OrganizationSite', id: any, sensorBrands?: Maybe<Array<Maybe<{ __typename?: 'SiteSensorBrand', id: any, brandName: SiteSensorBrandBrandName, isActive: boolean }>>> } | { __typename?: 'Error', message: string }> };

export type CompleteMetrcImportReviewMutationVariables = Exact<{
  input: CompleteMetrcImportReviewInput;
}>;


export type CompleteMetrcImportReviewMutation = { __typename?: 'Mutation', completeMetrcImportReview?: Maybe<{ __typename?: 'OrganizationSite', id: any } | { __typename?: 'Error', message: string }> };

export type CreateFacilitySurveyMutationVariables = Exact<{
  input: CreateFacilitySurveyInput;
}>;


export type CreateFacilitySurveyMutation = { __typename?: 'Mutation', createFacilitySurvey?: Maybe<(
    { __typename?: 'FacilitySurvey' }
    & FacilitySurveyFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type CreateFieldSurveyMutationVariables = Exact<{
  input: CreateFieldSurveyInput;
}>;


export type CreateFieldSurveyMutation = { __typename?: 'Mutation', createFieldSurvey?: Maybe<(
    { __typename?: 'FieldSurvey' }
    & FieldSurveyFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type CreateRoomSurveyMutationVariables = Exact<{
  input: CreateRoomSurveyInput;
}>;


export type CreateRoomSurveyMutation = { __typename?: 'Mutation', createRoomSurvey?: Maybe<(
    { __typename?: 'RoomSurvey' }
    & RoomSurveyFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateRoomSurveyMutationVariables = Exact<{
  input: UpdateRoomSurveyInput;
}>;


export type UpdateRoomSurveyMutation = { __typename?: 'Mutation', updateRoomSurvey?: Maybe<(
    { __typename?: 'RoomSurvey' }
    & RoomSurveyFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateFacilitySurveyMutationVariables = Exact<{
  input: UpdateFacilitySurveyInput;
}>;


export type UpdateFacilitySurveyMutation = { __typename?: 'Mutation', updateFacilitySurvey?: Maybe<(
    { __typename?: 'FacilitySurvey' }
    & FacilitySurveyFieldsFragment
  ) | { __typename?: 'Error', message: string }> };

export type CreateToppingStyleMutationVariables = Exact<{
  input: CreateToppingStyleInput;
}>;


export type CreateToppingStyleMutation = { __typename?: 'Mutation', createToppingStyle?: Maybe<{ __typename?: 'ToppingStyle', id: any, name: string } | { __typename?: 'Error', message: string }> };

export type DeleteToppingStyleMutationVariables = Exact<{
  input: DeleteToppingStyleInput;
}>;


export type DeleteToppingStyleMutation = { __typename?: 'Mutation', deleteToppingStyle?: Maybe<{ __typename?: 'DeleteToppingStyleResult', success?: Maybe<boolean> }> };

export type GetSignedUploadUrlMutationVariables = Exact<{
  input: GetSignedUploadUrlInput;
}>;


export type GetSignedUploadUrlMutation = { __typename?: 'Mutation', getSignedUploadUrl?: Maybe<{ __typename?: 'GetSignedUploadURLResult', signedUploadUrl?: Maybe<string>, success: boolean }> };

export type UpdateUserActiveMutationVariables = Exact<{
  input: UpdateUserActiveInput;
}>;


export type UpdateUserActiveMutation = { __typename?: 'Mutation', updateUserActive?: Maybe<(
    { __typename?: 'UserProfile' }
    & UserProfileFragment
  ) | { __typename?: 'Error', message: string }> };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: Maybe<(
    { __typename?: 'UserProfile' }
    & UserProfileFragment
  ) | { __typename?: 'Error', message: string }> };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: Maybe<(
    { __typename?: 'UserProfile' }
    & UserProfileFragment
  ) | { __typename?: 'Error', message: string }> };

export type MyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileQuery = { __typename?: 'Query', myProfile?: Maybe<(
    { __typename?: 'UserProfile' }
    & UserProfileFragment
  )> };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users?: Maybe<Array<Maybe<{ __typename?: 'UserProfile', id: string, firstName: string, lastName: string }>>> };

export type OrganizationUsersAndSitesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrganizationUsersAndSitesQuery = { __typename?: 'Query', staffOrganization?: Maybe<(
    { __typename?: 'Organization' }
    & StaffOrganizationFieldsFragment
  )> };

export type OrganizationOnboardingOverviewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrganizationOnboardingOverviewQuery = { __typename?: 'Query', staffOrganization?: Maybe<{ __typename?: 'Organization', id: string, deactivatedAt?: Maybe<any>, name: string, timezone: string, redesignEnabled: boolean, apiEnabled: boolean, allowMultisite: boolean, confirmedTargetValues: boolean, alertsRegenerated: boolean, asyncRegenerateAlertsStatus?: Maybe<OrganizationAsyncRegenerateAlertsStatus>, asyncRegenerateAlertsProgressPct: number, asyncRegenerateAlertsStartedAt?: Maybe<any>, asyncRegenerateAlertsCompletedAt?: Maybe<any>, asyncRegenerateAlertsError?: Maybe<string>, regenerateAlertsEtaSecondsRemaining?: Maybe<number>, branding: { __typename?: 'OrganizationBranding', colorPreset: string, logoUrl?: Maybe<string>, logoDarkUrl?: Maybe<string>, customized: boolean, updatedAt?: Maybe<any> }, staffUser?: Maybe<{ __typename?: 'UserProfile', id: string }>, metrcLicenses?: Maybe<Array<Maybe<(
      { __typename?: 'OrganizationMetrcLicense' }
      & OrganizationMetrcLicenseFieldsFragment
    )>>>, sites?: Maybe<Array<Maybe<{ __typename?: 'OrganizationSite', id: any, name: string, metrcLicenseNumber?: Maybe<string>, metrcUserKey?: Maybe<string>, metrcState?: Maybe<OrganizationSiteMetrcState>, asyncImportStatus?: Maybe<OrganizationSiteAsyncImportStatus>, asyncImportStartedAt?: Maybe<any>, asyncImportCompletedAt?: Maybe<any>, metrcSyncFloweringDates: boolean, metrcSyncHarvestDates: boolean, metrcProcessingConnectionsSkipped: boolean, hasConfiguredSensors?: Maybe<boolean>, hasEnvironmentalData?: Maybe<boolean>, confirmedLightingSchedules: boolean, importedHarvestGroupCount?: Maybe<number>, metrcLicenses?: Maybe<Array<Maybe<(
        { __typename?: 'OrganizationSiteMetrcLicense' }
        & OrganizationSiteMetrcLicenseFieldsFragment
      )>>>, metrcLicenseRelationships?: Maybe<Array<Maybe<(
        { __typename?: 'OrganizationMetrcLicenseRelationship' }
        & OrganizationMetrcLicenseRelationshipFieldsFragment
      )>>>, latestMetrcImportBatch?: Maybe<(
        { __typename?: 'MetrcSiteImportBatch' }
        & MetrcSiteImportBatchFieldsFragment
      )>, metrcImportTask?: Maybe<(
        { __typename?: 'MetrcImportTask' }
        & MetrcImportTaskFieldsFragment
      )>, sensorImportTask?: Maybe<(
        { __typename?: 'SensorImportTask' }
        & SensorImportTaskFieldsFragment
      )>, sensorBrands?: Maybe<Array<Maybe<{ __typename?: 'SiteSensorBrand', brandName: SiteSensorBrandBrandName, isActive: boolean }>>>, sensorCredentials?: Maybe<Array<Maybe<(
        { __typename?: 'SensorIntegrationCredential' }
        & SensorCredentialFieldsFragment
      )>>>, harvestGroupAutoCreationConfig?: Maybe<(
        { __typename?: 'HarvestGroupAutoCreationConfig' }
        & HarvestGroupAutoCreationConfigFieldsFragment
      )>, zones: Array<{ __typename?: 'Zone', id: string, name: string, active: boolean, metrcId?: Maybe<string>, roomUsage?: Maybe<ZoneRoomUsage>, dayStartTime?: Maybe<any>, nightStartTime?: Maybe<any>, primaryDevice?: Maybe<{ __typename?: 'EnvironmentalDevice', id: any }> }> }>>>, environmentalTargetSets: Array<(
      { __typename?: 'EnvironmentalTargetSet' }
      & EnvironmentalTargetSetFieldsFragment
    )>, budFormFactors?: Maybe<Array<Maybe<{ __typename?: 'BudFormFactor', id: any, metrcId?: Maybe<string>, yieldCount?: Maybe<number>, active: boolean, sites: Array<{ __typename?: 'OrganizationSite', id: any }> }>>>, harvestGroupTemplates?: Maybe<Array<Maybe<{ __typename?: 'HarvestGroupTemplate', id: any, name: string, archivedAt?: Maybe<any>, stageTemplates: Array<{ __typename?: 'StageTemplate', id: any, createdStageName: string, numberOfDays: number, designatedZones: Array<{ __typename?: 'Zone', id: string }> }> }>>>, users?: Maybe<Array<Maybe<(
      { __typename?: 'UserProfile' }
      & UserAttributesFragment
    )>>> }> };

export type OrganizationUsersQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrganizationUsersQuery = { __typename?: 'Query', staffOrganization?: Maybe<{ __typename?: 'Organization', id: string, name: string, users?: Maybe<Array<Maybe<(
      { __typename?: 'UserProfile' }
      & UserAttributesFragment
    )>>> }> };

export type OrganizationSensorIntegrationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrganizationSensorIntegrationQuery = { __typename?: 'Query', staffOrganization?: Maybe<{ __typename?: 'Organization', id: string, name: string, allowMultisite: boolean, confirmedTargetValues: boolean, staffUser?: Maybe<{ __typename?: 'UserProfile', id: string }>, sensorBrands: Array<{ __typename?: 'OrganizationSensorBrand', id: any, brandName: OrganizationSensorBrandBrandName, isActive: boolean }>, sites?: Maybe<Array<Maybe<{ __typename?: 'OrganizationSite', id: any, name: string, sensorBrands?: Maybe<Array<Maybe<{ __typename?: 'SiteSensorBrand', id: any, brandName: SiteSensorBrandBrandName, isActive: boolean }>>>, sensorImportTask?: Maybe<(
        { __typename?: 'SensorImportTask' }
        & SensorImportTaskFieldsFragment
      )>, sensorCredentials?: Maybe<Array<Maybe<(
        { __typename?: 'SensorIntegrationCredential' }
        & SensorCredentialFieldsFragment
      )>>>, zones: Array<{ __typename?: 'Zone', id: string, name: string, lightingClassification?: Maybe<ZoneLightingClassification>, dayStartTime?: Maybe<any>, nightStartTime?: Maybe<any>, active: boolean }> }>>>, environmentalTargetSets: Array<(
      { __typename?: 'EnvironmentalTargetSet' }
      & EnvironmentalTargetSetFieldsFragment
    )> }> };

export type OrganizationSensorDashboardQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrganizationSensorDashboardQuery = { __typename?: 'Query', staffOrganization?: Maybe<{ __typename?: 'Organization', id: string, name: string, confirmedTargetValues: boolean, staffUser?: Maybe<{ __typename?: 'UserProfile', id: string }>, environmentalTargetSets: Array<(
      { __typename?: 'EnvironmentalTargetSet' }
      & EnvironmentalTargetSetFieldsFragment
    )>, users?: Maybe<Array<Maybe<{ __typename?: 'UserProfile', id: string, email: string, firstName: string, lastName: string, role?: Maybe<{ __typename?: 'Role', id: any, name: string }> }>>>, sites?: Maybe<Array<Maybe<{ __typename?: 'OrganizationSite', id: any, name: string, sensorBrands?: Maybe<Array<Maybe<{ __typename?: 'SiteSensorBrand', id: any, brandName: SiteSensorBrandBrandName, isActive: boolean }>>>, sensorCredentials?: Maybe<Array<Maybe<(
        { __typename?: 'SensorIntegrationCredential' }
        & SensorCredentialFieldsFragment
      )>>>, sensorImportTask?: Maybe<(
        { __typename?: 'SensorImportTask' }
        & SensorImportTaskFieldsFragment
      )> }>>> }> };

export type SiteSensorIntegrationQueryVariables = Exact<{
  siteId: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
}>;


export type SiteSensorIntegrationQuery = { __typename?: 'Query', organizationSite?: Maybe<{ __typename?: 'OrganizationSite', id: any, name: string, importedHarvestGroupCount?: Maybe<number>, confirmedLightingSchedules: boolean, organization: { __typename?: 'Organization', id: string, name: string, timezone: string, staffUser?: Maybe<{ __typename?: 'UserProfile', id: string }> }, zones: Array<{ __typename?: 'Zone', id: string, name: string, lightingClassification?: Maybe<ZoneLightingClassification>, roomUsage?: Maybe<ZoneRoomUsage>, dayStartTime?: Maybe<any>, nightStartTime?: Maybe<any>, active: boolean, primaryDevice?: Maybe<{ __typename?: 'EnvironmentalDevice', id: any }> }>, sensorBrands?: Maybe<Array<Maybe<{ __typename?: 'SiteSensorBrand', id: any, brandName: SiteSensorBrandBrandName, isActive: boolean }>>>, sensorCredentials?: Maybe<Array<Maybe<(
      { __typename?: 'SensorIntegrationCredential' }
      & SensorCredentialFieldsFragment
    )>>>, sensorImportTask?: Maybe<(
      { __typename?: 'SensorImportTask' }
      & SensorImportTaskFieldsFragment
    )> }> };

export type FieldAgentsQueryVariables = Exact<{
  siteId?: Maybe<Scalars['ID']>;
}>;


export type FieldAgentsQuery = { __typename?: 'Query', fieldAgents?: Maybe<Array<Maybe<{ __typename?: 'FieldAgent', id: any, agentId: string, label: string, vendor: string, hostname: string, localIp?: Maybe<string>, subnet: string, softwareVersion: string, status: FieldAgentStatus, isStale?: Maybe<boolean>, isActive: boolean, lastSeenAt?: Maybe<any>, latestStatusPayload: any, devices: Array<{ __typename?: 'FieldAgentDevice', id: any, vendor: string, controllerId: string, modbusAddress: number, deviceName: string, deviceType: FieldAgentDeviceDeviceType, lastSeenAt?: Maybe<any>, lastMetrics: any, sensorDevice?: Maybe<{ __typename?: 'EnvironmentalDevice', id: any, name: string, zone: { __typename?: 'Zone', id: string, name: string } }> }> }>>> };

export type OrganizationNameQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrganizationNameQuery = { __typename?: 'Query', staffOrganization?: Maybe<{ __typename?: 'Organization', id: string, name: string }> };

export type OrganizationSiteQueryVariables = Exact<{
  id: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
}>;


export type OrganizationSiteQuery = { __typename?: 'Query', organizationSite?: Maybe<(
    { __typename?: 'OrganizationSite', organization: { __typename?: 'Organization', id: string, name: string } }
    & OrganizationSiteFieldsFragment
  )> };

export type EnvironmentalTargetSetsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type EnvironmentalTargetSetsQuery = { __typename?: 'Query', environmentalTargetSets?: Maybe<Array<Maybe<(
    { __typename?: 'EnvironmentalTargetSet' }
    & EnvironmentalTargetSetFieldsFragment
  )>>> };

export type OrganizationSetPointsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrganizationSetPointsQuery = { __typename?: 'Query', staffOrganization?: Maybe<{ __typename?: 'Organization', id: string, name: string, confirmedTargetValues: boolean, environmentalTargetSets: Array<(
      { __typename?: 'EnvironmentalTargetSet' }
      & EnvironmentalTargetSetFieldsFragment
    )>, sites?: Maybe<Array<Maybe<{ __typename?: 'OrganizationSite', id: any, sensorImportTask?: Maybe<{ __typename?: 'SensorImportTask', analysisResult: any }> }>>> }> };

export type HarvestGroupEnvironmentalInfoQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type HarvestGroupEnvironmentalInfoQuery = { __typename?: 'Query', harvestGroup: { __typename?: 'HarvestGroup', id: string, name: string, colorHexCode?: Maybe<string>, stages: Array<{ __typename?: 'Stage', id: any, name: string, environmentalTargetType: StageEnvironmentalTargetType, zone: { __typename?: 'Zone', id: string, lightingClassification?: Maybe<ZoneLightingClassification>, dayStartTime?: Maybe<any>, nightStartTime?: Maybe<any> } }>, site: { __typename?: 'OrganizationSite', id: any, organization: { __typename?: 'Organization', id: string, environmentalTargetSets: Array<(
          { __typename?: 'EnvironmentalTargetSet' }
          & EnvironmentalTargetSetFieldsFragment
        )> } } } };

export type OrganizationSiteNameQueryVariables = Exact<{
  id: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
}>;


export type OrganizationSiteNameQuery = { __typename?: 'Query', organizationSite?: Maybe<{ __typename?: 'OrganizationSite', id: any, name: string, organization: { __typename?: 'Organization', id: string, name: string } }> };

export type SiteEnabledChecklistTypesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type SiteEnabledChecklistTypesQuery = { __typename?: 'Query', organizationSite?: Maybe<{ __typename?: 'OrganizationSite', id: any, name: string, enabledChecklistTypes?: Maybe<Array<Maybe<string>>> }> };

export type ActiveUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveUsersQuery = { __typename?: 'Query', activeUsers?: Maybe<Array<Maybe<{ __typename?: 'UserProfile', id: string, firstName: string, lastName: string }>>> };

export type UserManagementRowsQueryVariables = Exact<{
  filters?: Maybe<UserFilterSetInput>;
}>;


export type UserManagementRowsQuery = { __typename?: 'Query', users?: Maybe<Array<Maybe<(
    { __typename?: 'UserProfile' }
    & UserAttributesFragment
  )>>> };

export type RolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesQuery = { __typename?: 'Query', roles?: Maybe<Array<Maybe<{ __typename?: 'Role', id: any, name: string, permissions?: Maybe<Array<Maybe<string>>> }>>> };

export type OrganizationRolesQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type OrganizationRolesQuery = { __typename?: 'Query', organizationRoles?: Maybe<Array<Maybe<{ __typename?: 'Role', id: any, name: string, permissions?: Maybe<Array<Maybe<string>>> }>>> };

export type ToppingStylesQueryVariables = Exact<{ [key: string]: never; }>;


export type ToppingStylesQuery = { __typename?: 'Query', toppingStyles?: Maybe<Array<Maybe<{ __typename?: 'ToppingStyle', id: any, name: string }>>> };

export type StaffOrganizationsQueryVariables = Exact<{
  filters?: Maybe<OrganizationFilterSetInput>;
}>;


export type StaffOrganizationsQuery = { __typename?: 'Query', staffOrganizations?: Maybe<Array<Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  )>>> };

export type OrganizationSitesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationSitesQuery = { __typename?: 'Query', organizationSites?: Maybe<Array<Maybe<{ __typename?: 'OrganizationSite', id: any, name: string }>>> };

export type StaffOrganizationsTableViewQueryVariables = Exact<{
  filters?: Maybe<OrganizationFilterSetInput>;
}>;


export type StaffOrganizationsTableViewQuery = { __typename?: 'Query', staffOrganizations?: Maybe<Array<Maybe<{ __typename?: 'Organization', id: string, name: string, accountType?: Maybe<OrganizationAccountType>, metrcImportCompleted?: Maybe<boolean>, hasEnvironmentalDevices?: Maybe<boolean>, sensorBrands: Array<{ __typename?: 'OrganizationSensorBrand', id: any, brandName: OrganizationSensorBrandBrandName, isActive: boolean }>, checklist?: Maybe<{ __typename?: 'OrganizationChecklist', checklistTasks?: Maybe<Array<Maybe<(
        { __typename?: 'ChecklistTask' }
        & ChecklistTaskFieldsFragment
      )>>> }>, staffUser?: Maybe<{ __typename?: 'UserProfile', id: string }>, users?: Maybe<Array<Maybe<{ __typename?: 'UserProfile', id: string, firstName: string, lastName: string, role?: Maybe<{ __typename?: 'Role', id: any, name: string }> }>>> }>>> };

export type StaffOrganizationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type StaffOrganizationQuery = { __typename?: 'Query', staffOrganization?: Maybe<(
    { __typename?: 'Organization' }
    & OrganizationFieldsFragment
  )> };

export type MyOrganizationPageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MyOrganizationPageQuery = { __typename?: 'Query', staffOrganization?: Maybe<(
    { __typename?: 'Organization' }
    & MyOrganizationPageFieldsFragment
  )> };

export type VerifyMetrcImportQueryVariables = Exact<{
  siteId: Scalars['ID'];
}>;


export type VerifyMetrcImportQuery = { __typename?: 'Query', verifyMetrcImport?: Maybe<{ __typename?: 'VerifyMetrcImportOutput', newStrains?: Maybe<Array<Maybe<{ __typename?: 'MetrcStrain', name?: Maybe<string>, sativaPercentage?: Maybe<number>, indicaPercentage?: Maybe<number>, metrcId?: Maybe<string>, existingStrain?: Maybe<{ __typename?: 'Strain', id: any, name: string }> }>>>, newLocations?: Maybe<Array<Maybe<{ __typename?: 'MetrcLocation', name?: Maybe<string>, metrcId?: Maybe<string>, isImported?: Maybe<boolean>, hasFloweringPlants?: Maybe<boolean>, existingLocation?: Maybe<{ __typename?: 'Zone', id: string, name: string, metrcId?: Maybe<string>, lightingClassification?: Maybe<ZoneLightingClassification>, roomUsage?: Maybe<ZoneRoomUsage> }> }>>>, newBudFormFactors?: Maybe<Array<Maybe<{ __typename?: 'MetrcBudFormFactor', name?: Maybe<string>, classification?: Maybe<string>, packageCount?: Maybe<number>, existingBff?: Maybe<string>, existingBffOrder?: Maybe<number>, sampleItemNames?: Maybe<Array<Maybe<string>>> }>>>, existingBudFormFactors?: Maybe<Array<Maybe<{ __typename?: 'BudFormFactor', id: any, name: string, active: boolean, classification: BudFormFactorClassification, yieldCount?: Maybe<number>, metrcId?: Maybe<string>, orderPosition: number }>>>, rotationAnalysis?: Maybe<{ __typename?: 'MetrcRotationAnalysis', source?: Maybe<string>, rotationOrder?: Maybe<Array<Maybe<string>>>, intervalDays?: Maybe<number>, flowerRooms?: Maybe<Array<Maybe<{ __typename?: 'MetrcFlowerRoom', dateSource?: Maybe<string>, name?: Maybe<string>, floweringDate?: Maybe<string> }>>> }>, bffDebug?: Maybe<{ __typename?: 'BffDebug', formFactors?: Maybe<Array<Maybe<{ __typename?: 'BffDebugFormFactor', name?: Maybe<string>, classification?: Maybe<string>, totalWeightG?: Maybe<number>, packageCount?: Maybe<number>, harvestCount?: Maybe<number>, sampleItemNames?: Maybe<Array<Maybe<string>>> }>>>, failedExtractions?: Maybe<Array<Maybe<{ __typename?: 'BffDebugFailedExtraction', itemName?: Maybe<string>, category?: Maybe<string>, weightG?: Maybe<number> }>>> }> }> };

export type MetrcImportOverviewV2QueryVariables = Exact<{
  siteId: Scalars['ID'];
}>;


export type MetrcImportOverviewV2Query = { __typename?: 'Query', metrcImportOverviewV2?: Maybe<{ __typename?: 'MetrcImportOverviewV2', siteId: string, ready: boolean, lastAnalyzedAt?: Maybe<any>, harvestsAnalyzedCount: number, totalHarvests?: Maybe<number>, totalPackages?: Maybe<number>, totalStrains?: Maybe<number>, totalLocations?: Maybe<number>, totalFloweringPlants?: Maybe<number>, dateRangeStart?: Maybe<string>, dateRangeEnd?: Maybe<string>, strainNames?: Maybe<Array<Maybe<string>>>, newStrainCount?: Maybe<number>, existingStrainCount?: Maybe<number>, hgsWithRoomCount?: Maybe<number>, hgsWithoutRoomCount?: Maybe<number>, ffFailedCount?: Maybe<number>, ffFailedSamples?: Maybe<Array<Maybe<string>>>, totalAdjustmentCount?: Maybe<number>, locations?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewLocation', name?: Maybe<string>, metrcId?: Maybe<string>, zoneId?: Maybe<string>, metrcSourceCount?: Maybe<number>, hasFloweringPlants?: Maybe<boolean>, guessedUsage?: Maybe<string> }>>>, strains?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewStrain', name?: Maybe<string>, pdsStrainId?: Maybe<string>, metrcSourceCount?: Maybe<number>, imported?: Maybe<boolean> }>>>, harvestGroups?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewHarvestGroup', proposedGroupId?: Maybe<string>, createdHgId?: Maybe<string>, kind?: Maybe<string>, name?: Maybe<string>, harvestDate?: Maybe<string>, assignedFlowerRoom?: Maybe<string>, strainNames?: Maybe<Array<Maybe<string>>>, totalWetWeightG?: Maybe<number>, totalPackagedWeightG?: Maybe<number>, pkgWetPct?: Maybe<number>, yieldCoveragePct?: Maybe<number>, isInferredComplete?: Maybe<boolean>, strainCount?: Maybe<number>, strainWithYieldCount?: Maybe<number>, harvestNames?: Maybe<Array<Maybe<string>>>, harvestNameRoomMap?: Maybe<Array<Maybe<string>>>, productStreams?: Maybe<Array<{ __typename?: 'MetrcOverviewProductStream', dryToWetBasis?: Maybe<string>, coverageNote?: Maybe<string>, harvestPackagedWeightG?: Maybe<number>, dryWeightG: number, wetPackagedWeightG: number, harvestWetWeightG: number, dryToWetPct?: Maybe<number>, stream: string, batchCount: number, finishedBatchCount: number, plantCount: number, outputWeightG?: Maybe<number>, reportedPackagedWeightG?: Maybe<number>, packageCoveragePct?: Maybe<number> }>>, strains?: Maybe<Array<Maybe<{ __typename?: 'MetrcHarvestGroupStrain', strainName?: Maybe<string>, plantCount?: Maybe<number>, totalWetWeight?: Maybe<number>, totalPackagedWeight?: Maybe<number>, finishedDate?: Maybe<string>, metrcHarvestId?: Maybe<string>, metrcHarvestName?: Maybe<string>, createdStrainId?: Maybe<string>, bffYields?: Maybe<Array<Maybe<{ __typename?: 'MetrcBffYield', name?: Maybe<string>, weightG?: Maybe<number>, packageCount?: Maybe<number>, classification?: Maybe<string> }>>> }>>> }>>>, formFactors?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewFormFactor', name?: Maybe<string>, classification?: Maybe<string>, totalWeightG?: Maybe<number>, packageCount?: Maybe<number>, sampleItemNames?: Maybe<Array<Maybe<string>>>, earliestDate?: Maybe<string>, latestDate?: Maybe<string> }>>>, adjustments?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewAdjustment', reason?: Maybe<string>, count?: Maybe<number>, totalQuantity?: Maybe<number>, unit?: Maybe<string>, totalWeightG?: Maybe<number>, earliestDate?: Maybe<string>, latestDate?: Maybe<string> }>>>, rotation?: Maybe<{ __typename?: 'MetrcOverviewRotation', rotationOrder?: Maybe<Array<Maybe<string>>>, intervalDays?: Maybe<number>, source?: Maybe<string>, flowerRooms?: Maybe<Array<Maybe<{ __typename?: 'MetrcFlowerRoom', dateSource?: Maybe<string>, name?: Maybe<string>, floweringDate?: Maybe<string> }>>>, harvestSequence?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewHarvestSequenceEntry', date?: Maybe<string>, room?: Maybe<string>, intervalDays?: Maybe<number>, cycle?: Maybe<number> }>>> }>, floweringGroups?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewFloweringGroup', proposedGroupId?: Maybe<string>, createdHgId?: Maybe<string>, locationName?: Maybe<string>, plantCount?: Maybe<number>, totalPlants?: Maybe<number>, strainNames?: Maybe<Array<Maybe<string>>>, floweringDate?: Maybe<string>, plantedDate?: Maybe<string>, projectedHarvestDate?: Maybe<string>, cloneStageDays?: Maybe<number>, vegStageDays?: Maybe<number>, flowerStageDays?: Maybe<number>, cloneVegDays?: Maybe<number>, allPlantedDates?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewPlantedDate', date?: Maybe<string>, plantCount?: Maybe<number>, isDominant?: Maybe<boolean>, isOutlier?: Maybe<boolean> }>>>, strains?: Maybe<Array<Maybe<{ __typename?: 'MetrcCurrentFloweringGroupStrain', strainName?: Maybe<string>, plantCount?: Maybe<number>, existingStrainId?: Maybe<string>, plantedDates?: Maybe<Array<Maybe<string>>> }>>> }>>>, alerts?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewAlert', severity?: Maybe<string>, title?: Maybe<string>, detail?: Maybe<string>, count?: Maybe<number>, samples?: Maybe<Array<Maybe<string>>> }>>>, integritySignals: Array<{ __typename?: 'MetrcIntegritySignal', id: string, category: string, severity: string, message: string, details?: Maybe<any>, dedupKey?: Maybe<string>, resolutionState: string, firstSeenAt?: Maybe<any>, lastSeenAt?: Maybe<any>, metrcHarvestId?: Maybe<string>, metrcPackageId?: Maybe<string> }>, parsingRulesetStatus: { __typename?: 'MetrcOverviewParsingRulesetStatus', harvestNames: { __typename?: 'MetrcOverviewParsingRulesetDomainStatus', status: string, rulesCount: number, inputFieldChain: Array<string>, rules: Array<{ __typename?: 'MetrcOverviewParsingRule', template: string, kind: string, priority: number, slotSummary: string }>, lastAuthoringSession?: Maybe<{ __typename?: 'MetrcOverviewLastAuthoringSession', status: string, endedAt?: Maybe<string>, iterations: number, aiCostUsd: number }> }, packageItems: { __typename?: 'MetrcOverviewParsingRulesetDomainStatus', status: string, rulesCount: number, inputFieldChain: Array<string>, rules: Array<{ __typename?: 'MetrcOverviewParsingRule', template: string, kind: string, priority: number, slotSummary: string }>, lastAuthoringSession?: Maybe<{ __typename?: 'MetrcOverviewLastAuthoringSession', status: string, endedAt?: Maybe<string>, iterations: number, aiCostUsd: number }> } } }> };

export type IntegrityEventsQueryVariables = Exact<{
  siteId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Scalars['String']>>;
  severities?: Maybe<Array<Scalars['String']>>;
  search?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type IntegrityEventsQuery = { __typename?: 'Query', integrityEvents?: Maybe<{ __typename?: 'IntegrityEventListResult', totalCount: number, pageInfo: { __typename?: 'IntegrityEventPageInfo', endCursor?: Maybe<string>, hasNextPage: boolean }, nodes: Array<{ __typename?: 'IntegrityEvent', id: string, category: string, severity: string, message: string, details?: Maybe<any>, dedupKey?: Maybe<string>, resolutionState: string, resolutionAction?: Maybe<string>, firstSeenAt?: Maybe<any>, lastSeenAt?: Maybe<any>, resolvedAt?: Maybe<any>, resolvedByName?: Maybe<string>, siteId: string, siteName: string, organizationId: string, organizationName: string, metrcHarvestId?: Maybe<string>, metrcHarvestName?: Maybe<string>, metrcPackageId?: Maybe<string>, metrcPackageLabel?: Maybe<string>, harvestGroupId?: Maybe<string>, harvestGroupName?: Maybe<string>, source: string, availableActions: Array<{ __typename?: 'IntegrityEventAction', action: string, label: string }>, resolutionOptions: { __typename?: 'IntegrityResolutionOptions', budFormFactors: Array<{ __typename?: 'IntegrityResolutionOption', id: string, label: string }>, zones: Array<{ __typename?: 'IntegrityResolutionOption', id: string, label: string }>, harvestGroups: Array<{ __typename?: 'IntegrityResolutionOption', id: string, label: string }> } }> }> };

export type IntegrityEventSummaryQueryVariables = Exact<{
  siteId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
}>;


export type IntegrityEventSummaryQuery = { __typename?: 'Query', integrityEventSummary?: Maybe<{ __typename?: 'IntegrityEventSummary', openErrors: number, openWarnings: number, openTotal: number, actionableOpen: number, warningOpen: number, dismissedLast7Days: number, resolvedLast7Days: number }> };

export type IntegrityEventsPaginatedQueryVariables = Exact<{
  options?: Maybe<IntegrityEventQuerysetOptionsInput>;
}>;


export type IntegrityEventsPaginatedQuery = { __typename?: 'Query', integrityEventsPaginated?: Maybe<{ __typename?: 'IntegrityEventQuerysetResult', options: { __typename?: 'IntegrityEventQuerysetOptionsOutput', paging: { __typename?: 'PagingInfo', start: number, size: number, page: number, totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, ordering: string } }, items: Array<Maybe<{ __typename?: 'IntegrityEvent', id: string, category: string, severity: string, message: string, details?: Maybe<any>, dedupKey?: Maybe<string>, resolutionState: string, resolutionAction?: Maybe<string>, firstSeenAt?: Maybe<any>, lastSeenAt?: Maybe<any>, resolvedAt?: Maybe<any>, resolvedByName?: Maybe<string>, siteId: string, siteName: string, organizationId: string, organizationName: string, metrcHarvestId?: Maybe<string>, metrcHarvestName?: Maybe<string>, metrcPackageId?: Maybe<string>, metrcPackageLabel?: Maybe<string>, metrcPackageDisplayName?: Maybe<string>, metrcPackageCategoryName?: Maybe<string>, metrcPackageKind?: Maybe<string>, harvestGroupId?: Maybe<string>, harvestGroupName?: Maybe<string>, source: string, dashboardGroup: string, isActionable: boolean, availableActions: Array<{ __typename?: 'IntegrityEventAction', action: string, label: string }>, resolutionOptions: { __typename?: 'IntegrityResolutionOptions', budFormFactors: Array<{ __typename?: 'IntegrityResolutionOption', id: string, label: string }>, zones: Array<{ __typename?: 'IntegrityResolutionOption', id: string, label: string }>, harvestGroups: Array<{ __typename?: 'IntegrityResolutionOption', id: string, label: string }> } }>> }> };

export type IntegrityEventFilterCountsQueryVariables = Exact<{
  siteId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
}>;


export type IntegrityEventFilterCountsQuery = { __typename?: 'Query', integrityEventCategoryCounts?: Maybe<Array<{ __typename?: 'IntegrityCategoryCount', category: string, count: number }>>, integrityEventSiteCounts?: Maybe<Array<{ __typename?: 'IntegritySiteCount', siteId: string, siteName: string, organizationName: string, count: number }>> };

export type IntegrityEventWarningSummariesQueryVariables = Exact<{
  siteId?: Maybe<Scalars['ID']>;
  organizationId?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
}>;


export type IntegrityEventWarningSummariesQuery = { __typename?: 'Query', integrityEventWarningSummaries?: Maybe<Array<{ __typename?: 'IntegrityWarningSummary', siteId: string, siteName: string, organizationName: string, category: string, severity: string, count: number, lastSeenAt?: Maybe<any> }>> };

export type MetrcImportDataOverviewQueryVariables = Exact<{
  siteId: Scalars['ID'];
}>;


export type MetrcImportDataOverviewQuery = { __typename?: 'Query', metrcImportDataOverview?: Maybe<{ __typename?: 'MetrcDataOverviewOutput', ready?: Maybe<boolean>, totalHarvests?: Maybe<number>, totalPackages?: Maybe<number>, totalStrains?: Maybe<number>, totalLocations?: Maybe<number>, totalFloweringPlants?: Maybe<number>, dateRangeStart?: Maybe<string>, dateRangeEnd?: Maybe<string>, strainNames?: Maybe<Array<Maybe<string>>>, newStrainCount?: Maybe<number>, existingStrainCount?: Maybe<number>, hgsWithRoomCount?: Maybe<number>, hgsWithoutRoomCount?: Maybe<number>, ffFailedCount?: Maybe<number>, ffFailedSamples?: Maybe<Array<Maybe<string>>>, totalAdjustmentCount?: Maybe<number>, locations?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewLocation', name?: Maybe<string>, metrcId?: Maybe<string>, hasFloweringPlants?: Maybe<boolean>, guessedUsage?: Maybe<string> }>>>, harvestGroups?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewHarvestGroup', name?: Maybe<string>, harvestDate?: Maybe<string>, assignedFlowerRoom?: Maybe<string>, strainNames?: Maybe<Array<Maybe<string>>>, totalWetWeightG?: Maybe<number>, totalPackagedWeightG?: Maybe<number>, pkgWetPct?: Maybe<number>, yieldCoveragePct?: Maybe<number>, isInferredComplete?: Maybe<boolean>, harvestNames?: Maybe<Array<Maybe<string>>>, harvestNameRoomMap?: Maybe<Array<Maybe<string>>> }>>>, formFactors?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewFormFactor', name?: Maybe<string>, classification?: Maybe<string>, totalWeightG?: Maybe<number>, packageCount?: Maybe<number>, sampleItemNames?: Maybe<Array<Maybe<string>>>, earliestDate?: Maybe<string>, latestDate?: Maybe<string> }>>>, adjustments?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewAdjustment', reason?: Maybe<string>, count?: Maybe<number>, totalQuantity?: Maybe<number>, unit?: Maybe<string>, totalWeightG?: Maybe<number>, earliestDate?: Maybe<string>, latestDate?: Maybe<string> }>>>, rotation?: Maybe<{ __typename?: 'MetrcOverviewRotation', rotationOrder?: Maybe<Array<Maybe<string>>>, intervalDays?: Maybe<number>, source?: Maybe<string>, flowerRooms?: Maybe<Array<Maybe<{ __typename?: 'MetrcFlowerRoom', dateSource?: Maybe<string>, name?: Maybe<string>, floweringDate?: Maybe<string> }>>>, harvestSequence?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewHarvestSequenceEntry', date?: Maybe<string>, room?: Maybe<string>, intervalDays?: Maybe<number>, cycle?: Maybe<number> }>>> }>, floweringGroups?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewFloweringGroup', proposedGroupId?: Maybe<string>, createdHgId?: Maybe<string>, locationName?: Maybe<string>, plantCount?: Maybe<number>, totalPlants?: Maybe<number>, strainNames?: Maybe<Array<Maybe<string>>>, floweringDate?: Maybe<string>, plantedDate?: Maybe<string>, projectedHarvestDate?: Maybe<string>, cloneStageDays?: Maybe<number>, vegStageDays?: Maybe<number>, flowerStageDays?: Maybe<number>, cloneVegDays?: Maybe<number>, allPlantedDates?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewPlantedDate', date?: Maybe<string>, plantCount?: Maybe<number>, isDominant?: Maybe<boolean>, isOutlier?: Maybe<boolean> }>>>, strains?: Maybe<Array<Maybe<{ __typename?: 'MetrcCurrentFloweringGroupStrain', strainName?: Maybe<string>, plantCount?: Maybe<number>, existingStrainId?: Maybe<string>, plantedDates?: Maybe<Array<Maybe<string>>> }>>> }>>>, alerts?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewAlert', severity?: Maybe<string>, title?: Maybe<string>, detail?: Maybe<string>, count?: Maybe<number>, samples?: Maybe<Array<Maybe<string>>> }>>> }> };

export type FieldSurveysQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type FieldSurveysQuery = { __typename?: 'Query', staffOrganization?: Maybe<{ __typename?: 'Organization', id: string, name: string, sites?: Maybe<Array<Maybe<{ __typename?: 'OrganizationSite', id: any, name: string, fieldSurveys?: Maybe<Array<Maybe<{ __typename?: 'FieldSurvey', id: any, createdAt: any, site?: Maybe<{ __typename?: 'OrganizationSite', id: any, name: string }>, createdBy?: Maybe<(
          { __typename?: 'UserProfile' }
          & UserAttributesFragment
        )>, facilitySurvey?: Maybe<{ __typename?: 'FacilitySurvey', id: any, completedAt?: Maybe<any>, recommendations?: Maybe<Array<Maybe<string>>> }>, roomSurveys: Array<{ __typename?: 'RoomSurvey', id: any, completedAt?: Maybe<any>, recommendations?: Maybe<Array<Maybe<string>>> }> }>>> }>>> }> };

export type FieldSurveyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type FieldSurveyQuery = { __typename?: 'Query', fieldSurvey?: Maybe<(
    { __typename?: 'FieldSurvey', zonesAvailable?: Maybe<Array<{ __typename?: 'Zone', id: string, name: string, roomUsage?: Maybe<ZoneRoomUsage>, site: { __typename?: 'OrganizationSite', id: any, name: string } }>> }
    & FieldSurveyFieldsFragment
  )> };

export type FacilitySurveyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type FacilitySurveyQuery = { __typename?: 'Query', facilitySurvey?: Maybe<(
    { __typename?: 'FacilitySurvey' }
    & FacilitySurveyFieldsFragment
  )> };

export type RoomSurveyQueryVariables = Exact<{
  id: Scalars['String'];
  zoneId: Scalars['String'];
}>;


export type RoomSurveyQuery = { __typename?: 'Query', roomSurvey?: Maybe<(
    { __typename?: 'RoomSurvey' }
    & RoomSurveyFieldsFragment
  )> };

export type ChecklistSessionsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  siteId?: Maybe<Scalars['ID']>;
}>;


export type ChecklistSessionsQuery = { __typename?: 'Query', checklistSessions?: Maybe<Array<Maybe<(
    { __typename?: 'ChecklistSession' }
    & ChecklistSessionFieldsFragment
  )>>> };

export type ChecklistSessionsPaginatedQueryVariables = Exact<{
  options?: Maybe<ChecklistSessionQuerysetOptionsInput>;
}>;


export type ChecklistSessionsPaginatedQuery = { __typename?: 'Query', checklistSessionsPaginated?: Maybe<{ __typename?: 'ChecklistSessionQuerysetResult', options: { __typename?: 'ChecklistSessionQuerysetOptionsOutput', paging: (
        { __typename?: 'PagingInfo' }
        & PagingInfoFragment
      ) }, items: Array<Maybe<(
      { __typename?: 'ChecklistSession' }
      & ChecklistSessionFieldsFragment
    )>> }> };

export type ChecklistSessionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ChecklistSessionQuery = { __typename?: 'Query', checklistSession?: Maybe<(
    { __typename?: 'ChecklistSession' }
    & ChecklistSessionFieldsFragment
  )> };

export type RoomWalkthroughChecklistsQueryVariables = Exact<{
  checklistSessionId: Scalars['ID'];
}>;


export type RoomWalkthroughChecklistsQuery = { __typename?: 'Query', roomWalkthroughChecklists?: Maybe<Array<Maybe<(
    { __typename?: 'RoomWalkthroughChecklist' }
    & RoomWalkthroughChecklistFieldsFragment
  )>>> };

export type EnvironmentalDevicesQueryVariables = Exact<{
  siteId?: Maybe<Scalars['ID']>;
  zoneId?: Maybe<Scalars['ID']>;
}>;


export type EnvironmentalDevicesQuery = { __typename?: 'Query', environmentalDevices?: Maybe<Array<Maybe<{ __typename?: 'EnvironmentalDevice', id: any, name: string, category?: Maybe<EnvironmentSensorDeviceCategory>, isPrimary: boolean, trolmasterMacAddress?: Maybe<string>, trolmasterModel?: Maybe<EnvironmentSensorDeviceTrolmasterModel>, aroyaModelKey?: Maybe<string>, aroyaDeviceId?: Maybe<string>, aroyaSerialNumber?: Maybe<string>, aroyaApiRoomName?: Maybe<string>, aroyaApiBenchName?: Maybe<string>, growlinkControllerId?: Maybe<string>, growlinkModuleName?: Maybe<string>, growlinkTemperatureSensorId?: Maybe<string>, growlinkHumiditySensorId?: Maybe<string>, growlinkCo2SensorId?: Maybe<string>, growlinkVpdSensorId?: Maybe<string>, zone: { __typename?: 'Zone', id: string, name: string, primaryDevice?: Maybe<{ __typename?: 'EnvironmentalDevice', id: any }>, site: { __typename?: 'OrganizationSite', id: any, name: string } } }>>> };

export type LocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationsQuery = { __typename?: 'Query', organizationSites?: Maybe<Array<Maybe<{ __typename?: 'OrganizationSite', id: any, name: string, locations: Array<{ __typename?: 'Location', id: any, name: string, zone?: Maybe<{ __typename?: 'Zone', id: string, name: string, active: boolean }>, equipment: Array<{ __typename?: 'Equipment', id: any, label: string, type: EquipmentType, brand?: Maybe<string>, model?: Maybe<string>, serialNumber?: Maybe<string>, lastMaintenanceDate: any, status: EquipmentStatus, notes?: Maybe<string>, installedAtDate?: Maybe<any> }> }> }>>> };

export type AroyaDeviceRequestsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  credentialId?: Maybe<Scalars['ID']>;
}>;


export type AroyaDeviceRequestsQuery = { __typename?: 'Query', aroyaDeviceRequests?: Maybe<Array<Maybe<(
    { __typename?: 'AroyaDeviceRequest' }
    & AroyaDeviceRequestFieldsFragment
  )>>> };

export type GrowlinkDeviceRequestsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  credentialId?: Maybe<Scalars['ID']>;
}>;


export type GrowlinkDeviceRequestsQuery = { __typename?: 'Query', growlinkDeviceRequests?: Maybe<Array<Maybe<(
    { __typename?: 'GrowlinkDeviceRequest' }
    & GrowlinkDeviceRequestFieldsFragment
  )>>> };

export type MetrcImportAnalyticsQueryVariables = Exact<{
  siteId: Scalars['ID'];
}>;


export type MetrcImportAnalyticsQuery = { __typename?: 'Query', metrcImportAnalytics?: Maybe<{ __typename?: 'MetrcImportAnalyticsResult', totals?: Maybe<{ __typename?: 'MetrcAnalyticsTotals', groups?: Maybe<number>, totalGrams?: Maybe<number>, flowerGrams?: Maybe<number>, trimGrams?: Maybe<number>, totalPlants?: Maybe<number>, gramsPerPlant?: Maybe<number> }>, topStrains?: Maybe<Array<Maybe<{ __typename?: 'MetrcStrainStat', strainId?: Maybe<string>, strainName?: Maybe<string>, totalGrams?: Maybe<number>, flowerGrams?: Maybe<number>, trimGrams?: Maybe<number>, totalPlants?: Maybe<number>, gramsPerPlant?: Maybe<number> }>>>, bottomStrains?: Maybe<Array<Maybe<{ __typename?: 'MetrcStrainStat', strainId?: Maybe<string>, strainName?: Maybe<string>, totalGrams?: Maybe<number>, flowerGrams?: Maybe<number>, trimGrams?: Maybe<number>, totalPlants?: Maybe<number>, gramsPerPlant?: Maybe<number> }>>>, topStrainsPerPlant?: Maybe<Array<Maybe<{ __typename?: 'MetrcStrainStat', strainId?: Maybe<string>, strainName?: Maybe<string>, totalGrams?: Maybe<number>, flowerGrams?: Maybe<number>, trimGrams?: Maybe<number>, totalPlants?: Maybe<number>, gramsPerPlant?: Maybe<number> }>>>, bottomStrainsPerPlant?: Maybe<Array<Maybe<{ __typename?: 'MetrcStrainStat', strainId?: Maybe<string>, strainName?: Maybe<string>, totalGrams?: Maybe<number>, flowerGrams?: Maybe<number>, trimGrams?: Maybe<number>, totalPlants?: Maybe<number>, gramsPerPlant?: Maybe<number> }>>>, topHarvestGroups?: Maybe<Array<Maybe<{ __typename?: 'MetrcGroupStat', harvestGroupId?: Maybe<string>, name?: Maybe<string>, harvestDate?: Maybe<any>, totalGrams?: Maybe<number>, flowerGrams?: Maybe<number>, trimGrams?: Maybe<number>, totalPlants?: Maybe<number>, gramsPerPlant?: Maybe<number> }>>>, topHarvestGroupsPerPlant?: Maybe<Array<Maybe<{ __typename?: 'MetrcGroupStat', harvestGroupId?: Maybe<string>, name?: Maybe<string>, harvestDate?: Maybe<any>, totalGrams?: Maybe<number>, flowerGrams?: Maybe<number>, trimGrams?: Maybe<number>, totalPlants?: Maybe<number>, gramsPerPlant?: Maybe<number> }>>>, bottomHarvestGroups?: Maybe<Array<Maybe<{ __typename?: 'MetrcGroupStat', harvestGroupId?: Maybe<string>, name?: Maybe<string>, harvestDate?: Maybe<any>, totalGrams?: Maybe<number>, flowerGrams?: Maybe<number>, trimGrams?: Maybe<number>, totalPlants?: Maybe<number>, gramsPerPlant?: Maybe<number> }>>>, bottomHarvestGroupsPerPlant?: Maybe<Array<Maybe<{ __typename?: 'MetrcGroupStat', harvestGroupId?: Maybe<string>, name?: Maybe<string>, harvestDate?: Maybe<any>, totalGrams?: Maybe<number>, flowerGrams?: Maybe<number>, trimGrams?: Maybe<number>, totalPlants?: Maybe<number>, gramsPerPlant?: Maybe<number> }>>> }> };

export type MetrcImportYieldBreakdownQueryVariables = Exact<{
  proposedGroupId: Scalars['ID'];
}>;


export type MetrcImportYieldBreakdownQuery = { __typename?: 'Query', metrcImportYieldBreakdown?: Maybe<{ __typename?: 'MetrcOverviewYieldBreakdown', totalPackagedG?: Maybe<number>, totalFoundG?: Maybe<number>, unaccountedG?: Maybe<number>, foundByFf: Array<{ __typename?: 'MetrcOverviewYieldFoundFf', ffName: string, classification?: Maybe<string>, weightG: number, packageCount: number, strainBreakdown: Array<{ __typename?: 'MetrcOverviewYieldFoundFfStrain', strainName: string, pdsStrainId?: Maybe<string>, weightG: number, packageCount: number }> }>, missingByReason: Array<{ __typename?: 'MetrcOverviewYieldMissingReason', category: string, label: string, description: string, weightG?: Maybe<number>, packageCount: number, samplePackageNames: Array<string> }> }> };

export type MetrcImportYieldPackageBreakdownQueryVariables = Exact<{
  proposedGroupId: Scalars['ID'];
  bucketKind: Scalars['String'];
  bucketKey: Scalars['String'];
}>;


export type MetrcImportYieldPackageBreakdownQuery = { __typename?: 'Query', metrcImportYieldPackageBreakdown?: Maybe<{ __typename?: 'MetrcOverviewYieldPackageBreakdown', packages: Array<{ __typename?: 'MetrcOverviewYieldPackageEntry', packageLabel: string, metrcPackageId?: Maybe<string>, weightG?: Maybe<number>, ffName?: Maybe<string>, sourceHarvestNames: Array<string>, packageSiteName?: Maybe<string>, packageLicenseNumber?: Maybe<string>, packageLicenseRole?: Maybe<string>, packageRole?: Maybe<string>, packageReason?: Maybe<string>, weightBasis?: Maybe<string>, createdWeightG?: Maybe<number>, shippedWeightG?: Maybe<number>, adjustmentWeightG?: Maybe<number>, adjustmentNote?: Maybe<string>, sourcePackageLabels: Array<string> }> }> };

export type MetrcScheduleProposalsQueryVariables = Exact<{
  siteId: Scalars['ID'];
}>;


export type MetrcScheduleProposalsQuery = { __typename?: 'Query', metrcImportOverviewV2?: Maybe<{ __typename?: 'MetrcImportOverviewV2', siteId: string, floweringGroups?: Maybe<Array<Maybe<{ __typename?: 'MetrcOverviewFloweringGroup', locationName?: Maybe<string>, floweringDate?: Maybe<string> }>>> }> };

export type SensorCoverageQueryVariables = Exact<{
  siteId: Scalars['ID'];
  start: Scalars['Date'];
  end: Scalars['Date'];
  brand?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['ID']>;
  outcomes?: Maybe<Array<Maybe<Scalars['String']>>>;
  after?: Maybe<Scalars['String']>;
}>;


export type SensorCoverageQuery = { __typename?: 'Query', sensorCoverage?: Maybe<{ __typename?: 'SensorCoverage', counts: any, exclusions: any, inventory: any, policy: string, timezone: string, collectAllSensors: boolean, eligibleDevices: number, total: number, nextCursor?: Maybe<string>, rows: Array<{ __typename?: 'SensorDayOutcome', deviceId: string, deviceName: string, zoneId: string, roomName: string, provider: string, category: string, day: any, outcome: string, readingsPresent: boolean, lastAttempt?: Maybe<any>, lastSuccessfulFetch?: Maybe<any>, failureReason?: Maybe<string>, runId?: Maybe<string> }>, runs?: Maybe<Array<Maybe<{ __typename?: 'SensorRunResult', id: string, state: string, provider?: Maybe<string>, trigger?: Maybe<string>, startDay?: Maybe<any>, endDay?: Maybe<any>, startedAt?: Maybe<any>, finishedAt?: Maybe<any>, summary?: Maybe<any>, error?: Maybe<string>, policy?: Maybe<string>, requestSettings?: Maybe<any> }>>> }> };

export type SetSensorCollectionMutationVariables = Exact<{
  siteId: Scalars['ID'];
  enabled: Scalars['Boolean'];
}>;


export type SetSensorCollectionMutation = { __typename?: 'Mutation', setSensorCollection?: Maybe<{ __typename?: 'SetSensorCollection', enabled: boolean }> };

export type VerifySensorReplacementMutationVariables = Exact<{
  deviceId: Scalars['ID'];
  candidateId: Scalars['ID'];
}>;


export type VerifySensorReplacementMutation = { __typename?: 'Mutation', verifySensorReplacement?: Maybe<{ __typename?: 'VerifySensorReplacement', result?: Maybe<any> }> };

export type SetSensorActiveMutationVariables = Exact<{
  deviceId: Scalars['ID'];
  active: Scalars['Boolean'];
}>;


export type SetSensorActiveMutation = { __typename?: 'Mutation', setSensorActive?: Maybe<{ __typename?: 'SetSensorActive', active: boolean }> };

export type LatestSensorCollectionQueryVariables = Exact<{
  siteId: Scalars['ID'];
  brand: Scalars['String'];
}>;


export type LatestSensorCollectionQuery = { __typename?: 'Query', latestSensorCollection?: Maybe<{ __typename?: 'SensorRunResult', id: string, state: string, startedAt?: Maybe<any>, finishedAt?: Maybe<any>, endDay?: Maybe<any>, error?: Maybe<string>, connectionStatus?: Maybe<string>, latestDayCounts?: Maybe<any> }> };

export const StageCalendarFieldsFragmentDoc = gql`
    fragment StageCalendarFields on Stage {
  id
  name
  startDate
  calendarBranchId
  zone {
    id
    name
  }
  harvestGroup {
    id
    name
    colorHexCode
    flowerZone {
      id
      name
    }
    site {
      id
      name
    }
  }
  templateUsed {
    id
    createdStageName
  }
}
    `;
export const NameFragmentDoc = gql`
    fragment Name on UserProfile {
  firstName
  lastName
}
    `;
export const TaskCalendarFieldsFragmentDoc = gql`
    fragment TaskCalendarFields on Task {
  id
  name
  startDate
  endDate
  priority
  isComplete
  assignedTo {
    id
    ...Name
  }
  notes
  templateUsed {
    id
  }
  currentZone {
    id
    name
  }
  stageOnTaskDate {
    name
    currentDayOfStage
    daysInStage
  }
  harvestGroup {
    id
    name
    colorHexCode
    flowerZone {
      id
      name
    }
    site {
      id
      name
    }
  }
}
    ${NameFragmentDoc}`;
export const UpdateAndConflictDisplaysFragmentDoc = gql`
    fragment UpdateAndConflictDisplays on CalendarBranch {
  updates {
    changeDescription
    harvestGroupName
    name
    id
    updateType
    colorHexCode
    undoable
    targetType
  }
  conflicts {
    id
    conflictType
    description
    harvestGroupName
    name
    colorHexCode
    calendarBranchId
    justification
    schedulingRule
  }
}
    `;
export const CalendarBranchFieldsFragmentDoc = gql`
    fragment CalendarBranchFields on CalendarBranch {
  id
  name
  status
  updatedAt
  createdBy {
    id
  }
  stages(dateRange: $dateRange) {
    ...StageCalendarFields
  }
  tasks(dateRange: $dateRange) {
    ...TaskCalendarFields
  }
  ...UpdateAndConflictDisplays
}
    ${StageCalendarFieldsFragmentDoc}
${TaskCalendarFieldsFragmentDoc}
${UpdateAndConflictDisplaysFragmentDoc}`;
export const ShortCalendarBranchFieldsFragmentDoc = gql`
    fragment ShortCalendarBranchFields on CalendarBranch {
  id
  name
  status
  updatedAt
  createdBy {
    id
  }
}
    `;
export const CalendarBranchesGeneralInfoFieldsFragmentDoc = gql`
    fragment CalendarBranchesGeneralInfoFields on CalendarBranch {
  id
  name
  createdBy {
    id
    firstName
    lastName
  }
  createdAt
  lastUpdatedBy {
    id
    firstName
    lastName
  }
  updatedAt
  status
  updateCount
  conflictCount
}
    `;
export const HarvestGroupAutoCreationStageZoneOrderFieldsFragmentDoc = gql`
    fragment HarvestGroupAutoCreationStageZoneOrderFields on HarvestGroupAutoCreationStageZoneOrder {
  id
  position
  rotationStep
  positionInStep
  stageTemplate {
    id
    createdStageName
    orderInProcess
    environmentalTargetType
    designatedZones {
      id
      name
      site {
        id
        name
      }
    }
  }
  zone {
    id
    name
    site {
      id
      name
    }
  }
}
    `;
export const HarvestGroupAutoCreationStageCursorFieldsFragmentDoc = gql`
    fragment HarvestGroupAutoCreationStageCursorFields on HarvestGroupAutoCreationStageCursor {
  id
  cursor
  stageTemplate {
    id
  }
}
    `;
export const HarvestGroupAutoCreationConfigFieldsFragmentDoc = gql`
    fragment HarvestGroupAutoCreationConfigFields on HarvestGroupAutoCreationConfig {
  id
  isEnabled
  fillAllRooms
  startDate
  intervalDays
  planningHorizonMonths
  nextRunOn
  lastRunAt
  lastSuccessAt
  lastErrorAt
  lastErrorMessage
  template {
    id
    name
  }
  site {
    id
    name
    metrcSyncFloweringDates
    metrcSyncHarvestDates
  }
  stageZoneOrders {
    ...HarvestGroupAutoCreationStageZoneOrderFields
  }
  stageCursors {
    ...HarvestGroupAutoCreationStageCursorFields
  }
}
    ${HarvestGroupAutoCreationStageZoneOrderFieldsFragmentDoc}
${HarvestGroupAutoCreationStageCursorFieldsFragmentDoc}`;
export const EnvironmentalFileFieldsFragmentDoc = gql`
    fragment EnvironmentalFileFields on EnvironmentalFileType {
  id
  createdAt
  dataFile
  fileType
  fileStatus
  autodetectStatus
  timeOffsetSeconds
  zone {
    id
    name
  }
}
    `;
export const PreviewFileFieldsFragmentDoc = gql`
    fragment PreviewFileFields on EnvironmentalFileType {
  id
  fileType
  autodetectStatus
  sevenDayPreview {
    x
    y
  }
  guessEnvType
  guessTargetValues {
    id
  }
  timeOffsetSeconds
  zone {
    id
    name
    site {
      id
      organization {
        id
        timezone
        dayStartTime
        nightStartTime
      }
    }
  }
  currentHgs {
    id
    name
  }
  currentStages {
    id
    name
  }
}
    `;
export const AlertWarningFragmentDoc = gql`
    fragment AlertWarning on AlertWarning {
  id
  metric
  updatedAt
  createdAt
  startTime
  endTime
  avgDeviation
  maxDeviation
  display
  position
  message
  zone {
    id
    name
  }
  stage {
    id
    name
    harvestGroup {
      id
      name
      colorHexCode
    }
  }
}
    `;
export const AnalyticsChartDataFragmentDoc = gql`
    fragment AnalyticsChartData on AnalyticsChartData {
  data {
    x
    y
  }
  name
  alertWarnings {
    ...AlertWarning
  }
}
    ${AlertWarningFragmentDoc}`;
export const WeeklyEnvironmentalMetricFragmentDoc = gql`
    fragment WeeklyEnvironmentalMetric on WeeklyEnvironmentalMetric {
  compliant
  deviation
  percentInRange
}
    `;
export const GenerationRequestFieldsFragmentDoc = gql`
    fragment GenerationRequestFields on GenerationRequestType {
  id
  createdAt
  updatedAt
  asyncAnalysisStatus
  asyncAnalysisStartedAt
  asyncAnalysisCompletedAt
  asyncAnalysisError
  asyncAnalysisProgressPct
  analysisType
  textPrompt
  result
  images {
    id
    imageUrl
    order
  }
}
    `;
export const PagingInfoFragmentDoc = gql`
    fragment PagingInfo on PagingInfo {
  totalCount
  pageCount
  size
  start
  page
  hasNextPage
  hasPreviousPage
}
    `;
export const StrainReportFieldsFragmentDoc = gql`
    fragment StrainReportFields on Strain {
  id
  name
}
    `;
export const ZoneIdAndNameFragmentDoc = gql`
    fragment ZoneIdAndName on Zone {
  id
  name
  site {
    id
    name
  }
}
    `;
export const CompletedHarvestGroupsPaginatedResultFragmentDoc = gql`
    fragment CompletedHarvestGroupsPaginatedResult on HarvestGroupQuerysetResult {
  options {
    paging {
      ...PagingInfo
    }
  }
  items {
    id
    name
    site {
      id
      name
      hasEnvironmentalData
    }
    startDate
    harvestDate
    archivedAt
    importedFromMetrc
    hasYields
    strains {
      ...StrainReportFields
    }
    flowerZone {
      ...ZoneIdAndName
    }
    aiSummary {
      status
      generatedAt
    }
  }
}
    ${PagingInfoFragmentDoc}
${StrainReportFieldsFragmentDoc}
${ZoneIdAndNameFragmentDoc}`;
export const AnalyticsHarvestGroupsOverviewFragmentDoc = gql`
    fragment AnalyticsHarvestGroupsOverview on HarvestGroup {
  name
  startDate
  harvestDate
  archivedAt
  yields {
    id
    strain {
      ...StrainReportFields
    }
  }
}
    ${StrainReportFieldsFragmentDoc}`;
export const HarvestGroupShortOverviewFieldsFragmentDoc = gql`
    fragment HarvestGroupShortOverviewFields on HarvestGroup {
  id
  name
  startDate
  harvestDate
  archivedAt
  colorHexCode
  flowerZone {
    id
    name
  }
  currentStage {
    id
    name
  }
}
    `;
export const StrainFieldsFragmentDoc = gql`
    fragment StrainFields on Strain {
  id
  name
  active
  metrcId
  createdBy {
    id
    firstName
    lastName
  }
  subspecies
  abbreviation
  documentationUrl
}
    `;
export const BudFormFactorFieldsFragmentDoc = gql`
    fragment BudFormFactorFields on BudFormFactor {
  id
  name
  active
  createdAt
  description
  orderPosition
  classification
  metrcId
  createdBy {
    id
    email
    firstName
    lastName
  }
}
    `;
export const BudFormFactorYieldFragmentDoc = gql`
    fragment BudFormFactorYield on BudFormFactorYield {
  budFormFactorId
  budFormFactor {
    ...BudFormFactorFields
  }
  numberOfGrams
}
    ${BudFormFactorFieldsFragmentDoc}`;
export const YieldFieldsFragmentDoc = gql`
    fragment YieldFields on HarvestStrainYield {
  harvestGroupId
  totalGrams
  finalPlantCount
  strainId
  strain {
    ...StrainFields
  }
  budFormFactorYields {
    ...BudFormFactorYield
  }
}
    ${StrainFieldsFragmentDoc}
${BudFormFactorYieldFragmentDoc}`;
export const HarvestGroupOverviewFieldsFragmentDoc = gql`
    fragment HarvestGroupOverviewFields on HarvestGroup {
  ...HarvestGroupShortOverviewFields
  strains {
    id
    name
  }
  flowerZone {
    id
    name
  }
  harvestCompletion {
    createdAt
    createdBy {
      id
      ...Name
    }
    cosignedAt
    cosignedBy {
      id
      ...Name
    }
  }
  yields {
    ...YieldFields
  }
}
    ${HarvestGroupShortOverviewFieldsFragmentDoc}
${NameFragmentDoc}
${YieldFieldsFragmentDoc}`;
export const HarvestProjectionFragmentDoc = gql`
    fragment HarvestProjection on HarvestProjection {
  id
  harvestGroupId
  strainId
  plantCount
}
    `;
export const HarvestGroupCurrentStageFieldsFragmentDoc = gql`
    fragment HarvestGroupCurrentStageFields on HarvestGroup {
  currentStage {
    id
    name
    zone {
      id
      name
    }
    currentDayOfStage
    daysInStage
    calendarBranchId
    strainsInStage {
      strain {
        name
        id
      }
      numberOfPlants
    }
  }
  projections {
    ...HarvestProjection
  }
}
    ${HarvestProjectionFragmentDoc}`;
export const LogEntryFieldsFragmentDoc = gql`
    fragment LogEntryFields on LogEntry {
  id
  logType
  date
  logEntryData
  performedBy {
    id
    ...Name
  }
  stage {
    harvestGroup {
      id
      name
    }
    id
    name
    startDate
    calendarBranchId
    zone {
      id
      name
    }
  }
  isDraft
  readyForApproval
  approvedBy {
    id
    ...Name
  }
  approvedAt
  paperlyticsImage {
    imageUrl
  }
  paperlyticsIssuesList
  paperlyticsBoundaries
  paperlyticsAccuracyScore
}
    ${NameFragmentDoc}`;
export const HarvestGroupWithLogEntriesFragmentDoc = gql`
    fragment HarvestGroupWithLogEntries on HarvestGroup {
  ...HarvestGroupOverviewFields
  ...HarvestGroupCurrentStageFields
  logEntries(logEntryOptions: $logEntryOptions) {
    ...LogEntryFields
  }
}
    ${HarvestGroupOverviewFieldsFragmentDoc}
${HarvestGroupCurrentStageFieldsFragmentDoc}
${LogEntryFieldsFragmentDoc}`;
export const HarvestGroupCalendarFieldsFragmentDoc = gql`
    fragment HarvestGroupCalendarFields on HarvestGroup {
  id
  name
  colorHexCode
  tasks {
    ...TaskCalendarFields
  }
  stages {
    ...StageCalendarFields
  }
}
    ${TaskCalendarFieldsFragmentDoc}
${StageCalendarFieldsFragmentDoc}`;
export const StageFieldsFragmentDoc = gql`
    fragment StageFields on Stage {
  id
  name
  startDate
  endDate
  calendarBranchId
  desiredNumberOfDays
  environmentalTargetType
  maxNumberOfDays
  minNumberOfDays
  orderInProcess
  templateUsed {
    id
    name
  }
}
    `;
export const TaskFieldsFragmentDoc = gql`
    fragment TaskFields on Task {
  id
  name
  startDate
  endDate
  assignedTo {
    id
    firstName
    lastName
  }
  completedAt
  createdBy {
    id
    firstName
    lastName
  }
  priority
  notes
  templateUsed {
    id
  }
}
    `;
export const ZoneFieldsFragmentDoc = gql`
    fragment ZoneFields on Zone {
  id
  site {
    id
    name
  }
  primaryDevice {
    id
  }
  name
  metrcId
  active
  maxConcurrentHarvestGroups
  maxConcurrentPlants
  lightingClassification
  dayStartTime
  nightStartTime
  cultivationStyle {
    id
    name
  }
  irrigationStyle {
    id
    name
  }
  irrigationFrequency {
    id
    name
  }
  irrigationType {
    id
    name
  }
  dripEmitterSize
  growingMedia {
    id
    name
  }
  rockwoolBrand {
    id
    name
  }
  rockwoolSize {
    id
    name
  }
  cocoBrand {
    id
    name
  }
  cocoContainerSize
  cocoContainerSizeOtherGallons
  soilBrand {
    id
    name
  }
  soilContainerSize
  lengthFeet
  lengthInches
  heightFeet
  heightInches
  widthFeet
  widthInches
  rows
  roomUsage
  numLightsUnderCanopy
  underCanopy
  underCanopyBrand {
    id
    name
  }
  benchSqFt
  tiers
  controlSystem {
    id
    name
  }
  sensors {
    id
    name
  }
  rootZoneSensor {
    id
    name
  }
  dehumidifierSelections {
    id
    brand {
      id
      name
      isCustom
    }
    brandNameOther
    size
    numUnits
  }
  circulatingFanSelections {
    id
    brand {
      id
      name
      isCustom
    }
    brandNameOther
    fanCount
  }
  acSelections {
    id
    brand {
      id
      name
      isCustom
    }
    brandNameOther
    acStyle
    acSizeByTon
    acNumUnits
  }
  lightingTypeSelections {
    id
    lightingType
    lightingTypeOther
    brand {
      id
      name
      isCustom
    }
    brandNameOther
    lightCount
    wattsPerLight
  }
}
    `;
export const HarvestGroupTaskTemplateFieldsFragmentDoc = gql`
    fragment HarvestGroupTaskTemplateFields on TaskTemplate {
  id
  createdTaskName
  stageDayStart
  stageDayEnd
  taskType
  logType
  logEntryRecipe {
    id
    name
    applicationType
  }
}
    `;
export const HarvestGroupStageTemplateFieldsFragmentDoc = gql`
    fragment HarvestGroupStageTemplateFields on StageTemplate {
  id
  name
  createdStageName
  numberOfDays
  maxNumberOfDays
  minNumberOfDays
  orderInProcess
  designatedZones {
    ...ZoneFields
  }
  taskTemplates {
    ...HarvestGroupTaskTemplateFields
  }
  environmentalTargetType
}
    ${ZoneFieldsFragmentDoc}
${HarvestGroupTaskTemplateFieldsFragmentDoc}`;
export const HarvestGroupTemplateFieldsFragmentDoc = gql`
    fragment HarvestGroupTemplateFields on HarvestGroupTemplate {
  id
  name
  archivedAt
  stageTemplates {
    ...HarvestGroupStageTemplateFields
  }
}
    ${HarvestGroupStageTemplateFieldsFragmentDoc}`;
export const HarvestGroupFieldsFragmentDoc = gql`
    fragment HarvestGroupFields on HarvestGroup {
  id
  startDate
  harvestDate
  isMultisite
  draftLogEntryCount
  flowerZone {
    id
    name
  }
  site {
    id
    name
  }
  archivedAt
  ...HarvestGroupCalendarFields
  stages {
    ...StageFields
    zone {
      id
      name
    }
    strainsInStage {
      numberOfPlants
      strain {
        id
        name
      }
    }
    tasks {
      ...TaskFields
    }
  }
  strains {
    ...StrainFields
  }
  harvestCompletion {
    createdAt
    createdBy {
      id
      ...Name
    }
    cosignedAt
    cosignedBy {
      id
      ...Name
    }
  }
  templateUsed {
    ...HarvestGroupTemplateFields
  }
}
    ${HarvestGroupCalendarFieldsFragmentDoc}
${StageFieldsFragmentDoc}
${TaskFieldsFragmentDoc}
${StrainFieldsFragmentDoc}
${NameFragmentDoc}
${HarvestGroupTemplateFieldsFragmentDoc}`;
export const HarvestCompletionFieldsFragmentDoc = gql`
    fragment HarvestCompletionFields on HarvestCompletion {
  id
  cosignedBy {
    id
    firstName
    lastName
  }
  harvestGroup {
    ...HarvestGroupFields
  }
  createdBy {
    id
    firstName
    lastName
  }
}
    ${HarvestGroupFieldsFragmentDoc}`;
export const YieldAnalysisBatchFragmentDoc = gql`
    fragment YieldAnalysisBatch on HarvestYieldBatch {
  id
  name
  stream
  plantCount
  gramsPerPlant
  dryGrams
  wetPackagedGrams
  isOpen
  issues
  byFormFactor {
    ...BudFormFactorYield
  }
}
    ${BudFormFactorYieldFragmentDoc}`;
export const YieldReportFieldsFragmentDoc = gql`
    fragment YieldReportFields on HarvestStrainYield {
  yieldBatches {
    ...YieldAnalysisBatch
  }
  ...YieldFields
  historicalAvgGramsPerPlant
  strain {
    ...StrainReportFields
  }
}
    ${YieldAnalysisBatchFragmentDoc}
${YieldFieldsFragmentDoc}
${StrainReportFieldsFragmentDoc}`;
export const CompletedHarvestGroupYieldsFieldsFragmentDoc = gql`
    fragment CompletedHarvestGroupYieldsFields on HarvestGroup {
  id
  name
  yields {
    ...YieldReportFields
  }
}
    ${YieldReportFieldsFragmentDoc}`;
export const HarvestForecastYieldHistoryFieldsFragmentDoc = gql`
    fragment HarvestForecastYieldHistoryFields on HarvestStrainYield {
  harvestGroup {
    id
    name
  }
  strain {
    ...StrainReportFields
  }
  finalPlantCount
  budFormFactorYields {
    budFormFactorId
    budFormFactor {
      id
      name
      active
      orderPosition
      classification
    }
    numberOfGrams
  }
}
    ${StrainReportFieldsFragmentDoc}`;
export const CurrentGroupsHarvestForecastFieldsFragmentDoc = gql`
    fragment CurrentGroupsHarvestForecastFields on HarvestGroup {
  id
  name
  ...HarvestGroupCurrentStageFields
  projections {
    ...HarvestProjection
  }
  startDate
  harvestDate
  colorHexCode
  strains {
    ...StrainReportFields
  }
  yields {
    ...YieldReportFields
  }
  flowerZone {
    ...ZoneIdAndName
  }
  harvestCompletion {
    id
  }
}
    ${HarvestGroupCurrentStageFieldsFragmentDoc}
${HarvestProjectionFragmentDoc}
${StrainReportFieldsFragmentDoc}
${YieldReportFieldsFragmentDoc}
${ZoneIdAndNameFragmentDoc}`;
export const HarvestGroupReportFieldsFragmentDoc = gql`
    fragment HarvestGroupReportFields on HarvestGroup {
  id
  name
  startDate
  harvestDate
  colorHexCode
}
    `;
export const StageReportFieldsFragmentDoc = gql`
    fragment StageReportFields on Stage {
  id
  name
  daysInStage
  startDate
  endDate
  calendarBranchId
  desiredNumberOfDays
}
    `;
export const AnalyticsHarvestGroupFieldsFragmentDoc = gql`
    fragment AnalyticsHarvestGroupFields on HarvestGroup {
  name
  startDate
  harvestDate
  archivedAt
  ...HarvestGroupReportFields
  stages {
    ...StageReportFields
  }
  strains {
    ...StrainReportFields
  }
  yields {
    ...YieldReportFields
  }
  flowerZone {
    ...ZoneIdAndName
  }
  becameProcessingGroup {
    id
    name
  }
  ...HarvestGroupFields
}
    ${HarvestGroupReportFieldsFragmentDoc}
${StageReportFieldsFragmentDoc}
${StrainReportFieldsFragmentDoc}
${YieldReportFieldsFragmentDoc}
${ZoneIdAndNameFragmentDoc}
${HarvestGroupFieldsFragmentDoc}`;
export const HarvestSummaryFieldsFragmentDoc = gql`
    fragment HarvestSummaryFields on HarvestSummary {
  id
  approvedAt
  approvedBy {
    id
    ...Name
  }
  adminNotes
  aiModelUsed
  generationCost
  status
  generatedAt
  summaryText
  yieldDriversAnalysis
}
    ${NameFragmentDoc}`;
export const ActivitySummaryFieldsFragmentDoc = gql`
    fragment ActivitySummaryFields on CultivationActivitySummary {
  id
  status
  generatedAt
  approvedAt
  approvedBy {
    id
    ...Name
  }
  observationsReport
  issuesReport
  irrigationReport
  foliarReport
  pruningReport
  toppingReport
  runoffReport
}
    ${NameFragmentDoc}`;
export const CompletedHarvestGroupFieldsFragmentDoc = gql`
    fragment CompletedHarvestGroupFields on HarvestGroup {
  id
  name
  startDate
  harvestDate
  archivedAt
  aiSummary {
    ...HarvestSummaryFields
  }
  aiActivitySummary {
    ...ActivitySummaryFields
  }
  ...HarvestGroupReportFields
  stages {
    ...StageReportFields
  }
  strains {
    ...StrainReportFields
  }
  yields {
    ...YieldReportFields
  }
  flowerZone {
    ...ZoneIdAndName
  }
  becameProcessingGroup {
    id
    name
  }
}
    ${HarvestSummaryFieldsFragmentDoc}
${ActivitySummaryFieldsFragmentDoc}
${HarvestGroupReportFieldsFragmentDoc}
${StageReportFieldsFragmentDoc}
${StrainReportFieldsFragmentDoc}
${YieldReportFieldsFragmentDoc}
${ZoneIdAndNameFragmentDoc}`;
export const CompletedHarvestGroupWithLogsFieldsFragmentDoc = gql`
    fragment CompletedHarvestGroupWithLogsFields on HarvestGroup {
  ...CompletedHarvestGroupFields
  logEntries {
    ...LogEntryFields
  }
  weeklyEnvironmentalData {
    week
    stageName
    environmentalType
    temperature {
      compliant
      percentInRange
    }
    humidity {
      compliant
      percentInRange
    }
    co2 {
      compliant
      percentInRange
    }
    vpd {
      compliant
      percentInRange
    }
  }
}
    ${CompletedHarvestGroupFieldsFragmentDoc}
${LogEntryFieldsFragmentDoc}`;
export const HarvestGroupReportComparisonFieldsFragmentDoc = gql`
    fragment HarvestGroupReportComparisonFields on HarvestGroup {
  ...CompletedHarvestGroupFields
  logEntries {
    id
    logType
  }
}
    ${CompletedHarvestGroupFieldsFragmentDoc}`;
export const ProcessingStrainYieldFieldsFragmentDoc = gql`
    fragment ProcessingStrainYieldFields on ProcessingGroupStrain {
  id
  status
  totalOutputGrams
  totalInputGrams
  inventoryGrams
  strain {
    id
  }
}
    `;
export const HarvestBecameProcessingFieldsFragmentDoc = gql`
    fragment HarvestBecameProcessingFields on HarvestGroup {
  id
  becameProcessingGroup {
    id
    name
    processingGroupStrains {
      ...ProcessingStrainYieldFields
    }
  }
}
    ${ProcessingStrainYieldFieldsFragmentDoc}`;
export const HarvestGroupDetailFieldsFragmentDoc = gql`
    fragment HarvestGroupDetailFields on HarvestGroup {
  id
  startDate
  harvestDate
  archivedAt
  ...HarvestGroupCalendarFields
  stages {
    ...StageCalendarFields
    zone {
      id
      name
    }
    strainsInStage {
      id
      numberOfPlants
      strain {
        id
        name
      }
    }
  }
  strains {
    ...StrainFields
  }
}
    ${HarvestGroupCalendarFieldsFragmentDoc}
${StageCalendarFieldsFragmentDoc}
${StrainFieldsFragmentDoc}`;
export const HarvestGroupOverviewTooltipFieldsFragmentDoc = gql`
    fragment HarvestGroupOverviewTooltipFields on HarvestGroup {
  id
  name
  site {
    id
    name
  }
  startDate
  flowerStartDate
  harvestDate
  colorHexCode
  flowerZone {
    id
    name
  }
  importedFromMetrc
  isAutoCreated
  currentStage {
    id
    name
    strainsInStage {
      id
      numberOfPlants
      strain {
        id
        name
      }
    }
  }
  strains {
    id
    name
  }
  harvestCompletion {
    id
    createdBy {
      id
      ...Name
    }
    cosignedBy {
      id
      ...Name
    }
  }
}
    ${NameFragmentDoc}`;
export const LogEntriesFragmentDoc = gql`
    fragment LogEntries on HarvestGroup {
  id
  logEntries(logEntryOptions: $zoneOptions) {
    ...LogEntryFields
  }
}
    ${LogEntryFieldsFragmentDoc}`;
export const MaintenanceRequestResolutionFieldsFragmentDoc = gql`
    fragment MaintenanceRequestResolutionFields on MaintenanceRequest {
  resolution {
    createdAt
    resolvedAt
    notes
    resolvedBy {
      id
      ...Name
    }
  }
}
    ${NameFragmentDoc}`;
export const MaintenanceRequestFieldsFragmentDoc = gql`
    fragment MaintenanceRequestFields on MaintenanceRequest {
  id
  createdAt
  firstObservedAt
  dueDate
  urgent
  equipmentInoperable
  lockOutTagOut
  requestedBy {
    id
    ...Name
  }
  description
  location {
    id
    name
  }
  imageUrl
  tags {
    name
  }
  ...MaintenanceRequestResolutionFields
}
    ${NameFragmentDoc}
${MaintenanceRequestResolutionFieldsFragmentDoc}`;
export const EquipmentFieldsFragmentDoc = gql`
    fragment EquipmentFields on Equipment {
  id
  label
  type
  lastMaintenanceDate
  brand
  serialNumber
  model
  installedAtDate
  notes
  status
  location {
    id
    name
  }
}
    `;
export const PaperlyticsImageFieldsFragmentDoc = gql`
    fragment PaperlyticsImageFields on PaperlyticsImage {
  id
  harvestGroup {
    id
    name
  }
  imageUrl
  imageUpload
  startedAt
  completedAt
  success
  targetType
  result
  accuracyScore
  issuesList
  uploadedBy {
    id
    firstName
    lastName
    email
  }
}
    `;
export const NutrientFieldsFragmentDoc = gql`
    fragment NutrientFields on Nutrient {
  id
  name
  active
  unitOfMeasure
  priceInCentsPerUnit
  boughtPrice
  boughtAmount
  boughtUnit
}
    `;
export const RecipeFieldsFragmentDoc = gql`
    fragment RecipeFields on Recipe {
  id
  name
  active
  applicationType
  ec
  ph
  components {
    id
    nutrient {
      ...NutrientFields
    }
    volume
  }
}
    ${NutrientFieldsFragmentDoc}`;
export const HarvestGroupTemplateVersionFieldsFragmentDoc = gql`
    fragment HarvestGroupTemplateVersionFields on HarvestGroupTemplateVersion {
  id
  name
  version
  stageTemplates {
    ...HarvestGroupStageTemplateFields
  }
}
    ${HarvestGroupStageTemplateFieldsFragmentDoc}`;
export const HarvestGroupZoneCardFieldsFragmentDoc = gql`
    fragment HarvestGroupZoneCardFields on HarvestGroup {
  id
  logEntries(logEntryOptions: $zoneOptions) {
    ...LogEntryFields
  }
  ...HarvestGroupCurrentStageFields
}
    ${LogEntryFieldsFragmentDoc}
${HarvestGroupCurrentStageFieldsFragmentDoc}`;
export const CurrentGroupsShortFieldsFragmentDoc = gql`
    fragment CurrentGroupsShortFields on HarvestGroup {
  id
  name
  site {
    id
    name
  }
  startDate
  flowerStartDate
  harvestDate
  colorHexCode
  flowerZone {
    id
    name
  }
  importedFromMetrc
  isAutoCreated
  currentStage {
    id
    name
    strainsInStage {
      id
      numberOfPlants
      strain {
        id
        name
      }
    }
  }
  strains {
    id
    name
  }
  harvestCompletion {
    id
    createdBy {
      id
      ...Name
    }
    cosignedBy {
      id
      ...Name
    }
  }
}
    ${NameFragmentDoc}`;
export const ZoneWithHarvestGroupFieldsFragmentDoc = gql`
    fragment ZoneWithHarvestGroupFields on Zone {
  ...ZoneFields
  currentHarvestGroups {
    ...CurrentGroupsShortFields
    ...HarvestGroupCurrentStageFields
    logEntries(logEntryOptions: $zoneOptions) {
      ...LogEntryFields
    }
  }
}
    ${ZoneFieldsFragmentDoc}
${CurrentGroupsShortFieldsFragmentDoc}
${HarvestGroupCurrentStageFieldsFragmentDoc}
${LogEntryFieldsFragmentDoc}`;
export const SensorMetricQualityFieldsFragmentDoc = gql`
    fragment SensorMetricQualityFields on SensorMetricQuality {
  codes
  messages
  expectedSamples
  observedSamples
  coveragePercent
  intervalMinutes
  cadenceConfigured
  latestObservation
  suspectedStuckDays
}
    `;
export const ZoneObservationSummaryFieldsFragmentDoc = gql`
    fragment ZoneObservationSummaryFields on ZoneObservationSummary {
  metrics {
    mean
    key
    label
    unit
    category
    sensors {
      quality {
        ...SensorMetricQualityFields
      }
      deviceId
      name
      mean
      dayMean
      nightMean
      observedBins
      expectedBins
    }
  }
  day
  sourceCount
  reportingSourceCount
  latestObservation
}
    ${SensorMetricQualityFieldsFragmentDoc}`;
export const ZoneCardFieldsFragmentDoc = gql`
    fragment ZoneCardFields on Zone {
  observationSummary {
    ...ZoneObservationSummaryFields
  }
  ...ZoneFields
  currentHarvestGroups {
    ...CurrentGroupsShortFields
    ...HarvestGroupCurrentStageFields
    tasks(dateRange: $taskDateRange, calendarBranchId: $calendarBranchId) {
      ...TaskCalendarFields
    }
  }
}
    ${ZoneObservationSummaryFieldsFragmentDoc}
${ZoneFieldsFragmentDoc}
${CurrentGroupsShortFieldsFragmentDoc}
${HarvestGroupCurrentStageFieldsFragmentDoc}
${TaskCalendarFieldsFragmentDoc}`;
export const DashboardTaskFieldsFragmentDoc = gql`
    fragment DashboardTaskFields on Task {
  id
  name
  startDate
  endDate
}
    `;
export const DashboardHarvestGroupFieldsFragmentDoc = gql`
    fragment DashboardHarvestGroupFields on HarvestGroup {
  id
  name
  harvestDate
  site {
    id
    name
  }
  colorHexCode
  flowerZone {
    id
    name
  }
  currentStage {
    id
    name
    currentDayOfStage
    daysInStage
  }
  tasks(dateRange: $taskDateRange, calendarBranchId: $calendarBranchId) {
    ...DashboardTaskFields
  }
}
    ${DashboardTaskFieldsFragmentDoc}`;
export const DashboardZoneCardFieldsFragmentDoc = gql`
    fragment DashboardZoneCardFields on Zone {
  observationSummary {
    ...ZoneObservationSummaryFields
  }
  id
  name
  roomUsage
  site {
    id
    name
  }
  primaryDevice {
    id
  }
  dayStartTime
  nightStartTime
  currentHarvestGroups {
    ...DashboardHarvestGroupFields
  }
}
    ${ZoneObservationSummaryFieldsFragmentDoc}
${DashboardHarvestGroupFieldsFragmentDoc}`;
export const CalendarZoneCardHarvestGroupFieldsFragmentDoc = gql`
    fragment CalendarZoneCardHarvestGroupFields on HarvestGroup {
  id
  name
  colorHexCode
  currentStage {
    id
    name
    currentDayOfStage
    daysInStage
  }
  tasks(dateRange: $taskDateRange, calendarBranchId: $calendarBranchId) {
    ...DashboardTaskFields
  }
}
    ${DashboardTaskFieldsFragmentDoc}`;
export const CalendarZoneCardFieldsFragmentDoc = gql`
    fragment CalendarZoneCardFields on Zone {
  observationSummary {
    ...ZoneObservationSummaryFields
  }
  id
  name
  roomUsage
  site {
    id
    name
  }
  primaryDevice {
    id
  }
  currentHarvestGroups {
    ...CalendarZoneCardHarvestGroupFields
  }
}
    ${ZoneObservationSummaryFieldsFragmentDoc}
${CalendarZoneCardHarvestGroupFieldsFragmentDoc}`;
export const ProcessingGroupNameFragmentDoc = gql`
    fragment ProcessingGroupName on ProcessingGroup {
  id
  name
}
    `;
export const ProcessingGroupStageFieldsFragmentDoc = gql`
    fragment ProcessingGroupStageFields on ProcessingGroupStage {
  id
  name
  status
  startDate
  endDate
  schedulingScope
  totalInputGrams
  totalOutputGrams
  totalPendingGrams
  totalPartialGrams
  processingGroup {
    ...ProcessingGroupName
  }
  summary {
    progressPercent
    weightCompletedGrams
    weightTotalGrams
    numDays
    daysElapsed
    remainingInventoryGrams
  }
  processingStageTemplate {
    id
    name
    inputTypes {
      id
      name
    }
  }
}
    ${ProcessingGroupNameFragmentDoc}`;
export const ProcessingStageTemplateFieldsFragmentDoc = gql`
    fragment ProcessingStageTemplateFields on ProcessingStageTemplate {
  id
  name
  numberOfDays
  trackPerformance
  orderInProcess
  progressScope
  schedulingScope
  inputTypes {
    ...BudFormFactorFields
  }
  outputTypes {
    ...BudFormFactorFields
  }
}
    ${BudFormFactorFieldsFragmentDoc}`;
export const ProcessingGroupStageWithTemplateFieldsFragmentDoc = gql`
    fragment ProcessingGroupStageWithTemplateFields on ProcessingGroupStage {
  ...ProcessingGroupStageFields
  processingStageTemplate {
    ...ProcessingStageTemplateFields
  }
}
    ${ProcessingGroupStageFieldsFragmentDoc}
${ProcessingStageTemplateFieldsFragmentDoc}`;
export const ProcessingJobOverviewFieldsFragmentDoc = gql`
    fragment ProcessingJobOverviewFields on ProcessingJob {
  id
  jobStatus
  assignee {
    id
    ...Name
  }
  createdBy {
    id
    ...Name
  }
  inputType {
    ...BudFormFactorFields
  }
  inputGrams
  totalOutputGrams
  createdAt
  startedAt
  totalWorkedMinutes
  strainStage {
    status
    id
    stage {
      ...ProcessingGroupStageWithTemplateFields
    }
    processingGroupStrain {
      id
      strain {
        id
        name
      }
    }
  }
}
    ${NameFragmentDoc}
${BudFormFactorFieldsFragmentDoc}
${ProcessingGroupStageWithTemplateFieldsFragmentDoc}`;
export const ProcessingJobLogFieldsFragmentDoc = gql`
    fragment ProcessingJobLogFields on ProcessingJobLog {
  id
  logType
  createdBy {
    id
    ...Name
  }
  performer {
    id
    ...Name
  }
  startedAt
  endedAt
  createdAt
  breakMinutes
  workedMinutes
  outputGrams
  leftoverInputGrams
}
    ${NameFragmentDoc}`;
export const ProcessingJobOverviewWithLogsFieldsFragmentDoc = gql`
    fragment ProcessingJobOverviewWithLogsFields on ProcessingJob {
  ...ProcessingJobOverviewFields
  processingJobLogs {
    ...ProcessingJobLogFields
  }
}
    ${ProcessingJobOverviewFieldsFragmentDoc}
${ProcessingJobLogFieldsFragmentDoc}`;
export const ProcessingJobOverviewWithGroupFieldsFragmentDoc = gql`
    fragment ProcessingJobOverviewWithGroupFields on ProcessingJob {
  ...ProcessingJobOverviewFields
}
    ${ProcessingJobOverviewFieldsFragmentDoc}`;
export const ProcessingGroupShortOverviewFragmentDoc = gql`
    fragment ProcessingGroupShortOverview on ProcessingGroup {
  id
  name
  status
  colorHexCode
}
    `;
export const ProcessingGroupStageWithSummaryFieldsFragmentDoc = gql`
    fragment ProcessingGroupStageWithSummaryFields on ProcessingGroupStage {
  ...ProcessingGroupStageWithTemplateFields
  summary {
    progressPercent
    daysElapsed
    numDays
    weightCompletedGrams
    weightTotalGrams
    remainingInventoryGrams
  }
}
    ${ProcessingGroupStageWithTemplateFieldsFragmentDoc}`;
export const AdjustmentFieldsFragmentDoc = gql`
    fragment AdjustmentFields on ProcessingGroupStrainInventoryAdjustment {
  id
  createdAt
  adjustmentGrams
  createdBy {
    id
    ...Name
  }
  description
}
    ${NameFragmentDoc}`;
export const ProcessingGroupStrainFieldsFragmentDoc = gql`
    fragment ProcessingGroupStrainFields on ProcessingGroupStrain {
  id
  strain {
    ...StrainFields
  }
  status
  orderInProcess
  inventoryGrams
  totalInputGrams
  totalPendingGrams
  totalPartialGrams
  totalOutputGrams
  totalAdjustmentGrams
  inventoryAdjustments {
    ...AdjustmentFields
  }
}
    ${StrainFieldsFragmentDoc}
${AdjustmentFieldsFragmentDoc}`;
export const ProcessingGroupStrainStageSummaryFieldsFragmentDoc = gql`
    fragment ProcessingGroupStrainStageSummaryFields on ProcessingGroupStrainStage {
  id
  summary {
    progressPercent
    daysElapsed
    numDays
    weightCompletedGrams
    weightTotalGrams
    remainingInventoryGrams
  }
}
    `;
export const ProcessingGroupStrainStageOverviewFieldsFragmentDoc = gql`
    fragment ProcessingGroupStrainStageOverviewFields on ProcessingGroupStrainStage {
  id
  status
  startDate
  endDate
  processingGroupStrain {
    inventoryAdjustments {
      ...AdjustmentFields
    }
    strain {
      ...StrainFields
    }
  }
  stage {
    ...ProcessingGroupStageWithSummaryFields
    processingGroup {
      id
    }
  }
  totalInputGrams
  totalPendingGrams
  totalPartialGrams
  totalOutputGrams
  ...ProcessingGroupStrainStageSummaryFields
}
    ${AdjustmentFieldsFragmentDoc}
${StrainFieldsFragmentDoc}
${ProcessingGroupStageWithSummaryFieldsFragmentDoc}
${ProcessingGroupStrainStageSummaryFieldsFragmentDoc}`;
export const ProcessingGroupWithStrainsAndStagesFieldsFragmentDoc = gql`
    fragment ProcessingGroupWithStrainsAndStagesFields on ProcessingGroup {
  ...ProcessingGroupShortOverview
  inUnfinishedJobs(strainId: $strainId)
  processingGroupStages {
    ...ProcessingGroupStageWithSummaryFields
  }
  processingGroupStrains {
    ...ProcessingGroupStrainFields
  }
  processingGroupStrainStages(strainId: $strainId) {
    id
    ...ProcessingGroupStrainStageOverviewFields
    stage {
      ...ProcessingGroupStageWithSummaryFields
    }
    processingGroupStrain {
      id
      strain {
        ...StrainFields
      }
    }
  }
}
    ${ProcessingGroupShortOverviewFragmentDoc}
${ProcessingGroupStageWithSummaryFieldsFragmentDoc}
${ProcessingGroupStrainFieldsFragmentDoc}
${ProcessingGroupStrainStageOverviewFieldsFragmentDoc}
${StrainFieldsFragmentDoc}`;
export const ProcessingGroupWithStrainsAndStagesFieldsAndJobsFragmentDoc = gql`
    fragment ProcessingGroupWithStrainsAndStagesFieldsAndJobs on ProcessingGroup {
  ...ProcessingGroupWithStrainsAndStagesFields
  processingGroupStages {
    jobs {
      ...ProcessingJobOverviewFields
    }
  }
}
    ${ProcessingGroupWithStrainsAndStagesFieldsFragmentDoc}
${ProcessingJobOverviewFieldsFragmentDoc}`;
export const ProcessingGroupFieldsFragmentDoc = gql`
    fragment ProcessingGroupFields on ProcessingGroup {
  id
  name
  status
  archivedAt
  colorHexCode
  startDate
  createdBy {
    ...Name
  }
  latestStage {
    ...ProcessingGroupStageFields
  }
  processingGroupStrains {
    id
  }
}
    ${NameFragmentDoc}
${ProcessingGroupStageFieldsFragmentDoc}`;
export const ProcessingGroupOverviewFieldsFragmentDoc = gql`
    fragment ProcessingGroupOverviewFields on ProcessingGroup {
  ...ProcessingGroupFields
  processingGroupStages {
    ...ProcessingGroupStageWithSummaryFields
  }
  status
  processingGroupStrains {
    ...ProcessingGroupStrainFields
  }
}
    ${ProcessingGroupFieldsFragmentDoc}
${ProcessingGroupStageWithSummaryFieldsFragmentDoc}
${ProcessingGroupStrainFieldsFragmentDoc}`;
export const ProcessingGroupFieldsWithStageJobsFragmentDoc = gql`
    fragment ProcessingGroupFieldsWithStageJobs on ProcessingGroup {
  ...ProcessingGroupOverviewFields
  id
  stages {
    processingStageTemplate {
      trackPerformance
      outputTypes {
        id
        name
      }
    }
    jobs {
      jobStatus
      inputType {
        ...BudFormFactorFields
      }
      assignee {
        id
        ...Name
      }
      totalOutputGrams
      totalWorkedMinutes
      strainStage {
        processingGroupStrain {
          strain {
            id
            name
          }
          id
        }
      }
    }
  }
}
    ${ProcessingGroupOverviewFieldsFragmentDoc}
${BudFormFactorFieldsFragmentDoc}
${NameFragmentDoc}`;
export const ProcessingGroupTemplateVersionFieldsFragmentDoc = gql`
    fragment ProcessingGroupTemplateVersionFields on ProcessingGroupTemplateVersion {
  id
  name
  version
  processingStageTemplates {
    ...ProcessingStageTemplateFields
  }
}
    ${ProcessingStageTemplateFieldsFragmentDoc}`;
export const ProcessingGroupTemplateFieldsFragmentDoc = gql`
    fragment ProcessingGroupTemplateFields on ProcessingGroupTemplate {
  id
  name
  archivedAt
  activeTemplateVersion {
    ...ProcessingGroupTemplateVersionFields
  }
  processingGroupTemplateVersions {
    ...ProcessingGroupTemplateVersionFields
  }
}
    ${ProcessingGroupTemplateVersionFieldsFragmentDoc}`;
export const OrganizationNotificationPreferenceFieldsFragmentDoc = gql`
    fragment OrganizationNotificationPreferenceFields on OrganizationNotificationPreference {
  id
  reportType
  enabled
  frequency
  sendToAdmins
  sendToCultivationManagers
  sendToCultivation
  isScheduledReport
  requiresFrequencySelection
}
    `;
export const MyOrganizationPageFieldsFragmentDoc = gql`
    fragment MyOrganizationPageFields on Organization {
  id
  name
  timezone
  allowMultisite
  accountType
  moduleEnabledCultivation
  moduleEnabledProcessing
  moduleEnabledFinance
  moduleEnabledMaintenance
  apiEnabled
  optionConvertGramsAbove
  normalizeWindowMinutes
  alertConsecutiveThreshold
  notificationPreferences {
    ...OrganizationNotificationPreferenceFields
  }
}
    ${OrganizationNotificationPreferenceFieldsFragmentDoc}`;
export const EnvironmentalTargetValuesFieldsFragmentDoc = gql`
    fragment EnvironmentalTargetValuesFields on EnvironmentalTargetValues {
  id
  environmentalTargetType
  weekInPhase
  dayTempLow
  dayTempHigh
  nightTempLow
  nightTempHigh
  dayVpdLow
  dayVpdHigh
  nightVpdLow
  nightVpdHigh
  dayHumidityLow
  dayHumidityHigh
  nightHumidityLow
  nightHumidityHigh
  dayCo2Low
  dayCo2High
  nightCo2Low
  nightCo2High
}
    `;
export const EnvironmentalTargetSetFieldsFragmentDoc = gql`
    fragment EnvironmentalTargetSetFields on EnvironmentalTargetSet {
  id
  displayName
  environmentLightingType
  organization {
    id
  }
  environmentalTargetValues {
    ...EnvironmentalTargetValuesFields
  }
}
    ${EnvironmentalTargetValuesFieldsFragmentDoc}`;
export const RoleFieldsFragmentDoc = gql`
    fragment RoleFields on Role {
  id
  name
  permissions
}
    `;
export const UserAttributesFragmentDoc = gql`
    fragment UserAttributes on UserProfile {
  id
  firstName
  lastName
  email
  lastLogin
  organizationId
  role {
    ...RoleFields
  }
  userPermissions
  isNoLogin
  isStaff
  isSuperuser
  isActive
  salesManagerGroup
}
    ${RoleFieldsFragmentDoc}`;
export const ChecklistTaskFieldsFragmentDoc = gql`
    fragment ChecklistTaskFields on ChecklistTask {
  id
  name
  tourStatus
  dataStatus
  order
}
    `;
export const OrganizationMetrcLicenseFieldsFragmentDoc = gql`
    fragment OrganizationMetrcLicenseFields on OrganizationMetrcLicense {
  id
  licenseNumber
  userKey
  metrcState
  licenseType
  canGrowPlants
  role
  isActive
  validationStatus
  validationError
  asyncPackageImportStatus
  asyncPackageImportStartedAt
  asyncPackageImportCompletedAt
  asyncPackageImportError
  asyncPackageImportProgressPct
  createdAt
  updatedAt
}
    `;
export const OrganizationSiteMetrcLicenseFieldsFragmentDoc = gql`
    fragment OrganizationSiteMetrcLicenseFields on OrganizationSiteMetrcLicense {
  id
  licenseNumber
  userKey
  metrcState
  licenseType
  canGrowPlants
  isActive
  validationStatus
  validationError
  latestImportStatus
  latestImportStartedAt
  latestImportCompletedAt
  createdAt
  updatedAt
}
    `;
export const OrganizationMetrcLicenseRelationshipFieldsFragmentDoc = gql`
    fragment OrganizationMetrcLicenseRelationshipFields on OrganizationMetrcLicenseRelationship {
  id
  relationshipType
  isActive
  isRequiredForInitialImport
  sourceSiteLicense {
    id
    licenseNumber
  }
  targetOrgLicense {
    ...OrganizationMetrcLicenseFields
  }
}
    ${OrganizationMetrcLicenseFieldsFragmentDoc}`;
export const MetrcLicenseImportTaskFieldsFragmentDoc = gql`
    fragment MetrcLicenseImportTaskFields on MetrcLicenseImportTask {
  id
  licenseNumber
  status
  progressPct
  resultSummary
  error
  startedAt
  completedAt
  orgMetrcLicense {
    id
    licenseNumber
    metrcState
    role
  }
  siteMetrcLicense {
    id
    licenseNumber
    metrcState
  }
}
    `;
export const MetrcSiteImportBatchFieldsFragmentDoc = gql`
    fragment MetrcSiteImportBatchFields on MetrcSiteImportBatch {
  id
  status
  startedAt
  completedAt
  licenseTasks {
    ...MetrcLicenseImportTaskFields
  }
}
    ${MetrcLicenseImportTaskFieldsFragmentDoc}`;
export const OrganizationSiteFieldsFragmentDoc = gql`
    fragment OrganizationSiteFields on OrganizationSite {
  metrcSyncFloweringDates
  metrcSyncHarvestDates
  id
  name
  organization {
    id
    name
    timezone
    allowMultisite
    environmentalTargetSets {
      ...EnvironmentalTargetSetFields
    }
    confirmedTargetValues
    metrcLicenses {
      ...OrganizationMetrcLicenseFields
    }
    harvestGroupTemplates {
      id
      stageTemplates {
        id
        designatedZones {
          id
        }
      }
    }
  }
  zones {
    id
    name
    active
    metrcId
    lightingClassification
    roomUsage
    dayStartTime
    nightStartTime
  }
  isActive
  metrcLicenseNumber
  metrcUserKey
  metrcState
  asyncImportStatus
  asyncImportStartedAt
  asyncImportCompletedAt
  metrcProcessingConnectionsSkipped
  metrcLicenses {
    ...OrganizationSiteMetrcLicenseFields
  }
  metrcLicenseRelationships {
    ...OrganizationMetrcLicenseRelationshipFields
  }
  latestMetrcImportBatch {
    ...MetrcSiteImportBatchFields
  }
}
    ${EnvironmentalTargetSetFieldsFragmentDoc}
${OrganizationMetrcLicenseFieldsFragmentDoc}
${OrganizationSiteMetrcLicenseFieldsFragmentDoc}
${OrganizationMetrcLicenseRelationshipFieldsFragmentDoc}
${MetrcSiteImportBatchFieldsFragmentDoc}`;
export const OrganizationFieldsFragmentDoc = gql`
    fragment OrganizationFields on Organization {
  id
  name
  timezone
  zones {
    id
  }
  moduleEnabledCultivation
  moduleEnabledProcessing
  moduleEnabledFinance
  moduleEnabledMaintenance
  redesignEnabled
  branding {
    colorPreset
    typographyPreset
    logoUrl
    logoDarkUrl
    customized
    updatedAt
  }
  apiEnabled
  optionConvertGramsAbove
  normalizeWindowMinutes
  alertConsecutiveThreshold
  environmentalTargetSets {
    ...EnvironmentalTargetSetFields
  }
  checklist {
    checklistTasks {
      ...ChecklistTaskFields
    }
  }
  trialAccount
  accountType
  deactivatedAt
  sites {
    ...OrganizationSiteFields
  }
  metrcLicenses {
    ...OrganizationMetrcLicenseFields
  }
  allowMultisite
  dayStartTime
  nightStartTime
  confirmedTargetValues
}
    ${EnvironmentalTargetSetFieldsFragmentDoc}
${ChecklistTaskFieldsFragmentDoc}
${OrganizationSiteFieldsFragmentDoc}
${OrganizationMetrcLicenseFieldsFragmentDoc}`;
export const UserNotificationPreferenceFieldsFragmentDoc = gql`
    fragment UserNotificationPreferenceFields on UserNotificationPreference {
  id
  notificationType
  optedOut
}
    `;
export const UserProfileFragmentDoc = gql`
    fragment UserProfile on UserProfile {
  ...UserAttributes
  organization {
    ...OrganizationFields
  }
  notificationPreferences {
    ...UserNotificationPreferenceFields
  }
}
    ${UserAttributesFragmentDoc}
${OrganizationFieldsFragmentDoc}
${UserNotificationPreferenceFieldsFragmentDoc}`;
export const StaffOrganizationFieldsFragmentDoc = gql`
    fragment StaffOrganizationFields on Organization {
  id
  name
  sensorBrands {
    id
    brandName
    isActive
  }
  apiEnabled
  allowMultisite
  dayStartTime
  nightStartTime
  confirmedTargetValues
  environmentalTargetSets {
    ...EnvironmentalTargetSetFields
  }
  users {
    ...UserProfile
  }
  sites {
    ...OrganizationSiteFields
  }
  metrcLicenses {
    ...OrganizationMetrcLicenseFields
  }
}
    ${EnvironmentalTargetSetFieldsFragmentDoc}
${UserProfileFragmentDoc}
${OrganizationSiteFieldsFragmentDoc}
${OrganizationMetrcLicenseFieldsFragmentDoc}`;
export const AroyaDeviceRequestFieldsFragmentDoc = gql`
    fragment AroyaDeviceRequestFields on AroyaDeviceRequest {
  id
  isAdded
  deviceId
  modelKey
  serialNumber
  name
  roomId
  roomName
  benchId
  benchName
  category
}
    `;
export const GrowlinkDeviceRequestFieldsFragmentDoc = gql`
    fragment GrowlinkDeviceRequestFields on GrowlinkDeviceRequest {
  id
  name
  isAdded
  controllerId
  moduleName
  temperatureSensorId
  humiditySensorId
  co2SensorId
  vpdSensorId
  lightSensorId
  roomName
}
    `;
export const SensorCredentialFieldsFragmentDoc = gql`
    fragment SensorCredentialFields on SensorIntegrationCredential {
  id
  brand
  label
  apiKey
  username
  password
  growlinkApiVersion
  growlinkOrganizationId
  isActive
}
    `;
export const FacilitySurveyFieldsFragmentDoc = gql`
    fragment FacilitySurveyFields on FacilitySurvey {
  id
  createdBy {
    ...UserAttributes
  }
  fieldSurvey {
    id
  }
  reportDate
  completedAt
  phPrefilter
  ecPrefilter
  tdsPrefilter
  tempPrefilter
  phPostfilter
  ecPostfilter
  tdsPostfilter
  tempPostfilter
  floorsStatus
  wallsStatus
  ceilingsStatus
  footBaths
  eyeWashStations
  handWashStations
  msdsDocumentationUpToDate
  trainingLogsUpToDate
  hygieneAdherence
  storageConditions
  storageLabels
  storageContainers
  safetyProtocols
  ppeForHandling
  ppeGlovesAvailable
  ppeGogglesAvailable
  ppeMasksAvailable
  roFilters
  roInlineFilters
  roAirChambers
  roCheckValves
  waterTestTap
  waterTestPostFilter
  notes
  recommendations
}
    ${UserAttributesFragmentDoc}`;
export const RoomSurveyFieldsFragmentDoc = gql`
    fragment RoomSurveyFields on RoomSurvey {
  id
  createdBy {
    ...UserAttributes
  }
  fieldSurvey {
    id
    createdAt
  }
  zone {
    id
    name
  }
  skipReason
  reportDate
  startedAt
  completedAt
  growthPhase
  lightingComponentsBulbs
  lightingComponentsBallasts
  lightingStatus
  lightingPpfd
  currentTemperature
  currentHumidity
  leafSurfaceTemperature
  acOutletTemperature
  vpdLevel
  co2Level
  runoffCollectionPh
  runoffCollectionEc
  acUnits
  dehumidifiers
  circulatingFans
  humidifiers
  dripLines
  pumps
  catchCups
  plantStressIndicator
  signsOfPests
  signsOfPathogens
  stickyTraps
  growingMediumPh
  growingMediumEc
  nutrientSolutionPh
  nutrientSolutionEc
  notes
  recommendations
}
    ${UserAttributesFragmentDoc}`;
export const FieldSurveyFieldsFragmentDoc = gql`
    fragment FieldSurveyFields on FieldSurvey {
  id
  site {
    ...OrganizationSiteFields
  }
  createdBy {
    ...UserAttributes
  }
  createdAt
  facilitySurvey {
    ...FacilitySurveyFields
  }
  roomSurveys {
    ...RoomSurveyFields
  }
}
    ${OrganizationSiteFieldsFragmentDoc}
${UserAttributesFragmentDoc}
${FacilitySurveyFieldsFragmentDoc}
${RoomSurveyFieldsFragmentDoc}`;
export const EnvironmentalDeviceFieldsFragmentDoc = gql`
    fragment EnvironmentalDeviceFields on EnvironmentalDevice {
  id
  name
  category
  isPrimary
  trolmasterMacAddress
  trolmasterModel
  aroyaModelKey
  aroyaDeviceId
  aroyaSerialNumber
  aroyaApiRoomName
  aroyaApiBenchName
  growlinkControllerId
  growlinkModuleName
  growlinkTemperatureSensorId
  growlinkHumiditySensorId
  growlinkCo2SensorId
  growlinkVpdSensorId
  growlinkLightSensorId
  zone {
    id
    name
    active
    metrcId
    primaryDevice {
      id
    }
    site {
      id
      name
    }
  }
}
    `;
export const AroyaImportTaskFieldsFragmentDoc = gql`
    fragment AroyaImportTaskFields on SensorImportTask {
  id
  asyncAroyaStatus
  asyncAroyaProgressPct
  asyncAroyaStartedAt
  asyncAroyaCompletedAt
  asyncAroyaError
  aroyaEtaSecondsRemaining
  asyncAroyaSubstrateStatus
  asyncAroyaSubstrateProgressPct
  asyncAroyaSubstrateStartedAt
  asyncAroyaSubstrateCompletedAt
  asyncAroyaSubstrateError
  aroyaSubstrateEtaSecondsRemaining
  asyncAroyaRefreshStatus
  asyncAroyaRefreshProgressPct
  asyncAroyaRefreshStartedAt
  asyncAroyaRefreshCompletedAt
  asyncAroyaRefreshError
  aroyaRefreshEtaSecondsRemaining
  asyncDailyAroyaStatus
  asyncDailyAroyaStartedAt
  asyncDailyAroyaCompletedAt
  asyncDailyAroyaError
}
    `;
export const TrolmasterImportTaskFieldsFragmentDoc = gql`
    fragment TrolmasterImportTaskFields on SensorImportTask {
  id
  asyncTrolmasterStatus
  asyncTrolmasterProgressPct
  asyncTrolmasterStartedAt
  asyncTrolmasterCompletedAt
  asyncTrolmasterError
  trolmasterEtaSecondsRemaining
  asyncDailyTrolmasterStatus
  asyncDailyTrolmasterStartedAt
  asyncDailyTrolmasterCompletedAt
  asyncDailyTrolmasterError
}
    `;
export const GrowlinkImportTaskFieldsFragmentDoc = gql`
    fragment GrowlinkImportTaskFields on SensorImportTask {
  id
  asyncGrowlinkStatus
  asyncGrowlinkProgressPct
  asyncGrowlinkStartedAt
  asyncGrowlinkCompletedAt
  asyncGrowlinkError
  growlinkEtaSecondsRemaining
  asyncDailyGrowlinkStatus
  asyncDailyGrowlinkStartedAt
  asyncDailyGrowlinkCompletedAt
  asyncDailyGrowlinkError
}
    `;
export const SensorImportTaskFieldsFragmentDoc = gql`
    fragment SensorImportTaskFields on SensorImportTask {
  id
  analysisResult
  eddGapDays
  ...AroyaImportTaskFields
  ...TrolmasterImportTaskFields
  ...GrowlinkImportTaskFields
}
    ${AroyaImportTaskFieldsFragmentDoc}
${TrolmasterImportTaskFieldsFragmentDoc}
${GrowlinkImportTaskFieldsFragmentDoc}`;
export const MetrcImportTaskFieldsFragmentDoc = gql`
    fragment MetrcImportTaskFields on MetrcImportTask {
  id
  asyncMetrcStatus
  asyncMetrcProgressPct
  asyncMetrcStartedAt
  asyncMetrcCompletedAt
  asyncMetrcError
  metrcProgressPct
  metrcEtaSecondsRemaining
  resultSummary
}
    `;
export const WaterRoomChecklistFullFieldsFragmentDoc = gql`
    fragment WaterRoomChecklistFullFields on WaterRoomChecklist {
  id
  notes
  timeCompleted
  zone {
    id
    name
  }
  roomTemp
  f1Level
  f1Ph
  f1Ec
  f1TankTemp
  f2Level
  f2Ph
  f2Ec
  f2TankTemp
  f3Level
  f3Ph
  f3Ec
  f3TankTemp
  f4Level
  f4Ph
  f4Ec
  f4TankTemp
  f5Level
  f5Ph
  f5Ec
  f5TankTemp
  f6Level
  f6Ph
  f6Ec
  f6TankTemp
  combinedVegTankLevel
  vegTankPh
  vegTankEc
  vegTankTemp
  roHoseValveClosed
  dechlorHoseValveClosed
  dishPitHoseValveClosed
  flowerBaseStockLevel
  flowerCalciumStockLevel
  flowerPhStockLevel
  vegBaseStockLevel
  vegCalciumStockLevel
  vegPhStockLevel
  amHeaterValveCloseAndTempCheck
  pmHeaterValveOpen
}
    `;
export const WaterQualityStationReadingFullFieldsFragmentDoc = gql`
    fragment WaterQualityStationReadingFullFields on WaterQualityStationReading {
  id
  station
  item
  target
  reading
  passFail
  notes
  correctiveAction
}
    `;
export const WaterQualityChecklistFullFieldsFragmentDoc = gql`
    fragment WaterQualityChecklistFullFields on WaterQualityChecklist {
  id
  notes
  timeCompleted
  issuesFoundSummary
  correctiveActionSummary
  readings {
    ...WaterQualityStationReadingFullFields
  }
}
    ${WaterQualityStationReadingFullFieldsFragmentDoc}`;
export const PreHarvestTaskChecklistFullFieldsFragmentDoc = gql`
    fragment PreHarvestTaskChecklistFullFields on PreHarvestTaskChecklist {
  id
  notes
  timeCompleted
  zone {
    id
    name
  }
  pullAroyaSensors
  pullAroyaSensorsNote
  cutLowestLayerOfTrellis
  cutLowestLayerOfTrellisNote
  flowerBinsClean
  flowerBinsCleanNote
  writeFlowerBinLabels
  writeFlowerBinLabelsNote
  dryRoomClean
  dryRoomCleanNote
}
    `;
export const PostHarvestTaskChecklistFullFieldsFragmentDoc = gql`
    fragment PostHarvestTaskChecklistFullFields on PostHarvestTaskChecklist {
  id
  notes
  timeCompleted
  zone {
    id
    name
  }
  zerotolSprayHallways
  zerotolSprayHallwaysNote
  cleanTablesGutters
  cleanTablesGuttersNote
  cleanMainFloorDrain
  cleanMainFloorDrainNote
  cleanRackAndFloorFans
  cleanRackAndFloorFansNote
  greencleanAcidFlushLines
  greencleanAcidFlushLinesNote
  flushAcidWithZerotolThenRo
  flushAcidWithZerotolThenRoNote
  replaceAcAndDehuFilters
  replaceAcAndDehuFiltersNote
  blowOutDehuDrainLines
  blowOutDehuDrainLinesNote
  replaceFeedingLinesDrippersIfNeeded
  replaceFeedingLinesDrippersIfNeededNote
}
    `;
export const DryRoomPreHarvestChecklistFullFieldsFragmentDoc = gql`
    fragment DryRoomPreHarvestChecklistFullFields on DryRoomPreHarvestChecklist {
  id
  notes
  timeCompleted
  zone {
    id
    name
  }
  setTrolmasterSetpoints68f55rh
  setTrolmasterSetpoints68f55rhNote
  setUpFloorFans
  setUpFloorFansNote
  setUpSmallDehus
  setUpSmallDehusNote
  setRacksUpForHanging
  setRacksUpForHangingNote
}
    `;
export const DryRoomPostHarvestChecklistFullFieldsFragmentDoc = gql`
    fragment DryRoomPostHarvestChecklistFullFields on DryRoomPostHarvestChecklist {
  id
  notes
  timeCompleted
  zone {
    id
    name
  }
  doubleCheckFloorFans
  doubleCheckFloorFansNote
  smallDehusOnHighestSetting
  smallDehusOnHighestSettingNote
  doubleCheckTrolmasterSetpoints68f55rh
  doubleCheckTrolmasterSetpoints68f55rhNote
  sweepAndRemovePlantDebris
  sweepAndRemovePlantDebrisNote
}
    `;
export const RoomLoadTaskChecklistFullFieldsFragmentDoc = gql`
    fragment RoomLoadTaskChecklistFullFields on RoomLoadTaskChecklist {
  id
  notes
  timeCompleted
  zone {
    id
    name
  }
  parMeterCheckPlants
  parMeterCheckPlantsNote
  measurePlantHeight
  measurePlantHeightNote
  setUpHumidifiers
  setUpHumidifiersNote
  roomAt82f72rh
  roomAt82f72rhNote
  trolmasterWeek1Settings
  trolmasterWeek1SettingsNote
  reinstallAroyaSensors
  reinstallAroyaSensorsNote
  placeTrolmasterClimateSensors
  placeTrolmasterClimateSensorsNote
  deployCatchCupsRunoffTrays
  deployCatchCupsRunoffTraysNote
  doubleCheckNetbowsPluggedIn
  doubleCheckNetbowsPluggedInNote
  placeMetrcTags
  placeMetrcTagsNote
  add3LayersOfTrellis
  add3LayersOfTrellisNote
}
    `;
export const TransplantTaskChecklistFullFieldsFragmentDoc = gql`
    fragment TransplantTaskChecklistFullFields on TransplantTaskChecklist {
  id
  notes
  timeCompleted
  zone {
    id
    name
  }
  handChargeCocosWithCalciumNitrate
  handChargeCocosWithCalciumNitrateNote
  plugInAroyaSensors
  plugInAroyaSensorsNote
  addGypsumAndCalciumCarbonateRinse
  addGypsumAndCalciumCarbonateRinseNote
  transplantClonesIntoPots
  transplantClonesIntoPotsNote
  topOffEachPlantWithVegFeed
  topOffEachPlantWithVegFeedNote
  plugInNetbows
  plugInNetbowsNote
  placeMetrcTags
  placeMetrcTagsNote
  cleanAndSanitizeCloneTablesTrays
  cleanAndSanitizeCloneTablesTraysNote
}
    `;
export const CloningTaskChecklistFullFieldsFragmentDoc = gql`
    fragment CloningTaskChecklistFullFields on CloningTaskChecklist {
  id
  notes
  timeCompleted
  zone {
    id
    name
  }
  sanitizeEquipment
  sanitizeEquipmentNote
  preSoakPlugsWithCloneFeed
  preSoakPlugsWithCloneFeedNote
  squeezePlugs
  squeezePlugsNote
  cutClones
  cutClonesNote
  cutStems45DegreesRazorBlade
  cutStems45DegreesRazorBladeNote
  mixDipNGrow
  mixDipNGrowNote
  placeCutsInDipNGrow1520Seconds
  placeCutsInDipNGrow1520SecondsNote
  plugClonesWithCallus
  plugClonesWithCallusNote
  placeMetrcTags
  placeMetrcTagsNote
}
    `;
export const PruningDefolTaskChecklistFullFieldsFragmentDoc = gql`
    fragment PruningDefolTaskChecklistFullFields on PruningDefolTaskChecklist {
  id
  notes
  timeCompleted
  zone {
    id
    name
  }
  prepPrunersTrashBagsBuckets
  prepPrunersTrashBagsBucketsNote
  sanitizeUsedEquipmentBuckets
  sanitizeUsedEquipmentBucketsNote
  putTablesBackInPlace
  putTablesBackInPlaceNote
  logWasteWeights
  logWasteWeightsNote
}
    `;
export const DailyTasksChecklistFullFieldsFragmentDoc = gql`
    fragment DailyTasksChecklistFullFields on DailyTasksChecklist {
  id
  notes
  timeCompleted
  zone {
    id
    name
  }
  flowerRoomAmCheck
  flowerRoomAmCheckNote
  collectRunOffs
  collectRunOffsNote
  cleanNetafimFilters
  cleanNetafimFiltersNote
  sweepMopHallways
  sweepMopHallwaysNote
  collectAllTrash
  collectAllTrashNote
  flowerRoomPmCheck
  flowerRoomPmCheckNote
}
    `;
export const DailyWetRoomTaskChecklistFullFieldsFragmentDoc = gql`
    fragment DailyWetRoomTaskChecklistFullFields on DailyWetRoomTaskChecklist {
  id
  notes
  timeCompleted
  zone {
    id
    name
  }
  amCheckStockBarrels
  amCheckStockBarrelsNote
  amCalibratePhEcEquipment
  amCalibratePhEcEquipmentNote
  amMakeNeededStockBarrels
  amMakeNeededStockBarrelsNote
  pmCheckStockBarrels
  pmCheckStockBarrelsNote
  pmCleanUpPutAwayProducts
  pmCleanUpPutAwayProductsNote
  pmCapAndStorePhEcEquipment
  pmCapAndStorePhEcEquipmentNote
}
    `;
export const AirClimateSectionFieldsFragmentDoc = gql`
    fragment AirClimateSectionFields on AirClimateSection {
  id
  environmentFeel
  environmentalFeelNote
  airCirculation
  airCirculationNote
}
    `;
export const LightingSectionFieldsFragmentDoc = gql`
    fragment LightingSectionFields on LightingSection {
  id
  lightsWorking
  lightsWorkingNote
}
    `;
export const CultivationSectionFieldsFragmentDoc = gql`
    fragment CultivationSectionFields on CultivationSection {
  id
  overallPlantHealth
  overallPlantHealthNote
  rootHealth
  rootHealthNote
  wiltingPlants
  wiltingPlantsLocation
  yellowingDiscoloration
  yellowingDiscolorationNote
  growthRate
  growthRateNote
}
    `;
export const IpmSectionFieldsFragmentDoc = gql`
    fragment IPMSectionFields on IPMSection {
  id
  pestsVisible
  pestsType
  diseaseSigns
  diseaseSignsOther
  stickyTraps
  stickyTrapsNote
}
    `;
export const MaintenanceSectionFieldsFragmentDoc = gql`
    fragment MaintenanceSectionFields on MaintenanceSection {
  id
  hvacRunning
  hvacRunningNote
  irrigationSystem
  irrigationSystemNote
  filterCheck
  filterCheckNote
  tableDrains
  tableDrainsNote
  pumpsOperating
  pumpsOperatingNote
  dehumidifiers
  dehumidifiersNote
  unusualNoises
  unusualNoisesSource
}
    `;
export const SafetySectionFieldsFragmentDoc = gql`
    fragment SafetySectionFields on SafetySection {
  id
  areaClean
  areaCleanNote
  spillsPresent
  spillsLocation
  toolsPutAway
  toolsPutAwayNote
  benchSpacing
  benchSpacingNote
}
    `;
export const RunoffSectionFieldsFragmentDoc = gql`
    fragment RunoffSectionFields on RunoffSection {
  id
  entries {
    id
    ec
    ph
    amount
    type
    notes
    strain {
      id
      name
    }
  }
}
    `;
export const ChecklistEntryFieldsFragmentDoc = gql`
    fragment ChecklistEntryFields on ChecklistEntry {
  id
  timePeriod
  notes
  timeCompleted
  followUpRequired
  skipReason
  photos
  createdAt
  updatedAt
  inspector {
    id
    ...Name
  }
  zone {
    id
    name
  }
  airClimateSection {
    ...AirClimateSectionFields
  }
  lightingSection {
    ...LightingSectionFields
  }
  cultivationSection {
    ...CultivationSectionFields
  }
  ipmSection {
    ...IPMSectionFields
  }
  maintenanceSection {
    ...MaintenanceSectionFields
  }
  safetySection {
    ...SafetySectionFields
  }
  runoffSection {
    ...RunoffSectionFields
  }
}
    ${NameFragmentDoc}
${AirClimateSectionFieldsFragmentDoc}
${LightingSectionFieldsFragmentDoc}
${CultivationSectionFieldsFragmentDoc}
${IpmSectionFieldsFragmentDoc}
${MaintenanceSectionFieldsFragmentDoc}
${SafetySectionFieldsFragmentDoc}
${RunoffSectionFieldsFragmentDoc}`;
export const WaterRoomChecklistFieldsFragmentDoc = gql`
    fragment WaterRoomChecklistFields on WaterRoomChecklist {
  id
  roomTemp
  f1Level
  f1Ph
  f1Ec
  f1TankTemp
  f2Level
  f2Ph
  f2Ec
  f2TankTemp
  f3Level
  f3Ph
  f3Ec
  f3TankTemp
  f4Level
  f4Ph
  f4Ec
  f4TankTemp
  f5Level
  f5Ph
  f5Ec
  f5TankTemp
  f6Level
  f6Ph
  f6Ec
  f6TankTemp
  combinedVegTankLevel
  vegTankPh
  vegTankEc
  vegTankTemp
  roHoseValveClosed
  dechlorHoseValveClosed
  dishPitHoseValveClosed
  flowerBaseStockLevel
  flowerCalciumStockLevel
  flowerPhStockLevel
  vegBaseStockLevel
  vegCalciumStockLevel
  vegPhStockLevel
  amHeaterValveCloseAndTempCheck
  pmHeaterValveOpen
  notes
  photos
  timeCompleted
  inspector {
    id
    ...Name
  }
}
    ${NameFragmentDoc}`;
export const WaterQualityChecklistFieldsFragmentDoc = gql`
    fragment WaterQualityChecklistFields on WaterQualityChecklist {
  id
  notes
  photos
  timeCompleted
  issuesFoundSummary
  correctiveActionSummary
  inspector {
    id
    ...Name
  }
  readings {
    id
    station
    item
    target
    reading
    passFail
    notes
    correctiveAction
  }
}
    ${NameFragmentDoc}`;
export const RoomWalkthroughChecklistFieldsFragmentDoc = gql`
    fragment RoomWalkthroughChecklistFields on RoomWalkthroughChecklist {
  id
  timePeriod
  notes
  timeCompleted
  followUpRequired
  skipReason
  createdAt
  updatedAt
  inspector {
    id
    ...Name
  }
  zone {
    id
    name
  }
  photos
  airClimateSection {
    id
    environmentFeel
    environmentalFeelNote
    airCirculation
    airCirculationNote
  }
  lightingSection {
    id
    lightsWorking
    lightsWorkingNote
  }
  cultivationSection {
    id
    overallPlantHealth
    overallPlantHealthNote
    rootHealth
    rootHealthNote
    wiltingPlants
    wiltingPlantsLocation
    yellowingDiscoloration
    yellowingDiscolorationNote
    growthRate
    growthRateNote
  }
  ipmSection {
    id
    pestsVisible
    pestsType
    diseaseSigns
    diseaseSignsOther
    stickyTraps
    stickyTrapsNote
  }
  maintenanceSection {
    id
    hvacRunning
    hvacRunningNote
    irrigationSystem
    irrigationSystemNote
    filterCheck
    filterCheckNote
    tableDrains
    tableDrainsNote
    pumpsOperating
    pumpsOperatingNote
    dehumidifiers
    dehumidifiersNote
    unusualNoises
    unusualNoisesSource
  }
  safetySection {
    id
    areaClean
    areaCleanNote
    spillsPresent
    spillsLocation
    toolsPutAway
    toolsPutAwayNote
    benchSpacing
    benchSpacingNote
  }
  runoffSection {
    ...RunoffSectionFields
  }
}
    ${NameFragmentDoc}
${RunoffSectionFieldsFragmentDoc}`;
export const ChecklistSessionFieldsFragmentDoc = gql`
    fragment ChecklistSessionFields on ChecklistSession {
  id
  date
  checklistType
  primaryZoneName
  createdAt
  updatedAt
  site {
    id
    name
    zones {
      id
      name
      active
    }
  }
  createdBy {
    id
    ...Name
  }
  roomWalkthroughs {
    id
    timeCompleted
    zone {
      id
    }
  }
}
    ${NameFragmentDoc}`;
export const CalendarBranchDocument = gql`
    query calendarBranch($id: String, $dateRange: DateRangeInput) {
  calendarBranch(id: $id) {
    ...CalendarBranchFields
  }
}
    ${CalendarBranchFieldsFragmentDoc}`;

/**
 * __useCalendarBranchQuery__
 *
 * To run a query within a React component, call `useCalendarBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarBranchQuery({
 *   variables: {
 *      id: // value for 'id'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useCalendarBranchQuery(baseOptions?: Apollo.QueryHookOptions<CalendarBranchQuery, CalendarBranchQueryVariables>) {
        return Apollo.useQuery<CalendarBranchQuery, CalendarBranchQueryVariables>(CalendarBranchDocument, baseOptions);
      }
export function useCalendarBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarBranchQuery, CalendarBranchQueryVariables>) {
          return Apollo.useLazyQuery<CalendarBranchQuery, CalendarBranchQueryVariables>(CalendarBranchDocument, baseOptions);
        }
export type CalendarBranchQueryHookResult = ReturnType<typeof useCalendarBranchQuery>;
export type CalendarBranchLazyQueryHookResult = ReturnType<typeof useCalendarBranchLazyQuery>;
export type CalendarBranchQueryResult = Apollo.QueryResult<CalendarBranchQuery, CalendarBranchQueryVariables>;
export const CalendarBranchesDocument = gql`
    query calendarBranches {
  calendarBranches {
    ...CalendarBranchesGeneralInfoFields
  }
}
    ${CalendarBranchesGeneralInfoFieldsFragmentDoc}`;

/**
 * __useCalendarBranchesQuery__
 *
 * To run a query within a React component, call `useCalendarBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarBranchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendarBranchesQuery(baseOptions?: Apollo.QueryHookOptions<CalendarBranchesQuery, CalendarBranchesQueryVariables>) {
        return Apollo.useQuery<CalendarBranchesQuery, CalendarBranchesQueryVariables>(CalendarBranchesDocument, baseOptions);
      }
export function useCalendarBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarBranchesQuery, CalendarBranchesQueryVariables>) {
          return Apollo.useLazyQuery<CalendarBranchesQuery, CalendarBranchesQueryVariables>(CalendarBranchesDocument, baseOptions);
        }
export type CalendarBranchesQueryHookResult = ReturnType<typeof useCalendarBranchesQuery>;
export type CalendarBranchesLazyQueryHookResult = ReturnType<typeof useCalendarBranchesLazyQuery>;
export type CalendarBranchesQueryResult = Apollo.QueryResult<CalendarBranchesQuery, CalendarBranchesQueryVariables>;
export const CalendarBranchMergeLogEntriesDocument = gql`
    query calendarBranchMergeLogEntries {
  calendarBranchMergeLogEntries {
    id
    calendarBranchName
    mergedAt
    mergedBy {
      id
      firstName
      lastName
    }
    changelog
  }
}
    `;

/**
 * __useCalendarBranchMergeLogEntriesQuery__
 *
 * To run a query within a React component, call `useCalendarBranchMergeLogEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarBranchMergeLogEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarBranchMergeLogEntriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendarBranchMergeLogEntriesQuery(baseOptions?: Apollo.QueryHookOptions<CalendarBranchMergeLogEntriesQuery, CalendarBranchMergeLogEntriesQueryVariables>) {
        return Apollo.useQuery<CalendarBranchMergeLogEntriesQuery, CalendarBranchMergeLogEntriesQueryVariables>(CalendarBranchMergeLogEntriesDocument, baseOptions);
      }
export function useCalendarBranchMergeLogEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarBranchMergeLogEntriesQuery, CalendarBranchMergeLogEntriesQueryVariables>) {
          return Apollo.useLazyQuery<CalendarBranchMergeLogEntriesQuery, CalendarBranchMergeLogEntriesQueryVariables>(CalendarBranchMergeLogEntriesDocument, baseOptions);
        }
export type CalendarBranchMergeLogEntriesQueryHookResult = ReturnType<typeof useCalendarBranchMergeLogEntriesQuery>;
export type CalendarBranchMergeLogEntriesLazyQueryHookResult = ReturnType<typeof useCalendarBranchMergeLogEntriesLazyQuery>;
export type CalendarBranchMergeLogEntriesQueryResult = Apollo.QueryResult<CalendarBranchMergeLogEntriesQuery, CalendarBranchMergeLogEntriesQueryVariables>;
export const CreateCalendarBranchDocument = gql`
    mutation createCalendarBranch($input: CreateCalendarBranchInput!) {
  createCalendarBranch(input: $input) {
    ... on CalendarBranch {
      ...ShortCalendarBranchFields
    }
    ... on Error {
      message
    }
  }
}
    ${ShortCalendarBranchFieldsFragmentDoc}`;
export type CreateCalendarBranchMutationFn = Apollo.MutationFunction<CreateCalendarBranchMutation, CreateCalendarBranchMutationVariables>;

/**
 * __useCreateCalendarBranchMutation__
 *
 * To run a mutation, you first call `useCreateCalendarBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalendarBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalendarBranchMutation, { data, loading, error }] = useCreateCalendarBranchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCalendarBranchMutation(baseOptions?: Apollo.MutationHookOptions<CreateCalendarBranchMutation, CreateCalendarBranchMutationVariables>) {
        return Apollo.useMutation<CreateCalendarBranchMutation, CreateCalendarBranchMutationVariables>(CreateCalendarBranchDocument, baseOptions);
      }
export type CreateCalendarBranchMutationHookResult = ReturnType<typeof useCreateCalendarBranchMutation>;
export type CreateCalendarBranchMutationResult = Apollo.MutationResult<CreateCalendarBranchMutation>;
export type CreateCalendarBranchMutationOptions = Apollo.BaseMutationOptions<CreateCalendarBranchMutation, CreateCalendarBranchMutationVariables>;
export const DuplicateCalendarBranchDocument = gql`
    mutation duplicateCalendarBranch($input: DuplicateCalendarBranchInput!) {
  duplicateCalendarBranch(input: $input) {
    ... on CalendarBranch {
      ...ShortCalendarBranchFields
    }
    ... on Error {
      message
    }
  }
}
    ${ShortCalendarBranchFieldsFragmentDoc}`;
export type DuplicateCalendarBranchMutationFn = Apollo.MutationFunction<DuplicateCalendarBranchMutation, DuplicateCalendarBranchMutationVariables>;

/**
 * __useDuplicateCalendarBranchMutation__
 *
 * To run a mutation, you first call `useDuplicateCalendarBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateCalendarBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateCalendarBranchMutation, { data, loading, error }] = useDuplicateCalendarBranchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateCalendarBranchMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateCalendarBranchMutation, DuplicateCalendarBranchMutationVariables>) {
        return Apollo.useMutation<DuplicateCalendarBranchMutation, DuplicateCalendarBranchMutationVariables>(DuplicateCalendarBranchDocument, baseOptions);
      }
export type DuplicateCalendarBranchMutationHookResult = ReturnType<typeof useDuplicateCalendarBranchMutation>;
export type DuplicateCalendarBranchMutationResult = Apollo.MutationResult<DuplicateCalendarBranchMutation>;
export type DuplicateCalendarBranchMutationOptions = Apollo.BaseMutationOptions<DuplicateCalendarBranchMutation, DuplicateCalendarBranchMutationVariables>;
export const UpdateCalendarBranchTaskDocument = gql`
    mutation updateCalendarBranchTask($input: UpdateCalendarBranchTaskInput!, $dateRange: DateRangeInput) {
  updateCalendarBranchTask(input: $input) {
    ...CalendarBranchFields
  }
}
    ${CalendarBranchFieldsFragmentDoc}`;
export type UpdateCalendarBranchTaskMutationFn = Apollo.MutationFunction<UpdateCalendarBranchTaskMutation, UpdateCalendarBranchTaskMutationVariables>;

/**
 * __useUpdateCalendarBranchTaskMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarBranchTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarBranchTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarBranchTaskMutation, { data, loading, error }] = useUpdateCalendarBranchTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useUpdateCalendarBranchTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarBranchTaskMutation, UpdateCalendarBranchTaskMutationVariables>) {
        return Apollo.useMutation<UpdateCalendarBranchTaskMutation, UpdateCalendarBranchTaskMutationVariables>(UpdateCalendarBranchTaskDocument, baseOptions);
      }
export type UpdateCalendarBranchTaskMutationHookResult = ReturnType<typeof useUpdateCalendarBranchTaskMutation>;
export type UpdateCalendarBranchTaskMutationResult = Apollo.MutationResult<UpdateCalendarBranchTaskMutation>;
export type UpdateCalendarBranchTaskMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarBranchTaskMutation, UpdateCalendarBranchTaskMutationVariables>;
export const UpdateCalendarBranchStageDocument = gql`
    mutation updateCalendarBranchStage($input: UpdateCalendarBranchStageInput!, $dateRange: DateRangeInput) {
  updateCalendarBranchStage(input: $input) {
    ...CalendarBranchFields
  }
}
    ${CalendarBranchFieldsFragmentDoc}`;
export type UpdateCalendarBranchStageMutationFn = Apollo.MutationFunction<UpdateCalendarBranchStageMutation, UpdateCalendarBranchStageMutationVariables>;

/**
 * __useUpdateCalendarBranchStageMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarBranchStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarBranchStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarBranchStageMutation, { data, loading, error }] = useUpdateCalendarBranchStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useUpdateCalendarBranchStageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarBranchStageMutation, UpdateCalendarBranchStageMutationVariables>) {
        return Apollo.useMutation<UpdateCalendarBranchStageMutation, UpdateCalendarBranchStageMutationVariables>(UpdateCalendarBranchStageDocument, baseOptions);
      }
export type UpdateCalendarBranchStageMutationHookResult = ReturnType<typeof useUpdateCalendarBranchStageMutation>;
export type UpdateCalendarBranchStageMutationResult = Apollo.MutationResult<UpdateCalendarBranchStageMutation>;
export type UpdateCalendarBranchStageMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarBranchStageMutation, UpdateCalendarBranchStageMutationVariables>;
export const UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupDocument = gql`
    mutation updateCalendarBranchStageAndFollowingEventsInHarvestGroup($input: UpdateCalendarBranchStageInput!) {
  updateCalendarBranchStageAndFollowingEventsInHarvestGroup(input: $input) {
    ...ShortCalendarBranchFields
  }
}
    ${ShortCalendarBranchFieldsFragmentDoc}`;
export type UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutationFn = Apollo.MutationFunction<UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutation, UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutationVariables>;

/**
 * __useUpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarBranchStageAndFollowingEventsInHarvestGroupMutation, { data, loading, error }] = useUpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutation, UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutationVariables>) {
        return Apollo.useMutation<UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutation, UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutationVariables>(UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupDocument, baseOptions);
      }
export type UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutationHookResult = ReturnType<typeof useUpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutation>;
export type UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutationResult = Apollo.MutationResult<UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutation>;
export type UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutation, UpdateCalendarBranchStageAndFollowingEventsInHarvestGroupMutationVariables>;
export const UndoBranchCalendarTaskUpdateDocument = gql`
    mutation undoBranchCalendarTaskUpdate($input: UndoBranchCalendarTaskUpdateInput!, $dateRange: DateRangeInput) {
  undoBranchCalendarTaskUpdate(input: $input) {
    ...CalendarBranchFields
  }
}
    ${CalendarBranchFieldsFragmentDoc}`;
export type UndoBranchCalendarTaskUpdateMutationFn = Apollo.MutationFunction<UndoBranchCalendarTaskUpdateMutation, UndoBranchCalendarTaskUpdateMutationVariables>;

/**
 * __useUndoBranchCalendarTaskUpdateMutation__
 *
 * To run a mutation, you first call `useUndoBranchCalendarTaskUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoBranchCalendarTaskUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoBranchCalendarTaskUpdateMutation, { data, loading, error }] = useUndoBranchCalendarTaskUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useUndoBranchCalendarTaskUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UndoBranchCalendarTaskUpdateMutation, UndoBranchCalendarTaskUpdateMutationVariables>) {
        return Apollo.useMutation<UndoBranchCalendarTaskUpdateMutation, UndoBranchCalendarTaskUpdateMutationVariables>(UndoBranchCalendarTaskUpdateDocument, baseOptions);
      }
export type UndoBranchCalendarTaskUpdateMutationHookResult = ReturnType<typeof useUndoBranchCalendarTaskUpdateMutation>;
export type UndoBranchCalendarTaskUpdateMutationResult = Apollo.MutationResult<UndoBranchCalendarTaskUpdateMutation>;
export type UndoBranchCalendarTaskUpdateMutationOptions = Apollo.BaseMutationOptions<UndoBranchCalendarTaskUpdateMutation, UndoBranchCalendarTaskUpdateMutationVariables>;
export const UndoBranchCalendarStageUpdateDocument = gql`
    mutation undoBranchCalendarStageUpdate($input: UndoBranchCalendarStageUpdateInput!, $dateRange: DateRangeInput) {
  undoBranchCalendarStageUpdate(input: $input) {
    ...CalendarBranchFields
  }
}
    ${CalendarBranchFieldsFragmentDoc}`;
export type UndoBranchCalendarStageUpdateMutationFn = Apollo.MutationFunction<UndoBranchCalendarStageUpdateMutation, UndoBranchCalendarStageUpdateMutationVariables>;

/**
 * __useUndoBranchCalendarStageUpdateMutation__
 *
 * To run a mutation, you first call `useUndoBranchCalendarStageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoBranchCalendarStageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoBranchCalendarStageUpdateMutation, { data, loading, error }] = useUndoBranchCalendarStageUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useUndoBranchCalendarStageUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UndoBranchCalendarStageUpdateMutation, UndoBranchCalendarStageUpdateMutationVariables>) {
        return Apollo.useMutation<UndoBranchCalendarStageUpdateMutation, UndoBranchCalendarStageUpdateMutationVariables>(UndoBranchCalendarStageUpdateDocument, baseOptions);
      }
export type UndoBranchCalendarStageUpdateMutationHookResult = ReturnType<typeof useUndoBranchCalendarStageUpdateMutation>;
export type UndoBranchCalendarStageUpdateMutationResult = Apollo.MutationResult<UndoBranchCalendarStageUpdateMutation>;
export type UndoBranchCalendarStageUpdateMutationOptions = Apollo.BaseMutationOptions<UndoBranchCalendarStageUpdateMutation, UndoBranchCalendarStageUpdateMutationVariables>;
export const UpdateStageConflictDocument = gql`
    mutation updateStageConflict($input: UpdateStageConflictInput!) {
  updateStageConflict(input: $input) {
    ... on Error {
      message
    }
    ... on CalendarBranch {
      id
      name
      status
      updatedAt
      createdBy {
        id
      }
    }
  }
}
    `;
export type UpdateStageConflictMutationFn = Apollo.MutationFunction<UpdateStageConflictMutation, UpdateStageConflictMutationVariables>;

/**
 * __useUpdateStageConflictMutation__
 *
 * To run a mutation, you first call `useUpdateStageConflictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStageConflictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStageConflictMutation, { data, loading, error }] = useUpdateStageConflictMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStageConflictMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStageConflictMutation, UpdateStageConflictMutationVariables>) {
        return Apollo.useMutation<UpdateStageConflictMutation, UpdateStageConflictMutationVariables>(UpdateStageConflictDocument, baseOptions);
      }
export type UpdateStageConflictMutationHookResult = ReturnType<typeof useUpdateStageConflictMutation>;
export type UpdateStageConflictMutationResult = Apollo.MutationResult<UpdateStageConflictMutation>;
export type UpdateStageConflictMutationOptions = Apollo.BaseMutationOptions<UpdateStageConflictMutation, UpdateStageConflictMutationVariables>;
export const UpdateTaskConflictDocument = gql`
    mutation updateTaskConflict($input: UpdateTaskConflictInput!) {
  updateTaskConflict(input: $input) {
    ... on Error {
      message
    }
    ... on CalendarBranch {
      id
      name
      status
      updatedAt
      createdBy {
        id
      }
    }
  }
}
    `;
export type UpdateTaskConflictMutationFn = Apollo.MutationFunction<UpdateTaskConflictMutation, UpdateTaskConflictMutationVariables>;

/**
 * __useUpdateTaskConflictMutation__
 *
 * To run a mutation, you first call `useUpdateTaskConflictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskConflictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskConflictMutation, { data, loading, error }] = useUpdateTaskConflictMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskConflictMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskConflictMutation, UpdateTaskConflictMutationVariables>) {
        return Apollo.useMutation<UpdateTaskConflictMutation, UpdateTaskConflictMutationVariables>(UpdateTaskConflictDocument, baseOptions);
      }
export type UpdateTaskConflictMutationHookResult = ReturnType<typeof useUpdateTaskConflictMutation>;
export type UpdateTaskConflictMutationResult = Apollo.MutationResult<UpdateTaskConflictMutation>;
export type UpdateTaskConflictMutationOptions = Apollo.BaseMutationOptions<UpdateTaskConflictMutation, UpdateTaskConflictMutationVariables>;
export const ApproveCalendarBranchDocument = gql`
    mutation approveCalendarBranch($id: ID!) {
  approveCalendarBranch(id: $id) {
    ...CalendarBranchesGeneralInfoFields
  }
}
    ${CalendarBranchesGeneralInfoFieldsFragmentDoc}`;
export type ApproveCalendarBranchMutationFn = Apollo.MutationFunction<ApproveCalendarBranchMutation, ApproveCalendarBranchMutationVariables>;

/**
 * __useApproveCalendarBranchMutation__
 *
 * To run a mutation, you first call `useApproveCalendarBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCalendarBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCalendarBranchMutation, { data, loading, error }] = useApproveCalendarBranchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveCalendarBranchMutation(baseOptions?: Apollo.MutationHookOptions<ApproveCalendarBranchMutation, ApproveCalendarBranchMutationVariables>) {
        return Apollo.useMutation<ApproveCalendarBranchMutation, ApproveCalendarBranchMutationVariables>(ApproveCalendarBranchDocument, baseOptions);
      }
export type ApproveCalendarBranchMutationHookResult = ReturnType<typeof useApproveCalendarBranchMutation>;
export type ApproveCalendarBranchMutationResult = Apollo.MutationResult<ApproveCalendarBranchMutation>;
export type ApproveCalendarBranchMutationOptions = Apollo.BaseMutationOptions<ApproveCalendarBranchMutation, ApproveCalendarBranchMutationVariables>;
export const DeleteCalendarBranchDocument = gql`
    mutation deleteCalendarBranch($id: ID!) {
  deleteCalendarBranch(id: $id) {
    ... on Error {
      message
    }
    ... on SuccessOK {
      ok
    }
  }
}
    `;
export type DeleteCalendarBranchMutationFn = Apollo.MutationFunction<DeleteCalendarBranchMutation, DeleteCalendarBranchMutationVariables>;

/**
 * __useDeleteCalendarBranchMutation__
 *
 * To run a mutation, you first call `useDeleteCalendarBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalendarBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCalendarBranchMutation, { data, loading, error }] = useDeleteCalendarBranchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCalendarBranchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCalendarBranchMutation, DeleteCalendarBranchMutationVariables>) {
        return Apollo.useMutation<DeleteCalendarBranchMutation, DeleteCalendarBranchMutationVariables>(DeleteCalendarBranchDocument, baseOptions);
      }
export type DeleteCalendarBranchMutationHookResult = ReturnType<typeof useDeleteCalendarBranchMutation>;
export type DeleteCalendarBranchMutationResult = Apollo.MutationResult<DeleteCalendarBranchMutation>;
export type DeleteCalendarBranchMutationOptions = Apollo.BaseMutationOptions<DeleteCalendarBranchMutation, DeleteCalendarBranchMutationVariables>;
export const StrainPerformanceDocument = gql`
    query strainPerformance($strainId1: String!, $strainId2: String!, $strainId3: String!, $strainId4: String!) {
  strainPerformance(
    strainId1: $strainId1
    strainId2: $strainId2
    strainId3: $strainId3
    strainId4: $strainId4
  ) {
    strain1 {
      id
      name
    }
    strainPerformance1 {
      id
      name
      avgGramsPerPlant
      harvests {
        finalPlantCount
        gramsPerPlant
        harvestDate
        id
        name
        totalGrams
        effectiveTotalGrams
        totalFlowerGrams
        byFormFactor {
          budFormFactorId
          numberOfGrams
        }
      }
    }
    strain2 {
      id
      name
    }
    strainPerformance2 {
      id
      name
      avgGramsPerPlant
      harvests {
        finalPlantCount
        gramsPerPlant
        harvestDate
        id
        name
        totalGrams
        effectiveTotalGrams
        totalFlowerGrams
        byFormFactor {
          budFormFactorId
          numberOfGrams
        }
      }
    }
    strain3 {
      id
      name
    }
    strainPerformance3 {
      id
      name
      avgGramsPerPlant
      harvests {
        finalPlantCount
        gramsPerPlant
        harvestDate
        id
        name
        totalGrams
        effectiveTotalGrams
        totalFlowerGrams
        byFormFactor {
          budFormFactorId
          numberOfGrams
        }
      }
    }
    strain4 {
      id
      name
    }
    strainPerformance4 {
      id
      name
      avgGramsPerPlant
      harvests {
        finalPlantCount
        gramsPerPlant
        harvestDate
        id
        name
        totalGrams
        effectiveTotalGrams
        totalFlowerGrams
        byFormFactor {
          budFormFactorId
          numberOfGrams
        }
      }
    }
    allStrains {
      id
      name
    }
    allBudFormFactors {
      ...BudFormFactorFields
    }
  }
}
    ${BudFormFactorFieldsFragmentDoc}`;

/**
 * __useStrainPerformanceQuery__
 *
 * To run a query within a React component, call `useStrainPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useStrainPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStrainPerformanceQuery({
 *   variables: {
 *      strainId1: // value for 'strainId1'
 *      strainId2: // value for 'strainId2'
 *      strainId3: // value for 'strainId3'
 *      strainId4: // value for 'strainId4'
 *   },
 * });
 */
export function useStrainPerformanceQuery(baseOptions?: Apollo.QueryHookOptions<StrainPerformanceQuery, StrainPerformanceQueryVariables>) {
        return Apollo.useQuery<StrainPerformanceQuery, StrainPerformanceQueryVariables>(StrainPerformanceDocument, baseOptions);
      }
export function useStrainPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StrainPerformanceQuery, StrainPerformanceQueryVariables>) {
          return Apollo.useLazyQuery<StrainPerformanceQuery, StrainPerformanceQueryVariables>(StrainPerformanceDocument, baseOptions);
        }
export type StrainPerformanceQueryHookResult = ReturnType<typeof useStrainPerformanceQuery>;
export type StrainPerformanceLazyQueryHookResult = ReturnType<typeof useStrainPerformanceLazyQuery>;
export type StrainPerformanceQueryResult = Apollo.QueryResult<StrainPerformanceQuery, StrainPerformanceQueryVariables>;
export const BestYieldingStrainsDocument = gql`
    query bestYieldingStrains($limit: Int, $minHarvests: Int, $sortBy: String, $startDate: Date, $endDate: Date, $siteId: String, $productStream: YieldProductStream) {
  bestYieldingStrains(
    limit: $limit
    minHarvests: $minHarvests
    sortBy: $sortBy
    startDate: $startDate
    endDate: $endDate
    siteId: $siteId
    productStream: $productStream
  ) {
    productStream
    excludedBatches {
      id
      name
      issues
    }
    reconciliationBatches {
      id
      name
      reconciliationGapGrams
    }
    strains {
      strain {
        id
        name
      }
      totalHarvests
      totalPlants
      totalGrams
      totalFlowerGrams
      avgGramsPerPlant
      avgFlowerGramsPerPlant
      harvests {
        id
        name
        harvestDate
        totalGrams
        totalFlowerGrams
        finalPlantCount
        gramsPerPlant
        byFormFactor {
          budFormFactorId
          numberOfGrams
        }
      }
    }
    allBudFormFactors {
      ...BudFormFactorFields
    }
  }
}
    ${BudFormFactorFieldsFragmentDoc}`;

/**
 * __useBestYieldingStrainsQuery__
 *
 * To run a query within a React component, call `useBestYieldingStrainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBestYieldingStrainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBestYieldingStrainsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      minHarvests: // value for 'minHarvests'
 *      sortBy: // value for 'sortBy'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      siteId: // value for 'siteId'
 *      productStream: // value for 'productStream'
 *   },
 * });
 */
export function useBestYieldingStrainsQuery(baseOptions?: Apollo.QueryHookOptions<BestYieldingStrainsQuery, BestYieldingStrainsQueryVariables>) {
        return Apollo.useQuery<BestYieldingStrainsQuery, BestYieldingStrainsQueryVariables>(BestYieldingStrainsDocument, baseOptions);
      }
export function useBestYieldingStrainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BestYieldingStrainsQuery, BestYieldingStrainsQueryVariables>) {
          return Apollo.useLazyQuery<BestYieldingStrainsQuery, BestYieldingStrainsQueryVariables>(BestYieldingStrainsDocument, baseOptions);
        }
export type BestYieldingStrainsQueryHookResult = ReturnType<typeof useBestYieldingStrainsQuery>;
export type BestYieldingStrainsLazyQueryHookResult = ReturnType<typeof useBestYieldingStrainsLazyQuery>;
export type BestYieldingStrainsQueryResult = Apollo.QueryResult<BestYieldingStrainsQuery, BestYieldingStrainsQueryVariables>;
export const HarvestAnalyticsDocument = gql`
    query harvestAnalytics($unarchived: String, $siteId: String) {
  harvestGroups(
    filters: {unarchived: $unarchived, completed: "true", siteId: $siteId}
  ) {
    id
    name
    startDate
    harvestDate
    archivedAt
    flowerZone {
      id
      name
    }
    yields {
      yieldBatches {
        ...YieldAnalysisBatch
      }
      id
      totalGrams
      finalPlantCount
      strain {
        id
        name
      }
      budFormFactorYields {
        numberOfGrams
        budFormFactor {
          id
          name
        }
      }
    }
  }
}
    ${YieldAnalysisBatchFragmentDoc}`;

/**
 * __useHarvestAnalyticsQuery__
 *
 * To run a query within a React component, call `useHarvestAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestAnalyticsQuery({
 *   variables: {
 *      unarchived: // value for 'unarchived'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useHarvestAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<HarvestAnalyticsQuery, HarvestAnalyticsQueryVariables>) {
        return Apollo.useQuery<HarvestAnalyticsQuery, HarvestAnalyticsQueryVariables>(HarvestAnalyticsDocument, baseOptions);
      }
export function useHarvestAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestAnalyticsQuery, HarvestAnalyticsQueryVariables>) {
          return Apollo.useLazyQuery<HarvestAnalyticsQuery, HarvestAnalyticsQueryVariables>(HarvestAnalyticsDocument, baseOptions);
        }
export type HarvestAnalyticsQueryHookResult = ReturnType<typeof useHarvestAnalyticsQuery>;
export type HarvestAnalyticsLazyQueryHookResult = ReturnType<typeof useHarvestAnalyticsLazyQuery>;
export type HarvestAnalyticsQueryResult = Apollo.QueryResult<HarvestAnalyticsQuery, HarvestAnalyticsQueryVariables>;
export const TelemetryRoomsDocument = gql`
    query TelemetryRooms($siteId: ID, $organizationId: ID) {
  telemetryRooms(siteId: $siteId, organizationId: $organizationId) {
    id
    name
    site {
      id
      name
    }
  }
}
    `;

/**
 * __useTelemetryRoomsQuery__
 *
 * To run a query within a React component, call `useTelemetryRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTelemetryRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTelemetryRoomsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useTelemetryRoomsQuery(baseOptions?: Apollo.QueryHookOptions<TelemetryRoomsQuery, TelemetryRoomsQueryVariables>) {
        return Apollo.useQuery<TelemetryRoomsQuery, TelemetryRoomsQueryVariables>(TelemetryRoomsDocument, baseOptions);
      }
export function useTelemetryRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TelemetryRoomsQuery, TelemetryRoomsQueryVariables>) {
          return Apollo.useLazyQuery<TelemetryRoomsQuery, TelemetryRoomsQueryVariables>(TelemetryRoomsDocument, baseOptions);
        }
export type TelemetryRoomsQueryHookResult = ReturnType<typeof useTelemetryRoomsQuery>;
export type TelemetryRoomsLazyQueryHookResult = ReturnType<typeof useTelemetryRoomsLazyQuery>;
export type TelemetryRoomsQueryResult = Apollo.QueryResult<TelemetryRoomsQuery, TelemetryRoomsQueryVariables>;
export const RoomTelemetryDocument = gql`
    query RoomTelemetry($zoneId: ID!, $startDate: Date!, $endDate: Date!, $organizationId: ID, $siteId: ID) {
  roomTelemetry(
    zoneId: $zoneId
    startDate: $startDate
    endDate: $endDate
    organizationId: $organizationId
    siteId: $siteId
  ) {
    zoneId
    roomName
    timezone
    startDate
    endDate
    expectedBins
    nightPeriods {
      start
      end
    }
    sources {
      id
      name
      primary
      active
      category
      latestObservation
      metrics {
        key
        label
        unit
        category
        observedBins
        expectedBins
        minimum
        maximum
        mean
        dayMean
        nightMean
        constant
        quality {
          ...SensorMetricQualityFields
        }
        points {
          time
          value
        }
      }
    }
  }
}
    ${SensorMetricQualityFieldsFragmentDoc}`;

/**
 * __useRoomTelemetryQuery__
 *
 * To run a query within a React component, call `useRoomTelemetryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomTelemetryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomTelemetryQuery({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      organizationId: // value for 'organizationId'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useRoomTelemetryQuery(baseOptions?: Apollo.QueryHookOptions<RoomTelemetryQuery, RoomTelemetryQueryVariables>) {
        return Apollo.useQuery<RoomTelemetryQuery, RoomTelemetryQueryVariables>(RoomTelemetryDocument, baseOptions);
      }
export function useRoomTelemetryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomTelemetryQuery, RoomTelemetryQueryVariables>) {
          return Apollo.useLazyQuery<RoomTelemetryQuery, RoomTelemetryQueryVariables>(RoomTelemetryDocument, baseOptions);
        }
export type RoomTelemetryQueryHookResult = ReturnType<typeof useRoomTelemetryQuery>;
export type RoomTelemetryLazyQueryHookResult = ReturnType<typeof useRoomTelemetryLazyQuery>;
export type RoomTelemetryQueryResult = Apollo.QueryResult<RoomTelemetryQuery, RoomTelemetryQueryVariables>;
export const HarvestGroupAutoCreationConfigsDocument = gql`
    query harvestGroupAutoCreationConfigs($siteId: String) {
  harvestGroupAutoCreationConfigs(siteId: $siteId) {
    ...HarvestGroupAutoCreationConfigFields
  }
}
    ${HarvestGroupAutoCreationConfigFieldsFragmentDoc}`;

/**
 * __useHarvestGroupAutoCreationConfigsQuery__
 *
 * To run a query within a React component, call `useHarvestGroupAutoCreationConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestGroupAutoCreationConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestGroupAutoCreationConfigsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useHarvestGroupAutoCreationConfigsQuery(baseOptions?: Apollo.QueryHookOptions<HarvestGroupAutoCreationConfigsQuery, HarvestGroupAutoCreationConfigsQueryVariables>) {
        return Apollo.useQuery<HarvestGroupAutoCreationConfigsQuery, HarvestGroupAutoCreationConfigsQueryVariables>(HarvestGroupAutoCreationConfigsDocument, baseOptions);
      }
export function useHarvestGroupAutoCreationConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestGroupAutoCreationConfigsQuery, HarvestGroupAutoCreationConfigsQueryVariables>) {
          return Apollo.useLazyQuery<HarvestGroupAutoCreationConfigsQuery, HarvestGroupAutoCreationConfigsQueryVariables>(HarvestGroupAutoCreationConfigsDocument, baseOptions);
        }
export type HarvestGroupAutoCreationConfigsQueryHookResult = ReturnType<typeof useHarvestGroupAutoCreationConfigsQuery>;
export type HarvestGroupAutoCreationConfigsLazyQueryHookResult = ReturnType<typeof useHarvestGroupAutoCreationConfigsLazyQuery>;
export type HarvestGroupAutoCreationConfigsQueryResult = Apollo.QueryResult<HarvestGroupAutoCreationConfigsQuery, HarvestGroupAutoCreationConfigsQueryVariables>;
export const HarvestGroupAutoCreationConfigDocument = gql`
    query harvestGroupAutoCreationConfig($siteId: String!) {
  harvestGroupAutoCreationConfig(siteId: $siteId) {
    ...HarvestGroupAutoCreationConfigFields
  }
}
    ${HarvestGroupAutoCreationConfigFieldsFragmentDoc}`;

/**
 * __useHarvestGroupAutoCreationConfigQuery__
 *
 * To run a query within a React component, call `useHarvestGroupAutoCreationConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestGroupAutoCreationConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestGroupAutoCreationConfigQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useHarvestGroupAutoCreationConfigQuery(baseOptions?: Apollo.QueryHookOptions<HarvestGroupAutoCreationConfigQuery, HarvestGroupAutoCreationConfigQueryVariables>) {
        return Apollo.useQuery<HarvestGroupAutoCreationConfigQuery, HarvestGroupAutoCreationConfigQueryVariables>(HarvestGroupAutoCreationConfigDocument, baseOptions);
      }
export function useHarvestGroupAutoCreationConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestGroupAutoCreationConfigQuery, HarvestGroupAutoCreationConfigQueryVariables>) {
          return Apollo.useLazyQuery<HarvestGroupAutoCreationConfigQuery, HarvestGroupAutoCreationConfigQueryVariables>(HarvestGroupAutoCreationConfigDocument, baseOptions);
        }
export type HarvestGroupAutoCreationConfigQueryHookResult = ReturnType<typeof useHarvestGroupAutoCreationConfigQuery>;
export type HarvestGroupAutoCreationConfigLazyQueryHookResult = ReturnType<typeof useHarvestGroupAutoCreationConfigLazyQuery>;
export type HarvestGroupAutoCreationConfigQueryResult = Apollo.QueryResult<HarvestGroupAutoCreationConfigQuery, HarvestGroupAutoCreationConfigQueryVariables>;
export const UpsertHarvestGroupAutoCreationConfigDocument = gql`
    mutation upsertHarvestGroupAutoCreationConfig($input: UpsertHarvestGroupAutoCreationConfigInput!) {
  upsertHarvestGroupAutoCreationConfig(input: $input) {
    ... on HarvestGroupAutoCreationConfig {
      ...HarvestGroupAutoCreationConfigFields
    }
    ... on Error {
      message
    }
  }
}
    ${HarvestGroupAutoCreationConfigFieldsFragmentDoc}`;
export type UpsertHarvestGroupAutoCreationConfigMutationFn = Apollo.MutationFunction<UpsertHarvestGroupAutoCreationConfigMutation, UpsertHarvestGroupAutoCreationConfigMutationVariables>;

/**
 * __useUpsertHarvestGroupAutoCreationConfigMutation__
 *
 * To run a mutation, you first call `useUpsertHarvestGroupAutoCreationConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertHarvestGroupAutoCreationConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertHarvestGroupAutoCreationConfigMutation, { data, loading, error }] = useUpsertHarvestGroupAutoCreationConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertHarvestGroupAutoCreationConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpsertHarvestGroupAutoCreationConfigMutation, UpsertHarvestGroupAutoCreationConfigMutationVariables>) {
        return Apollo.useMutation<UpsertHarvestGroupAutoCreationConfigMutation, UpsertHarvestGroupAutoCreationConfigMutationVariables>(UpsertHarvestGroupAutoCreationConfigDocument, baseOptions);
      }
export type UpsertHarvestGroupAutoCreationConfigMutationHookResult = ReturnType<typeof useUpsertHarvestGroupAutoCreationConfigMutation>;
export type UpsertHarvestGroupAutoCreationConfigMutationResult = Apollo.MutationResult<UpsertHarvestGroupAutoCreationConfigMutation>;
export type UpsertHarvestGroupAutoCreationConfigMutationOptions = Apollo.BaseMutationOptions<UpsertHarvestGroupAutoCreationConfigMutation, UpsertHarvestGroupAutoCreationConfigMutationVariables>;
export const ToggleHarvestGroupAutoCreationConfigDocument = gql`
    mutation toggleHarvestGroupAutoCreationConfig($siteId: ID!, $isEnabled: Boolean!) {
  toggleHarvestGroupAutoCreationConfig(siteId: $siteId, isEnabled: $isEnabled) {
    ... on HarvestGroupAutoCreationConfig {
      ...HarvestGroupAutoCreationConfigFields
    }
    ... on Error {
      message
    }
  }
}
    ${HarvestGroupAutoCreationConfigFieldsFragmentDoc}`;
export type ToggleHarvestGroupAutoCreationConfigMutationFn = Apollo.MutationFunction<ToggleHarvestGroupAutoCreationConfigMutation, ToggleHarvestGroupAutoCreationConfigMutationVariables>;

/**
 * __useToggleHarvestGroupAutoCreationConfigMutation__
 *
 * To run a mutation, you first call `useToggleHarvestGroupAutoCreationConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleHarvestGroupAutoCreationConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleHarvestGroupAutoCreationConfigMutation, { data, loading, error }] = useToggleHarvestGroupAutoCreationConfigMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      isEnabled: // value for 'isEnabled'
 *   },
 * });
 */
export function useToggleHarvestGroupAutoCreationConfigMutation(baseOptions?: Apollo.MutationHookOptions<ToggleHarvestGroupAutoCreationConfigMutation, ToggleHarvestGroupAutoCreationConfigMutationVariables>) {
        return Apollo.useMutation<ToggleHarvestGroupAutoCreationConfigMutation, ToggleHarvestGroupAutoCreationConfigMutationVariables>(ToggleHarvestGroupAutoCreationConfigDocument, baseOptions);
      }
export type ToggleHarvestGroupAutoCreationConfigMutationHookResult = ReturnType<typeof useToggleHarvestGroupAutoCreationConfigMutation>;
export type ToggleHarvestGroupAutoCreationConfigMutationResult = Apollo.MutationResult<ToggleHarvestGroupAutoCreationConfigMutation>;
export type ToggleHarvestGroupAutoCreationConfigMutationOptions = Apollo.BaseMutationOptions<ToggleHarvestGroupAutoCreationConfigMutation, ToggleHarvestGroupAutoCreationConfigMutationVariables>;
export const BudFormFactorsDocument = gql`
    query budFormFactors($filters: BudFormFactorFilterSetInput) {
  budFormFactors(filters: $filters) {
    ...BudFormFactorFields
  }
}
    ${BudFormFactorFieldsFragmentDoc}`;

/**
 * __useBudFormFactorsQuery__
 *
 * To run a query within a React component, call `useBudFormFactorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudFormFactorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudFormFactorsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBudFormFactorsQuery(baseOptions?: Apollo.QueryHookOptions<BudFormFactorsQuery, BudFormFactorsQueryVariables>) {
        return Apollo.useQuery<BudFormFactorsQuery, BudFormFactorsQueryVariables>(BudFormFactorsDocument, baseOptions);
      }
export function useBudFormFactorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BudFormFactorsQuery, BudFormFactorsQueryVariables>) {
          return Apollo.useLazyQuery<BudFormFactorsQuery, BudFormFactorsQueryVariables>(BudFormFactorsDocument, baseOptions);
        }
export type BudFormFactorsQueryHookResult = ReturnType<typeof useBudFormFactorsQuery>;
export type BudFormFactorsLazyQueryHookResult = ReturnType<typeof useBudFormFactorsLazyQuery>;
export type BudFormFactorsQueryResult = Apollo.QueryResult<BudFormFactorsQuery, BudFormFactorsQueryVariables>;
export const CreateBudFormFactorDocument = gql`
    mutation createBudFormFactor($input: CreateBudFormFactorInput!) {
  createBudFormFactor(input: $input) {
    ... on BudFormFactor {
      ...BudFormFactorFields
    }
    ... on Error {
      message
    }
  }
}
    ${BudFormFactorFieldsFragmentDoc}`;
export type CreateBudFormFactorMutationFn = Apollo.MutationFunction<CreateBudFormFactorMutation, CreateBudFormFactorMutationVariables>;

/**
 * __useCreateBudFormFactorMutation__
 *
 * To run a mutation, you first call `useCreateBudFormFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBudFormFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBudFormFactorMutation, { data, loading, error }] = useCreateBudFormFactorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBudFormFactorMutation(baseOptions?: Apollo.MutationHookOptions<CreateBudFormFactorMutation, CreateBudFormFactorMutationVariables>) {
        return Apollo.useMutation<CreateBudFormFactorMutation, CreateBudFormFactorMutationVariables>(CreateBudFormFactorDocument, baseOptions);
      }
export type CreateBudFormFactorMutationHookResult = ReturnType<typeof useCreateBudFormFactorMutation>;
export type CreateBudFormFactorMutationResult = Apollo.MutationResult<CreateBudFormFactorMutation>;
export type CreateBudFormFactorMutationOptions = Apollo.BaseMutationOptions<CreateBudFormFactorMutation, CreateBudFormFactorMutationVariables>;
export const UpdateBudFormFactorDocument = gql`
    mutation updateBudFormFactor($input: UpdateBudFormFactorInput!) {
  updateBudFormFactor(input: $input) {
    ... on BudFormFactor {
      ...BudFormFactorFields
    }
    ... on Error {
      message
    }
  }
}
    ${BudFormFactorFieldsFragmentDoc}`;
export type UpdateBudFormFactorMutationFn = Apollo.MutationFunction<UpdateBudFormFactorMutation, UpdateBudFormFactorMutationVariables>;

/**
 * __useUpdateBudFormFactorMutation__
 *
 * To run a mutation, you first call `useUpdateBudFormFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBudFormFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBudFormFactorMutation, { data, loading, error }] = useUpdateBudFormFactorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBudFormFactorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBudFormFactorMutation, UpdateBudFormFactorMutationVariables>) {
        return Apollo.useMutation<UpdateBudFormFactorMutation, UpdateBudFormFactorMutationVariables>(UpdateBudFormFactorDocument, baseOptions);
      }
export type UpdateBudFormFactorMutationHookResult = ReturnType<typeof useUpdateBudFormFactorMutation>;
export type UpdateBudFormFactorMutationResult = Apollo.MutationResult<UpdateBudFormFactorMutation>;
export type UpdateBudFormFactorMutationOptions = Apollo.BaseMutationOptions<UpdateBudFormFactorMutation, UpdateBudFormFactorMutationVariables>;
export const ReorderBudFormFactorsDocument = gql`
    mutation reorderBudFormFactors($input: ReorderBudFormFactorsInput!) {
  reorderBudFormFactors(input: $input) {
    ... on BudFormFactor {
      ...BudFormFactorFields
    }
    ... on Error {
      message
    }
  }
}
    ${BudFormFactorFieldsFragmentDoc}`;
export type ReorderBudFormFactorsMutationFn = Apollo.MutationFunction<ReorderBudFormFactorsMutation, ReorderBudFormFactorsMutationVariables>;

/**
 * __useReorderBudFormFactorsMutation__
 *
 * To run a mutation, you first call `useReorderBudFormFactorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderBudFormFactorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderBudFormFactorsMutation, { data, loading, error }] = useReorderBudFormFactorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderBudFormFactorsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderBudFormFactorsMutation, ReorderBudFormFactorsMutationVariables>) {
        return Apollo.useMutation<ReorderBudFormFactorsMutation, ReorderBudFormFactorsMutationVariables>(ReorderBudFormFactorsDocument, baseOptions);
      }
export type ReorderBudFormFactorsMutationHookResult = ReturnType<typeof useReorderBudFormFactorsMutation>;
export type ReorderBudFormFactorsMutationResult = Apollo.MutationResult<ReorderBudFormFactorsMutation>;
export type ReorderBudFormFactorsMutationOptions = Apollo.BaseMutationOptions<ReorderBudFormFactorsMutation, ReorderBudFormFactorsMutationVariables>;
export const ActivateBudFormFactorDocument = gql`
    mutation activateBudFormFactor($id: ID!) {
  updateBudFormFactor(input: {active: true, id: $id}) {
    ... on BudFormFactor {
      ...BudFormFactorFields
    }
    ... on Error {
      message
    }
  }
}
    ${BudFormFactorFieldsFragmentDoc}`;
export type ActivateBudFormFactorMutationFn = Apollo.MutationFunction<ActivateBudFormFactorMutation, ActivateBudFormFactorMutationVariables>;

/**
 * __useActivateBudFormFactorMutation__
 *
 * To run a mutation, you first call `useActivateBudFormFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateBudFormFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateBudFormFactorMutation, { data, loading, error }] = useActivateBudFormFactorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateBudFormFactorMutation(baseOptions?: Apollo.MutationHookOptions<ActivateBudFormFactorMutation, ActivateBudFormFactorMutationVariables>) {
        return Apollo.useMutation<ActivateBudFormFactorMutation, ActivateBudFormFactorMutationVariables>(ActivateBudFormFactorDocument, baseOptions);
      }
export type ActivateBudFormFactorMutationHookResult = ReturnType<typeof useActivateBudFormFactorMutation>;
export type ActivateBudFormFactorMutationResult = Apollo.MutationResult<ActivateBudFormFactorMutation>;
export type ActivateBudFormFactorMutationOptions = Apollo.BaseMutationOptions<ActivateBudFormFactorMutation, ActivateBudFormFactorMutationVariables>;
export const DeactivateBudFormFactorDocument = gql`
    mutation deactivateBudFormFactor($id: ID!) {
  updateBudFormFactor(input: {active: false, id: $id}) {
    ... on BudFormFactor {
      ...BudFormFactorFields
    }
    ... on Error {
      message
    }
  }
}
    ${BudFormFactorFieldsFragmentDoc}`;
export type DeactivateBudFormFactorMutationFn = Apollo.MutationFunction<DeactivateBudFormFactorMutation, DeactivateBudFormFactorMutationVariables>;

/**
 * __useDeactivateBudFormFactorMutation__
 *
 * To run a mutation, you first call `useDeactivateBudFormFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateBudFormFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateBudFormFactorMutation, { data, loading, error }] = useDeactivateBudFormFactorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateBudFormFactorMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateBudFormFactorMutation, DeactivateBudFormFactorMutationVariables>) {
        return Apollo.useMutation<DeactivateBudFormFactorMutation, DeactivateBudFormFactorMutationVariables>(DeactivateBudFormFactorDocument, baseOptions);
      }
export type DeactivateBudFormFactorMutationHookResult = ReturnType<typeof useDeactivateBudFormFactorMutation>;
export type DeactivateBudFormFactorMutationResult = Apollo.MutationResult<DeactivateBudFormFactorMutation>;
export type DeactivateBudFormFactorMutationOptions = Apollo.BaseMutationOptions<DeactivateBudFormFactorMutation, DeactivateBudFormFactorMutationVariables>;
export const UploadEnvironmentalFileDocument = gql`
    mutation uploadEnvironmentalFile($input: EnvironmentalFileInput!) {
  uploadEnvironmentalFile(input: $input) {
    ... on EnvironmentalFileType {
      ...EnvironmentalFileFields
    }
    ... on Error {
      message
    }
  }
}
    ${EnvironmentalFileFieldsFragmentDoc}`;
export type UploadEnvironmentalFileMutationFn = Apollo.MutationFunction<UploadEnvironmentalFileMutation, UploadEnvironmentalFileMutationVariables>;

/**
 * __useUploadEnvironmentalFileMutation__
 *
 * To run a mutation, you first call `useUploadEnvironmentalFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEnvironmentalFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEnvironmentalFileMutation, { data, loading, error }] = useUploadEnvironmentalFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadEnvironmentalFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadEnvironmentalFileMutation, UploadEnvironmentalFileMutationVariables>) {
        return Apollo.useMutation<UploadEnvironmentalFileMutation, UploadEnvironmentalFileMutationVariables>(UploadEnvironmentalFileDocument, baseOptions);
      }
export type UploadEnvironmentalFileMutationHookResult = ReturnType<typeof useUploadEnvironmentalFileMutation>;
export type UploadEnvironmentalFileMutationResult = Apollo.MutationResult<UploadEnvironmentalFileMutation>;
export type UploadEnvironmentalFileMutationOptions = Apollo.BaseMutationOptions<UploadEnvironmentalFileMutation, UploadEnvironmentalFileMutationVariables>;
export const UpdateTimeOffsetDocument = gql`
    mutation updateTimeOffset($input: UpdateTimeOffsetInput!) {
  updateTimeOffset(input: $input) {
    ... on EnvironmentalFileType {
      ...EnvironmentalFileFields
    }
    ... on Error {
      message
    }
  }
}
    ${EnvironmentalFileFieldsFragmentDoc}`;
export type UpdateTimeOffsetMutationFn = Apollo.MutationFunction<UpdateTimeOffsetMutation, UpdateTimeOffsetMutationVariables>;

/**
 * __useUpdateTimeOffsetMutation__
 *
 * To run a mutation, you first call `useUpdateTimeOffsetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeOffsetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeOffsetMutation, { data, loading, error }] = useUpdateTimeOffsetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimeOffsetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeOffsetMutation, UpdateTimeOffsetMutationVariables>) {
        return Apollo.useMutation<UpdateTimeOffsetMutation, UpdateTimeOffsetMutationVariables>(UpdateTimeOffsetDocument, baseOptions);
      }
export type UpdateTimeOffsetMutationHookResult = ReturnType<typeof useUpdateTimeOffsetMutation>;
export type UpdateTimeOffsetMutationResult = Apollo.MutationResult<UpdateTimeOffsetMutation>;
export type UpdateTimeOffsetMutationOptions = Apollo.BaseMutationOptions<UpdateTimeOffsetMutation, UpdateTimeOffsetMutationVariables>;
export const ProcessEnvironmentalFileDocument = gql`
    mutation processEnvironmentalFile($input: ProcessEnvironmentalFileInput!) {
  processEnvironmentalFile(input: $input) {
    ... on EnvironmentalFileType {
      ...EnvironmentalFileFields
    }
    ... on Error {
      message
    }
  }
}
    ${EnvironmentalFileFieldsFragmentDoc}`;
export type ProcessEnvironmentalFileMutationFn = Apollo.MutationFunction<ProcessEnvironmentalFileMutation, ProcessEnvironmentalFileMutationVariables>;

/**
 * __useProcessEnvironmentalFileMutation__
 *
 * To run a mutation, you first call `useProcessEnvironmentalFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessEnvironmentalFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processEnvironmentalFileMutation, { data, loading, error }] = useProcessEnvironmentalFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessEnvironmentalFileMutation(baseOptions?: Apollo.MutationHookOptions<ProcessEnvironmentalFileMutation, ProcessEnvironmentalFileMutationVariables>) {
        return Apollo.useMutation<ProcessEnvironmentalFileMutation, ProcessEnvironmentalFileMutationVariables>(ProcessEnvironmentalFileDocument, baseOptions);
      }
export type ProcessEnvironmentalFileMutationHookResult = ReturnType<typeof useProcessEnvironmentalFileMutation>;
export type ProcessEnvironmentalFileMutationResult = Apollo.MutationResult<ProcessEnvironmentalFileMutation>;
export type ProcessEnvironmentalFileMutationOptions = Apollo.BaseMutationOptions<ProcessEnvironmentalFileMutation, ProcessEnvironmentalFileMutationVariables>;
export const EnvironmentalFilesDocument = gql`
    query environmentalFiles($filters: EnvironmentalFileFilterSetInput) {
  environmentalFiles(filters: $filters) {
    ...EnvironmentalFileFields
  }
}
    ${EnvironmentalFileFieldsFragmentDoc}`;

/**
 * __useEnvironmentalFilesQuery__
 *
 * To run a query within a React component, call `useEnvironmentalFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentalFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentalFilesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEnvironmentalFilesQuery(baseOptions?: Apollo.QueryHookOptions<EnvironmentalFilesQuery, EnvironmentalFilesQueryVariables>) {
        return Apollo.useQuery<EnvironmentalFilesQuery, EnvironmentalFilesQueryVariables>(EnvironmentalFilesDocument, baseOptions);
      }
export function useEnvironmentalFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentalFilesQuery, EnvironmentalFilesQueryVariables>) {
          return Apollo.useLazyQuery<EnvironmentalFilesQuery, EnvironmentalFilesQueryVariables>(EnvironmentalFilesDocument, baseOptions);
        }
export type EnvironmentalFilesQueryHookResult = ReturnType<typeof useEnvironmentalFilesQuery>;
export type EnvironmentalFilesLazyQueryHookResult = ReturnType<typeof useEnvironmentalFilesLazyQuery>;
export type EnvironmentalFilesQueryResult = Apollo.QueryResult<EnvironmentalFilesQuery, EnvironmentalFilesQueryVariables>;
export const EnvironmentalFileDocument = gql`
    query environmentalFile($id: String!) {
  environmentalFile(id: $id) {
    ...PreviewFileFields
  }
}
    ${PreviewFileFieldsFragmentDoc}`;

/**
 * __useEnvironmentalFileQuery__
 *
 * To run a query within a React component, call `useEnvironmentalFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentalFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentalFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnvironmentalFileQuery(baseOptions?: Apollo.QueryHookOptions<EnvironmentalFileQuery, EnvironmentalFileQueryVariables>) {
        return Apollo.useQuery<EnvironmentalFileQuery, EnvironmentalFileQueryVariables>(EnvironmentalFileDocument, baseOptions);
      }
export function useEnvironmentalFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentalFileQuery, EnvironmentalFileQueryVariables>) {
          return Apollo.useLazyQuery<EnvironmentalFileQuery, EnvironmentalFileQueryVariables>(EnvironmentalFileDocument, baseOptions);
        }
export type EnvironmentalFileQueryHookResult = ReturnType<typeof useEnvironmentalFileQuery>;
export type EnvironmentalFileLazyQueryHookResult = ReturnType<typeof useEnvironmentalFileLazyQuery>;
export type EnvironmentalFileQueryResult = Apollo.QueryResult<EnvironmentalFileQuery, EnvironmentalFileQueryVariables>;
export const EnvironmentalAnalyticsDocument = gql`
    query environmentalAnalytics($filters: EnvironmentalAnalyticsFilterInput) {
  environmentalAnalytics(filters: $filters) {
    temperature {
      ...AnalyticsChartData
    }
    humidity {
      ...AnalyticsChartData
    }
    co2 {
      ...AnalyticsChartData
    }
    vpd {
      ...AnalyticsChartData
    }
  }
}
    ${AnalyticsChartDataFragmentDoc}`;

/**
 * __useEnvironmentalAnalyticsQuery__
 *
 * To run a query within a React component, call `useEnvironmentalAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentalAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentalAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEnvironmentalAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<EnvironmentalAnalyticsQuery, EnvironmentalAnalyticsQueryVariables>) {
        return Apollo.useQuery<EnvironmentalAnalyticsQuery, EnvironmentalAnalyticsQueryVariables>(EnvironmentalAnalyticsDocument, baseOptions);
      }
export function useEnvironmentalAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentalAnalyticsQuery, EnvironmentalAnalyticsQueryVariables>) {
          return Apollo.useLazyQuery<EnvironmentalAnalyticsQuery, EnvironmentalAnalyticsQueryVariables>(EnvironmentalAnalyticsDocument, baseOptions);
        }
export type EnvironmentalAnalyticsQueryHookResult = ReturnType<typeof useEnvironmentalAnalyticsQuery>;
export type EnvironmentalAnalyticsLazyQueryHookResult = ReturnType<typeof useEnvironmentalAnalyticsLazyQuery>;
export type EnvironmentalAnalyticsQueryResult = Apollo.QueryResult<EnvironmentalAnalyticsQuery, EnvironmentalAnalyticsQueryVariables>;
export const EnvironmentalWeeklyDataDocument = gql`
    query environmentalWeeklyData($harvestGroupId: ID!) {
  environmentalWeeklyData(harvestGroupId: $harvestGroupId) {
    week
    stageName
    environmentalType
    temperature {
      ...WeeklyEnvironmentalMetric
    }
    humidity {
      ...WeeklyEnvironmentalMetric
    }
    co2 {
      ...WeeklyEnvironmentalMetric
    }
    vpd {
      ...WeeklyEnvironmentalMetric
    }
  }
}
    ${WeeklyEnvironmentalMetricFragmentDoc}`;

/**
 * __useEnvironmentalWeeklyDataQuery__
 *
 * To run a query within a React component, call `useEnvironmentalWeeklyDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentalWeeklyDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentalWeeklyDataQuery({
 *   variables: {
 *      harvestGroupId: // value for 'harvestGroupId'
 *   },
 * });
 */
export function useEnvironmentalWeeklyDataQuery(baseOptions?: Apollo.QueryHookOptions<EnvironmentalWeeklyDataQuery, EnvironmentalWeeklyDataQueryVariables>) {
        return Apollo.useQuery<EnvironmentalWeeklyDataQuery, EnvironmentalWeeklyDataQueryVariables>(EnvironmentalWeeklyDataDocument, baseOptions);
      }
export function useEnvironmentalWeeklyDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentalWeeklyDataQuery, EnvironmentalWeeklyDataQueryVariables>) {
          return Apollo.useLazyQuery<EnvironmentalWeeklyDataQuery, EnvironmentalWeeklyDataQueryVariables>(EnvironmentalWeeklyDataDocument, baseOptions);
        }
export type EnvironmentalWeeklyDataQueryHookResult = ReturnType<typeof useEnvironmentalWeeklyDataQuery>;
export type EnvironmentalWeeklyDataLazyQueryHookResult = ReturnType<typeof useEnvironmentalWeeklyDataLazyQuery>;
export type EnvironmentalWeeklyDataQueryResult = Apollo.QueryResult<EnvironmentalWeeklyDataQuery, EnvironmentalWeeklyDataQueryVariables>;
export const CreateGenerationRequestDocument = gql`
    mutation createGenerationRequest($analysisType: String!, $images: [GenerationRequestImageInput!]!, $textPrompt: String, $siteId: String, $organizationId: String) {
  createGenerationRequest(
    analysisType: $analysisType
    images: $images
    textPrompt: $textPrompt
    siteId: $siteId
    organizationId: $organizationId
  ) {
    ... on GenerationRequestType {
      ...GenerationRequestFields
    }
    ... on Error {
      message
    }
  }
}
    ${GenerationRequestFieldsFragmentDoc}`;
export type CreateGenerationRequestMutationFn = Apollo.MutationFunction<CreateGenerationRequestMutation, CreateGenerationRequestMutationVariables>;

/**
 * __useCreateGenerationRequestMutation__
 *
 * To run a mutation, you first call `useCreateGenerationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenerationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenerationRequestMutation, { data, loading, error }] = useCreateGenerationRequestMutation({
 *   variables: {
 *      analysisType: // value for 'analysisType'
 *      images: // value for 'images'
 *      textPrompt: // value for 'textPrompt'
 *      siteId: // value for 'siteId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCreateGenerationRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenerationRequestMutation, CreateGenerationRequestMutationVariables>) {
        return Apollo.useMutation<CreateGenerationRequestMutation, CreateGenerationRequestMutationVariables>(CreateGenerationRequestDocument, baseOptions);
      }
export type CreateGenerationRequestMutationHookResult = ReturnType<typeof useCreateGenerationRequestMutation>;
export type CreateGenerationRequestMutationResult = Apollo.MutationResult<CreateGenerationRequestMutation>;
export type CreateGenerationRequestMutationOptions = Apollo.BaseMutationOptions<CreateGenerationRequestMutation, CreateGenerationRequestMutationVariables>;
export const GenerationRequestDocument = gql`
    query generationRequest($id: String!) {
  generationRequest(id: $id) {
    ...GenerationRequestFields
  }
}
    ${GenerationRequestFieldsFragmentDoc}`;

/**
 * __useGenerationRequestQuery__
 *
 * To run a query within a React component, call `useGenerationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerationRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerationRequestQuery(baseOptions?: Apollo.QueryHookOptions<GenerationRequestQuery, GenerationRequestQueryVariables>) {
        return Apollo.useQuery<GenerationRequestQuery, GenerationRequestQueryVariables>(GenerationRequestDocument, baseOptions);
      }
export function useGenerationRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerationRequestQuery, GenerationRequestQueryVariables>) {
          return Apollo.useLazyQuery<GenerationRequestQuery, GenerationRequestQueryVariables>(GenerationRequestDocument, baseOptions);
        }
export type GenerationRequestQueryHookResult = ReturnType<typeof useGenerationRequestQuery>;
export type GenerationRequestLazyQueryHookResult = ReturnType<typeof useGenerationRequestLazyQuery>;
export type GenerationRequestQueryResult = Apollo.QueryResult<GenerationRequestQuery, GenerationRequestQueryVariables>;
export const CurrentAndUpcomingHarvestGroupsDocument = gql`
    query currentAndUpcomingHarvestGroups($unarchived: String, $siteId: String) {
  harvestGroups(
    filters: {unarchived: $unarchived, completed: "false", siteId: $siteId}
  ) {
    ...HarvestGroupFields
    ...HarvestGroupOverviewFields
    ...HarvestGroupCurrentStageFields
  }
}
    ${HarvestGroupFieldsFragmentDoc}
${HarvestGroupOverviewFieldsFragmentDoc}
${HarvestGroupCurrentStageFieldsFragmentDoc}`;

/**
 * __useCurrentAndUpcomingHarvestGroupsQuery__
 *
 * To run a query within a React component, call `useCurrentAndUpcomingHarvestGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAndUpcomingHarvestGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAndUpcomingHarvestGroupsQuery({
 *   variables: {
 *      unarchived: // value for 'unarchived'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useCurrentAndUpcomingHarvestGroupsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentAndUpcomingHarvestGroupsQuery, CurrentAndUpcomingHarvestGroupsQueryVariables>) {
        return Apollo.useQuery<CurrentAndUpcomingHarvestGroupsQuery, CurrentAndUpcomingHarvestGroupsQueryVariables>(CurrentAndUpcomingHarvestGroupsDocument, baseOptions);
      }
export function useCurrentAndUpcomingHarvestGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAndUpcomingHarvestGroupsQuery, CurrentAndUpcomingHarvestGroupsQueryVariables>) {
          return Apollo.useLazyQuery<CurrentAndUpcomingHarvestGroupsQuery, CurrentAndUpcomingHarvestGroupsQueryVariables>(CurrentAndUpcomingHarvestGroupsDocument, baseOptions);
        }
export type CurrentAndUpcomingHarvestGroupsQueryHookResult = ReturnType<typeof useCurrentAndUpcomingHarvestGroupsQuery>;
export type CurrentAndUpcomingHarvestGroupsLazyQueryHookResult = ReturnType<typeof useCurrentAndUpcomingHarvestGroupsLazyQuery>;
export type CurrentAndUpcomingHarvestGroupsQueryResult = Apollo.QueryResult<CurrentAndUpcomingHarvestGroupsQuery, CurrentAndUpcomingHarvestGroupsQueryVariables>;
export const CurrentAndUpcomingHarvestGroupsShortDocument = gql`
    query currentAndUpcomingHarvestGroupsShort($unarchived: String, $siteId: String) {
  harvestGroups(
    filters: {unarchived: $unarchived, completed: "false", siteId: $siteId}
  ) {
    ...CurrentGroupsShortFields
  }
}
    ${CurrentGroupsShortFieldsFragmentDoc}`;

/**
 * __useCurrentAndUpcomingHarvestGroupsShortQuery__
 *
 * To run a query within a React component, call `useCurrentAndUpcomingHarvestGroupsShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAndUpcomingHarvestGroupsShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAndUpcomingHarvestGroupsShortQuery({
 *   variables: {
 *      unarchived: // value for 'unarchived'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useCurrentAndUpcomingHarvestGroupsShortQuery(baseOptions?: Apollo.QueryHookOptions<CurrentAndUpcomingHarvestGroupsShortQuery, CurrentAndUpcomingHarvestGroupsShortQueryVariables>) {
        return Apollo.useQuery<CurrentAndUpcomingHarvestGroupsShortQuery, CurrentAndUpcomingHarvestGroupsShortQueryVariables>(CurrentAndUpcomingHarvestGroupsShortDocument, baseOptions);
      }
export function useCurrentAndUpcomingHarvestGroupsShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAndUpcomingHarvestGroupsShortQuery, CurrentAndUpcomingHarvestGroupsShortQueryVariables>) {
          return Apollo.useLazyQuery<CurrentAndUpcomingHarvestGroupsShortQuery, CurrentAndUpcomingHarvestGroupsShortQueryVariables>(CurrentAndUpcomingHarvestGroupsShortDocument, baseOptions);
        }
export type CurrentAndUpcomingHarvestGroupsShortQueryHookResult = ReturnType<typeof useCurrentAndUpcomingHarvestGroupsShortQuery>;
export type CurrentAndUpcomingHarvestGroupsShortLazyQueryHookResult = ReturnType<typeof useCurrentAndUpcomingHarvestGroupsShortLazyQuery>;
export type CurrentAndUpcomingHarvestGroupsShortQueryResult = Apollo.QueryResult<CurrentAndUpcomingHarvestGroupsShortQuery, CurrentAndUpcomingHarvestGroupsShortQueryVariables>;
export const HarvestGroupsStartedInThePastDocument = gql`
    query harvestGroupsStartedInThePast($zoneId: String) {
  harvestGroups(
    filters: {unarchived: "true", started: "true", usesZoneId: $zoneId}
  ) {
    ...HarvestGroupShortOverviewFields
    ...HarvestGroupCurrentStageFields
    site {
      organization {
        id
        environmentalTargetSets {
          ...EnvironmentalTargetSetFields
        }
      }
    }
    stages {
      id
      name
      startDate
      endDate
      environmentalTargetType
      zone {
        id
        name
        lightingClassification
      }
    }
  }
}
    ${HarvestGroupShortOverviewFieldsFragmentDoc}
${HarvestGroupCurrentStageFieldsFragmentDoc}
${EnvironmentalTargetSetFieldsFragmentDoc}`;

/**
 * __useHarvestGroupsStartedInThePastQuery__
 *
 * To run a query within a React component, call `useHarvestGroupsStartedInThePastQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestGroupsStartedInThePastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestGroupsStartedInThePastQuery({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useHarvestGroupsStartedInThePastQuery(baseOptions?: Apollo.QueryHookOptions<HarvestGroupsStartedInThePastQuery, HarvestGroupsStartedInThePastQueryVariables>) {
        return Apollo.useQuery<HarvestGroupsStartedInThePastQuery, HarvestGroupsStartedInThePastQueryVariables>(HarvestGroupsStartedInThePastDocument, baseOptions);
      }
export function useHarvestGroupsStartedInThePastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestGroupsStartedInThePastQuery, HarvestGroupsStartedInThePastQueryVariables>) {
          return Apollo.useLazyQuery<HarvestGroupsStartedInThePastQuery, HarvestGroupsStartedInThePastQueryVariables>(HarvestGroupsStartedInThePastDocument, baseOptions);
        }
export type HarvestGroupsStartedInThePastQueryHookResult = ReturnType<typeof useHarvestGroupsStartedInThePastQuery>;
export type HarvestGroupsStartedInThePastLazyQueryHookResult = ReturnType<typeof useHarvestGroupsStartedInThePastLazyQuery>;
export type HarvestGroupsStartedInThePastQueryResult = Apollo.QueryResult<HarvestGroupsStartedInThePastQuery, HarvestGroupsStartedInThePastQueryVariables>;
export const CurrentAndUpcomingHarvestGroupsForTaskFormDocument = gql`
    query currentAndUpcomingHarvestGroupsForTaskForm($unarchived: String, $siteId: String) {
  harvestGroups(
    filters: {unarchived: $unarchived, completed: "false", siteId: $siteId}
  ) {
    id
    name
    flowerZone {
      id
      name
    }
    stages {
      id
      name
      startDate
      endDate
    }
  }
}
    `;

/**
 * __useCurrentAndUpcomingHarvestGroupsForTaskFormQuery__
 *
 * To run a query within a React component, call `useCurrentAndUpcomingHarvestGroupsForTaskFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAndUpcomingHarvestGroupsForTaskFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAndUpcomingHarvestGroupsForTaskFormQuery({
 *   variables: {
 *      unarchived: // value for 'unarchived'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useCurrentAndUpcomingHarvestGroupsForTaskFormQuery(baseOptions?: Apollo.QueryHookOptions<CurrentAndUpcomingHarvestGroupsForTaskFormQuery, CurrentAndUpcomingHarvestGroupsForTaskFormQueryVariables>) {
        return Apollo.useQuery<CurrentAndUpcomingHarvestGroupsForTaskFormQuery, CurrentAndUpcomingHarvestGroupsForTaskFormQueryVariables>(CurrentAndUpcomingHarvestGroupsForTaskFormDocument, baseOptions);
      }
export function useCurrentAndUpcomingHarvestGroupsForTaskFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAndUpcomingHarvestGroupsForTaskFormQuery, CurrentAndUpcomingHarvestGroupsForTaskFormQueryVariables>) {
          return Apollo.useLazyQuery<CurrentAndUpcomingHarvestGroupsForTaskFormQuery, CurrentAndUpcomingHarvestGroupsForTaskFormQueryVariables>(CurrentAndUpcomingHarvestGroupsForTaskFormDocument, baseOptions);
        }
export type CurrentAndUpcomingHarvestGroupsForTaskFormQueryHookResult = ReturnType<typeof useCurrentAndUpcomingHarvestGroupsForTaskFormQuery>;
export type CurrentAndUpcomingHarvestGroupsForTaskFormLazyQueryHookResult = ReturnType<typeof useCurrentAndUpcomingHarvestGroupsForTaskFormLazyQuery>;
export type CurrentAndUpcomingHarvestGroupsForTaskFormQueryResult = Apollo.QueryResult<CurrentAndUpcomingHarvestGroupsForTaskFormQuery, CurrentAndUpcomingHarvestGroupsForTaskFormQueryVariables>;
export const CurrentAndUpcomingHarvestGroupsForSelectDocument = gql`
    query currentAndUpcomingHarvestGroupsForSelect($filters: HarvestGroupFilterSetInput) {
  harvestGroups(filters: $filters) {
    name
    id
    colorHexCode
    startDate
    stages {
      zone {
        id
      }
    }
  }
}
    `;

/**
 * __useCurrentAndUpcomingHarvestGroupsForSelectQuery__
 *
 * To run a query within a React component, call `useCurrentAndUpcomingHarvestGroupsForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAndUpcomingHarvestGroupsForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAndUpcomingHarvestGroupsForSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCurrentAndUpcomingHarvestGroupsForSelectQuery(baseOptions?: Apollo.QueryHookOptions<CurrentAndUpcomingHarvestGroupsForSelectQuery, CurrentAndUpcomingHarvestGroupsForSelectQueryVariables>) {
        return Apollo.useQuery<CurrentAndUpcomingHarvestGroupsForSelectQuery, CurrentAndUpcomingHarvestGroupsForSelectQueryVariables>(CurrentAndUpcomingHarvestGroupsForSelectDocument, baseOptions);
      }
export function useCurrentAndUpcomingHarvestGroupsForSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAndUpcomingHarvestGroupsForSelectQuery, CurrentAndUpcomingHarvestGroupsForSelectQueryVariables>) {
          return Apollo.useLazyQuery<CurrentAndUpcomingHarvestGroupsForSelectQuery, CurrentAndUpcomingHarvestGroupsForSelectQueryVariables>(CurrentAndUpcomingHarvestGroupsForSelectDocument, baseOptions);
        }
export type CurrentAndUpcomingHarvestGroupsForSelectQueryHookResult = ReturnType<typeof useCurrentAndUpcomingHarvestGroupsForSelectQuery>;
export type CurrentAndUpcomingHarvestGroupsForSelectLazyQueryHookResult = ReturnType<typeof useCurrentAndUpcomingHarvestGroupsForSelectLazyQuery>;
export type CurrentAndUpcomingHarvestGroupsForSelectQueryResult = Apollo.QueryResult<CurrentAndUpcomingHarvestGroupsForSelectQuery, CurrentAndUpcomingHarvestGroupsForSelectQueryVariables>;
export const CompletedHarvestGroupsPaginatedDocument = gql`
    query completedHarvestGroupsPaginated($options: HarvestGroupQuerysetOptionsInput) {
  completedHarvestGroupsPaginated(options: $options) {
    ...CompletedHarvestGroupsPaginatedResult
  }
}
    ${CompletedHarvestGroupsPaginatedResultFragmentDoc}`;

/**
 * __useCompletedHarvestGroupsPaginatedQuery__
 *
 * To run a query within a React component, call `useCompletedHarvestGroupsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedHarvestGroupsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedHarvestGroupsPaginatedQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCompletedHarvestGroupsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<CompletedHarvestGroupsPaginatedQuery, CompletedHarvestGroupsPaginatedQueryVariables>) {
        return Apollo.useQuery<CompletedHarvestGroupsPaginatedQuery, CompletedHarvestGroupsPaginatedQueryVariables>(CompletedHarvestGroupsPaginatedDocument, baseOptions);
      }
export function useCompletedHarvestGroupsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedHarvestGroupsPaginatedQuery, CompletedHarvestGroupsPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<CompletedHarvestGroupsPaginatedQuery, CompletedHarvestGroupsPaginatedQueryVariables>(CompletedHarvestGroupsPaginatedDocument, baseOptions);
        }
export type CompletedHarvestGroupsPaginatedQueryHookResult = ReturnType<typeof useCompletedHarvestGroupsPaginatedQuery>;
export type CompletedHarvestGroupsPaginatedLazyQueryHookResult = ReturnType<typeof useCompletedHarvestGroupsPaginatedLazyQuery>;
export type CompletedHarvestGroupsPaginatedQueryResult = Apollo.QueryResult<CompletedHarvestGroupsPaginatedQuery, CompletedHarvestGroupsPaginatedQueryVariables>;
export const CompletedHarvestGroupsDocument = gql`
    query completedHarvestGroups($unarchived: String, $siteId: String, $importedFromMetrc: Boolean) {
  harvestGroups(
    filters: {unarchived: $unarchived, completed: "true", siteId: $siteId, importedFromMetrc: $importedFromMetrc}
  ) {
    ...CompletedHarvestGroupFields
  }
}
    ${CompletedHarvestGroupFieldsFragmentDoc}`;

/**
 * __useCompletedHarvestGroupsQuery__
 *
 * To run a query within a React component, call `useCompletedHarvestGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedHarvestGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedHarvestGroupsQuery({
 *   variables: {
 *      unarchived: // value for 'unarchived'
 *      siteId: // value for 'siteId'
 *      importedFromMetrc: // value for 'importedFromMetrc'
 *   },
 * });
 */
export function useCompletedHarvestGroupsQuery(baseOptions?: Apollo.QueryHookOptions<CompletedHarvestGroupsQuery, CompletedHarvestGroupsQueryVariables>) {
        return Apollo.useQuery<CompletedHarvestGroupsQuery, CompletedHarvestGroupsQueryVariables>(CompletedHarvestGroupsDocument, baseOptions);
      }
export function useCompletedHarvestGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedHarvestGroupsQuery, CompletedHarvestGroupsQueryVariables>) {
          return Apollo.useLazyQuery<CompletedHarvestGroupsQuery, CompletedHarvestGroupsQueryVariables>(CompletedHarvestGroupsDocument, baseOptions);
        }
export type CompletedHarvestGroupsQueryHookResult = ReturnType<typeof useCompletedHarvestGroupsQuery>;
export type CompletedHarvestGroupsLazyQueryHookResult = ReturnType<typeof useCompletedHarvestGroupsLazyQuery>;
export type CompletedHarvestGroupsQueryResult = Apollo.QueryResult<CompletedHarvestGroupsQuery, CompletedHarvestGroupsQueryVariables>;
export const CompletedHarvestGroupsYieldsDocument = gql`
    query completedHarvestGroupsYields($unarchived: String, $siteId: String) {
  harvestGroups(
    filters: {unarchived: $unarchived, completed: "true", siteId: $siteId}
  ) {
    ...CompletedHarvestGroupYieldsFields
  }
}
    ${CompletedHarvestGroupYieldsFieldsFragmentDoc}`;

/**
 * __useCompletedHarvestGroupsYieldsQuery__
 *
 * To run a query within a React component, call `useCompletedHarvestGroupsYieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedHarvestGroupsYieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedHarvestGroupsYieldsQuery({
 *   variables: {
 *      unarchived: // value for 'unarchived'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useCompletedHarvestGroupsYieldsQuery(baseOptions?: Apollo.QueryHookOptions<CompletedHarvestGroupsYieldsQuery, CompletedHarvestGroupsYieldsQueryVariables>) {
        return Apollo.useQuery<CompletedHarvestGroupsYieldsQuery, CompletedHarvestGroupsYieldsQueryVariables>(CompletedHarvestGroupsYieldsDocument, baseOptions);
      }
export function useCompletedHarvestGroupsYieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedHarvestGroupsYieldsQuery, CompletedHarvestGroupsYieldsQueryVariables>) {
          return Apollo.useLazyQuery<CompletedHarvestGroupsYieldsQuery, CompletedHarvestGroupsYieldsQueryVariables>(CompletedHarvestGroupsYieldsDocument, baseOptions);
        }
export type CompletedHarvestGroupsYieldsQueryHookResult = ReturnType<typeof useCompletedHarvestGroupsYieldsQuery>;
export type CompletedHarvestGroupsYieldsLazyQueryHookResult = ReturnType<typeof useCompletedHarvestGroupsYieldsLazyQuery>;
export type CompletedHarvestGroupsYieldsQueryResult = Apollo.QueryResult<CompletedHarvestGroupsYieldsQuery, CompletedHarvestGroupsYieldsQueryVariables>;
export const HarvestForecastYieldHistoryDocument = gql`
    query harvestForecastYieldHistory($siteId: String) {
  harvestForecastYieldHistory(siteId: $siteId) {
    ...HarvestForecastYieldHistoryFields
  }
}
    ${HarvestForecastYieldHistoryFieldsFragmentDoc}`;

/**
 * __useHarvestForecastYieldHistoryQuery__
 *
 * To run a query within a React component, call `useHarvestForecastYieldHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestForecastYieldHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestForecastYieldHistoryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useHarvestForecastYieldHistoryQuery(baseOptions?: Apollo.QueryHookOptions<HarvestForecastYieldHistoryQuery, HarvestForecastYieldHistoryQueryVariables>) {
        return Apollo.useQuery<HarvestForecastYieldHistoryQuery, HarvestForecastYieldHistoryQueryVariables>(HarvestForecastYieldHistoryDocument, baseOptions);
      }
export function useHarvestForecastYieldHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestForecastYieldHistoryQuery, HarvestForecastYieldHistoryQueryVariables>) {
          return Apollo.useLazyQuery<HarvestForecastYieldHistoryQuery, HarvestForecastYieldHistoryQueryVariables>(HarvestForecastYieldHistoryDocument, baseOptions);
        }
export type HarvestForecastYieldHistoryQueryHookResult = ReturnType<typeof useHarvestForecastYieldHistoryQuery>;
export type HarvestForecastYieldHistoryLazyQueryHookResult = ReturnType<typeof useHarvestForecastYieldHistoryLazyQuery>;
export type HarvestForecastYieldHistoryQueryResult = Apollo.QueryResult<HarvestForecastYieldHistoryQuery, HarvestForecastYieldHistoryQueryVariables>;
export const CompletedHarvestGroupsNamesDocument = gql`
    query completedHarvestGroupsNames($unarchived: String, $siteId: String) {
  harvestGroups(
    filters: {unarchived: $unarchived, completed: "true", siteId: $siteId}
  ) {
    id
    name
    harvestDate
  }
}
    `;

/**
 * __useCompletedHarvestGroupsNamesQuery__
 *
 * To run a query within a React component, call `useCompletedHarvestGroupsNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedHarvestGroupsNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedHarvestGroupsNamesQuery({
 *   variables: {
 *      unarchived: // value for 'unarchived'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useCompletedHarvestGroupsNamesQuery(baseOptions?: Apollo.QueryHookOptions<CompletedHarvestGroupsNamesQuery, CompletedHarvestGroupsNamesQueryVariables>) {
        return Apollo.useQuery<CompletedHarvestGroupsNamesQuery, CompletedHarvestGroupsNamesQueryVariables>(CompletedHarvestGroupsNamesDocument, baseOptions);
      }
export function useCompletedHarvestGroupsNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedHarvestGroupsNamesQuery, CompletedHarvestGroupsNamesQueryVariables>) {
          return Apollo.useLazyQuery<CompletedHarvestGroupsNamesQuery, CompletedHarvestGroupsNamesQueryVariables>(CompletedHarvestGroupsNamesDocument, baseOptions);
        }
export type CompletedHarvestGroupsNamesQueryHookResult = ReturnType<typeof useCompletedHarvestGroupsNamesQuery>;
export type CompletedHarvestGroupsNamesLazyQueryHookResult = ReturnType<typeof useCompletedHarvestGroupsNamesLazyQuery>;
export type CompletedHarvestGroupsNamesQueryResult = Apollo.QueryResult<CompletedHarvestGroupsNamesQuery, CompletedHarvestGroupsNamesQueryVariables>;
export const CompletedHarvestGroupsTableViewDocument = gql`
    query completedHarvestGroupsTableView($unarchived: String, $siteId: String) {
  harvestGroups(
    filters: {unarchived: $unarchived, completed: "true", siteId: $siteId}
  ) {
    id
    name
    startDate
    harvestDate
    archivedAt
    hasYields
    strains {
      ...StrainReportFields
    }
    flowerZone {
      ...ZoneIdAndName
    }
  }
}
    ${StrainReportFieldsFragmentDoc}
${ZoneIdAndNameFragmentDoc}`;

/**
 * __useCompletedHarvestGroupsTableViewQuery__
 *
 * To run a query within a React component, call `useCompletedHarvestGroupsTableViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedHarvestGroupsTableViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedHarvestGroupsTableViewQuery({
 *   variables: {
 *      unarchived: // value for 'unarchived'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useCompletedHarvestGroupsTableViewQuery(baseOptions?: Apollo.QueryHookOptions<CompletedHarvestGroupsTableViewQuery, CompletedHarvestGroupsTableViewQueryVariables>) {
        return Apollo.useQuery<CompletedHarvestGroupsTableViewQuery, CompletedHarvestGroupsTableViewQueryVariables>(CompletedHarvestGroupsTableViewDocument, baseOptions);
      }
export function useCompletedHarvestGroupsTableViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedHarvestGroupsTableViewQuery, CompletedHarvestGroupsTableViewQueryVariables>) {
          return Apollo.useLazyQuery<CompletedHarvestGroupsTableViewQuery, CompletedHarvestGroupsTableViewQueryVariables>(CompletedHarvestGroupsTableViewDocument, baseOptions);
        }
export type CompletedHarvestGroupsTableViewQueryHookResult = ReturnType<typeof useCompletedHarvestGroupsTableViewQuery>;
export type CompletedHarvestGroupsTableViewLazyQueryHookResult = ReturnType<typeof useCompletedHarvestGroupsTableViewLazyQuery>;
export type CompletedHarvestGroupsTableViewQueryResult = Apollo.QueryResult<CompletedHarvestGroupsTableViewQuery, CompletedHarvestGroupsTableViewQueryVariables>;
export const CompletedHarvestGroupsListDocument = gql`
    query completedHarvestGroupsList($unarchived: String, $siteId: String) {
  harvestGroups(
    filters: {unarchived: $unarchived, completed: "true", siteId: $siteId}
  ) {
    id
    name
    startDate
    harvestDate
    archivedAt
    strains {
      ...StrainReportFields
    }
    flowerZone {
      ...ZoneIdAndName
    }
    yields {
      id
      totalGrams
      budFormFactorYields {
        numberOfGrams
        budFormFactor {
          id
          name
        }
      }
    }
  }
}
    ${StrainReportFieldsFragmentDoc}
${ZoneIdAndNameFragmentDoc}`;

/**
 * __useCompletedHarvestGroupsListQuery__
 *
 * To run a query within a React component, call `useCompletedHarvestGroupsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedHarvestGroupsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedHarvestGroupsListQuery({
 *   variables: {
 *      unarchived: // value for 'unarchived'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useCompletedHarvestGroupsListQuery(baseOptions?: Apollo.QueryHookOptions<CompletedHarvestGroupsListQuery, CompletedHarvestGroupsListQueryVariables>) {
        return Apollo.useQuery<CompletedHarvestGroupsListQuery, CompletedHarvestGroupsListQueryVariables>(CompletedHarvestGroupsListDocument, baseOptions);
      }
export function useCompletedHarvestGroupsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedHarvestGroupsListQuery, CompletedHarvestGroupsListQueryVariables>) {
          return Apollo.useLazyQuery<CompletedHarvestGroupsListQuery, CompletedHarvestGroupsListQueryVariables>(CompletedHarvestGroupsListDocument, baseOptions);
        }
export type CompletedHarvestGroupsListQueryHookResult = ReturnType<typeof useCompletedHarvestGroupsListQuery>;
export type CompletedHarvestGroupsListLazyQueryHookResult = ReturnType<typeof useCompletedHarvestGroupsListLazyQuery>;
export type CompletedHarvestGroupsListQueryResult = Apollo.QueryResult<CompletedHarvestGroupsListQuery, CompletedHarvestGroupsListQueryVariables>;
export const CompletedHarvestGroupDocument = gql`
    query completedHarvestGroup($id: String!) {
  harvestGroup(id: $id) {
    ...CompletedHarvestGroupFields
  }
}
    ${CompletedHarvestGroupFieldsFragmentDoc}`;

/**
 * __useCompletedHarvestGroupQuery__
 *
 * To run a query within a React component, call `useCompletedHarvestGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedHarvestGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedHarvestGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompletedHarvestGroupQuery(baseOptions?: Apollo.QueryHookOptions<CompletedHarvestGroupQuery, CompletedHarvestGroupQueryVariables>) {
        return Apollo.useQuery<CompletedHarvestGroupQuery, CompletedHarvestGroupQueryVariables>(CompletedHarvestGroupDocument, baseOptions);
      }
export function useCompletedHarvestGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedHarvestGroupQuery, CompletedHarvestGroupQueryVariables>) {
          return Apollo.useLazyQuery<CompletedHarvestGroupQuery, CompletedHarvestGroupQueryVariables>(CompletedHarvestGroupDocument, baseOptions);
        }
export type CompletedHarvestGroupQueryHookResult = ReturnType<typeof useCompletedHarvestGroupQuery>;
export type CompletedHarvestGroupLazyQueryHookResult = ReturnType<typeof useCompletedHarvestGroupLazyQuery>;
export type CompletedHarvestGroupQueryResult = Apollo.QueryResult<CompletedHarvestGroupQuery, CompletedHarvestGroupQueryVariables>;
export const AnalyticsHarvestGroupsDocument = gql`
    query analyticsHarvestGroups($unarchived: String, $siteId: String) {
  harvestGroups(
    filters: {unarchived: $unarchived, completed: "true", siteId: $siteId}
  ) {
    ...AnalyticsHarvestGroupFields
  }
}
    ${AnalyticsHarvestGroupFieldsFragmentDoc}`;

/**
 * __useAnalyticsHarvestGroupsQuery__
 *
 * To run a query within a React component, call `useAnalyticsHarvestGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsHarvestGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsHarvestGroupsQuery({
 *   variables: {
 *      unarchived: // value for 'unarchived'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useAnalyticsHarvestGroupsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsHarvestGroupsQuery, AnalyticsHarvestGroupsQueryVariables>) {
        return Apollo.useQuery<AnalyticsHarvestGroupsQuery, AnalyticsHarvestGroupsQueryVariables>(AnalyticsHarvestGroupsDocument, baseOptions);
      }
export function useAnalyticsHarvestGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsHarvestGroupsQuery, AnalyticsHarvestGroupsQueryVariables>) {
          return Apollo.useLazyQuery<AnalyticsHarvestGroupsQuery, AnalyticsHarvestGroupsQueryVariables>(AnalyticsHarvestGroupsDocument, baseOptions);
        }
export type AnalyticsHarvestGroupsQueryHookResult = ReturnType<typeof useAnalyticsHarvestGroupsQuery>;
export type AnalyticsHarvestGroupsLazyQueryHookResult = ReturnType<typeof useAnalyticsHarvestGroupsLazyQuery>;
export type AnalyticsHarvestGroupsQueryResult = Apollo.QueryResult<AnalyticsHarvestGroupsQuery, AnalyticsHarvestGroupsQueryVariables>;
export const AnalyticsHarvestGroupsOverviewDocument = gql`
    query analyticsHarvestGroupsOverview($unarchived: String, $siteId: String) {
  harvestGroups(
    filters: {unarchived: $unarchived, completed: "true", siteId: $siteId}
  ) {
    ...AnalyticsHarvestGroupsOverview
  }
}
    ${AnalyticsHarvestGroupsOverviewFragmentDoc}`;

/**
 * __useAnalyticsHarvestGroupsOverviewQuery__
 *
 * To run a query within a React component, call `useAnalyticsHarvestGroupsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsHarvestGroupsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsHarvestGroupsOverviewQuery({
 *   variables: {
 *      unarchived: // value for 'unarchived'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useAnalyticsHarvestGroupsOverviewQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsHarvestGroupsOverviewQuery, AnalyticsHarvestGroupsOverviewQueryVariables>) {
        return Apollo.useQuery<AnalyticsHarvestGroupsOverviewQuery, AnalyticsHarvestGroupsOverviewQueryVariables>(AnalyticsHarvestGroupsOverviewDocument, baseOptions);
      }
export function useAnalyticsHarvestGroupsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsHarvestGroupsOverviewQuery, AnalyticsHarvestGroupsOverviewQueryVariables>) {
          return Apollo.useLazyQuery<AnalyticsHarvestGroupsOverviewQuery, AnalyticsHarvestGroupsOverviewQueryVariables>(AnalyticsHarvestGroupsOverviewDocument, baseOptions);
        }
export type AnalyticsHarvestGroupsOverviewQueryHookResult = ReturnType<typeof useAnalyticsHarvestGroupsOverviewQuery>;
export type AnalyticsHarvestGroupsOverviewLazyQueryHookResult = ReturnType<typeof useAnalyticsHarvestGroupsOverviewLazyQuery>;
export type AnalyticsHarvestGroupsOverviewQueryResult = Apollo.QueryResult<AnalyticsHarvestGroupsOverviewQuery, AnalyticsHarvestGroupsOverviewQueryVariables>;
export const CompletedHarvestGroupWithLogsDocument = gql`
    query completedHarvestGroupWithLogs($id: String!) {
  harvestGroup(id: $id) {
    ...CompletedHarvestGroupWithLogsFields
  }
}
    ${CompletedHarvestGroupWithLogsFieldsFragmentDoc}`;

/**
 * __useCompletedHarvestGroupWithLogsQuery__
 *
 * To run a query within a React component, call `useCompletedHarvestGroupWithLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedHarvestGroupWithLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedHarvestGroupWithLogsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompletedHarvestGroupWithLogsQuery(baseOptions?: Apollo.QueryHookOptions<CompletedHarvestGroupWithLogsQuery, CompletedHarvestGroupWithLogsQueryVariables>) {
        return Apollo.useQuery<CompletedHarvestGroupWithLogsQuery, CompletedHarvestGroupWithLogsQueryVariables>(CompletedHarvestGroupWithLogsDocument, baseOptions);
      }
export function useCompletedHarvestGroupWithLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedHarvestGroupWithLogsQuery, CompletedHarvestGroupWithLogsQueryVariables>) {
          return Apollo.useLazyQuery<CompletedHarvestGroupWithLogsQuery, CompletedHarvestGroupWithLogsQueryVariables>(CompletedHarvestGroupWithLogsDocument, baseOptions);
        }
export type CompletedHarvestGroupWithLogsQueryHookResult = ReturnType<typeof useCompletedHarvestGroupWithLogsQuery>;
export type CompletedHarvestGroupWithLogsLazyQueryHookResult = ReturnType<typeof useCompletedHarvestGroupWithLogsLazyQuery>;
export type CompletedHarvestGroupWithLogsQueryResult = Apollo.QueryResult<CompletedHarvestGroupWithLogsQuery, CompletedHarvestGroupWithLogsQueryVariables>;
export const HarvestReportComparisonDocument = gql`
    query harvestReportComparison($id: String!) {
  harvestGroup(id: $id) {
    ...HarvestGroupReportComparisonFields
  }
}
    ${HarvestGroupReportComparisonFieldsFragmentDoc}`;

/**
 * __useHarvestReportComparisonQuery__
 *
 * To run a query within a React component, call `useHarvestReportComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestReportComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestReportComparisonQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHarvestReportComparisonQuery(baseOptions?: Apollo.QueryHookOptions<HarvestReportComparisonQuery, HarvestReportComparisonQueryVariables>) {
        return Apollo.useQuery<HarvestReportComparisonQuery, HarvestReportComparisonQueryVariables>(HarvestReportComparisonDocument, baseOptions);
      }
export function useHarvestReportComparisonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestReportComparisonQuery, HarvestReportComparisonQueryVariables>) {
          return Apollo.useLazyQuery<HarvestReportComparisonQuery, HarvestReportComparisonQueryVariables>(HarvestReportComparisonDocument, baseOptions);
        }
export type HarvestReportComparisonQueryHookResult = ReturnType<typeof useHarvestReportComparisonQuery>;
export type HarvestReportComparisonLazyQueryHookResult = ReturnType<typeof useHarvestReportComparisonLazyQuery>;
export type HarvestReportComparisonQueryResult = Apollo.QueryResult<HarvestReportComparisonQuery, HarvestReportComparisonQueryVariables>;
export const HarvestGroupDocument = gql`
    query harvestGroup($id: String!) {
  harvestGroup(id: $id) {
    ...HarvestGroupFields
  }
}
    ${HarvestGroupFieldsFragmentDoc}`;

/**
 * __useHarvestGroupQuery__
 *
 * To run a query within a React component, call `useHarvestGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHarvestGroupQuery(baseOptions?: Apollo.QueryHookOptions<HarvestGroupQuery, HarvestGroupQueryVariables>) {
        return Apollo.useQuery<HarvestGroupQuery, HarvestGroupQueryVariables>(HarvestGroupDocument, baseOptions);
      }
export function useHarvestGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestGroupQuery, HarvestGroupQueryVariables>) {
          return Apollo.useLazyQuery<HarvestGroupQuery, HarvestGroupQueryVariables>(HarvestGroupDocument, baseOptions);
        }
export type HarvestGroupQueryHookResult = ReturnType<typeof useHarvestGroupQuery>;
export type HarvestGroupLazyQueryHookResult = ReturnType<typeof useHarvestGroupLazyQuery>;
export type HarvestGroupQueryResult = Apollo.QueryResult<HarvestGroupQuery, HarvestGroupQueryVariables>;
export const DashboardHarvestGroupTooltipDocument = gql`
    query dashboardHarvestGroupTooltip($id: String!) {
  harvestGroup(id: $id) {
    ...HarvestGroupOverviewTooltipFields
  }
}
    ${HarvestGroupOverviewTooltipFieldsFragmentDoc}`;

/**
 * __useDashboardHarvestGroupTooltipQuery__
 *
 * To run a query within a React component, call `useDashboardHarvestGroupTooltipQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardHarvestGroupTooltipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardHarvestGroupTooltipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardHarvestGroupTooltipQuery(baseOptions?: Apollo.QueryHookOptions<DashboardHarvestGroupTooltipQuery, DashboardHarvestGroupTooltipQueryVariables>) {
        return Apollo.useQuery<DashboardHarvestGroupTooltipQuery, DashboardHarvestGroupTooltipQueryVariables>(DashboardHarvestGroupTooltipDocument, baseOptions);
      }
export function useDashboardHarvestGroupTooltipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardHarvestGroupTooltipQuery, DashboardHarvestGroupTooltipQueryVariables>) {
          return Apollo.useLazyQuery<DashboardHarvestGroupTooltipQuery, DashboardHarvestGroupTooltipQueryVariables>(DashboardHarvestGroupTooltipDocument, baseOptions);
        }
export type DashboardHarvestGroupTooltipQueryHookResult = ReturnType<typeof useDashboardHarvestGroupTooltipQuery>;
export type DashboardHarvestGroupTooltipLazyQueryHookResult = ReturnType<typeof useDashboardHarvestGroupTooltipLazyQuery>;
export type DashboardHarvestGroupTooltipQueryResult = Apollo.QueryResult<DashboardHarvestGroupTooltipQuery, DashboardHarvestGroupTooltipQueryVariables>;
export const HarvestGroupWithJustLogEntriesAndCompletionDocument = gql`
    query harvestGroupWithJustLogEntriesAndCompletion($id: String!, $logEntryOptions: LogsFilterInput) {
  harvestGroup(id: $id) {
    id
    name
    colorHexCode
    logEntries(logEntryOptions: $logEntryOptions) {
      ...LogEntryFields
    }
    harvestCompletion {
      cosignedAt
    }
  }
}
    ${LogEntryFieldsFragmentDoc}`;

/**
 * __useHarvestGroupWithJustLogEntriesAndCompletionQuery__
 *
 * To run a query within a React component, call `useHarvestGroupWithJustLogEntriesAndCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestGroupWithJustLogEntriesAndCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestGroupWithJustLogEntriesAndCompletionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      logEntryOptions: // value for 'logEntryOptions'
 *   },
 * });
 */
export function useHarvestGroupWithJustLogEntriesAndCompletionQuery(baseOptions?: Apollo.QueryHookOptions<HarvestGroupWithJustLogEntriesAndCompletionQuery, HarvestGroupWithJustLogEntriesAndCompletionQueryVariables>) {
        return Apollo.useQuery<HarvestGroupWithJustLogEntriesAndCompletionQuery, HarvestGroupWithJustLogEntriesAndCompletionQueryVariables>(HarvestGroupWithJustLogEntriesAndCompletionDocument, baseOptions);
      }
export function useHarvestGroupWithJustLogEntriesAndCompletionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestGroupWithJustLogEntriesAndCompletionQuery, HarvestGroupWithJustLogEntriesAndCompletionQueryVariables>) {
          return Apollo.useLazyQuery<HarvestGroupWithJustLogEntriesAndCompletionQuery, HarvestGroupWithJustLogEntriesAndCompletionQueryVariables>(HarvestGroupWithJustLogEntriesAndCompletionDocument, baseOptions);
        }
export type HarvestGroupWithJustLogEntriesAndCompletionQueryHookResult = ReturnType<typeof useHarvestGroupWithJustLogEntriesAndCompletionQuery>;
export type HarvestGroupWithJustLogEntriesAndCompletionLazyQueryHookResult = ReturnType<typeof useHarvestGroupWithJustLogEntriesAndCompletionLazyQuery>;
export type HarvestGroupWithJustLogEntriesAndCompletionQueryResult = Apollo.QueryResult<HarvestGroupWithJustLogEntriesAndCompletionQuery, HarvestGroupWithJustLogEntriesAndCompletionQueryVariables>;
export const AllHarvestGroupsWithLogEntriesDocument = gql`
    query allHarvestGroupsWithLogEntries($logEntryOptions: LogsFilterInput) {
  harvestGroups(filters: {unarchived: "true"}, logEntryOptions: $logEntryOptions) {
    id
    name
    flowerZone {
      id
    }
    logEntries(logEntryOptions: $logEntryOptions) {
      ...LogEntryFields
    }
  }
}
    ${LogEntryFieldsFragmentDoc}`;

/**
 * __useAllHarvestGroupsWithLogEntriesQuery__
 *
 * To run a query within a React component, call `useAllHarvestGroupsWithLogEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllHarvestGroupsWithLogEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllHarvestGroupsWithLogEntriesQuery({
 *   variables: {
 *      logEntryOptions: // value for 'logEntryOptions'
 *   },
 * });
 */
export function useAllHarvestGroupsWithLogEntriesQuery(baseOptions?: Apollo.QueryHookOptions<AllHarvestGroupsWithLogEntriesQuery, AllHarvestGroupsWithLogEntriesQueryVariables>) {
        return Apollo.useQuery<AllHarvestGroupsWithLogEntriesQuery, AllHarvestGroupsWithLogEntriesQueryVariables>(AllHarvestGroupsWithLogEntriesDocument, baseOptions);
      }
export function useAllHarvestGroupsWithLogEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllHarvestGroupsWithLogEntriesQuery, AllHarvestGroupsWithLogEntriesQueryVariables>) {
          return Apollo.useLazyQuery<AllHarvestGroupsWithLogEntriesQuery, AllHarvestGroupsWithLogEntriesQueryVariables>(AllHarvestGroupsWithLogEntriesDocument, baseOptions);
        }
export type AllHarvestGroupsWithLogEntriesQueryHookResult = ReturnType<typeof useAllHarvestGroupsWithLogEntriesQuery>;
export type AllHarvestGroupsWithLogEntriesLazyQueryHookResult = ReturnType<typeof useAllHarvestGroupsWithLogEntriesLazyQuery>;
export type AllHarvestGroupsWithLogEntriesQueryResult = Apollo.QueryResult<AllHarvestGroupsWithLogEntriesQuery, AllHarvestGroupsWithLogEntriesQueryVariables>;
export const AllHarvestGroupsShortOverviewDocument = gql`
    query allHarvestGroupsShortOverview {
  harvestGroups(filters: {unarchived: "true"}) {
    ...HarvestGroupShortOverviewFields
  }
}
    ${HarvestGroupShortOverviewFieldsFragmentDoc}`;

/**
 * __useAllHarvestGroupsShortOverviewQuery__
 *
 * To run a query within a React component, call `useAllHarvestGroupsShortOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllHarvestGroupsShortOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllHarvestGroupsShortOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllHarvestGroupsShortOverviewQuery(baseOptions?: Apollo.QueryHookOptions<AllHarvestGroupsShortOverviewQuery, AllHarvestGroupsShortOverviewQueryVariables>) {
        return Apollo.useQuery<AllHarvestGroupsShortOverviewQuery, AllHarvestGroupsShortOverviewQueryVariables>(AllHarvestGroupsShortOverviewDocument, baseOptions);
      }
export function useAllHarvestGroupsShortOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllHarvestGroupsShortOverviewQuery, AllHarvestGroupsShortOverviewQueryVariables>) {
          return Apollo.useLazyQuery<AllHarvestGroupsShortOverviewQuery, AllHarvestGroupsShortOverviewQueryVariables>(AllHarvestGroupsShortOverviewDocument, baseOptions);
        }
export type AllHarvestGroupsShortOverviewQueryHookResult = ReturnType<typeof useAllHarvestGroupsShortOverviewQuery>;
export type AllHarvestGroupsShortOverviewLazyQueryHookResult = ReturnType<typeof useAllHarvestGroupsShortOverviewLazyQuery>;
export type AllHarvestGroupsShortOverviewQueryResult = Apollo.QueryResult<AllHarvestGroupsShortOverviewQuery, AllHarvestGroupsShortOverviewQueryVariables>;
export const HarvestGroupWithJustStrainsDocument = gql`
    query harvestGroupWithJustStrains($id: String!) {
  harvestGroup(id: $id) {
    strains {
      ...StrainReportFields
    }
  }
}
    ${StrainReportFieldsFragmentDoc}`;

/**
 * __useHarvestGroupWithJustStrainsQuery__
 *
 * To run a query within a React component, call `useHarvestGroupWithJustStrainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestGroupWithJustStrainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestGroupWithJustStrainsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHarvestGroupWithJustStrainsQuery(baseOptions?: Apollo.QueryHookOptions<HarvestGroupWithJustStrainsQuery, HarvestGroupWithJustStrainsQueryVariables>) {
        return Apollo.useQuery<HarvestGroupWithJustStrainsQuery, HarvestGroupWithJustStrainsQueryVariables>(HarvestGroupWithJustStrainsDocument, baseOptions);
      }
export function useHarvestGroupWithJustStrainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestGroupWithJustStrainsQuery, HarvestGroupWithJustStrainsQueryVariables>) {
          return Apollo.useLazyQuery<HarvestGroupWithJustStrainsQuery, HarvestGroupWithJustStrainsQueryVariables>(HarvestGroupWithJustStrainsDocument, baseOptions);
        }
export type HarvestGroupWithJustStrainsQueryHookResult = ReturnType<typeof useHarvestGroupWithJustStrainsQuery>;
export type HarvestGroupWithJustStrainsLazyQueryHookResult = ReturnType<typeof useHarvestGroupWithJustStrainsLazyQuery>;
export type HarvestGroupWithJustStrainsQueryResult = Apollo.QueryResult<HarvestGroupWithJustStrainsQuery, HarvestGroupWithJustStrainsQueryVariables>;
export const CreateHarvestGroupDocument = gql`
    mutation createHarvestGroup($input: CreateHarvestGroupInput!) {
  createHarvestGroup(input: $input) {
    ... on HarvestGroup {
      ...HarvestGroupFields
    }
    ... on Error {
      message
    }
  }
}
    ${HarvestGroupFieldsFragmentDoc}`;
export type CreateHarvestGroupMutationFn = Apollo.MutationFunction<CreateHarvestGroupMutation, CreateHarvestGroupMutationVariables>;

/**
 * __useCreateHarvestGroupMutation__
 *
 * To run a mutation, you first call `useCreateHarvestGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHarvestGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHarvestGroupMutation, { data, loading, error }] = useCreateHarvestGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHarvestGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateHarvestGroupMutation, CreateHarvestGroupMutationVariables>) {
        return Apollo.useMutation<CreateHarvestGroupMutation, CreateHarvestGroupMutationVariables>(CreateHarvestGroupDocument, baseOptions);
      }
export type CreateHarvestGroupMutationHookResult = ReturnType<typeof useCreateHarvestGroupMutation>;
export type CreateHarvestGroupMutationResult = Apollo.MutationResult<CreateHarvestGroupMutation>;
export type CreateHarvestGroupMutationOptions = Apollo.BaseMutationOptions<CreateHarvestGroupMutation, CreateHarvestGroupMutationVariables>;
export const UpdateHarvestGroupDocument = gql`
    mutation updateHarvestGroup($input: UpdateHarvestGroupInput!) {
  updateHarvestGroup(input: $input) {
    ... on HarvestGroup {
      id
      name
      colorHexCode
      startDate
      harvestDate
      isMultisite
      flowerZone {
        id
        name
      }
      site {
        id
        name
      }
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdateHarvestGroupMutationFn = Apollo.MutationFunction<UpdateHarvestGroupMutation, UpdateHarvestGroupMutationVariables>;

/**
 * __useUpdateHarvestGroupMutation__
 *
 * To run a mutation, you first call `useUpdateHarvestGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHarvestGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHarvestGroupMutation, { data, loading, error }] = useUpdateHarvestGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHarvestGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHarvestGroupMutation, UpdateHarvestGroupMutationVariables>) {
        return Apollo.useMutation<UpdateHarvestGroupMutation, UpdateHarvestGroupMutationVariables>(UpdateHarvestGroupDocument, baseOptions);
      }
export type UpdateHarvestGroupMutationHookResult = ReturnType<typeof useUpdateHarvestGroupMutation>;
export type UpdateHarvestGroupMutationResult = Apollo.MutationResult<UpdateHarvestGroupMutation>;
export type UpdateHarvestGroupMutationOptions = Apollo.BaseMutationOptions<UpdateHarvestGroupMutation, UpdateHarvestGroupMutationVariables>;
export const UpdateHarvestGroupArchivedDocument = gql`
    mutation updateHarvestGroupArchived($input: UpdateHarvestGroupArchivedInput!) {
  updateHarvestGroupArchived(input: $input) {
    ... on HarvestGroup {
      ...HarvestGroupFields
    }
    ... on Error {
      message
    }
  }
}
    ${HarvestGroupFieldsFragmentDoc}`;
export type UpdateHarvestGroupArchivedMutationFn = Apollo.MutationFunction<UpdateHarvestGroupArchivedMutation, UpdateHarvestGroupArchivedMutationVariables>;

/**
 * __useUpdateHarvestGroupArchivedMutation__
 *
 * To run a mutation, you first call `useUpdateHarvestGroupArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHarvestGroupArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHarvestGroupArchivedMutation, { data, loading, error }] = useUpdateHarvestGroupArchivedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHarvestGroupArchivedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHarvestGroupArchivedMutation, UpdateHarvestGroupArchivedMutationVariables>) {
        return Apollo.useMutation<UpdateHarvestGroupArchivedMutation, UpdateHarvestGroupArchivedMutationVariables>(UpdateHarvestGroupArchivedDocument, baseOptions);
      }
export type UpdateHarvestGroupArchivedMutationHookResult = ReturnType<typeof useUpdateHarvestGroupArchivedMutation>;
export type UpdateHarvestGroupArchivedMutationResult = Apollo.MutationResult<UpdateHarvestGroupArchivedMutation>;
export type UpdateHarvestGroupArchivedMutationOptions = Apollo.BaseMutationOptions<UpdateHarvestGroupArchivedMutation, UpdateHarvestGroupArchivedMutationVariables>;
export const GenerateHarvestSummaryDocument = gql`
    mutation GenerateHarvestSummary($input: GenerateHarvestSummaryInput!) {
  generateHarvestSummary(input: $input) {
    ... on HarvestGroup {
      id
      name
      aiSummary {
        id
        summaryText
        yieldDriversAnalysis
        status
        generatedAt
      }
    }
    ... on Error {
      message
    }
  }
}
    `;
export type GenerateHarvestSummaryMutationFn = Apollo.MutationFunction<GenerateHarvestSummaryMutation, GenerateHarvestSummaryMutationVariables>;

/**
 * __useGenerateHarvestSummaryMutation__
 *
 * To run a mutation, you first call `useGenerateHarvestSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateHarvestSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateHarvestSummaryMutation, { data, loading, error }] = useGenerateHarvestSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateHarvestSummaryMutation(baseOptions?: Apollo.MutationHookOptions<GenerateHarvestSummaryMutation, GenerateHarvestSummaryMutationVariables>) {
        return Apollo.useMutation<GenerateHarvestSummaryMutation, GenerateHarvestSummaryMutationVariables>(GenerateHarvestSummaryDocument, baseOptions);
      }
export type GenerateHarvestSummaryMutationHookResult = ReturnType<typeof useGenerateHarvestSummaryMutation>;
export type GenerateHarvestSummaryMutationResult = Apollo.MutationResult<GenerateHarvestSummaryMutation>;
export type GenerateHarvestSummaryMutationOptions = Apollo.BaseMutationOptions<GenerateHarvestSummaryMutation, GenerateHarvestSummaryMutationVariables>;
export const CreateHarvestReportDocument = gql`
    mutation createHarvestReport($input: CreateHarvestReportInput!) {
  createHarvestReport(input: $input) {
    ... on HarvestGroup {
      id
      yields {
        ...YieldFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${YieldFieldsFragmentDoc}`;
export type CreateHarvestReportMutationFn = Apollo.MutationFunction<CreateHarvestReportMutation, CreateHarvestReportMutationVariables>;

/**
 * __useCreateHarvestReportMutation__
 *
 * To run a mutation, you first call `useCreateHarvestReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHarvestReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHarvestReportMutation, { data, loading, error }] = useCreateHarvestReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHarvestReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateHarvestReportMutation, CreateHarvestReportMutationVariables>) {
        return Apollo.useMutation<CreateHarvestReportMutation, CreateHarvestReportMutationVariables>(CreateHarvestReportDocument, baseOptions);
      }
export type CreateHarvestReportMutationHookResult = ReturnType<typeof useCreateHarvestReportMutation>;
export type CreateHarvestReportMutationResult = Apollo.MutationResult<CreateHarvestReportMutation>;
export type CreateHarvestReportMutationOptions = Apollo.BaseMutationOptions<CreateHarvestReportMutation, CreateHarvestReportMutationVariables>;
export const UpdateHarvestReportDocument = gql`
    mutation updateHarvestReport($input: UpdateHarvestReportInput!) {
  updateHarvestReport(input: $input) {
    ... on HarvestGroup {
      id
      yields {
        ...YieldFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${YieldFieldsFragmentDoc}`;
export type UpdateHarvestReportMutationFn = Apollo.MutationFunction<UpdateHarvestReportMutation, UpdateHarvestReportMutationVariables>;

/**
 * __useUpdateHarvestReportMutation__
 *
 * To run a mutation, you first call `useUpdateHarvestReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHarvestReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHarvestReportMutation, { data, loading, error }] = useUpdateHarvestReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHarvestReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHarvestReportMutation, UpdateHarvestReportMutationVariables>) {
        return Apollo.useMutation<UpdateHarvestReportMutation, UpdateHarvestReportMutationVariables>(UpdateHarvestReportDocument, baseOptions);
      }
export type UpdateHarvestReportMutationHookResult = ReturnType<typeof useUpdateHarvestReportMutation>;
export type UpdateHarvestReportMutationResult = Apollo.MutationResult<UpdateHarvestReportMutation>;
export type UpdateHarvestReportMutationOptions = Apollo.BaseMutationOptions<UpdateHarvestReportMutation, UpdateHarvestReportMutationVariables>;
export const UpdateHarvestProjectionDocument = gql`
    mutation updateHarvestProjection($input: UpdateHarvestProjectionInput!) {
  updateHarvestProjection(input: $input) {
    ... on HarvestProjection {
      id
      strainId
      plantCount
      harvestGroupId
      strain {
        id
        name
      }
    }
  }
}
    `;
export type UpdateHarvestProjectionMutationFn = Apollo.MutationFunction<UpdateHarvestProjectionMutation, UpdateHarvestProjectionMutationVariables>;

/**
 * __useUpdateHarvestProjectionMutation__
 *
 * To run a mutation, you first call `useUpdateHarvestProjectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHarvestProjectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHarvestProjectionMutation, { data, loading, error }] = useUpdateHarvestProjectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHarvestProjectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHarvestProjectionMutation, UpdateHarvestProjectionMutationVariables>) {
        return Apollo.useMutation<UpdateHarvestProjectionMutation, UpdateHarvestProjectionMutationVariables>(UpdateHarvestProjectionDocument, baseOptions);
      }
export type UpdateHarvestProjectionMutationHookResult = ReturnType<typeof useUpdateHarvestProjectionMutation>;
export type UpdateHarvestProjectionMutationResult = Apollo.MutationResult<UpdateHarvestProjectionMutation>;
export type UpdateHarvestProjectionMutationOptions = Apollo.BaseMutationOptions<UpdateHarvestProjectionMutation, UpdateHarvestProjectionMutationVariables>;
export const HarvestReportDocument = gql`
    query harvestReport($id: String!) {
  harvestGroup(id: $id) {
    id
    yields {
      ...YieldFields
    }
  }
}
    ${YieldFieldsFragmentDoc}`;

/**
 * __useHarvestReportQuery__
 *
 * To run a query within a React component, call `useHarvestReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHarvestReportQuery(baseOptions?: Apollo.QueryHookOptions<HarvestReportQuery, HarvestReportQueryVariables>) {
        return Apollo.useQuery<HarvestReportQuery, HarvestReportQueryVariables>(HarvestReportDocument, baseOptions);
      }
export function useHarvestReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestReportQuery, HarvestReportQueryVariables>) {
          return Apollo.useLazyQuery<HarvestReportQuery, HarvestReportQueryVariables>(HarvestReportDocument, baseOptions);
        }
export type HarvestReportQueryHookResult = ReturnType<typeof useHarvestReportQuery>;
export type HarvestReportLazyQueryHookResult = ReturnType<typeof useHarvestReportLazyQuery>;
export type HarvestReportQueryResult = Apollo.QueryResult<HarvestReportQuery, HarvestReportQueryVariables>;
export const UpdateHarvestYieldsDocument = gql`
    mutation updateHarvestYields($input: UpdateHarvestYieldsInput!) {
  updateHarvestYields(input: $input) {
    ... on HarvestGroup {
      id
      yields {
        strainId
        strain {
          id
          name
        }
        totalGrams
        finalPlantCount
        budFormFactorYields {
          budFormFactorId
          numberOfGrams
        }
      }
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdateHarvestYieldsMutationFn = Apollo.MutationFunction<UpdateHarvestYieldsMutation, UpdateHarvestYieldsMutationVariables>;

/**
 * __useUpdateHarvestYieldsMutation__
 *
 * To run a mutation, you first call `useUpdateHarvestYieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHarvestYieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHarvestYieldsMutation, { data, loading, error }] = useUpdateHarvestYieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHarvestYieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHarvestYieldsMutation, UpdateHarvestYieldsMutationVariables>) {
        return Apollo.useMutation<UpdateHarvestYieldsMutation, UpdateHarvestYieldsMutationVariables>(UpdateHarvestYieldsDocument, baseOptions);
      }
export type UpdateHarvestYieldsMutationHookResult = ReturnType<typeof useUpdateHarvestYieldsMutation>;
export type UpdateHarvestYieldsMutationResult = Apollo.MutationResult<UpdateHarvestYieldsMutation>;
export type UpdateHarvestYieldsMutationOptions = Apollo.BaseMutationOptions<UpdateHarvestYieldsMutation, UpdateHarvestYieldsMutationVariables>;
export const HarvestYieldFormDataDocument = gql`
    query harvestYieldFormData($id: String!, $formFactorFilters: BudFormFactorFilterSetInput) {
  harvestGroup(id: $id) {
    id
    importedFromMetrc
    site {
      id
    }
    yields {
      strainId
      strain {
        id
        name
        yieldEditIdentity {
          id
          name
        }
      }
      totalGrams
      finalPlantCount
      budFormFactorYields {
        budFormFactorId
        budFormFactor {
          id
          name
          classification
          metrcId
          sites {
            id
          }
        }
        numberOfGrams
      }
    }
    stages {
      id
      strainsInStage {
        numberOfPlants
        strain {
          id
          name
          yieldEditIdentity {
            id
            name
          }
        }
      }
    }
    becameProcessingGroup {
      id
      processingGroupStrains {
        ...ProcessingStrainYieldFields
      }
    }
  }
  budFormFactors(filters: $formFactorFilters) {
    id
    name
    classification
    metrcId
    sites {
      id
    }
  }
}
    ${ProcessingStrainYieldFieldsFragmentDoc}`;

/**
 * __useHarvestYieldFormDataQuery__
 *
 * To run a query within a React component, call `useHarvestYieldFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestYieldFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestYieldFormDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      formFactorFilters: // value for 'formFactorFilters'
 *   },
 * });
 */
export function useHarvestYieldFormDataQuery(baseOptions?: Apollo.QueryHookOptions<HarvestYieldFormDataQuery, HarvestYieldFormDataQueryVariables>) {
        return Apollo.useQuery<HarvestYieldFormDataQuery, HarvestYieldFormDataQueryVariables>(HarvestYieldFormDataDocument, baseOptions);
      }
export function useHarvestYieldFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestYieldFormDataQuery, HarvestYieldFormDataQueryVariables>) {
          return Apollo.useLazyQuery<HarvestYieldFormDataQuery, HarvestYieldFormDataQueryVariables>(HarvestYieldFormDataDocument, baseOptions);
        }
export type HarvestYieldFormDataQueryHookResult = ReturnType<typeof useHarvestYieldFormDataQuery>;
export type HarvestYieldFormDataLazyQueryHookResult = ReturnType<typeof useHarvestYieldFormDataLazyQuery>;
export type HarvestYieldFormDataQueryResult = Apollo.QueryResult<HarvestYieldFormDataQuery, HarvestYieldFormDataQueryVariables>;
export const CurrentGroupsHarvestForecastDocument = gql`
    query currentGroupsHarvestForecast($siteId: String) {
  harvestGroups(
    filters: {unarchived: "true", completed: "false", siteId: $siteId}
  ) {
    ...CurrentGroupsHarvestForecastFields
  }
}
    ${CurrentGroupsHarvestForecastFieldsFragmentDoc}`;

/**
 * __useCurrentGroupsHarvestForecastQuery__
 *
 * To run a query within a React component, call `useCurrentGroupsHarvestForecastQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentGroupsHarvestForecastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentGroupsHarvestForecastQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useCurrentGroupsHarvestForecastQuery(baseOptions?: Apollo.QueryHookOptions<CurrentGroupsHarvestForecastQuery, CurrentGroupsHarvestForecastQueryVariables>) {
        return Apollo.useQuery<CurrentGroupsHarvestForecastQuery, CurrentGroupsHarvestForecastQueryVariables>(CurrentGroupsHarvestForecastDocument, baseOptions);
      }
export function useCurrentGroupsHarvestForecastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentGroupsHarvestForecastQuery, CurrentGroupsHarvestForecastQueryVariables>) {
          return Apollo.useLazyQuery<CurrentGroupsHarvestForecastQuery, CurrentGroupsHarvestForecastQueryVariables>(CurrentGroupsHarvestForecastDocument, baseOptions);
        }
export type CurrentGroupsHarvestForecastQueryHookResult = ReturnType<typeof useCurrentGroupsHarvestForecastQuery>;
export type CurrentGroupsHarvestForecastLazyQueryHookResult = ReturnType<typeof useCurrentGroupsHarvestForecastLazyQuery>;
export type CurrentGroupsHarvestForecastQueryResult = Apollo.QueryResult<CurrentGroupsHarvestForecastQuery, CurrentGroupsHarvestForecastQueryVariables>;
export const CompleteHarvestDocument = gql`
    mutation completeHarvest($input: CompleteHarvestInput!) {
  completeHarvest(input: $input) {
    ... on HarvestCompletion {
      ...HarvestCompletionFields
    }
    ... on Error {
      message
    }
  }
}
    ${HarvestCompletionFieldsFragmentDoc}`;
export type CompleteHarvestMutationFn = Apollo.MutationFunction<CompleteHarvestMutation, CompleteHarvestMutationVariables>;

/**
 * __useCompleteHarvestMutation__
 *
 * To run a mutation, you first call `useCompleteHarvestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteHarvestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeHarvestMutation, { data, loading, error }] = useCompleteHarvestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteHarvestMutation(baseOptions?: Apollo.MutationHookOptions<CompleteHarvestMutation, CompleteHarvestMutationVariables>) {
        return Apollo.useMutation<CompleteHarvestMutation, CompleteHarvestMutationVariables>(CompleteHarvestDocument, baseOptions);
      }
export type CompleteHarvestMutationHookResult = ReturnType<typeof useCompleteHarvestMutation>;
export type CompleteHarvestMutationResult = Apollo.MutationResult<CompleteHarvestMutation>;
export type CompleteHarvestMutationOptions = Apollo.BaseMutationOptions<CompleteHarvestMutation, CompleteHarvestMutationVariables>;
export const ApproveHarvestCompletionDocument = gql`
    mutation approveHarvestCompletion($input: ApproveHarvestCompletionInput!) {
  approveHarvestCompletion(input: $input) {
    ... on HarvestCompletion {
      ...HarvestCompletionFields
    }
    ... on Error {
      message
    }
  }
}
    ${HarvestCompletionFieldsFragmentDoc}`;
export type ApproveHarvestCompletionMutationFn = Apollo.MutationFunction<ApproveHarvestCompletionMutation, ApproveHarvestCompletionMutationVariables>;

/**
 * __useApproveHarvestCompletionMutation__
 *
 * To run a mutation, you first call `useApproveHarvestCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveHarvestCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveHarvestCompletionMutation, { data, loading, error }] = useApproveHarvestCompletionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveHarvestCompletionMutation(baseOptions?: Apollo.MutationHookOptions<ApproveHarvestCompletionMutation, ApproveHarvestCompletionMutationVariables>) {
        return Apollo.useMutation<ApproveHarvestCompletionMutation, ApproveHarvestCompletionMutationVariables>(ApproveHarvestCompletionDocument, baseOptions);
      }
export type ApproveHarvestCompletionMutationHookResult = ReturnType<typeof useApproveHarvestCompletionMutation>;
export type ApproveHarvestCompletionMutationResult = Apollo.MutationResult<ApproveHarvestCompletionMutation>;
export type ApproveHarvestCompletionMutationOptions = Apollo.BaseMutationOptions<ApproveHarvestCompletionMutation, ApproveHarvestCompletionMutationVariables>;
export const ArchiveHarvestGroupDocument = gql`
    mutation archiveHarvestGroup($id: ID!) {
  updateHarvestGroupArchived(input: {archivedAt: "true", id: $id}) {
    ... on HarvestGroup {
      ...HarvestGroupFields
    }
    ... on Error {
      message
    }
  }
}
    ${HarvestGroupFieldsFragmentDoc}`;
export type ArchiveHarvestGroupMutationFn = Apollo.MutationFunction<ArchiveHarvestGroupMutation, ArchiveHarvestGroupMutationVariables>;

/**
 * __useArchiveHarvestGroupMutation__
 *
 * To run a mutation, you first call `useArchiveHarvestGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveHarvestGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveHarvestGroupMutation, { data, loading, error }] = useArchiveHarvestGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveHarvestGroupMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveHarvestGroupMutation, ArchiveHarvestGroupMutationVariables>) {
        return Apollo.useMutation<ArchiveHarvestGroupMutation, ArchiveHarvestGroupMutationVariables>(ArchiveHarvestGroupDocument, baseOptions);
      }
export type ArchiveHarvestGroupMutationHookResult = ReturnType<typeof useArchiveHarvestGroupMutation>;
export type ArchiveHarvestGroupMutationResult = Apollo.MutationResult<ArchiveHarvestGroupMutation>;
export type ArchiveHarvestGroupMutationOptions = Apollo.BaseMutationOptions<ArchiveHarvestGroupMutation, ArchiveHarvestGroupMutationVariables>;
export const UnarchiveHarvestGroupDocument = gql`
    mutation unarchiveHarvestGroup($id: ID!) {
  updateHarvestGroupArchived(input: {archivedAt: "false", id: $id}) {
    ... on HarvestGroup {
      ...HarvestGroupFields
    }
    ... on Error {
      message
    }
  }
}
    ${HarvestGroupFieldsFragmentDoc}`;
export type UnarchiveHarvestGroupMutationFn = Apollo.MutationFunction<UnarchiveHarvestGroupMutation, UnarchiveHarvestGroupMutationVariables>;

/**
 * __useUnarchiveHarvestGroupMutation__
 *
 * To run a mutation, you first call `useUnarchiveHarvestGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveHarvestGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveHarvestGroupMutation, { data, loading, error }] = useUnarchiveHarvestGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveHarvestGroupMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveHarvestGroupMutation, UnarchiveHarvestGroupMutationVariables>) {
        return Apollo.useMutation<UnarchiveHarvestGroupMutation, UnarchiveHarvestGroupMutationVariables>(UnarchiveHarvestGroupDocument, baseOptions);
      }
export type UnarchiveHarvestGroupMutationHookResult = ReturnType<typeof useUnarchiveHarvestGroupMutation>;
export type UnarchiveHarvestGroupMutationResult = Apollo.MutationResult<UnarchiveHarvestGroupMutation>;
export type UnarchiveHarvestGroupMutationOptions = Apollo.BaseMutationOptions<UnarchiveHarvestGroupMutation, UnarchiveHarvestGroupMutationVariables>;
export const HarvestGroupWithLogEntriesDocument = gql`
    query harvestGroupWithLogEntries($id: String!, $logEntryOptions: LogsFilterInput) {
  harvestGroup(id: $id) {
    ...HarvestGroupWithLogEntries
  }
}
    ${HarvestGroupWithLogEntriesFragmentDoc}`;

/**
 * __useHarvestGroupWithLogEntriesQuery__
 *
 * To run a query within a React component, call `useHarvestGroupWithLogEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestGroupWithLogEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestGroupWithLogEntriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      logEntryOptions: // value for 'logEntryOptions'
 *   },
 * });
 */
export function useHarvestGroupWithLogEntriesQuery(baseOptions?: Apollo.QueryHookOptions<HarvestGroupWithLogEntriesQuery, HarvestGroupWithLogEntriesQueryVariables>) {
        return Apollo.useQuery<HarvestGroupWithLogEntriesQuery, HarvestGroupWithLogEntriesQueryVariables>(HarvestGroupWithLogEntriesDocument, baseOptions);
      }
export function useHarvestGroupWithLogEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestGroupWithLogEntriesQuery, HarvestGroupWithLogEntriesQueryVariables>) {
          return Apollo.useLazyQuery<HarvestGroupWithLogEntriesQuery, HarvestGroupWithLogEntriesQueryVariables>(HarvestGroupWithLogEntriesDocument, baseOptions);
        }
export type HarvestGroupWithLogEntriesQueryHookResult = ReturnType<typeof useHarvestGroupWithLogEntriesQuery>;
export type HarvestGroupWithLogEntriesLazyQueryHookResult = ReturnType<typeof useHarvestGroupWithLogEntriesLazyQuery>;
export type HarvestGroupWithLogEntriesQueryResult = Apollo.QueryResult<HarvestGroupWithLogEntriesQuery, HarvestGroupWithLogEntriesQueryVariables>;
export const HarvestGroupsWithTemplateDocument = gql`
    query harvestGroupsWithTemplate($id: String!) {
  harvestGroupsWithTemplate(id: $id) {
    id
    name
    startDate
    harvestDate
    stages {
      id
      name
      startDate
      endDate
      desiredNumberOfDays
      templateUsed {
        id
        createdStageName
        numberOfDays
      }
    }
  }
}
    `;

/**
 * __useHarvestGroupsWithTemplateQuery__
 *
 * To run a query within a React component, call `useHarvestGroupsWithTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestGroupsWithTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestGroupsWithTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHarvestGroupsWithTemplateQuery(baseOptions?: Apollo.QueryHookOptions<HarvestGroupsWithTemplateQuery, HarvestGroupsWithTemplateQueryVariables>) {
        return Apollo.useQuery<HarvestGroupsWithTemplateQuery, HarvestGroupsWithTemplateQueryVariables>(HarvestGroupsWithTemplateDocument, baseOptions);
      }
export function useHarvestGroupsWithTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestGroupsWithTemplateQuery, HarvestGroupsWithTemplateQueryVariables>) {
          return Apollo.useLazyQuery<HarvestGroupsWithTemplateQuery, HarvestGroupsWithTemplateQueryVariables>(HarvestGroupsWithTemplateDocument, baseOptions);
        }
export type HarvestGroupsWithTemplateQueryHookResult = ReturnType<typeof useHarvestGroupsWithTemplateQuery>;
export type HarvestGroupsWithTemplateLazyQueryHookResult = ReturnType<typeof useHarvestGroupsWithTemplateLazyQuery>;
export type HarvestGroupsWithTemplateQueryResult = Apollo.QueryResult<HarvestGroupsWithTemplateQuery, HarvestGroupsWithTemplateQueryVariables>;
export const HarvestGroupWithProcessingAndFormFactorsDocument = gql`
    query harvestGroupWithProcessingAndFormFactors($id: String!, $filters: BudFormFactorFilterSetInput) {
  harvestGroup(id: $id) {
    ...HarvestGroupDetailFields
    ...HarvestBecameProcessingFields
  }
  budFormFactors(filters: $filters) {
    ...BudFormFactorFields
  }
}
    ${HarvestGroupDetailFieldsFragmentDoc}
${HarvestBecameProcessingFieldsFragmentDoc}
${BudFormFactorFieldsFragmentDoc}`;

/**
 * __useHarvestGroupWithProcessingAndFormFactorsQuery__
 *
 * To run a query within a React component, call `useHarvestGroupWithProcessingAndFormFactorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestGroupWithProcessingAndFormFactorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestGroupWithProcessingAndFormFactorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useHarvestGroupWithProcessingAndFormFactorsQuery(baseOptions?: Apollo.QueryHookOptions<HarvestGroupWithProcessingAndFormFactorsQuery, HarvestGroupWithProcessingAndFormFactorsQueryVariables>) {
        return Apollo.useQuery<HarvestGroupWithProcessingAndFormFactorsQuery, HarvestGroupWithProcessingAndFormFactorsQueryVariables>(HarvestGroupWithProcessingAndFormFactorsDocument, baseOptions);
      }
export function useHarvestGroupWithProcessingAndFormFactorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestGroupWithProcessingAndFormFactorsQuery, HarvestGroupWithProcessingAndFormFactorsQueryVariables>) {
          return Apollo.useLazyQuery<HarvestGroupWithProcessingAndFormFactorsQuery, HarvestGroupWithProcessingAndFormFactorsQueryVariables>(HarvestGroupWithProcessingAndFormFactorsDocument, baseOptions);
        }
export type HarvestGroupWithProcessingAndFormFactorsQueryHookResult = ReturnType<typeof useHarvestGroupWithProcessingAndFormFactorsQuery>;
export type HarvestGroupWithProcessingAndFormFactorsLazyQueryHookResult = ReturnType<typeof useHarvestGroupWithProcessingAndFormFactorsLazyQuery>;
export type HarvestGroupWithProcessingAndFormFactorsQueryResult = Apollo.QueryResult<HarvestGroupWithProcessingAndFormFactorsQuery, HarvestGroupWithProcessingAndFormFactorsQueryVariables>;
export const UpdateHarvestGroupFlowerZoneDocument = gql`
    mutation updateHarvestGroupFlowerZone($input: UpdateHarvestGroupFlowerZoneInput!) {
  updateHarvestGroupFlowerZone(input: $input) {
    ... on HarvestGroup {
      id
      flowerZone {
        id
        name
      }
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdateHarvestGroupFlowerZoneMutationFn = Apollo.MutationFunction<UpdateHarvestGroupFlowerZoneMutation, UpdateHarvestGroupFlowerZoneMutationVariables>;

/**
 * __useUpdateHarvestGroupFlowerZoneMutation__
 *
 * To run a mutation, you first call `useUpdateHarvestGroupFlowerZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHarvestGroupFlowerZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHarvestGroupFlowerZoneMutation, { data, loading, error }] = useUpdateHarvestGroupFlowerZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHarvestGroupFlowerZoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHarvestGroupFlowerZoneMutation, UpdateHarvestGroupFlowerZoneMutationVariables>) {
        return Apollo.useMutation<UpdateHarvestGroupFlowerZoneMutation, UpdateHarvestGroupFlowerZoneMutationVariables>(UpdateHarvestGroupFlowerZoneDocument, baseOptions);
      }
export type UpdateHarvestGroupFlowerZoneMutationHookResult = ReturnType<typeof useUpdateHarvestGroupFlowerZoneMutation>;
export type UpdateHarvestGroupFlowerZoneMutationResult = Apollo.MutationResult<UpdateHarvestGroupFlowerZoneMutation>;
export type UpdateHarvestGroupFlowerZoneMutationOptions = Apollo.BaseMutationOptions<UpdateHarvestGroupFlowerZoneMutation, UpdateHarvestGroupFlowerZoneMutationVariables>;
export const AddObservationDocument = gql`
    mutation addObservation($input: LogEntryInput!) {
  addObservationLogEntry(input: $input) {
    ... on LogEntry {
      ...LogEntryFields
    }
    ... on Error {
      message
    }
  }
}
    ${LogEntryFieldsFragmentDoc}`;
export type AddObservationMutationFn = Apollo.MutationFunction<AddObservationMutation, AddObservationMutationVariables>;

/**
 * __useAddObservationMutation__
 *
 * To run a mutation, you first call `useAddObservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddObservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addObservationMutation, { data, loading, error }] = useAddObservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddObservationMutation(baseOptions?: Apollo.MutationHookOptions<AddObservationMutation, AddObservationMutationVariables>) {
        return Apollo.useMutation<AddObservationMutation, AddObservationMutationVariables>(AddObservationDocument, baseOptions);
      }
export type AddObservationMutationHookResult = ReturnType<typeof useAddObservationMutation>;
export type AddObservationMutationResult = Apollo.MutationResult<AddObservationMutation>;
export type AddObservationMutationOptions = Apollo.BaseMutationOptions<AddObservationMutation, AddObservationMutationVariables>;
export const AddIssueDocument = gql`
    mutation addIssue($input: LogEntryInput!) {
  addIssueLogEntry(input: $input) {
    ... on LogEntry {
      ...LogEntryFields
    }
    ... on Error {
      message
    }
  }
}
    ${LogEntryFieldsFragmentDoc}`;
export type AddIssueMutationFn = Apollo.MutationFunction<AddIssueMutation, AddIssueMutationVariables>;

/**
 * __useAddIssueMutation__
 *
 * To run a mutation, you first call `useAddIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIssueMutation, { data, loading, error }] = useAddIssueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddIssueMutation(baseOptions?: Apollo.MutationHookOptions<AddIssueMutation, AddIssueMutationVariables>) {
        return Apollo.useMutation<AddIssueMutation, AddIssueMutationVariables>(AddIssueDocument, baseOptions);
      }
export type AddIssueMutationHookResult = ReturnType<typeof useAddIssueMutation>;
export type AddIssueMutationResult = Apollo.MutationResult<AddIssueMutation>;
export type AddIssueMutationOptions = Apollo.BaseMutationOptions<AddIssueMutation, AddIssueMutationVariables>;
export const AddIrrigationActivityDocument = gql`
    mutation addIrrigationActivity($input: LogEntryInput!) {
  addIrrigationLogEntry(input: $input) {
    ... on LogEntry {
      ...LogEntryFields
    }
    ... on Error {
      message
    }
  }
}
    ${LogEntryFieldsFragmentDoc}`;
export type AddIrrigationActivityMutationFn = Apollo.MutationFunction<AddIrrigationActivityMutation, AddIrrigationActivityMutationVariables>;

/**
 * __useAddIrrigationActivityMutation__
 *
 * To run a mutation, you first call `useAddIrrigationActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIrrigationActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIrrigationActivityMutation, { data, loading, error }] = useAddIrrigationActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddIrrigationActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddIrrigationActivityMutation, AddIrrigationActivityMutationVariables>) {
        return Apollo.useMutation<AddIrrigationActivityMutation, AddIrrigationActivityMutationVariables>(AddIrrigationActivityDocument, baseOptions);
      }
export type AddIrrigationActivityMutationHookResult = ReturnType<typeof useAddIrrigationActivityMutation>;
export type AddIrrigationActivityMutationResult = Apollo.MutationResult<AddIrrigationActivityMutation>;
export type AddIrrigationActivityMutationOptions = Apollo.BaseMutationOptions<AddIrrigationActivityMutation, AddIrrigationActivityMutationVariables>;
export const AddFoliarActivityDocument = gql`
    mutation addFoliarActivity($input: LogEntryInput!) {
  addFoliarLogEntry(input: $input) {
    ... on LogEntry {
      ...LogEntryFields
    }
    ... on Error {
      message
    }
  }
}
    ${LogEntryFieldsFragmentDoc}`;
export type AddFoliarActivityMutationFn = Apollo.MutationFunction<AddFoliarActivityMutation, AddFoliarActivityMutationVariables>;

/**
 * __useAddFoliarActivityMutation__
 *
 * To run a mutation, you first call `useAddFoliarActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFoliarActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFoliarActivityMutation, { data, loading, error }] = useAddFoliarActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFoliarActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddFoliarActivityMutation, AddFoliarActivityMutationVariables>) {
        return Apollo.useMutation<AddFoliarActivityMutation, AddFoliarActivityMutationVariables>(AddFoliarActivityDocument, baseOptions);
      }
export type AddFoliarActivityMutationHookResult = ReturnType<typeof useAddFoliarActivityMutation>;
export type AddFoliarActivityMutationResult = Apollo.MutationResult<AddFoliarActivityMutation>;
export type AddFoliarActivityMutationOptions = Apollo.BaseMutationOptions<AddFoliarActivityMutation, AddFoliarActivityMutationVariables>;
export const AddPruningActivityDocument = gql`
    mutation addPruningActivity($input: LogEntryInput!) {
  addPruningLogEntry(input: $input) {
    ... on LogEntry {
      ...LogEntryFields
    }
    ... on Error {
      message
    }
  }
}
    ${LogEntryFieldsFragmentDoc}`;
export type AddPruningActivityMutationFn = Apollo.MutationFunction<AddPruningActivityMutation, AddPruningActivityMutationVariables>;

/**
 * __useAddPruningActivityMutation__
 *
 * To run a mutation, you first call `useAddPruningActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPruningActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPruningActivityMutation, { data, loading, error }] = useAddPruningActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPruningActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddPruningActivityMutation, AddPruningActivityMutationVariables>) {
        return Apollo.useMutation<AddPruningActivityMutation, AddPruningActivityMutationVariables>(AddPruningActivityDocument, baseOptions);
      }
export type AddPruningActivityMutationHookResult = ReturnType<typeof useAddPruningActivityMutation>;
export type AddPruningActivityMutationResult = Apollo.MutationResult<AddPruningActivityMutation>;
export type AddPruningActivityMutationOptions = Apollo.BaseMutationOptions<AddPruningActivityMutation, AddPruningActivityMutationVariables>;
export const AddDefoliateActivityDocument = gql`
    mutation addDefoliateActivity($input: LogEntryInput!) {
  addDefoliateLogEntry(input: $input) {
    ... on LogEntry {
      ...LogEntryFields
    }
    ... on Error {
      message
    }
  }
}
    ${LogEntryFieldsFragmentDoc}`;
export type AddDefoliateActivityMutationFn = Apollo.MutationFunction<AddDefoliateActivityMutation, AddDefoliateActivityMutationVariables>;

/**
 * __useAddDefoliateActivityMutation__
 *
 * To run a mutation, you first call `useAddDefoliateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDefoliateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDefoliateActivityMutation, { data, loading, error }] = useAddDefoliateActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDefoliateActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddDefoliateActivityMutation, AddDefoliateActivityMutationVariables>) {
        return Apollo.useMutation<AddDefoliateActivityMutation, AddDefoliateActivityMutationVariables>(AddDefoliateActivityDocument, baseOptions);
      }
export type AddDefoliateActivityMutationHookResult = ReturnType<typeof useAddDefoliateActivityMutation>;
export type AddDefoliateActivityMutationResult = Apollo.MutationResult<AddDefoliateActivityMutation>;
export type AddDefoliateActivityMutationOptions = Apollo.BaseMutationOptions<AddDefoliateActivityMutation, AddDefoliateActivityMutationVariables>;
export const AddToppingActivityDocument = gql`
    mutation addToppingActivity($input: LogEntryInput!) {
  addToppingLogEntry(input: $input) {
    ... on LogEntry {
      ...LogEntryFields
    }
    ... on Error {
      message
    }
  }
}
    ${LogEntryFieldsFragmentDoc}`;
export type AddToppingActivityMutationFn = Apollo.MutationFunction<AddToppingActivityMutation, AddToppingActivityMutationVariables>;

/**
 * __useAddToppingActivityMutation__
 *
 * To run a mutation, you first call `useAddToppingActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToppingActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToppingActivityMutation, { data, loading, error }] = useAddToppingActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddToppingActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddToppingActivityMutation, AddToppingActivityMutationVariables>) {
        return Apollo.useMutation<AddToppingActivityMutation, AddToppingActivityMutationVariables>(AddToppingActivityDocument, baseOptions);
      }
export type AddToppingActivityMutationHookResult = ReturnType<typeof useAddToppingActivityMutation>;
export type AddToppingActivityMutationResult = Apollo.MutationResult<AddToppingActivityMutation>;
export type AddToppingActivityMutationOptions = Apollo.BaseMutationOptions<AddToppingActivityMutation, AddToppingActivityMutationVariables>;
export const AddGreenWasteActivityDocument = gql`
    mutation addGreenWasteActivity($input: LogEntryInput!) {
  addGreenWasteLogEntry(input: $input) {
    ... on LogEntry {
      ...LogEntryFields
    }
    ... on Error {
      message
    }
  }
}
    ${LogEntryFieldsFragmentDoc}`;
export type AddGreenWasteActivityMutationFn = Apollo.MutationFunction<AddGreenWasteActivityMutation, AddGreenWasteActivityMutationVariables>;

/**
 * __useAddGreenWasteActivityMutation__
 *
 * To run a mutation, you first call `useAddGreenWasteActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGreenWasteActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGreenWasteActivityMutation, { data, loading, error }] = useAddGreenWasteActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddGreenWasteActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddGreenWasteActivityMutation, AddGreenWasteActivityMutationVariables>) {
        return Apollo.useMutation<AddGreenWasteActivityMutation, AddGreenWasteActivityMutationVariables>(AddGreenWasteActivityDocument, baseOptions);
      }
export type AddGreenWasteActivityMutationHookResult = ReturnType<typeof useAddGreenWasteActivityMutation>;
export type AddGreenWasteActivityMutationResult = Apollo.MutationResult<AddGreenWasteActivityMutation>;
export type AddGreenWasteActivityMutationOptions = Apollo.BaseMutationOptions<AddGreenWasteActivityMutation, AddGreenWasteActivityMutationVariables>;
export const AddRunOffActivityDocument = gql`
    mutation addRunOffActivity($input: LogEntryInput!) {
  addRunOffLogEntry(input: $input) {
    ... on LogEntry {
      ...LogEntryFields
    }
    ... on Error {
      message
    }
  }
}
    ${LogEntryFieldsFragmentDoc}`;
export type AddRunOffActivityMutationFn = Apollo.MutationFunction<AddRunOffActivityMutation, AddRunOffActivityMutationVariables>;

/**
 * __useAddRunOffActivityMutation__
 *
 * To run a mutation, you first call `useAddRunOffActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRunOffActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRunOffActivityMutation, { data, loading, error }] = useAddRunOffActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRunOffActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddRunOffActivityMutation, AddRunOffActivityMutationVariables>) {
        return Apollo.useMutation<AddRunOffActivityMutation, AddRunOffActivityMutationVariables>(AddRunOffActivityDocument, baseOptions);
      }
export type AddRunOffActivityMutationHookResult = ReturnType<typeof useAddRunOffActivityMutation>;
export type AddRunOffActivityMutationResult = Apollo.MutationResult<AddRunOffActivityMutation>;
export type AddRunOffActivityMutationOptions = Apollo.BaseMutationOptions<AddRunOffActivityMutation, AddRunOffActivityMutationVariables>;
export const DeleteLogEntryDocument = gql`
    mutation deleteLogEntry($input: DeleteLogEntryInput!) {
  deleteLogEntry(input: $input) {
    success
  }
}
    `;
export type DeleteLogEntryMutationFn = Apollo.MutationFunction<DeleteLogEntryMutation, DeleteLogEntryMutationVariables>;

/**
 * __useDeleteLogEntryMutation__
 *
 * To run a mutation, you first call `useDeleteLogEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLogEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLogEntryMutation, { data, loading, error }] = useDeleteLogEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLogEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLogEntryMutation, DeleteLogEntryMutationVariables>) {
        return Apollo.useMutation<DeleteLogEntryMutation, DeleteLogEntryMutationVariables>(DeleteLogEntryDocument, baseOptions);
      }
export type DeleteLogEntryMutationHookResult = ReturnType<typeof useDeleteLogEntryMutation>;
export type DeleteLogEntryMutationResult = Apollo.MutationResult<DeleteLogEntryMutation>;
export type DeleteLogEntryMutationOptions = Apollo.BaseMutationOptions<DeleteLogEntryMutation, DeleteLogEntryMutationVariables>;
export const ApproveLogEntryDocument = gql`
    mutation approveLogEntry($input: ApproveLogEntryInput!) {
  approveLogEntry(input: $input) {
    ... on LogEntry {
      ...LogEntryFields
    }
    ... on Error {
      message
    }
  }
}
    ${LogEntryFieldsFragmentDoc}`;
export type ApproveLogEntryMutationFn = Apollo.MutationFunction<ApproveLogEntryMutation, ApproveLogEntryMutationVariables>;

/**
 * __useApproveLogEntryMutation__
 *
 * To run a mutation, you first call `useApproveLogEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveLogEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveLogEntryMutation, { data, loading, error }] = useApproveLogEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveLogEntryMutation(baseOptions?: Apollo.MutationHookOptions<ApproveLogEntryMutation, ApproveLogEntryMutationVariables>) {
        return Apollo.useMutation<ApproveLogEntryMutation, ApproveLogEntryMutationVariables>(ApproveLogEntryDocument, baseOptions);
      }
export type ApproveLogEntryMutationHookResult = ReturnType<typeof useApproveLogEntryMutation>;
export type ApproveLogEntryMutationResult = Apollo.MutationResult<ApproveLogEntryMutation>;
export type ApproveLogEntryMutationOptions = Apollo.BaseMutationOptions<ApproveLogEntryMutation, ApproveLogEntryMutationVariables>;
export const MaintenanceRequestsDocument = gql`
    query maintenanceRequests {
  maintenanceRequests {
    ...MaintenanceRequestFields
  }
}
    ${MaintenanceRequestFieldsFragmentDoc}`;

/**
 * __useMaintenanceRequestsQuery__
 *
 * To run a query within a React component, call `useMaintenanceRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaintenanceRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaintenanceRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaintenanceRequestsQuery(baseOptions?: Apollo.QueryHookOptions<MaintenanceRequestsQuery, MaintenanceRequestsQueryVariables>) {
        return Apollo.useQuery<MaintenanceRequestsQuery, MaintenanceRequestsQueryVariables>(MaintenanceRequestsDocument, baseOptions);
      }
export function useMaintenanceRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaintenanceRequestsQuery, MaintenanceRequestsQueryVariables>) {
          return Apollo.useLazyQuery<MaintenanceRequestsQuery, MaintenanceRequestsQueryVariables>(MaintenanceRequestsDocument, baseOptions);
        }
export type MaintenanceRequestsQueryHookResult = ReturnType<typeof useMaintenanceRequestsQuery>;
export type MaintenanceRequestsLazyQueryHookResult = ReturnType<typeof useMaintenanceRequestsLazyQuery>;
export type MaintenanceRequestsQueryResult = Apollo.QueryResult<MaintenanceRequestsQuery, MaintenanceRequestsQueryVariables>;
export const CreateMaintenanceRequestDocument = gql`
    mutation createMaintenanceRequest($input: CreateMaintenanceRequestInput!) {
  createMaintenanceRequest(input: $input) {
    ... on MaintenanceRequest {
      ...MaintenanceRequestFields
    }
    ... on Error {
      message
    }
  }
}
    ${MaintenanceRequestFieldsFragmentDoc}`;
export type CreateMaintenanceRequestMutationFn = Apollo.MutationFunction<CreateMaintenanceRequestMutation, CreateMaintenanceRequestMutationVariables>;

/**
 * __useCreateMaintenanceRequestMutation__
 *
 * To run a mutation, you first call `useCreateMaintenanceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMaintenanceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMaintenanceRequestMutation, { data, loading, error }] = useCreateMaintenanceRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMaintenanceRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateMaintenanceRequestMutation, CreateMaintenanceRequestMutationVariables>) {
        return Apollo.useMutation<CreateMaintenanceRequestMutation, CreateMaintenanceRequestMutationVariables>(CreateMaintenanceRequestDocument, baseOptions);
      }
export type CreateMaintenanceRequestMutationHookResult = ReturnType<typeof useCreateMaintenanceRequestMutation>;
export type CreateMaintenanceRequestMutationResult = Apollo.MutationResult<CreateMaintenanceRequestMutation>;
export type CreateMaintenanceRequestMutationOptions = Apollo.BaseMutationOptions<CreateMaintenanceRequestMutation, CreateMaintenanceRequestMutationVariables>;
export const ResolveMaintenanceRequestDocument = gql`
    mutation resolveMaintenanceRequest($input: ResolveMaintenanceRequestInput!) {
  resolveMaintenanceRequest(input: $input) {
    ... on MaintenanceRequest {
      id
      ...MaintenanceRequestResolutionFields
    }
    ... on Error {
      message
    }
  }
}
    ${MaintenanceRequestResolutionFieldsFragmentDoc}`;
export type ResolveMaintenanceRequestMutationFn = Apollo.MutationFunction<ResolveMaintenanceRequestMutation, ResolveMaintenanceRequestMutationVariables>;

/**
 * __useResolveMaintenanceRequestMutation__
 *
 * To run a mutation, you first call `useResolveMaintenanceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveMaintenanceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveMaintenanceRequestMutation, { data, loading, error }] = useResolveMaintenanceRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveMaintenanceRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResolveMaintenanceRequestMutation, ResolveMaintenanceRequestMutationVariables>) {
        return Apollo.useMutation<ResolveMaintenanceRequestMutation, ResolveMaintenanceRequestMutationVariables>(ResolveMaintenanceRequestDocument, baseOptions);
      }
export type ResolveMaintenanceRequestMutationHookResult = ReturnType<typeof useResolveMaintenanceRequestMutation>;
export type ResolveMaintenanceRequestMutationResult = Apollo.MutationResult<ResolveMaintenanceRequestMutation>;
export type ResolveMaintenanceRequestMutationOptions = Apollo.BaseMutationOptions<ResolveMaintenanceRequestMutation, ResolveMaintenanceRequestMutationVariables>;
export const CreateEquipmentDocument = gql`
    mutation createEquipment($input: CreateEquipmentInput!) {
  createEquipment(input: $input) {
    ... on Equipment {
      ...EquipmentFields
    }
    ... on Error {
      message
    }
  }
}
    ${EquipmentFieldsFragmentDoc}`;
export type CreateEquipmentMutationFn = Apollo.MutationFunction<CreateEquipmentMutation, CreateEquipmentMutationVariables>;

/**
 * __useCreateEquipmentMutation__
 *
 * To run a mutation, you first call `useCreateEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEquipmentMutation, { data, loading, error }] = useCreateEquipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateEquipmentMutation, CreateEquipmentMutationVariables>) {
        return Apollo.useMutation<CreateEquipmentMutation, CreateEquipmentMutationVariables>(CreateEquipmentDocument, baseOptions);
      }
export type CreateEquipmentMutationHookResult = ReturnType<typeof useCreateEquipmentMutation>;
export type CreateEquipmentMutationResult = Apollo.MutationResult<CreateEquipmentMutation>;
export type CreateEquipmentMutationOptions = Apollo.BaseMutationOptions<CreateEquipmentMutation, CreateEquipmentMutationVariables>;
export const UpdateEquipmentDocument = gql`
    mutation updateEquipment($input: UpdateEquipmentInput!) {
  updateEquipment(input: $input) {
    ... on Equipment {
      ...EquipmentFields
    }
    ... on Error {
      message
    }
  }
}
    ${EquipmentFieldsFragmentDoc}`;
export type UpdateEquipmentMutationFn = Apollo.MutationFunction<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>;

/**
 * __useUpdateEquipmentMutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentMutation, { data, loading, error }] = useUpdateEquipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>) {
        return Apollo.useMutation<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>(UpdateEquipmentDocument, baseOptions);
      }
export type UpdateEquipmentMutationHookResult = ReturnType<typeof useUpdateEquipmentMutation>;
export type UpdateEquipmentMutationResult = Apollo.MutationResult<UpdateEquipmentMutation>;
export type UpdateEquipmentMutationOptions = Apollo.BaseMutationOptions<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>;
export const BulkCreateEquipmentDocument = gql`
    mutation bulkCreateEquipment($input: BulkCreateEquipmentInput!) {
  bulkCreateEquipment(input: $input) {
    ...EquipmentFields
  }
}
    ${EquipmentFieldsFragmentDoc}`;
export type BulkCreateEquipmentMutationFn = Apollo.MutationFunction<BulkCreateEquipmentMutation, BulkCreateEquipmentMutationVariables>;

/**
 * __useBulkCreateEquipmentMutation__
 *
 * To run a mutation, you first call `useBulkCreateEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateEquipmentMutation, { data, loading, error }] = useBulkCreateEquipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkCreateEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateEquipmentMutation, BulkCreateEquipmentMutationVariables>) {
        return Apollo.useMutation<BulkCreateEquipmentMutation, BulkCreateEquipmentMutationVariables>(BulkCreateEquipmentDocument, baseOptions);
      }
export type BulkCreateEquipmentMutationHookResult = ReturnType<typeof useBulkCreateEquipmentMutation>;
export type BulkCreateEquipmentMutationResult = Apollo.MutationResult<BulkCreateEquipmentMutation>;
export type BulkCreateEquipmentMutationOptions = Apollo.BaseMutationOptions<BulkCreateEquipmentMutation, BulkCreateEquipmentMutationVariables>;
export const NutrientsDocument = gql`
    query nutrients($filters: NutrientFilterSetInput) {
  nutrients(filters: $filters) {
    ...NutrientFields
  }
}
    ${NutrientFieldsFragmentDoc}`;

/**
 * __useNutrientsQuery__
 *
 * To run a query within a React component, call `useNutrientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNutrientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNutrientsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useNutrientsQuery(baseOptions?: Apollo.QueryHookOptions<NutrientsQuery, NutrientsQueryVariables>) {
        return Apollo.useQuery<NutrientsQuery, NutrientsQueryVariables>(NutrientsDocument, baseOptions);
      }
export function useNutrientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NutrientsQuery, NutrientsQueryVariables>) {
          return Apollo.useLazyQuery<NutrientsQuery, NutrientsQueryVariables>(NutrientsDocument, baseOptions);
        }
export type NutrientsQueryHookResult = ReturnType<typeof useNutrientsQuery>;
export type NutrientsLazyQueryHookResult = ReturnType<typeof useNutrientsLazyQuery>;
export type NutrientsQueryResult = Apollo.QueryResult<NutrientsQuery, NutrientsQueryVariables>;
export const CreateNutrientDocument = gql`
    mutation createNutrient($input: CreateNutrientInput!) {
  createNutrient(input: $input) {
    ... on Nutrient {
      ...NutrientFields
    }
    ... on Error {
      message
    }
  }
}
    ${NutrientFieldsFragmentDoc}`;
export type CreateNutrientMutationFn = Apollo.MutationFunction<CreateNutrientMutation, CreateNutrientMutationVariables>;

/**
 * __useCreateNutrientMutation__
 *
 * To run a mutation, you first call `useCreateNutrientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNutrientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNutrientMutation, { data, loading, error }] = useCreateNutrientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNutrientMutation(baseOptions?: Apollo.MutationHookOptions<CreateNutrientMutation, CreateNutrientMutationVariables>) {
        return Apollo.useMutation<CreateNutrientMutation, CreateNutrientMutationVariables>(CreateNutrientDocument, baseOptions);
      }
export type CreateNutrientMutationHookResult = ReturnType<typeof useCreateNutrientMutation>;
export type CreateNutrientMutationResult = Apollo.MutationResult<CreateNutrientMutation>;
export type CreateNutrientMutationOptions = Apollo.BaseMutationOptions<CreateNutrientMutation, CreateNutrientMutationVariables>;
export const UpdateNutrientDocument = gql`
    mutation updateNutrient($input: UpdateNutrientInput!) {
  updateNutrient(input: $input) {
    ... on Nutrient {
      ...NutrientFields
    }
    ... on Error {
      message
    }
  }
}
    ${NutrientFieldsFragmentDoc}`;
export type UpdateNutrientMutationFn = Apollo.MutationFunction<UpdateNutrientMutation, UpdateNutrientMutationVariables>;

/**
 * __useUpdateNutrientMutation__
 *
 * To run a mutation, you first call `useUpdateNutrientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNutrientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNutrientMutation, { data, loading, error }] = useUpdateNutrientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNutrientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNutrientMutation, UpdateNutrientMutationVariables>) {
        return Apollo.useMutation<UpdateNutrientMutation, UpdateNutrientMutationVariables>(UpdateNutrientDocument, baseOptions);
      }
export type UpdateNutrientMutationHookResult = ReturnType<typeof useUpdateNutrientMutation>;
export type UpdateNutrientMutationResult = Apollo.MutationResult<UpdateNutrientMutation>;
export type UpdateNutrientMutationOptions = Apollo.BaseMutationOptions<UpdateNutrientMutation, UpdateNutrientMutationVariables>;
export const ActivateNutrientDocument = gql`
    mutation activateNutrient($id: ID!) {
  updateNutrient(input: {active: true, id: $id}) {
    ... on Nutrient {
      ...NutrientFields
    }
    ... on Error {
      message
    }
  }
}
    ${NutrientFieldsFragmentDoc}`;
export type ActivateNutrientMutationFn = Apollo.MutationFunction<ActivateNutrientMutation, ActivateNutrientMutationVariables>;

/**
 * __useActivateNutrientMutation__
 *
 * To run a mutation, you first call `useActivateNutrientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateNutrientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateNutrientMutation, { data, loading, error }] = useActivateNutrientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateNutrientMutation(baseOptions?: Apollo.MutationHookOptions<ActivateNutrientMutation, ActivateNutrientMutationVariables>) {
        return Apollo.useMutation<ActivateNutrientMutation, ActivateNutrientMutationVariables>(ActivateNutrientDocument, baseOptions);
      }
export type ActivateNutrientMutationHookResult = ReturnType<typeof useActivateNutrientMutation>;
export type ActivateNutrientMutationResult = Apollo.MutationResult<ActivateNutrientMutation>;
export type ActivateNutrientMutationOptions = Apollo.BaseMutationOptions<ActivateNutrientMutation, ActivateNutrientMutationVariables>;
export const DeactivateNutrientDocument = gql`
    mutation deactivateNutrient($id: ID!) {
  updateNutrient(input: {active: false, id: $id}) {
    ... on Nutrient {
      ...NutrientFields
    }
    ... on Error {
      message
    }
  }
}
    ${NutrientFieldsFragmentDoc}`;
export type DeactivateNutrientMutationFn = Apollo.MutationFunction<DeactivateNutrientMutation, DeactivateNutrientMutationVariables>;

/**
 * __useDeactivateNutrientMutation__
 *
 * To run a mutation, you first call `useDeactivateNutrientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateNutrientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateNutrientMutation, { data, loading, error }] = useDeactivateNutrientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateNutrientMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateNutrientMutation, DeactivateNutrientMutationVariables>) {
        return Apollo.useMutation<DeactivateNutrientMutation, DeactivateNutrientMutationVariables>(DeactivateNutrientDocument, baseOptions);
      }
export type DeactivateNutrientMutationHookResult = ReturnType<typeof useDeactivateNutrientMutation>;
export type DeactivateNutrientMutationResult = Apollo.MutationResult<DeactivateNutrientMutation>;
export type DeactivateNutrientMutationOptions = Apollo.BaseMutationOptions<DeactivateNutrientMutation, DeactivateNutrientMutationVariables>;
export const UploadPaperlyticsImageDocument = gql`
    mutation uploadPaperlyticsImage($imageUrl: String!, $harvestGroupId: String!) {
  uploadPaperlyticsImage(imageUrl: $imageUrl, harvestGroupId: $harvestGroupId) {
    ... on PaperlyticsImage {
      ...PaperlyticsImageFields
    }
    ... on Error {
      message
    }
  }
}
    ${PaperlyticsImageFieldsFragmentDoc}`;
export type UploadPaperlyticsImageMutationFn = Apollo.MutationFunction<UploadPaperlyticsImageMutation, UploadPaperlyticsImageMutationVariables>;

/**
 * __useUploadPaperlyticsImageMutation__
 *
 * To run a mutation, you first call `useUploadPaperlyticsImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPaperlyticsImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPaperlyticsImageMutation, { data, loading, error }] = useUploadPaperlyticsImageMutation({
 *   variables: {
 *      imageUrl: // value for 'imageUrl'
 *      harvestGroupId: // value for 'harvestGroupId'
 *   },
 * });
 */
export function useUploadPaperlyticsImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadPaperlyticsImageMutation, UploadPaperlyticsImageMutationVariables>) {
        return Apollo.useMutation<UploadPaperlyticsImageMutation, UploadPaperlyticsImageMutationVariables>(UploadPaperlyticsImageDocument, baseOptions);
      }
export type UploadPaperlyticsImageMutationHookResult = ReturnType<typeof useUploadPaperlyticsImageMutation>;
export type UploadPaperlyticsImageMutationResult = Apollo.MutationResult<UploadPaperlyticsImageMutation>;
export type UploadPaperlyticsImageMutationOptions = Apollo.BaseMutationOptions<UploadPaperlyticsImageMutation, UploadPaperlyticsImageMutationVariables>;
export const RetryPaperlyticsImageDocument = gql`
    mutation retryPaperlyticsImage($imageId: String!) {
  retryPaperlyticsImage(imageId: $imageId) {
    ... on PaperlyticsImage {
      ...PaperlyticsImageFields
    }
    ... on Error {
      message
    }
  }
}
    ${PaperlyticsImageFieldsFragmentDoc}`;
export type RetryPaperlyticsImageMutationFn = Apollo.MutationFunction<RetryPaperlyticsImageMutation, RetryPaperlyticsImageMutationVariables>;

/**
 * __useRetryPaperlyticsImageMutation__
 *
 * To run a mutation, you first call `useRetryPaperlyticsImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryPaperlyticsImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryPaperlyticsImageMutation, { data, loading, error }] = useRetryPaperlyticsImageMutation({
 *   variables: {
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useRetryPaperlyticsImageMutation(baseOptions?: Apollo.MutationHookOptions<RetryPaperlyticsImageMutation, RetryPaperlyticsImageMutationVariables>) {
        return Apollo.useMutation<RetryPaperlyticsImageMutation, RetryPaperlyticsImageMutationVariables>(RetryPaperlyticsImageDocument, baseOptions);
      }
export type RetryPaperlyticsImageMutationHookResult = ReturnType<typeof useRetryPaperlyticsImageMutation>;
export type RetryPaperlyticsImageMutationResult = Apollo.MutationResult<RetryPaperlyticsImageMutation>;
export type RetryPaperlyticsImageMutationOptions = Apollo.BaseMutationOptions<RetryPaperlyticsImageMutation, RetryPaperlyticsImageMutationVariables>;
export const PaperlyticsImagesDocument = gql`
    query paperlyticsImages($filters: PaperlyticsFilterSetInput) {
  paperlyticsImages(filters: $filters) {
    ...PaperlyticsImageFields
  }
}
    ${PaperlyticsImageFieldsFragmentDoc}`;

/**
 * __usePaperlyticsImagesQuery__
 *
 * To run a query within a React component, call `usePaperlyticsImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaperlyticsImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaperlyticsImagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePaperlyticsImagesQuery(baseOptions?: Apollo.QueryHookOptions<PaperlyticsImagesQuery, PaperlyticsImagesQueryVariables>) {
        return Apollo.useQuery<PaperlyticsImagesQuery, PaperlyticsImagesQueryVariables>(PaperlyticsImagesDocument, baseOptions);
      }
export function usePaperlyticsImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaperlyticsImagesQuery, PaperlyticsImagesQueryVariables>) {
          return Apollo.useLazyQuery<PaperlyticsImagesQuery, PaperlyticsImagesQueryVariables>(PaperlyticsImagesDocument, baseOptions);
        }
export type PaperlyticsImagesQueryHookResult = ReturnType<typeof usePaperlyticsImagesQuery>;
export type PaperlyticsImagesLazyQueryHookResult = ReturnType<typeof usePaperlyticsImagesLazyQuery>;
export type PaperlyticsImagesQueryResult = Apollo.QueryResult<PaperlyticsImagesQuery, PaperlyticsImagesQueryVariables>;
export const RecipesDocument = gql`
    query recipes($filters: RecipeFilterSetInput) {
  recipes(filters: $filters) {
    ...RecipeFields
  }
}
    ${RecipeFieldsFragmentDoc}`;

/**
 * __useRecipesQuery__
 *
 * To run a query within a React component, call `useRecipesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRecipesQuery(baseOptions?: Apollo.QueryHookOptions<RecipesQuery, RecipesQueryVariables>) {
        return Apollo.useQuery<RecipesQuery, RecipesQueryVariables>(RecipesDocument, baseOptions);
      }
export function useRecipesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecipesQuery, RecipesQueryVariables>) {
          return Apollo.useLazyQuery<RecipesQuery, RecipesQueryVariables>(RecipesDocument, baseOptions);
        }
export type RecipesQueryHookResult = ReturnType<typeof useRecipesQuery>;
export type RecipesLazyQueryHookResult = ReturnType<typeof useRecipesLazyQuery>;
export type RecipesQueryResult = Apollo.QueryResult<RecipesQuery, RecipesQueryVariables>;
export const RecipeDocument = gql`
    query recipe($id: String!) {
  recipe(id: $id) {
    ...RecipeFields
  }
}
    ${RecipeFieldsFragmentDoc}`;

/**
 * __useRecipeQuery__
 *
 * To run a query within a React component, call `useRecipeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecipeQuery(baseOptions?: Apollo.QueryHookOptions<RecipeQuery, RecipeQueryVariables>) {
        return Apollo.useQuery<RecipeQuery, RecipeQueryVariables>(RecipeDocument, baseOptions);
      }
export function useRecipeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecipeQuery, RecipeQueryVariables>) {
          return Apollo.useLazyQuery<RecipeQuery, RecipeQueryVariables>(RecipeDocument, baseOptions);
        }
export type RecipeQueryHookResult = ReturnType<typeof useRecipeQuery>;
export type RecipeLazyQueryHookResult = ReturnType<typeof useRecipeLazyQuery>;
export type RecipeQueryResult = Apollo.QueryResult<RecipeQuery, RecipeQueryVariables>;
export const RecipesAndNutrientsDocument = gql`
    query recipesAndNutrients($filters: RecipeFilterSetInput) {
  recipes(filters: $filters) {
    ...RecipeFields
  }
  nutrients {
    ...NutrientFields
  }
}
    ${RecipeFieldsFragmentDoc}
${NutrientFieldsFragmentDoc}`;

/**
 * __useRecipesAndNutrientsQuery__
 *
 * To run a query within a React component, call `useRecipesAndNutrientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipesAndNutrientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipesAndNutrientsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRecipesAndNutrientsQuery(baseOptions?: Apollo.QueryHookOptions<RecipesAndNutrientsQuery, RecipesAndNutrientsQueryVariables>) {
        return Apollo.useQuery<RecipesAndNutrientsQuery, RecipesAndNutrientsQueryVariables>(RecipesAndNutrientsDocument, baseOptions);
      }
export function useRecipesAndNutrientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecipesAndNutrientsQuery, RecipesAndNutrientsQueryVariables>) {
          return Apollo.useLazyQuery<RecipesAndNutrientsQuery, RecipesAndNutrientsQueryVariables>(RecipesAndNutrientsDocument, baseOptions);
        }
export type RecipesAndNutrientsQueryHookResult = ReturnType<typeof useRecipesAndNutrientsQuery>;
export type RecipesAndNutrientsLazyQueryHookResult = ReturnType<typeof useRecipesAndNutrientsLazyQuery>;
export type RecipesAndNutrientsQueryResult = Apollo.QueryResult<RecipesAndNutrientsQuery, RecipesAndNutrientsQueryVariables>;
export const CreateRecipeDocument = gql`
    mutation createRecipe($input: CreateRecipeInput!) {
  createRecipe(input: $input) {
    ... on Recipe {
      ...RecipeFields
    }
    ... on Error {
      message
    }
  }
}
    ${RecipeFieldsFragmentDoc}`;
export type CreateRecipeMutationFn = Apollo.MutationFunction<CreateRecipeMutation, CreateRecipeMutationVariables>;

/**
 * __useCreateRecipeMutation__
 *
 * To run a mutation, you first call `useCreateRecipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecipeMutation, { data, loading, error }] = useCreateRecipeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRecipeMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecipeMutation, CreateRecipeMutationVariables>) {
        return Apollo.useMutation<CreateRecipeMutation, CreateRecipeMutationVariables>(CreateRecipeDocument, baseOptions);
      }
export type CreateRecipeMutationHookResult = ReturnType<typeof useCreateRecipeMutation>;
export type CreateRecipeMutationResult = Apollo.MutationResult<CreateRecipeMutation>;
export type CreateRecipeMutationOptions = Apollo.BaseMutationOptions<CreateRecipeMutation, CreateRecipeMutationVariables>;
export const UpdateRecipeDocument = gql`
    mutation updateRecipe($input: UpdateRecipeInput!) {
  updateRecipe(input: $input) {
    ... on Recipe {
      ...RecipeFields
    }
    ... on Error {
      message
    }
  }
}
    ${RecipeFieldsFragmentDoc}`;
export type UpdateRecipeMutationFn = Apollo.MutationFunction<UpdateRecipeMutation, UpdateRecipeMutationVariables>;

/**
 * __useUpdateRecipeMutation__
 *
 * To run a mutation, you first call `useUpdateRecipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecipeMutation, { data, loading, error }] = useUpdateRecipeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRecipeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecipeMutation, UpdateRecipeMutationVariables>) {
        return Apollo.useMutation<UpdateRecipeMutation, UpdateRecipeMutationVariables>(UpdateRecipeDocument, baseOptions);
      }
export type UpdateRecipeMutationHookResult = ReturnType<typeof useUpdateRecipeMutation>;
export type UpdateRecipeMutationResult = Apollo.MutationResult<UpdateRecipeMutation>;
export type UpdateRecipeMutationOptions = Apollo.BaseMutationOptions<UpdateRecipeMutation, UpdateRecipeMutationVariables>;
export const ActivateRecipeDocument = gql`
    mutation activateRecipe($id: ID!) {
  updateRecipe(input: {active: true, id: $id}) {
    ... on Recipe {
      ...RecipeFields
    }
    ... on Error {
      message
    }
  }
}
    ${RecipeFieldsFragmentDoc}`;
export type ActivateRecipeMutationFn = Apollo.MutationFunction<ActivateRecipeMutation, ActivateRecipeMutationVariables>;

/**
 * __useActivateRecipeMutation__
 *
 * To run a mutation, you first call `useActivateRecipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateRecipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateRecipeMutation, { data, loading, error }] = useActivateRecipeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateRecipeMutation(baseOptions?: Apollo.MutationHookOptions<ActivateRecipeMutation, ActivateRecipeMutationVariables>) {
        return Apollo.useMutation<ActivateRecipeMutation, ActivateRecipeMutationVariables>(ActivateRecipeDocument, baseOptions);
      }
export type ActivateRecipeMutationHookResult = ReturnType<typeof useActivateRecipeMutation>;
export type ActivateRecipeMutationResult = Apollo.MutationResult<ActivateRecipeMutation>;
export type ActivateRecipeMutationOptions = Apollo.BaseMutationOptions<ActivateRecipeMutation, ActivateRecipeMutationVariables>;
export const DeactivateRecipeDocument = gql`
    mutation deactivateRecipe($id: ID!) {
  updateRecipe(input: {active: false, id: $id}) {
    ... on Recipe {
      ...RecipeFields
    }
    ... on Error {
      message
    }
  }
}
    ${RecipeFieldsFragmentDoc}`;
export type DeactivateRecipeMutationFn = Apollo.MutationFunction<DeactivateRecipeMutation, DeactivateRecipeMutationVariables>;

/**
 * __useDeactivateRecipeMutation__
 *
 * To run a mutation, you first call `useDeactivateRecipeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateRecipeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateRecipeMutation, { data, loading, error }] = useDeactivateRecipeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateRecipeMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateRecipeMutation, DeactivateRecipeMutationVariables>) {
        return Apollo.useMutation<DeactivateRecipeMutation, DeactivateRecipeMutationVariables>(DeactivateRecipeDocument, baseOptions);
      }
export type DeactivateRecipeMutationHookResult = ReturnType<typeof useDeactivateRecipeMutation>;
export type DeactivateRecipeMutationResult = Apollo.MutationResult<DeactivateRecipeMutation>;
export type DeactivateRecipeMutationOptions = Apollo.BaseMutationOptions<DeactivateRecipeMutation, DeactivateRecipeMutationVariables>;
export const StrainsDocument = gql`
    query strains($filters: StrainFilterSetInput) {
  strains(filters: $filters) {
    ...StrainFields
  }
}
    ${StrainFieldsFragmentDoc}`;

/**
 * __useStrainsQuery__
 *
 * To run a query within a React component, call `useStrainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStrainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStrainsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useStrainsQuery(baseOptions?: Apollo.QueryHookOptions<StrainsQuery, StrainsQueryVariables>) {
        return Apollo.useQuery<StrainsQuery, StrainsQueryVariables>(StrainsDocument, baseOptions);
      }
export function useStrainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StrainsQuery, StrainsQueryVariables>) {
          return Apollo.useLazyQuery<StrainsQuery, StrainsQueryVariables>(StrainsDocument, baseOptions);
        }
export type StrainsQueryHookResult = ReturnType<typeof useStrainsQuery>;
export type StrainsLazyQueryHookResult = ReturnType<typeof useStrainsLazyQuery>;
export type StrainsQueryResult = Apollo.QueryResult<StrainsQuery, StrainsQueryVariables>;
export const CreateStrainDocument = gql`
    mutation createStrain($input: CreateStrainInput!) {
  createStrain(input: $input) {
    ... on Strain {
      ...StrainFields
    }
    ... on Error {
      message
    }
  }
}
    ${StrainFieldsFragmentDoc}`;
export type CreateStrainMutationFn = Apollo.MutationFunction<CreateStrainMutation, CreateStrainMutationVariables>;

/**
 * __useCreateStrainMutation__
 *
 * To run a mutation, you first call `useCreateStrainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStrainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStrainMutation, { data, loading, error }] = useCreateStrainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStrainMutation(baseOptions?: Apollo.MutationHookOptions<CreateStrainMutation, CreateStrainMutationVariables>) {
        return Apollo.useMutation<CreateStrainMutation, CreateStrainMutationVariables>(CreateStrainDocument, baseOptions);
      }
export type CreateStrainMutationHookResult = ReturnType<typeof useCreateStrainMutation>;
export type CreateStrainMutationResult = Apollo.MutationResult<CreateStrainMutation>;
export type CreateStrainMutationOptions = Apollo.BaseMutationOptions<CreateStrainMutation, CreateStrainMutationVariables>;
export const UpdateStrainDocument = gql`
    mutation updateStrain($input: UpdateStrainInput!) {
  updateStrain(input: $input) {
    ... on Strain {
      ...StrainFields
    }
    ... on Error {
      message
    }
  }
}
    ${StrainFieldsFragmentDoc}`;
export type UpdateStrainMutationFn = Apollo.MutationFunction<UpdateStrainMutation, UpdateStrainMutationVariables>;

/**
 * __useUpdateStrainMutation__
 *
 * To run a mutation, you first call `useUpdateStrainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStrainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStrainMutation, { data, loading, error }] = useUpdateStrainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStrainMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStrainMutation, UpdateStrainMutationVariables>) {
        return Apollo.useMutation<UpdateStrainMutation, UpdateStrainMutationVariables>(UpdateStrainDocument, baseOptions);
      }
export type UpdateStrainMutationHookResult = ReturnType<typeof useUpdateStrainMutation>;
export type UpdateStrainMutationResult = Apollo.MutationResult<UpdateStrainMutation>;
export type UpdateStrainMutationOptions = Apollo.BaseMutationOptions<UpdateStrainMutation, UpdateStrainMutationVariables>;
export const ActivateStrainDocument = gql`
    mutation activateStrain($id: ID!) {
  updateStrain(input: {active: true, id: $id}) {
    ... on Strain {
      ...StrainFields
    }
    ... on Error {
      message
    }
  }
}
    ${StrainFieldsFragmentDoc}`;
export type ActivateStrainMutationFn = Apollo.MutationFunction<ActivateStrainMutation, ActivateStrainMutationVariables>;

/**
 * __useActivateStrainMutation__
 *
 * To run a mutation, you first call `useActivateStrainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateStrainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateStrainMutation, { data, loading, error }] = useActivateStrainMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateStrainMutation(baseOptions?: Apollo.MutationHookOptions<ActivateStrainMutation, ActivateStrainMutationVariables>) {
        return Apollo.useMutation<ActivateStrainMutation, ActivateStrainMutationVariables>(ActivateStrainDocument, baseOptions);
      }
export type ActivateStrainMutationHookResult = ReturnType<typeof useActivateStrainMutation>;
export type ActivateStrainMutationResult = Apollo.MutationResult<ActivateStrainMutation>;
export type ActivateStrainMutationOptions = Apollo.BaseMutationOptions<ActivateStrainMutation, ActivateStrainMutationVariables>;
export const DeactivateStrainDocument = gql`
    mutation deactivateStrain($id: ID!) {
  updateStrain(input: {active: false, id: $id}) {
    ... on Strain {
      ...StrainFields
    }
    ... on Error {
      message
    }
  }
}
    ${StrainFieldsFragmentDoc}`;
export type DeactivateStrainMutationFn = Apollo.MutationFunction<DeactivateStrainMutation, DeactivateStrainMutationVariables>;

/**
 * __useDeactivateStrainMutation__
 *
 * To run a mutation, you first call `useDeactivateStrainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateStrainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateStrainMutation, { data, loading, error }] = useDeactivateStrainMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateStrainMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateStrainMutation, DeactivateStrainMutationVariables>) {
        return Apollo.useMutation<DeactivateStrainMutation, DeactivateStrainMutationVariables>(DeactivateStrainDocument, baseOptions);
      }
export type DeactivateStrainMutationHookResult = ReturnType<typeof useDeactivateStrainMutation>;
export type DeactivateStrainMutationResult = Apollo.MutationResult<DeactivateStrainMutation>;
export type DeactivateStrainMutationOptions = Apollo.BaseMutationOptions<DeactivateStrainMutation, DeactivateStrainMutationVariables>;
export const StrainsAndRecipesAndNutrientsDocument = gql`
    query strainsAndRecipesAndNutrients($harvestGroupId: String!, $filters: RecipeFilterSetInput) {
  harvestGroup(id: $harvestGroupId) {
    strains {
      ...StrainReportFields
    }
  }
  recipes(filters: $filters) {
    ...RecipeFields
  }
  nutrients {
    ...NutrientFields
  }
}
    ${StrainReportFieldsFragmentDoc}
${RecipeFieldsFragmentDoc}
${NutrientFieldsFragmentDoc}`;

/**
 * __useStrainsAndRecipesAndNutrientsQuery__
 *
 * To run a query within a React component, call `useStrainsAndRecipesAndNutrientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStrainsAndRecipesAndNutrientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStrainsAndRecipesAndNutrientsQuery({
 *   variables: {
 *      harvestGroupId: // value for 'harvestGroupId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useStrainsAndRecipesAndNutrientsQuery(baseOptions?: Apollo.QueryHookOptions<StrainsAndRecipesAndNutrientsQuery, StrainsAndRecipesAndNutrientsQueryVariables>) {
        return Apollo.useQuery<StrainsAndRecipesAndNutrientsQuery, StrainsAndRecipesAndNutrientsQueryVariables>(StrainsAndRecipesAndNutrientsDocument, baseOptions);
      }
export function useStrainsAndRecipesAndNutrientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StrainsAndRecipesAndNutrientsQuery, StrainsAndRecipesAndNutrientsQueryVariables>) {
          return Apollo.useLazyQuery<StrainsAndRecipesAndNutrientsQuery, StrainsAndRecipesAndNutrientsQueryVariables>(StrainsAndRecipesAndNutrientsDocument, baseOptions);
        }
export type StrainsAndRecipesAndNutrientsQueryHookResult = ReturnType<typeof useStrainsAndRecipesAndNutrientsQuery>;
export type StrainsAndRecipesAndNutrientsLazyQueryHookResult = ReturnType<typeof useStrainsAndRecipesAndNutrientsLazyQuery>;
export type StrainsAndRecipesAndNutrientsQueryResult = Apollo.QueryResult<StrainsAndRecipesAndNutrientsQuery, StrainsAndRecipesAndNutrientsQueryVariables>;
export const CreateTaskDocument = gql`
    mutation createTask($input: CreateTaskInput!) {
  createTask(input: $input) {
    ... on Task {
      ...TaskFields
    }
    ... on Error {
      message
    }
  }
}
    ${TaskFieldsFragmentDoc}`;
export type CreateTaskMutationFn = Apollo.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, baseOptions);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation updateTask($input: UpdateTaskInput!) {
  updateTask(input: $input) {
    ... on Task {
      ...TaskFields
    }
    ... on Error {
      message
    }
  }
}
    ${TaskFieldsFragmentDoc}`;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, baseOptions);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const CompleteTaskDocument = gql`
    mutation completeTask($input: CompleteTaskInput!) {
  completeTask(input: $input) {
    ... on Task {
      ...TaskFields
    }
    ... on Error {
      message
    }
  }
}
    ${TaskFieldsFragmentDoc}`;
export type CompleteTaskMutationFn = Apollo.MutationFunction<CompleteTaskMutation, CompleteTaskMutationVariables>;

/**
 * __useCompleteTaskMutation__
 *
 * To run a mutation, you first call `useCompleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTaskMutation, { data, loading, error }] = useCompleteTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<CompleteTaskMutation, CompleteTaskMutationVariables>) {
        return Apollo.useMutation<CompleteTaskMutation, CompleteTaskMutationVariables>(CompleteTaskDocument, baseOptions);
      }
export type CompleteTaskMutationHookResult = ReturnType<typeof useCompleteTaskMutation>;
export type CompleteTaskMutationResult = Apollo.MutationResult<CompleteTaskMutation>;
export type CompleteTaskMutationOptions = Apollo.BaseMutationOptions<CompleteTaskMutation, CompleteTaskMutationVariables>;
export const UncompleteTaskDocument = gql`
    mutation uncompleteTask($input: UncompleteTaskInput!) {
  uncompleteTask(input: $input) {
    ... on Task {
      ...TaskFields
    }
    ... on Error {
      message
    }
  }
}
    ${TaskFieldsFragmentDoc}`;
export type UncompleteTaskMutationFn = Apollo.MutationFunction<UncompleteTaskMutation, UncompleteTaskMutationVariables>;

/**
 * __useUncompleteTaskMutation__
 *
 * To run a mutation, you first call `useUncompleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUncompleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uncompleteTaskMutation, { data, loading, error }] = useUncompleteTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUncompleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<UncompleteTaskMutation, UncompleteTaskMutationVariables>) {
        return Apollo.useMutation<UncompleteTaskMutation, UncompleteTaskMutationVariables>(UncompleteTaskDocument, baseOptions);
      }
export type UncompleteTaskMutationHookResult = ReturnType<typeof useUncompleteTaskMutation>;
export type UncompleteTaskMutationResult = Apollo.MutationResult<UncompleteTaskMutation>;
export type UncompleteTaskMutationOptions = Apollo.BaseMutationOptions<UncompleteTaskMutation, UncompleteTaskMutationVariables>;
export const AddHarvestGroupTemplateDocument = gql`
    mutation addHarvestGroupTemplate($input: CreateHarvestGroupTemplateInput!) {
  createHarvestGroupTemplate(input: $input) {
    ... on HarvestGroupTemplate {
      ...HarvestGroupTemplateFields
    }
    ... on Error {
      message
    }
  }
}
    ${HarvestGroupTemplateFieldsFragmentDoc}`;
export type AddHarvestGroupTemplateMutationFn = Apollo.MutationFunction<AddHarvestGroupTemplateMutation, AddHarvestGroupTemplateMutationVariables>;

/**
 * __useAddHarvestGroupTemplateMutation__
 *
 * To run a mutation, you first call `useAddHarvestGroupTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddHarvestGroupTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addHarvestGroupTemplateMutation, { data, loading, error }] = useAddHarvestGroupTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddHarvestGroupTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddHarvestGroupTemplateMutation, AddHarvestGroupTemplateMutationVariables>) {
        return Apollo.useMutation<AddHarvestGroupTemplateMutation, AddHarvestGroupTemplateMutationVariables>(AddHarvestGroupTemplateDocument, baseOptions);
      }
export type AddHarvestGroupTemplateMutationHookResult = ReturnType<typeof useAddHarvestGroupTemplateMutation>;
export type AddHarvestGroupTemplateMutationResult = Apollo.MutationResult<AddHarvestGroupTemplateMutation>;
export type AddHarvestGroupTemplateMutationOptions = Apollo.BaseMutationOptions<AddHarvestGroupTemplateMutation, AddHarvestGroupTemplateMutationVariables>;
export const UpdateHarvestGroupTemplateDocument = gql`
    mutation updateHarvestGroupTemplate($input: UpdateHarvestGroupTemplateInput!) {
  updateHarvestGroupTemplate(input: $input) {
    template {
      ...HarvestGroupTemplateFields
    }
    conflicts {
      type
      stageName
      taskName
      message
      suggestedFix
      harvestGroupId
      severity
      harvestGroupName
      customStages
      durationChange
      oldDuration
      newDuration
      taskStartDay
      taskEndDay
      affectedStages {
        stageName
        currentStart
        currentEnd
        newStart
        newEnd
      }
      currentStartDate
      currentEndDate
      newStartDate
      newEndDate
    }
    changeNotifications {
      type
      stageName
      taskName
      message
      suggestedFix
      harvestGroupId
      severity
      harvestGroupName
      customStages
      durationChange
      oldDuration
      newDuration
      taskStartDay
      taskEndDay
      affectedStages {
        stageName
        currentStart
        currentEnd
        newStart
        newEnd
      }
      currentStartDate
      currentEndDate
      newStartDate
      newEndDate
    }
    success
    message
  }
}
    ${HarvestGroupTemplateFieldsFragmentDoc}`;
export type UpdateHarvestGroupTemplateMutationFn = Apollo.MutationFunction<UpdateHarvestGroupTemplateMutation, UpdateHarvestGroupTemplateMutationVariables>;

/**
 * __useUpdateHarvestGroupTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateHarvestGroupTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHarvestGroupTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHarvestGroupTemplateMutation, { data, loading, error }] = useUpdateHarvestGroupTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHarvestGroupTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHarvestGroupTemplateMutation, UpdateHarvestGroupTemplateMutationVariables>) {
        return Apollo.useMutation<UpdateHarvestGroupTemplateMutation, UpdateHarvestGroupTemplateMutationVariables>(UpdateHarvestGroupTemplateDocument, baseOptions);
      }
export type UpdateHarvestGroupTemplateMutationHookResult = ReturnType<typeof useUpdateHarvestGroupTemplateMutation>;
export type UpdateHarvestGroupTemplateMutationResult = Apollo.MutationResult<UpdateHarvestGroupTemplateMutation>;
export type UpdateHarvestGroupTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateHarvestGroupTemplateMutation, UpdateHarvestGroupTemplateMutationVariables>;
export const HarvestGroupTemplatesDocument = gql`
    query harvestGroupTemplates($filters: HarvestGroupTemplateFilterSetInput) {
  harvestGroupTemplates(filters: $filters) {
    ...HarvestGroupTemplateFields
  }
}
    ${HarvestGroupTemplateFieldsFragmentDoc}`;

/**
 * __useHarvestGroupTemplatesQuery__
 *
 * To run a query within a React component, call `useHarvestGroupTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestGroupTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestGroupTemplatesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useHarvestGroupTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<HarvestGroupTemplatesQuery, HarvestGroupTemplatesQueryVariables>) {
        return Apollo.useQuery<HarvestGroupTemplatesQuery, HarvestGroupTemplatesQueryVariables>(HarvestGroupTemplatesDocument, baseOptions);
      }
export function useHarvestGroupTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestGroupTemplatesQuery, HarvestGroupTemplatesQueryVariables>) {
          return Apollo.useLazyQuery<HarvestGroupTemplatesQuery, HarvestGroupTemplatesQueryVariables>(HarvestGroupTemplatesDocument, baseOptions);
        }
export type HarvestGroupTemplatesQueryHookResult = ReturnType<typeof useHarvestGroupTemplatesQuery>;
export type HarvestGroupTemplatesLazyQueryHookResult = ReturnType<typeof useHarvestGroupTemplatesLazyQuery>;
export type HarvestGroupTemplatesQueryResult = Apollo.QueryResult<HarvestGroupTemplatesQuery, HarvestGroupTemplatesQueryVariables>;
export const ArchiveHarvestGroupTemplateDocument = gql`
    mutation archiveHarvestGroupTemplate($id: ID!) {
  updateHarvestGroupTemplateArchived(input: {id: $id, archivedAt: "now"}) {
    ... on HarvestGroupTemplate {
      ...HarvestGroupTemplateFields
    }
    ... on Error {
      message
    }
  }
}
    ${HarvestGroupTemplateFieldsFragmentDoc}`;
export type ArchiveHarvestGroupTemplateMutationFn = Apollo.MutationFunction<ArchiveHarvestGroupTemplateMutation, ArchiveHarvestGroupTemplateMutationVariables>;

/**
 * __useArchiveHarvestGroupTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveHarvestGroupTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveHarvestGroupTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveHarvestGroupTemplateMutation, { data, loading, error }] = useArchiveHarvestGroupTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveHarvestGroupTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveHarvestGroupTemplateMutation, ArchiveHarvestGroupTemplateMutationVariables>) {
        return Apollo.useMutation<ArchiveHarvestGroupTemplateMutation, ArchiveHarvestGroupTemplateMutationVariables>(ArchiveHarvestGroupTemplateDocument, baseOptions);
      }
export type ArchiveHarvestGroupTemplateMutationHookResult = ReturnType<typeof useArchiveHarvestGroupTemplateMutation>;
export type ArchiveHarvestGroupTemplateMutationResult = Apollo.MutationResult<ArchiveHarvestGroupTemplateMutation>;
export type ArchiveHarvestGroupTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveHarvestGroupTemplateMutation, ArchiveHarvestGroupTemplateMutationVariables>;
export const UnarchiveHarvestGroupTemplateDocument = gql`
    mutation unarchiveHarvestGroupTemplate($id: ID!) {
  updateHarvestGroupTemplateArchived(input: {id: $id, archivedAt: "false"}) {
    ... on HarvestGroupTemplate {
      ...HarvestGroupTemplateFields
    }
    ... on Error {
      message
    }
  }
}
    ${HarvestGroupTemplateFieldsFragmentDoc}`;
export type UnarchiveHarvestGroupTemplateMutationFn = Apollo.MutationFunction<UnarchiveHarvestGroupTemplateMutation, UnarchiveHarvestGroupTemplateMutationVariables>;

/**
 * __useUnarchiveHarvestGroupTemplateMutation__
 *
 * To run a mutation, you first call `useUnarchiveHarvestGroupTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveHarvestGroupTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveHarvestGroupTemplateMutation, { data, loading, error }] = useUnarchiveHarvestGroupTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveHarvestGroupTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveHarvestGroupTemplateMutation, UnarchiveHarvestGroupTemplateMutationVariables>) {
        return Apollo.useMutation<UnarchiveHarvestGroupTemplateMutation, UnarchiveHarvestGroupTemplateMutationVariables>(UnarchiveHarvestGroupTemplateDocument, baseOptions);
      }
export type UnarchiveHarvestGroupTemplateMutationHookResult = ReturnType<typeof useUnarchiveHarvestGroupTemplateMutation>;
export type UnarchiveHarvestGroupTemplateMutationResult = Apollo.MutationResult<UnarchiveHarvestGroupTemplateMutation>;
export type UnarchiveHarvestGroupTemplateMutationOptions = Apollo.BaseMutationOptions<UnarchiveHarvestGroupTemplateMutation, UnarchiveHarvestGroupTemplateMutationVariables>;
export const StaffHarvestGroupTemplatesDocument = gql`
    query staffHarvestGroupTemplates($organizationId: String!) {
  staffHarvestGroupTemplates(organizationId: $organizationId) {
    ...HarvestGroupTemplateFields
  }
}
    ${HarvestGroupTemplateFieldsFragmentDoc}`;

/**
 * __useStaffHarvestGroupTemplatesQuery__
 *
 * To run a query within a React component, call `useStaffHarvestGroupTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffHarvestGroupTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffHarvestGroupTemplatesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useStaffHarvestGroupTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<StaffHarvestGroupTemplatesQuery, StaffHarvestGroupTemplatesQueryVariables>) {
        return Apollo.useQuery<StaffHarvestGroupTemplatesQuery, StaffHarvestGroupTemplatesQueryVariables>(StaffHarvestGroupTemplatesDocument, baseOptions);
      }
export function useStaffHarvestGroupTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaffHarvestGroupTemplatesQuery, StaffHarvestGroupTemplatesQueryVariables>) {
          return Apollo.useLazyQuery<StaffHarvestGroupTemplatesQuery, StaffHarvestGroupTemplatesQueryVariables>(StaffHarvestGroupTemplatesDocument, baseOptions);
        }
export type StaffHarvestGroupTemplatesQueryHookResult = ReturnType<typeof useStaffHarvestGroupTemplatesQuery>;
export type StaffHarvestGroupTemplatesLazyQueryHookResult = ReturnType<typeof useStaffHarvestGroupTemplatesLazyQuery>;
export type StaffHarvestGroupTemplatesQueryResult = Apollo.QueryResult<StaffHarvestGroupTemplatesQuery, StaffHarvestGroupTemplatesQueryVariables>;
export const ZonesWithHarvestGroupsDocument = gql`
    query zonesWithHarvestGroups($zoneOptions: LogsFilterInput, $filters: ZoneFilterSetInput) {
  zones(filters: $filters) {
    ...ZoneWithHarvestGroupFields
  }
}
    ${ZoneWithHarvestGroupFieldsFragmentDoc}`;

/**
 * __useZonesWithHarvestGroupsQuery__
 *
 * To run a query within a React component, call `useZonesWithHarvestGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesWithHarvestGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesWithHarvestGroupsQuery({
 *   variables: {
 *      zoneOptions: // value for 'zoneOptions'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useZonesWithHarvestGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ZonesWithHarvestGroupsQuery, ZonesWithHarvestGroupsQueryVariables>) {
        return Apollo.useQuery<ZonesWithHarvestGroupsQuery, ZonesWithHarvestGroupsQueryVariables>(ZonesWithHarvestGroupsDocument, baseOptions);
      }
export function useZonesWithHarvestGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesWithHarvestGroupsQuery, ZonesWithHarvestGroupsQueryVariables>) {
          return Apollo.useLazyQuery<ZonesWithHarvestGroupsQuery, ZonesWithHarvestGroupsQueryVariables>(ZonesWithHarvestGroupsDocument, baseOptions);
        }
export type ZonesWithHarvestGroupsQueryHookResult = ReturnType<typeof useZonesWithHarvestGroupsQuery>;
export type ZonesWithHarvestGroupsLazyQueryHookResult = ReturnType<typeof useZonesWithHarvestGroupsLazyQuery>;
export type ZonesWithHarvestGroupsQueryResult = Apollo.QueryResult<ZonesWithHarvestGroupsQuery, ZonesWithHarvestGroupsQueryVariables>;
export const ZonesDocument = gql`
    query zones {
  zones {
    ...ZoneFields
  }
}
    ${ZoneFieldsFragmentDoc}`;

/**
 * __useZonesQuery__
 *
 * To run a query within a React component, call `useZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useZonesQuery(baseOptions?: Apollo.QueryHookOptions<ZonesQuery, ZonesQueryVariables>) {
        return Apollo.useQuery<ZonesQuery, ZonesQueryVariables>(ZonesDocument, baseOptions);
      }
export function useZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesQuery, ZonesQueryVariables>) {
          return Apollo.useLazyQuery<ZonesQuery, ZonesQueryVariables>(ZonesDocument, baseOptions);
        }
export type ZonesQueryHookResult = ReturnType<typeof useZonesQuery>;
export type ZonesLazyQueryHookResult = ReturnType<typeof useZonesLazyQuery>;
export type ZonesQueryResult = Apollo.QueryResult<ZonesQuery, ZonesQueryVariables>;
export const AppIndexPageDocument = gql`
    query AppIndexPage($filters: ZoneFilterSetInput, $taskDateRange: DateRangeInput, $calendarBranchId: String) {
  zones(filters: $filters) {
    ...DashboardZoneCardFields
  }
}
    ${DashboardZoneCardFieldsFragmentDoc}`;

/**
 * __useAppIndexPageQuery__
 *
 * To run a query within a React component, call `useAppIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppIndexPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppIndexPageQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      taskDateRange: // value for 'taskDateRange'
 *      calendarBranchId: // value for 'calendarBranchId'
 *   },
 * });
 */
export function useAppIndexPageQuery(baseOptions?: Apollo.QueryHookOptions<AppIndexPageQuery, AppIndexPageQueryVariables>) {
        return Apollo.useQuery<AppIndexPageQuery, AppIndexPageQueryVariables>(AppIndexPageDocument, baseOptions);
      }
export function useAppIndexPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppIndexPageQuery, AppIndexPageQueryVariables>) {
          return Apollo.useLazyQuery<AppIndexPageQuery, AppIndexPageQueryVariables>(AppIndexPageDocument, baseOptions);
        }
export type AppIndexPageQueryHookResult = ReturnType<typeof useAppIndexPageQuery>;
export type AppIndexPageLazyQueryHookResult = ReturnType<typeof useAppIndexPageLazyQuery>;
export type AppIndexPageQueryResult = Apollo.QueryResult<AppIndexPageQuery, AppIndexPageQueryVariables>;
export const CalendarZoneCardsDocument = gql`
    query CalendarZoneCards($filters: ZoneFilterSetInput, $taskDateRange: DateRangeInput, $calendarBranchId: String) {
  zones(filters: $filters) {
    ...CalendarZoneCardFields
  }
}
    ${CalendarZoneCardFieldsFragmentDoc}`;

/**
 * __useCalendarZoneCardsQuery__
 *
 * To run a query within a React component, call `useCalendarZoneCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarZoneCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarZoneCardsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      taskDateRange: // value for 'taskDateRange'
 *      calendarBranchId: // value for 'calendarBranchId'
 *   },
 * });
 */
export function useCalendarZoneCardsQuery(baseOptions?: Apollo.QueryHookOptions<CalendarZoneCardsQuery, CalendarZoneCardsQueryVariables>) {
        return Apollo.useQuery<CalendarZoneCardsQuery, CalendarZoneCardsQueryVariables>(CalendarZoneCardsDocument, baseOptions);
      }
export function useCalendarZoneCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarZoneCardsQuery, CalendarZoneCardsQueryVariables>) {
          return Apollo.useLazyQuery<CalendarZoneCardsQuery, CalendarZoneCardsQueryVariables>(CalendarZoneCardsDocument, baseOptions);
        }
export type CalendarZoneCardsQueryHookResult = ReturnType<typeof useCalendarZoneCardsQuery>;
export type CalendarZoneCardsLazyQueryHookResult = ReturnType<typeof useCalendarZoneCardsLazyQuery>;
export type CalendarZoneCardsQueryResult = Apollo.QueryResult<CalendarZoneCardsQuery, CalendarZoneCardsQueryVariables>;
export const CreateZoneDocument = gql`
    mutation createZone($input: CreateZoneInput!) {
  createZone(input: $input) {
    ... on Zone {
      ...ZoneFields
    }
    ... on Error {
      message
    }
  }
}
    ${ZoneFieldsFragmentDoc}`;
export type CreateZoneMutationFn = Apollo.MutationFunction<CreateZoneMutation, CreateZoneMutationVariables>;

/**
 * __useCreateZoneMutation__
 *
 * To run a mutation, you first call `useCreateZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZoneMutation, { data, loading, error }] = useCreateZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateZoneMutation(baseOptions?: Apollo.MutationHookOptions<CreateZoneMutation, CreateZoneMutationVariables>) {
        return Apollo.useMutation<CreateZoneMutation, CreateZoneMutationVariables>(CreateZoneDocument, baseOptions);
      }
export type CreateZoneMutationHookResult = ReturnType<typeof useCreateZoneMutation>;
export type CreateZoneMutationResult = Apollo.MutationResult<CreateZoneMutation>;
export type CreateZoneMutationOptions = Apollo.BaseMutationOptions<CreateZoneMutation, CreateZoneMutationVariables>;
export const UpdateZoneDocument = gql`
    mutation updateZone($input: UpdateZoneInput!) {
  updateZone(input: $input) {
    ... on Zone {
      ...ZoneFields
    }
    ... on Error {
      message
    }
  }
}
    ${ZoneFieldsFragmentDoc}`;
export type UpdateZoneMutationFn = Apollo.MutationFunction<UpdateZoneMutation, UpdateZoneMutationVariables>;

/**
 * __useUpdateZoneMutation__
 *
 * To run a mutation, you first call `useUpdateZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateZoneMutation, { data, loading, error }] = useUpdateZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateZoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateZoneMutation, UpdateZoneMutationVariables>) {
        return Apollo.useMutation<UpdateZoneMutation, UpdateZoneMutationVariables>(UpdateZoneDocument, baseOptions);
      }
export type UpdateZoneMutationHookResult = ReturnType<typeof useUpdateZoneMutation>;
export type UpdateZoneMutationResult = Apollo.MutationResult<UpdateZoneMutation>;
export type UpdateZoneMutationOptions = Apollo.BaseMutationOptions<UpdateZoneMutation, UpdateZoneMutationVariables>;
export const ActivateZoneDocument = gql`
    mutation activateZone($id: ID!) {
  updateZone(input: {active: true, id: $id}) {
    ... on Zone {
      ...ZoneFields
    }
    ... on Error {
      message
    }
  }
}
    ${ZoneFieldsFragmentDoc}`;
export type ActivateZoneMutationFn = Apollo.MutationFunction<ActivateZoneMutation, ActivateZoneMutationVariables>;

/**
 * __useActivateZoneMutation__
 *
 * To run a mutation, you first call `useActivateZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateZoneMutation, { data, loading, error }] = useActivateZoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateZoneMutation(baseOptions?: Apollo.MutationHookOptions<ActivateZoneMutation, ActivateZoneMutationVariables>) {
        return Apollo.useMutation<ActivateZoneMutation, ActivateZoneMutationVariables>(ActivateZoneDocument, baseOptions);
      }
export type ActivateZoneMutationHookResult = ReturnType<typeof useActivateZoneMutation>;
export type ActivateZoneMutationResult = Apollo.MutationResult<ActivateZoneMutation>;
export type ActivateZoneMutationOptions = Apollo.BaseMutationOptions<ActivateZoneMutation, ActivateZoneMutationVariables>;
export const DeactivateZoneDocument = gql`
    mutation deactivateZone($id: ID!) {
  updateZone(input: {active: false, id: $id}) {
    ... on Zone {
      ...ZoneFields
    }
    ... on Error {
      message
    }
  }
}
    ${ZoneFieldsFragmentDoc}`;
export type DeactivateZoneMutationFn = Apollo.MutationFunction<DeactivateZoneMutation, DeactivateZoneMutationVariables>;

/**
 * __useDeactivateZoneMutation__
 *
 * To run a mutation, you first call `useDeactivateZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateZoneMutation, { data, loading, error }] = useDeactivateZoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateZoneMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateZoneMutation, DeactivateZoneMutationVariables>) {
        return Apollo.useMutation<DeactivateZoneMutation, DeactivateZoneMutationVariables>(DeactivateZoneDocument, baseOptions);
      }
export type DeactivateZoneMutationHookResult = ReturnType<typeof useDeactivateZoneMutation>;
export type DeactivateZoneMutationResult = Apollo.MutationResult<DeactivateZoneMutation>;
export type DeactivateZoneMutationOptions = Apollo.BaseMutationOptions<DeactivateZoneMutation, DeactivateZoneMutationVariables>;
export const ZoneNamesDocument = gql`
    query zoneNames($filters: ZoneFilterSetInput) {
  zones(filters: $filters) {
    ...ZoneIdAndName
  }
}
    ${ZoneIdAndNameFragmentDoc}`;

/**
 * __useZoneNamesQuery__
 *
 * To run a query within a React component, call `useZoneNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useZoneNamesQuery(baseOptions?: Apollo.QueryHookOptions<ZoneNamesQuery, ZoneNamesQueryVariables>) {
        return Apollo.useQuery<ZoneNamesQuery, ZoneNamesQueryVariables>(ZoneNamesDocument, baseOptions);
      }
export function useZoneNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoneNamesQuery, ZoneNamesQueryVariables>) {
          return Apollo.useLazyQuery<ZoneNamesQuery, ZoneNamesQueryVariables>(ZoneNamesDocument, baseOptions);
        }
export type ZoneNamesQueryHookResult = ReturnType<typeof useZoneNamesQuery>;
export type ZoneNamesLazyQueryHookResult = ReturnType<typeof useZoneNamesLazyQuery>;
export type ZoneNamesQueryResult = Apollo.QueryResult<ZoneNamesQuery, ZoneNamesQueryVariables>;
export const SalesManagerZoneNamesDocument = gql`
    query salesManagerZoneNames($filters: SalesManagerZoneFilterSetInput) {
  salesManagerZones(filters: $filters) {
    ...ZoneIdAndName
  }
}
    ${ZoneIdAndNameFragmentDoc}`;

/**
 * __useSalesManagerZoneNamesQuery__
 *
 * To run a query within a React component, call `useSalesManagerZoneNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesManagerZoneNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesManagerZoneNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSalesManagerZoneNamesQuery(baseOptions?: Apollo.QueryHookOptions<SalesManagerZoneNamesQuery, SalesManagerZoneNamesQueryVariables>) {
        return Apollo.useQuery<SalesManagerZoneNamesQuery, SalesManagerZoneNamesQueryVariables>(SalesManagerZoneNamesDocument, baseOptions);
      }
export function useSalesManagerZoneNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesManagerZoneNamesQuery, SalesManagerZoneNamesQueryVariables>) {
          return Apollo.useLazyQuery<SalesManagerZoneNamesQuery, SalesManagerZoneNamesQueryVariables>(SalesManagerZoneNamesDocument, baseOptions);
        }
export type SalesManagerZoneNamesQueryHookResult = ReturnType<typeof useSalesManagerZoneNamesQuery>;
export type SalesManagerZoneNamesLazyQueryHookResult = ReturnType<typeof useSalesManagerZoneNamesLazyQuery>;
export type SalesManagerZoneNamesQueryResult = Apollo.QueryResult<SalesManagerZoneNamesQuery, SalesManagerZoneNamesQueryVariables>;
export const ZonesWithActiveHarvestGroupsDocument = gql`
    query zonesWithActiveHarvestGroups($filters: ZoneFilterSetInput) {
  zones(filters: $filters) {
    id
    name
    site {
      id
      name
    }
    primaryDevice {
      id
      trolmasterMacAddress
      aroyaDeviceId
      growlinkControllerId
    }
    currentHarvestGroups {
      id
      name
      site {
        organization {
          id
          timezone
        }
      }
      stageWeeks {
        stage {
          id
          name
          environmentalTargetType
          zone {
            id
            name
            lightingClassification
          }
        }
        weekNumber
        weekStartDate
        weekEndDate
        hasEnvironmentalData
      }
    }
  }
}
    `;

/**
 * __useZonesWithActiveHarvestGroupsQuery__
 *
 * To run a query within a React component, call `useZonesWithActiveHarvestGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesWithActiveHarvestGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesWithActiveHarvestGroupsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useZonesWithActiveHarvestGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ZonesWithActiveHarvestGroupsQuery, ZonesWithActiveHarvestGroupsQueryVariables>) {
        return Apollo.useQuery<ZonesWithActiveHarvestGroupsQuery, ZonesWithActiveHarvestGroupsQueryVariables>(ZonesWithActiveHarvestGroupsDocument, baseOptions);
      }
export function useZonesWithActiveHarvestGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesWithActiveHarvestGroupsQuery, ZonesWithActiveHarvestGroupsQueryVariables>) {
          return Apollo.useLazyQuery<ZonesWithActiveHarvestGroupsQuery, ZonesWithActiveHarvestGroupsQueryVariables>(ZonesWithActiveHarvestGroupsDocument, baseOptions);
        }
export type ZonesWithActiveHarvestGroupsQueryHookResult = ReturnType<typeof useZonesWithActiveHarvestGroupsQuery>;
export type ZonesWithActiveHarvestGroupsLazyQueryHookResult = ReturnType<typeof useZonesWithActiveHarvestGroupsLazyQuery>;
export type ZonesWithActiveHarvestGroupsQueryResult = Apollo.QueryResult<ZonesWithActiveHarvestGroupsQuery, ZonesWithActiveHarvestGroupsQueryVariables>;
export const ZonesOverviewDocument = gql`
    query zonesOverview($filters: ZoneFilterSetInput) {
  zones(filters: $filters) {
    ...ZoneFields
  }
}
    ${ZoneFieldsFragmentDoc}`;

/**
 * __useZonesOverviewQuery__
 *
 * To run a query within a React component, call `useZonesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesOverviewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useZonesOverviewQuery(baseOptions?: Apollo.QueryHookOptions<ZonesOverviewQuery, ZonesOverviewQueryVariables>) {
        return Apollo.useQuery<ZonesOverviewQuery, ZonesOverviewQueryVariables>(ZonesOverviewDocument, baseOptions);
      }
export function useZonesOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesOverviewQuery, ZonesOverviewQueryVariables>) {
          return Apollo.useLazyQuery<ZonesOverviewQuery, ZonesOverviewQueryVariables>(ZonesOverviewDocument, baseOptions);
        }
export type ZonesOverviewQueryHookResult = ReturnType<typeof useZonesOverviewQuery>;
export type ZonesOverviewLazyQueryHookResult = ReturnType<typeof useZonesOverviewLazyQuery>;
export type ZonesOverviewQueryResult = Apollo.QueryResult<ZonesOverviewQuery, ZonesOverviewQueryVariables>;
export const DehumidifierBrandsDocument = gql`
    query dehumidifierBrands {
  dehumidifierBrands {
    id
    name
    isCustom
  }
}
    `;

/**
 * __useDehumidifierBrandsQuery__
 *
 * To run a query within a React component, call `useDehumidifierBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDehumidifierBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDehumidifierBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDehumidifierBrandsQuery(baseOptions?: Apollo.QueryHookOptions<DehumidifierBrandsQuery, DehumidifierBrandsQueryVariables>) {
        return Apollo.useQuery<DehumidifierBrandsQuery, DehumidifierBrandsQueryVariables>(DehumidifierBrandsDocument, baseOptions);
      }
export function useDehumidifierBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DehumidifierBrandsQuery, DehumidifierBrandsQueryVariables>) {
          return Apollo.useLazyQuery<DehumidifierBrandsQuery, DehumidifierBrandsQueryVariables>(DehumidifierBrandsDocument, baseOptions);
        }
export type DehumidifierBrandsQueryHookResult = ReturnType<typeof useDehumidifierBrandsQuery>;
export type DehumidifierBrandsLazyQueryHookResult = ReturnType<typeof useDehumidifierBrandsLazyQuery>;
export type DehumidifierBrandsQueryResult = Apollo.QueryResult<DehumidifierBrandsQuery, DehumidifierBrandsQueryVariables>;
export const CirculatingFanBrandsDocument = gql`
    query circulatingFanBrands {
  circulatingFanBrands {
    id
    name
    isCustom
  }
}
    `;

/**
 * __useCirculatingFanBrandsQuery__
 *
 * To run a query within a React component, call `useCirculatingFanBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCirculatingFanBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCirculatingFanBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCirculatingFanBrandsQuery(baseOptions?: Apollo.QueryHookOptions<CirculatingFanBrandsQuery, CirculatingFanBrandsQueryVariables>) {
        return Apollo.useQuery<CirculatingFanBrandsQuery, CirculatingFanBrandsQueryVariables>(CirculatingFanBrandsDocument, baseOptions);
      }
export function useCirculatingFanBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CirculatingFanBrandsQuery, CirculatingFanBrandsQueryVariables>) {
          return Apollo.useLazyQuery<CirculatingFanBrandsQuery, CirculatingFanBrandsQueryVariables>(CirculatingFanBrandsDocument, baseOptions);
        }
export type CirculatingFanBrandsQueryHookResult = ReturnType<typeof useCirculatingFanBrandsQuery>;
export type CirculatingFanBrandsLazyQueryHookResult = ReturnType<typeof useCirculatingFanBrandsLazyQuery>;
export type CirculatingFanBrandsQueryResult = Apollo.QueryResult<CirculatingFanBrandsQuery, CirculatingFanBrandsQueryVariables>;
export const AcBrandsDocument = gql`
    query acBrands {
  acBrands {
    id
    name
    isCustom
  }
}
    `;

/**
 * __useAcBrandsQuery__
 *
 * To run a query within a React component, call `useAcBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAcBrandsQuery(baseOptions?: Apollo.QueryHookOptions<AcBrandsQuery, AcBrandsQueryVariables>) {
        return Apollo.useQuery<AcBrandsQuery, AcBrandsQueryVariables>(AcBrandsDocument, baseOptions);
      }
export function useAcBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AcBrandsQuery, AcBrandsQueryVariables>) {
          return Apollo.useLazyQuery<AcBrandsQuery, AcBrandsQueryVariables>(AcBrandsDocument, baseOptions);
        }
export type AcBrandsQueryHookResult = ReturnType<typeof useAcBrandsQuery>;
export type AcBrandsLazyQueryHookResult = ReturnType<typeof useAcBrandsLazyQuery>;
export type AcBrandsQueryResult = Apollo.QueryResult<AcBrandsQuery, AcBrandsQueryVariables>;
export const LightingTypeBrandsDocument = gql`
    query lightingTypeBrands {
  lightingTypeBrands {
    id
    name
    isCustom
  }
}
    `;

/**
 * __useLightingTypeBrandsQuery__
 *
 * To run a query within a React component, call `useLightingTypeBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLightingTypeBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLightingTypeBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLightingTypeBrandsQuery(baseOptions?: Apollo.QueryHookOptions<LightingTypeBrandsQuery, LightingTypeBrandsQueryVariables>) {
        return Apollo.useQuery<LightingTypeBrandsQuery, LightingTypeBrandsQueryVariables>(LightingTypeBrandsDocument, baseOptions);
      }
export function useLightingTypeBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LightingTypeBrandsQuery, LightingTypeBrandsQueryVariables>) {
          return Apollo.useLazyQuery<LightingTypeBrandsQuery, LightingTypeBrandsQueryVariables>(LightingTypeBrandsDocument, baseOptions);
        }
export type LightingTypeBrandsQueryHookResult = ReturnType<typeof useLightingTypeBrandsQuery>;
export type LightingTypeBrandsLazyQueryHookResult = ReturnType<typeof useLightingTypeBrandsLazyQuery>;
export type LightingTypeBrandsQueryResult = Apollo.QueryResult<LightingTypeBrandsQuery, LightingTypeBrandsQueryVariables>;
export const SensorsDocument = gql`
    query sensors {
  sensors {
    id
    name
    isCustom
  }
}
    `;

/**
 * __useSensorsQuery__
 *
 * To run a query within a React component, call `useSensorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSensorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSensorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSensorsQuery(baseOptions?: Apollo.QueryHookOptions<SensorsQuery, SensorsQueryVariables>) {
        return Apollo.useQuery<SensorsQuery, SensorsQueryVariables>(SensorsDocument, baseOptions);
      }
export function useSensorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SensorsQuery, SensorsQueryVariables>) {
          return Apollo.useLazyQuery<SensorsQuery, SensorsQueryVariables>(SensorsDocument, baseOptions);
        }
export type SensorsQueryHookResult = ReturnType<typeof useSensorsQuery>;
export type SensorsLazyQueryHookResult = ReturnType<typeof useSensorsLazyQuery>;
export type SensorsQueryResult = Apollo.QueryResult<SensorsQuery, SensorsQueryVariables>;
export const UnderCanopyBrandsDocument = gql`
    query underCanopyBrands {
  underCanopyBrands {
    id
    name
    isCustom
  }
}
    `;

/**
 * __useUnderCanopyBrandsQuery__
 *
 * To run a query within a React component, call `useUnderCanopyBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnderCanopyBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnderCanopyBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnderCanopyBrandsQuery(baseOptions?: Apollo.QueryHookOptions<UnderCanopyBrandsQuery, UnderCanopyBrandsQueryVariables>) {
        return Apollo.useQuery<UnderCanopyBrandsQuery, UnderCanopyBrandsQueryVariables>(UnderCanopyBrandsDocument, baseOptions);
      }
export function useUnderCanopyBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnderCanopyBrandsQuery, UnderCanopyBrandsQueryVariables>) {
          return Apollo.useLazyQuery<UnderCanopyBrandsQuery, UnderCanopyBrandsQueryVariables>(UnderCanopyBrandsDocument, baseOptions);
        }
export type UnderCanopyBrandsQueryHookResult = ReturnType<typeof useUnderCanopyBrandsQuery>;
export type UnderCanopyBrandsLazyQueryHookResult = ReturnType<typeof useUnderCanopyBrandsLazyQuery>;
export type UnderCanopyBrandsQueryResult = Apollo.QueryResult<UnderCanopyBrandsQuery, UnderCanopyBrandsQueryVariables>;
export const GrowingMediasDocument = gql`
    query growingMedias {
  growingMedias {
    id
    name
    isCustom
  }
}
    `;

/**
 * __useGrowingMediasQuery__
 *
 * To run a query within a React component, call `useGrowingMediasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrowingMediasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrowingMediasQuery({
 *   variables: {
 *   },
 * });
 */
export function useGrowingMediasQuery(baseOptions?: Apollo.QueryHookOptions<GrowingMediasQuery, GrowingMediasQueryVariables>) {
        return Apollo.useQuery<GrowingMediasQuery, GrowingMediasQueryVariables>(GrowingMediasDocument, baseOptions);
      }
export function useGrowingMediasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrowingMediasQuery, GrowingMediasQueryVariables>) {
          return Apollo.useLazyQuery<GrowingMediasQuery, GrowingMediasQueryVariables>(GrowingMediasDocument, baseOptions);
        }
export type GrowingMediasQueryHookResult = ReturnType<typeof useGrowingMediasQuery>;
export type GrowingMediasLazyQueryHookResult = ReturnType<typeof useGrowingMediasLazyQuery>;
export type GrowingMediasQueryResult = Apollo.QueryResult<GrowingMediasQuery, GrowingMediasQueryVariables>;
export const SoilBrandsDocument = gql`
    query soilBrands {
  soilBrands {
    id
    name
    isCustom
  }
}
    `;

/**
 * __useSoilBrandsQuery__
 *
 * To run a query within a React component, call `useSoilBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoilBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoilBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSoilBrandsQuery(baseOptions?: Apollo.QueryHookOptions<SoilBrandsQuery, SoilBrandsQueryVariables>) {
        return Apollo.useQuery<SoilBrandsQuery, SoilBrandsQueryVariables>(SoilBrandsDocument, baseOptions);
      }
export function useSoilBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoilBrandsQuery, SoilBrandsQueryVariables>) {
          return Apollo.useLazyQuery<SoilBrandsQuery, SoilBrandsQueryVariables>(SoilBrandsDocument, baseOptions);
        }
export type SoilBrandsQueryHookResult = ReturnType<typeof useSoilBrandsQuery>;
export type SoilBrandsLazyQueryHookResult = ReturnType<typeof useSoilBrandsLazyQuery>;
export type SoilBrandsQueryResult = Apollo.QueryResult<SoilBrandsQuery, SoilBrandsQueryVariables>;
export const IrrigationStylesDocument = gql`
    query irrigationStyles {
  irrigationStyles {
    id
    name
  }
}
    `;

/**
 * __useIrrigationStylesQuery__
 *
 * To run a query within a React component, call `useIrrigationStylesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIrrigationStylesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIrrigationStylesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIrrigationStylesQuery(baseOptions?: Apollo.QueryHookOptions<IrrigationStylesQuery, IrrigationStylesQueryVariables>) {
        return Apollo.useQuery<IrrigationStylesQuery, IrrigationStylesQueryVariables>(IrrigationStylesDocument, baseOptions);
      }
export function useIrrigationStylesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IrrigationStylesQuery, IrrigationStylesQueryVariables>) {
          return Apollo.useLazyQuery<IrrigationStylesQuery, IrrigationStylesQueryVariables>(IrrigationStylesDocument, baseOptions);
        }
export type IrrigationStylesQueryHookResult = ReturnType<typeof useIrrigationStylesQuery>;
export type IrrigationStylesLazyQueryHookResult = ReturnType<typeof useIrrigationStylesLazyQuery>;
export type IrrigationStylesQueryResult = Apollo.QueryResult<IrrigationStylesQuery, IrrigationStylesQueryVariables>;
export const IrrigationFrequenciesDocument = gql`
    query irrigationFrequencies {
  irrigationFrequencies {
    id
    name
  }
}
    `;

/**
 * __useIrrigationFrequenciesQuery__
 *
 * To run a query within a React component, call `useIrrigationFrequenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIrrigationFrequenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIrrigationFrequenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIrrigationFrequenciesQuery(baseOptions?: Apollo.QueryHookOptions<IrrigationFrequenciesQuery, IrrigationFrequenciesQueryVariables>) {
        return Apollo.useQuery<IrrigationFrequenciesQuery, IrrigationFrequenciesQueryVariables>(IrrigationFrequenciesDocument, baseOptions);
      }
export function useIrrigationFrequenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IrrigationFrequenciesQuery, IrrigationFrequenciesQueryVariables>) {
          return Apollo.useLazyQuery<IrrigationFrequenciesQuery, IrrigationFrequenciesQueryVariables>(IrrigationFrequenciesDocument, baseOptions);
        }
export type IrrigationFrequenciesQueryHookResult = ReturnType<typeof useIrrigationFrequenciesQuery>;
export type IrrigationFrequenciesLazyQueryHookResult = ReturnType<typeof useIrrigationFrequenciesLazyQuery>;
export type IrrigationFrequenciesQueryResult = Apollo.QueryResult<IrrigationFrequenciesQuery, IrrigationFrequenciesQueryVariables>;
export const IrrigationTypesDocument = gql`
    query irrigationTypes {
  irrigationTypes {
    id
    name
  }
}
    `;

/**
 * __useIrrigationTypesQuery__
 *
 * To run a query within a React component, call `useIrrigationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIrrigationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIrrigationTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIrrigationTypesQuery(baseOptions?: Apollo.QueryHookOptions<IrrigationTypesQuery, IrrigationTypesQueryVariables>) {
        return Apollo.useQuery<IrrigationTypesQuery, IrrigationTypesQueryVariables>(IrrigationTypesDocument, baseOptions);
      }
export function useIrrigationTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IrrigationTypesQuery, IrrigationTypesQueryVariables>) {
          return Apollo.useLazyQuery<IrrigationTypesQuery, IrrigationTypesQueryVariables>(IrrigationTypesDocument, baseOptions);
        }
export type IrrigationTypesQueryHookResult = ReturnType<typeof useIrrigationTypesQuery>;
export type IrrigationTypesLazyQueryHookResult = ReturnType<typeof useIrrigationTypesLazyQuery>;
export type IrrigationTypesQueryResult = Apollo.QueryResult<IrrigationTypesQuery, IrrigationTypesQueryVariables>;
export const ControlSystemsDocument = gql`
    query controlSystems {
  controlSystems {
    id
    name
  }
}
    `;

/**
 * __useControlSystemsQuery__
 *
 * To run a query within a React component, call `useControlSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlSystemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useControlSystemsQuery(baseOptions?: Apollo.QueryHookOptions<ControlSystemsQuery, ControlSystemsQueryVariables>) {
        return Apollo.useQuery<ControlSystemsQuery, ControlSystemsQueryVariables>(ControlSystemsDocument, baseOptions);
      }
export function useControlSystemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlSystemsQuery, ControlSystemsQueryVariables>) {
          return Apollo.useLazyQuery<ControlSystemsQuery, ControlSystemsQueryVariables>(ControlSystemsDocument, baseOptions);
        }
export type ControlSystemsQueryHookResult = ReturnType<typeof useControlSystemsQuery>;
export type ControlSystemsLazyQueryHookResult = ReturnType<typeof useControlSystemsLazyQuery>;
export type ControlSystemsQueryResult = Apollo.QueryResult<ControlSystemsQuery, ControlSystemsQueryVariables>;
export const CultivationStylesDocument = gql`
    query cultivationStyles {
  cultivationStyles {
    id
    name
  }
}
    `;

/**
 * __useCultivationStylesQuery__
 *
 * To run a query within a React component, call `useCultivationStylesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCultivationStylesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCultivationStylesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCultivationStylesQuery(baseOptions?: Apollo.QueryHookOptions<CultivationStylesQuery, CultivationStylesQueryVariables>) {
        return Apollo.useQuery<CultivationStylesQuery, CultivationStylesQueryVariables>(CultivationStylesDocument, baseOptions);
      }
export function useCultivationStylesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CultivationStylesQuery, CultivationStylesQueryVariables>) {
          return Apollo.useLazyQuery<CultivationStylesQuery, CultivationStylesQueryVariables>(CultivationStylesDocument, baseOptions);
        }
export type CultivationStylesQueryHookResult = ReturnType<typeof useCultivationStylesQuery>;
export type CultivationStylesLazyQueryHookResult = ReturnType<typeof useCultivationStylesLazyQuery>;
export type CultivationStylesQueryResult = Apollo.QueryResult<CultivationStylesQuery, CultivationStylesQueryVariables>;
export const RockwoolBrandsDocument = gql`
    query rockwoolBrands {
  rockwoolBrands {
    id
    name
  }
}
    `;

/**
 * __useRockwoolBrandsQuery__
 *
 * To run a query within a React component, call `useRockwoolBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRockwoolBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRockwoolBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRockwoolBrandsQuery(baseOptions?: Apollo.QueryHookOptions<RockwoolBrandsQuery, RockwoolBrandsQueryVariables>) {
        return Apollo.useQuery<RockwoolBrandsQuery, RockwoolBrandsQueryVariables>(RockwoolBrandsDocument, baseOptions);
      }
export function useRockwoolBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RockwoolBrandsQuery, RockwoolBrandsQueryVariables>) {
          return Apollo.useLazyQuery<RockwoolBrandsQuery, RockwoolBrandsQueryVariables>(RockwoolBrandsDocument, baseOptions);
        }
export type RockwoolBrandsQueryHookResult = ReturnType<typeof useRockwoolBrandsQuery>;
export type RockwoolBrandsLazyQueryHookResult = ReturnType<typeof useRockwoolBrandsLazyQuery>;
export type RockwoolBrandsQueryResult = Apollo.QueryResult<RockwoolBrandsQuery, RockwoolBrandsQueryVariables>;
export const RockwoolSizesDocument = gql`
    query rockwoolSizes {
  rockwoolSizes {
    id
    name
    isCustom
  }
}
    `;

/**
 * __useRockwoolSizesQuery__
 *
 * To run a query within a React component, call `useRockwoolSizesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRockwoolSizesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRockwoolSizesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRockwoolSizesQuery(baseOptions?: Apollo.QueryHookOptions<RockwoolSizesQuery, RockwoolSizesQueryVariables>) {
        return Apollo.useQuery<RockwoolSizesQuery, RockwoolSizesQueryVariables>(RockwoolSizesDocument, baseOptions);
      }
export function useRockwoolSizesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RockwoolSizesQuery, RockwoolSizesQueryVariables>) {
          return Apollo.useLazyQuery<RockwoolSizesQuery, RockwoolSizesQueryVariables>(RockwoolSizesDocument, baseOptions);
        }
export type RockwoolSizesQueryHookResult = ReturnType<typeof useRockwoolSizesQuery>;
export type RockwoolSizesLazyQueryHookResult = ReturnType<typeof useRockwoolSizesLazyQuery>;
export type RockwoolSizesQueryResult = Apollo.QueryResult<RockwoolSizesQuery, RockwoolSizesQueryVariables>;
export const CocoBrandsDocument = gql`
    query cocoBrands {
  cocoBrands {
    id
    name
  }
}
    `;

/**
 * __useCocoBrandsQuery__
 *
 * To run a query within a React component, call `useCocoBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCocoBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCocoBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCocoBrandsQuery(baseOptions?: Apollo.QueryHookOptions<CocoBrandsQuery, CocoBrandsQueryVariables>) {
        return Apollo.useQuery<CocoBrandsQuery, CocoBrandsQueryVariables>(CocoBrandsDocument, baseOptions);
      }
export function useCocoBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CocoBrandsQuery, CocoBrandsQueryVariables>) {
          return Apollo.useLazyQuery<CocoBrandsQuery, CocoBrandsQueryVariables>(CocoBrandsDocument, baseOptions);
        }
export type CocoBrandsQueryHookResult = ReturnType<typeof useCocoBrandsQuery>;
export type CocoBrandsLazyQueryHookResult = ReturnType<typeof useCocoBrandsLazyQuery>;
export type CocoBrandsQueryResult = Apollo.QueryResult<CocoBrandsQuery, CocoBrandsQueryVariables>;
export const BulkUpdateZoneSchedulesDocument = gql`
    mutation BulkUpdateZoneSchedules($input: BulkUpdateZoneSchedulesInput!) {
  bulkUpdateZoneSchedules(input: $input) {
    zones {
      id
      name
      lightingClassification
      dayStartTime
      nightStartTime
    }
    success
  }
}
    `;
export type BulkUpdateZoneSchedulesMutationFn = Apollo.MutationFunction<BulkUpdateZoneSchedulesMutation, BulkUpdateZoneSchedulesMutationVariables>;

/**
 * __useBulkUpdateZoneSchedulesMutation__
 *
 * To run a mutation, you first call `useBulkUpdateZoneSchedulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateZoneSchedulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateZoneSchedulesMutation, { data, loading, error }] = useBulkUpdateZoneSchedulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateZoneSchedulesMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateZoneSchedulesMutation, BulkUpdateZoneSchedulesMutationVariables>) {
        return Apollo.useMutation<BulkUpdateZoneSchedulesMutation, BulkUpdateZoneSchedulesMutationVariables>(BulkUpdateZoneSchedulesDocument, baseOptions);
      }
export type BulkUpdateZoneSchedulesMutationHookResult = ReturnType<typeof useBulkUpdateZoneSchedulesMutation>;
export type BulkUpdateZoneSchedulesMutationResult = Apollo.MutationResult<BulkUpdateZoneSchedulesMutation>;
export type BulkUpdateZoneSchedulesMutationOptions = Apollo.BaseMutationOptions<BulkUpdateZoneSchedulesMutation, BulkUpdateZoneSchedulesMutationVariables>;
export const DetectZoneLightingSchedulesDocument = gql`
    mutation DetectZoneLightingSchedules($siteId: ID!) {
  detectZoneLightingSchedules(siteId: $siteId) {
    schedules {
      zoneId
      zoneName
      dayStartTime
      nightStartTime
      detected
      brand
    }
    success
    error
  }
}
    `;
export type DetectZoneLightingSchedulesMutationFn = Apollo.MutationFunction<DetectZoneLightingSchedulesMutation, DetectZoneLightingSchedulesMutationVariables>;

/**
 * __useDetectZoneLightingSchedulesMutation__
 *
 * To run a mutation, you first call `useDetectZoneLightingSchedulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetectZoneLightingSchedulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detectZoneLightingSchedulesMutation, { data, loading, error }] = useDetectZoneLightingSchedulesMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useDetectZoneLightingSchedulesMutation(baseOptions?: Apollo.MutationHookOptions<DetectZoneLightingSchedulesMutation, DetectZoneLightingSchedulesMutationVariables>) {
        return Apollo.useMutation<DetectZoneLightingSchedulesMutation, DetectZoneLightingSchedulesMutationVariables>(DetectZoneLightingSchedulesDocument, baseOptions);
      }
export type DetectZoneLightingSchedulesMutationHookResult = ReturnType<typeof useDetectZoneLightingSchedulesMutation>;
export type DetectZoneLightingSchedulesMutationResult = Apollo.MutationResult<DetectZoneLightingSchedulesMutation>;
export type DetectZoneLightingSchedulesMutationOptions = Apollo.BaseMutationOptions<DetectZoneLightingSchedulesMutation, DetectZoneLightingSchedulesMutationVariables>;
export const TagsDocument = gql`
    query tags {
  tags {
    id
    name
    colorHexCode
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, baseOptions);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, baseOptions);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const FinanceWorkspaceDocument = gql`
    query FinanceWorkspace {
  financeWorkspace
  financeMappings
}
    `;

/**
 * __useFinanceWorkspaceQuery__
 *
 * To run a query within a React component, call `useFinanceWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinanceWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinanceWorkspaceQuery({
 *   variables: {
 *   },
 * });
 */
export function useFinanceWorkspaceQuery(baseOptions?: Apollo.QueryHookOptions<FinanceWorkspaceQuery, FinanceWorkspaceQueryVariables>) {
        return Apollo.useQuery<FinanceWorkspaceQuery, FinanceWorkspaceQueryVariables>(FinanceWorkspaceDocument, baseOptions);
      }
export function useFinanceWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinanceWorkspaceQuery, FinanceWorkspaceQueryVariables>) {
          return Apollo.useLazyQuery<FinanceWorkspaceQuery, FinanceWorkspaceQueryVariables>(FinanceWorkspaceDocument, baseOptions);
        }
export type FinanceWorkspaceQueryHookResult = ReturnType<typeof useFinanceWorkspaceQuery>;
export type FinanceWorkspaceLazyQueryHookResult = ReturnType<typeof useFinanceWorkspaceLazyQuery>;
export type FinanceWorkspaceQueryResult = Apollo.QueryResult<FinanceWorkspaceQuery, FinanceWorkspaceQueryVariables>;
export const FinanceSettingsDocument = gql`
    mutation FinanceSettings($source: String!, $confirm: Boolean, $basis: String, $mappings: GenericScalar) {
  financeSettings(
    source: $source
    confirm: $confirm
    basis: $basis
    mappings: $mappings
  ) {
    ok
  }
}
    `;
export type FinanceSettingsMutationFn = Apollo.MutationFunction<FinanceSettingsMutation, FinanceSettingsMutationVariables>;

/**
 * __useFinanceSettingsMutation__
 *
 * To run a mutation, you first call `useFinanceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinanceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financeSettingsMutation, { data, loading, error }] = useFinanceSettingsMutation({
 *   variables: {
 *      source: // value for 'source'
 *      confirm: // value for 'confirm'
 *      basis: // value for 'basis'
 *      mappings: // value for 'mappings'
 *   },
 * });
 */
export function useFinanceSettingsMutation(baseOptions?: Apollo.MutationHookOptions<FinanceSettingsMutation, FinanceSettingsMutationVariables>) {
        return Apollo.useMutation<FinanceSettingsMutation, FinanceSettingsMutationVariables>(FinanceSettingsDocument, baseOptions);
      }
export type FinanceSettingsMutationHookResult = ReturnType<typeof useFinanceSettingsMutation>;
export type FinanceSettingsMutationResult = Apollo.MutationResult<FinanceSettingsMutation>;
export type FinanceSettingsMutationOptions = Apollo.BaseMutationOptions<FinanceSettingsMutation, FinanceSettingsMutationVariables>;
export const FinanceConfirmMappingsDocument = gql`
    mutation FinanceConfirmMappings($mappings: GenericScalar!) {
  financeConfirmMappings(mappings: $mappings) {
    ok
  }
}
    `;
export type FinanceConfirmMappingsMutationFn = Apollo.MutationFunction<FinanceConfirmMappingsMutation, FinanceConfirmMappingsMutationVariables>;

/**
 * __useFinanceConfirmMappingsMutation__
 *
 * To run a mutation, you first call `useFinanceConfirmMappingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinanceConfirmMappingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financeConfirmMappingsMutation, { data, loading, error }] = useFinanceConfirmMappingsMutation({
 *   variables: {
 *      mappings: // value for 'mappings'
 *   },
 * });
 */
export function useFinanceConfirmMappingsMutation(baseOptions?: Apollo.MutationHookOptions<FinanceConfirmMappingsMutation, FinanceConfirmMappingsMutationVariables>) {
        return Apollo.useMutation<FinanceConfirmMappingsMutation, FinanceConfirmMappingsMutationVariables>(FinanceConfirmMappingsDocument, baseOptions);
      }
export type FinanceConfirmMappingsMutationHookResult = ReturnType<typeof useFinanceConfirmMappingsMutation>;
export type FinanceConfirmMappingsMutationResult = Apollo.MutationResult<FinanceConfirmMappingsMutation>;
export type FinanceConfirmMappingsMutationOptions = Apollo.BaseMutationOptions<FinanceConfirmMappingsMutation, FinanceConfirmMappingsMutationVariables>;
export const FinancePublishCsvDocument = gql`
    mutation FinancePublishCsv($runId: UUID!, $months: [String!]!, $replace: Boolean, $mappings: GenericScalar) {
  financePublishCsv(
    runId: $runId
    months: $months
    replace: $replace
    mappings: $mappings
  ) {
    ok
  }
}
    `;
export type FinancePublishCsvMutationFn = Apollo.MutationFunction<FinancePublishCsvMutation, FinancePublishCsvMutationVariables>;

/**
 * __useFinancePublishCsvMutation__
 *
 * To run a mutation, you first call `useFinancePublishCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancePublishCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financePublishCsvMutation, { data, loading, error }] = useFinancePublishCsvMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *      months: // value for 'months'
 *      replace: // value for 'replace'
 *      mappings: // value for 'mappings'
 *   },
 * });
 */
export function useFinancePublishCsvMutation(baseOptions?: Apollo.MutationHookOptions<FinancePublishCsvMutation, FinancePublishCsvMutationVariables>) {
        return Apollo.useMutation<FinancePublishCsvMutation, FinancePublishCsvMutationVariables>(FinancePublishCsvDocument, baseOptions);
      }
export type FinancePublishCsvMutationHookResult = ReturnType<typeof useFinancePublishCsvMutation>;
export type FinancePublishCsvMutationResult = Apollo.MutationResult<FinancePublishCsvMutation>;
export type FinancePublishCsvMutationOptions = Apollo.BaseMutationOptions<FinancePublishCsvMutation, FinancePublishCsvMutationVariables>;
export const FinanceDeleteDataDocument = gql`
    mutation FinanceDeleteData($confirm: Boolean!) {
  financeDeleteData(confirm: $confirm) {
    ok
  }
}
    `;
export type FinanceDeleteDataMutationFn = Apollo.MutationFunction<FinanceDeleteDataMutation, FinanceDeleteDataMutationVariables>;

/**
 * __useFinanceDeleteDataMutation__
 *
 * To run a mutation, you first call `useFinanceDeleteDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinanceDeleteDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financeDeleteDataMutation, { data, loading, error }] = useFinanceDeleteDataMutation({
 *   variables: {
 *      confirm: // value for 'confirm'
 *   },
 * });
 */
export function useFinanceDeleteDataMutation(baseOptions?: Apollo.MutationHookOptions<FinanceDeleteDataMutation, FinanceDeleteDataMutationVariables>) {
        return Apollo.useMutation<FinanceDeleteDataMutation, FinanceDeleteDataMutationVariables>(FinanceDeleteDataDocument, baseOptions);
      }
export type FinanceDeleteDataMutationHookResult = ReturnType<typeof useFinanceDeleteDataMutation>;
export type FinanceDeleteDataMutationResult = Apollo.MutationResult<FinanceDeleteDataMutation>;
export type FinanceDeleteDataMutationOptions = Apollo.BaseMutationOptions<FinanceDeleteDataMutation, FinanceDeleteDataMutationVariables>;
export const ProcessingJobsDocument = gql`
    query processingJobs($filters: ProcessingJobFilterSetInput) {
  processingJobs(filters: $filters) {
    ...ProcessingJobOverviewWithGroupFields
  }
}
    ${ProcessingJobOverviewWithGroupFieldsFragmentDoc}`;

/**
 * __useProcessingJobsQuery__
 *
 * To run a query within a React component, call `useProcessingJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingJobsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProcessingJobsQuery(baseOptions?: Apollo.QueryHookOptions<ProcessingJobsQuery, ProcessingJobsQueryVariables>) {
        return Apollo.useQuery<ProcessingJobsQuery, ProcessingJobsQueryVariables>(ProcessingJobsDocument, baseOptions);
      }
export function useProcessingJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingJobsQuery, ProcessingJobsQueryVariables>) {
          return Apollo.useLazyQuery<ProcessingJobsQuery, ProcessingJobsQueryVariables>(ProcessingJobsDocument, baseOptions);
        }
export type ProcessingJobsQueryHookResult = ReturnType<typeof useProcessingJobsQuery>;
export type ProcessingJobsLazyQueryHookResult = ReturnType<typeof useProcessingJobsLazyQuery>;
export type ProcessingJobsQueryResult = Apollo.QueryResult<ProcessingJobsQuery, ProcessingJobsQueryVariables>;
export const ProcessingGroupJobDocument = gql`
    query processingGroupJob($id: ID!) {
  processingJob(id: $id) {
    ...ProcessingJobOverviewWithLogsFields
  }
}
    ${ProcessingJobOverviewWithLogsFieldsFragmentDoc}`;

/**
 * __useProcessingGroupJobQuery__
 *
 * To run a query within a React component, call `useProcessingGroupJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingGroupJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingGroupJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessingGroupJobQuery(baseOptions?: Apollo.QueryHookOptions<ProcessingGroupJobQuery, ProcessingGroupJobQueryVariables>) {
        return Apollo.useQuery<ProcessingGroupJobQuery, ProcessingGroupJobQueryVariables>(ProcessingGroupJobDocument, baseOptions);
      }
export function useProcessingGroupJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingGroupJobQuery, ProcessingGroupJobQueryVariables>) {
          return Apollo.useLazyQuery<ProcessingGroupJobQuery, ProcessingGroupJobQueryVariables>(ProcessingGroupJobDocument, baseOptions);
        }
export type ProcessingGroupJobQueryHookResult = ReturnType<typeof useProcessingGroupJobQuery>;
export type ProcessingGroupJobLazyQueryHookResult = ReturnType<typeof useProcessingGroupJobLazyQuery>;
export type ProcessingGroupJobQueryResult = Apollo.QueryResult<ProcessingGroupJobQuery, ProcessingGroupJobQueryVariables>;
export const CreateProcessingJobDocument = gql`
    mutation createProcessingJob($input: CreateProcessingJobInput!) {
  createProcessingJob(input: $input) {
    ... on ProcessingJob {
      ...ProcessingJobOverviewFields
    }
    ... on Error {
      message
    }
  }
}
    ${ProcessingJobOverviewFieldsFragmentDoc}`;
export type CreateProcessingJobMutationFn = Apollo.MutationFunction<CreateProcessingJobMutation, CreateProcessingJobMutationVariables>;

/**
 * __useCreateProcessingJobMutation__
 *
 * To run a mutation, you first call `useCreateProcessingJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcessingJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcessingJobMutation, { data, loading, error }] = useCreateProcessingJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcessingJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcessingJobMutation, CreateProcessingJobMutationVariables>) {
        return Apollo.useMutation<CreateProcessingJobMutation, CreateProcessingJobMutationVariables>(CreateProcessingJobDocument, baseOptions);
      }
export type CreateProcessingJobMutationHookResult = ReturnType<typeof useCreateProcessingJobMutation>;
export type CreateProcessingJobMutationResult = Apollo.MutationResult<CreateProcessingJobMutation>;
export type CreateProcessingJobMutationOptions = Apollo.BaseMutationOptions<CreateProcessingJobMutation, CreateProcessingJobMutationVariables>;
export const AssignProcessingJobToUserDocument = gql`
    mutation assignProcessingJobToUser($input: AssignProcessingJobToUserInput!) {
  assignProcessingJobToUser(input: $input) {
    ... on ProcessingJob {
      ...ProcessingJobOverviewFields
    }
    ... on Error {
      message
    }
  }
}
    ${ProcessingJobOverviewFieldsFragmentDoc}`;
export type AssignProcessingJobToUserMutationFn = Apollo.MutationFunction<AssignProcessingJobToUserMutation, AssignProcessingJobToUserMutationVariables>;

/**
 * __useAssignProcessingJobToUserMutation__
 *
 * To run a mutation, you first call `useAssignProcessingJobToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignProcessingJobToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignProcessingJobToUserMutation, { data, loading, error }] = useAssignProcessingJobToUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignProcessingJobToUserMutation(baseOptions?: Apollo.MutationHookOptions<AssignProcessingJobToUserMutation, AssignProcessingJobToUserMutationVariables>) {
        return Apollo.useMutation<AssignProcessingJobToUserMutation, AssignProcessingJobToUserMutationVariables>(AssignProcessingJobToUserDocument, baseOptions);
      }
export type AssignProcessingJobToUserMutationHookResult = ReturnType<typeof useAssignProcessingJobToUserMutation>;
export type AssignProcessingJobToUserMutationResult = Apollo.MutationResult<AssignProcessingJobToUserMutation>;
export type AssignProcessingJobToUserMutationOptions = Apollo.BaseMutationOptions<AssignProcessingJobToUserMutation, AssignProcessingJobToUserMutationVariables>;
export const UpdateProcessingJobDocument = gql`
    mutation updateProcessingJob($input: UpdateProcessingJobInput!) {
  updateProcessingJob(input: $input) {
    ... on ProcessingJob {
      ...ProcessingJobOverviewFields
    }
    ... on Error {
      message
    }
  }
}
    ${ProcessingJobOverviewFieldsFragmentDoc}`;
export type UpdateProcessingJobMutationFn = Apollo.MutationFunction<UpdateProcessingJobMutation, UpdateProcessingJobMutationVariables>;

/**
 * __useUpdateProcessingJobMutation__
 *
 * To run a mutation, you first call `useUpdateProcessingJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcessingJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcessingJobMutation, { data, loading, error }] = useUpdateProcessingJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProcessingJobMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcessingJobMutation, UpdateProcessingJobMutationVariables>) {
        return Apollo.useMutation<UpdateProcessingJobMutation, UpdateProcessingJobMutationVariables>(UpdateProcessingJobDocument, baseOptions);
      }
export type UpdateProcessingJobMutationHookResult = ReturnType<typeof useUpdateProcessingJobMutation>;
export type UpdateProcessingJobMutationResult = Apollo.MutationResult<UpdateProcessingJobMutation>;
export type UpdateProcessingJobMutationOptions = Apollo.BaseMutationOptions<UpdateProcessingJobMutation, UpdateProcessingJobMutationVariables>;
export const CreateProcessingJobLogDocument = gql`
    mutation createProcessingJobLog($input: CreateProcessingJobLogInput!) {
  createProcessingJobLog(input: $input) {
    ... on ProcessingJobLog {
      ...ProcessingJobLogFields
      job {
        ...ProcessingJobOverviewFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${ProcessingJobLogFieldsFragmentDoc}
${ProcessingJobOverviewFieldsFragmentDoc}`;
export type CreateProcessingJobLogMutationFn = Apollo.MutationFunction<CreateProcessingJobLogMutation, CreateProcessingJobLogMutationVariables>;

/**
 * __useCreateProcessingJobLogMutation__
 *
 * To run a mutation, you first call `useCreateProcessingJobLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcessingJobLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcessingJobLogMutation, { data, loading, error }] = useCreateProcessingJobLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcessingJobLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcessingJobLogMutation, CreateProcessingJobLogMutationVariables>) {
        return Apollo.useMutation<CreateProcessingJobLogMutation, CreateProcessingJobLogMutationVariables>(CreateProcessingJobLogDocument, baseOptions);
      }
export type CreateProcessingJobLogMutationHookResult = ReturnType<typeof useCreateProcessingJobLogMutation>;
export type CreateProcessingJobLogMutationResult = Apollo.MutationResult<CreateProcessingJobLogMutation>;
export type CreateProcessingJobLogMutationOptions = Apollo.BaseMutationOptions<CreateProcessingJobLogMutation, CreateProcessingJobLogMutationVariables>;
export const UpdateProcessingJobLogDocument = gql`
    mutation updateProcessingJobLog($input: UpdateProcessingJobLogInput!) {
  updateProcessingJobLog(input: $input) {
    ... on ProcessingJobLog {
      ...ProcessingJobLogFields
      job {
        ...ProcessingJobOverviewFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${ProcessingJobLogFieldsFragmentDoc}
${ProcessingJobOverviewFieldsFragmentDoc}`;
export type UpdateProcessingJobLogMutationFn = Apollo.MutationFunction<UpdateProcessingJobLogMutation, UpdateProcessingJobLogMutationVariables>;

/**
 * __useUpdateProcessingJobLogMutation__
 *
 * To run a mutation, you first call `useUpdateProcessingJobLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcessingJobLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcessingJobLogMutation, { data, loading, error }] = useUpdateProcessingJobLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProcessingJobLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcessingJobLogMutation, UpdateProcessingJobLogMutationVariables>) {
        return Apollo.useMutation<UpdateProcessingJobLogMutation, UpdateProcessingJobLogMutationVariables>(UpdateProcessingJobLogDocument, baseOptions);
      }
export type UpdateProcessingJobLogMutationHookResult = ReturnType<typeof useUpdateProcessingJobLogMutation>;
export type UpdateProcessingJobLogMutationResult = Apollo.MutationResult<UpdateProcessingJobLogMutation>;
export type UpdateProcessingJobLogMutationOptions = Apollo.BaseMutationOptions<UpdateProcessingJobLogMutation, UpdateProcessingJobLogMutationVariables>;
export const ProcessingGroupsDocument = gql`
    query processingGroups($filters: ProcessingGroupFilterSetInput) {
  processingGroups(filters: $filters) {
    ...ProcessingGroupFields
  }
}
    ${ProcessingGroupFieldsFragmentDoc}`;

/**
 * __useProcessingGroupsQuery__
 *
 * To run a query within a React component, call `useProcessingGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingGroupsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProcessingGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ProcessingGroupsQuery, ProcessingGroupsQueryVariables>) {
        return Apollo.useQuery<ProcessingGroupsQuery, ProcessingGroupsQueryVariables>(ProcessingGroupsDocument, baseOptions);
      }
export function useProcessingGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingGroupsQuery, ProcessingGroupsQueryVariables>) {
          return Apollo.useLazyQuery<ProcessingGroupsQuery, ProcessingGroupsQueryVariables>(ProcessingGroupsDocument, baseOptions);
        }
export type ProcessingGroupsQueryHookResult = ReturnType<typeof useProcessingGroupsQuery>;
export type ProcessingGroupsLazyQueryHookResult = ReturnType<typeof useProcessingGroupsLazyQuery>;
export type ProcessingGroupsQueryResult = Apollo.QueryResult<ProcessingGroupsQuery, ProcessingGroupsQueryVariables>;
export const CurrentAndUpcomingProcessingGroupsDocument = gql`
    query currentAndUpcomingProcessingGroups($unarchived: String) {
  processingGroups(filters: {unarchived: $unarchived, isCurrent: true}) {
    ...ProcessingGroupFields
  }
}
    ${ProcessingGroupFieldsFragmentDoc}`;

/**
 * __useCurrentAndUpcomingProcessingGroupsQuery__
 *
 * To run a query within a React component, call `useCurrentAndUpcomingProcessingGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAndUpcomingProcessingGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAndUpcomingProcessingGroupsQuery({
 *   variables: {
 *      unarchived: // value for 'unarchived'
 *   },
 * });
 */
export function useCurrentAndUpcomingProcessingGroupsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentAndUpcomingProcessingGroupsQuery, CurrentAndUpcomingProcessingGroupsQueryVariables>) {
        return Apollo.useQuery<CurrentAndUpcomingProcessingGroupsQuery, CurrentAndUpcomingProcessingGroupsQueryVariables>(CurrentAndUpcomingProcessingGroupsDocument, baseOptions);
      }
export function useCurrentAndUpcomingProcessingGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAndUpcomingProcessingGroupsQuery, CurrentAndUpcomingProcessingGroupsQueryVariables>) {
          return Apollo.useLazyQuery<CurrentAndUpcomingProcessingGroupsQuery, CurrentAndUpcomingProcessingGroupsQueryVariables>(CurrentAndUpcomingProcessingGroupsDocument, baseOptions);
        }
export type CurrentAndUpcomingProcessingGroupsQueryHookResult = ReturnType<typeof useCurrentAndUpcomingProcessingGroupsQuery>;
export type CurrentAndUpcomingProcessingGroupsLazyQueryHookResult = ReturnType<typeof useCurrentAndUpcomingProcessingGroupsLazyQuery>;
export type CurrentAndUpcomingProcessingGroupsQueryResult = Apollo.QueryResult<CurrentAndUpcomingProcessingGroupsQuery, CurrentAndUpcomingProcessingGroupsQueryVariables>;
export const CompletedProcessingGroupsDocument = gql`
    query completedProcessingGroups {
  processingGroups(filters: {status: "COMPLETE"}) {
    ...ProcessingGroupOverviewFields
  }
}
    ${ProcessingGroupOverviewFieldsFragmentDoc}`;

/**
 * __useCompletedProcessingGroupsQuery__
 *
 * To run a query within a React component, call `useCompletedProcessingGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedProcessingGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedProcessingGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompletedProcessingGroupsQuery(baseOptions?: Apollo.QueryHookOptions<CompletedProcessingGroupsQuery, CompletedProcessingGroupsQueryVariables>) {
        return Apollo.useQuery<CompletedProcessingGroupsQuery, CompletedProcessingGroupsQueryVariables>(CompletedProcessingGroupsDocument, baseOptions);
      }
export function useCompletedProcessingGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedProcessingGroupsQuery, CompletedProcessingGroupsQueryVariables>) {
          return Apollo.useLazyQuery<CompletedProcessingGroupsQuery, CompletedProcessingGroupsQueryVariables>(CompletedProcessingGroupsDocument, baseOptions);
        }
export type CompletedProcessingGroupsQueryHookResult = ReturnType<typeof useCompletedProcessingGroupsQuery>;
export type CompletedProcessingGroupsLazyQueryHookResult = ReturnType<typeof useCompletedProcessingGroupsLazyQuery>;
export type CompletedProcessingGroupsQueryResult = Apollo.QueryResult<CompletedProcessingGroupsQuery, CompletedProcessingGroupsQueryVariables>;
export const ProcessingGroupDocument = gql`
    query processingGroup($id: String!) {
  processingGroup(id: $id) {
    ...ProcessingGroupOverviewFields
  }
}
    ${ProcessingGroupOverviewFieldsFragmentDoc}`;

/**
 * __useProcessingGroupQuery__
 *
 * To run a query within a React component, call `useProcessingGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessingGroupQuery(baseOptions?: Apollo.QueryHookOptions<ProcessingGroupQuery, ProcessingGroupQueryVariables>) {
        return Apollo.useQuery<ProcessingGroupQuery, ProcessingGroupQueryVariables>(ProcessingGroupDocument, baseOptions);
      }
export function useProcessingGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingGroupQuery, ProcessingGroupQueryVariables>) {
          return Apollo.useLazyQuery<ProcessingGroupQuery, ProcessingGroupQueryVariables>(ProcessingGroupDocument, baseOptions);
        }
export type ProcessingGroupQueryHookResult = ReturnType<typeof useProcessingGroupQuery>;
export type ProcessingGroupLazyQueryHookResult = ReturnType<typeof useProcessingGroupLazyQuery>;
export type ProcessingGroupQueryResult = Apollo.QueryResult<ProcessingGroupQuery, ProcessingGroupQueryVariables>;
export const ProcessingGroupWithJobsDocument = gql`
    query processingGroupWithJobs($id: String!) {
  processingGroup(id: $id) {
    ...ProcessingGroupOverviewFields
    ...ProcessingGroupFieldsWithStageJobs
  }
}
    ${ProcessingGroupOverviewFieldsFragmentDoc}
${ProcessingGroupFieldsWithStageJobsFragmentDoc}`;

/**
 * __useProcessingGroupWithJobsQuery__
 *
 * To run a query within a React component, call `useProcessingGroupWithJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingGroupWithJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingGroupWithJobsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessingGroupWithJobsQuery(baseOptions?: Apollo.QueryHookOptions<ProcessingGroupWithJobsQuery, ProcessingGroupWithJobsQueryVariables>) {
        return Apollo.useQuery<ProcessingGroupWithJobsQuery, ProcessingGroupWithJobsQueryVariables>(ProcessingGroupWithJobsDocument, baseOptions);
      }
export function useProcessingGroupWithJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingGroupWithJobsQuery, ProcessingGroupWithJobsQueryVariables>) {
          return Apollo.useLazyQuery<ProcessingGroupWithJobsQuery, ProcessingGroupWithJobsQueryVariables>(ProcessingGroupWithJobsDocument, baseOptions);
        }
export type ProcessingGroupWithJobsQueryHookResult = ReturnType<typeof useProcessingGroupWithJobsQuery>;
export type ProcessingGroupWithJobsLazyQueryHookResult = ReturnType<typeof useProcessingGroupWithJobsLazyQuery>;
export type ProcessingGroupWithJobsQueryResult = Apollo.QueryResult<ProcessingGroupWithJobsQuery, ProcessingGroupWithJobsQueryVariables>;
export const ProcessingGroupWithStrainsAndStagesDocument = gql`
    query processingGroupWithStrainsAndStages($id: String!, $strainId: String) {
  processingGroup(id: $id) {
    ...ProcessingGroupWithStrainsAndStagesFields
  }
}
    ${ProcessingGroupWithStrainsAndStagesFieldsFragmentDoc}`;

/**
 * __useProcessingGroupWithStrainsAndStagesQuery__
 *
 * To run a query within a React component, call `useProcessingGroupWithStrainsAndStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingGroupWithStrainsAndStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingGroupWithStrainsAndStagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      strainId: // value for 'strainId'
 *   },
 * });
 */
export function useProcessingGroupWithStrainsAndStagesQuery(baseOptions?: Apollo.QueryHookOptions<ProcessingGroupWithStrainsAndStagesQuery, ProcessingGroupWithStrainsAndStagesQueryVariables>) {
        return Apollo.useQuery<ProcessingGroupWithStrainsAndStagesQuery, ProcessingGroupWithStrainsAndStagesQueryVariables>(ProcessingGroupWithStrainsAndStagesDocument, baseOptions);
      }
export function useProcessingGroupWithStrainsAndStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingGroupWithStrainsAndStagesQuery, ProcessingGroupWithStrainsAndStagesQueryVariables>) {
          return Apollo.useLazyQuery<ProcessingGroupWithStrainsAndStagesQuery, ProcessingGroupWithStrainsAndStagesQueryVariables>(ProcessingGroupWithStrainsAndStagesDocument, baseOptions);
        }
export type ProcessingGroupWithStrainsAndStagesQueryHookResult = ReturnType<typeof useProcessingGroupWithStrainsAndStagesQuery>;
export type ProcessingGroupWithStrainsAndStagesLazyQueryHookResult = ReturnType<typeof useProcessingGroupWithStrainsAndStagesLazyQuery>;
export type ProcessingGroupWithStrainsAndStagesQueryResult = Apollo.QueryResult<ProcessingGroupWithStrainsAndStagesQuery, ProcessingGroupWithStrainsAndStagesQueryVariables>;
export const ProcessingGroupWithStrainsAndStagesAndJobsDocument = gql`
    query processingGroupWithStrainsAndStagesAndJobs($id: String!, $strainId: String) {
  processingGroup(id: $id) {
    ...ProcessingGroupWithStrainsAndStagesFieldsAndJobs
  }
}
    ${ProcessingGroupWithStrainsAndStagesFieldsAndJobsFragmentDoc}`;

/**
 * __useProcessingGroupWithStrainsAndStagesAndJobsQuery__
 *
 * To run a query within a React component, call `useProcessingGroupWithStrainsAndStagesAndJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingGroupWithStrainsAndStagesAndJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingGroupWithStrainsAndStagesAndJobsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      strainId: // value for 'strainId'
 *   },
 * });
 */
export function useProcessingGroupWithStrainsAndStagesAndJobsQuery(baseOptions?: Apollo.QueryHookOptions<ProcessingGroupWithStrainsAndStagesAndJobsQuery, ProcessingGroupWithStrainsAndStagesAndJobsQueryVariables>) {
        return Apollo.useQuery<ProcessingGroupWithStrainsAndStagesAndJobsQuery, ProcessingGroupWithStrainsAndStagesAndJobsQueryVariables>(ProcessingGroupWithStrainsAndStagesAndJobsDocument, baseOptions);
      }
export function useProcessingGroupWithStrainsAndStagesAndJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingGroupWithStrainsAndStagesAndJobsQuery, ProcessingGroupWithStrainsAndStagesAndJobsQueryVariables>) {
          return Apollo.useLazyQuery<ProcessingGroupWithStrainsAndStagesAndJobsQuery, ProcessingGroupWithStrainsAndStagesAndJobsQueryVariables>(ProcessingGroupWithStrainsAndStagesAndJobsDocument, baseOptions);
        }
export type ProcessingGroupWithStrainsAndStagesAndJobsQueryHookResult = ReturnType<typeof useProcessingGroupWithStrainsAndStagesAndJobsQuery>;
export type ProcessingGroupWithStrainsAndStagesAndJobsLazyQueryHookResult = ReturnType<typeof useProcessingGroupWithStrainsAndStagesAndJobsLazyQuery>;
export type ProcessingGroupWithStrainsAndStagesAndJobsQueryResult = Apollo.QueryResult<ProcessingGroupWithStrainsAndStagesAndJobsQuery, ProcessingGroupWithStrainsAndStagesAndJobsQueryVariables>;
export const ProcessingGroupStatusDocument = gql`
    query processingGroupStatus($id: String!) {
  processingGroup(id: $id) {
    id
    name
    status
    processingGroupStrains {
      id
      status
    }
  }
}
    `;

/**
 * __useProcessingGroupStatusQuery__
 *
 * To run a query within a React component, call `useProcessingGroupStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingGroupStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingGroupStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessingGroupStatusQuery(baseOptions?: Apollo.QueryHookOptions<ProcessingGroupStatusQuery, ProcessingGroupStatusQueryVariables>) {
        return Apollo.useQuery<ProcessingGroupStatusQuery, ProcessingGroupStatusQueryVariables>(ProcessingGroupStatusDocument, baseOptions);
      }
export function useProcessingGroupStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingGroupStatusQuery, ProcessingGroupStatusQueryVariables>) {
          return Apollo.useLazyQuery<ProcessingGroupStatusQuery, ProcessingGroupStatusQueryVariables>(ProcessingGroupStatusDocument, baseOptions);
        }
export type ProcessingGroupStatusQueryHookResult = ReturnType<typeof useProcessingGroupStatusQuery>;
export type ProcessingGroupStatusLazyQueryHookResult = ReturnType<typeof useProcessingGroupStatusLazyQuery>;
export type ProcessingGroupStatusQueryResult = Apollo.QueryResult<ProcessingGroupStatusQuery, ProcessingGroupStatusQueryVariables>;
export const AllProcessingGroupsWithStrainsAndStagesDocument = gql`
    query allProcessingGroupsWithStrainsAndStages($strainId: String) {
  processingGroups {
    ...ProcessingGroupShortOverview
    ...ProcessingGroupWithStrainsAndStagesFields
  }
}
    ${ProcessingGroupShortOverviewFragmentDoc}
${ProcessingGroupWithStrainsAndStagesFieldsFragmentDoc}`;

/**
 * __useAllProcessingGroupsWithStrainsAndStagesQuery__
 *
 * To run a query within a React component, call `useAllProcessingGroupsWithStrainsAndStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProcessingGroupsWithStrainsAndStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProcessingGroupsWithStrainsAndStagesQuery({
 *   variables: {
 *      strainId: // value for 'strainId'
 *   },
 * });
 */
export function useAllProcessingGroupsWithStrainsAndStagesQuery(baseOptions?: Apollo.QueryHookOptions<AllProcessingGroupsWithStrainsAndStagesQuery, AllProcessingGroupsWithStrainsAndStagesQueryVariables>) {
        return Apollo.useQuery<AllProcessingGroupsWithStrainsAndStagesQuery, AllProcessingGroupsWithStrainsAndStagesQueryVariables>(AllProcessingGroupsWithStrainsAndStagesDocument, baseOptions);
      }
export function useAllProcessingGroupsWithStrainsAndStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProcessingGroupsWithStrainsAndStagesQuery, AllProcessingGroupsWithStrainsAndStagesQueryVariables>) {
          return Apollo.useLazyQuery<AllProcessingGroupsWithStrainsAndStagesQuery, AllProcessingGroupsWithStrainsAndStagesQueryVariables>(AllProcessingGroupsWithStrainsAndStagesDocument, baseOptions);
        }
export type AllProcessingGroupsWithStrainsAndStagesQueryHookResult = ReturnType<typeof useAllProcessingGroupsWithStrainsAndStagesQuery>;
export type AllProcessingGroupsWithStrainsAndStagesLazyQueryHookResult = ReturnType<typeof useAllProcessingGroupsWithStrainsAndStagesLazyQuery>;
export type AllProcessingGroupsWithStrainsAndStagesQueryResult = Apollo.QueryResult<AllProcessingGroupsWithStrainsAndStagesQuery, AllProcessingGroupsWithStrainsAndStagesQueryVariables>;
export const AllProcessingGroupsShortOverviewDocument = gql`
    query allProcessingGroupsShortOverview {
  processingGroups {
    ...ProcessingGroupShortOverview
  }
}
    ${ProcessingGroupShortOverviewFragmentDoc}`;

/**
 * __useAllProcessingGroupsShortOverviewQuery__
 *
 * To run a query within a React component, call `useAllProcessingGroupsShortOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProcessingGroupsShortOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProcessingGroupsShortOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllProcessingGroupsShortOverviewQuery(baseOptions?: Apollo.QueryHookOptions<AllProcessingGroupsShortOverviewQuery, AllProcessingGroupsShortOverviewQueryVariables>) {
        return Apollo.useQuery<AllProcessingGroupsShortOverviewQuery, AllProcessingGroupsShortOverviewQueryVariables>(AllProcessingGroupsShortOverviewDocument, baseOptions);
      }
export function useAllProcessingGroupsShortOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProcessingGroupsShortOverviewQuery, AllProcessingGroupsShortOverviewQueryVariables>) {
          return Apollo.useLazyQuery<AllProcessingGroupsShortOverviewQuery, AllProcessingGroupsShortOverviewQueryVariables>(AllProcessingGroupsShortOverviewDocument, baseOptions);
        }
export type AllProcessingGroupsShortOverviewQueryHookResult = ReturnType<typeof useAllProcessingGroupsShortOverviewQuery>;
export type AllProcessingGroupsShortOverviewLazyQueryHookResult = ReturnType<typeof useAllProcessingGroupsShortOverviewLazyQuery>;
export type AllProcessingGroupsShortOverviewQueryResult = Apollo.QueryResult<AllProcessingGroupsShortOverviewQuery, AllProcessingGroupsShortOverviewQueryVariables>;
export const CreateProcessingGroupDocument = gql`
    mutation createProcessingGroup($input: CreateProcessingGroupInput!) {
  createProcessingGroup(input: $input) {
    ... on ProcessingGroup {
      ...ProcessingGroupFields
    }
    ... on Error {
      message
    }
  }
}
    ${ProcessingGroupFieldsFragmentDoc}`;
export type CreateProcessingGroupMutationFn = Apollo.MutationFunction<CreateProcessingGroupMutation, CreateProcessingGroupMutationVariables>;

/**
 * __useCreateProcessingGroupMutation__
 *
 * To run a mutation, you first call `useCreateProcessingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcessingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcessingGroupMutation, { data, loading, error }] = useCreateProcessingGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcessingGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcessingGroupMutation, CreateProcessingGroupMutationVariables>) {
        return Apollo.useMutation<CreateProcessingGroupMutation, CreateProcessingGroupMutationVariables>(CreateProcessingGroupDocument, baseOptions);
      }
export type CreateProcessingGroupMutationHookResult = ReturnType<typeof useCreateProcessingGroupMutation>;
export type CreateProcessingGroupMutationResult = Apollo.MutationResult<CreateProcessingGroupMutation>;
export type CreateProcessingGroupMutationOptions = Apollo.BaseMutationOptions<CreateProcessingGroupMutation, CreateProcessingGroupMutationVariables>;
export const CreateProcessingGroupStrainInventoryAdjustmentDocument = gql`
    mutation createProcessingGroupStrainInventoryAdjustment($input: CreateProcessingGroupStrainInventoryAdjustmentInput!) {
  createProcessingGroupStrainInventoryAdjustment(input: $input) {
    ... on ProcessingGroupStrain {
      ...ProcessingGroupStrainFields
    }
    ... on Error {
      message
    }
  }
}
    ${ProcessingGroupStrainFieldsFragmentDoc}`;
export type CreateProcessingGroupStrainInventoryAdjustmentMutationFn = Apollo.MutationFunction<CreateProcessingGroupStrainInventoryAdjustmentMutation, CreateProcessingGroupStrainInventoryAdjustmentMutationVariables>;

/**
 * __useCreateProcessingGroupStrainInventoryAdjustmentMutation__
 *
 * To run a mutation, you first call `useCreateProcessingGroupStrainInventoryAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcessingGroupStrainInventoryAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcessingGroupStrainInventoryAdjustmentMutation, { data, loading, error }] = useCreateProcessingGroupStrainInventoryAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcessingGroupStrainInventoryAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcessingGroupStrainInventoryAdjustmentMutation, CreateProcessingGroupStrainInventoryAdjustmentMutationVariables>) {
        return Apollo.useMutation<CreateProcessingGroupStrainInventoryAdjustmentMutation, CreateProcessingGroupStrainInventoryAdjustmentMutationVariables>(CreateProcessingGroupStrainInventoryAdjustmentDocument, baseOptions);
      }
export type CreateProcessingGroupStrainInventoryAdjustmentMutationHookResult = ReturnType<typeof useCreateProcessingGroupStrainInventoryAdjustmentMutation>;
export type CreateProcessingGroupStrainInventoryAdjustmentMutationResult = Apollo.MutationResult<CreateProcessingGroupStrainInventoryAdjustmentMutation>;
export type CreateProcessingGroupStrainInventoryAdjustmentMutationOptions = Apollo.BaseMutationOptions<CreateProcessingGroupStrainInventoryAdjustmentMutation, CreateProcessingGroupStrainInventoryAdjustmentMutationVariables>;
export const ArchiveProcessingGroupDocument = gql`
    mutation archiveProcessingGroup($id: ID!) {
  updateProcessingGroupArchived(input: {archivedAt: "true", id: $id}) {
    ...ProcessingGroupFields
  }
}
    ${ProcessingGroupFieldsFragmentDoc}`;
export type ArchiveProcessingGroupMutationFn = Apollo.MutationFunction<ArchiveProcessingGroupMutation, ArchiveProcessingGroupMutationVariables>;

/**
 * __useArchiveProcessingGroupMutation__
 *
 * To run a mutation, you first call `useArchiveProcessingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProcessingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProcessingGroupMutation, { data, loading, error }] = useArchiveProcessingGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveProcessingGroupMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveProcessingGroupMutation, ArchiveProcessingGroupMutationVariables>) {
        return Apollo.useMutation<ArchiveProcessingGroupMutation, ArchiveProcessingGroupMutationVariables>(ArchiveProcessingGroupDocument, baseOptions);
      }
export type ArchiveProcessingGroupMutationHookResult = ReturnType<typeof useArchiveProcessingGroupMutation>;
export type ArchiveProcessingGroupMutationResult = Apollo.MutationResult<ArchiveProcessingGroupMutation>;
export type ArchiveProcessingGroupMutationOptions = Apollo.BaseMutationOptions<ArchiveProcessingGroupMutation, ArchiveProcessingGroupMutationVariables>;
export const UnarchiveProcessingGroupDocument = gql`
    mutation unarchiveProcessingGroup($id: ID!) {
  updateProcessingGroupArchived(input: {archivedAt: "false", id: $id}) {
    ...ProcessingGroupFields
  }
}
    ${ProcessingGroupFieldsFragmentDoc}`;
export type UnarchiveProcessingGroupMutationFn = Apollo.MutationFunction<UnarchiveProcessingGroupMutation, UnarchiveProcessingGroupMutationVariables>;

/**
 * __useUnarchiveProcessingGroupMutation__
 *
 * To run a mutation, you first call `useUnarchiveProcessingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveProcessingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveProcessingGroupMutation, { data, loading, error }] = useUnarchiveProcessingGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveProcessingGroupMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveProcessingGroupMutation, UnarchiveProcessingGroupMutationVariables>) {
        return Apollo.useMutation<UnarchiveProcessingGroupMutation, UnarchiveProcessingGroupMutationVariables>(UnarchiveProcessingGroupDocument, baseOptions);
      }
export type UnarchiveProcessingGroupMutationHookResult = ReturnType<typeof useUnarchiveProcessingGroupMutation>;
export type UnarchiveProcessingGroupMutationResult = Apollo.MutationResult<UnarchiveProcessingGroupMutation>;
export type UnarchiveProcessingGroupMutationOptions = Apollo.BaseMutationOptions<UnarchiveProcessingGroupMutation, UnarchiveProcessingGroupMutationVariables>;
export const MoveUpProcessingGroupStrainDocument = gql`
    mutation moveUpProcessingGroupStrain($input: MoveUpProcessingGroupStrainInput!) {
  moveUpProcessingGroupStrain(input: $input) {
    ... on ProcessingGroupStrain {
      ...ProcessingGroupStrainFields
    }
    ... on Error {
      message
    }
  }
}
    ${ProcessingGroupStrainFieldsFragmentDoc}`;
export type MoveUpProcessingGroupStrainMutationFn = Apollo.MutationFunction<MoveUpProcessingGroupStrainMutation, MoveUpProcessingGroupStrainMutationVariables>;

/**
 * __useMoveUpProcessingGroupStrainMutation__
 *
 * To run a mutation, you first call `useMoveUpProcessingGroupStrainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveUpProcessingGroupStrainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveUpProcessingGroupStrainMutation, { data, loading, error }] = useMoveUpProcessingGroupStrainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveUpProcessingGroupStrainMutation(baseOptions?: Apollo.MutationHookOptions<MoveUpProcessingGroupStrainMutation, MoveUpProcessingGroupStrainMutationVariables>) {
        return Apollo.useMutation<MoveUpProcessingGroupStrainMutation, MoveUpProcessingGroupStrainMutationVariables>(MoveUpProcessingGroupStrainDocument, baseOptions);
      }
export type MoveUpProcessingGroupStrainMutationHookResult = ReturnType<typeof useMoveUpProcessingGroupStrainMutation>;
export type MoveUpProcessingGroupStrainMutationResult = Apollo.MutationResult<MoveUpProcessingGroupStrainMutation>;
export type MoveUpProcessingGroupStrainMutationOptions = Apollo.BaseMutationOptions<MoveUpProcessingGroupStrainMutation, MoveUpProcessingGroupStrainMutationVariables>;
export const FinishProcessingGroupStrainDocument = gql`
    mutation finishProcessingGroupStrain($input: FinishProcessingGroupStrainInput!) {
  finishProcessingGroupStrain(input: $input) {
    ... on ProcessingGroupStrain {
      ...ProcessingGroupStrainFields
    }
    ... on Error {
      message
    }
  }
}
    ${ProcessingGroupStrainFieldsFragmentDoc}`;
export type FinishProcessingGroupStrainMutationFn = Apollo.MutationFunction<FinishProcessingGroupStrainMutation, FinishProcessingGroupStrainMutationVariables>;

/**
 * __useFinishProcessingGroupStrainMutation__
 *
 * To run a mutation, you first call `useFinishProcessingGroupStrainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishProcessingGroupStrainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishProcessingGroupStrainMutation, { data, loading, error }] = useFinishProcessingGroupStrainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinishProcessingGroupStrainMutation(baseOptions?: Apollo.MutationHookOptions<FinishProcessingGroupStrainMutation, FinishProcessingGroupStrainMutationVariables>) {
        return Apollo.useMutation<FinishProcessingGroupStrainMutation, FinishProcessingGroupStrainMutationVariables>(FinishProcessingGroupStrainDocument, baseOptions);
      }
export type FinishProcessingGroupStrainMutationHookResult = ReturnType<typeof useFinishProcessingGroupStrainMutation>;
export type FinishProcessingGroupStrainMutationResult = Apollo.MutationResult<FinishProcessingGroupStrainMutation>;
export type FinishProcessingGroupStrainMutationOptions = Apollo.BaseMutationOptions<FinishProcessingGroupStrainMutation, FinishProcessingGroupStrainMutationVariables>;
export const ProcessingGroupTemplatesDocument = gql`
    query processingGroupTemplates($filters: ProcessingGroupTemplateFilterSetInput) {
  processingGroupTemplates(filters: $filters) {
    ...ProcessingGroupTemplateFields
  }
}
    ${ProcessingGroupTemplateFieldsFragmentDoc}`;

/**
 * __useProcessingGroupTemplatesQuery__
 *
 * To run a query within a React component, call `useProcessingGroupTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingGroupTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingGroupTemplatesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProcessingGroupTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ProcessingGroupTemplatesQuery, ProcessingGroupTemplatesQueryVariables>) {
        return Apollo.useQuery<ProcessingGroupTemplatesQuery, ProcessingGroupTemplatesQueryVariables>(ProcessingGroupTemplatesDocument, baseOptions);
      }
export function useProcessingGroupTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingGroupTemplatesQuery, ProcessingGroupTemplatesQueryVariables>) {
          return Apollo.useLazyQuery<ProcessingGroupTemplatesQuery, ProcessingGroupTemplatesQueryVariables>(ProcessingGroupTemplatesDocument, baseOptions);
        }
export type ProcessingGroupTemplatesQueryHookResult = ReturnType<typeof useProcessingGroupTemplatesQuery>;
export type ProcessingGroupTemplatesLazyQueryHookResult = ReturnType<typeof useProcessingGroupTemplatesLazyQuery>;
export type ProcessingGroupTemplatesQueryResult = Apollo.QueryResult<ProcessingGroupTemplatesQuery, ProcessingGroupTemplatesQueryVariables>;
export const ProcessingGroupTemplateDocument = gql`
    query processingGroupTemplate($id: String!) {
  processingGroupTemplate(id: $id) {
    ...ProcessingGroupTemplateFields
  }
}
    ${ProcessingGroupTemplateFieldsFragmentDoc}`;

/**
 * __useProcessingGroupTemplateQuery__
 *
 * To run a query within a React component, call `useProcessingGroupTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingGroupTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingGroupTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessingGroupTemplateQuery(baseOptions?: Apollo.QueryHookOptions<ProcessingGroupTemplateQuery, ProcessingGroupTemplateQueryVariables>) {
        return Apollo.useQuery<ProcessingGroupTemplateQuery, ProcessingGroupTemplateQueryVariables>(ProcessingGroupTemplateDocument, baseOptions);
      }
export function useProcessingGroupTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingGroupTemplateQuery, ProcessingGroupTemplateQueryVariables>) {
          return Apollo.useLazyQuery<ProcessingGroupTemplateQuery, ProcessingGroupTemplateQueryVariables>(ProcessingGroupTemplateDocument, baseOptions);
        }
export type ProcessingGroupTemplateQueryHookResult = ReturnType<typeof useProcessingGroupTemplateQuery>;
export type ProcessingGroupTemplateLazyQueryHookResult = ReturnType<typeof useProcessingGroupTemplateLazyQuery>;
export type ProcessingGroupTemplateQueryResult = Apollo.QueryResult<ProcessingGroupTemplateQuery, ProcessingGroupTemplateQueryVariables>;
export const AddProcessingGroupTemplateDocument = gql`
    mutation addProcessingGroupTemplate($input: CreateProcessingGroupTemplateInput!) {
  createProcessingGroupTemplate(input: $input) {
    ...ProcessingGroupTemplateFields
  }
}
    ${ProcessingGroupTemplateFieldsFragmentDoc}`;
export type AddProcessingGroupTemplateMutationFn = Apollo.MutationFunction<AddProcessingGroupTemplateMutation, AddProcessingGroupTemplateMutationVariables>;

/**
 * __useAddProcessingGroupTemplateMutation__
 *
 * To run a mutation, you first call `useAddProcessingGroupTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProcessingGroupTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProcessingGroupTemplateMutation, { data, loading, error }] = useAddProcessingGroupTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProcessingGroupTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddProcessingGroupTemplateMutation, AddProcessingGroupTemplateMutationVariables>) {
        return Apollo.useMutation<AddProcessingGroupTemplateMutation, AddProcessingGroupTemplateMutationVariables>(AddProcessingGroupTemplateDocument, baseOptions);
      }
export type AddProcessingGroupTemplateMutationHookResult = ReturnType<typeof useAddProcessingGroupTemplateMutation>;
export type AddProcessingGroupTemplateMutationResult = Apollo.MutationResult<AddProcessingGroupTemplateMutation>;
export type AddProcessingGroupTemplateMutationOptions = Apollo.BaseMutationOptions<AddProcessingGroupTemplateMutation, AddProcessingGroupTemplateMutationVariables>;
export const UpdateActiveProcessingGroupTemplateVersionDocument = gql`
    mutation updateActiveProcessingGroupTemplateVersion($input: UpdateActiveProcessingGroupTemplateVersionInput!) {
  updateActiveProcessingGroupTemplateVersion(input: $input) {
    ...ProcessingGroupTemplateFields
  }
}
    ${ProcessingGroupTemplateFieldsFragmentDoc}`;
export type UpdateActiveProcessingGroupTemplateVersionMutationFn = Apollo.MutationFunction<UpdateActiveProcessingGroupTemplateVersionMutation, UpdateActiveProcessingGroupTemplateVersionMutationVariables>;

/**
 * __useUpdateActiveProcessingGroupTemplateVersionMutation__
 *
 * To run a mutation, you first call `useUpdateActiveProcessingGroupTemplateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActiveProcessingGroupTemplateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActiveProcessingGroupTemplateVersionMutation, { data, loading, error }] = useUpdateActiveProcessingGroupTemplateVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActiveProcessingGroupTemplateVersionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActiveProcessingGroupTemplateVersionMutation, UpdateActiveProcessingGroupTemplateVersionMutationVariables>) {
        return Apollo.useMutation<UpdateActiveProcessingGroupTemplateVersionMutation, UpdateActiveProcessingGroupTemplateVersionMutationVariables>(UpdateActiveProcessingGroupTemplateVersionDocument, baseOptions);
      }
export type UpdateActiveProcessingGroupTemplateVersionMutationHookResult = ReturnType<typeof useUpdateActiveProcessingGroupTemplateVersionMutation>;
export type UpdateActiveProcessingGroupTemplateVersionMutationResult = Apollo.MutationResult<UpdateActiveProcessingGroupTemplateVersionMutation>;
export type UpdateActiveProcessingGroupTemplateVersionMutationOptions = Apollo.BaseMutationOptions<UpdateActiveProcessingGroupTemplateVersionMutation, UpdateActiveProcessingGroupTemplateVersionMutationVariables>;
export const ArchiveProcessingGroupTemplateDocument = gql`
    mutation archiveProcessingGroupTemplate($id: ID!) {
  updateProcessingGroupTemplateArchived(input: {archivedAt: "true", id: $id}) {
    ...ProcessingGroupTemplateFields
  }
}
    ${ProcessingGroupTemplateFieldsFragmentDoc}`;
export type ArchiveProcessingGroupTemplateMutationFn = Apollo.MutationFunction<ArchiveProcessingGroupTemplateMutation, ArchiveProcessingGroupTemplateMutationVariables>;

/**
 * __useArchiveProcessingGroupTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveProcessingGroupTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProcessingGroupTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProcessingGroupTemplateMutation, { data, loading, error }] = useArchiveProcessingGroupTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveProcessingGroupTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveProcessingGroupTemplateMutation, ArchiveProcessingGroupTemplateMutationVariables>) {
        return Apollo.useMutation<ArchiveProcessingGroupTemplateMutation, ArchiveProcessingGroupTemplateMutationVariables>(ArchiveProcessingGroupTemplateDocument, baseOptions);
      }
export type ArchiveProcessingGroupTemplateMutationHookResult = ReturnType<typeof useArchiveProcessingGroupTemplateMutation>;
export type ArchiveProcessingGroupTemplateMutationResult = Apollo.MutationResult<ArchiveProcessingGroupTemplateMutation>;
export type ArchiveProcessingGroupTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveProcessingGroupTemplateMutation, ArchiveProcessingGroupTemplateMutationVariables>;
export const UnarchiveProcessingGroupTemplateDocument = gql`
    mutation unarchiveProcessingGroupTemplate($id: ID!) {
  updateProcessingGroupTemplateArchived(input: {archivedAt: "false", id: $id}) {
    ...ProcessingGroupTemplateFields
  }
}
    ${ProcessingGroupTemplateFieldsFragmentDoc}`;
export type UnarchiveProcessingGroupTemplateMutationFn = Apollo.MutationFunction<UnarchiveProcessingGroupTemplateMutation, UnarchiveProcessingGroupTemplateMutationVariables>;

/**
 * __useUnarchiveProcessingGroupTemplateMutation__
 *
 * To run a mutation, you first call `useUnarchiveProcessingGroupTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveProcessingGroupTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveProcessingGroupTemplateMutation, { data, loading, error }] = useUnarchiveProcessingGroupTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveProcessingGroupTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveProcessingGroupTemplateMutation, UnarchiveProcessingGroupTemplateMutationVariables>) {
        return Apollo.useMutation<UnarchiveProcessingGroupTemplateMutation, UnarchiveProcessingGroupTemplateMutationVariables>(UnarchiveProcessingGroupTemplateDocument, baseOptions);
      }
export type UnarchiveProcessingGroupTemplateMutationHookResult = ReturnType<typeof useUnarchiveProcessingGroupTemplateMutation>;
export type UnarchiveProcessingGroupTemplateMutationResult = Apollo.MutationResult<UnarchiveProcessingGroupTemplateMutation>;
export type UnarchiveProcessingGroupTemplateMutationOptions = Apollo.BaseMutationOptions<UnarchiveProcessingGroupTemplateMutation, UnarchiveProcessingGroupTemplateMutationVariables>;
export const HarvestAnalysisReportDocument = gql`
    query HarvestAnalysisReport($organizationId: ID, $siteId: ID, $start: Date, $end: Date) {
  harvestAnalysisReport(
    organizationId: $organizationId
    siteId: $siteId
    startDate: $start
    endDate: $end
  ) {
    truncated
    excludedBatches {
      groupName
      metrcHarvestName
      linkedHarvests
      id
      name
      harvestGroupId
      groupDate
      harvestDate
      siteName
      strainId
      strainName
      issues
    }
    metadata {
      generatedAt
      report
      organizationId
    }
    metrics {
      name
      value
      unit
    }
    rows {
      id
      name
      siteName
      zoneId
      zoneName
      date
      startDate
      flowerStartDate
      metrics {
        name
        value
        unit
      }
    }
    dataQuality {
      code
      severity
      message
    }
    caveats
  }
}
    `;

/**
 * __useHarvestAnalysisReportQuery__
 *
 * To run a query within a React component, call `useHarvestAnalysisReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestAnalysisReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestAnalysisReportQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      siteId: // value for 'siteId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useHarvestAnalysisReportQuery(baseOptions?: Apollo.QueryHookOptions<HarvestAnalysisReportQuery, HarvestAnalysisReportQueryVariables>) {
        return Apollo.useQuery<HarvestAnalysisReportQuery, HarvestAnalysisReportQueryVariables>(HarvestAnalysisReportDocument, baseOptions);
      }
export function useHarvestAnalysisReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestAnalysisReportQuery, HarvestAnalysisReportQueryVariables>) {
          return Apollo.useLazyQuery<HarvestAnalysisReportQuery, HarvestAnalysisReportQueryVariables>(HarvestAnalysisReportDocument, baseOptions);
        }
export type HarvestAnalysisReportQueryHookResult = ReturnType<typeof useHarvestAnalysisReportQuery>;
export type HarvestAnalysisReportLazyQueryHookResult = ReturnType<typeof useHarvestAnalysisReportLazyQuery>;
export type HarvestAnalysisReportQueryResult = Apollo.QueryResult<HarvestAnalysisReportQuery, HarvestAnalysisReportQueryVariables>;
export const HarvestAnalysisDetailReportDocument = gql`
    query HarvestAnalysisDetailReport($harvestGroupId: ID!, $organizationId: ID, $siteId: ID, $start: Date, $end: Date) {
  harvestAnalysisDetailReport(
    harvestGroupId: $harvestGroupId
    organizationId: $organizationId
    siteId: $siteId
    startDate: $start
    endDate: $end
  ) {
    truncated
    excludedBatches {
      groupName
      metrcHarvestName
      linkedHarvests
      id
      name
      harvestGroupId
      groupDate
      harvestDate
      siteName
      strainId
      strainName
      issues
    }
    metadata {
      generatedAt
      report
      organizationId
    }
    metrics {
      name
      value
      unit
    }
    rows {
      id
      strainId
      strainName
      metrics {
        name
        value
        unit
      }
    }
    dataQuality {
      code
      severity
      message
    }
    caveats
  }
}
    `;

/**
 * __useHarvestAnalysisDetailReportQuery__
 *
 * To run a query within a React component, call `useHarvestAnalysisDetailReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestAnalysisDetailReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestAnalysisDetailReportQuery({
 *   variables: {
 *      harvestGroupId: // value for 'harvestGroupId'
 *      organizationId: // value for 'organizationId'
 *      siteId: // value for 'siteId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useHarvestAnalysisDetailReportQuery(baseOptions?: Apollo.QueryHookOptions<HarvestAnalysisDetailReportQuery, HarvestAnalysisDetailReportQueryVariables>) {
        return Apollo.useQuery<HarvestAnalysisDetailReportQuery, HarvestAnalysisDetailReportQueryVariables>(HarvestAnalysisDetailReportDocument, baseOptions);
      }
export function useHarvestAnalysisDetailReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestAnalysisDetailReportQuery, HarvestAnalysisDetailReportQueryVariables>) {
          return Apollo.useLazyQuery<HarvestAnalysisDetailReportQuery, HarvestAnalysisDetailReportQueryVariables>(HarvestAnalysisDetailReportDocument, baseOptions);
        }
export type HarvestAnalysisDetailReportQueryHookResult = ReturnType<typeof useHarvestAnalysisDetailReportQuery>;
export type HarvestAnalysisDetailReportLazyQueryHookResult = ReturnType<typeof useHarvestAnalysisDetailReportLazyQuery>;
export type HarvestAnalysisDetailReportQueryResult = Apollo.QueryResult<HarvestAnalysisDetailReportQuery, HarvestAnalysisDetailReportQueryVariables>;
export const HarvestAnalysisInsightsReportDocument = gql`
    query HarvestAnalysisInsightsReport($harvestGroupIds: [ID!]!, $organizationId: ID, $siteId: ID, $start: Date, $end: Date) {
  harvestAnalysisInsightsReport(
    harvestGroupIds: $harvestGroupIds
    organizationId: $organizationId
    siteId: $siteId
    startDate: $start
    endDate: $end
  ) {
    metadata {
      generatedAt
      report
      organizationId
    }
    rows {
      id
      strainId
      strainName
      status
      metrics {
        name
        value
        unit
      }
    }
    dataQuality {
      code
      severity
      message
    }
    caveats
  }
}
    `;

/**
 * __useHarvestAnalysisInsightsReportQuery__
 *
 * To run a query within a React component, call `useHarvestAnalysisInsightsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestAnalysisInsightsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestAnalysisInsightsReportQuery({
 *   variables: {
 *      harvestGroupIds: // value for 'harvestGroupIds'
 *      organizationId: // value for 'organizationId'
 *      siteId: // value for 'siteId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useHarvestAnalysisInsightsReportQuery(baseOptions?: Apollo.QueryHookOptions<HarvestAnalysisInsightsReportQuery, HarvestAnalysisInsightsReportQueryVariables>) {
        return Apollo.useQuery<HarvestAnalysisInsightsReportQuery, HarvestAnalysisInsightsReportQueryVariables>(HarvestAnalysisInsightsReportDocument, baseOptions);
      }
export function useHarvestAnalysisInsightsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestAnalysisInsightsReportQuery, HarvestAnalysisInsightsReportQueryVariables>) {
          return Apollo.useLazyQuery<HarvestAnalysisInsightsReportQuery, HarvestAnalysisInsightsReportQueryVariables>(HarvestAnalysisInsightsReportDocument, baseOptions);
        }
export type HarvestAnalysisInsightsReportQueryHookResult = ReturnType<typeof useHarvestAnalysisInsightsReportQuery>;
export type HarvestAnalysisInsightsReportLazyQueryHookResult = ReturnType<typeof useHarvestAnalysisInsightsReportLazyQuery>;
export type HarvestAnalysisInsightsReportQueryResult = Apollo.QueryResult<HarvestAnalysisInsightsReportQuery, HarvestAnalysisInsightsReportQueryVariables>;
export const StrainPerformanceReportDocument = gql`
    query StrainPerformanceReport($organizationId: ID, $siteId: ID, $start: Date, $end: Date) {
  strainPerformanceReport(
    organizationId: $organizationId
    siteId: $siteId
    startDate: $start
    endDate: $end
  ) {
    truncated
    excludedBatches {
      groupName
      metrcHarvestName
      linkedHarvests
      id
      name
      harvestGroupId
      groupDate
      harvestDate
      siteName
      strainId
      strainName
      issues
    }
    metadata {
      generatedAt
      report
      organizationId
    }
    metrics {
      name
      value
      unit
    }
    rows {
      id
      strainId
      strainName
      zoneId
      zoneName
      status
      metrics {
        name
        value
        unit
      }
    }
    relatedRows {
      id
      name
      strainId
      strainName
      zoneId
      zoneName
      date
      status
      metrics {
        name
        value
        unit
      }
    }
    dataQuality {
      code
      severity
      message
    }
    caveats
  }
}
    `;

/**
 * __useStrainPerformanceReportQuery__
 *
 * To run a query within a React component, call `useStrainPerformanceReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useStrainPerformanceReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStrainPerformanceReportQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      siteId: // value for 'siteId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useStrainPerformanceReportQuery(baseOptions?: Apollo.QueryHookOptions<StrainPerformanceReportQuery, StrainPerformanceReportQueryVariables>) {
        return Apollo.useQuery<StrainPerformanceReportQuery, StrainPerformanceReportQueryVariables>(StrainPerformanceReportDocument, baseOptions);
      }
export function useStrainPerformanceReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StrainPerformanceReportQuery, StrainPerformanceReportQueryVariables>) {
          return Apollo.useLazyQuery<StrainPerformanceReportQuery, StrainPerformanceReportQueryVariables>(StrainPerformanceReportDocument, baseOptions);
        }
export type StrainPerformanceReportQueryHookResult = ReturnType<typeof useStrainPerformanceReportQuery>;
export type StrainPerformanceReportLazyQueryHookResult = ReturnType<typeof useStrainPerformanceReportLazyQuery>;
export type StrainPerformanceReportQueryResult = Apollo.QueryResult<StrainPerformanceReportQuery, StrainPerformanceReportQueryVariables>;
export const HarvestBenchmarkReportDocument = gql`
    query HarvestBenchmarkReport($organizationId: ID, $siteId: ID, $start: Date, $end: Date) {
  harvestBenchmarkReport(
    organizationId: $organizationId
    siteId: $siteId
    startDate: $start
    endDate: $end
  ) {
    metadata {
      generatedAt
      report
      organizationId
    }
    metrics {
      name
      value
      unit
    }
    rows {
      id
      name
      siteName
      zoneName
      strainId
      strainName
      date
      status
      metrics {
        name
        value
        unit
      }
    }
    dataQuality {
      code
      severity
      message
    }
    caveats
  }
}
    `;

/**
 * __useHarvestBenchmarkReportQuery__
 *
 * To run a query within a React component, call `useHarvestBenchmarkReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestBenchmarkReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestBenchmarkReportQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      siteId: // value for 'siteId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useHarvestBenchmarkReportQuery(baseOptions?: Apollo.QueryHookOptions<HarvestBenchmarkReportQuery, HarvestBenchmarkReportQueryVariables>) {
        return Apollo.useQuery<HarvestBenchmarkReportQuery, HarvestBenchmarkReportQueryVariables>(HarvestBenchmarkReportDocument, baseOptions);
      }
export function useHarvestBenchmarkReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestBenchmarkReportQuery, HarvestBenchmarkReportQueryVariables>) {
          return Apollo.useLazyQuery<HarvestBenchmarkReportQuery, HarvestBenchmarkReportQueryVariables>(HarvestBenchmarkReportDocument, baseOptions);
        }
export type HarvestBenchmarkReportQueryHookResult = ReturnType<typeof useHarvestBenchmarkReportQuery>;
export type HarvestBenchmarkReportLazyQueryHookResult = ReturnType<typeof useHarvestBenchmarkReportLazyQuery>;
export type HarvestBenchmarkReportQueryResult = Apollo.QueryResult<HarvestBenchmarkReportQuery, HarvestBenchmarkReportQueryVariables>;
export const HarvestForecastReportDocument = gql`
    query HarvestForecastReport($organizationId: ID, $siteId: ID, $start: Date, $end: Date) {
  harvestForecastReport(
    organizationId: $organizationId
    siteId: $siteId
    startDate: $start
    endDate: $end
  ) {
    truncated
    excludedBatches {
      groupName
      metrcHarvestName
      linkedHarvests
      id
      name
      harvestGroupId
      groupDate
      harvestDate
      siteName
      strainId
      strainName
      issues
    }
    metadata {
      generatedAt
      report
      organizationId
    }
    metrics {
      name
      value
      unit
    }
    rows {
      id
      name
      siteId
      siteName
      strainId
      strainName
      date
      status
      metrics {
        name
        value
        unit
      }
    }
    dataQuality {
      code
      severity
      message
    }
    caveats
  }
}
    `;

/**
 * __useHarvestForecastReportQuery__
 *
 * To run a query within a React component, call `useHarvestForecastReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestForecastReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestForecastReportQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      siteId: // value for 'siteId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useHarvestForecastReportQuery(baseOptions?: Apollo.QueryHookOptions<HarvestForecastReportQuery, HarvestForecastReportQueryVariables>) {
        return Apollo.useQuery<HarvestForecastReportQuery, HarvestForecastReportQueryVariables>(HarvestForecastReportDocument, baseOptions);
      }
export function useHarvestForecastReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestForecastReportQuery, HarvestForecastReportQueryVariables>) {
          return Apollo.useLazyQuery<HarvestForecastReportQuery, HarvestForecastReportQueryVariables>(HarvestForecastReportDocument, baseOptions);
        }
export type HarvestForecastReportQueryHookResult = ReturnType<typeof useHarvestForecastReportQuery>;
export type HarvestForecastReportLazyQueryHookResult = ReturnType<typeof useHarvestForecastReportLazyQuery>;
export type HarvestForecastReportQueryResult = Apollo.QueryResult<HarvestForecastReportQuery, HarvestForecastReportQueryVariables>;
export const ApiKeysDocument = gql`
    query apiKeys {
  apiKeys {
    id
    name
    user {
      id
      firstName
      lastName
      email
    }
    keyPrefix
    accessLevel
    rateLimitTier
    active
    createdAt
    lastUsedAt
    revokedAt
  }
}
    `;

/**
 * __useApiKeysQuery__
 *
 * To run a query within a React component, call `useApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
        return Apollo.useQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, baseOptions);
      }
export function useApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          return Apollo.useLazyQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, baseOptions);
        }
export type ApiKeysQueryHookResult = ReturnType<typeof useApiKeysQuery>;
export type ApiKeysLazyQueryHookResult = ReturnType<typeof useApiKeysLazyQuery>;
export type ApiKeysQueryResult = Apollo.QueryResult<ApiKeysQuery, ApiKeysQueryVariables>;
export const CreateApiKeyDocument = gql`
    mutation createApiKey($input: CreateApiKeyInput!) {
  createApiKey(input: $input) {
    ... on CreateApiKeySuccess {
      token
      apiKey {
        id
        name
        user {
          id
          firstName
          lastName
          email
        }
        keyPrefix
        accessLevel
        rateLimitTier
        active
        createdAt
        lastUsedAt
        revokedAt
      }
    }
    ... on Error {
      message
    }
  }
}
    `;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, baseOptions);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const RevokeApiKeyDocument = gql`
    mutation revokeApiKey($input: RevokeApiKeyInput!) {
  revokeApiKey(input: $input) {
    ... on RevokeApiKeySuccess {
      apiKey {
        id
        name
        user {
          id
          firstName
          lastName
          email
        }
        keyPrefix
        accessLevel
        rateLimitTier
        active
        createdAt
        lastUsedAt
        revokedAt
      }
    }
    ... on Error {
      message
    }
  }
}
    `;
export type RevokeApiKeyMutationFn = Apollo.MutationFunction<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;

/**
 * __useRevokeApiKeyMutation__
 *
 * To run a mutation, you first call `useRevokeApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApiKeyMutation, { data, loading, error }] = useRevokeApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>) {
        return Apollo.useMutation<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>(RevokeApiKeyDocument, baseOptions);
      }
export type RevokeApiKeyMutationHookResult = ReturnType<typeof useRevokeApiKeyMutation>;
export type RevokeApiKeyMutationResult = Apollo.MutationResult<RevokeApiKeyMutation>;
export type RevokeApiKeyMutationOptions = Apollo.BaseMutationOptions<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;
export const TokenAuthDocument = gql`
    mutation tokenAuth($username_Iexact: String!, $password: String!) {
  tokenAuth(username_Iexact: $username_Iexact, password: $password) {
    __typename
    ... on TokenAuthSuccess {
      token
      refreshToken
    }
    ... on Error {
      message
    }
  }
}
    `;
export type TokenAuthMutationFn = Apollo.MutationFunction<TokenAuthMutation, TokenAuthMutationVariables>;

/**
 * __useTokenAuthMutation__
 *
 * To run a mutation, you first call `useTokenAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTokenAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tokenAuthMutation, { data, loading, error }] = useTokenAuthMutation({
 *   variables: {
 *      username_Iexact: // value for 'username_Iexact'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useTokenAuthMutation(baseOptions?: Apollo.MutationHookOptions<TokenAuthMutation, TokenAuthMutationVariables>) {
        return Apollo.useMutation<TokenAuthMutation, TokenAuthMutationVariables>(TokenAuthDocument, baseOptions);
      }
export type TokenAuthMutationHookResult = ReturnType<typeof useTokenAuthMutation>;
export type TokenAuthMutationResult = Apollo.MutationResult<TokenAuthMutation>;
export type TokenAuthMutationOptions = Apollo.BaseMutationOptions<TokenAuthMutation, TokenAuthMutationVariables>;
export const SendPasswordResetEmailDocument = gql`
    mutation sendPasswordResetEmail($email: String!) {
  sendPasswordResetEmail(email: $email) {
    __typename
    ... on SendPasswordResetEmailSuccess {
      success
    }
    ... on Error {
      message
    }
  }
}
    `;
export type SendPasswordResetEmailMutationFn = Apollo.MutationFunction<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;

/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>) {
        return Apollo.useMutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument, baseOptions);
      }
export type SendPasswordResetEmailMutationHookResult = ReturnType<typeof useSendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationResult = Apollo.MutationResult<SendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;
export const SendAccountInvitationDocument = gql`
    mutation sendAccountInvitation($id: ID!) {
  sendAccountInvitation(id: $id) {
    user {
      ...UserProfile
    }
  }
}
    ${UserProfileFragmentDoc}`;
export type SendAccountInvitationMutationFn = Apollo.MutationFunction<SendAccountInvitationMutation, SendAccountInvitationMutationVariables>;

/**
 * __useSendAccountInvitationMutation__
 *
 * To run a mutation, you first call `useSendAccountInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAccountInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAccountInvitationMutation, { data, loading, error }] = useSendAccountInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendAccountInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendAccountInvitationMutation, SendAccountInvitationMutationVariables>) {
        return Apollo.useMutation<SendAccountInvitationMutation, SendAccountInvitationMutationVariables>(SendAccountInvitationDocument, baseOptions);
      }
export type SendAccountInvitationMutationHookResult = ReturnType<typeof useSendAccountInvitationMutation>;
export type SendAccountInvitationMutationResult = Apollo.MutationResult<SendAccountInvitationMutation>;
export type SendAccountInvitationMutationOptions = Apollo.BaseMutationOptions<SendAccountInvitationMutation, SendAccountInvitationMutationVariables>;
export const PasswordResetDocument = gql`
    mutation passwordReset($token: String!, $newPassword1: String!, $newPassword2: String!) {
  passwordReset(
    token: $token
    newPassword1: $newPassword1
    newPassword2: $newPassword2
  ) {
    __typename
    ... on PasswordResetSuccess {
      success
    }
    ... on Error {
      message
    }
  }
}
    `;
export type PasswordResetMutationFn = Apollo.MutationFunction<PasswordResetMutation, PasswordResetMutationVariables>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      token: // value for 'token'
 *      newPassword1: // value for 'newPassword1'
 *      newPassword2: // value for 'newPassword2'
 *   },
 * });
 */
export function usePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>) {
        return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(PasswordResetDocument, baseOptions);
      }
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout {
    __typename
    ... on LogoutSuccess {
      success
    }
    ... on Error {
      message
    }
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, baseOptions);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation updateUserProfile($input: UpdateUserProfileInput) {
  updateUserProfile(input: $input) {
    __typename
    ... on UpdateUserProfileSuccess {
      user {
        ...UserProfile
      }
    }
    ... on Error {
      message
    }
  }
}
    ${UserProfileFragmentDoc}`;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, baseOptions);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const MarkTourCompletedDocument = gql`
    mutation markTourCompleted($input: MarkTourCompletedInput!) {
  markTourCompleted(input: $input) {
    ... on ChecklistTask {
      ...ChecklistTaskFields
    }
  }
}
    ${ChecklistTaskFieldsFragmentDoc}`;
export type MarkTourCompletedMutationFn = Apollo.MutationFunction<MarkTourCompletedMutation, MarkTourCompletedMutationVariables>;

/**
 * __useMarkTourCompletedMutation__
 *
 * To run a mutation, you first call `useMarkTourCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkTourCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markTourCompletedMutation, { data, loading, error }] = useMarkTourCompletedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkTourCompletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkTourCompletedMutation, MarkTourCompletedMutationVariables>) {
        return Apollo.useMutation<MarkTourCompletedMutation, MarkTourCompletedMutationVariables>(MarkTourCompletedDocument, baseOptions);
      }
export type MarkTourCompletedMutationHookResult = ReturnType<typeof useMarkTourCompletedMutation>;
export type MarkTourCompletedMutationResult = Apollo.MutationResult<MarkTourCompletedMutation>;
export type MarkTourCompletedMutationOptions = Apollo.BaseMutationOptions<MarkTourCompletedMutation, MarkTourCompletedMutationVariables>;
export const ExistingWaterRoomChecklistDocument = gql`
    query existingWaterRoomChecklist($checklistSessionId: ID!) {
  checklistSession(id: $checklistSessionId) {
    id
    waterRoomChecklists {
      ...WaterRoomChecklistFullFields
    }
  }
}
    ${WaterRoomChecklistFullFieldsFragmentDoc}`;

/**
 * __useExistingWaterRoomChecklistQuery__
 *
 * To run a query within a React component, call `useExistingWaterRoomChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistingWaterRoomChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistingWaterRoomChecklistQuery({
 *   variables: {
 *      checklistSessionId: // value for 'checklistSessionId'
 *   },
 * });
 */
export function useExistingWaterRoomChecklistQuery(baseOptions?: Apollo.QueryHookOptions<ExistingWaterRoomChecklistQuery, ExistingWaterRoomChecklistQueryVariables>) {
        return Apollo.useQuery<ExistingWaterRoomChecklistQuery, ExistingWaterRoomChecklistQueryVariables>(ExistingWaterRoomChecklistDocument, baseOptions);
      }
export function useExistingWaterRoomChecklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExistingWaterRoomChecklistQuery, ExistingWaterRoomChecklistQueryVariables>) {
          return Apollo.useLazyQuery<ExistingWaterRoomChecklistQuery, ExistingWaterRoomChecklistQueryVariables>(ExistingWaterRoomChecklistDocument, baseOptions);
        }
export type ExistingWaterRoomChecklistQueryHookResult = ReturnType<typeof useExistingWaterRoomChecklistQuery>;
export type ExistingWaterRoomChecklistLazyQueryHookResult = ReturnType<typeof useExistingWaterRoomChecklistLazyQuery>;
export type ExistingWaterRoomChecklistQueryResult = Apollo.QueryResult<ExistingWaterRoomChecklistQuery, ExistingWaterRoomChecklistQueryVariables>;
export const ExistingWaterQualityChecklistDocument = gql`
    query existingWaterQualityChecklist($checklistSessionId: ID!) {
  checklistSession(id: $checklistSessionId) {
    id
    waterQualityChecklists {
      ...WaterQualityChecklistFullFields
    }
  }
}
    ${WaterQualityChecklistFullFieldsFragmentDoc}`;

/**
 * __useExistingWaterQualityChecklistQuery__
 *
 * To run a query within a React component, call `useExistingWaterQualityChecklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistingWaterQualityChecklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistingWaterQualityChecklistQuery({
 *   variables: {
 *      checklistSessionId: // value for 'checklistSessionId'
 *   },
 * });
 */
export function useExistingWaterQualityChecklistQuery(baseOptions?: Apollo.QueryHookOptions<ExistingWaterQualityChecklistQuery, ExistingWaterQualityChecklistQueryVariables>) {
        return Apollo.useQuery<ExistingWaterQualityChecklistQuery, ExistingWaterQualityChecklistQueryVariables>(ExistingWaterQualityChecklistDocument, baseOptions);
      }
export function useExistingWaterQualityChecklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExistingWaterQualityChecklistQuery, ExistingWaterQualityChecklistQueryVariables>) {
          return Apollo.useLazyQuery<ExistingWaterQualityChecklistQuery, ExistingWaterQualityChecklistQueryVariables>(ExistingWaterQualityChecklistDocument, baseOptions);
        }
export type ExistingWaterQualityChecklistQueryHookResult = ReturnType<typeof useExistingWaterQualityChecklistQuery>;
export type ExistingWaterQualityChecklistLazyQueryHookResult = ReturnType<typeof useExistingWaterQualityChecklistLazyQuery>;
export type ExistingWaterQualityChecklistQueryResult = Apollo.QueryResult<ExistingWaterQualityChecklistQuery, ExistingWaterQualityChecklistQueryVariables>;
export const ExistingTaskChecklistForSessionDocument = gql`
    query existingTaskChecklistForSession($checklistSessionId: ID!) {
  checklistSession(id: $checklistSessionId) {
    id
    preHarvestTaskChecklists {
      ...PreHarvestTaskChecklistFullFields
    }
    postHarvestTaskChecklists {
      ...PostHarvestTaskChecklistFullFields
    }
    dryRoomPreHarvestChecklists {
      ...DryRoomPreHarvestChecklistFullFields
    }
    dryRoomPostHarvestChecklists {
      ...DryRoomPostHarvestChecklistFullFields
    }
    roomLoadTaskChecklists {
      ...RoomLoadTaskChecklistFullFields
    }
    transplantTaskChecklists {
      ...TransplantTaskChecklistFullFields
    }
    cloningTaskChecklists {
      ...CloningTaskChecklistFullFields
    }
    pruningDefolTaskChecklists {
      ...PruningDefolTaskChecklistFullFields
    }
    dailyTasksChecklists {
      ...DailyTasksChecklistFullFields
    }
    dailyWetRoomTaskChecklists {
      ...DailyWetRoomTaskChecklistFullFields
    }
  }
}
    ${PreHarvestTaskChecklistFullFieldsFragmentDoc}
${PostHarvestTaskChecklistFullFieldsFragmentDoc}
${DryRoomPreHarvestChecklistFullFieldsFragmentDoc}
${DryRoomPostHarvestChecklistFullFieldsFragmentDoc}
${RoomLoadTaskChecklistFullFieldsFragmentDoc}
${TransplantTaskChecklistFullFieldsFragmentDoc}
${CloningTaskChecklistFullFieldsFragmentDoc}
${PruningDefolTaskChecklistFullFieldsFragmentDoc}
${DailyTasksChecklistFullFieldsFragmentDoc}
${DailyWetRoomTaskChecklistFullFieldsFragmentDoc}`;

/**
 * __useExistingTaskChecklistForSessionQuery__
 *
 * To run a query within a React component, call `useExistingTaskChecklistForSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistingTaskChecklistForSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistingTaskChecklistForSessionQuery({
 *   variables: {
 *      checklistSessionId: // value for 'checklistSessionId'
 *   },
 * });
 */
export function useExistingTaskChecklistForSessionQuery(baseOptions?: Apollo.QueryHookOptions<ExistingTaskChecklistForSessionQuery, ExistingTaskChecklistForSessionQueryVariables>) {
        return Apollo.useQuery<ExistingTaskChecklistForSessionQuery, ExistingTaskChecklistForSessionQueryVariables>(ExistingTaskChecklistForSessionDocument, baseOptions);
      }
export function useExistingTaskChecklistForSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExistingTaskChecklistForSessionQuery, ExistingTaskChecklistForSessionQueryVariables>) {
          return Apollo.useLazyQuery<ExistingTaskChecklistForSessionQuery, ExistingTaskChecklistForSessionQueryVariables>(ExistingTaskChecklistForSessionDocument, baseOptions);
        }
export type ExistingTaskChecklistForSessionQueryHookResult = ReturnType<typeof useExistingTaskChecklistForSessionQuery>;
export type ExistingTaskChecklistForSessionLazyQueryHookResult = ReturnType<typeof useExistingTaskChecklistForSessionLazyQuery>;
export type ExistingTaskChecklistForSessionQueryResult = Apollo.QueryResult<ExistingTaskChecklistForSessionQuery, ExistingTaskChecklistForSessionQueryVariables>;
export const CreatePreHarvestTaskChecklistDocument = gql`
    mutation createPreHarvestTaskChecklist($input: PreHarvestTaskChecklistInput!) {
  createPreHarvestTaskChecklist(input: $input) {
    ... on PreHarvestTaskChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type CreatePreHarvestTaskChecklistMutationFn = Apollo.MutationFunction<CreatePreHarvestTaskChecklistMutation, CreatePreHarvestTaskChecklistMutationVariables>;

/**
 * __useCreatePreHarvestTaskChecklistMutation__
 *
 * To run a mutation, you first call `useCreatePreHarvestTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreHarvestTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreHarvestTaskChecklistMutation, { data, loading, error }] = useCreatePreHarvestTaskChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePreHarvestTaskChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreHarvestTaskChecklistMutation, CreatePreHarvestTaskChecklistMutationVariables>) {
        return Apollo.useMutation<CreatePreHarvestTaskChecklistMutation, CreatePreHarvestTaskChecklistMutationVariables>(CreatePreHarvestTaskChecklistDocument, baseOptions);
      }
export type CreatePreHarvestTaskChecklistMutationHookResult = ReturnType<typeof useCreatePreHarvestTaskChecklistMutation>;
export type CreatePreHarvestTaskChecklistMutationResult = Apollo.MutationResult<CreatePreHarvestTaskChecklistMutation>;
export type CreatePreHarvestTaskChecklistMutationOptions = Apollo.BaseMutationOptions<CreatePreHarvestTaskChecklistMutation, CreatePreHarvestTaskChecklistMutationVariables>;
export const UpdatePreHarvestTaskChecklistDocument = gql`
    mutation updatePreHarvestTaskChecklist($input: UpdatePreHarvestTaskChecklistInput!) {
  updatePreHarvestTaskChecklist(input: $input) {
    ... on PreHarvestTaskChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdatePreHarvestTaskChecklistMutationFn = Apollo.MutationFunction<UpdatePreHarvestTaskChecklistMutation, UpdatePreHarvestTaskChecklistMutationVariables>;

/**
 * __useUpdatePreHarvestTaskChecklistMutation__
 *
 * To run a mutation, you first call `useUpdatePreHarvestTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreHarvestTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreHarvestTaskChecklistMutation, { data, loading, error }] = useUpdatePreHarvestTaskChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePreHarvestTaskChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePreHarvestTaskChecklistMutation, UpdatePreHarvestTaskChecklistMutationVariables>) {
        return Apollo.useMutation<UpdatePreHarvestTaskChecklistMutation, UpdatePreHarvestTaskChecklistMutationVariables>(UpdatePreHarvestTaskChecklistDocument, baseOptions);
      }
export type UpdatePreHarvestTaskChecklistMutationHookResult = ReturnType<typeof useUpdatePreHarvestTaskChecklistMutation>;
export type UpdatePreHarvestTaskChecklistMutationResult = Apollo.MutationResult<UpdatePreHarvestTaskChecklistMutation>;
export type UpdatePreHarvestTaskChecklistMutationOptions = Apollo.BaseMutationOptions<UpdatePreHarvestTaskChecklistMutation, UpdatePreHarvestTaskChecklistMutationVariables>;
export const CreatePostHarvestTaskChecklistDocument = gql`
    mutation createPostHarvestTaskChecklist($input: PostHarvestTaskChecklistInput!) {
  createPostHarvestTaskChecklist(input: $input) {
    ... on PostHarvestTaskChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type CreatePostHarvestTaskChecklistMutationFn = Apollo.MutationFunction<CreatePostHarvestTaskChecklistMutation, CreatePostHarvestTaskChecklistMutationVariables>;

/**
 * __useCreatePostHarvestTaskChecklistMutation__
 *
 * To run a mutation, you first call `useCreatePostHarvestTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostHarvestTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostHarvestTaskChecklistMutation, { data, loading, error }] = useCreatePostHarvestTaskChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePostHarvestTaskChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostHarvestTaskChecklistMutation, CreatePostHarvestTaskChecklistMutationVariables>) {
        return Apollo.useMutation<CreatePostHarvestTaskChecklistMutation, CreatePostHarvestTaskChecklistMutationVariables>(CreatePostHarvestTaskChecklistDocument, baseOptions);
      }
export type CreatePostHarvestTaskChecklistMutationHookResult = ReturnType<typeof useCreatePostHarvestTaskChecklistMutation>;
export type CreatePostHarvestTaskChecklistMutationResult = Apollo.MutationResult<CreatePostHarvestTaskChecklistMutation>;
export type CreatePostHarvestTaskChecklistMutationOptions = Apollo.BaseMutationOptions<CreatePostHarvestTaskChecklistMutation, CreatePostHarvestTaskChecklistMutationVariables>;
export const UpdatePostHarvestTaskChecklistDocument = gql`
    mutation updatePostHarvestTaskChecklist($input: UpdatePostHarvestTaskChecklistInput!) {
  updatePostHarvestTaskChecklist(input: $input) {
    ... on PostHarvestTaskChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdatePostHarvestTaskChecklistMutationFn = Apollo.MutationFunction<UpdatePostHarvestTaskChecklistMutation, UpdatePostHarvestTaskChecklistMutationVariables>;

/**
 * __useUpdatePostHarvestTaskChecklistMutation__
 *
 * To run a mutation, you first call `useUpdatePostHarvestTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostHarvestTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostHarvestTaskChecklistMutation, { data, loading, error }] = useUpdatePostHarvestTaskChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePostHarvestTaskChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostHarvestTaskChecklistMutation, UpdatePostHarvestTaskChecklistMutationVariables>) {
        return Apollo.useMutation<UpdatePostHarvestTaskChecklistMutation, UpdatePostHarvestTaskChecklistMutationVariables>(UpdatePostHarvestTaskChecklistDocument, baseOptions);
      }
export type UpdatePostHarvestTaskChecklistMutationHookResult = ReturnType<typeof useUpdatePostHarvestTaskChecklistMutation>;
export type UpdatePostHarvestTaskChecklistMutationResult = Apollo.MutationResult<UpdatePostHarvestTaskChecklistMutation>;
export type UpdatePostHarvestTaskChecklistMutationOptions = Apollo.BaseMutationOptions<UpdatePostHarvestTaskChecklistMutation, UpdatePostHarvestTaskChecklistMutationVariables>;
export const CreateDryRoomPreHarvestChecklistDocument = gql`
    mutation createDryRoomPreHarvestChecklist($input: DryRoomPreHarvestChecklistInput!) {
  createDryRoomPreHarvestChecklist(input: $input) {
    ... on DryRoomPreHarvestChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type CreateDryRoomPreHarvestChecklistMutationFn = Apollo.MutationFunction<CreateDryRoomPreHarvestChecklistMutation, CreateDryRoomPreHarvestChecklistMutationVariables>;

/**
 * __useCreateDryRoomPreHarvestChecklistMutation__
 *
 * To run a mutation, you first call `useCreateDryRoomPreHarvestChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDryRoomPreHarvestChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDryRoomPreHarvestChecklistMutation, { data, loading, error }] = useCreateDryRoomPreHarvestChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDryRoomPreHarvestChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreateDryRoomPreHarvestChecklistMutation, CreateDryRoomPreHarvestChecklistMutationVariables>) {
        return Apollo.useMutation<CreateDryRoomPreHarvestChecklistMutation, CreateDryRoomPreHarvestChecklistMutationVariables>(CreateDryRoomPreHarvestChecklistDocument, baseOptions);
      }
export type CreateDryRoomPreHarvestChecklistMutationHookResult = ReturnType<typeof useCreateDryRoomPreHarvestChecklistMutation>;
export type CreateDryRoomPreHarvestChecklistMutationResult = Apollo.MutationResult<CreateDryRoomPreHarvestChecklistMutation>;
export type CreateDryRoomPreHarvestChecklistMutationOptions = Apollo.BaseMutationOptions<CreateDryRoomPreHarvestChecklistMutation, CreateDryRoomPreHarvestChecklistMutationVariables>;
export const UpdateDryRoomPreHarvestChecklistDocument = gql`
    mutation updateDryRoomPreHarvestChecklist($input: UpdateDryRoomPreHarvestChecklistInput!) {
  updateDryRoomPreHarvestChecklist(input: $input) {
    ... on DryRoomPreHarvestChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdateDryRoomPreHarvestChecklistMutationFn = Apollo.MutationFunction<UpdateDryRoomPreHarvestChecklistMutation, UpdateDryRoomPreHarvestChecklistMutationVariables>;

/**
 * __useUpdateDryRoomPreHarvestChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateDryRoomPreHarvestChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDryRoomPreHarvestChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDryRoomPreHarvestChecklistMutation, { data, loading, error }] = useUpdateDryRoomPreHarvestChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDryRoomPreHarvestChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDryRoomPreHarvestChecklistMutation, UpdateDryRoomPreHarvestChecklistMutationVariables>) {
        return Apollo.useMutation<UpdateDryRoomPreHarvestChecklistMutation, UpdateDryRoomPreHarvestChecklistMutationVariables>(UpdateDryRoomPreHarvestChecklistDocument, baseOptions);
      }
export type UpdateDryRoomPreHarvestChecklistMutationHookResult = ReturnType<typeof useUpdateDryRoomPreHarvestChecklistMutation>;
export type UpdateDryRoomPreHarvestChecklistMutationResult = Apollo.MutationResult<UpdateDryRoomPreHarvestChecklistMutation>;
export type UpdateDryRoomPreHarvestChecklistMutationOptions = Apollo.BaseMutationOptions<UpdateDryRoomPreHarvestChecklistMutation, UpdateDryRoomPreHarvestChecklistMutationVariables>;
export const CreateDryRoomPostHarvestChecklistDocument = gql`
    mutation createDryRoomPostHarvestChecklist($input: DryRoomPostHarvestChecklistInput!) {
  createDryRoomPostHarvestChecklist(input: $input) {
    ... on DryRoomPostHarvestChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type CreateDryRoomPostHarvestChecklistMutationFn = Apollo.MutationFunction<CreateDryRoomPostHarvestChecklistMutation, CreateDryRoomPostHarvestChecklistMutationVariables>;

/**
 * __useCreateDryRoomPostHarvestChecklistMutation__
 *
 * To run a mutation, you first call `useCreateDryRoomPostHarvestChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDryRoomPostHarvestChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDryRoomPostHarvestChecklistMutation, { data, loading, error }] = useCreateDryRoomPostHarvestChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDryRoomPostHarvestChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreateDryRoomPostHarvestChecklistMutation, CreateDryRoomPostHarvestChecklistMutationVariables>) {
        return Apollo.useMutation<CreateDryRoomPostHarvestChecklistMutation, CreateDryRoomPostHarvestChecklistMutationVariables>(CreateDryRoomPostHarvestChecklistDocument, baseOptions);
      }
export type CreateDryRoomPostHarvestChecklistMutationHookResult = ReturnType<typeof useCreateDryRoomPostHarvestChecklistMutation>;
export type CreateDryRoomPostHarvestChecklistMutationResult = Apollo.MutationResult<CreateDryRoomPostHarvestChecklistMutation>;
export type CreateDryRoomPostHarvestChecklistMutationOptions = Apollo.BaseMutationOptions<CreateDryRoomPostHarvestChecklistMutation, CreateDryRoomPostHarvestChecklistMutationVariables>;
export const UpdateDryRoomPostHarvestChecklistDocument = gql`
    mutation updateDryRoomPostHarvestChecklist($input: UpdateDryRoomPostHarvestChecklistInput!) {
  updateDryRoomPostHarvestChecklist(input: $input) {
    ... on DryRoomPostHarvestChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdateDryRoomPostHarvestChecklistMutationFn = Apollo.MutationFunction<UpdateDryRoomPostHarvestChecklistMutation, UpdateDryRoomPostHarvestChecklistMutationVariables>;

/**
 * __useUpdateDryRoomPostHarvestChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateDryRoomPostHarvestChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDryRoomPostHarvestChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDryRoomPostHarvestChecklistMutation, { data, loading, error }] = useUpdateDryRoomPostHarvestChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDryRoomPostHarvestChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDryRoomPostHarvestChecklistMutation, UpdateDryRoomPostHarvestChecklistMutationVariables>) {
        return Apollo.useMutation<UpdateDryRoomPostHarvestChecklistMutation, UpdateDryRoomPostHarvestChecklistMutationVariables>(UpdateDryRoomPostHarvestChecklistDocument, baseOptions);
      }
export type UpdateDryRoomPostHarvestChecklistMutationHookResult = ReturnType<typeof useUpdateDryRoomPostHarvestChecklistMutation>;
export type UpdateDryRoomPostHarvestChecklistMutationResult = Apollo.MutationResult<UpdateDryRoomPostHarvestChecklistMutation>;
export type UpdateDryRoomPostHarvestChecklistMutationOptions = Apollo.BaseMutationOptions<UpdateDryRoomPostHarvestChecklistMutation, UpdateDryRoomPostHarvestChecklistMutationVariables>;
export const CreateRoomLoadTaskChecklistDocument = gql`
    mutation createRoomLoadTaskChecklist($input: RoomLoadTaskChecklistInput!) {
  createRoomLoadTaskChecklist(input: $input) {
    ... on RoomLoadTaskChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type CreateRoomLoadTaskChecklistMutationFn = Apollo.MutationFunction<CreateRoomLoadTaskChecklistMutation, CreateRoomLoadTaskChecklistMutationVariables>;

/**
 * __useCreateRoomLoadTaskChecklistMutation__
 *
 * To run a mutation, you first call `useCreateRoomLoadTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoomLoadTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoomLoadTaskChecklistMutation, { data, loading, error }] = useCreateRoomLoadTaskChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoomLoadTaskChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoomLoadTaskChecklistMutation, CreateRoomLoadTaskChecklistMutationVariables>) {
        return Apollo.useMutation<CreateRoomLoadTaskChecklistMutation, CreateRoomLoadTaskChecklistMutationVariables>(CreateRoomLoadTaskChecklistDocument, baseOptions);
      }
export type CreateRoomLoadTaskChecklistMutationHookResult = ReturnType<typeof useCreateRoomLoadTaskChecklistMutation>;
export type CreateRoomLoadTaskChecklistMutationResult = Apollo.MutationResult<CreateRoomLoadTaskChecklistMutation>;
export type CreateRoomLoadTaskChecklistMutationOptions = Apollo.BaseMutationOptions<CreateRoomLoadTaskChecklistMutation, CreateRoomLoadTaskChecklistMutationVariables>;
export const UpdateRoomLoadTaskChecklistDocument = gql`
    mutation updateRoomLoadTaskChecklist($input: UpdateRoomLoadTaskChecklistInput!) {
  updateRoomLoadTaskChecklist(input: $input) {
    ... on RoomLoadTaskChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdateRoomLoadTaskChecklistMutationFn = Apollo.MutationFunction<UpdateRoomLoadTaskChecklistMutation, UpdateRoomLoadTaskChecklistMutationVariables>;

/**
 * __useUpdateRoomLoadTaskChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateRoomLoadTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomLoadTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomLoadTaskChecklistMutation, { data, loading, error }] = useUpdateRoomLoadTaskChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoomLoadTaskChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomLoadTaskChecklistMutation, UpdateRoomLoadTaskChecklistMutationVariables>) {
        return Apollo.useMutation<UpdateRoomLoadTaskChecklistMutation, UpdateRoomLoadTaskChecklistMutationVariables>(UpdateRoomLoadTaskChecklistDocument, baseOptions);
      }
export type UpdateRoomLoadTaskChecklistMutationHookResult = ReturnType<typeof useUpdateRoomLoadTaskChecklistMutation>;
export type UpdateRoomLoadTaskChecklistMutationResult = Apollo.MutationResult<UpdateRoomLoadTaskChecklistMutation>;
export type UpdateRoomLoadTaskChecklistMutationOptions = Apollo.BaseMutationOptions<UpdateRoomLoadTaskChecklistMutation, UpdateRoomLoadTaskChecklistMutationVariables>;
export const CreateTransplantTaskChecklistDocument = gql`
    mutation createTransplantTaskChecklist($input: TransplantTaskChecklistInput!) {
  createTransplantTaskChecklist(input: $input) {
    ... on TransplantTaskChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type CreateTransplantTaskChecklistMutationFn = Apollo.MutationFunction<CreateTransplantTaskChecklistMutation, CreateTransplantTaskChecklistMutationVariables>;

/**
 * __useCreateTransplantTaskChecklistMutation__
 *
 * To run a mutation, you first call `useCreateTransplantTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransplantTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransplantTaskChecklistMutation, { data, loading, error }] = useCreateTransplantTaskChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransplantTaskChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransplantTaskChecklistMutation, CreateTransplantTaskChecklistMutationVariables>) {
        return Apollo.useMutation<CreateTransplantTaskChecklistMutation, CreateTransplantTaskChecklistMutationVariables>(CreateTransplantTaskChecklistDocument, baseOptions);
      }
export type CreateTransplantTaskChecklistMutationHookResult = ReturnType<typeof useCreateTransplantTaskChecklistMutation>;
export type CreateTransplantTaskChecklistMutationResult = Apollo.MutationResult<CreateTransplantTaskChecklistMutation>;
export type CreateTransplantTaskChecklistMutationOptions = Apollo.BaseMutationOptions<CreateTransplantTaskChecklistMutation, CreateTransplantTaskChecklistMutationVariables>;
export const UpdateTransplantTaskChecklistDocument = gql`
    mutation updateTransplantTaskChecklist($input: UpdateTransplantTaskChecklistInput!) {
  updateTransplantTaskChecklist(input: $input) {
    ... on TransplantTaskChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdateTransplantTaskChecklistMutationFn = Apollo.MutationFunction<UpdateTransplantTaskChecklistMutation, UpdateTransplantTaskChecklistMutationVariables>;

/**
 * __useUpdateTransplantTaskChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateTransplantTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransplantTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransplantTaskChecklistMutation, { data, loading, error }] = useUpdateTransplantTaskChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTransplantTaskChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransplantTaskChecklistMutation, UpdateTransplantTaskChecklistMutationVariables>) {
        return Apollo.useMutation<UpdateTransplantTaskChecklistMutation, UpdateTransplantTaskChecklistMutationVariables>(UpdateTransplantTaskChecklistDocument, baseOptions);
      }
export type UpdateTransplantTaskChecklistMutationHookResult = ReturnType<typeof useUpdateTransplantTaskChecklistMutation>;
export type UpdateTransplantTaskChecklistMutationResult = Apollo.MutationResult<UpdateTransplantTaskChecklistMutation>;
export type UpdateTransplantTaskChecklistMutationOptions = Apollo.BaseMutationOptions<UpdateTransplantTaskChecklistMutation, UpdateTransplantTaskChecklistMutationVariables>;
export const CreateCloningTaskChecklistDocument = gql`
    mutation createCloningTaskChecklist($input: CloningTaskChecklistInput!) {
  createCloningTaskChecklist(input: $input) {
    ... on CloningTaskChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type CreateCloningTaskChecklistMutationFn = Apollo.MutationFunction<CreateCloningTaskChecklistMutation, CreateCloningTaskChecklistMutationVariables>;

/**
 * __useCreateCloningTaskChecklistMutation__
 *
 * To run a mutation, you first call `useCreateCloningTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCloningTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCloningTaskChecklistMutation, { data, loading, error }] = useCreateCloningTaskChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCloningTaskChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreateCloningTaskChecklistMutation, CreateCloningTaskChecklistMutationVariables>) {
        return Apollo.useMutation<CreateCloningTaskChecklistMutation, CreateCloningTaskChecklistMutationVariables>(CreateCloningTaskChecklistDocument, baseOptions);
      }
export type CreateCloningTaskChecklistMutationHookResult = ReturnType<typeof useCreateCloningTaskChecklistMutation>;
export type CreateCloningTaskChecklistMutationResult = Apollo.MutationResult<CreateCloningTaskChecklistMutation>;
export type CreateCloningTaskChecklistMutationOptions = Apollo.BaseMutationOptions<CreateCloningTaskChecklistMutation, CreateCloningTaskChecklistMutationVariables>;
export const UpdateCloningTaskChecklistDocument = gql`
    mutation updateCloningTaskChecklist($input: UpdateCloningTaskChecklistInput!) {
  updateCloningTaskChecklist(input: $input) {
    ... on CloningTaskChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdateCloningTaskChecklistMutationFn = Apollo.MutationFunction<UpdateCloningTaskChecklistMutation, UpdateCloningTaskChecklistMutationVariables>;

/**
 * __useUpdateCloningTaskChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateCloningTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCloningTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCloningTaskChecklistMutation, { data, loading, error }] = useUpdateCloningTaskChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCloningTaskChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCloningTaskChecklistMutation, UpdateCloningTaskChecklistMutationVariables>) {
        return Apollo.useMutation<UpdateCloningTaskChecklistMutation, UpdateCloningTaskChecklistMutationVariables>(UpdateCloningTaskChecklistDocument, baseOptions);
      }
export type UpdateCloningTaskChecklistMutationHookResult = ReturnType<typeof useUpdateCloningTaskChecklistMutation>;
export type UpdateCloningTaskChecklistMutationResult = Apollo.MutationResult<UpdateCloningTaskChecklistMutation>;
export type UpdateCloningTaskChecklistMutationOptions = Apollo.BaseMutationOptions<UpdateCloningTaskChecklistMutation, UpdateCloningTaskChecklistMutationVariables>;
export const CreatePruningDefolTaskChecklistDocument = gql`
    mutation createPruningDefolTaskChecklist($input: PruningDefolTaskChecklistInput!) {
  createPruningDefolTaskChecklist(input: $input) {
    ... on PruningDefolTaskChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type CreatePruningDefolTaskChecklistMutationFn = Apollo.MutationFunction<CreatePruningDefolTaskChecklistMutation, CreatePruningDefolTaskChecklistMutationVariables>;

/**
 * __useCreatePruningDefolTaskChecklistMutation__
 *
 * To run a mutation, you first call `useCreatePruningDefolTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePruningDefolTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPruningDefolTaskChecklistMutation, { data, loading, error }] = useCreatePruningDefolTaskChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePruningDefolTaskChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreatePruningDefolTaskChecklistMutation, CreatePruningDefolTaskChecklistMutationVariables>) {
        return Apollo.useMutation<CreatePruningDefolTaskChecklistMutation, CreatePruningDefolTaskChecklistMutationVariables>(CreatePruningDefolTaskChecklistDocument, baseOptions);
      }
export type CreatePruningDefolTaskChecklistMutationHookResult = ReturnType<typeof useCreatePruningDefolTaskChecklistMutation>;
export type CreatePruningDefolTaskChecklistMutationResult = Apollo.MutationResult<CreatePruningDefolTaskChecklistMutation>;
export type CreatePruningDefolTaskChecklistMutationOptions = Apollo.BaseMutationOptions<CreatePruningDefolTaskChecklistMutation, CreatePruningDefolTaskChecklistMutationVariables>;
export const UpdatePruningDefolTaskChecklistDocument = gql`
    mutation updatePruningDefolTaskChecklist($input: UpdatePruningDefolTaskChecklistInput!) {
  updatePruningDefolTaskChecklist(input: $input) {
    ... on PruningDefolTaskChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdatePruningDefolTaskChecklistMutationFn = Apollo.MutationFunction<UpdatePruningDefolTaskChecklistMutation, UpdatePruningDefolTaskChecklistMutationVariables>;

/**
 * __useUpdatePruningDefolTaskChecklistMutation__
 *
 * To run a mutation, you first call `useUpdatePruningDefolTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePruningDefolTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePruningDefolTaskChecklistMutation, { data, loading, error }] = useUpdatePruningDefolTaskChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePruningDefolTaskChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePruningDefolTaskChecklistMutation, UpdatePruningDefolTaskChecklistMutationVariables>) {
        return Apollo.useMutation<UpdatePruningDefolTaskChecklistMutation, UpdatePruningDefolTaskChecklistMutationVariables>(UpdatePruningDefolTaskChecklistDocument, baseOptions);
      }
export type UpdatePruningDefolTaskChecklistMutationHookResult = ReturnType<typeof useUpdatePruningDefolTaskChecklistMutation>;
export type UpdatePruningDefolTaskChecklistMutationResult = Apollo.MutationResult<UpdatePruningDefolTaskChecklistMutation>;
export type UpdatePruningDefolTaskChecklistMutationOptions = Apollo.BaseMutationOptions<UpdatePruningDefolTaskChecklistMutation, UpdatePruningDefolTaskChecklistMutationVariables>;
export const CreateDailyTasksChecklistDocument = gql`
    mutation createDailyTasksChecklist($input: DailyTasksChecklistInput!) {
  createDailyTasksChecklist(input: $input) {
    ... on DailyTasksChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type CreateDailyTasksChecklistMutationFn = Apollo.MutationFunction<CreateDailyTasksChecklistMutation, CreateDailyTasksChecklistMutationVariables>;

/**
 * __useCreateDailyTasksChecklistMutation__
 *
 * To run a mutation, you first call `useCreateDailyTasksChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDailyTasksChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDailyTasksChecklistMutation, { data, loading, error }] = useCreateDailyTasksChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDailyTasksChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreateDailyTasksChecklistMutation, CreateDailyTasksChecklistMutationVariables>) {
        return Apollo.useMutation<CreateDailyTasksChecklistMutation, CreateDailyTasksChecklistMutationVariables>(CreateDailyTasksChecklistDocument, baseOptions);
      }
export type CreateDailyTasksChecklistMutationHookResult = ReturnType<typeof useCreateDailyTasksChecklistMutation>;
export type CreateDailyTasksChecklistMutationResult = Apollo.MutationResult<CreateDailyTasksChecklistMutation>;
export type CreateDailyTasksChecklistMutationOptions = Apollo.BaseMutationOptions<CreateDailyTasksChecklistMutation, CreateDailyTasksChecklistMutationVariables>;
export const UpdateDailyTasksChecklistDocument = gql`
    mutation updateDailyTasksChecklist($input: UpdateDailyTasksChecklistInput!) {
  updateDailyTasksChecklist(input: $input) {
    ... on DailyTasksChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdateDailyTasksChecklistMutationFn = Apollo.MutationFunction<UpdateDailyTasksChecklistMutation, UpdateDailyTasksChecklistMutationVariables>;

/**
 * __useUpdateDailyTasksChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateDailyTasksChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyTasksChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyTasksChecklistMutation, { data, loading, error }] = useUpdateDailyTasksChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDailyTasksChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyTasksChecklistMutation, UpdateDailyTasksChecklistMutationVariables>) {
        return Apollo.useMutation<UpdateDailyTasksChecklistMutation, UpdateDailyTasksChecklistMutationVariables>(UpdateDailyTasksChecklistDocument, baseOptions);
      }
export type UpdateDailyTasksChecklistMutationHookResult = ReturnType<typeof useUpdateDailyTasksChecklistMutation>;
export type UpdateDailyTasksChecklistMutationResult = Apollo.MutationResult<UpdateDailyTasksChecklistMutation>;
export type UpdateDailyTasksChecklistMutationOptions = Apollo.BaseMutationOptions<UpdateDailyTasksChecklistMutation, UpdateDailyTasksChecklistMutationVariables>;
export const CreateDailyWetRoomTaskChecklistDocument = gql`
    mutation createDailyWetRoomTaskChecklist($input: DailyWetRoomTaskChecklistInput!) {
  createDailyWetRoomTaskChecklist(input: $input) {
    ... on DailyWetRoomTaskChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type CreateDailyWetRoomTaskChecklistMutationFn = Apollo.MutationFunction<CreateDailyWetRoomTaskChecklistMutation, CreateDailyWetRoomTaskChecklistMutationVariables>;

/**
 * __useCreateDailyWetRoomTaskChecklistMutation__
 *
 * To run a mutation, you first call `useCreateDailyWetRoomTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDailyWetRoomTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDailyWetRoomTaskChecklistMutation, { data, loading, error }] = useCreateDailyWetRoomTaskChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDailyWetRoomTaskChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreateDailyWetRoomTaskChecklistMutation, CreateDailyWetRoomTaskChecklistMutationVariables>) {
        return Apollo.useMutation<CreateDailyWetRoomTaskChecklistMutation, CreateDailyWetRoomTaskChecklistMutationVariables>(CreateDailyWetRoomTaskChecklistDocument, baseOptions);
      }
export type CreateDailyWetRoomTaskChecklistMutationHookResult = ReturnType<typeof useCreateDailyWetRoomTaskChecklistMutation>;
export type CreateDailyWetRoomTaskChecklistMutationResult = Apollo.MutationResult<CreateDailyWetRoomTaskChecklistMutation>;
export type CreateDailyWetRoomTaskChecklistMutationOptions = Apollo.BaseMutationOptions<CreateDailyWetRoomTaskChecklistMutation, CreateDailyWetRoomTaskChecklistMutationVariables>;
export const UpdateDailyWetRoomTaskChecklistDocument = gql`
    mutation updateDailyWetRoomTaskChecklist($input: UpdateDailyWetRoomTaskChecklistInput!) {
  updateDailyWetRoomTaskChecklist(input: $input) {
    ... on DailyWetRoomTaskChecklist {
      id
      timeCompleted
      notes
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdateDailyWetRoomTaskChecklistMutationFn = Apollo.MutationFunction<UpdateDailyWetRoomTaskChecklistMutation, UpdateDailyWetRoomTaskChecklistMutationVariables>;

/**
 * __useUpdateDailyWetRoomTaskChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateDailyWetRoomTaskChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyWetRoomTaskChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyWetRoomTaskChecklistMutation, { data, loading, error }] = useUpdateDailyWetRoomTaskChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDailyWetRoomTaskChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyWetRoomTaskChecklistMutation, UpdateDailyWetRoomTaskChecklistMutationVariables>) {
        return Apollo.useMutation<UpdateDailyWetRoomTaskChecklistMutation, UpdateDailyWetRoomTaskChecklistMutationVariables>(UpdateDailyWetRoomTaskChecklistDocument, baseOptions);
      }
export type UpdateDailyWetRoomTaskChecklistMutationHookResult = ReturnType<typeof useUpdateDailyWetRoomTaskChecklistMutation>;
export type UpdateDailyWetRoomTaskChecklistMutationResult = Apollo.MutationResult<UpdateDailyWetRoomTaskChecklistMutation>;
export type UpdateDailyWetRoomTaskChecklistMutationOptions = Apollo.BaseMutationOptions<UpdateDailyWetRoomTaskChecklistMutation, UpdateDailyWetRoomTaskChecklistMutationVariables>;
export const CreateChecklistEntryDocument = gql`
    mutation createChecklistEntry($input: CreateChecklistEntryInput!) {
  createChecklistEntry(input: $input) {
    ... on ChecklistEntry {
      ...ChecklistEntryFields
    }
    ... on Error {
      message
    }
  }
}
    ${ChecklistEntryFieldsFragmentDoc}`;
export type CreateChecklistEntryMutationFn = Apollo.MutationFunction<CreateChecklistEntryMutation, CreateChecklistEntryMutationVariables>;

/**
 * __useCreateChecklistEntryMutation__
 *
 * To run a mutation, you first call `useCreateChecklistEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChecklistEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChecklistEntryMutation, { data, loading, error }] = useCreateChecklistEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChecklistEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateChecklistEntryMutation, CreateChecklistEntryMutationVariables>) {
        return Apollo.useMutation<CreateChecklistEntryMutation, CreateChecklistEntryMutationVariables>(CreateChecklistEntryDocument, baseOptions);
      }
export type CreateChecklistEntryMutationHookResult = ReturnType<typeof useCreateChecklistEntryMutation>;
export type CreateChecklistEntryMutationResult = Apollo.MutationResult<CreateChecklistEntryMutation>;
export type CreateChecklistEntryMutationOptions = Apollo.BaseMutationOptions<CreateChecklistEntryMutation, CreateChecklistEntryMutationVariables>;
export const UpdateChecklistEntryDocument = gql`
    mutation updateChecklistEntry($input: UpdateChecklistEntryInput!) {
  updateChecklistEntry(input: $input) {
    ... on ChecklistEntry {
      ...ChecklistEntryFields
    }
    ... on Error {
      message
    }
  }
}
    ${ChecklistEntryFieldsFragmentDoc}`;
export type UpdateChecklistEntryMutationFn = Apollo.MutationFunction<UpdateChecklistEntryMutation, UpdateChecklistEntryMutationVariables>;

/**
 * __useUpdateChecklistEntryMutation__
 *
 * To run a mutation, you first call `useUpdateChecklistEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChecklistEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChecklistEntryMutation, { data, loading, error }] = useUpdateChecklistEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChecklistEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChecklistEntryMutation, UpdateChecklistEntryMutationVariables>) {
        return Apollo.useMutation<UpdateChecklistEntryMutation, UpdateChecklistEntryMutationVariables>(UpdateChecklistEntryDocument, baseOptions);
      }
export type UpdateChecklistEntryMutationHookResult = ReturnType<typeof useUpdateChecklistEntryMutation>;
export type UpdateChecklistEntryMutationResult = Apollo.MutationResult<UpdateChecklistEntryMutation>;
export type UpdateChecklistEntryMutationOptions = Apollo.BaseMutationOptions<UpdateChecklistEntryMutation, UpdateChecklistEntryMutationVariables>;
export const CreateWaterRoomChecklistDocument = gql`
    mutation createWaterRoomChecklist($input: WaterRoomChecklistInput!) {
  createWaterRoomChecklist(input: $input) {
    ... on WaterRoomChecklist {
      ...WaterRoomChecklistFields
    }
    ... on Error {
      message
    }
  }
}
    ${WaterRoomChecklistFieldsFragmentDoc}`;
export type CreateWaterRoomChecklistMutationFn = Apollo.MutationFunction<CreateWaterRoomChecklistMutation, CreateWaterRoomChecklistMutationVariables>;

/**
 * __useCreateWaterRoomChecklistMutation__
 *
 * To run a mutation, you first call `useCreateWaterRoomChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWaterRoomChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWaterRoomChecklistMutation, { data, loading, error }] = useCreateWaterRoomChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWaterRoomChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreateWaterRoomChecklistMutation, CreateWaterRoomChecklistMutationVariables>) {
        return Apollo.useMutation<CreateWaterRoomChecklistMutation, CreateWaterRoomChecklistMutationVariables>(CreateWaterRoomChecklistDocument, baseOptions);
      }
export type CreateWaterRoomChecklistMutationHookResult = ReturnType<typeof useCreateWaterRoomChecklistMutation>;
export type CreateWaterRoomChecklistMutationResult = Apollo.MutationResult<CreateWaterRoomChecklistMutation>;
export type CreateWaterRoomChecklistMutationOptions = Apollo.BaseMutationOptions<CreateWaterRoomChecklistMutation, CreateWaterRoomChecklistMutationVariables>;
export const UpdateWaterRoomChecklistDocument = gql`
    mutation updateWaterRoomChecklist($input: UpdateWaterRoomChecklistInput!) {
  updateWaterRoomChecklist(input: $input) {
    ... on WaterRoomChecklist {
      ...WaterRoomChecklistFields
    }
    ... on Error {
      message
    }
  }
}
    ${WaterRoomChecklistFieldsFragmentDoc}`;
export type UpdateWaterRoomChecklistMutationFn = Apollo.MutationFunction<UpdateWaterRoomChecklistMutation, UpdateWaterRoomChecklistMutationVariables>;

/**
 * __useUpdateWaterRoomChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateWaterRoomChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWaterRoomChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWaterRoomChecklistMutation, { data, loading, error }] = useUpdateWaterRoomChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWaterRoomChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWaterRoomChecklistMutation, UpdateWaterRoomChecklistMutationVariables>) {
        return Apollo.useMutation<UpdateWaterRoomChecklistMutation, UpdateWaterRoomChecklistMutationVariables>(UpdateWaterRoomChecklistDocument, baseOptions);
      }
export type UpdateWaterRoomChecklistMutationHookResult = ReturnType<typeof useUpdateWaterRoomChecklistMutation>;
export type UpdateWaterRoomChecklistMutationResult = Apollo.MutationResult<UpdateWaterRoomChecklistMutation>;
export type UpdateWaterRoomChecklistMutationOptions = Apollo.BaseMutationOptions<UpdateWaterRoomChecklistMutation, UpdateWaterRoomChecklistMutationVariables>;
export const CreateWaterQualityChecklistDocument = gql`
    mutation createWaterQualityChecklist($input: WaterQualityChecklistInput!) {
  createWaterQualityChecklist(input: $input) {
    ... on WaterQualityChecklist {
      ...WaterQualityChecklistFields
    }
    ... on Error {
      message
    }
  }
}
    ${WaterQualityChecklistFieldsFragmentDoc}`;
export type CreateWaterQualityChecklistMutationFn = Apollo.MutationFunction<CreateWaterQualityChecklistMutation, CreateWaterQualityChecklistMutationVariables>;

/**
 * __useCreateWaterQualityChecklistMutation__
 *
 * To run a mutation, you first call `useCreateWaterQualityChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWaterQualityChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWaterQualityChecklistMutation, { data, loading, error }] = useCreateWaterQualityChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWaterQualityChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreateWaterQualityChecklistMutation, CreateWaterQualityChecklistMutationVariables>) {
        return Apollo.useMutation<CreateWaterQualityChecklistMutation, CreateWaterQualityChecklistMutationVariables>(CreateWaterQualityChecklistDocument, baseOptions);
      }
export type CreateWaterQualityChecklistMutationHookResult = ReturnType<typeof useCreateWaterQualityChecklistMutation>;
export type CreateWaterQualityChecklistMutationResult = Apollo.MutationResult<CreateWaterQualityChecklistMutation>;
export type CreateWaterQualityChecklistMutationOptions = Apollo.BaseMutationOptions<CreateWaterQualityChecklistMutation, CreateWaterQualityChecklistMutationVariables>;
export const UpdateWaterQualityChecklistDocument = gql`
    mutation updateWaterQualityChecklist($input: UpdateWaterQualityChecklistInput!) {
  updateWaterQualityChecklist(input: $input) {
    ... on WaterQualityChecklist {
      ...WaterQualityChecklistFields
    }
    ... on Error {
      message
    }
  }
}
    ${WaterQualityChecklistFieldsFragmentDoc}`;
export type UpdateWaterQualityChecklistMutationFn = Apollo.MutationFunction<UpdateWaterQualityChecklistMutation, UpdateWaterQualityChecklistMutationVariables>;

/**
 * __useUpdateWaterQualityChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateWaterQualityChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWaterQualityChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWaterQualityChecklistMutation, { data, loading, error }] = useUpdateWaterQualityChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWaterQualityChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWaterQualityChecklistMutation, UpdateWaterQualityChecklistMutationVariables>) {
        return Apollo.useMutation<UpdateWaterQualityChecklistMutation, UpdateWaterQualityChecklistMutationVariables>(UpdateWaterQualityChecklistDocument, baseOptions);
      }
export type UpdateWaterQualityChecklistMutationHookResult = ReturnType<typeof useUpdateWaterQualityChecklistMutation>;
export type UpdateWaterQualityChecklistMutationResult = Apollo.MutationResult<UpdateWaterQualityChecklistMutation>;
export type UpdateWaterQualityChecklistMutationOptions = Apollo.BaseMutationOptions<UpdateWaterQualityChecklistMutation, UpdateWaterQualityChecklistMutationVariables>;
export const CreateRoomWalkthroughChecklistDocument = gql`
    mutation createRoomWalkthroughChecklist($input: CreateRoomWalkthroughChecklistInput!) {
  createRoomWalkthroughChecklist(input: $input) {
    ... on RoomWalkthroughChecklist {
      ...RoomWalkthroughChecklistFields
    }
    ... on Error {
      message
    }
  }
}
    ${RoomWalkthroughChecklistFieldsFragmentDoc}`;
export type CreateRoomWalkthroughChecklistMutationFn = Apollo.MutationFunction<CreateRoomWalkthroughChecklistMutation, CreateRoomWalkthroughChecklistMutationVariables>;

/**
 * __useCreateRoomWalkthroughChecklistMutation__
 *
 * To run a mutation, you first call `useCreateRoomWalkthroughChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoomWalkthroughChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoomWalkthroughChecklistMutation, { data, loading, error }] = useCreateRoomWalkthroughChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoomWalkthroughChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoomWalkthroughChecklistMutation, CreateRoomWalkthroughChecklistMutationVariables>) {
        return Apollo.useMutation<CreateRoomWalkthroughChecklistMutation, CreateRoomWalkthroughChecklistMutationVariables>(CreateRoomWalkthroughChecklistDocument, baseOptions);
      }
export type CreateRoomWalkthroughChecklistMutationHookResult = ReturnType<typeof useCreateRoomWalkthroughChecklistMutation>;
export type CreateRoomWalkthroughChecklistMutationResult = Apollo.MutationResult<CreateRoomWalkthroughChecklistMutation>;
export type CreateRoomWalkthroughChecklistMutationOptions = Apollo.BaseMutationOptions<CreateRoomWalkthroughChecklistMutation, CreateRoomWalkthroughChecklistMutationVariables>;
export const UpdateRoomWalkthroughChecklistDocument = gql`
    mutation updateRoomWalkthroughChecklist($input: UpdateRoomWalkthroughChecklistInput!) {
  updateRoomWalkthroughChecklist(input: $input) {
    ... on RoomWalkthroughChecklist {
      ...RoomWalkthroughChecklistFields
    }
    ... on Error {
      message
    }
  }
}
    ${RoomWalkthroughChecklistFieldsFragmentDoc}`;
export type UpdateRoomWalkthroughChecklistMutationFn = Apollo.MutationFunction<UpdateRoomWalkthroughChecklistMutation, UpdateRoomWalkthroughChecklistMutationVariables>;

/**
 * __useUpdateRoomWalkthroughChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateRoomWalkthroughChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomWalkthroughChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomWalkthroughChecklistMutation, { data, loading, error }] = useUpdateRoomWalkthroughChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoomWalkthroughChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomWalkthroughChecklistMutation, UpdateRoomWalkthroughChecklistMutationVariables>) {
        return Apollo.useMutation<UpdateRoomWalkthroughChecklistMutation, UpdateRoomWalkthroughChecklistMutationVariables>(UpdateRoomWalkthroughChecklistDocument, baseOptions);
      }
export type UpdateRoomWalkthroughChecklistMutationHookResult = ReturnType<typeof useUpdateRoomWalkthroughChecklistMutation>;
export type UpdateRoomWalkthroughChecklistMutationResult = Apollo.MutationResult<UpdateRoomWalkthroughChecklistMutation>;
export type UpdateRoomWalkthroughChecklistMutationOptions = Apollo.BaseMutationOptions<UpdateRoomWalkthroughChecklistMutation, UpdateRoomWalkthroughChecklistMutationVariables>;
export const CreateChecklistSessionDocument = gql`
    mutation createChecklistSession($input: CreateChecklistSessionInput!) {
  createChecklistSession(input: $input) {
    ... on ChecklistSession {
      ...ChecklistSessionFields
    }
    ... on Error {
      message
    }
  }
}
    ${ChecklistSessionFieldsFragmentDoc}`;
export type CreateChecklistSessionMutationFn = Apollo.MutationFunction<CreateChecklistSessionMutation, CreateChecklistSessionMutationVariables>;

/**
 * __useCreateChecklistSessionMutation__
 *
 * To run a mutation, you first call `useCreateChecklistSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChecklistSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChecklistSessionMutation, { data, loading, error }] = useCreateChecklistSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChecklistSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateChecklistSessionMutation, CreateChecklistSessionMutationVariables>) {
        return Apollo.useMutation<CreateChecklistSessionMutation, CreateChecklistSessionMutationVariables>(CreateChecklistSessionDocument, baseOptions);
      }
export type CreateChecklistSessionMutationHookResult = ReturnType<typeof useCreateChecklistSessionMutation>;
export type CreateChecklistSessionMutationResult = Apollo.MutationResult<CreateChecklistSessionMutation>;
export type CreateChecklistSessionMutationOptions = Apollo.BaseMutationOptions<CreateChecklistSessionMutation, CreateChecklistSessionMutationVariables>;
export const CreateTrolmasterDeviceDocument = gql`
    mutation createTrolmasterDevice($input: CreateTrolmasterDeviceInput!) {
  createTrolmasterDevice(input: $input) {
    ... on EnvironmentalDevice {
      ...EnvironmentalDeviceFields
    }
    ... on Error {
      message
    }
  }
}
    ${EnvironmentalDeviceFieldsFragmentDoc}`;
export type CreateTrolmasterDeviceMutationFn = Apollo.MutationFunction<CreateTrolmasterDeviceMutation, CreateTrolmasterDeviceMutationVariables>;

/**
 * __useCreateTrolmasterDeviceMutation__
 *
 * To run a mutation, you first call `useCreateTrolmasterDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrolmasterDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrolmasterDeviceMutation, { data, loading, error }] = useCreateTrolmasterDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTrolmasterDeviceMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrolmasterDeviceMutation, CreateTrolmasterDeviceMutationVariables>) {
        return Apollo.useMutation<CreateTrolmasterDeviceMutation, CreateTrolmasterDeviceMutationVariables>(CreateTrolmasterDeviceDocument, baseOptions);
      }
export type CreateTrolmasterDeviceMutationHookResult = ReturnType<typeof useCreateTrolmasterDeviceMutation>;
export type CreateTrolmasterDeviceMutationResult = Apollo.MutationResult<CreateTrolmasterDeviceMutation>;
export type CreateTrolmasterDeviceMutationOptions = Apollo.BaseMutationOptions<CreateTrolmasterDeviceMutation, CreateTrolmasterDeviceMutationVariables>;
export const CreateAroyaDeviceDocument = gql`
    mutation createAroyaDevice($input: CreateAroyaDeviceInput!) {
  createAroyaDevice(input: $input) {
    ... on EnvironmentalDevice {
      ...EnvironmentalDeviceFields
    }
    ... on Error {
      message
    }
  }
}
    ${EnvironmentalDeviceFieldsFragmentDoc}`;
export type CreateAroyaDeviceMutationFn = Apollo.MutationFunction<CreateAroyaDeviceMutation, CreateAroyaDeviceMutationVariables>;

/**
 * __useCreateAroyaDeviceMutation__
 *
 * To run a mutation, you first call `useCreateAroyaDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAroyaDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAroyaDeviceMutation, { data, loading, error }] = useCreateAroyaDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAroyaDeviceMutation(baseOptions?: Apollo.MutationHookOptions<CreateAroyaDeviceMutation, CreateAroyaDeviceMutationVariables>) {
        return Apollo.useMutation<CreateAroyaDeviceMutation, CreateAroyaDeviceMutationVariables>(CreateAroyaDeviceDocument, baseOptions);
      }
export type CreateAroyaDeviceMutationHookResult = ReturnType<typeof useCreateAroyaDeviceMutation>;
export type CreateAroyaDeviceMutationResult = Apollo.MutationResult<CreateAroyaDeviceMutation>;
export type CreateAroyaDeviceMutationOptions = Apollo.BaseMutationOptions<CreateAroyaDeviceMutation, CreateAroyaDeviceMutationVariables>;
export const CreateGrowlinkDeviceDocument = gql`
    mutation createGrowlinkDevice($input: CreateGrowlinkDeviceInput!) {
  createGrowlinkDevice(input: $input) {
    ... on EnvironmentalDevice {
      ...EnvironmentalDeviceFields
    }
    ... on Error {
      message
    }
  }
}
    ${EnvironmentalDeviceFieldsFragmentDoc}`;
export type CreateGrowlinkDeviceMutationFn = Apollo.MutationFunction<CreateGrowlinkDeviceMutation, CreateGrowlinkDeviceMutationVariables>;

/**
 * __useCreateGrowlinkDeviceMutation__
 *
 * To run a mutation, you first call `useCreateGrowlinkDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGrowlinkDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGrowlinkDeviceMutation, { data, loading, error }] = useCreateGrowlinkDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGrowlinkDeviceMutation(baseOptions?: Apollo.MutationHookOptions<CreateGrowlinkDeviceMutation, CreateGrowlinkDeviceMutationVariables>) {
        return Apollo.useMutation<CreateGrowlinkDeviceMutation, CreateGrowlinkDeviceMutationVariables>(CreateGrowlinkDeviceDocument, baseOptions);
      }
export type CreateGrowlinkDeviceMutationHookResult = ReturnType<typeof useCreateGrowlinkDeviceMutation>;
export type CreateGrowlinkDeviceMutationResult = Apollo.MutationResult<CreateGrowlinkDeviceMutation>;
export type CreateGrowlinkDeviceMutationOptions = Apollo.BaseMutationOptions<CreateGrowlinkDeviceMutation, CreateGrowlinkDeviceMutationVariables>;
export const UpdateGrowlinkDeviceDocument = gql`
    mutation updateGrowlinkDevice($input: UpdateGrowlinkDeviceInput!) {
  updateGrowlinkDevice(input: $input) {
    ... on EnvironmentalDevice {
      ...EnvironmentalDeviceFields
    }
    ... on Error {
      message
    }
  }
}
    ${EnvironmentalDeviceFieldsFragmentDoc}`;
export type UpdateGrowlinkDeviceMutationFn = Apollo.MutationFunction<UpdateGrowlinkDeviceMutation, UpdateGrowlinkDeviceMutationVariables>;

/**
 * __useUpdateGrowlinkDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateGrowlinkDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGrowlinkDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGrowlinkDeviceMutation, { data, loading, error }] = useUpdateGrowlinkDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGrowlinkDeviceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGrowlinkDeviceMutation, UpdateGrowlinkDeviceMutationVariables>) {
        return Apollo.useMutation<UpdateGrowlinkDeviceMutation, UpdateGrowlinkDeviceMutationVariables>(UpdateGrowlinkDeviceDocument, baseOptions);
      }
export type UpdateGrowlinkDeviceMutationHookResult = ReturnType<typeof useUpdateGrowlinkDeviceMutation>;
export type UpdateGrowlinkDeviceMutationResult = Apollo.MutationResult<UpdateGrowlinkDeviceMutation>;
export type UpdateGrowlinkDeviceMutationOptions = Apollo.BaseMutationOptions<UpdateGrowlinkDeviceMutation, UpdateGrowlinkDeviceMutationVariables>;
export const UpdateTrolmasterDeviceDocument = gql`
    mutation updateTrolmasterDevice($input: UpdateTrolmasterDeviceInput!) {
  updateTrolmasterDevice(input: $input) {
    ... on EnvironmentalDevice {
      ...EnvironmentalDeviceFields
    }
    ... on Error {
      message
    }
  }
}
    ${EnvironmentalDeviceFieldsFragmentDoc}`;
export type UpdateTrolmasterDeviceMutationFn = Apollo.MutationFunction<UpdateTrolmasterDeviceMutation, UpdateTrolmasterDeviceMutationVariables>;

/**
 * __useUpdateTrolmasterDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateTrolmasterDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrolmasterDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrolmasterDeviceMutation, { data, loading, error }] = useUpdateTrolmasterDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrolmasterDeviceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrolmasterDeviceMutation, UpdateTrolmasterDeviceMutationVariables>) {
        return Apollo.useMutation<UpdateTrolmasterDeviceMutation, UpdateTrolmasterDeviceMutationVariables>(UpdateTrolmasterDeviceDocument, baseOptions);
      }
export type UpdateTrolmasterDeviceMutationHookResult = ReturnType<typeof useUpdateTrolmasterDeviceMutation>;
export type UpdateTrolmasterDeviceMutationResult = Apollo.MutationResult<UpdateTrolmasterDeviceMutation>;
export type UpdateTrolmasterDeviceMutationOptions = Apollo.BaseMutationOptions<UpdateTrolmasterDeviceMutation, UpdateTrolmasterDeviceMutationVariables>;
export const UpdateAroyaDeviceDocument = gql`
    mutation updateAroyaDevice($input: UpdateAroyaDeviceInput!) {
  updateAroyaDevice(input: $input) {
    ... on EnvironmentalDevice {
      ...EnvironmentalDeviceFields
    }
    ... on Error {
      message
    }
  }
}
    ${EnvironmentalDeviceFieldsFragmentDoc}`;
export type UpdateAroyaDeviceMutationFn = Apollo.MutationFunction<UpdateAroyaDeviceMutation, UpdateAroyaDeviceMutationVariables>;

/**
 * __useUpdateAroyaDeviceMutation__
 *
 * To run a mutation, you first call `useUpdateAroyaDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAroyaDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAroyaDeviceMutation, { data, loading, error }] = useUpdateAroyaDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAroyaDeviceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAroyaDeviceMutation, UpdateAroyaDeviceMutationVariables>) {
        return Apollo.useMutation<UpdateAroyaDeviceMutation, UpdateAroyaDeviceMutationVariables>(UpdateAroyaDeviceDocument, baseOptions);
      }
export type UpdateAroyaDeviceMutationHookResult = ReturnType<typeof useUpdateAroyaDeviceMutation>;
export type UpdateAroyaDeviceMutationResult = Apollo.MutationResult<UpdateAroyaDeviceMutation>;
export type UpdateAroyaDeviceMutationOptions = Apollo.BaseMutationOptions<UpdateAroyaDeviceMutation, UpdateAroyaDeviceMutationVariables>;
export const DeleteEnvironmentalDeviceDocument = gql`
    mutation deleteEnvironmentalDevice($input: DeleteEnvironmentalDeviceInput!) {
  deleteEnvironmentalDevice(input: $input) {
    ... on EnvironmentalDevice {
      id
    }
    ... on Error {
      message
    }
  }
}
    `;
export type DeleteEnvironmentalDeviceMutationFn = Apollo.MutationFunction<DeleteEnvironmentalDeviceMutation, DeleteEnvironmentalDeviceMutationVariables>;

/**
 * __useDeleteEnvironmentalDeviceMutation__
 *
 * To run a mutation, you first call `useDeleteEnvironmentalDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnvironmentalDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnvironmentalDeviceMutation, { data, loading, error }] = useDeleteEnvironmentalDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEnvironmentalDeviceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEnvironmentalDeviceMutation, DeleteEnvironmentalDeviceMutationVariables>) {
        return Apollo.useMutation<DeleteEnvironmentalDeviceMutation, DeleteEnvironmentalDeviceMutationVariables>(DeleteEnvironmentalDeviceDocument, baseOptions);
      }
export type DeleteEnvironmentalDeviceMutationHookResult = ReturnType<typeof useDeleteEnvironmentalDeviceMutation>;
export type DeleteEnvironmentalDeviceMutationResult = Apollo.MutationResult<DeleteEnvironmentalDeviceMutation>;
export type DeleteEnvironmentalDeviceMutationOptions = Apollo.BaseMutationOptions<DeleteEnvironmentalDeviceMutation, DeleteEnvironmentalDeviceMutationVariables>;
export const SetPrimaryDeviceDocument = gql`
    mutation setPrimaryDevice($input: SetPrimaryDeviceInput!) {
  setPrimaryDevice(input: $input) {
    ... on EnvironmentalDevice {
      ...EnvironmentalDeviceFields
    }
    ... on Error {
      message
    }
  }
}
    ${EnvironmentalDeviceFieldsFragmentDoc}`;
export type SetPrimaryDeviceMutationFn = Apollo.MutationFunction<SetPrimaryDeviceMutation, SetPrimaryDeviceMutationVariables>;

/**
 * __useSetPrimaryDeviceMutation__
 *
 * To run a mutation, you first call `useSetPrimaryDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimaryDeviceMutation, { data, loading, error }] = useSetPrimaryDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPrimaryDeviceMutation(baseOptions?: Apollo.MutationHookOptions<SetPrimaryDeviceMutation, SetPrimaryDeviceMutationVariables>) {
        return Apollo.useMutation<SetPrimaryDeviceMutation, SetPrimaryDeviceMutationVariables>(SetPrimaryDeviceDocument, baseOptions);
      }
export type SetPrimaryDeviceMutationHookResult = ReturnType<typeof useSetPrimaryDeviceMutation>;
export type SetPrimaryDeviceMutationResult = Apollo.MutationResult<SetPrimaryDeviceMutation>;
export type SetPrimaryDeviceMutationOptions = Apollo.BaseMutationOptions<SetPrimaryDeviceMutation, SetPrimaryDeviceMutationVariables>;
export const ImportAroyaDataDocument = gql`
    mutation importAroyaData($siteId: ID!) {
  importAroyaData(siteId: $siteId) {
    ... on OrganizationSite {
      id
      sensorImportTask {
        ...AroyaImportTaskFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${AroyaImportTaskFieldsFragmentDoc}`;
export type ImportAroyaDataMutationFn = Apollo.MutationFunction<ImportAroyaDataMutation, ImportAroyaDataMutationVariables>;

/**
 * __useImportAroyaDataMutation__
 *
 * To run a mutation, you first call `useImportAroyaDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportAroyaDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importAroyaDataMutation, { data, loading, error }] = useImportAroyaDataMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useImportAroyaDataMutation(baseOptions?: Apollo.MutationHookOptions<ImportAroyaDataMutation, ImportAroyaDataMutationVariables>) {
        return Apollo.useMutation<ImportAroyaDataMutation, ImportAroyaDataMutationVariables>(ImportAroyaDataDocument, baseOptions);
      }
export type ImportAroyaDataMutationHookResult = ReturnType<typeof useImportAroyaDataMutation>;
export type ImportAroyaDataMutationResult = Apollo.MutationResult<ImportAroyaDataMutation>;
export type ImportAroyaDataMutationOptions = Apollo.BaseMutationOptions<ImportAroyaDataMutation, ImportAroyaDataMutationVariables>;
export const ImportAroyaSubstrateDataDocument = gql`
    mutation importAroyaSubstrateData($siteId: ID!) {
  importAroyaSubstrateData(siteId: $siteId) {
    ... on OrganizationSite {
      id
      sensorImportTask {
        ...AroyaImportTaskFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${AroyaImportTaskFieldsFragmentDoc}`;
export type ImportAroyaSubstrateDataMutationFn = Apollo.MutationFunction<ImportAroyaSubstrateDataMutation, ImportAroyaSubstrateDataMutationVariables>;

/**
 * __useImportAroyaSubstrateDataMutation__
 *
 * To run a mutation, you first call `useImportAroyaSubstrateDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportAroyaSubstrateDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importAroyaSubstrateDataMutation, { data, loading, error }] = useImportAroyaSubstrateDataMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useImportAroyaSubstrateDataMutation(baseOptions?: Apollo.MutationHookOptions<ImportAroyaSubstrateDataMutation, ImportAroyaSubstrateDataMutationVariables>) {
        return Apollo.useMutation<ImportAroyaSubstrateDataMutation, ImportAroyaSubstrateDataMutationVariables>(ImportAroyaSubstrateDataDocument, baseOptions);
      }
export type ImportAroyaSubstrateDataMutationHookResult = ReturnType<typeof useImportAroyaSubstrateDataMutation>;
export type ImportAroyaSubstrateDataMutationResult = Apollo.MutationResult<ImportAroyaSubstrateDataMutation>;
export type ImportAroyaSubstrateDataMutationOptions = Apollo.BaseMutationOptions<ImportAroyaSubstrateDataMutation, ImportAroyaSubstrateDataMutationVariables>;
export const ImportTrolmasterDataDocument = gql`
    mutation importTrolmasterData($siteId: ID!) {
  importTrolmasterData(siteId: $siteId) {
    ... on OrganizationSite {
      id
      sensorImportTask {
        ...TrolmasterImportTaskFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${TrolmasterImportTaskFieldsFragmentDoc}`;
export type ImportTrolmasterDataMutationFn = Apollo.MutationFunction<ImportTrolmasterDataMutation, ImportTrolmasterDataMutationVariables>;

/**
 * __useImportTrolmasterDataMutation__
 *
 * To run a mutation, you first call `useImportTrolmasterDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTrolmasterDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTrolmasterDataMutation, { data, loading, error }] = useImportTrolmasterDataMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useImportTrolmasterDataMutation(baseOptions?: Apollo.MutationHookOptions<ImportTrolmasterDataMutation, ImportTrolmasterDataMutationVariables>) {
        return Apollo.useMutation<ImportTrolmasterDataMutation, ImportTrolmasterDataMutationVariables>(ImportTrolmasterDataDocument, baseOptions);
      }
export type ImportTrolmasterDataMutationHookResult = ReturnType<typeof useImportTrolmasterDataMutation>;
export type ImportTrolmasterDataMutationResult = Apollo.MutationResult<ImportTrolmasterDataMutation>;
export type ImportTrolmasterDataMutationOptions = Apollo.BaseMutationOptions<ImportTrolmasterDataMutation, ImportTrolmasterDataMutationVariables>;
export const ImportGrowlinkDataDocument = gql`
    mutation importGrowlinkData($siteId: ID!) {
  importGrowlinkData(siteId: $siteId) {
    ... on OrganizationSite {
      id
      sensorImportTask {
        ...GrowlinkImportTaskFields
      }
    }
    ... on Error {
      message
    }
  }
}
    ${GrowlinkImportTaskFieldsFragmentDoc}`;
export type ImportGrowlinkDataMutationFn = Apollo.MutationFunction<ImportGrowlinkDataMutation, ImportGrowlinkDataMutationVariables>;

/**
 * __useImportGrowlinkDataMutation__
 *
 * To run a mutation, you first call `useImportGrowlinkDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportGrowlinkDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importGrowlinkDataMutation, { data, loading, error }] = useImportGrowlinkDataMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useImportGrowlinkDataMutation(baseOptions?: Apollo.MutationHookOptions<ImportGrowlinkDataMutation, ImportGrowlinkDataMutationVariables>) {
        return Apollo.useMutation<ImportGrowlinkDataMutation, ImportGrowlinkDataMutationVariables>(ImportGrowlinkDataDocument, baseOptions);
      }
export type ImportGrowlinkDataMutationHookResult = ReturnType<typeof useImportGrowlinkDataMutation>;
export type ImportGrowlinkDataMutationResult = Apollo.MutationResult<ImportGrowlinkDataMutation>;
export type ImportGrowlinkDataMutationOptions = Apollo.BaseMutationOptions<ImportGrowlinkDataMutation, ImportGrowlinkDataMutationVariables>;
export const ReassignDeviceZoneDocument = gql`
    mutation reassignDeviceZone($input: ReassignDeviceZoneInput!) {
  reassignDeviceZone(input: $input) {
    ... on EnvironmentalDevice {
      ...EnvironmentalDeviceFields
    }
    ... on Error {
      message
    }
  }
}
    ${EnvironmentalDeviceFieldsFragmentDoc}`;
export type ReassignDeviceZoneMutationFn = Apollo.MutationFunction<ReassignDeviceZoneMutation, ReassignDeviceZoneMutationVariables>;

/**
 * __useReassignDeviceZoneMutation__
 *
 * To run a mutation, you first call `useReassignDeviceZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignDeviceZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignDeviceZoneMutation, { data, loading, error }] = useReassignDeviceZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReassignDeviceZoneMutation(baseOptions?: Apollo.MutationHookOptions<ReassignDeviceZoneMutation, ReassignDeviceZoneMutationVariables>) {
        return Apollo.useMutation<ReassignDeviceZoneMutation, ReassignDeviceZoneMutationVariables>(ReassignDeviceZoneDocument, baseOptions);
      }
export type ReassignDeviceZoneMutationHookResult = ReturnType<typeof useReassignDeviceZoneMutation>;
export type ReassignDeviceZoneMutationResult = Apollo.MutationResult<ReassignDeviceZoneMutation>;
export type ReassignDeviceZoneMutationOptions = Apollo.BaseMutationOptions<ReassignDeviceZoneMutation, ReassignDeviceZoneMutationVariables>;
export const ValidateDeviceQrCodeDocument = gql`
    mutation validateDeviceQrCode($input: ValidateDeviceQrCodeInput!) {
  validateDeviceQrCode(input: $input) {
    macAddress
    error
  }
}
    `;
export type ValidateDeviceQrCodeMutationFn = Apollo.MutationFunction<ValidateDeviceQrCodeMutation, ValidateDeviceQrCodeMutationVariables>;

/**
 * __useValidateDeviceQrCodeMutation__
 *
 * To run a mutation, you first call `useValidateDeviceQrCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDeviceQrCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDeviceQrCodeMutation, { data, loading, error }] = useValidateDeviceQrCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateDeviceQrCodeMutation(baseOptions?: Apollo.MutationHookOptions<ValidateDeviceQrCodeMutation, ValidateDeviceQrCodeMutationVariables>) {
        return Apollo.useMutation<ValidateDeviceQrCodeMutation, ValidateDeviceQrCodeMutationVariables>(ValidateDeviceQrCodeDocument, baseOptions);
      }
export type ValidateDeviceQrCodeMutationHookResult = ReturnType<typeof useValidateDeviceQrCodeMutation>;
export type ValidateDeviceQrCodeMutationResult = Apollo.MutationResult<ValidateDeviceQrCodeMutation>;
export type ValidateDeviceQrCodeMutationOptions = Apollo.BaseMutationOptions<ValidateDeviceQrCodeMutation, ValidateDeviceQrCodeMutationVariables>;
export const UpdateEnvironmentalTargetSetDocument = gql`
    mutation updateEnvironmentalTargetSet($input: UpdateEnvironmentalTargetSetInput!) {
  updateEnvironmentalTargetSet(input: $input) {
    ... on EnvironmentalTargetSet {
      ...EnvironmentalTargetSetFields
    }
    ... on Error {
      message
    }
  }
}
    ${EnvironmentalTargetSetFieldsFragmentDoc}`;
export type UpdateEnvironmentalTargetSetMutationFn = Apollo.MutationFunction<UpdateEnvironmentalTargetSetMutation, UpdateEnvironmentalTargetSetMutationVariables>;

/**
 * __useUpdateEnvironmentalTargetSetMutation__
 *
 * To run a mutation, you first call `useUpdateEnvironmentalTargetSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnvironmentalTargetSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnvironmentalTargetSetMutation, { data, loading, error }] = useUpdateEnvironmentalTargetSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnvironmentalTargetSetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnvironmentalTargetSetMutation, UpdateEnvironmentalTargetSetMutationVariables>) {
        return Apollo.useMutation<UpdateEnvironmentalTargetSetMutation, UpdateEnvironmentalTargetSetMutationVariables>(UpdateEnvironmentalTargetSetDocument, baseOptions);
      }
export type UpdateEnvironmentalTargetSetMutationHookResult = ReturnType<typeof useUpdateEnvironmentalTargetSetMutation>;
export type UpdateEnvironmentalTargetSetMutationResult = Apollo.MutationResult<UpdateEnvironmentalTargetSetMutation>;
export type UpdateEnvironmentalTargetSetMutationOptions = Apollo.BaseMutationOptions<UpdateEnvironmentalTargetSetMutation, UpdateEnvironmentalTargetSetMutationVariables>;
export const UpdateEnvironmentalTargetSetBulkDocument = gql`
    mutation updateEnvironmentalTargetSetBulk($input: UpdateEnvironmentalTargetSetBulkInput!) {
  updateEnvironmentalTargetSetBulk(input: $input) {
    ... on EnvironmentalTargetSet {
      ...EnvironmentalTargetSetFields
    }
    ... on Error {
      message
    }
  }
}
    ${EnvironmentalTargetSetFieldsFragmentDoc}`;
export type UpdateEnvironmentalTargetSetBulkMutationFn = Apollo.MutationFunction<UpdateEnvironmentalTargetSetBulkMutation, UpdateEnvironmentalTargetSetBulkMutationVariables>;

/**
 * __useUpdateEnvironmentalTargetSetBulkMutation__
 *
 * To run a mutation, you first call `useUpdateEnvironmentalTargetSetBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnvironmentalTargetSetBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnvironmentalTargetSetBulkMutation, { data, loading, error }] = useUpdateEnvironmentalTargetSetBulkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnvironmentalTargetSetBulkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnvironmentalTargetSetBulkMutation, UpdateEnvironmentalTargetSetBulkMutationVariables>) {
        return Apollo.useMutation<UpdateEnvironmentalTargetSetBulkMutation, UpdateEnvironmentalTargetSetBulkMutationVariables>(UpdateEnvironmentalTargetSetBulkDocument, baseOptions);
      }
export type UpdateEnvironmentalTargetSetBulkMutationHookResult = ReturnType<typeof useUpdateEnvironmentalTargetSetBulkMutation>;
export type UpdateEnvironmentalTargetSetBulkMutationResult = Apollo.MutationResult<UpdateEnvironmentalTargetSetBulkMutation>;
export type UpdateEnvironmentalTargetSetBulkMutationOptions = Apollo.BaseMutationOptions<UpdateEnvironmentalTargetSetBulkMutation, UpdateEnvironmentalTargetSetBulkMutationVariables>;
export const CreateEnvironmentalTargetSetDocument = gql`
    mutation createEnvironmentalTargetSet($input: CreateEnvironmentalTargetSetInput!) {
  createEnvironmentalTargetSet(input: $input) {
    ... on EnvironmentalTargetSet {
      ...EnvironmentalTargetSetFields
    }
    ... on Error {
      message
    }
  }
}
    ${EnvironmentalTargetSetFieldsFragmentDoc}`;
export type CreateEnvironmentalTargetSetMutationFn = Apollo.MutationFunction<CreateEnvironmentalTargetSetMutation, CreateEnvironmentalTargetSetMutationVariables>;

/**
 * __useCreateEnvironmentalTargetSetMutation__
 *
 * To run a mutation, you first call `useCreateEnvironmentalTargetSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnvironmentalTargetSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnvironmentalTargetSetMutation, { data, loading, error }] = useCreateEnvironmentalTargetSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnvironmentalTargetSetMutation(baseOptions?: Apollo.MutationHookOptions<CreateEnvironmentalTargetSetMutation, CreateEnvironmentalTargetSetMutationVariables>) {
        return Apollo.useMutation<CreateEnvironmentalTargetSetMutation, CreateEnvironmentalTargetSetMutationVariables>(CreateEnvironmentalTargetSetDocument, baseOptions);
      }
export type CreateEnvironmentalTargetSetMutationHookResult = ReturnType<typeof useCreateEnvironmentalTargetSetMutation>;
export type CreateEnvironmentalTargetSetMutationResult = Apollo.MutationResult<CreateEnvironmentalTargetSetMutation>;
export type CreateEnvironmentalTargetSetMutationOptions = Apollo.BaseMutationOptions<CreateEnvironmentalTargetSetMutation, CreateEnvironmentalTargetSetMutationVariables>;
export const CreateFieldAgentDocument = gql`
    mutation createFieldAgent($input: CreateFieldAgentInput!) {
  createFieldAgent(input: $input) {
    ... on CreateFieldAgentSuccess {
      token
      fieldAgent {
        id
        agentId
        label
        vendor
        hostname
        localIp
        subnet
        softwareVersion
        status
        isStale
        isActive
        lastSeenAt
        devices {
          id
        }
      }
    }
    ... on Error {
      message
    }
  }
}
    `;
export type CreateFieldAgentMutationFn = Apollo.MutationFunction<CreateFieldAgentMutation, CreateFieldAgentMutationVariables>;

/**
 * __useCreateFieldAgentMutation__
 *
 * To run a mutation, you first call `useCreateFieldAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFieldAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFieldAgentMutation, { data, loading, error }] = useCreateFieldAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFieldAgentMutation(baseOptions?: Apollo.MutationHookOptions<CreateFieldAgentMutation, CreateFieldAgentMutationVariables>) {
        return Apollo.useMutation<CreateFieldAgentMutation, CreateFieldAgentMutationVariables>(CreateFieldAgentDocument, baseOptions);
      }
export type CreateFieldAgentMutationHookResult = ReturnType<typeof useCreateFieldAgentMutation>;
export type CreateFieldAgentMutationResult = Apollo.MutationResult<CreateFieldAgentMutation>;
export type CreateFieldAgentMutationOptions = Apollo.BaseMutationOptions<CreateFieldAgentMutation, CreateFieldAgentMutationVariables>;
export const RotateFieldAgentTokenDocument = gql`
    mutation rotateFieldAgentToken($input: RotateFieldAgentTokenInput!) {
  rotateFieldAgentToken(input: $input) {
    ... on RotateFieldAgentTokenSuccess {
      token
      fieldAgent {
        id
        agentId
        tokenKeyPrefix
      }
    }
    ... on Error {
      message
    }
  }
}
    `;
export type RotateFieldAgentTokenMutationFn = Apollo.MutationFunction<RotateFieldAgentTokenMutation, RotateFieldAgentTokenMutationVariables>;

/**
 * __useRotateFieldAgentTokenMutation__
 *
 * To run a mutation, you first call `useRotateFieldAgentTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateFieldAgentTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateFieldAgentTokenMutation, { data, loading, error }] = useRotateFieldAgentTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRotateFieldAgentTokenMutation(baseOptions?: Apollo.MutationHookOptions<RotateFieldAgentTokenMutation, RotateFieldAgentTokenMutationVariables>) {
        return Apollo.useMutation<RotateFieldAgentTokenMutation, RotateFieldAgentTokenMutationVariables>(RotateFieldAgentTokenDocument, baseOptions);
      }
export type RotateFieldAgentTokenMutationHookResult = ReturnType<typeof useRotateFieldAgentTokenMutation>;
export type RotateFieldAgentTokenMutationResult = Apollo.MutationResult<RotateFieldAgentTokenMutation>;
export type RotateFieldAgentTokenMutationOptions = Apollo.BaseMutationOptions<RotateFieldAgentTokenMutation, RotateFieldAgentTokenMutationVariables>;
export const GenerateFieldAgentClaimCodeDocument = gql`
    mutation generateFieldAgentClaimCode($input: GenerateFieldAgentClaimCodeInput!) {
  generateFieldAgentClaimCode(input: $input) {
    ... on GenerateFieldAgentClaimCodeSuccess {
      claimCode
      expiresAt
      fieldAgent {
        id
        agentId
      }
    }
    ... on Error {
      message
    }
  }
}
    `;
export type GenerateFieldAgentClaimCodeMutationFn = Apollo.MutationFunction<GenerateFieldAgentClaimCodeMutation, GenerateFieldAgentClaimCodeMutationVariables>;

/**
 * __useGenerateFieldAgentClaimCodeMutation__
 *
 * To run a mutation, you first call `useGenerateFieldAgentClaimCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateFieldAgentClaimCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateFieldAgentClaimCodeMutation, { data, loading, error }] = useGenerateFieldAgentClaimCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateFieldAgentClaimCodeMutation(baseOptions?: Apollo.MutationHookOptions<GenerateFieldAgentClaimCodeMutation, GenerateFieldAgentClaimCodeMutationVariables>) {
        return Apollo.useMutation<GenerateFieldAgentClaimCodeMutation, GenerateFieldAgentClaimCodeMutationVariables>(GenerateFieldAgentClaimCodeDocument, baseOptions);
      }
export type GenerateFieldAgentClaimCodeMutationHookResult = ReturnType<typeof useGenerateFieldAgentClaimCodeMutation>;
export type GenerateFieldAgentClaimCodeMutationResult = Apollo.MutationResult<GenerateFieldAgentClaimCodeMutation>;
export type GenerateFieldAgentClaimCodeMutationOptions = Apollo.BaseMutationOptions<GenerateFieldAgentClaimCodeMutation, GenerateFieldAgentClaimCodeMutationVariables>;
export const MapFieldAgentDeviceDocument = gql`
    mutation mapFieldAgentDevice($input: MapFieldAgentDeviceInput!) {
  mapFieldAgentDevice(input: $input) {
    ... on FieldAgentDevice {
      id
      sensorDevice {
        id
        name
        zone {
          id
          name
        }
      }
    }
    ... on Error {
      message
    }
  }
}
    `;
export type MapFieldAgentDeviceMutationFn = Apollo.MutationFunction<MapFieldAgentDeviceMutation, MapFieldAgentDeviceMutationVariables>;

/**
 * __useMapFieldAgentDeviceMutation__
 *
 * To run a mutation, you first call `useMapFieldAgentDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMapFieldAgentDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mapFieldAgentDeviceMutation, { data, loading, error }] = useMapFieldAgentDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMapFieldAgentDeviceMutation(baseOptions?: Apollo.MutationHookOptions<MapFieldAgentDeviceMutation, MapFieldAgentDeviceMutationVariables>) {
        return Apollo.useMutation<MapFieldAgentDeviceMutation, MapFieldAgentDeviceMutationVariables>(MapFieldAgentDeviceDocument, baseOptions);
      }
export type MapFieldAgentDeviceMutationHookResult = ReturnType<typeof useMapFieldAgentDeviceMutation>;
export type MapFieldAgentDeviceMutationResult = Apollo.MutationResult<MapFieldAgentDeviceMutation>;
export type MapFieldAgentDeviceMutationOptions = Apollo.BaseMutationOptions<MapFieldAgentDeviceMutation, MapFieldAgentDeviceMutationVariables>;
export const ResolveIntegrityEventDocument = gql`
    mutation resolveIntegrityEvent($input: ResolveIntegrityEventInput!) {
  resolveIntegrityEvent(input: $input) {
    event {
      id
      category
      severity
      message
      resolutionState
      resolutionAction
      siteId
      siteName
      availableActions {
        action
        label
      }
      resolutionOptions {
        budFormFactors {
          id
          label
        }
        zones {
          id
          label
        }
        harvestGroups {
          id
          label
        }
      }
    }
    createdSideEffects {
      type
      id
      label
    }
    queuedTask {
      type
      label
    }
    errors
  }
}
    `;
export type ResolveIntegrityEventMutationFn = Apollo.MutationFunction<ResolveIntegrityEventMutation, ResolveIntegrityEventMutationVariables>;

/**
 * __useResolveIntegrityEventMutation__
 *
 * To run a mutation, you first call `useResolveIntegrityEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveIntegrityEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveIntegrityEventMutation, { data, loading, error }] = useResolveIntegrityEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveIntegrityEventMutation(baseOptions?: Apollo.MutationHookOptions<ResolveIntegrityEventMutation, ResolveIntegrityEventMutationVariables>) {
        return Apollo.useMutation<ResolveIntegrityEventMutation, ResolveIntegrityEventMutationVariables>(ResolveIntegrityEventDocument, baseOptions);
      }
export type ResolveIntegrityEventMutationHookResult = ReturnType<typeof useResolveIntegrityEventMutation>;
export type ResolveIntegrityEventMutationResult = Apollo.MutationResult<ResolveIntegrityEventMutation>;
export type ResolveIntegrityEventMutationOptions = Apollo.BaseMutationOptions<ResolveIntegrityEventMutation, ResolveIntegrityEventMutationVariables>;
export const ImportMetrcCompletedHarvestGroupsDocument = gql`
    mutation importMetrcCompletedHarvestGroups($input: ImportMetrcCompletedHarvestGroupsInput!) {
  importMetrcCompletedHarvestGroups(input: $input) {
    ... on Organization {
      ...OrganizationFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type ImportMetrcCompletedHarvestGroupsMutationFn = Apollo.MutationFunction<ImportMetrcCompletedHarvestGroupsMutation, ImportMetrcCompletedHarvestGroupsMutationVariables>;

/**
 * __useImportMetrcCompletedHarvestGroupsMutation__
 *
 * To run a mutation, you first call `useImportMetrcCompletedHarvestGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMetrcCompletedHarvestGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMetrcCompletedHarvestGroupsMutation, { data, loading, error }] = useImportMetrcCompletedHarvestGroupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportMetrcCompletedHarvestGroupsMutation(baseOptions?: Apollo.MutationHookOptions<ImportMetrcCompletedHarvestGroupsMutation, ImportMetrcCompletedHarvestGroupsMutationVariables>) {
        return Apollo.useMutation<ImportMetrcCompletedHarvestGroupsMutation, ImportMetrcCompletedHarvestGroupsMutationVariables>(ImportMetrcCompletedHarvestGroupsDocument, baseOptions);
      }
export type ImportMetrcCompletedHarvestGroupsMutationHookResult = ReturnType<typeof useImportMetrcCompletedHarvestGroupsMutation>;
export type ImportMetrcCompletedHarvestGroupsMutationResult = Apollo.MutationResult<ImportMetrcCompletedHarvestGroupsMutation>;
export type ImportMetrcCompletedHarvestGroupsMutationOptions = Apollo.BaseMutationOptions<ImportMetrcCompletedHarvestGroupsMutation, ImportMetrcCompletedHarvestGroupsMutationVariables>;
export const ImportMetrcLocationsDocument = gql`
    mutation importMetrcLocations($input: ImportMetrcLocationsInput!) {
  importMetrcLocations(input: $input) {
    ... on Error {
      message
    }
    ... on Organization {
      ...OrganizationFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type ImportMetrcLocationsMutationFn = Apollo.MutationFunction<ImportMetrcLocationsMutation, ImportMetrcLocationsMutationVariables>;

/**
 * __useImportMetrcLocationsMutation__
 *
 * To run a mutation, you first call `useImportMetrcLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMetrcLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMetrcLocationsMutation, { data, loading, error }] = useImportMetrcLocationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportMetrcLocationsMutation(baseOptions?: Apollo.MutationHookOptions<ImportMetrcLocationsMutation, ImportMetrcLocationsMutationVariables>) {
        return Apollo.useMutation<ImportMetrcLocationsMutation, ImportMetrcLocationsMutationVariables>(ImportMetrcLocationsDocument, baseOptions);
      }
export type ImportMetrcLocationsMutationHookResult = ReturnType<typeof useImportMetrcLocationsMutation>;
export type ImportMetrcLocationsMutationResult = Apollo.MutationResult<ImportMetrcLocationsMutation>;
export type ImportMetrcLocationsMutationOptions = Apollo.BaseMutationOptions<ImportMetrcLocationsMutation, ImportMetrcLocationsMutationVariables>;
export const ImportMetrcStrainsDocument = gql`
    mutation importMetrcStrains($input: ImportMetrcStrainsInput!) {
  importMetrcStrains(input: $input) {
    ... on Organization {
      ...OrganizationFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type ImportMetrcStrainsMutationFn = Apollo.MutationFunction<ImportMetrcStrainsMutation, ImportMetrcStrainsMutationVariables>;

/**
 * __useImportMetrcStrainsMutation__
 *
 * To run a mutation, you first call `useImportMetrcStrainsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMetrcStrainsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMetrcStrainsMutation, { data, loading, error }] = useImportMetrcStrainsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportMetrcStrainsMutation(baseOptions?: Apollo.MutationHookOptions<ImportMetrcStrainsMutation, ImportMetrcStrainsMutationVariables>) {
        return Apollo.useMutation<ImportMetrcStrainsMutation, ImportMetrcStrainsMutationVariables>(ImportMetrcStrainsDocument, baseOptions);
      }
export type ImportMetrcStrainsMutationHookResult = ReturnType<typeof useImportMetrcStrainsMutation>;
export type ImportMetrcStrainsMutationResult = Apollo.MutationResult<ImportMetrcStrainsMutation>;
export type ImportMetrcStrainsMutationOptions = Apollo.BaseMutationOptions<ImportMetrcStrainsMutation, ImportMetrcStrainsMutationVariables>;
export const ImportMetrcTemplateDocument = gql`
    mutation importMetrcTemplate($input: ImportMetrcTemplateInput!) {
  importMetrcTemplate(input: $input) {
    ... on Organization {
      ...OrganizationFields
    }
    ... on Error {
      message
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type ImportMetrcTemplateMutationFn = Apollo.MutationFunction<ImportMetrcTemplateMutation, ImportMetrcTemplateMutationVariables>;

/**
 * __useImportMetrcTemplateMutation__
 *
 * To run a mutation, you first call `useImportMetrcTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMetrcTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMetrcTemplateMutation, { data, loading, error }] = useImportMetrcTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportMetrcTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ImportMetrcTemplateMutation, ImportMetrcTemplateMutationVariables>) {
        return Apollo.useMutation<ImportMetrcTemplateMutation, ImportMetrcTemplateMutationVariables>(ImportMetrcTemplateDocument, baseOptions);
      }
export type ImportMetrcTemplateMutationHookResult = ReturnType<typeof useImportMetrcTemplateMutation>;
export type ImportMetrcTemplateMutationResult = Apollo.MutationResult<ImportMetrcTemplateMutation>;
export type ImportMetrcTemplateMutationOptions = Apollo.BaseMutationOptions<ImportMetrcTemplateMutation, ImportMetrcTemplateMutationVariables>;
export const ImportMetrcBudFormFactorsDocument = gql`
    mutation importMetrcBudFormFactors($input: ImportMetrcBudFormFactorsInput!) {
  importMetrcBudFormFactors(input: $input) {
    ... on Organization {
      ...OrganizationFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type ImportMetrcBudFormFactorsMutationFn = Apollo.MutationFunction<ImportMetrcBudFormFactorsMutation, ImportMetrcBudFormFactorsMutationVariables>;

/**
 * __useImportMetrcBudFormFactorsMutation__
 *
 * To run a mutation, you first call `useImportMetrcBudFormFactorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMetrcBudFormFactorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMetrcBudFormFactorsMutation, { data, loading, error }] = useImportMetrcBudFormFactorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportMetrcBudFormFactorsMutation(baseOptions?: Apollo.MutationHookOptions<ImportMetrcBudFormFactorsMutation, ImportMetrcBudFormFactorsMutationVariables>) {
        return Apollo.useMutation<ImportMetrcBudFormFactorsMutation, ImportMetrcBudFormFactorsMutationVariables>(ImportMetrcBudFormFactorsDocument, baseOptions);
      }
export type ImportMetrcBudFormFactorsMutationHookResult = ReturnType<typeof useImportMetrcBudFormFactorsMutation>;
export type ImportMetrcBudFormFactorsMutationResult = Apollo.MutationResult<ImportMetrcBudFormFactorsMutation>;
export type ImportMetrcBudFormFactorsMutationOptions = Apollo.BaseMutationOptions<ImportMetrcBudFormFactorsMutation, ImportMetrcBudFormFactorsMutationVariables>;
export const ImportMetrcZoneRotationDocument = gql`
    mutation importMetrcZoneRotation($input: ImportMetrcZoneRotationInput!) {
  importMetrcZoneRotation(input: $input) {
    ... on Organization {
      ...OrganizationFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type ImportMetrcZoneRotationMutationFn = Apollo.MutationFunction<ImportMetrcZoneRotationMutation, ImportMetrcZoneRotationMutationVariables>;

/**
 * __useImportMetrcZoneRotationMutation__
 *
 * To run a mutation, you first call `useImportMetrcZoneRotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMetrcZoneRotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMetrcZoneRotationMutation, { data, loading, error }] = useImportMetrcZoneRotationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportMetrcZoneRotationMutation(baseOptions?: Apollo.MutationHookOptions<ImportMetrcZoneRotationMutation, ImportMetrcZoneRotationMutationVariables>) {
        return Apollo.useMutation<ImportMetrcZoneRotationMutation, ImportMetrcZoneRotationMutationVariables>(ImportMetrcZoneRotationDocument, baseOptions);
      }
export type ImportMetrcZoneRotationMutationHookResult = ReturnType<typeof useImportMetrcZoneRotationMutation>;
export type ImportMetrcZoneRotationMutationResult = Apollo.MutationResult<ImportMetrcZoneRotationMutation>;
export type ImportMetrcZoneRotationMutationOptions = Apollo.BaseMutationOptions<ImportMetrcZoneRotationMutation, ImportMetrcZoneRotationMutationVariables>;
export const ImportMetrcCurrentHarvestGroupsDocument = gql`
    mutation importMetrcCurrentHarvestGroups($input: ImportMetrcCurrentHarvestGroupsInput!) {
  importMetrcCurrentHarvestGroups(input: $input) {
    ... on Organization {
      ...OrganizationFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type ImportMetrcCurrentHarvestGroupsMutationFn = Apollo.MutationFunction<ImportMetrcCurrentHarvestGroupsMutation, ImportMetrcCurrentHarvestGroupsMutationVariables>;

/**
 * __useImportMetrcCurrentHarvestGroupsMutation__
 *
 * To run a mutation, you first call `useImportMetrcCurrentHarvestGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMetrcCurrentHarvestGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMetrcCurrentHarvestGroupsMutation, { data, loading, error }] = useImportMetrcCurrentHarvestGroupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportMetrcCurrentHarvestGroupsMutation(baseOptions?: Apollo.MutationHookOptions<ImportMetrcCurrentHarvestGroupsMutation, ImportMetrcCurrentHarvestGroupsMutationVariables>) {
        return Apollo.useMutation<ImportMetrcCurrentHarvestGroupsMutation, ImportMetrcCurrentHarvestGroupsMutationVariables>(ImportMetrcCurrentHarvestGroupsDocument, baseOptions);
      }
export type ImportMetrcCurrentHarvestGroupsMutationHookResult = ReturnType<typeof useImportMetrcCurrentHarvestGroupsMutation>;
export type ImportMetrcCurrentHarvestGroupsMutationResult = Apollo.MutationResult<ImportMetrcCurrentHarvestGroupsMutation>;
export type ImportMetrcCurrentHarvestGroupsMutationOptions = Apollo.BaseMutationOptions<ImportMetrcCurrentHarvestGroupsMutation, ImportMetrcCurrentHarvestGroupsMutationVariables>;
export const CreateOrganizationAndFirstUserDocument = gql`
    mutation createOrganizationAndFirstUser($input: CreateOrganizationAndFirstUserInput!) {
  createOrganizationAndFirstUser(input: $input) {
    ... on Organization {
      ...OrganizationFields
    }
    ... on Error {
      message
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type CreateOrganizationAndFirstUserMutationFn = Apollo.MutationFunction<CreateOrganizationAndFirstUserMutation, CreateOrganizationAndFirstUserMutationVariables>;

/**
 * __useCreateOrganizationAndFirstUserMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationAndFirstUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationAndFirstUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationAndFirstUserMutation, { data, loading, error }] = useCreateOrganizationAndFirstUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationAndFirstUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationAndFirstUserMutation, CreateOrganizationAndFirstUserMutationVariables>) {
        return Apollo.useMutation<CreateOrganizationAndFirstUserMutation, CreateOrganizationAndFirstUserMutationVariables>(CreateOrganizationAndFirstUserDocument, baseOptions);
      }
export type CreateOrganizationAndFirstUserMutationHookResult = ReturnType<typeof useCreateOrganizationAndFirstUserMutation>;
export type CreateOrganizationAndFirstUserMutationResult = Apollo.MutationResult<CreateOrganizationAndFirstUserMutation>;
export type CreateOrganizationAndFirstUserMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationAndFirstUserMutation, CreateOrganizationAndFirstUserMutationVariables>;
export const UpdateOrganizationSettingsDocument = gql`
    mutation updateOrganizationSettings($input: UpdateOrganizationSettingsInput) {
  updateOrganizationSettings(input: $input) {
    ... on Organization {
      ...OrganizationFields
    }
    ... on Error {
      message
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type UpdateOrganizationSettingsMutationFn = Apollo.MutationFunction<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>;

/**
 * __useUpdateOrganizationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSettingsMutation, { data, loading, error }] = useUpdateOrganizationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>) {
        return Apollo.useMutation<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>(UpdateOrganizationSettingsDocument, baseOptions);
      }
export type UpdateOrganizationSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationSettingsMutation>;
export type UpdateOrganizationSettingsMutationResult = Apollo.MutationResult<UpdateOrganizationSettingsMutation>;
export type UpdateOrganizationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>;
export const UpdateOrganizationBrandingDocument = gql`
    mutation updateOrganizationBranding($input: UpdateOrganizationBrandingInput!) {
  updateOrganizationBranding(input: $input) {
    ... on Organization {
      id
      branding {
        colorPreset
        logoUrl
        logoDarkUrl
        customized
        updatedAt
      }
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdateOrganizationBrandingMutationFn = Apollo.MutationFunction<UpdateOrganizationBrandingMutation, UpdateOrganizationBrandingMutationVariables>;

/**
 * __useUpdateOrganizationBrandingMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationBrandingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationBrandingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationBrandingMutation, { data, loading, error }] = useUpdateOrganizationBrandingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationBrandingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationBrandingMutation, UpdateOrganizationBrandingMutationVariables>) {
        return Apollo.useMutation<UpdateOrganizationBrandingMutation, UpdateOrganizationBrandingMutationVariables>(UpdateOrganizationBrandingDocument, baseOptions);
      }
export type UpdateOrganizationBrandingMutationHookResult = ReturnType<typeof useUpdateOrganizationBrandingMutation>;
export type UpdateOrganizationBrandingMutationResult = Apollo.MutationResult<UpdateOrganizationBrandingMutation>;
export type UpdateOrganizationBrandingMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationBrandingMutation, UpdateOrganizationBrandingMutationVariables>;
export const EnableMultisiteDocument = gql`
    mutation enableMultisite($input: EnableMultisiteInput!) {
  enableMultisite(input: $input) {
    ... on Organization {
      ...OrganizationFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type EnableMultisiteMutationFn = Apollo.MutationFunction<EnableMultisiteMutation, EnableMultisiteMutationVariables>;

/**
 * __useEnableMultisiteMutation__
 *
 * To run a mutation, you first call `useEnableMultisiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableMultisiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableMultisiteMutation, { data, loading, error }] = useEnableMultisiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableMultisiteMutation(baseOptions?: Apollo.MutationHookOptions<EnableMultisiteMutation, EnableMultisiteMutationVariables>) {
        return Apollo.useMutation<EnableMultisiteMutation, EnableMultisiteMutationVariables>(EnableMultisiteDocument, baseOptions);
      }
export type EnableMultisiteMutationHookResult = ReturnType<typeof useEnableMultisiteMutation>;
export type EnableMultisiteMutationResult = Apollo.MutationResult<EnableMultisiteMutation>;
export type EnableMultisiteMutationOptions = Apollo.BaseMutationOptions<EnableMultisiteMutation, EnableMultisiteMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation updateRole($input: UpdateRoleInput!) {
  updateRole(input: $input) {
    ... on Role {
      ...RoleFields
    }
    ... on Error {
      message
    }
  }
}
    ${RoleFieldsFragmentDoc}`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, baseOptions);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const AddTrolmasterApiKeyDocument = gql`
    mutation addTrolmasterApiKey($input: AddTrolmasterApiKeyInput!) {
  addTrolmasterApiKey(input: $input) {
    ... on Organization {
      ...OrganizationFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type AddTrolmasterApiKeyMutationFn = Apollo.MutationFunction<AddTrolmasterApiKeyMutation, AddTrolmasterApiKeyMutationVariables>;

/**
 * __useAddTrolmasterApiKeyMutation__
 *
 * To run a mutation, you first call `useAddTrolmasterApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrolmasterApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrolmasterApiKeyMutation, { data, loading, error }] = useAddTrolmasterApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTrolmasterApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<AddTrolmasterApiKeyMutation, AddTrolmasterApiKeyMutationVariables>) {
        return Apollo.useMutation<AddTrolmasterApiKeyMutation, AddTrolmasterApiKeyMutationVariables>(AddTrolmasterApiKeyDocument, baseOptions);
      }
export type AddTrolmasterApiKeyMutationHookResult = ReturnType<typeof useAddTrolmasterApiKeyMutation>;
export type AddTrolmasterApiKeyMutationResult = Apollo.MutationResult<AddTrolmasterApiKeyMutation>;
export type AddTrolmasterApiKeyMutationOptions = Apollo.BaseMutationOptions<AddTrolmasterApiKeyMutation, AddTrolmasterApiKeyMutationVariables>;
export const AddAroyaApiKeyDocument = gql`
    mutation addAroyaApiKey($input: AddAroyaApiKeyInput!) {
  addAroyaApiKey(input: $input) {
    error
    devices {
      deviceId
      modelKey
      serialNumber
      name
    }
    organization {
      id
    }
  }
}
    `;
export type AddAroyaApiKeyMutationFn = Apollo.MutationFunction<AddAroyaApiKeyMutation, AddAroyaApiKeyMutationVariables>;

/**
 * __useAddAroyaApiKeyMutation__
 *
 * To run a mutation, you first call `useAddAroyaApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAroyaApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAroyaApiKeyMutation, { data, loading, error }] = useAddAroyaApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAroyaApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<AddAroyaApiKeyMutation, AddAroyaApiKeyMutationVariables>) {
        return Apollo.useMutation<AddAroyaApiKeyMutation, AddAroyaApiKeyMutationVariables>(AddAroyaApiKeyDocument, baseOptions);
      }
export type AddAroyaApiKeyMutationHookResult = ReturnType<typeof useAddAroyaApiKeyMutation>;
export type AddAroyaApiKeyMutationResult = Apollo.MutationResult<AddAroyaApiKeyMutation>;
export type AddAroyaApiKeyMutationOptions = Apollo.BaseMutationOptions<AddAroyaApiKeyMutation, AddAroyaApiKeyMutationVariables>;
export const AddGrowlinkApiKeyDocument = gql`
    mutation addGrowlinkApiKey($input: AddGrowlinkApiKeyInput!) {
  addGrowlinkApiKey(input: $input) {
    error
    devices {
      controllerId
      moduleName
      temperatureSensorId
      humiditySensorId
      co2SensorId
      vpdSensorId
    }
    organization {
      id
    }
  }
}
    `;
export type AddGrowlinkApiKeyMutationFn = Apollo.MutationFunction<AddGrowlinkApiKeyMutation, AddGrowlinkApiKeyMutationVariables>;

/**
 * __useAddGrowlinkApiKeyMutation__
 *
 * To run a mutation, you first call `useAddGrowlinkApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGrowlinkApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGrowlinkApiKeyMutation, { data, loading, error }] = useAddGrowlinkApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddGrowlinkApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<AddGrowlinkApiKeyMutation, AddGrowlinkApiKeyMutationVariables>) {
        return Apollo.useMutation<AddGrowlinkApiKeyMutation, AddGrowlinkApiKeyMutationVariables>(AddGrowlinkApiKeyDocument, baseOptions);
      }
export type AddGrowlinkApiKeyMutationHookResult = ReturnType<typeof useAddGrowlinkApiKeyMutation>;
export type AddGrowlinkApiKeyMutationResult = Apollo.MutationResult<AddGrowlinkApiKeyMutation>;
export type AddGrowlinkApiKeyMutationOptions = Apollo.BaseMutationOptions<AddGrowlinkApiKeyMutation, AddGrowlinkApiKeyMutationVariables>;
export const AddSiteAroyaCredentialDocument = gql`
    mutation addSiteAroyaCredential($input: AddSiteAroyaCredentialInput!) {
  addSiteAroyaCredential(input: $input) {
    error
    credential {
      id
      brand
      label
    }
  }
}
    `;
export type AddSiteAroyaCredentialMutationFn = Apollo.MutationFunction<AddSiteAroyaCredentialMutation, AddSiteAroyaCredentialMutationVariables>;

/**
 * __useAddSiteAroyaCredentialMutation__
 *
 * To run a mutation, you first call `useAddSiteAroyaCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSiteAroyaCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSiteAroyaCredentialMutation, { data, loading, error }] = useAddSiteAroyaCredentialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSiteAroyaCredentialMutation(baseOptions?: Apollo.MutationHookOptions<AddSiteAroyaCredentialMutation, AddSiteAroyaCredentialMutationVariables>) {
        return Apollo.useMutation<AddSiteAroyaCredentialMutation, AddSiteAroyaCredentialMutationVariables>(AddSiteAroyaCredentialDocument, baseOptions);
      }
export type AddSiteAroyaCredentialMutationHookResult = ReturnType<typeof useAddSiteAroyaCredentialMutation>;
export type AddSiteAroyaCredentialMutationResult = Apollo.MutationResult<AddSiteAroyaCredentialMutation>;
export type AddSiteAroyaCredentialMutationOptions = Apollo.BaseMutationOptions<AddSiteAroyaCredentialMutation, AddSiteAroyaCredentialMutationVariables>;
export const AddSiteGrowlinkCredentialDocument = gql`
    mutation addSiteGrowlinkCredential($input: AddSiteGrowlinkCredentialInput!) {
  addSiteGrowlinkCredential(input: $input) {
    error
    organizations {
      id
      name
    }
    credential {
      id
      brand
      label
      growlinkApiVersion
      growlinkOrganizationId
    }
  }
}
    `;
export type AddSiteGrowlinkCredentialMutationFn = Apollo.MutationFunction<AddSiteGrowlinkCredentialMutation, AddSiteGrowlinkCredentialMutationVariables>;

/**
 * __useAddSiteGrowlinkCredentialMutation__
 *
 * To run a mutation, you first call `useAddSiteGrowlinkCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSiteGrowlinkCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSiteGrowlinkCredentialMutation, { data, loading, error }] = useAddSiteGrowlinkCredentialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSiteGrowlinkCredentialMutation(baseOptions?: Apollo.MutationHookOptions<AddSiteGrowlinkCredentialMutation, AddSiteGrowlinkCredentialMutationVariables>) {
        return Apollo.useMutation<AddSiteGrowlinkCredentialMutation, AddSiteGrowlinkCredentialMutationVariables>(AddSiteGrowlinkCredentialDocument, baseOptions);
      }
export type AddSiteGrowlinkCredentialMutationHookResult = ReturnType<typeof useAddSiteGrowlinkCredentialMutation>;
export type AddSiteGrowlinkCredentialMutationResult = Apollo.MutationResult<AddSiteGrowlinkCredentialMutation>;
export type AddSiteGrowlinkCredentialMutationOptions = Apollo.BaseMutationOptions<AddSiteGrowlinkCredentialMutation, AddSiteGrowlinkCredentialMutationVariables>;
export const AddSiteTrolmasterCredentialDocument = gql`
    mutation addSiteTrolmasterCredential($input: AddSiteTrolmasterCredentialInput!) {
  addSiteTrolmasterCredential(input: $input) {
    error
    credential {
      id
      brand
      label
    }
  }
}
    `;
export type AddSiteTrolmasterCredentialMutationFn = Apollo.MutationFunction<AddSiteTrolmasterCredentialMutation, AddSiteTrolmasterCredentialMutationVariables>;

/**
 * __useAddSiteTrolmasterCredentialMutation__
 *
 * To run a mutation, you first call `useAddSiteTrolmasterCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSiteTrolmasterCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSiteTrolmasterCredentialMutation, { data, loading, error }] = useAddSiteTrolmasterCredentialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSiteTrolmasterCredentialMutation(baseOptions?: Apollo.MutationHookOptions<AddSiteTrolmasterCredentialMutation, AddSiteTrolmasterCredentialMutationVariables>) {
        return Apollo.useMutation<AddSiteTrolmasterCredentialMutation, AddSiteTrolmasterCredentialMutationVariables>(AddSiteTrolmasterCredentialDocument, baseOptions);
      }
export type AddSiteTrolmasterCredentialMutationHookResult = ReturnType<typeof useAddSiteTrolmasterCredentialMutation>;
export type AddSiteTrolmasterCredentialMutationResult = Apollo.MutationResult<AddSiteTrolmasterCredentialMutation>;
export type AddSiteTrolmasterCredentialMutationOptions = Apollo.BaseMutationOptions<AddSiteTrolmasterCredentialMutation, AddSiteTrolmasterCredentialMutationVariables>;
export const RefreshSiteAroyaDeviceRequestsDocument = gql`
    mutation refreshSiteAroyaDeviceRequests($input: RefreshSiteAroyaDeviceRequestsInput!) {
  refreshSiteAroyaDeviceRequests(input: $input) {
    error
    devices {
      deviceId
      modelKey
      serialNumber
      name
    }
  }
}
    `;
export type RefreshSiteAroyaDeviceRequestsMutationFn = Apollo.MutationFunction<RefreshSiteAroyaDeviceRequestsMutation, RefreshSiteAroyaDeviceRequestsMutationVariables>;

/**
 * __useRefreshSiteAroyaDeviceRequestsMutation__
 *
 * To run a mutation, you first call `useRefreshSiteAroyaDeviceRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshSiteAroyaDeviceRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshSiteAroyaDeviceRequestsMutation, { data, loading, error }] = useRefreshSiteAroyaDeviceRequestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshSiteAroyaDeviceRequestsMutation(baseOptions?: Apollo.MutationHookOptions<RefreshSiteAroyaDeviceRequestsMutation, RefreshSiteAroyaDeviceRequestsMutationVariables>) {
        return Apollo.useMutation<RefreshSiteAroyaDeviceRequestsMutation, RefreshSiteAroyaDeviceRequestsMutationVariables>(RefreshSiteAroyaDeviceRequestsDocument, baseOptions);
      }
export type RefreshSiteAroyaDeviceRequestsMutationHookResult = ReturnType<typeof useRefreshSiteAroyaDeviceRequestsMutation>;
export type RefreshSiteAroyaDeviceRequestsMutationResult = Apollo.MutationResult<RefreshSiteAroyaDeviceRequestsMutation>;
export type RefreshSiteAroyaDeviceRequestsMutationOptions = Apollo.BaseMutationOptions<RefreshSiteAroyaDeviceRequestsMutation, RefreshSiteAroyaDeviceRequestsMutationVariables>;
export const RefreshSiteGrowlinkDeviceRequestsDocument = gql`
    mutation refreshSiteGrowlinkDeviceRequests($input: RefreshSiteGrowlinkDeviceRequestsInput!) {
  refreshSiteGrowlinkDeviceRequests(input: $input) {
    error
    devices {
      controllerId
      moduleName
      temperatureSensorId
      humiditySensorId
      co2SensorId
      vpdSensorId
      name
    }
  }
}
    `;
export type RefreshSiteGrowlinkDeviceRequestsMutationFn = Apollo.MutationFunction<RefreshSiteGrowlinkDeviceRequestsMutation, RefreshSiteGrowlinkDeviceRequestsMutationVariables>;

/**
 * __useRefreshSiteGrowlinkDeviceRequestsMutation__
 *
 * To run a mutation, you first call `useRefreshSiteGrowlinkDeviceRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshSiteGrowlinkDeviceRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshSiteGrowlinkDeviceRequestsMutation, { data, loading, error }] = useRefreshSiteGrowlinkDeviceRequestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshSiteGrowlinkDeviceRequestsMutation(baseOptions?: Apollo.MutationHookOptions<RefreshSiteGrowlinkDeviceRequestsMutation, RefreshSiteGrowlinkDeviceRequestsMutationVariables>) {
        return Apollo.useMutation<RefreshSiteGrowlinkDeviceRequestsMutation, RefreshSiteGrowlinkDeviceRequestsMutationVariables>(RefreshSiteGrowlinkDeviceRequestsDocument, baseOptions);
      }
export type RefreshSiteGrowlinkDeviceRequestsMutationHookResult = ReturnType<typeof useRefreshSiteGrowlinkDeviceRequestsMutation>;
export type RefreshSiteGrowlinkDeviceRequestsMutationResult = Apollo.MutationResult<RefreshSiteGrowlinkDeviceRequestsMutation>;
export type RefreshSiteGrowlinkDeviceRequestsMutationOptions = Apollo.BaseMutationOptions<RefreshSiteGrowlinkDeviceRequestsMutation, RefreshSiteGrowlinkDeviceRequestsMutationVariables>;
export const ConfirmTargetValuesDocument = gql`
    mutation confirmTargetValues($organizationId: ID!) {
  confirmTargetValues(organizationId: $organizationId) {
    ... on Organization {
      ...OrganizationFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type ConfirmTargetValuesMutationFn = Apollo.MutationFunction<ConfirmTargetValuesMutation, ConfirmTargetValuesMutationVariables>;

/**
 * __useConfirmTargetValuesMutation__
 *
 * To run a mutation, you first call `useConfirmTargetValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTargetValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmTargetValuesMutation, { data, loading, error }] = useConfirmTargetValuesMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useConfirmTargetValuesMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmTargetValuesMutation, ConfirmTargetValuesMutationVariables>) {
        return Apollo.useMutation<ConfirmTargetValuesMutation, ConfirmTargetValuesMutationVariables>(ConfirmTargetValuesDocument, baseOptions);
      }
export type ConfirmTargetValuesMutationHookResult = ReturnType<typeof useConfirmTargetValuesMutation>;
export type ConfirmTargetValuesMutationResult = Apollo.MutationResult<ConfirmTargetValuesMutation>;
export type ConfirmTargetValuesMutationOptions = Apollo.BaseMutationOptions<ConfirmTargetValuesMutation, ConfirmTargetValuesMutationVariables>;
export const RegenerateAlertsDocument = gql`
    mutation regenerateAlerts($organizationId: ID!) {
  regenerateAlerts(organizationId: $organizationId) {
    ... on Organization {
      ...OrganizationFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type RegenerateAlertsMutationFn = Apollo.MutationFunction<RegenerateAlertsMutation, RegenerateAlertsMutationVariables>;

/**
 * __useRegenerateAlertsMutation__
 *
 * To run a mutation, you first call `useRegenerateAlertsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateAlertsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateAlertsMutation, { data, loading, error }] = useRegenerateAlertsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRegenerateAlertsMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateAlertsMutation, RegenerateAlertsMutationVariables>) {
        return Apollo.useMutation<RegenerateAlertsMutation, RegenerateAlertsMutationVariables>(RegenerateAlertsDocument, baseOptions);
      }
export type RegenerateAlertsMutationHookResult = ReturnType<typeof useRegenerateAlertsMutation>;
export type RegenerateAlertsMutationResult = Apollo.MutationResult<RegenerateAlertsMutation>;
export type RegenerateAlertsMutationOptions = Apollo.BaseMutationOptions<RegenerateAlertsMutation, RegenerateAlertsMutationVariables>;
export const CopySensorCredentialToAllSitesDocument = gql`
    mutation copySensorCredentialToAllSites($input: CopySensorCredentialToAllSitesInput!) {
  copySensorCredentialToAllSites(input: $input) {
    updatedCount
    skippedCount
    updatedSiteNames
    brandsAddedCount
    brandsAddedSiteNames
    error
  }
}
    `;
export type CopySensorCredentialToAllSitesMutationFn = Apollo.MutationFunction<CopySensorCredentialToAllSitesMutation, CopySensorCredentialToAllSitesMutationVariables>;

/**
 * __useCopySensorCredentialToAllSitesMutation__
 *
 * To run a mutation, you first call `useCopySensorCredentialToAllSitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopySensorCredentialToAllSitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copySensorCredentialToAllSitesMutation, { data, loading, error }] = useCopySensorCredentialToAllSitesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopySensorCredentialToAllSitesMutation(baseOptions?: Apollo.MutationHookOptions<CopySensorCredentialToAllSitesMutation, CopySensorCredentialToAllSitesMutationVariables>) {
        return Apollo.useMutation<CopySensorCredentialToAllSitesMutation, CopySensorCredentialToAllSitesMutationVariables>(CopySensorCredentialToAllSitesDocument, baseOptions);
      }
export type CopySensorCredentialToAllSitesMutationHookResult = ReturnType<typeof useCopySensorCredentialToAllSitesMutation>;
export type CopySensorCredentialToAllSitesMutationResult = Apollo.MutationResult<CopySensorCredentialToAllSitesMutation>;
export type CopySensorCredentialToAllSitesMutationOptions = Apollo.BaseMutationOptions<CopySensorCredentialToAllSitesMutation, CopySensorCredentialToAllSitesMutationVariables>;
export const UpdateNotificationPreferenceDocument = gql`
    mutation updateNotificationPreference($input: UpdateNotificationPreferenceInput) {
  updateNotificationPreference(input: $input) {
    ... on OrganizationNotificationPreference {
      id
      reportType
      enabled
      frequency
      sendToAdmins
      sendToCultivationManagers
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdateNotificationPreferenceMutationFn = Apollo.MutationFunction<UpdateNotificationPreferenceMutation, UpdateNotificationPreferenceMutationVariables>;

/**
 * __useUpdateNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationPreferenceMutation, { data, loading, error }] = useUpdateNotificationPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationPreferenceMutation, UpdateNotificationPreferenceMutationVariables>) {
        return Apollo.useMutation<UpdateNotificationPreferenceMutation, UpdateNotificationPreferenceMutationVariables>(UpdateNotificationPreferenceDocument, baseOptions);
      }
export type UpdateNotificationPreferenceMutationHookResult = ReturnType<typeof useUpdateNotificationPreferenceMutation>;
export type UpdateNotificationPreferenceMutationResult = Apollo.MutationResult<UpdateNotificationPreferenceMutation>;
export type UpdateNotificationPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationPreferenceMutation, UpdateNotificationPreferenceMutationVariables>;
export const UpdateUserNotificationPreferenceDocument = gql`
    mutation updateUserNotificationPreference($input: UpdateUserNotificationPreferenceInput!) {
  updateUserNotificationPreference(input: $input) {
    ... on UserNotificationPreference {
      ...UserNotificationPreferenceFields
    }
    ... on Error {
      message
    }
  }
}
    ${UserNotificationPreferenceFieldsFragmentDoc}`;
export type UpdateUserNotificationPreferenceMutationFn = Apollo.MutationFunction<UpdateUserNotificationPreferenceMutation, UpdateUserNotificationPreferenceMutationVariables>;

/**
 * __useUpdateUserNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateUserNotificationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNotificationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNotificationPreferenceMutation, { data, loading, error }] = useUpdateUserNotificationPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserNotificationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserNotificationPreferenceMutation, UpdateUserNotificationPreferenceMutationVariables>) {
        return Apollo.useMutation<UpdateUserNotificationPreferenceMutation, UpdateUserNotificationPreferenceMutationVariables>(UpdateUserNotificationPreferenceDocument, baseOptions);
      }
export type UpdateUserNotificationPreferenceMutationHookResult = ReturnType<typeof useUpdateUserNotificationPreferenceMutation>;
export type UpdateUserNotificationPreferenceMutationResult = Apollo.MutationResult<UpdateUserNotificationPreferenceMutation>;
export type UpdateUserNotificationPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateUserNotificationPreferenceMutation, UpdateUserNotificationPreferenceMutationVariables>;
export const SetOrganizationActiveDocument = gql`
    mutation setOrganizationActive($organizationId: ID!, $active: Boolean!) {
  setOrganizationActive(organizationId: $organizationId, active: $active) {
    ... on Organization {
      id
      deactivatedAt
    }
    ... on Error {
      message
    }
  }
}
    `;
export type SetOrganizationActiveMutationFn = Apollo.MutationFunction<SetOrganizationActiveMutation, SetOrganizationActiveMutationVariables>;

/**
 * __useSetOrganizationActiveMutation__
 *
 * To run a mutation, you first call `useSetOrganizationActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganizationActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganizationActiveMutation, { data, loading, error }] = useSetOrganizationActiveMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSetOrganizationActiveMutation(baseOptions?: Apollo.MutationHookOptions<SetOrganizationActiveMutation, SetOrganizationActiveMutationVariables>) {
        return Apollo.useMutation<SetOrganizationActiveMutation, SetOrganizationActiveMutationVariables>(SetOrganizationActiveDocument, baseOptions);
      }
export type SetOrganizationActiveMutationHookResult = ReturnType<typeof useSetOrganizationActiveMutation>;
export type SetOrganizationActiveMutationResult = Apollo.MutationResult<SetOrganizationActiveMutation>;
export type SetOrganizationActiveMutationOptions = Apollo.BaseMutationOptions<SetOrganizationActiveMutation, SetOrganizationActiveMutationVariables>;
export const CreateSiteDocument = gql`
    mutation createSite($input: CreateSiteInput!) {
  createSite(input: $input) {
    ... on OrganizationSite {
      ...OrganizationSiteFields
    }
    ... on Error {
      message
    }
  }
}
    ${OrganizationSiteFieldsFragmentDoc}`;
export type CreateSiteMutationFn = Apollo.MutationFunction<CreateSiteMutation, CreateSiteMutationVariables>;

/**
 * __useCreateSiteMutation__
 *
 * To run a mutation, you first call `useCreateSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSiteMutation, { data, loading, error }] = useCreateSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSiteMutation(baseOptions?: Apollo.MutationHookOptions<CreateSiteMutation, CreateSiteMutationVariables>) {
        return Apollo.useMutation<CreateSiteMutation, CreateSiteMutationVariables>(CreateSiteDocument, baseOptions);
      }
export type CreateSiteMutationHookResult = ReturnType<typeof useCreateSiteMutation>;
export type CreateSiteMutationResult = Apollo.MutationResult<CreateSiteMutation>;
export type CreateSiteMutationOptions = Apollo.BaseMutationOptions<CreateSiteMutation, CreateSiteMutationVariables>;
export const UpdateSiteDocument = gql`
    mutation updateSite($input: UpdateSiteInput!) {
  updateSite(input: $input) {
    ... on OrganizationSite {
      ...OrganizationSiteFields
    }
  }
}
    ${OrganizationSiteFieldsFragmentDoc}`;
export type UpdateSiteMutationFn = Apollo.MutationFunction<UpdateSiteMutation, UpdateSiteMutationVariables>;

/**
 * __useUpdateSiteMutation__
 *
 * To run a mutation, you first call `useUpdateSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteMutation, { data, loading, error }] = useUpdateSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSiteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteMutation, UpdateSiteMutationVariables>) {
        return Apollo.useMutation<UpdateSiteMutation, UpdateSiteMutationVariables>(UpdateSiteDocument, baseOptions);
      }
export type UpdateSiteMutationHookResult = ReturnType<typeof useUpdateSiteMutation>;
export type UpdateSiteMutationResult = Apollo.MutationResult<UpdateSiteMutation>;
export type UpdateSiteMutationOptions = Apollo.BaseMutationOptions<UpdateSiteMutation, UpdateSiteMutationVariables>;
export const UpdateSiteCredentialsDocument = gql`
    mutation updateSiteCredentials($input: UpdateSiteCredentialsInput!) {
  updateSiteCredentials(input: $input) {
    ... on OrganizationSite {
      ...OrganizationSiteFields
    }
    ... on Error {
      message
    }
  }
}
    ${OrganizationSiteFieldsFragmentDoc}`;
export type UpdateSiteCredentialsMutationFn = Apollo.MutationFunction<UpdateSiteCredentialsMutation, UpdateSiteCredentialsMutationVariables>;

/**
 * __useUpdateSiteCredentialsMutation__
 *
 * To run a mutation, you first call `useUpdateSiteCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteCredentialsMutation, { data, loading, error }] = useUpdateSiteCredentialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSiteCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteCredentialsMutation, UpdateSiteCredentialsMutationVariables>) {
        return Apollo.useMutation<UpdateSiteCredentialsMutation, UpdateSiteCredentialsMutationVariables>(UpdateSiteCredentialsDocument, baseOptions);
      }
export type UpdateSiteCredentialsMutationHookResult = ReturnType<typeof useUpdateSiteCredentialsMutation>;
export type UpdateSiteCredentialsMutationResult = Apollo.MutationResult<UpdateSiteCredentialsMutation>;
export type UpdateSiteCredentialsMutationOptions = Apollo.BaseMutationOptions<UpdateSiteCredentialsMutation, UpdateSiteCredentialsMutationVariables>;
export const AddSiteMetrcLicenseDocument = gql`
    mutation addSiteMetrcLicense($input: AddSiteMetrcLicenseInput!) {
  addSiteMetrcLicense(input: $input) {
    ... on OrganizationSite {
      ...OrganizationSiteFields
    }
    ... on Error {
      message
    }
  }
}
    ${OrganizationSiteFieldsFragmentDoc}`;
export type AddSiteMetrcLicenseMutationFn = Apollo.MutationFunction<AddSiteMetrcLicenseMutation, AddSiteMetrcLicenseMutationVariables>;

/**
 * __useAddSiteMetrcLicenseMutation__
 *
 * To run a mutation, you first call `useAddSiteMetrcLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSiteMetrcLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSiteMetrcLicenseMutation, { data, loading, error }] = useAddSiteMetrcLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSiteMetrcLicenseMutation(baseOptions?: Apollo.MutationHookOptions<AddSiteMetrcLicenseMutation, AddSiteMetrcLicenseMutationVariables>) {
        return Apollo.useMutation<AddSiteMetrcLicenseMutation, AddSiteMetrcLicenseMutationVariables>(AddSiteMetrcLicenseDocument, baseOptions);
      }
export type AddSiteMetrcLicenseMutationHookResult = ReturnType<typeof useAddSiteMetrcLicenseMutation>;
export type AddSiteMetrcLicenseMutationResult = Apollo.MutationResult<AddSiteMetrcLicenseMutation>;
export type AddSiteMetrcLicenseMutationOptions = Apollo.BaseMutationOptions<AddSiteMetrcLicenseMutation, AddSiteMetrcLicenseMutationVariables>;
export const ValidateOrganizationMetrcApiKeyDocument = gql`
    mutation validateOrganizationMetrcApiKey($input: OrganizationMetrcApiKeyInput!) {
  validateOrganizationMetrcApiKey(input: $input) {
    ... on ValidateOrganizationMetrcApiKeySuccess {
      facilities {
        licenseNumber
        siteName
        isConfigured
        willCatchUp
      }
    }
    ... on Error {
      message
    }
  }
}
    `;
export type ValidateOrganizationMetrcApiKeyMutationFn = Apollo.MutationFunction<ValidateOrganizationMetrcApiKeyMutation, ValidateOrganizationMetrcApiKeyMutationVariables>;

/**
 * __useValidateOrganizationMetrcApiKeyMutation__
 *
 * To run a mutation, you first call `useValidateOrganizationMetrcApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateOrganizationMetrcApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateOrganizationMetrcApiKeyMutation, { data, loading, error }] = useValidateOrganizationMetrcApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateOrganizationMetrcApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<ValidateOrganizationMetrcApiKeyMutation, ValidateOrganizationMetrcApiKeyMutationVariables>) {
        return Apollo.useMutation<ValidateOrganizationMetrcApiKeyMutation, ValidateOrganizationMetrcApiKeyMutationVariables>(ValidateOrganizationMetrcApiKeyDocument, baseOptions);
      }
export type ValidateOrganizationMetrcApiKeyMutationHookResult = ReturnType<typeof useValidateOrganizationMetrcApiKeyMutation>;
export type ValidateOrganizationMetrcApiKeyMutationResult = Apollo.MutationResult<ValidateOrganizationMetrcApiKeyMutation>;
export type ValidateOrganizationMetrcApiKeyMutationOptions = Apollo.BaseMutationOptions<ValidateOrganizationMetrcApiKeyMutation, ValidateOrganizationMetrcApiKeyMutationVariables>;
export const RotateOrganizationMetrcApiKeyAndCatchUpDocument = gql`
    mutation rotateOrganizationMetrcApiKeyAndCatchUp($input: OrganizationMetrcApiKeyInput!) {
  rotateOrganizationMetrcApiKeyAndCatchUp(input: $input) {
    ... on RotateOrganizationMetrcApiKeySuccess {
      catchUpQueued
    }
    ... on Error {
      message
    }
  }
}
    `;
export type RotateOrganizationMetrcApiKeyAndCatchUpMutationFn = Apollo.MutationFunction<RotateOrganizationMetrcApiKeyAndCatchUpMutation, RotateOrganizationMetrcApiKeyAndCatchUpMutationVariables>;

/**
 * __useRotateOrganizationMetrcApiKeyAndCatchUpMutation__
 *
 * To run a mutation, you first call `useRotateOrganizationMetrcApiKeyAndCatchUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateOrganizationMetrcApiKeyAndCatchUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateOrganizationMetrcApiKeyAndCatchUpMutation, { data, loading, error }] = useRotateOrganizationMetrcApiKeyAndCatchUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRotateOrganizationMetrcApiKeyAndCatchUpMutation(baseOptions?: Apollo.MutationHookOptions<RotateOrganizationMetrcApiKeyAndCatchUpMutation, RotateOrganizationMetrcApiKeyAndCatchUpMutationVariables>) {
        return Apollo.useMutation<RotateOrganizationMetrcApiKeyAndCatchUpMutation, RotateOrganizationMetrcApiKeyAndCatchUpMutationVariables>(RotateOrganizationMetrcApiKeyAndCatchUpDocument, baseOptions);
      }
export type RotateOrganizationMetrcApiKeyAndCatchUpMutationHookResult = ReturnType<typeof useRotateOrganizationMetrcApiKeyAndCatchUpMutation>;
export type RotateOrganizationMetrcApiKeyAndCatchUpMutationResult = Apollo.MutationResult<RotateOrganizationMetrcApiKeyAndCatchUpMutation>;
export type RotateOrganizationMetrcApiKeyAndCatchUpMutationOptions = Apollo.BaseMutationOptions<RotateOrganizationMetrcApiKeyAndCatchUpMutation, RotateOrganizationMetrcApiKeyAndCatchUpMutationVariables>;
export const AddOrganizationMetrcPackageSourceLicenseDocument = gql`
    mutation addOrganizationMetrcPackageSourceLicense($input: AddOrganizationMetrcPackageSourceLicenseInput!) {
  addOrganizationMetrcPackageSourceLicense(input: $input) {
    ... on OrganizationMetrcLicense {
      ...OrganizationMetrcLicenseFields
    }
    ... on Error {
      message
    }
  }
}
    ${OrganizationMetrcLicenseFieldsFragmentDoc}`;
export type AddOrganizationMetrcPackageSourceLicenseMutationFn = Apollo.MutationFunction<AddOrganizationMetrcPackageSourceLicenseMutation, AddOrganizationMetrcPackageSourceLicenseMutationVariables>;

/**
 * __useAddOrganizationMetrcPackageSourceLicenseMutation__
 *
 * To run a mutation, you first call `useAddOrganizationMetrcPackageSourceLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationMetrcPackageSourceLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationMetrcPackageSourceLicenseMutation, { data, loading, error }] = useAddOrganizationMetrcPackageSourceLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganizationMetrcPackageSourceLicenseMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganizationMetrcPackageSourceLicenseMutation, AddOrganizationMetrcPackageSourceLicenseMutationVariables>) {
        return Apollo.useMutation<AddOrganizationMetrcPackageSourceLicenseMutation, AddOrganizationMetrcPackageSourceLicenseMutationVariables>(AddOrganizationMetrcPackageSourceLicenseDocument, baseOptions);
      }
export type AddOrganizationMetrcPackageSourceLicenseMutationHookResult = ReturnType<typeof useAddOrganizationMetrcPackageSourceLicenseMutation>;
export type AddOrganizationMetrcPackageSourceLicenseMutationResult = Apollo.MutationResult<AddOrganizationMetrcPackageSourceLicenseMutation>;
export type AddOrganizationMetrcPackageSourceLicenseMutationOptions = Apollo.BaseMutationOptions<AddOrganizationMetrcPackageSourceLicenseMutation, AddOrganizationMetrcPackageSourceLicenseMutationVariables>;
export const AddMetrcPackageSourceRelationshipDocument = gql`
    mutation addMetrcPackageSourceRelationship($input: AddMetrcPackageSourceRelationshipInput!) {
  addMetrcPackageSourceRelationship(input: $input) {
    ... on OrganizationMetrcLicenseRelationship {
      ...OrganizationMetrcLicenseRelationshipFields
    }
    ... on Error {
      message
    }
  }
}
    ${OrganizationMetrcLicenseRelationshipFieldsFragmentDoc}`;
export type AddMetrcPackageSourceRelationshipMutationFn = Apollo.MutationFunction<AddMetrcPackageSourceRelationshipMutation, AddMetrcPackageSourceRelationshipMutationVariables>;

/**
 * __useAddMetrcPackageSourceRelationshipMutation__
 *
 * To run a mutation, you first call `useAddMetrcPackageSourceRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMetrcPackageSourceRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMetrcPackageSourceRelationshipMutation, { data, loading, error }] = useAddMetrcPackageSourceRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMetrcPackageSourceRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<AddMetrcPackageSourceRelationshipMutation, AddMetrcPackageSourceRelationshipMutationVariables>) {
        return Apollo.useMutation<AddMetrcPackageSourceRelationshipMutation, AddMetrcPackageSourceRelationshipMutationVariables>(AddMetrcPackageSourceRelationshipDocument, baseOptions);
      }
export type AddMetrcPackageSourceRelationshipMutationHookResult = ReturnType<typeof useAddMetrcPackageSourceRelationshipMutation>;
export type AddMetrcPackageSourceRelationshipMutationResult = Apollo.MutationResult<AddMetrcPackageSourceRelationshipMutation>;
export type AddMetrcPackageSourceRelationshipMutationOptions = Apollo.BaseMutationOptions<AddMetrcPackageSourceRelationshipMutation, AddMetrcPackageSourceRelationshipMutationVariables>;
export const SkipMetrcProcessingConnectionsDocument = gql`
    mutation skipMetrcProcessingConnections($input: SkipMetrcProcessingConnectionsInput!) {
  skipMetrcProcessingConnections(input: $input) {
    ... on OrganizationSite {
      ...OrganizationSiteFields
    }
    ... on Error {
      message
    }
  }
}
    ${OrganizationSiteFieldsFragmentDoc}`;
export type SkipMetrcProcessingConnectionsMutationFn = Apollo.MutationFunction<SkipMetrcProcessingConnectionsMutation, SkipMetrcProcessingConnectionsMutationVariables>;

/**
 * __useSkipMetrcProcessingConnectionsMutation__
 *
 * To run a mutation, you first call `useSkipMetrcProcessingConnectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipMetrcProcessingConnectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipMetrcProcessingConnectionsMutation, { data, loading, error }] = useSkipMetrcProcessingConnectionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSkipMetrcProcessingConnectionsMutation(baseOptions?: Apollo.MutationHookOptions<SkipMetrcProcessingConnectionsMutation, SkipMetrcProcessingConnectionsMutationVariables>) {
        return Apollo.useMutation<SkipMetrcProcessingConnectionsMutation, SkipMetrcProcessingConnectionsMutationVariables>(SkipMetrcProcessingConnectionsDocument, baseOptions);
      }
export type SkipMetrcProcessingConnectionsMutationHookResult = ReturnType<typeof useSkipMetrcProcessingConnectionsMutation>;
export type SkipMetrcProcessingConnectionsMutationResult = Apollo.MutationResult<SkipMetrcProcessingConnectionsMutation>;
export type SkipMetrcProcessingConnectionsMutationOptions = Apollo.BaseMutationOptions<SkipMetrcProcessingConnectionsMutation, SkipMetrcProcessingConnectionsMutationVariables>;
export const RefreshMetrcDataDocument = gql`
    mutation refreshMetrcData($input: RefreshMetrcDataInput!) {
  refreshMetrcData(input: $input) {
    ... on OrganizationSite {
      ...OrganizationSiteFields
    }
  }
}
    ${OrganizationSiteFieldsFragmentDoc}`;
export type RefreshMetrcDataMutationFn = Apollo.MutationFunction<RefreshMetrcDataMutation, RefreshMetrcDataMutationVariables>;

/**
 * __useRefreshMetrcDataMutation__
 *
 * To run a mutation, you first call `useRefreshMetrcDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshMetrcDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshMetrcDataMutation, { data, loading, error }] = useRefreshMetrcDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshMetrcDataMutation(baseOptions?: Apollo.MutationHookOptions<RefreshMetrcDataMutation, RefreshMetrcDataMutationVariables>) {
        return Apollo.useMutation<RefreshMetrcDataMutation, RefreshMetrcDataMutationVariables>(RefreshMetrcDataDocument, baseOptions);
      }
export type RefreshMetrcDataMutationHookResult = ReturnType<typeof useRefreshMetrcDataMutation>;
export type RefreshMetrcDataMutationResult = Apollo.MutationResult<RefreshMetrcDataMutation>;
export type RefreshMetrcDataMutationOptions = Apollo.BaseMutationOptions<RefreshMetrcDataMutation, RefreshMetrcDataMutationVariables>;
export const UpdateSiteSensorBrandsDocument = gql`
    mutation updateSiteSensorBrands($input: UpdateSiteSensorBrandsInput!) {
  updateSiteSensorBrands(input: $input) {
    ... on OrganizationSite {
      id
      sensorBrands {
        id
        brandName
        isActive
      }
    }
    ... on Error {
      message
    }
  }
}
    `;
export type UpdateSiteSensorBrandsMutationFn = Apollo.MutationFunction<UpdateSiteSensorBrandsMutation, UpdateSiteSensorBrandsMutationVariables>;

/**
 * __useUpdateSiteSensorBrandsMutation__
 *
 * To run a mutation, you first call `useUpdateSiteSensorBrandsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteSensorBrandsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteSensorBrandsMutation, { data, loading, error }] = useUpdateSiteSensorBrandsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSiteSensorBrandsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteSensorBrandsMutation, UpdateSiteSensorBrandsMutationVariables>) {
        return Apollo.useMutation<UpdateSiteSensorBrandsMutation, UpdateSiteSensorBrandsMutationVariables>(UpdateSiteSensorBrandsDocument, baseOptions);
      }
export type UpdateSiteSensorBrandsMutationHookResult = ReturnType<typeof useUpdateSiteSensorBrandsMutation>;
export type UpdateSiteSensorBrandsMutationResult = Apollo.MutationResult<UpdateSiteSensorBrandsMutation>;
export type UpdateSiteSensorBrandsMutationOptions = Apollo.BaseMutationOptions<UpdateSiteSensorBrandsMutation, UpdateSiteSensorBrandsMutationVariables>;
export const CompleteMetrcImportReviewDocument = gql`
    mutation completeMetrcImportReview($input: CompleteMetrcImportReviewInput!) {
  completeMetrcImportReview(input: $input) {
    ... on OrganizationSite {
      id
    }
    ... on Error {
      message
    }
  }
}
    `;
export type CompleteMetrcImportReviewMutationFn = Apollo.MutationFunction<CompleteMetrcImportReviewMutation, CompleteMetrcImportReviewMutationVariables>;

/**
 * __useCompleteMetrcImportReviewMutation__
 *
 * To run a mutation, you first call `useCompleteMetrcImportReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteMetrcImportReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeMetrcImportReviewMutation, { data, loading, error }] = useCompleteMetrcImportReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteMetrcImportReviewMutation(baseOptions?: Apollo.MutationHookOptions<CompleteMetrcImportReviewMutation, CompleteMetrcImportReviewMutationVariables>) {
        return Apollo.useMutation<CompleteMetrcImportReviewMutation, CompleteMetrcImportReviewMutationVariables>(CompleteMetrcImportReviewDocument, baseOptions);
      }
export type CompleteMetrcImportReviewMutationHookResult = ReturnType<typeof useCompleteMetrcImportReviewMutation>;
export type CompleteMetrcImportReviewMutationResult = Apollo.MutationResult<CompleteMetrcImportReviewMutation>;
export type CompleteMetrcImportReviewMutationOptions = Apollo.BaseMutationOptions<CompleteMetrcImportReviewMutation, CompleteMetrcImportReviewMutationVariables>;
export const CreateFacilitySurveyDocument = gql`
    mutation createFacilitySurvey($input: CreateFacilitySurveyInput!) {
  createFacilitySurvey(input: $input) {
    ... on FacilitySurvey {
      ...FacilitySurveyFields
    }
    ... on Error {
      message
    }
  }
}
    ${FacilitySurveyFieldsFragmentDoc}`;
export type CreateFacilitySurveyMutationFn = Apollo.MutationFunction<CreateFacilitySurveyMutation, CreateFacilitySurveyMutationVariables>;

/**
 * __useCreateFacilitySurveyMutation__
 *
 * To run a mutation, you first call `useCreateFacilitySurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFacilitySurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFacilitySurveyMutation, { data, loading, error }] = useCreateFacilitySurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFacilitySurveyMutation(baseOptions?: Apollo.MutationHookOptions<CreateFacilitySurveyMutation, CreateFacilitySurveyMutationVariables>) {
        return Apollo.useMutation<CreateFacilitySurveyMutation, CreateFacilitySurveyMutationVariables>(CreateFacilitySurveyDocument, baseOptions);
      }
export type CreateFacilitySurveyMutationHookResult = ReturnType<typeof useCreateFacilitySurveyMutation>;
export type CreateFacilitySurveyMutationResult = Apollo.MutationResult<CreateFacilitySurveyMutation>;
export type CreateFacilitySurveyMutationOptions = Apollo.BaseMutationOptions<CreateFacilitySurveyMutation, CreateFacilitySurveyMutationVariables>;
export const CreateFieldSurveyDocument = gql`
    mutation createFieldSurvey($input: CreateFieldSurveyInput!) {
  createFieldSurvey(input: $input) {
    ... on FieldSurvey {
      ...FieldSurveyFields
    }
    ... on Error {
      message
    }
  }
}
    ${FieldSurveyFieldsFragmentDoc}`;
export type CreateFieldSurveyMutationFn = Apollo.MutationFunction<CreateFieldSurveyMutation, CreateFieldSurveyMutationVariables>;

/**
 * __useCreateFieldSurveyMutation__
 *
 * To run a mutation, you first call `useCreateFieldSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFieldSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFieldSurveyMutation, { data, loading, error }] = useCreateFieldSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFieldSurveyMutation(baseOptions?: Apollo.MutationHookOptions<CreateFieldSurveyMutation, CreateFieldSurveyMutationVariables>) {
        return Apollo.useMutation<CreateFieldSurveyMutation, CreateFieldSurveyMutationVariables>(CreateFieldSurveyDocument, baseOptions);
      }
export type CreateFieldSurveyMutationHookResult = ReturnType<typeof useCreateFieldSurveyMutation>;
export type CreateFieldSurveyMutationResult = Apollo.MutationResult<CreateFieldSurveyMutation>;
export type CreateFieldSurveyMutationOptions = Apollo.BaseMutationOptions<CreateFieldSurveyMutation, CreateFieldSurveyMutationVariables>;
export const CreateRoomSurveyDocument = gql`
    mutation createRoomSurvey($input: CreateRoomSurveyInput!) {
  createRoomSurvey(input: $input) {
    ... on RoomSurvey {
      ...RoomSurveyFields
    }
    ... on Error {
      message
    }
  }
}
    ${RoomSurveyFieldsFragmentDoc}`;
export type CreateRoomSurveyMutationFn = Apollo.MutationFunction<CreateRoomSurveyMutation, CreateRoomSurveyMutationVariables>;

/**
 * __useCreateRoomSurveyMutation__
 *
 * To run a mutation, you first call `useCreateRoomSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoomSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoomSurveyMutation, { data, loading, error }] = useCreateRoomSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoomSurveyMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoomSurveyMutation, CreateRoomSurveyMutationVariables>) {
        return Apollo.useMutation<CreateRoomSurveyMutation, CreateRoomSurveyMutationVariables>(CreateRoomSurveyDocument, baseOptions);
      }
export type CreateRoomSurveyMutationHookResult = ReturnType<typeof useCreateRoomSurveyMutation>;
export type CreateRoomSurveyMutationResult = Apollo.MutationResult<CreateRoomSurveyMutation>;
export type CreateRoomSurveyMutationOptions = Apollo.BaseMutationOptions<CreateRoomSurveyMutation, CreateRoomSurveyMutationVariables>;
export const UpdateRoomSurveyDocument = gql`
    mutation updateRoomSurvey($input: UpdateRoomSurveyInput!) {
  updateRoomSurvey(input: $input) {
    ... on RoomSurvey {
      ...RoomSurveyFields
    }
    ... on Error {
      message
    }
  }
}
    ${RoomSurveyFieldsFragmentDoc}`;
export type UpdateRoomSurveyMutationFn = Apollo.MutationFunction<UpdateRoomSurveyMutation, UpdateRoomSurveyMutationVariables>;

/**
 * __useUpdateRoomSurveyMutation__
 *
 * To run a mutation, you first call `useUpdateRoomSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomSurveyMutation, { data, loading, error }] = useUpdateRoomSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoomSurveyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomSurveyMutation, UpdateRoomSurveyMutationVariables>) {
        return Apollo.useMutation<UpdateRoomSurveyMutation, UpdateRoomSurveyMutationVariables>(UpdateRoomSurveyDocument, baseOptions);
      }
export type UpdateRoomSurveyMutationHookResult = ReturnType<typeof useUpdateRoomSurveyMutation>;
export type UpdateRoomSurveyMutationResult = Apollo.MutationResult<UpdateRoomSurveyMutation>;
export type UpdateRoomSurveyMutationOptions = Apollo.BaseMutationOptions<UpdateRoomSurveyMutation, UpdateRoomSurveyMutationVariables>;
export const UpdateFacilitySurveyDocument = gql`
    mutation updateFacilitySurvey($input: UpdateFacilitySurveyInput!) {
  updateFacilitySurvey(input: $input) {
    ... on FacilitySurvey {
      ...FacilitySurveyFields
    }
    ... on Error {
      message
    }
  }
}
    ${FacilitySurveyFieldsFragmentDoc}`;
export type UpdateFacilitySurveyMutationFn = Apollo.MutationFunction<UpdateFacilitySurveyMutation, UpdateFacilitySurveyMutationVariables>;

/**
 * __useUpdateFacilitySurveyMutation__
 *
 * To run a mutation, you first call `useUpdateFacilitySurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFacilitySurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFacilitySurveyMutation, { data, loading, error }] = useUpdateFacilitySurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFacilitySurveyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFacilitySurveyMutation, UpdateFacilitySurveyMutationVariables>) {
        return Apollo.useMutation<UpdateFacilitySurveyMutation, UpdateFacilitySurveyMutationVariables>(UpdateFacilitySurveyDocument, baseOptions);
      }
export type UpdateFacilitySurveyMutationHookResult = ReturnType<typeof useUpdateFacilitySurveyMutation>;
export type UpdateFacilitySurveyMutationResult = Apollo.MutationResult<UpdateFacilitySurveyMutation>;
export type UpdateFacilitySurveyMutationOptions = Apollo.BaseMutationOptions<UpdateFacilitySurveyMutation, UpdateFacilitySurveyMutationVariables>;
export const CreateToppingStyleDocument = gql`
    mutation createToppingStyle($input: CreateToppingStyleInput!) {
  createToppingStyle(input: $input) {
    ... on ToppingStyle {
      id
      name
    }
    ... on Error {
      message
    }
  }
}
    `;
export type CreateToppingStyleMutationFn = Apollo.MutationFunction<CreateToppingStyleMutation, CreateToppingStyleMutationVariables>;

/**
 * __useCreateToppingStyleMutation__
 *
 * To run a mutation, you first call `useCreateToppingStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateToppingStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createToppingStyleMutation, { data, loading, error }] = useCreateToppingStyleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateToppingStyleMutation(baseOptions?: Apollo.MutationHookOptions<CreateToppingStyleMutation, CreateToppingStyleMutationVariables>) {
        return Apollo.useMutation<CreateToppingStyleMutation, CreateToppingStyleMutationVariables>(CreateToppingStyleDocument, baseOptions);
      }
export type CreateToppingStyleMutationHookResult = ReturnType<typeof useCreateToppingStyleMutation>;
export type CreateToppingStyleMutationResult = Apollo.MutationResult<CreateToppingStyleMutation>;
export type CreateToppingStyleMutationOptions = Apollo.BaseMutationOptions<CreateToppingStyleMutation, CreateToppingStyleMutationVariables>;
export const DeleteToppingStyleDocument = gql`
    mutation deleteToppingStyle($input: DeleteToppingStyleInput!) {
  deleteToppingStyle(input: $input) {
    success
  }
}
    `;
export type DeleteToppingStyleMutationFn = Apollo.MutationFunction<DeleteToppingStyleMutation, DeleteToppingStyleMutationVariables>;

/**
 * __useDeleteToppingStyleMutation__
 *
 * To run a mutation, you first call `useDeleteToppingStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteToppingStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteToppingStyleMutation, { data, loading, error }] = useDeleteToppingStyleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteToppingStyleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteToppingStyleMutation, DeleteToppingStyleMutationVariables>) {
        return Apollo.useMutation<DeleteToppingStyleMutation, DeleteToppingStyleMutationVariables>(DeleteToppingStyleDocument, baseOptions);
      }
export type DeleteToppingStyleMutationHookResult = ReturnType<typeof useDeleteToppingStyleMutation>;
export type DeleteToppingStyleMutationResult = Apollo.MutationResult<DeleteToppingStyleMutation>;
export type DeleteToppingStyleMutationOptions = Apollo.BaseMutationOptions<DeleteToppingStyleMutation, DeleteToppingStyleMutationVariables>;
export const GetSignedUploadUrlDocument = gql`
    mutation getSignedUploadUrl($input: GetSignedUploadURLInput!) {
  getSignedUploadUrl(input: $input) {
    signedUploadUrl
    success
  }
}
    `;
export type GetSignedUploadUrlMutationFn = Apollo.MutationFunction<GetSignedUploadUrlMutation, GetSignedUploadUrlMutationVariables>;

/**
 * __useGetSignedUploadUrlMutation__
 *
 * To run a mutation, you first call `useGetSignedUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSignedUploadUrlMutation, { data, loading, error }] = useGetSignedUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSignedUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetSignedUploadUrlMutation, GetSignedUploadUrlMutationVariables>) {
        return Apollo.useMutation<GetSignedUploadUrlMutation, GetSignedUploadUrlMutationVariables>(GetSignedUploadUrlDocument, baseOptions);
      }
export type GetSignedUploadUrlMutationHookResult = ReturnType<typeof useGetSignedUploadUrlMutation>;
export type GetSignedUploadUrlMutationResult = Apollo.MutationResult<GetSignedUploadUrlMutation>;
export type GetSignedUploadUrlMutationOptions = Apollo.BaseMutationOptions<GetSignedUploadUrlMutation, GetSignedUploadUrlMutationVariables>;
export const UpdateUserActiveDocument = gql`
    mutation updateUserActive($input: UpdateUserActiveInput!) {
  updateUserActive(input: $input) {
    ... on UserProfile {
      ...UserProfile
    }
    ... on Error {
      message
    }
  }
}
    ${UserProfileFragmentDoc}`;
export type UpdateUserActiveMutationFn = Apollo.MutationFunction<UpdateUserActiveMutation, UpdateUserActiveMutationVariables>;

/**
 * __useUpdateUserActiveMutation__
 *
 * To run a mutation, you first call `useUpdateUserActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserActiveMutation, { data, loading, error }] = useUpdateUserActiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserActiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserActiveMutation, UpdateUserActiveMutationVariables>) {
        return Apollo.useMutation<UpdateUserActiveMutation, UpdateUserActiveMutationVariables>(UpdateUserActiveDocument, baseOptions);
      }
export type UpdateUserActiveMutationHookResult = ReturnType<typeof useUpdateUserActiveMutation>;
export type UpdateUserActiveMutationResult = Apollo.MutationResult<UpdateUserActiveMutation>;
export type UpdateUserActiveMutationOptions = Apollo.BaseMutationOptions<UpdateUserActiveMutation, UpdateUserActiveMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    ... on UserProfile {
      ...UserProfile
    }
    ... on Error {
      message
    }
  }
}
    ${UserProfileFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, baseOptions);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    ... on UserProfile {
      ...UserProfile
    }
    ... on Error {
      message
    }
  }
}
    ${UserProfileFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, baseOptions);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const MyProfileDocument = gql`
    query myProfile {
  myProfile {
    ...UserProfile
  }
}
    ${UserProfileFragmentDoc}`;

/**
 * __useMyProfileQuery__
 *
 * To run a query within a React component, call `useMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProfileQuery(baseOptions?: Apollo.QueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
        return Apollo.useQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, baseOptions);
      }
export function useMyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
          return Apollo.useLazyQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, baseOptions);
        }
export type MyProfileQueryHookResult = ReturnType<typeof useMyProfileQuery>;
export type MyProfileLazyQueryHookResult = ReturnType<typeof useMyProfileLazyQuery>;
export type MyProfileQueryResult = Apollo.QueryResult<MyProfileQuery, MyProfileQueryVariables>;
export const UsersDocument = gql`
    query users {
  users {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, baseOptions);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, baseOptions);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const OrganizationUsersAndSitesDocument = gql`
    query organizationUsersAndSites($id: String!) {
  staffOrganization(id: $id) {
    ...StaffOrganizationFields
  }
}
    ${StaffOrganizationFieldsFragmentDoc}`;

/**
 * __useOrganizationUsersAndSitesQuery__
 *
 * To run a query within a React component, call `useOrganizationUsersAndSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUsersAndSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationUsersAndSitesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationUsersAndSitesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationUsersAndSitesQuery, OrganizationUsersAndSitesQueryVariables>) {
        return Apollo.useQuery<OrganizationUsersAndSitesQuery, OrganizationUsersAndSitesQueryVariables>(OrganizationUsersAndSitesDocument, baseOptions);
      }
export function useOrganizationUsersAndSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationUsersAndSitesQuery, OrganizationUsersAndSitesQueryVariables>) {
          return Apollo.useLazyQuery<OrganizationUsersAndSitesQuery, OrganizationUsersAndSitesQueryVariables>(OrganizationUsersAndSitesDocument, baseOptions);
        }
export type OrganizationUsersAndSitesQueryHookResult = ReturnType<typeof useOrganizationUsersAndSitesQuery>;
export type OrganizationUsersAndSitesLazyQueryHookResult = ReturnType<typeof useOrganizationUsersAndSitesLazyQuery>;
export type OrganizationUsersAndSitesQueryResult = Apollo.QueryResult<OrganizationUsersAndSitesQuery, OrganizationUsersAndSitesQueryVariables>;
export const OrganizationOnboardingOverviewDocument = gql`
    query organizationOnboardingOverview($id: String!) {
  staffOrganization(id: $id) {
    id
    deactivatedAt
    name
    timezone
    redesignEnabled
    branding {
      colorPreset
      logoUrl
      logoDarkUrl
      customized
      updatedAt
    }
    apiEnabled
    allowMultisite
    confirmedTargetValues
    alertsRegenerated
    asyncRegenerateAlertsStatus
    asyncRegenerateAlertsProgressPct
    asyncRegenerateAlertsStartedAt
    asyncRegenerateAlertsCompletedAt
    asyncRegenerateAlertsError
    regenerateAlertsEtaSecondsRemaining
    staffUser {
      id
    }
    metrcLicenses {
      ...OrganizationMetrcLicenseFields
    }
    sites {
      id
      name
      metrcLicenseNumber
      metrcUserKey
      metrcState
      asyncImportStatus
      asyncImportStartedAt
      asyncImportCompletedAt
      metrcSyncFloweringDates
      metrcSyncHarvestDates
      metrcProcessingConnectionsSkipped
      metrcLicenses {
        ...OrganizationSiteMetrcLicenseFields
      }
      metrcLicenseRelationships {
        ...OrganizationMetrcLicenseRelationshipFields
      }
      latestMetrcImportBatch {
        ...MetrcSiteImportBatchFields
      }
      metrcImportTask {
        ...MetrcImportTaskFields
      }
      sensorImportTask {
        ...SensorImportTaskFields
      }
      sensorBrands {
        brandName
        isActive
      }
      sensorCredentials {
        ...SensorCredentialFields
      }
      hasConfiguredSensors
      hasEnvironmentalData
      confirmedLightingSchedules
      harvestGroupAutoCreationConfig {
        ...HarvestGroupAutoCreationConfigFields
      }
      importedHarvestGroupCount
      zones {
        id
        name
        active
        metrcId
        roomUsage
        dayStartTime
        nightStartTime
        primaryDevice {
          id
        }
      }
    }
    environmentalTargetSets {
      ...EnvironmentalTargetSetFields
    }
    budFormFactors {
      id
      metrcId
      yieldCount
      active
      sites {
        id
      }
    }
    harvestGroupTemplates {
      id
      name
      archivedAt
      stageTemplates {
        id
        createdStageName
        numberOfDays
        designatedZones {
          id
        }
      }
    }
    users {
      ...UserAttributes
    }
  }
}
    ${OrganizationMetrcLicenseFieldsFragmentDoc}
${OrganizationSiteMetrcLicenseFieldsFragmentDoc}
${OrganizationMetrcLicenseRelationshipFieldsFragmentDoc}
${MetrcSiteImportBatchFieldsFragmentDoc}
${MetrcImportTaskFieldsFragmentDoc}
${SensorImportTaskFieldsFragmentDoc}
${SensorCredentialFieldsFragmentDoc}
${HarvestGroupAutoCreationConfigFieldsFragmentDoc}
${EnvironmentalTargetSetFieldsFragmentDoc}
${UserAttributesFragmentDoc}`;

/**
 * __useOrganizationOnboardingOverviewQuery__
 *
 * To run a query within a React component, call `useOrganizationOnboardingOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationOnboardingOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationOnboardingOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationOnboardingOverviewQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationOnboardingOverviewQuery, OrganizationOnboardingOverviewQueryVariables>) {
        return Apollo.useQuery<OrganizationOnboardingOverviewQuery, OrganizationOnboardingOverviewQueryVariables>(OrganizationOnboardingOverviewDocument, baseOptions);
      }
export function useOrganizationOnboardingOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationOnboardingOverviewQuery, OrganizationOnboardingOverviewQueryVariables>) {
          return Apollo.useLazyQuery<OrganizationOnboardingOverviewQuery, OrganizationOnboardingOverviewQueryVariables>(OrganizationOnboardingOverviewDocument, baseOptions);
        }
export type OrganizationOnboardingOverviewQueryHookResult = ReturnType<typeof useOrganizationOnboardingOverviewQuery>;
export type OrganizationOnboardingOverviewLazyQueryHookResult = ReturnType<typeof useOrganizationOnboardingOverviewLazyQuery>;
export type OrganizationOnboardingOverviewQueryResult = Apollo.QueryResult<OrganizationOnboardingOverviewQuery, OrganizationOnboardingOverviewQueryVariables>;
export const OrganizationUsersDocument = gql`
    query organizationUsers($id: String!) {
  staffOrganization(id: $id) {
    id
    name
    users {
      ...UserAttributes
    }
  }
}
    ${UserAttributesFragmentDoc}`;

/**
 * __useOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationUsersQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationUsersQuery, OrganizationUsersQueryVariables>) {
        return Apollo.useQuery<OrganizationUsersQuery, OrganizationUsersQueryVariables>(OrganizationUsersDocument, baseOptions);
      }
export function useOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationUsersQuery, OrganizationUsersQueryVariables>) {
          return Apollo.useLazyQuery<OrganizationUsersQuery, OrganizationUsersQueryVariables>(OrganizationUsersDocument, baseOptions);
        }
export type OrganizationUsersQueryHookResult = ReturnType<typeof useOrganizationUsersQuery>;
export type OrganizationUsersLazyQueryHookResult = ReturnType<typeof useOrganizationUsersLazyQuery>;
export type OrganizationUsersQueryResult = Apollo.QueryResult<OrganizationUsersQuery, OrganizationUsersQueryVariables>;
export const OrganizationSensorIntegrationDocument = gql`
    query organizationSensorIntegration($id: String!) {
  staffOrganization(id: $id) {
    id
    name
    allowMultisite
    confirmedTargetValues
    staffUser {
      id
    }
    sensorBrands {
      id
      brandName
      isActive
    }
    sites {
      id
      name
      sensorBrands {
        id
        brandName
        isActive
      }
      sensorImportTask {
        ...SensorImportTaskFields
      }
      sensorCredentials {
        ...SensorCredentialFields
      }
      zones {
        id
        name
        lightingClassification
        dayStartTime
        nightStartTime
        active
      }
    }
    environmentalTargetSets {
      ...EnvironmentalTargetSetFields
    }
  }
}
    ${SensorImportTaskFieldsFragmentDoc}
${SensorCredentialFieldsFragmentDoc}
${EnvironmentalTargetSetFieldsFragmentDoc}`;

/**
 * __useOrganizationSensorIntegrationQuery__
 *
 * To run a query within a React component, call `useOrganizationSensorIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSensorIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSensorIntegrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationSensorIntegrationQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationSensorIntegrationQuery, OrganizationSensorIntegrationQueryVariables>) {
        return Apollo.useQuery<OrganizationSensorIntegrationQuery, OrganizationSensorIntegrationQueryVariables>(OrganizationSensorIntegrationDocument, baseOptions);
      }
export function useOrganizationSensorIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSensorIntegrationQuery, OrganizationSensorIntegrationQueryVariables>) {
          return Apollo.useLazyQuery<OrganizationSensorIntegrationQuery, OrganizationSensorIntegrationQueryVariables>(OrganizationSensorIntegrationDocument, baseOptions);
        }
export type OrganizationSensorIntegrationQueryHookResult = ReturnType<typeof useOrganizationSensorIntegrationQuery>;
export type OrganizationSensorIntegrationLazyQueryHookResult = ReturnType<typeof useOrganizationSensorIntegrationLazyQuery>;
export type OrganizationSensorIntegrationQueryResult = Apollo.QueryResult<OrganizationSensorIntegrationQuery, OrganizationSensorIntegrationQueryVariables>;
export const OrganizationSensorDashboardDocument = gql`
    query organizationSensorDashboard($id: String!) {
  staffOrganization(id: $id) {
    id
    name
    confirmedTargetValues
    staffUser {
      id
    }
    environmentalTargetSets {
      ...EnvironmentalTargetSetFields
    }
    users {
      id
      email
      firstName
      lastName
      role {
        id
        name
      }
    }
    sites {
      id
      name
      sensorBrands {
        id
        brandName
        isActive
      }
      sensorCredentials {
        ...SensorCredentialFields
      }
      sensorImportTask {
        ...SensorImportTaskFields
      }
    }
  }
}
    ${EnvironmentalTargetSetFieldsFragmentDoc}
${SensorCredentialFieldsFragmentDoc}
${SensorImportTaskFieldsFragmentDoc}`;

/**
 * __useOrganizationSensorDashboardQuery__
 *
 * To run a query within a React component, call `useOrganizationSensorDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSensorDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSensorDashboardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationSensorDashboardQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationSensorDashboardQuery, OrganizationSensorDashboardQueryVariables>) {
        return Apollo.useQuery<OrganizationSensorDashboardQuery, OrganizationSensorDashboardQueryVariables>(OrganizationSensorDashboardDocument, baseOptions);
      }
export function useOrganizationSensorDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSensorDashboardQuery, OrganizationSensorDashboardQueryVariables>) {
          return Apollo.useLazyQuery<OrganizationSensorDashboardQuery, OrganizationSensorDashboardQueryVariables>(OrganizationSensorDashboardDocument, baseOptions);
        }
export type OrganizationSensorDashboardQueryHookResult = ReturnType<typeof useOrganizationSensorDashboardQuery>;
export type OrganizationSensorDashboardLazyQueryHookResult = ReturnType<typeof useOrganizationSensorDashboardLazyQuery>;
export type OrganizationSensorDashboardQueryResult = Apollo.QueryResult<OrganizationSensorDashboardQuery, OrganizationSensorDashboardQueryVariables>;
export const SiteSensorIntegrationDocument = gql`
    query siteSensorIntegration($siteId: String!, $organizationId: String) {
  organizationSite(id: $siteId, organizationId: $organizationId) {
    id
    name
    organization {
      id
      name
      timezone
      staffUser {
        id
      }
    }
    zones {
      id
      name
      lightingClassification
      roomUsage
      dayStartTime
      nightStartTime
      active
      primaryDevice {
        id
      }
    }
    sensorBrands {
      id
      brandName
      isActive
    }
    sensorCredentials {
      ...SensorCredentialFields
    }
    importedHarvestGroupCount
    confirmedLightingSchedules
    sensorImportTask {
      ...SensorImportTaskFields
    }
  }
}
    ${SensorCredentialFieldsFragmentDoc}
${SensorImportTaskFieldsFragmentDoc}`;

/**
 * __useSiteSensorIntegrationQuery__
 *
 * To run a query within a React component, call `useSiteSensorIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteSensorIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSensorIntegrationQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSiteSensorIntegrationQuery(baseOptions?: Apollo.QueryHookOptions<SiteSensorIntegrationQuery, SiteSensorIntegrationQueryVariables>) {
        return Apollo.useQuery<SiteSensorIntegrationQuery, SiteSensorIntegrationQueryVariables>(SiteSensorIntegrationDocument, baseOptions);
      }
export function useSiteSensorIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteSensorIntegrationQuery, SiteSensorIntegrationQueryVariables>) {
          return Apollo.useLazyQuery<SiteSensorIntegrationQuery, SiteSensorIntegrationQueryVariables>(SiteSensorIntegrationDocument, baseOptions);
        }
export type SiteSensorIntegrationQueryHookResult = ReturnType<typeof useSiteSensorIntegrationQuery>;
export type SiteSensorIntegrationLazyQueryHookResult = ReturnType<typeof useSiteSensorIntegrationLazyQuery>;
export type SiteSensorIntegrationQueryResult = Apollo.QueryResult<SiteSensorIntegrationQuery, SiteSensorIntegrationQueryVariables>;
export const FieldAgentsDocument = gql`
    query fieldAgents($siteId: ID) {
  fieldAgents(siteId: $siteId) {
    id
    agentId
    label
    vendor
    hostname
    localIp
    subnet
    softwareVersion
    status
    isStale
    isActive
    lastSeenAt
    latestStatusPayload
    devices {
      id
      vendor
      controllerId
      modbusAddress
      deviceName
      deviceType
      lastSeenAt
      lastMetrics
      sensorDevice {
        id
        name
        zone {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFieldAgentsQuery__
 *
 * To run a query within a React component, call `useFieldAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldAgentsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useFieldAgentsQuery(baseOptions?: Apollo.QueryHookOptions<FieldAgentsQuery, FieldAgentsQueryVariables>) {
        return Apollo.useQuery<FieldAgentsQuery, FieldAgentsQueryVariables>(FieldAgentsDocument, baseOptions);
      }
export function useFieldAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldAgentsQuery, FieldAgentsQueryVariables>) {
          return Apollo.useLazyQuery<FieldAgentsQuery, FieldAgentsQueryVariables>(FieldAgentsDocument, baseOptions);
        }
export type FieldAgentsQueryHookResult = ReturnType<typeof useFieldAgentsQuery>;
export type FieldAgentsLazyQueryHookResult = ReturnType<typeof useFieldAgentsLazyQuery>;
export type FieldAgentsQueryResult = Apollo.QueryResult<FieldAgentsQuery, FieldAgentsQueryVariables>;
export const OrganizationNameDocument = gql`
    query organizationName($id: String!) {
  staffOrganization(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useOrganizationNameQuery__
 *
 * To run a query within a React component, call `useOrganizationNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationNameQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationNameQuery, OrganizationNameQueryVariables>) {
        return Apollo.useQuery<OrganizationNameQuery, OrganizationNameQueryVariables>(OrganizationNameDocument, baseOptions);
      }
export function useOrganizationNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationNameQuery, OrganizationNameQueryVariables>) {
          return Apollo.useLazyQuery<OrganizationNameQuery, OrganizationNameQueryVariables>(OrganizationNameDocument, baseOptions);
        }
export type OrganizationNameQueryHookResult = ReturnType<typeof useOrganizationNameQuery>;
export type OrganizationNameLazyQueryHookResult = ReturnType<typeof useOrganizationNameLazyQuery>;
export type OrganizationNameQueryResult = Apollo.QueryResult<OrganizationNameQuery, OrganizationNameQueryVariables>;
export const OrganizationSiteDocument = gql`
    query organizationSite($id: String!, $organizationId: String) {
  organizationSite(id: $id, organizationId: $organizationId) {
    ...OrganizationSiteFields
    organization {
      id
      name
    }
  }
}
    ${OrganizationSiteFieldsFragmentDoc}`;

/**
 * __useOrganizationSiteQuery__
 *
 * To run a query within a React component, call `useOrganizationSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSiteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationSiteQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationSiteQuery, OrganizationSiteQueryVariables>) {
        return Apollo.useQuery<OrganizationSiteQuery, OrganizationSiteQueryVariables>(OrganizationSiteDocument, baseOptions);
      }
export function useOrganizationSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSiteQuery, OrganizationSiteQueryVariables>) {
          return Apollo.useLazyQuery<OrganizationSiteQuery, OrganizationSiteQueryVariables>(OrganizationSiteDocument, baseOptions);
        }
export type OrganizationSiteQueryHookResult = ReturnType<typeof useOrganizationSiteQuery>;
export type OrganizationSiteLazyQueryHookResult = ReturnType<typeof useOrganizationSiteLazyQuery>;
export type OrganizationSiteQueryResult = Apollo.QueryResult<OrganizationSiteQuery, OrganizationSiteQueryVariables>;
export const EnvironmentalTargetSetsDocument = gql`
    query environmentalTargetSets($organizationId: ID!) {
  environmentalTargetSets(organizationId: $organizationId) {
    ...EnvironmentalTargetSetFields
  }
}
    ${EnvironmentalTargetSetFieldsFragmentDoc}`;

/**
 * __useEnvironmentalTargetSetsQuery__
 *
 * To run a query within a React component, call `useEnvironmentalTargetSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentalTargetSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentalTargetSetsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEnvironmentalTargetSetsQuery(baseOptions?: Apollo.QueryHookOptions<EnvironmentalTargetSetsQuery, EnvironmentalTargetSetsQueryVariables>) {
        return Apollo.useQuery<EnvironmentalTargetSetsQuery, EnvironmentalTargetSetsQueryVariables>(EnvironmentalTargetSetsDocument, baseOptions);
      }
export function useEnvironmentalTargetSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentalTargetSetsQuery, EnvironmentalTargetSetsQueryVariables>) {
          return Apollo.useLazyQuery<EnvironmentalTargetSetsQuery, EnvironmentalTargetSetsQueryVariables>(EnvironmentalTargetSetsDocument, baseOptions);
        }
export type EnvironmentalTargetSetsQueryHookResult = ReturnType<typeof useEnvironmentalTargetSetsQuery>;
export type EnvironmentalTargetSetsLazyQueryHookResult = ReturnType<typeof useEnvironmentalTargetSetsLazyQuery>;
export type EnvironmentalTargetSetsQueryResult = Apollo.QueryResult<EnvironmentalTargetSetsQuery, EnvironmentalTargetSetsQueryVariables>;
export const OrganizationSetPointsDocument = gql`
    query organizationSetPoints($id: String!) {
  staffOrganization(id: $id) {
    id
    name
    confirmedTargetValues
    environmentalTargetSets {
      ...EnvironmentalTargetSetFields
    }
    sites {
      id
      sensorImportTask {
        analysisResult
      }
    }
  }
}
    ${EnvironmentalTargetSetFieldsFragmentDoc}`;

/**
 * __useOrganizationSetPointsQuery__
 *
 * To run a query within a React component, call `useOrganizationSetPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSetPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSetPointsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationSetPointsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationSetPointsQuery, OrganizationSetPointsQueryVariables>) {
        return Apollo.useQuery<OrganizationSetPointsQuery, OrganizationSetPointsQueryVariables>(OrganizationSetPointsDocument, baseOptions);
      }
export function useOrganizationSetPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSetPointsQuery, OrganizationSetPointsQueryVariables>) {
          return Apollo.useLazyQuery<OrganizationSetPointsQuery, OrganizationSetPointsQueryVariables>(OrganizationSetPointsDocument, baseOptions);
        }
export type OrganizationSetPointsQueryHookResult = ReturnType<typeof useOrganizationSetPointsQuery>;
export type OrganizationSetPointsLazyQueryHookResult = ReturnType<typeof useOrganizationSetPointsLazyQuery>;
export type OrganizationSetPointsQueryResult = Apollo.QueryResult<OrganizationSetPointsQuery, OrganizationSetPointsQueryVariables>;
export const HarvestGroupEnvironmentalInfoDocument = gql`
    query harvestGroupEnvironmentalInfo($id: String!) {
  harvestGroup(id: $id) {
    id
    name
    colorHexCode
    stages {
      id
      name
      environmentalTargetType
      zone {
        id
        lightingClassification
        dayStartTime
        nightStartTime
      }
    }
    site {
      id
      organization {
        id
        environmentalTargetSets {
          ...EnvironmentalTargetSetFields
        }
      }
    }
  }
}
    ${EnvironmentalTargetSetFieldsFragmentDoc}`;

/**
 * __useHarvestGroupEnvironmentalInfoQuery__
 *
 * To run a query within a React component, call `useHarvestGroupEnvironmentalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHarvestGroupEnvironmentalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHarvestGroupEnvironmentalInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHarvestGroupEnvironmentalInfoQuery(baseOptions?: Apollo.QueryHookOptions<HarvestGroupEnvironmentalInfoQuery, HarvestGroupEnvironmentalInfoQueryVariables>) {
        return Apollo.useQuery<HarvestGroupEnvironmentalInfoQuery, HarvestGroupEnvironmentalInfoQueryVariables>(HarvestGroupEnvironmentalInfoDocument, baseOptions);
      }
export function useHarvestGroupEnvironmentalInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HarvestGroupEnvironmentalInfoQuery, HarvestGroupEnvironmentalInfoQueryVariables>) {
          return Apollo.useLazyQuery<HarvestGroupEnvironmentalInfoQuery, HarvestGroupEnvironmentalInfoQueryVariables>(HarvestGroupEnvironmentalInfoDocument, baseOptions);
        }
export type HarvestGroupEnvironmentalInfoQueryHookResult = ReturnType<typeof useHarvestGroupEnvironmentalInfoQuery>;
export type HarvestGroupEnvironmentalInfoLazyQueryHookResult = ReturnType<typeof useHarvestGroupEnvironmentalInfoLazyQuery>;
export type HarvestGroupEnvironmentalInfoQueryResult = Apollo.QueryResult<HarvestGroupEnvironmentalInfoQuery, HarvestGroupEnvironmentalInfoQueryVariables>;
export const OrganizationSiteNameDocument = gql`
    query organizationSiteName($id: String!, $organizationId: String) {
  organizationSite(id: $id, organizationId: $organizationId) {
    id
    name
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useOrganizationSiteNameQuery__
 *
 * To run a query within a React component, call `useOrganizationSiteNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSiteNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSiteNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationSiteNameQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationSiteNameQuery, OrganizationSiteNameQueryVariables>) {
        return Apollo.useQuery<OrganizationSiteNameQuery, OrganizationSiteNameQueryVariables>(OrganizationSiteNameDocument, baseOptions);
      }
export function useOrganizationSiteNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSiteNameQuery, OrganizationSiteNameQueryVariables>) {
          return Apollo.useLazyQuery<OrganizationSiteNameQuery, OrganizationSiteNameQueryVariables>(OrganizationSiteNameDocument, baseOptions);
        }
export type OrganizationSiteNameQueryHookResult = ReturnType<typeof useOrganizationSiteNameQuery>;
export type OrganizationSiteNameLazyQueryHookResult = ReturnType<typeof useOrganizationSiteNameLazyQuery>;
export type OrganizationSiteNameQueryResult = Apollo.QueryResult<OrganizationSiteNameQuery, OrganizationSiteNameQueryVariables>;
export const SiteEnabledChecklistTypesDocument = gql`
    query siteEnabledChecklistTypes($id: String!) {
  organizationSite(id: $id) {
    id
    name
    enabledChecklistTypes
  }
}
    `;

/**
 * __useSiteEnabledChecklistTypesQuery__
 *
 * To run a query within a React component, call `useSiteEnabledChecklistTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteEnabledChecklistTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteEnabledChecklistTypesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSiteEnabledChecklistTypesQuery(baseOptions?: Apollo.QueryHookOptions<SiteEnabledChecklistTypesQuery, SiteEnabledChecklistTypesQueryVariables>) {
        return Apollo.useQuery<SiteEnabledChecklistTypesQuery, SiteEnabledChecklistTypesQueryVariables>(SiteEnabledChecklistTypesDocument, baseOptions);
      }
export function useSiteEnabledChecklistTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteEnabledChecklistTypesQuery, SiteEnabledChecklistTypesQueryVariables>) {
          return Apollo.useLazyQuery<SiteEnabledChecklistTypesQuery, SiteEnabledChecklistTypesQueryVariables>(SiteEnabledChecklistTypesDocument, baseOptions);
        }
export type SiteEnabledChecklistTypesQueryHookResult = ReturnType<typeof useSiteEnabledChecklistTypesQuery>;
export type SiteEnabledChecklistTypesLazyQueryHookResult = ReturnType<typeof useSiteEnabledChecklistTypesLazyQuery>;
export type SiteEnabledChecklistTypesQueryResult = Apollo.QueryResult<SiteEnabledChecklistTypesQuery, SiteEnabledChecklistTypesQueryVariables>;
export const ActiveUsersDocument = gql`
    query activeUsers {
  activeUsers {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useActiveUsersQuery__
 *
 * To run a query within a React component, call `useActiveUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveUsersQuery(baseOptions?: Apollo.QueryHookOptions<ActiveUsersQuery, ActiveUsersQueryVariables>) {
        return Apollo.useQuery<ActiveUsersQuery, ActiveUsersQueryVariables>(ActiveUsersDocument, baseOptions);
      }
export function useActiveUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveUsersQuery, ActiveUsersQueryVariables>) {
          return Apollo.useLazyQuery<ActiveUsersQuery, ActiveUsersQueryVariables>(ActiveUsersDocument, baseOptions);
        }
export type ActiveUsersQueryHookResult = ReturnType<typeof useActiveUsersQuery>;
export type ActiveUsersLazyQueryHookResult = ReturnType<typeof useActiveUsersLazyQuery>;
export type ActiveUsersQueryResult = Apollo.QueryResult<ActiveUsersQuery, ActiveUsersQueryVariables>;
export const UserManagementRowsDocument = gql`
    query userManagementRows($filters: UserFilterSetInput) {
  users(filters: $filters) {
    ...UserAttributes
  }
}
    ${UserAttributesFragmentDoc}`;

/**
 * __useUserManagementRowsQuery__
 *
 * To run a query within a React component, call `useUserManagementRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserManagementRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserManagementRowsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUserManagementRowsQuery(baseOptions?: Apollo.QueryHookOptions<UserManagementRowsQuery, UserManagementRowsQueryVariables>) {
        return Apollo.useQuery<UserManagementRowsQuery, UserManagementRowsQueryVariables>(UserManagementRowsDocument, baseOptions);
      }
export function useUserManagementRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserManagementRowsQuery, UserManagementRowsQueryVariables>) {
          return Apollo.useLazyQuery<UserManagementRowsQuery, UserManagementRowsQueryVariables>(UserManagementRowsDocument, baseOptions);
        }
export type UserManagementRowsQueryHookResult = ReturnType<typeof useUserManagementRowsQuery>;
export type UserManagementRowsLazyQueryHookResult = ReturnType<typeof useUserManagementRowsLazyQuery>;
export type UserManagementRowsQueryResult = Apollo.QueryResult<UserManagementRowsQuery, UserManagementRowsQueryVariables>;
export const RolesDocument = gql`
    query roles {
  roles {
    id
    name
    permissions
  }
}
    `;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, baseOptions);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, baseOptions);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const OrganizationRolesDocument = gql`
    query organizationRoles($organizationId: String!) {
  organizationRoles(organizationId: $organizationId) {
    id
    name
    permissions
  }
}
    `;

/**
 * __useOrganizationRolesQuery__
 *
 * To run a query within a React component, call `useOrganizationRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRolesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationRolesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationRolesQuery, OrganizationRolesQueryVariables>) {
        return Apollo.useQuery<OrganizationRolesQuery, OrganizationRolesQueryVariables>(OrganizationRolesDocument, baseOptions);
      }
export function useOrganizationRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationRolesQuery, OrganizationRolesQueryVariables>) {
          return Apollo.useLazyQuery<OrganizationRolesQuery, OrganizationRolesQueryVariables>(OrganizationRolesDocument, baseOptions);
        }
export type OrganizationRolesQueryHookResult = ReturnType<typeof useOrganizationRolesQuery>;
export type OrganizationRolesLazyQueryHookResult = ReturnType<typeof useOrganizationRolesLazyQuery>;
export type OrganizationRolesQueryResult = Apollo.QueryResult<OrganizationRolesQuery, OrganizationRolesQueryVariables>;
export const ToppingStylesDocument = gql`
    query toppingStyles {
  toppingStyles {
    id
    name
  }
}
    `;

/**
 * __useToppingStylesQuery__
 *
 * To run a query within a React component, call `useToppingStylesQuery` and pass it any options that fit your needs.
 * When your component renders, `useToppingStylesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToppingStylesQuery({
 *   variables: {
 *   },
 * });
 */
export function useToppingStylesQuery(baseOptions?: Apollo.QueryHookOptions<ToppingStylesQuery, ToppingStylesQueryVariables>) {
        return Apollo.useQuery<ToppingStylesQuery, ToppingStylesQueryVariables>(ToppingStylesDocument, baseOptions);
      }
export function useToppingStylesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ToppingStylesQuery, ToppingStylesQueryVariables>) {
          return Apollo.useLazyQuery<ToppingStylesQuery, ToppingStylesQueryVariables>(ToppingStylesDocument, baseOptions);
        }
export type ToppingStylesQueryHookResult = ReturnType<typeof useToppingStylesQuery>;
export type ToppingStylesLazyQueryHookResult = ReturnType<typeof useToppingStylesLazyQuery>;
export type ToppingStylesQueryResult = Apollo.QueryResult<ToppingStylesQuery, ToppingStylesQueryVariables>;
export const StaffOrganizationsDocument = gql`
    query staffOrganizations($filters: OrganizationFilterSetInput) {
  staffOrganizations(filters: $filters) {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;

/**
 * __useStaffOrganizationsQuery__
 *
 * To run a query within a React component, call `useStaffOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffOrganizationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useStaffOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<StaffOrganizationsQuery, StaffOrganizationsQueryVariables>) {
        return Apollo.useQuery<StaffOrganizationsQuery, StaffOrganizationsQueryVariables>(StaffOrganizationsDocument, baseOptions);
      }
export function useStaffOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaffOrganizationsQuery, StaffOrganizationsQueryVariables>) {
          return Apollo.useLazyQuery<StaffOrganizationsQuery, StaffOrganizationsQueryVariables>(StaffOrganizationsDocument, baseOptions);
        }
export type StaffOrganizationsQueryHookResult = ReturnType<typeof useStaffOrganizationsQuery>;
export type StaffOrganizationsLazyQueryHookResult = ReturnType<typeof useStaffOrganizationsLazyQuery>;
export type StaffOrganizationsQueryResult = Apollo.QueryResult<StaffOrganizationsQuery, StaffOrganizationsQueryVariables>;
export const OrganizationSitesDocument = gql`
    query organizationSites {
  organizationSites {
    id
    name
  }
}
    `;

/**
 * __useOrganizationSitesQuery__
 *
 * To run a query within a React component, call `useOrganizationSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationSitesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationSitesQuery, OrganizationSitesQueryVariables>) {
        return Apollo.useQuery<OrganizationSitesQuery, OrganizationSitesQueryVariables>(OrganizationSitesDocument, baseOptions);
      }
export function useOrganizationSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSitesQuery, OrganizationSitesQueryVariables>) {
          return Apollo.useLazyQuery<OrganizationSitesQuery, OrganizationSitesQueryVariables>(OrganizationSitesDocument, baseOptions);
        }
export type OrganizationSitesQueryHookResult = ReturnType<typeof useOrganizationSitesQuery>;
export type OrganizationSitesLazyQueryHookResult = ReturnType<typeof useOrganizationSitesLazyQuery>;
export type OrganizationSitesQueryResult = Apollo.QueryResult<OrganizationSitesQuery, OrganizationSitesQueryVariables>;
export const StaffOrganizationsTableViewDocument = gql`
    query staffOrganizationsTableView($filters: OrganizationFilterSetInput) {
  staffOrganizations(filters: $filters) {
    id
    name
    accountType
    metrcImportCompleted
    hasEnvironmentalDevices
    sensorBrands {
      id
      brandName
      isActive
    }
    checklist {
      checklistTasks {
        ...ChecklistTaskFields
      }
    }
    staffUser {
      id
    }
    users {
      id
      firstName
      lastName
      role {
        id
        name
      }
    }
  }
}
    ${ChecklistTaskFieldsFragmentDoc}`;

/**
 * __useStaffOrganizationsTableViewQuery__
 *
 * To run a query within a React component, call `useStaffOrganizationsTableViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffOrganizationsTableViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffOrganizationsTableViewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useStaffOrganizationsTableViewQuery(baseOptions?: Apollo.QueryHookOptions<StaffOrganizationsTableViewQuery, StaffOrganizationsTableViewQueryVariables>) {
        return Apollo.useQuery<StaffOrganizationsTableViewQuery, StaffOrganizationsTableViewQueryVariables>(StaffOrganizationsTableViewDocument, baseOptions);
      }
export function useStaffOrganizationsTableViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaffOrganizationsTableViewQuery, StaffOrganizationsTableViewQueryVariables>) {
          return Apollo.useLazyQuery<StaffOrganizationsTableViewQuery, StaffOrganizationsTableViewQueryVariables>(StaffOrganizationsTableViewDocument, baseOptions);
        }
export type StaffOrganizationsTableViewQueryHookResult = ReturnType<typeof useStaffOrganizationsTableViewQuery>;
export type StaffOrganizationsTableViewLazyQueryHookResult = ReturnType<typeof useStaffOrganizationsTableViewLazyQuery>;
export type StaffOrganizationsTableViewQueryResult = Apollo.QueryResult<StaffOrganizationsTableViewQuery, StaffOrganizationsTableViewQueryVariables>;
export const StaffOrganizationDocument = gql`
    query staffOrganization($id: String!) {
  staffOrganization(id: $id) {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;

/**
 * __useStaffOrganizationQuery__
 *
 * To run a query within a React component, call `useStaffOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStaffOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<StaffOrganizationQuery, StaffOrganizationQueryVariables>) {
        return Apollo.useQuery<StaffOrganizationQuery, StaffOrganizationQueryVariables>(StaffOrganizationDocument, baseOptions);
      }
export function useStaffOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaffOrganizationQuery, StaffOrganizationQueryVariables>) {
          return Apollo.useLazyQuery<StaffOrganizationQuery, StaffOrganizationQueryVariables>(StaffOrganizationDocument, baseOptions);
        }
export type StaffOrganizationQueryHookResult = ReturnType<typeof useStaffOrganizationQuery>;
export type StaffOrganizationLazyQueryHookResult = ReturnType<typeof useStaffOrganizationLazyQuery>;
export type StaffOrganizationQueryResult = Apollo.QueryResult<StaffOrganizationQuery, StaffOrganizationQueryVariables>;
export const MyOrganizationPageDocument = gql`
    query myOrganizationPage($id: String!) {
  staffOrganization(id: $id) {
    ...MyOrganizationPageFields
  }
}
    ${MyOrganizationPageFieldsFragmentDoc}`;

/**
 * __useMyOrganizationPageQuery__
 *
 * To run a query within a React component, call `useMyOrganizationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOrganizationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOrganizationPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyOrganizationPageQuery(baseOptions?: Apollo.QueryHookOptions<MyOrganizationPageQuery, MyOrganizationPageQueryVariables>) {
        return Apollo.useQuery<MyOrganizationPageQuery, MyOrganizationPageQueryVariables>(MyOrganizationPageDocument, baseOptions);
      }
export function useMyOrganizationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyOrganizationPageQuery, MyOrganizationPageQueryVariables>) {
          return Apollo.useLazyQuery<MyOrganizationPageQuery, MyOrganizationPageQueryVariables>(MyOrganizationPageDocument, baseOptions);
        }
export type MyOrganizationPageQueryHookResult = ReturnType<typeof useMyOrganizationPageQuery>;
export type MyOrganizationPageLazyQueryHookResult = ReturnType<typeof useMyOrganizationPageLazyQuery>;
export type MyOrganizationPageQueryResult = Apollo.QueryResult<MyOrganizationPageQuery, MyOrganizationPageQueryVariables>;
export const VerifyMetrcImportDocument = gql`
    query verifyMetrcImport($siteId: ID!) {
  verifyMetrcImport(siteId: $siteId) {
    newStrains {
      name
      sativaPercentage
      indicaPercentage
      metrcId
      existingStrain {
        id
        name
      }
    }
    newLocations {
      name
      metrcId
      isImported
      hasFloweringPlants
      existingLocation {
        id
        name
        metrcId
        lightingClassification
        roomUsage
      }
    }
    newBudFormFactors {
      name
      classification
      packageCount
      existingBff
      existingBffOrder
      sampleItemNames
    }
    existingBudFormFactors {
      id
      name
      active
      classification
      yieldCount
      metrcId
      orderPosition
    }
    rotationAnalysis {
      source
      rotationOrder
      intervalDays
      flowerRooms {
        dateSource
        name
        floweringDate
      }
    }
    bffDebug {
      formFactors {
        name
        classification
        totalWeightG
        packageCount
        harvestCount
        sampleItemNames
      }
      failedExtractions {
        itemName
        category
        weightG
      }
    }
  }
}
    `;

/**
 * __useVerifyMetrcImportQuery__
 *
 * To run a query within a React component, call `useVerifyMetrcImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyMetrcImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyMetrcImportQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useVerifyMetrcImportQuery(baseOptions?: Apollo.QueryHookOptions<VerifyMetrcImportQuery, VerifyMetrcImportQueryVariables>) {
        return Apollo.useQuery<VerifyMetrcImportQuery, VerifyMetrcImportQueryVariables>(VerifyMetrcImportDocument, baseOptions);
      }
export function useVerifyMetrcImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyMetrcImportQuery, VerifyMetrcImportQueryVariables>) {
          return Apollo.useLazyQuery<VerifyMetrcImportQuery, VerifyMetrcImportQueryVariables>(VerifyMetrcImportDocument, baseOptions);
        }
export type VerifyMetrcImportQueryHookResult = ReturnType<typeof useVerifyMetrcImportQuery>;
export type VerifyMetrcImportLazyQueryHookResult = ReturnType<typeof useVerifyMetrcImportLazyQuery>;
export type VerifyMetrcImportQueryResult = Apollo.QueryResult<VerifyMetrcImportQuery, VerifyMetrcImportQueryVariables>;
export const MetrcImportOverviewV2Document = gql`
    query metrcImportOverviewV2($siteId: ID!) {
  metrcImportOverviewV2(siteId: $siteId) {
    siteId
    ready
    lastAnalyzedAt
    harvestsAnalyzedCount
    totalHarvests
    totalPackages
    totalStrains
    totalLocations
    totalFloweringPlants
    dateRangeStart
    dateRangeEnd
    locations {
      name
      metrcId
      zoneId
      metrcSourceCount
      hasFloweringPlants
      guessedUsage
    }
    strainNames
    strains {
      name
      pdsStrainId
      metrcSourceCount
      imported
    }
    newStrainCount
    existingStrainCount
    harvestGroups {
      proposedGroupId
      createdHgId
      kind
      name
      harvestDate
      assignedFlowerRoom
      strainNames
      totalWetWeightG
      totalPackagedWeightG
      pkgWetPct
      yieldCoveragePct
      productStreams {
        dryToWetBasis
        coverageNote
        harvestPackagedWeightG
        dryWeightG
        wetPackagedWeightG
        harvestWetWeightG
        dryToWetPct
        stream
        batchCount
        finishedBatchCount
        plantCount
        outputWeightG
        reportedPackagedWeightG
        packageCoveragePct
      }
      isInferredComplete
      strainCount
      strainWithYieldCount
      harvestNames
      harvestNameRoomMap
      strains {
        strainName
        plantCount
        totalWetWeight
        totalPackagedWeight
        finishedDate
        metrcHarvestId
        metrcHarvestName
        createdStrainId
        bffYields {
          name
          weightG
          packageCount
          classification
        }
      }
    }
    hgsWithRoomCount
    hgsWithoutRoomCount
    formFactors {
      name
      classification
      totalWeightG
      packageCount
      sampleItemNames
      earliestDate
      latestDate
    }
    ffFailedCount
    ffFailedSamples
    adjustments {
      reason
      count
      totalQuantity
      unit
      totalWeightG
      earliestDate
      latestDate
    }
    totalAdjustmentCount
    rotation {
      rotationOrder
      intervalDays
      source
      flowerRooms {
        dateSource
        name
        floweringDate
      }
      harvestSequence {
        date
        room
        intervalDays
        cycle
      }
    }
    floweringGroups {
      proposedGroupId
      createdHgId
      locationName
      plantCount
      totalPlants
      strainNames
      floweringDate
      plantedDate
      projectedHarvestDate
      cloneStageDays
      vegStageDays
      flowerStageDays
      cloneVegDays
      allPlantedDates {
        date
        plantCount
        isDominant
        isOutlier
      }
      strains {
        strainName
        plantCount
        existingStrainId
        plantedDates
      }
    }
    alerts {
      severity
      title
      detail
      count
      samples
    }
    integritySignals {
      id
      category
      severity
      message
      details
      dedupKey
      resolutionState
      firstSeenAt
      lastSeenAt
      metrcHarvestId
      metrcPackageId
    }
    parsingRulesetStatus {
      harvestNames {
        status
        rulesCount
        inputFieldChain
        rules {
          template
          kind
          priority
          slotSummary
        }
        lastAuthoringSession {
          status
          endedAt
          iterations
          aiCostUsd
        }
      }
      packageItems {
        status
        rulesCount
        inputFieldChain
        rules {
          template
          kind
          priority
          slotSummary
        }
        lastAuthoringSession {
          status
          endedAt
          iterations
          aiCostUsd
        }
      }
    }
  }
}
    `;

/**
 * __useMetrcImportOverviewV2Query__
 *
 * To run a query within a React component, call `useMetrcImportOverviewV2Query` and pass it any options that fit your needs.
 * When your component renders, `useMetrcImportOverviewV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetrcImportOverviewV2Query({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useMetrcImportOverviewV2Query(baseOptions?: Apollo.QueryHookOptions<MetrcImportOverviewV2Query, MetrcImportOverviewV2QueryVariables>) {
        return Apollo.useQuery<MetrcImportOverviewV2Query, MetrcImportOverviewV2QueryVariables>(MetrcImportOverviewV2Document, baseOptions);
      }
export function useMetrcImportOverviewV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetrcImportOverviewV2Query, MetrcImportOverviewV2QueryVariables>) {
          return Apollo.useLazyQuery<MetrcImportOverviewV2Query, MetrcImportOverviewV2QueryVariables>(MetrcImportOverviewV2Document, baseOptions);
        }
export type MetrcImportOverviewV2QueryHookResult = ReturnType<typeof useMetrcImportOverviewV2Query>;
export type MetrcImportOverviewV2LazyQueryHookResult = ReturnType<typeof useMetrcImportOverviewV2LazyQuery>;
export type MetrcImportOverviewV2QueryResult = Apollo.QueryResult<MetrcImportOverviewV2Query, MetrcImportOverviewV2QueryVariables>;
export const IntegrityEventsDocument = gql`
    query integrityEvents($siteId: ID, $organizationId: ID, $state: String, $categories: [String!], $severities: [String!], $search: String, $first: Int, $after: String) {
  integrityEvents(
    siteId: $siteId
    organizationId: $organizationId
    state: $state
    categories: $categories
    severities: $severities
    search: $search
    first: $first
    after: $after
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    nodes {
      id
      category
      severity
      message
      details
      dedupKey
      resolutionState
      resolutionAction
      firstSeenAt
      lastSeenAt
      resolvedAt
      resolvedByName
      siteId
      siteName
      organizationId
      organizationName
      metrcHarvestId
      metrcHarvestName
      metrcPackageId
      metrcPackageLabel
      harvestGroupId
      harvestGroupName
      source
      availableActions {
        action
        label
      }
      resolutionOptions {
        budFormFactors {
          id
          label
        }
        zones {
          id
          label
        }
        harvestGroups {
          id
          label
        }
      }
    }
  }
}
    `;

/**
 * __useIntegrityEventsQuery__
 *
 * To run a query within a React component, call `useIntegrityEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrityEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrityEventsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      organizationId: // value for 'organizationId'
 *      state: // value for 'state'
 *      categories: // value for 'categories'
 *      severities: // value for 'severities'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useIntegrityEventsQuery(baseOptions?: Apollo.QueryHookOptions<IntegrityEventsQuery, IntegrityEventsQueryVariables>) {
        return Apollo.useQuery<IntegrityEventsQuery, IntegrityEventsQueryVariables>(IntegrityEventsDocument, baseOptions);
      }
export function useIntegrityEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrityEventsQuery, IntegrityEventsQueryVariables>) {
          return Apollo.useLazyQuery<IntegrityEventsQuery, IntegrityEventsQueryVariables>(IntegrityEventsDocument, baseOptions);
        }
export type IntegrityEventsQueryHookResult = ReturnType<typeof useIntegrityEventsQuery>;
export type IntegrityEventsLazyQueryHookResult = ReturnType<typeof useIntegrityEventsLazyQuery>;
export type IntegrityEventsQueryResult = Apollo.QueryResult<IntegrityEventsQuery, IntegrityEventsQueryVariables>;
export const IntegrityEventSummaryDocument = gql`
    query integrityEventSummary($siteId: ID, $organizationId: ID) {
  integrityEventSummary(siteId: $siteId, organizationId: $organizationId) {
    openErrors
    openWarnings
    openTotal
    actionableOpen
    warningOpen
    dismissedLast7Days
    resolvedLast7Days
  }
}
    `;

/**
 * __useIntegrityEventSummaryQuery__
 *
 * To run a query within a React component, call `useIntegrityEventSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrityEventSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrityEventSummaryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useIntegrityEventSummaryQuery(baseOptions?: Apollo.QueryHookOptions<IntegrityEventSummaryQuery, IntegrityEventSummaryQueryVariables>) {
        return Apollo.useQuery<IntegrityEventSummaryQuery, IntegrityEventSummaryQueryVariables>(IntegrityEventSummaryDocument, baseOptions);
      }
export function useIntegrityEventSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrityEventSummaryQuery, IntegrityEventSummaryQueryVariables>) {
          return Apollo.useLazyQuery<IntegrityEventSummaryQuery, IntegrityEventSummaryQueryVariables>(IntegrityEventSummaryDocument, baseOptions);
        }
export type IntegrityEventSummaryQueryHookResult = ReturnType<typeof useIntegrityEventSummaryQuery>;
export type IntegrityEventSummaryLazyQueryHookResult = ReturnType<typeof useIntegrityEventSummaryLazyQuery>;
export type IntegrityEventSummaryQueryResult = Apollo.QueryResult<IntegrityEventSummaryQuery, IntegrityEventSummaryQueryVariables>;
export const IntegrityEventsPaginatedDocument = gql`
    query integrityEventsPaginated($options: IntegrityEventQuerysetOptionsInput) {
  integrityEventsPaginated(options: $options) {
    options {
      paging {
        start
        size
        page
        totalCount
        hasNextPage
        hasPreviousPage
        ordering
      }
    }
    items {
      id
      category
      severity
      message
      details
      dedupKey
      resolutionState
      resolutionAction
      firstSeenAt
      lastSeenAt
      resolvedAt
      resolvedByName
      siteId
      siteName
      organizationId
      organizationName
      metrcHarvestId
      metrcHarvestName
      metrcPackageId
      metrcPackageLabel
      metrcPackageDisplayName
      metrcPackageCategoryName
      metrcPackageKind
      harvestGroupId
      harvestGroupName
      source
      dashboardGroup
      isActionable
      availableActions {
        action
        label
      }
      resolutionOptions {
        budFormFactors {
          id
          label
        }
        zones {
          id
          label
        }
        harvestGroups {
          id
          label
        }
      }
    }
  }
}
    `;

/**
 * __useIntegrityEventsPaginatedQuery__
 *
 * To run a query within a React component, call `useIntegrityEventsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrityEventsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrityEventsPaginatedQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useIntegrityEventsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<IntegrityEventsPaginatedQuery, IntegrityEventsPaginatedQueryVariables>) {
        return Apollo.useQuery<IntegrityEventsPaginatedQuery, IntegrityEventsPaginatedQueryVariables>(IntegrityEventsPaginatedDocument, baseOptions);
      }
export function useIntegrityEventsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrityEventsPaginatedQuery, IntegrityEventsPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<IntegrityEventsPaginatedQuery, IntegrityEventsPaginatedQueryVariables>(IntegrityEventsPaginatedDocument, baseOptions);
        }
export type IntegrityEventsPaginatedQueryHookResult = ReturnType<typeof useIntegrityEventsPaginatedQuery>;
export type IntegrityEventsPaginatedLazyQueryHookResult = ReturnType<typeof useIntegrityEventsPaginatedLazyQuery>;
export type IntegrityEventsPaginatedQueryResult = Apollo.QueryResult<IntegrityEventsPaginatedQuery, IntegrityEventsPaginatedQueryVariables>;
export const IntegrityEventFilterCountsDocument = gql`
    query integrityEventFilterCounts($siteId: ID, $organizationId: ID, $state: String) {
  integrityEventCategoryCounts(
    siteId: $siteId
    organizationId: $organizationId
    state: $state
  ) {
    category
    count
  }
  integrityEventSiteCounts(organizationId: $organizationId, state: $state) {
    siteId
    siteName
    organizationName
    count
  }
}
    `;

/**
 * __useIntegrityEventFilterCountsQuery__
 *
 * To run a query within a React component, call `useIntegrityEventFilterCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrityEventFilterCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrityEventFilterCountsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      organizationId: // value for 'organizationId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useIntegrityEventFilterCountsQuery(baseOptions?: Apollo.QueryHookOptions<IntegrityEventFilterCountsQuery, IntegrityEventFilterCountsQueryVariables>) {
        return Apollo.useQuery<IntegrityEventFilterCountsQuery, IntegrityEventFilterCountsQueryVariables>(IntegrityEventFilterCountsDocument, baseOptions);
      }
export function useIntegrityEventFilterCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrityEventFilterCountsQuery, IntegrityEventFilterCountsQueryVariables>) {
          return Apollo.useLazyQuery<IntegrityEventFilterCountsQuery, IntegrityEventFilterCountsQueryVariables>(IntegrityEventFilterCountsDocument, baseOptions);
        }
export type IntegrityEventFilterCountsQueryHookResult = ReturnType<typeof useIntegrityEventFilterCountsQuery>;
export type IntegrityEventFilterCountsLazyQueryHookResult = ReturnType<typeof useIntegrityEventFilterCountsLazyQuery>;
export type IntegrityEventFilterCountsQueryResult = Apollo.QueryResult<IntegrityEventFilterCountsQuery, IntegrityEventFilterCountsQueryVariables>;
export const IntegrityEventWarningSummariesDocument = gql`
    query integrityEventWarningSummaries($siteId: ID, $organizationId: ID, $state: String) {
  integrityEventWarningSummaries(
    siteId: $siteId
    organizationId: $organizationId
    state: $state
  ) {
    siteId
    siteName
    organizationName
    category
    severity
    count
    lastSeenAt
  }
}
    `;

/**
 * __useIntegrityEventWarningSummariesQuery__
 *
 * To run a query within a React component, call `useIntegrityEventWarningSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrityEventWarningSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrityEventWarningSummariesQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      organizationId: // value for 'organizationId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useIntegrityEventWarningSummariesQuery(baseOptions?: Apollo.QueryHookOptions<IntegrityEventWarningSummariesQuery, IntegrityEventWarningSummariesQueryVariables>) {
        return Apollo.useQuery<IntegrityEventWarningSummariesQuery, IntegrityEventWarningSummariesQueryVariables>(IntegrityEventWarningSummariesDocument, baseOptions);
      }
export function useIntegrityEventWarningSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrityEventWarningSummariesQuery, IntegrityEventWarningSummariesQueryVariables>) {
          return Apollo.useLazyQuery<IntegrityEventWarningSummariesQuery, IntegrityEventWarningSummariesQueryVariables>(IntegrityEventWarningSummariesDocument, baseOptions);
        }
export type IntegrityEventWarningSummariesQueryHookResult = ReturnType<typeof useIntegrityEventWarningSummariesQuery>;
export type IntegrityEventWarningSummariesLazyQueryHookResult = ReturnType<typeof useIntegrityEventWarningSummariesLazyQuery>;
export type IntegrityEventWarningSummariesQueryResult = Apollo.QueryResult<IntegrityEventWarningSummariesQuery, IntegrityEventWarningSummariesQueryVariables>;
export const MetrcImportDataOverviewDocument = gql`
    query metrcImportDataOverview($siteId: ID!) {
  metrcImportDataOverview(siteId: $siteId) {
    ready
    totalHarvests
    totalPackages
    totalStrains
    totalLocations
    totalFloweringPlants
    dateRangeStart
    dateRangeEnd
    locations {
      name
      metrcId
      hasFloweringPlants
      guessedUsage
    }
    strainNames
    newStrainCount
    existingStrainCount
    harvestGroups {
      name
      harvestDate
      assignedFlowerRoom
      strainNames
      totalWetWeightG
      totalPackagedWeightG
      pkgWetPct
      yieldCoveragePct
      isInferredComplete
      harvestNames
      harvestNameRoomMap
    }
    hgsWithRoomCount
    hgsWithoutRoomCount
    formFactors {
      name
      classification
      totalWeightG
      packageCount
      sampleItemNames
      earliestDate
      latestDate
    }
    ffFailedCount
    ffFailedSamples
    adjustments {
      reason
      count
      totalQuantity
      unit
      totalWeightG
      earliestDate
      latestDate
    }
    totalAdjustmentCount
    rotation {
      rotationOrder
      intervalDays
      source
      flowerRooms {
        dateSource
        name
        floweringDate
      }
      harvestSequence {
        date
        room
        intervalDays
        cycle
      }
    }
    floweringGroups {
      proposedGroupId
      createdHgId
      locationName
      plantCount
      totalPlants
      strainNames
      floweringDate
      plantedDate
      projectedHarvestDate
      cloneStageDays
      vegStageDays
      flowerStageDays
      cloneVegDays
      allPlantedDates {
        date
        plantCount
        isDominant
        isOutlier
      }
      strains {
        strainName
        plantCount
        existingStrainId
        plantedDates
      }
    }
    alerts {
      severity
      title
      detail
      count
      samples
    }
  }
}
    `;

/**
 * __useMetrcImportDataOverviewQuery__
 *
 * To run a query within a React component, call `useMetrcImportDataOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetrcImportDataOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetrcImportDataOverviewQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useMetrcImportDataOverviewQuery(baseOptions?: Apollo.QueryHookOptions<MetrcImportDataOverviewQuery, MetrcImportDataOverviewQueryVariables>) {
        return Apollo.useQuery<MetrcImportDataOverviewQuery, MetrcImportDataOverviewQueryVariables>(MetrcImportDataOverviewDocument, baseOptions);
      }
export function useMetrcImportDataOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetrcImportDataOverviewQuery, MetrcImportDataOverviewQueryVariables>) {
          return Apollo.useLazyQuery<MetrcImportDataOverviewQuery, MetrcImportDataOverviewQueryVariables>(MetrcImportDataOverviewDocument, baseOptions);
        }
export type MetrcImportDataOverviewQueryHookResult = ReturnType<typeof useMetrcImportDataOverviewQuery>;
export type MetrcImportDataOverviewLazyQueryHookResult = ReturnType<typeof useMetrcImportDataOverviewLazyQuery>;
export type MetrcImportDataOverviewQueryResult = Apollo.QueryResult<MetrcImportDataOverviewQuery, MetrcImportDataOverviewQueryVariables>;
export const FieldSurveysDocument = gql`
    query fieldSurveys($id: String!) {
  staffOrganization(id: $id) {
    id
    name
    sites {
      id
      name
      fieldSurveys {
        id
        createdAt
        site {
          id
          name
        }
        createdBy {
          ...UserAttributes
        }
        facilitySurvey {
          id
          completedAt
          recommendations
        }
        roomSurveys {
          id
          completedAt
          recommendations
        }
      }
    }
  }
}
    ${UserAttributesFragmentDoc}`;

/**
 * __useFieldSurveysQuery__
 *
 * To run a query within a React component, call `useFieldSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldSurveysQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFieldSurveysQuery(baseOptions?: Apollo.QueryHookOptions<FieldSurveysQuery, FieldSurveysQueryVariables>) {
        return Apollo.useQuery<FieldSurveysQuery, FieldSurveysQueryVariables>(FieldSurveysDocument, baseOptions);
      }
export function useFieldSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldSurveysQuery, FieldSurveysQueryVariables>) {
          return Apollo.useLazyQuery<FieldSurveysQuery, FieldSurveysQueryVariables>(FieldSurveysDocument, baseOptions);
        }
export type FieldSurveysQueryHookResult = ReturnType<typeof useFieldSurveysQuery>;
export type FieldSurveysLazyQueryHookResult = ReturnType<typeof useFieldSurveysLazyQuery>;
export type FieldSurveysQueryResult = Apollo.QueryResult<FieldSurveysQuery, FieldSurveysQueryVariables>;
export const FieldSurveyDocument = gql`
    query fieldSurvey($id: String!) {
  fieldSurvey(id: $id) {
    ...FieldSurveyFields
    zonesAvailable {
      id
      name
      roomUsage
      site {
        id
        name
      }
    }
  }
}
    ${FieldSurveyFieldsFragmentDoc}`;

/**
 * __useFieldSurveyQuery__
 *
 * To run a query within a React component, call `useFieldSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldSurveyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFieldSurveyQuery(baseOptions?: Apollo.QueryHookOptions<FieldSurveyQuery, FieldSurveyQueryVariables>) {
        return Apollo.useQuery<FieldSurveyQuery, FieldSurveyQueryVariables>(FieldSurveyDocument, baseOptions);
      }
export function useFieldSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldSurveyQuery, FieldSurveyQueryVariables>) {
          return Apollo.useLazyQuery<FieldSurveyQuery, FieldSurveyQueryVariables>(FieldSurveyDocument, baseOptions);
        }
export type FieldSurveyQueryHookResult = ReturnType<typeof useFieldSurveyQuery>;
export type FieldSurveyLazyQueryHookResult = ReturnType<typeof useFieldSurveyLazyQuery>;
export type FieldSurveyQueryResult = Apollo.QueryResult<FieldSurveyQuery, FieldSurveyQueryVariables>;
export const FacilitySurveyDocument = gql`
    query facilitySurvey($id: String!) {
  facilitySurvey(id: $id) {
    ...FacilitySurveyFields
  }
}
    ${FacilitySurveyFieldsFragmentDoc}`;

/**
 * __useFacilitySurveyQuery__
 *
 * To run a query within a React component, call `useFacilitySurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilitySurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilitySurveyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFacilitySurveyQuery(baseOptions?: Apollo.QueryHookOptions<FacilitySurveyQuery, FacilitySurveyQueryVariables>) {
        return Apollo.useQuery<FacilitySurveyQuery, FacilitySurveyQueryVariables>(FacilitySurveyDocument, baseOptions);
      }
export function useFacilitySurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacilitySurveyQuery, FacilitySurveyQueryVariables>) {
          return Apollo.useLazyQuery<FacilitySurveyQuery, FacilitySurveyQueryVariables>(FacilitySurveyDocument, baseOptions);
        }
export type FacilitySurveyQueryHookResult = ReturnType<typeof useFacilitySurveyQuery>;
export type FacilitySurveyLazyQueryHookResult = ReturnType<typeof useFacilitySurveyLazyQuery>;
export type FacilitySurveyQueryResult = Apollo.QueryResult<FacilitySurveyQuery, FacilitySurveyQueryVariables>;
export const RoomSurveyDocument = gql`
    query roomSurvey($id: String!, $zoneId: String!) {
  roomSurvey(id: $id, zoneId: $zoneId) {
    ...RoomSurveyFields
  }
}
    ${RoomSurveyFieldsFragmentDoc}`;

/**
 * __useRoomSurveyQuery__
 *
 * To run a query within a React component, call `useRoomSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomSurveyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useRoomSurveyQuery(baseOptions?: Apollo.QueryHookOptions<RoomSurveyQuery, RoomSurveyQueryVariables>) {
        return Apollo.useQuery<RoomSurveyQuery, RoomSurveyQueryVariables>(RoomSurveyDocument, baseOptions);
      }
export function useRoomSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomSurveyQuery, RoomSurveyQueryVariables>) {
          return Apollo.useLazyQuery<RoomSurveyQuery, RoomSurveyQueryVariables>(RoomSurveyDocument, baseOptions);
        }
export type RoomSurveyQueryHookResult = ReturnType<typeof useRoomSurveyQuery>;
export type RoomSurveyLazyQueryHookResult = ReturnType<typeof useRoomSurveyLazyQuery>;
export type RoomSurveyQueryResult = Apollo.QueryResult<RoomSurveyQuery, RoomSurveyQueryVariables>;
export const ChecklistSessionsDocument = gql`
    query checklistSessions($organizationId: ID!, $siteId: ID) {
  checklistSessions(organizationId: $organizationId, siteId: $siteId) {
    ...ChecklistSessionFields
  }
}
    ${ChecklistSessionFieldsFragmentDoc}`;

/**
 * __useChecklistSessionsQuery__
 *
 * To run a query within a React component, call `useChecklistSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistSessionsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useChecklistSessionsQuery(baseOptions?: Apollo.QueryHookOptions<ChecklistSessionsQuery, ChecklistSessionsQueryVariables>) {
        return Apollo.useQuery<ChecklistSessionsQuery, ChecklistSessionsQueryVariables>(ChecklistSessionsDocument, baseOptions);
      }
export function useChecklistSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChecklistSessionsQuery, ChecklistSessionsQueryVariables>) {
          return Apollo.useLazyQuery<ChecklistSessionsQuery, ChecklistSessionsQueryVariables>(ChecklistSessionsDocument, baseOptions);
        }
export type ChecklistSessionsQueryHookResult = ReturnType<typeof useChecklistSessionsQuery>;
export type ChecklistSessionsLazyQueryHookResult = ReturnType<typeof useChecklistSessionsLazyQuery>;
export type ChecklistSessionsQueryResult = Apollo.QueryResult<ChecklistSessionsQuery, ChecklistSessionsQueryVariables>;
export const ChecklistSessionsPaginatedDocument = gql`
    query checklistSessionsPaginated($options: ChecklistSessionQuerysetOptionsInput) {
  checklistSessionsPaginated(options: $options) {
    options {
      paging {
        ...PagingInfo
      }
    }
    items {
      ...ChecklistSessionFields
    }
  }
}
    ${PagingInfoFragmentDoc}
${ChecklistSessionFieldsFragmentDoc}`;

/**
 * __useChecklistSessionsPaginatedQuery__
 *
 * To run a query within a React component, call `useChecklistSessionsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistSessionsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistSessionsPaginatedQuery({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useChecklistSessionsPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<ChecklistSessionsPaginatedQuery, ChecklistSessionsPaginatedQueryVariables>) {
        return Apollo.useQuery<ChecklistSessionsPaginatedQuery, ChecklistSessionsPaginatedQueryVariables>(ChecklistSessionsPaginatedDocument, baseOptions);
      }
export function useChecklistSessionsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChecklistSessionsPaginatedQuery, ChecklistSessionsPaginatedQueryVariables>) {
          return Apollo.useLazyQuery<ChecklistSessionsPaginatedQuery, ChecklistSessionsPaginatedQueryVariables>(ChecklistSessionsPaginatedDocument, baseOptions);
        }
export type ChecklistSessionsPaginatedQueryHookResult = ReturnType<typeof useChecklistSessionsPaginatedQuery>;
export type ChecklistSessionsPaginatedLazyQueryHookResult = ReturnType<typeof useChecklistSessionsPaginatedLazyQuery>;
export type ChecklistSessionsPaginatedQueryResult = Apollo.QueryResult<ChecklistSessionsPaginatedQuery, ChecklistSessionsPaginatedQueryVariables>;
export const ChecklistSessionDocument = gql`
    query checklistSession($id: ID!) {
  checklistSession(id: $id) {
    ...ChecklistSessionFields
  }
}
    ${ChecklistSessionFieldsFragmentDoc}`;

/**
 * __useChecklistSessionQuery__
 *
 * To run a query within a React component, call `useChecklistSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useChecklistSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChecklistSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChecklistSessionQuery(baseOptions?: Apollo.QueryHookOptions<ChecklistSessionQuery, ChecklistSessionQueryVariables>) {
        return Apollo.useQuery<ChecklistSessionQuery, ChecklistSessionQueryVariables>(ChecklistSessionDocument, baseOptions);
      }
export function useChecklistSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChecklistSessionQuery, ChecklistSessionQueryVariables>) {
          return Apollo.useLazyQuery<ChecklistSessionQuery, ChecklistSessionQueryVariables>(ChecklistSessionDocument, baseOptions);
        }
export type ChecklistSessionQueryHookResult = ReturnType<typeof useChecklistSessionQuery>;
export type ChecklistSessionLazyQueryHookResult = ReturnType<typeof useChecklistSessionLazyQuery>;
export type ChecklistSessionQueryResult = Apollo.QueryResult<ChecklistSessionQuery, ChecklistSessionQueryVariables>;
export const RoomWalkthroughChecklistsDocument = gql`
    query roomWalkthroughChecklists($checklistSessionId: ID!) {
  roomWalkthroughChecklists(checklistSessionId: $checklistSessionId) {
    ...RoomWalkthroughChecklistFields
  }
}
    ${RoomWalkthroughChecklistFieldsFragmentDoc}`;

/**
 * __useRoomWalkthroughChecklistsQuery__
 *
 * To run a query within a React component, call `useRoomWalkthroughChecklistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomWalkthroughChecklistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomWalkthroughChecklistsQuery({
 *   variables: {
 *      checklistSessionId: // value for 'checklistSessionId'
 *   },
 * });
 */
export function useRoomWalkthroughChecklistsQuery(baseOptions?: Apollo.QueryHookOptions<RoomWalkthroughChecklistsQuery, RoomWalkthroughChecklistsQueryVariables>) {
        return Apollo.useQuery<RoomWalkthroughChecklistsQuery, RoomWalkthroughChecklistsQueryVariables>(RoomWalkthroughChecklistsDocument, baseOptions);
      }
export function useRoomWalkthroughChecklistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomWalkthroughChecklistsQuery, RoomWalkthroughChecklistsQueryVariables>) {
          return Apollo.useLazyQuery<RoomWalkthroughChecklistsQuery, RoomWalkthroughChecklistsQueryVariables>(RoomWalkthroughChecklistsDocument, baseOptions);
        }
export type RoomWalkthroughChecklistsQueryHookResult = ReturnType<typeof useRoomWalkthroughChecklistsQuery>;
export type RoomWalkthroughChecklistsLazyQueryHookResult = ReturnType<typeof useRoomWalkthroughChecklistsLazyQuery>;
export type RoomWalkthroughChecklistsQueryResult = Apollo.QueryResult<RoomWalkthroughChecklistsQuery, RoomWalkthroughChecklistsQueryVariables>;
export const EnvironmentalDevicesDocument = gql`
    query environmentalDevices($siteId: ID, $zoneId: ID) {
  environmentalDevices(siteId: $siteId, zoneId: $zoneId) {
    id
    name
    category
    isPrimary
    trolmasterMacAddress
    trolmasterModel
    aroyaModelKey
    aroyaDeviceId
    aroyaSerialNumber
    aroyaApiRoomName
    aroyaApiBenchName
    growlinkControllerId
    growlinkModuleName
    growlinkTemperatureSensorId
    growlinkHumiditySensorId
    growlinkCo2SensorId
    growlinkVpdSensorId
    zone {
      id
      name
      primaryDevice {
        id
      }
      site {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useEnvironmentalDevicesQuery__
 *
 * To run a query within a React component, call `useEnvironmentalDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentalDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentalDevicesQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useEnvironmentalDevicesQuery(baseOptions?: Apollo.QueryHookOptions<EnvironmentalDevicesQuery, EnvironmentalDevicesQueryVariables>) {
        return Apollo.useQuery<EnvironmentalDevicesQuery, EnvironmentalDevicesQueryVariables>(EnvironmentalDevicesDocument, baseOptions);
      }
export function useEnvironmentalDevicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnvironmentalDevicesQuery, EnvironmentalDevicesQueryVariables>) {
          return Apollo.useLazyQuery<EnvironmentalDevicesQuery, EnvironmentalDevicesQueryVariables>(EnvironmentalDevicesDocument, baseOptions);
        }
export type EnvironmentalDevicesQueryHookResult = ReturnType<typeof useEnvironmentalDevicesQuery>;
export type EnvironmentalDevicesLazyQueryHookResult = ReturnType<typeof useEnvironmentalDevicesLazyQuery>;
export type EnvironmentalDevicesQueryResult = Apollo.QueryResult<EnvironmentalDevicesQuery, EnvironmentalDevicesQueryVariables>;
export const LocationsDocument = gql`
    query locations {
  organizationSites {
    id
    name
    locations {
      id
      name
      zone {
        id
        name
        active
      }
      equipment {
        id
        label
        type
        brand
        model
        serialNumber
        lastMaintenanceDate
        status
        notes
        installedAtDate
      }
    }
  }
}
    `;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, baseOptions);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, baseOptions);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const AroyaDeviceRequestsDocument = gql`
    query aroyaDeviceRequests($organizationId: ID!, $credentialId: ID) {
  aroyaDeviceRequests(
    organizationId: $organizationId
    credentialId: $credentialId
  ) {
    ...AroyaDeviceRequestFields
  }
}
    ${AroyaDeviceRequestFieldsFragmentDoc}`;

/**
 * __useAroyaDeviceRequestsQuery__
 *
 * To run a query within a React component, call `useAroyaDeviceRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAroyaDeviceRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAroyaDeviceRequestsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      credentialId: // value for 'credentialId'
 *   },
 * });
 */
export function useAroyaDeviceRequestsQuery(baseOptions?: Apollo.QueryHookOptions<AroyaDeviceRequestsQuery, AroyaDeviceRequestsQueryVariables>) {
        return Apollo.useQuery<AroyaDeviceRequestsQuery, AroyaDeviceRequestsQueryVariables>(AroyaDeviceRequestsDocument, baseOptions);
      }
export function useAroyaDeviceRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AroyaDeviceRequestsQuery, AroyaDeviceRequestsQueryVariables>) {
          return Apollo.useLazyQuery<AroyaDeviceRequestsQuery, AroyaDeviceRequestsQueryVariables>(AroyaDeviceRequestsDocument, baseOptions);
        }
export type AroyaDeviceRequestsQueryHookResult = ReturnType<typeof useAroyaDeviceRequestsQuery>;
export type AroyaDeviceRequestsLazyQueryHookResult = ReturnType<typeof useAroyaDeviceRequestsLazyQuery>;
export type AroyaDeviceRequestsQueryResult = Apollo.QueryResult<AroyaDeviceRequestsQuery, AroyaDeviceRequestsQueryVariables>;
export const GrowlinkDeviceRequestsDocument = gql`
    query growlinkDeviceRequests($organizationId: ID!, $credentialId: ID) {
  growlinkDeviceRequests(
    organizationId: $organizationId
    credentialId: $credentialId
  ) {
    ...GrowlinkDeviceRequestFields
  }
}
    ${GrowlinkDeviceRequestFieldsFragmentDoc}`;

/**
 * __useGrowlinkDeviceRequestsQuery__
 *
 * To run a query within a React component, call `useGrowlinkDeviceRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrowlinkDeviceRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrowlinkDeviceRequestsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      credentialId: // value for 'credentialId'
 *   },
 * });
 */
export function useGrowlinkDeviceRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GrowlinkDeviceRequestsQuery, GrowlinkDeviceRequestsQueryVariables>) {
        return Apollo.useQuery<GrowlinkDeviceRequestsQuery, GrowlinkDeviceRequestsQueryVariables>(GrowlinkDeviceRequestsDocument, baseOptions);
      }
export function useGrowlinkDeviceRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrowlinkDeviceRequestsQuery, GrowlinkDeviceRequestsQueryVariables>) {
          return Apollo.useLazyQuery<GrowlinkDeviceRequestsQuery, GrowlinkDeviceRequestsQueryVariables>(GrowlinkDeviceRequestsDocument, baseOptions);
        }
export type GrowlinkDeviceRequestsQueryHookResult = ReturnType<typeof useGrowlinkDeviceRequestsQuery>;
export type GrowlinkDeviceRequestsLazyQueryHookResult = ReturnType<typeof useGrowlinkDeviceRequestsLazyQuery>;
export type GrowlinkDeviceRequestsQueryResult = Apollo.QueryResult<GrowlinkDeviceRequestsQuery, GrowlinkDeviceRequestsQueryVariables>;
export const MetrcImportAnalyticsDocument = gql`
    query metrcImportAnalytics($siteId: ID!) {
  metrcImportAnalytics(siteId: $siteId) {
    totals {
      groups
      totalGrams
      flowerGrams
      trimGrams
      totalPlants
      gramsPerPlant
    }
    topStrains {
      strainId
      strainName
      totalGrams
      flowerGrams
      trimGrams
      totalPlants
      gramsPerPlant
    }
    bottomStrains {
      strainId
      strainName
      totalGrams
      flowerGrams
      trimGrams
      totalPlants
      gramsPerPlant
    }
    topStrainsPerPlant {
      strainId
      strainName
      totalGrams
      flowerGrams
      trimGrams
      totalPlants
      gramsPerPlant
    }
    bottomStrainsPerPlant {
      strainId
      strainName
      totalGrams
      flowerGrams
      trimGrams
      totalPlants
      gramsPerPlant
    }
    topHarvestGroups {
      harvestGroupId
      name
      harvestDate
      totalGrams
      flowerGrams
      trimGrams
      totalPlants
      gramsPerPlant
    }
    topHarvestGroupsPerPlant {
      harvestGroupId
      name
      harvestDate
      totalGrams
      flowerGrams
      trimGrams
      totalPlants
      gramsPerPlant
    }
    bottomHarvestGroups {
      harvestGroupId
      name
      harvestDate
      totalGrams
      flowerGrams
      trimGrams
      totalPlants
      gramsPerPlant
    }
    bottomHarvestGroupsPerPlant {
      harvestGroupId
      name
      harvestDate
      totalGrams
      flowerGrams
      trimGrams
      totalPlants
      gramsPerPlant
    }
  }
}
    `;

/**
 * __useMetrcImportAnalyticsQuery__
 *
 * To run a query within a React component, call `useMetrcImportAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetrcImportAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetrcImportAnalyticsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useMetrcImportAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<MetrcImportAnalyticsQuery, MetrcImportAnalyticsQueryVariables>) {
        return Apollo.useQuery<MetrcImportAnalyticsQuery, MetrcImportAnalyticsQueryVariables>(MetrcImportAnalyticsDocument, baseOptions);
      }
export function useMetrcImportAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetrcImportAnalyticsQuery, MetrcImportAnalyticsQueryVariables>) {
          return Apollo.useLazyQuery<MetrcImportAnalyticsQuery, MetrcImportAnalyticsQueryVariables>(MetrcImportAnalyticsDocument, baseOptions);
        }
export type MetrcImportAnalyticsQueryHookResult = ReturnType<typeof useMetrcImportAnalyticsQuery>;
export type MetrcImportAnalyticsLazyQueryHookResult = ReturnType<typeof useMetrcImportAnalyticsLazyQuery>;
export type MetrcImportAnalyticsQueryResult = Apollo.QueryResult<MetrcImportAnalyticsQuery, MetrcImportAnalyticsQueryVariables>;
export const MetrcImportYieldBreakdownDocument = gql`
    query metrcImportYieldBreakdown($proposedGroupId: ID!) {
  metrcImportYieldBreakdown(proposedGroupId: $proposedGroupId) {
    totalPackagedG
    totalFoundG
    unaccountedG
    foundByFf {
      ffName
      classification
      weightG
      packageCount
      strainBreakdown {
        strainName
        pdsStrainId
        weightG
        packageCount
      }
    }
    missingByReason {
      category
      label
      description
      weightG
      packageCount
      samplePackageNames
    }
  }
}
    `;

/**
 * __useMetrcImportYieldBreakdownQuery__
 *
 * To run a query within a React component, call `useMetrcImportYieldBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetrcImportYieldBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetrcImportYieldBreakdownQuery({
 *   variables: {
 *      proposedGroupId: // value for 'proposedGroupId'
 *   },
 * });
 */
export function useMetrcImportYieldBreakdownQuery(baseOptions?: Apollo.QueryHookOptions<MetrcImportYieldBreakdownQuery, MetrcImportYieldBreakdownQueryVariables>) {
        return Apollo.useQuery<MetrcImportYieldBreakdownQuery, MetrcImportYieldBreakdownQueryVariables>(MetrcImportYieldBreakdownDocument, baseOptions);
      }
export function useMetrcImportYieldBreakdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetrcImportYieldBreakdownQuery, MetrcImportYieldBreakdownQueryVariables>) {
          return Apollo.useLazyQuery<MetrcImportYieldBreakdownQuery, MetrcImportYieldBreakdownQueryVariables>(MetrcImportYieldBreakdownDocument, baseOptions);
        }
export type MetrcImportYieldBreakdownQueryHookResult = ReturnType<typeof useMetrcImportYieldBreakdownQuery>;
export type MetrcImportYieldBreakdownLazyQueryHookResult = ReturnType<typeof useMetrcImportYieldBreakdownLazyQuery>;
export type MetrcImportYieldBreakdownQueryResult = Apollo.QueryResult<MetrcImportYieldBreakdownQuery, MetrcImportYieldBreakdownQueryVariables>;
export const MetrcImportYieldPackageBreakdownDocument = gql`
    query metrcImportYieldPackageBreakdown($proposedGroupId: ID!, $bucketKind: String!, $bucketKey: String!) {
  metrcImportYieldPackageBreakdown(
    proposedGroupId: $proposedGroupId
    bucketKind: $bucketKind
    bucketKey: $bucketKey
  ) {
    packages {
      packageLabel
      metrcPackageId
      weightG
      ffName
      sourceHarvestNames
      packageSiteName
      packageLicenseNumber
      packageLicenseRole
      packageRole
      packageReason
      weightBasis
      createdWeightG
      shippedWeightG
      adjustmentWeightG
      adjustmentNote
      sourcePackageLabels
    }
  }
}
    `;

/**
 * __useMetrcImportYieldPackageBreakdownQuery__
 *
 * To run a query within a React component, call `useMetrcImportYieldPackageBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetrcImportYieldPackageBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetrcImportYieldPackageBreakdownQuery({
 *   variables: {
 *      proposedGroupId: // value for 'proposedGroupId'
 *      bucketKind: // value for 'bucketKind'
 *      bucketKey: // value for 'bucketKey'
 *   },
 * });
 */
export function useMetrcImportYieldPackageBreakdownQuery(baseOptions?: Apollo.QueryHookOptions<MetrcImportYieldPackageBreakdownQuery, MetrcImportYieldPackageBreakdownQueryVariables>) {
        return Apollo.useQuery<MetrcImportYieldPackageBreakdownQuery, MetrcImportYieldPackageBreakdownQueryVariables>(MetrcImportYieldPackageBreakdownDocument, baseOptions);
      }
export function useMetrcImportYieldPackageBreakdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetrcImportYieldPackageBreakdownQuery, MetrcImportYieldPackageBreakdownQueryVariables>) {
          return Apollo.useLazyQuery<MetrcImportYieldPackageBreakdownQuery, MetrcImportYieldPackageBreakdownQueryVariables>(MetrcImportYieldPackageBreakdownDocument, baseOptions);
        }
export type MetrcImportYieldPackageBreakdownQueryHookResult = ReturnType<typeof useMetrcImportYieldPackageBreakdownQuery>;
export type MetrcImportYieldPackageBreakdownLazyQueryHookResult = ReturnType<typeof useMetrcImportYieldPackageBreakdownLazyQuery>;
export type MetrcImportYieldPackageBreakdownQueryResult = Apollo.QueryResult<MetrcImportYieldPackageBreakdownQuery, MetrcImportYieldPackageBreakdownQueryVariables>;
export const MetrcScheduleProposalsDocument = gql`
    query metrcScheduleProposals($siteId: ID!) {
  metrcImportOverviewV2(siteId: $siteId) {
    siteId
    floweringGroups {
      locationName
      floweringDate
    }
  }
}
    `;

/**
 * __useMetrcScheduleProposalsQuery__
 *
 * To run a query within a React component, call `useMetrcScheduleProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetrcScheduleProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetrcScheduleProposalsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useMetrcScheduleProposalsQuery(baseOptions?: Apollo.QueryHookOptions<MetrcScheduleProposalsQuery, MetrcScheduleProposalsQueryVariables>) {
        return Apollo.useQuery<MetrcScheduleProposalsQuery, MetrcScheduleProposalsQueryVariables>(MetrcScheduleProposalsDocument, baseOptions);
      }
export function useMetrcScheduleProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetrcScheduleProposalsQuery, MetrcScheduleProposalsQueryVariables>) {
          return Apollo.useLazyQuery<MetrcScheduleProposalsQuery, MetrcScheduleProposalsQueryVariables>(MetrcScheduleProposalsDocument, baseOptions);
        }
export type MetrcScheduleProposalsQueryHookResult = ReturnType<typeof useMetrcScheduleProposalsQuery>;
export type MetrcScheduleProposalsLazyQueryHookResult = ReturnType<typeof useMetrcScheduleProposalsLazyQuery>;
export type MetrcScheduleProposalsQueryResult = Apollo.QueryResult<MetrcScheduleProposalsQuery, MetrcScheduleProposalsQueryVariables>;
export const SensorCoverageDocument = gql`
    query sensorCoverage($siteId: ID!, $start: Date!, $end: Date!, $brand: String, $deviceId: ID, $outcomes: [String], $after: String) {
  sensorCoverage(
    siteId: $siteId
    start: $start
    end: $end
    brand: $brand
    deviceId: $deviceId
    outcomes: $outcomes
    after: $after
  ) {
    counts
    exclusions
    inventory
    policy
    timezone
    collectAllSensors
    eligibleDevices
    total
    nextCursor
    rows {
      deviceId
      deviceName
      zoneId
      roomName
      provider
      category
      day
      outcome
      readingsPresent
      lastAttempt
      lastSuccessfulFetch
      failureReason
      runId
    }
    runs {
      id
      state
      provider
      trigger
      startDay
      endDay
      startedAt
      finishedAt
      summary
      error
      policy
      requestSettings
    }
  }
}
    `;

/**
 * __useSensorCoverageQuery__
 *
 * To run a query within a React component, call `useSensorCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSensorCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSensorCoverageQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      brand: // value for 'brand'
 *      deviceId: // value for 'deviceId'
 *      outcomes: // value for 'outcomes'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSensorCoverageQuery(baseOptions?: Apollo.QueryHookOptions<SensorCoverageQuery, SensorCoverageQueryVariables>) {
        return Apollo.useQuery<SensorCoverageQuery, SensorCoverageQueryVariables>(SensorCoverageDocument, baseOptions);
      }
export function useSensorCoverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SensorCoverageQuery, SensorCoverageQueryVariables>) {
          return Apollo.useLazyQuery<SensorCoverageQuery, SensorCoverageQueryVariables>(SensorCoverageDocument, baseOptions);
        }
export type SensorCoverageQueryHookResult = ReturnType<typeof useSensorCoverageQuery>;
export type SensorCoverageLazyQueryHookResult = ReturnType<typeof useSensorCoverageLazyQuery>;
export type SensorCoverageQueryResult = Apollo.QueryResult<SensorCoverageQuery, SensorCoverageQueryVariables>;
export const SetSensorCollectionDocument = gql`
    mutation setSensorCollection($siteId: ID!, $enabled: Boolean!) {
  setSensorCollection(siteId: $siteId, enabled: $enabled) {
    enabled
  }
}
    `;
export type SetSensorCollectionMutationFn = Apollo.MutationFunction<SetSensorCollectionMutation, SetSensorCollectionMutationVariables>;

/**
 * __useSetSensorCollectionMutation__
 *
 * To run a mutation, you first call `useSetSensorCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSensorCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSensorCollectionMutation, { data, loading, error }] = useSetSensorCollectionMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetSensorCollectionMutation(baseOptions?: Apollo.MutationHookOptions<SetSensorCollectionMutation, SetSensorCollectionMutationVariables>) {
        return Apollo.useMutation<SetSensorCollectionMutation, SetSensorCollectionMutationVariables>(SetSensorCollectionDocument, baseOptions);
      }
export type SetSensorCollectionMutationHookResult = ReturnType<typeof useSetSensorCollectionMutation>;
export type SetSensorCollectionMutationResult = Apollo.MutationResult<SetSensorCollectionMutation>;
export type SetSensorCollectionMutationOptions = Apollo.BaseMutationOptions<SetSensorCollectionMutation, SetSensorCollectionMutationVariables>;
export const VerifySensorReplacementDocument = gql`
    mutation verifySensorReplacement($deviceId: ID!, $candidateId: ID!) {
  verifySensorReplacement(deviceId: $deviceId, candidateId: $candidateId) {
    result
  }
}
    `;
export type VerifySensorReplacementMutationFn = Apollo.MutationFunction<VerifySensorReplacementMutation, VerifySensorReplacementMutationVariables>;

/**
 * __useVerifySensorReplacementMutation__
 *
 * To run a mutation, you first call `useVerifySensorReplacementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifySensorReplacementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifySensorReplacementMutation, { data, loading, error }] = useVerifySensorReplacementMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useVerifySensorReplacementMutation(baseOptions?: Apollo.MutationHookOptions<VerifySensorReplacementMutation, VerifySensorReplacementMutationVariables>) {
        return Apollo.useMutation<VerifySensorReplacementMutation, VerifySensorReplacementMutationVariables>(VerifySensorReplacementDocument, baseOptions);
      }
export type VerifySensorReplacementMutationHookResult = ReturnType<typeof useVerifySensorReplacementMutation>;
export type VerifySensorReplacementMutationResult = Apollo.MutationResult<VerifySensorReplacementMutation>;
export type VerifySensorReplacementMutationOptions = Apollo.BaseMutationOptions<VerifySensorReplacementMutation, VerifySensorReplacementMutationVariables>;
export const SetSensorActiveDocument = gql`
    mutation setSensorActive($deviceId: ID!, $active: Boolean!) {
  setSensorActive(deviceId: $deviceId, active: $active) {
    active
  }
}
    `;
export type SetSensorActiveMutationFn = Apollo.MutationFunction<SetSensorActiveMutation, SetSensorActiveMutationVariables>;

/**
 * __useSetSensorActiveMutation__
 *
 * To run a mutation, you first call `useSetSensorActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSensorActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSensorActiveMutation, { data, loading, error }] = useSetSensorActiveMutation({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSetSensorActiveMutation(baseOptions?: Apollo.MutationHookOptions<SetSensorActiveMutation, SetSensorActiveMutationVariables>) {
        return Apollo.useMutation<SetSensorActiveMutation, SetSensorActiveMutationVariables>(SetSensorActiveDocument, baseOptions);
      }
export type SetSensorActiveMutationHookResult = ReturnType<typeof useSetSensorActiveMutation>;
export type SetSensorActiveMutationResult = Apollo.MutationResult<SetSensorActiveMutation>;
export type SetSensorActiveMutationOptions = Apollo.BaseMutationOptions<SetSensorActiveMutation, SetSensorActiveMutationVariables>;
export const LatestSensorCollectionDocument = gql`
    query latestSensorCollection($siteId: ID!, $brand: String!) {
  latestSensorCollection(siteId: $siteId, brand: $brand) {
    id
    state
    startedAt
    finishedAt
    endDay
    error
    connectionStatus
    latestDayCounts
  }
}
    `;

/**
 * __useLatestSensorCollectionQuery__
 *
 * To run a query within a React component, call `useLatestSensorCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestSensorCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestSensorCollectionQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useLatestSensorCollectionQuery(baseOptions?: Apollo.QueryHookOptions<LatestSensorCollectionQuery, LatestSensorCollectionQueryVariables>) {
        return Apollo.useQuery<LatestSensorCollectionQuery, LatestSensorCollectionQueryVariables>(LatestSensorCollectionDocument, baseOptions);
      }
export function useLatestSensorCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestSensorCollectionQuery, LatestSensorCollectionQueryVariables>) {
          return Apollo.useLazyQuery<LatestSensorCollectionQuery, LatestSensorCollectionQueryVariables>(LatestSensorCollectionDocument, baseOptions);
        }
export type LatestSensorCollectionQueryHookResult = ReturnType<typeof useLatestSensorCollectionQuery>;
export type LatestSensorCollectionLazyQueryHookResult = ReturnType<typeof useLatestSensorCollectionLazyQuery>;
export type LatestSensorCollectionQueryResult = Apollo.QueryResult<LatestSensorCollectionQuery, LatestSensorCollectionQueryVariables>;